import React from 'react';

const Counties = ({ onMouseMove, onMouseLeave }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      baseProfile="tiny"
      height="510"
      strokeLinecap="round"
      strokeLinejoin="round"
      version="1.2"
      viewBox="0 0 800 510"
      width="800"
    >
      <g id="County2021" onMouseMove={onMouseMove} onMouseLeave={onMouseLeave}>
        <path
          className="white"
          d="M 585.89 372.12 586.27 372.39 587.42 372.76 588.55 373.14 588.78 375.93 587.99 375.99 586.15 376.3 585.24 376.22 584.92 375.13 585.27 374.06 585.87 372.59 585.89 372.12 Z"
          data-name="Quitman"
          data-stusps="GA"
          id="13239"
        />
        <path
          className="white"
          d="M 531.3 203.15 533.19 203.03 534.77 201.81 535.78 210.86 532.08 211.21 531.8 208.23 531.59 206.07 531.56 205.8 531.3 203.15 Z"
          data-name="Newton"
          data-stusps="IN"
          id="18111"
        />
        <path
          className="white"
          d="M 439.33 213.58 445.85 213.4 446 219.38 445.42 219.39 442.89 219.49 441.94 219.53 439.44 219.63 439.33 213.58 Z"
          data-name="Decatur"
          data-stusps="IA"
          id="19053"
        />
        <path
          className="white"
          d="M 684.02 207.27 687.2 206.58 687.32 206.55 690.3 205.88 690.23 206.79 689.84 211.21 689.99 211.51 690.54 213.05 690.44 213.21 687.14 213.54 686.22 214.04 686.54 211.19 684.88 209.95 683.11 209.47 684.02 207.27 Z"
          data-name="Carroll"
          data-stusps="MD"
          id="24013"
        />
        <path
          className="white"
          d="M 502.52 295.67 505.7 295.51 506 294.72 507.81 294.91 508.9 296.1 508.05 296.18 507.92 296.83 508.84 297.36 508.15 298.15 506.99 298.04 506.8 298.49 507.83 299.17 507.89 299.21 508.43 300.07 507.7 300.72 507.16 301.15 507.04 302.33 506.45 302.74 503.88 302.92 502.99 302.98 502.52 295.67 Z"
          data-name="Pemiscot"
          data-stusps="MO"
          id="29155"
        />
        <path
          className="white"
          d="M 726.34 173.18 727.38 173.08 727.87 173.36 729.05 173.42 728.91 174.67 728.25 175 727.99 175.13 727.07 175.47 726.16 175.13 726.26 174.44 726.31 174.08 726.32 173.92 726.34 173.26 726.34 173.18 Z"
          data-name="Bronx"
          data-stusps="NY"
          id="36005"
        />
        <path
          className="white"
          d="M 712.07 139.04 714.04 136.47 713.62 135.41 715.82 135.99 716.46 135.54 716.88 136.63 718.46 137.66 718.17 137.88 713.56 139.98 712.36 140.62 712.07 139.04 Z"
          data-name="Schenectady"
          data-stusps="NY"
          id="36093"
        />
        <path
          className="white"
          d="M 629.03 305.66 630.69 305.49 634.98 305.06 636.96 304.87 636.65 307.19 635.47 307.6 635.63 309.24 636.47 311.23 636.01 310.77 632.26 310.42 631.57 310.18 630.44 307.93 629.03 305.66 Z"
          data-name="Cherokee"
          data-stusps="SC"
          id="45021"
        />
        <path
          className="white"
          d="M 293.62 376.46 297.82 376.74 297.93 375.12 301.45 375.35 302.18 375.42 301.65 383.58 293.15 383.02 293.62 376.46 Z"
          data-name="Winkler"
          data-stusps="TX"
          id="48495"
        />
        <path
          className="white"
          d="M 600.35 302.12 600.5 302.09 601.51 301.99 602.9 301.89 603.51 301.04 603.97 300.82 605 299.75 605.78 299.7 606.16 298.78 607.52 299.21 608.22 301.4 607.84 302.18 607.05 302.09 605.4 303.39 605.92 305.95 604.49 306.25 603.58 306.85 600.77 307.59 601.86 304.48 596.12 304.71 596.65 304.38 597.6 303.39 598.69 302.43 600.35 302.12 Z"
          data-name="Swain"
          data-stusps="NC"
          id="37173"
        />
        <path
          className="white"
          d="M 465.64 308.72 465.56 305.21 467.19 305.18 467.17 303.55 468.81 303.52 468.78 302.14 470.94 303.86 470.27 305.88 472.46 305.65 474.26 306.92 473.97 308.01 474.57 309.95 468.39 310.06 465.67 310.08 465.64 308.72 Z"
          data-name="Stone"
          data-stusps="AR"
          id="5137"
        />
        <path
          className="white"
          d="M 560.73 214.96 562.66 214.74 565.89 214.35 566.07 215.71 566.66 220.02 561.43 220.64 560.73 214.96 Z"
          data-name="Delaware"
          data-stusps="IN"
          id="18035"
        />
        <path
          className="white"
          d="M 574.26 260.83 575.58 259.48 577.58 258.94 577.25 260 578.32 261.18 579.12 260.82 579.45 260.99 579.12 261.71 579.73 263.32 578.93 263.69 578.19 263.69 574.81 264.83 574.79 261.47 574.27 261.02 574.26 260.83 Z"
          data-name="Mercer"
          data-stusps="KY"
          id="21167"
        />
        <path
          className="white"
          d="M 606.61 373.51 609.68 373.15 609.58 372.2 610.72 372.09 611.73 372.09 612.19 373.06 612.35 373.73 612.47 374.66 611.95 376.92 609.54 377.15 609.59 377.69 608.35 376.79 607.09 376.92 606.61 373.51 Z"
          data-name="Turner"
          data-stusps="GA"
          id="13287"
        />
        <path
          className="white"
          d="M 508.27 346.43 512.67 346.14 512.92 350.23 514.9 350.1 513.78 350.68 513.95 353.45 510.93 353.64 510.79 351.44 508.58 351.31 508.27 346.43 Z"
          data-name="Montgomery"
          data-stusps="MS"
          id="28097"
        />
        <path
          className="white"
          d="M 502.93 377.36 510.94 376.97 512.03 376.91 512.46 381.91 510.83 382.11 507.32 382.55 504.95 382.85 505.17 382.36 502.93 377.36 Z"
          data-name="Simpson"
          data-stusps="MS"
          id="28127"
        />
        <path
          className="white"
          d="M 445.71 208.46 448.97 208.39 452.21 208.28 452.39 213.21 445.85 213.4 445.71 208.46 Z"
          data-name="Lucas"
          data-stusps="IA"
          id="19117"
        />
        <path
          className="white"
          d="M 446.85 284.69 455.03 284.66 457.35 284.64 457.48 284.92 457.54 289.83 451.57 289.85 450.99 286.57 446.88 286.61 446.85 284.69 Z"
          data-name="Christian"
          data-stusps="MO"
          id="29043"
        />
        <path
          className="white"
          d="M 622.33 209.38 622.1 207.68 622.95 207.55 622.62 205.09 623.09 205.03 623.45 204.95 627.37 204.45 628.48 204.29 629.09 209.3 626.07 209.67 624.52 209.83 624.09 209.95 622.44 210.18 622.33 209.38 Z"
          data-name="Harrison"
          data-stusps="OH"
          id="39067"
        />
        <path
          className="white"
          d="M 362.33 124.48 375.28 125.07 375.3 125.6 375.08 131.59 363.8 131.1 362 131 362.33 124.48 Z"
          data-name="Edmunds"
          data-stusps="SD"
          id="46045"
        />
        <path
          className="white"
          d="M 396.4 424.88 401.43 418.76 401.98 419.78 403.97 421.33 405.11 421.25 406.47 424.27 407.84 424.93 405.67 427.15 404.98 429.18 400.18 432.12 399.89 431.82 401.5 430.49 397.72 425.93 396.4 424.88 Z"
          data-name="Colorado"
          data-stusps="TX"
          id="48089"
        />
        <path
          className="white"
          d="M 424.29 411.59 429.36 408.97 429.4 408.77 430.58 408.84 431.3 408.81 433.59 415.87 436.06 415.82 436.15 420.01 427.35 420.19 427.03 418.19 426.59 418.09 426.45 417.94 425.43 414.91 424.29 411.59 Z"
          data-name="Liberty"
          data-stusps="TX"
          id="48291"
        />
        <path
          className="white"
          d="M 412.98 362.27 415.91 362.27 416.09 362.63 416.58 367.12 416.19 367.29 414.57 366.19 413.5 366.26 411.84 364.94 411 364.2 411.67 362.27 412.98 362.27 Z"
          data-name="Rains"
          data-stusps="TX"
          id="48379"
        />
        <path
          className="white"
          d="M 569.07 388.93 570.19 389.02 575.58 388.26 576.9 388.16 580.53 387.73 580.85 391.55 580.69 391.56 579.37 391.7 576.6 391.99 574.27 392.24 571.97 392.44 569.49 392.65 569.41 392.29 569.07 388.93 Z"
          data-name="Geneva"
          data-stusps="AL"
          id="1061"
        />
        <path
          className="white"
          d="M 130.44 225.3 144.58 228.29 144.17 230.27 144.17 230.27 143.51 233.46 142.92 236.39 142.53 238.31 142.53 238.31 141.5 243.38 140.95 245.94 140.4 248.62 139.97 250.75 139.19 254.7 138.46 258.42 138.14 260.09 137.56 263.08 126.68 260.88 111.74 257.54 109.31 257.23 114.46 234.25 127.88 237.19 130.44 225.3 Z"
          data-name="Lincoln"
          data-stusps="NV"
          id="32017"
        />
        <path
          className="white"
          d="M 561.43 234.5 562.22 234.4 562.01 232.47 566.85 231.9 567.28 235.38 565.34 236.99 563.63 238.39 561.86 238.62 561.43 234.5 Z"
          data-name="Decatur"
          data-stusps="IN"
          id="18031"
        />
        <path
          className="white"
          d="M 563.6 192.73 569.09 191.96 569.36 193.92 569.4 194.25 569.74 196.83 564.24 197.66 563.6 192.73 Z"
          data-name="DeKalb"
          data-stusps="IN"
          id="18033"
        />
        <path
          className="white"
          d="M 323.11 235.65 332.36 236.26 332.72 236.28 332.18 244.41 330.91 244.34 322.59 243.82 322.87 239.3 323.11 235.65 Z"
          data-name="Sherman"
          data-stusps="KS"
          id="20181"
        />
        <path
          className="white"
          d="M 371.88 223.42 371.92 223.43 378.32 223.62 378.39 223.62 378.2 230.15 374.88 230.05 373.3 230 371.67 229.95 371.88 223.42 Z"
          data-name="Webster"
          data-stusps="NE"
          id="31181"
        />
        <path
          className="white"
          d="M 386.18 151.62 392.66 151.77 392.55 158.27 389.3 158.2 386 158.11 386.18 151.62 Z"
          data-name="Miner"
          data-stusps="SD"
          id="46097"
        />
        <path
          className="white"
          d="M 513.72 146.48 516.58 146.26 518.6 146.09 519.24 152.64 517.61 152.8 517.54 151.93 514.24 152.23 513.72 146.48 Z"
          data-name="Calumet"
          data-stusps="WI"
          id="55015"
        />
        <path
          className="white"
          d="M 486.61 325.17 486.58 324.33 497.27 323.93 497.35 325.22 496.49 325.28 496.38 326.15 495.91 326.63 495.35 327.84 495.32 328.57 494.97 329.18 494.61 329.02 487.55 329.29 487.51 327.63 486.69 327.65 486.61 325.17 Z"
          data-name="Lee"
          data-stusps="AR"
          id="5077"
        />
        <path
          className="white"
          d="M 529.13 265.84 529.36 265.34 529.62 264 529.29 262.72 529.88 262.2 530.2 261.33 530.63 260.31 529.84 259.51 529.87 258.89 532.41 258.71 532.45 259.21 534.16 259.69 534.42 264.77 534.26 265.09 534.09 264.93 532.86 265.36 531.82 264.58 531.11 264.89 531.07 265.05 530.93 265.61 531.52 266.56 531.09 267.13 530.59 267.32 529.7 267.07 529.02 266.05 529.13 265.84 Z"
          data-name="Posey"
          data-stusps="IN"
          id="18129"
        />
        <path
          className="white"
          d="M 475.54 424.97 476.45 423.97 476.59 420.45 476.15 417.58 476.53 416.32 476.73 415.64 478.91 416.1 480.3 414.58 481.47 414.81 482.48 416.18 486.24 415.55 488.49 415.81 488.62 416.08 488.16 417.12 484.63 417.54 482.15 417.84 480.79 419.75 477.24 423.14 478.43 423.19 478.28 423.95 479.44 424.49 480.98 424.94 480.1 426.45 479.23 426.79 477.66 426.01 475.75 425.06 475.54 424.97 Z"
          data-name="Iberia"
          data-stusps="LA"
          id="22045"
        />
        <path
          className="white"
          d="M 431.64 280.46 431.63 279.98 439.66 280.13 439.65 281.23 440.12 281.24 440.11 285.77 431.7 285.74 431.67 283.81 431.64 280.46 Z"
          data-name="Jasper"
          data-stusps="MO"
          id="29097"
        />
        <path
          className="white"
          d="M 651.49 142.24 653.35 141.8 655.87 141.2 657.96 140.94 658.29 142.45 658.9 145.32 652.47 146.8 651.49 142.24 Z"
          data-name="Orleans"
          data-stusps="NY"
          id="36073"
        />
        <path
          className="white"
          d="M 713.56 139.98 718.17 137.88 718.46 137.66 719.38 136.53 720.27 137.07 720 140.65 720.35 142.6 720.44 143.49 714.15 146.32 713.95 146.07 713.61 143.59 714.02 141.12 713.56 139.98 Z"
          data-name="Albany"
          data-stusps="NY"
          id="36001"
        />
        <path
          className="white"
          d="M 300.03 347.25 300.03 347.25 300.45 342.48 307.23 342.93 307.02 351.15 299.73 350.67 300.03 347.25 Z"
          data-name="Cochran"
          data-stusps="TX"
          id="48079"
        />
        <path
          className="white"
          d="M 173.43 335.37 174.12 337.88 174.25 339.12 176.22 345.14 177.34 343.63 179.03 342.46 179.63 342.72 182.1 341.9 180.34 354.43 180.23 354.81 173.94 353.92 173.67 353.93 168.85 353.23 165.7 352.95 158.6 351.78 151.96 350.74 152.5 347.37 154.23 336.65 154.42 335.44 154.46 336.34 156.03 337.76 159.05 338.24 159.42 338.32 162.37 338.76 164.02 339 164.82 334.06 173.43 335.37 Z"
          data-name="Pinal"
          data-stusps="AZ"
          id="4021"
        />
        <path
          className="white"
          d="M 468.32 347.69 473.89 347.56 474.01 350.84 473.45 352.29 473.88 353.31 474.15 355.1 472.01 356.67 471.72 357.81 470.29 356.16 468.15 355.69 468.28 355.37 468.22 355.26 467.82 355.09 468.73 351.71 468.32 347.69 Z"
          data-name="Bradley"
          data-stusps="AR"
          id="5011"
        />
        <path
          className="white"
          d="M 586.92 332.18 588.16 332.06 588.7 331.93 589.54 331.94 590.42 331.8 591.94 331.73 592.83 333.3 591.94 335.02 591.77 335.99 591.89 336.45 591.52 336.67 590.13 338.24 589.3 337.17 587.7 337.31 587.5 335.47 587.17 334.67 586.92 332.18 Z"
          data-name="Cobb"
          data-stusps="GA"
          id="13067"
        />
        <path
          className="white"
          d="M 539.64 200.97 540.43 200.36 541.2 200.11 542.17 199.1 543.33 196.87 544.99 196.68 545.81 196.59 546.34 201.51 539.76 202.19 539.64 200.97 Z"
          data-name="Starke"
          data-stusps="IN"
          id="18149"
        />
        <path
          className="white"
          d="M 452.18 175.47 458.68 175.25 458.87 180.22 458.94 181.84 452.38 182.06 452.18 175.47 Z"
          data-name="Butler"
          data-stusps="IA"
          id="19023"
        />
        <path
          className="white"
          d="M 458.68 175.25 465.21 174.97 465.43 179.95 458.87 180.22 458.68 175.25 Z"
          data-name="Bremer"
          data-stusps="IA"
          id="19017"
        />
        <path
          className="white"
          d="M 421.23 138.86 427.78 138.78 431.19 138.72 431.25 139.09 431.3 142.01 429.54 142.05 429.69 146.94 427.58 146.96 427.11 146.44 426.43 146.19 426.23 145.84 422.82 144.38 421.32 143.07 419.76 142.49 419.01 141.82 418.11 141.49 418.1 138.89 421.23 138.86 Z"
          data-name="Renville"
          data-stusps="MN"
          id="27129"
        />
        <path
          className="white"
          d="M 397.01 70.22 397.01 70.16 406.5 70.27 416.3 70.39 416.43 77.26 405.02 77.21 396.92 77.12 396.97 76.74 397.15 75.54 397.07 73.91 397.08 72.29 396.99 70.38 397.01 70.22 Z"
          data-name="Marshall"
          data-stusps="MN"
          id="27089"
        />
        <path
          className="white"
          d="M 359.26 314.73 370.63 315.11 370.52 321.62 370.48 321.98 370.02 321.48 368.5 321.58 359.09 321.27 359.26 314.73 Z"
          data-name="Washita"
          data-stusps="OK"
          id="40149"
        />
        <path
          className="white"
          d="M 305.51 282.86 307.92 283.05 310.08 283.29 315.25 283.67 319.97 284.01 320.18 284.02 319.52 293.28 317.54 293.14 304.8 292.25 304.95 290.33 305.04 288.96 305.38 284.56 305.51 282.86 Z"
          data-name="Cimarron"
          data-stusps="OK"
          id="40025"
        />
        <path
          className="white"
          d="M 309.64 139.36 317.74 140.1 318.55 131.93 331.3 133.01 330.54 142.89 330.53 142.91 328.93 144.2 327.88 144.28 326.65 143.78 326.31 145.15 325.71 145.59 324.79 148.27 324.77 149.46 310.38 148.2 310.57 146.03 308.93 145.88 309.64 139.36 Z"
          data-name="Meade"
          data-stusps="SD"
          id="46093"
        />
        <path
          className="white"
          d="M 389.45 403.83 390.4 401.27 393.47 399.5 397.06 397.4 397.36 397.31 398.37 398.49 398.53 400.66 400.37 402.71 400.84 403.85 400.68 404.35 395.11 407.55 391.98 409.39 390.19 404.16 389.45 403.83 Z"
          data-name="Milam"
          data-stusps="TX"
          id="48331"
        />
        <path
          className="white"
          d="M 189.9 214.7 195.57 215.68 208.37 217.94 209.73 218.16 208.34 219.49 206.75 222.32 206.66 224.19 206.65 224.19 191.18 221.64 191.3 220.61 190.92 218.75 190.46 219.02 189.54 216.75 189.9 214.7 Z"
          data-name="Carbon"
          data-stusps="UT"
          id="49007"
        />
        <path
          className="white"
          d="M 678.56 244.23 678.76 244.25 679.83 244.91 681.22 245.34 681.85 246.49 683.23 246.74 684.6 246.94 685.82 246.71 685.84 248.46 686.53 249.1 685.99 249.47 683.42 249.15 681.53 247.84 680.83 249.31 679.35 248.95 678.83 248.02 677.7 247.48 677.78 246.96 678.56 244.23 Z"
          data-name="Goochland"
          data-stusps="VA"
          id="51075"
        />
        <path
          className="white"
          d="M 507.18 166.84 513.69 166.32 513.9 169.64 514.19 172.96 512.02 173.15 510.93 173.24 508.97 173.34 507.66 173.42 507.18 166.84 Z"
          data-name="Jefferson"
          data-stusps="WI"
          id="55055"
        />
        <path
          className="white"
          d="M 459.58 401.04 461.86 401 462.08 400.72 463.43 400.69 465.33 400.5 465.73 400.54 466.15 406.78 465.43 408.2 463.09 408.26 463.09 409.21 458.38 409.31 457.32 409.62 457.25 406.35 459.71 406.29 459.58 401.04 Z"
          data-name="Allen"
          data-stusps="LA"
          id="22003"
        />
        <path
          className="white"
          d="M 250.9 269.97 260.49 271.1 260.41 271.93 264.85 272.41 265.06 273.79 263.81 278.3 264.51 279.24 260.3 278.81 260.16 278.79 255.07 278.25 253.06 278.04 251.67 275.09 251.66 274.04 250.51 273.27 250.9 269.97 Z"
          data-name="Conejos"
          data-stusps="CO"
          id="8021"
        />
        <path
          className="white"
          d="M 545.59 209.87 546.49 210.6 548.66 210.36 548.91 212.83 549.16 215.26 544.57 215.75 544.31 213.31 543.22 213.42 543.18 210.12 545.59 209.87 Z"
          data-name="Carroll"
          data-stusps="IN"
          id="18015"
        />
        <path
          className="white"
          d="M 713.35 263.91 714.82 263.59 717.28 263.06 718.2 265.17 719.44 267.79 720.08 268.81 720.87 272.14 719.84 272.92 719.25 272.79 718.58 272.05 718.55 270.51 717.11 268.38 715.23 267.3 714.26 267.56 713.3 266.41 710.42 264.53 710.42 264.53 713.35 263.91 Z"
          data-name="Currituck"
          data-stusps="NC"
          id="37053"
        />
        <path
          className="white"
          d="M 590.04 355.42 592.11 355.18 593.05 354.38 595.28 356.1 596.85 356.53 596.08 357.13 595.27 360.25 594.71 360.31 592.54 361.29 591.67 361.16 590.79 361.56 591.13 360.66 590.66 360.33 590.46 358.4 590.55 357.54 590.04 355.42 Z"
          data-name="Talbot"
          data-stusps="GA"
          id="13263"
        />
        <path
          className="white"
          d="M 518.6 146.09 520.7 145.89 520.54 144.26 522.18 144.1 525.19 143.8 525.17 143.91 525.61 145.04 525.89 145.94 525.55 146.94 524.78 147.55 524.14 148.56 523.76 150.8 523.5 152.22 519.24 152.64 518.6 146.09 Z"
          data-name="Manitowoc"
          data-stusps="WI"
          id="55071"
        />
        <path
          className="white"
          d="M 641.4 174.11 640.88 171.32 642.82 170.94 648.6 169.78 649.7 169.56 650.6 169.37 651.25 172.34 650.82 172.63 651.51 176.56 643.64 178.09 642.21 178.38 641.4 174.11 Z"
          data-name="Warren"
          data-stusps="PA"
          id="42123"
        />
        <path
          className="white"
          d="M 594.79 403.5 601.8 402.73 602.59 403.21 605.31 402.94 605.65 406.24 604.86 406.48 604 406.91 603.5 406.74 602.21 407.4 601.05 408.44 601.46 409.14 599.39 408.74 598.5 409.21 598.11 408.69 597.31 408.42 595.82 406.68 594.79 403.5 Z"
          data-name="Wakulla"
          data-stusps="FL"
          id="12129"
        />
        <path
          className="white"
          d="M 636.07 450.04 644.52 449.08 645.16 454.95 645.43 457.43 642.15 457.78 642.07 457.76 641.72 454.41 634.99 455.08 634.15 454.26 633.09 452.57 633.49 452.56 634.67 452.55 635.64 451.04 636.07 450.04 Z"
          data-name="Manatee"
          data-stusps="FL"
          id="12081"
        />
        <path
          className="white"
          d="M 411.51 279.68 418.04 279.72 418.1 279.72 418.11 286.93 417.34 286.93 414.13 286.94 412.01 286.94 411.46 286.94 411.47 281.32 411.47 280.11 411.51 279.68 Z"
          data-name="Montgomery"
          data-stusps="KS"
          id="20125"
        />
        <path
          className="white"
          d="M 768.15 152.35 769.16 151.78 769.72 150.04 770.67 148.9 771.56 149.23 772.54 149.51 773.03 149.47 773.64 150.64 771.83 151.3 770.21 151.93 769.37 153.01 768.92 154.23 768.37 153.04 768.15 152.35 Z M 768.57 148.29 769.07 148.47 769.56 148.61 768.79 149.4 768.22 150.4 767.39 151.09 766.19 151.8 766.12 150.88 767.69 149.51 768.57 148.29 Z"
          data-name="Dukes"
          data-stusps="MA"
          fillRule="evenodd"
          id="25007"
        />
        <path
          className="white"
          d="M 410.08 220.86 415.16 220.85 415.41 221.41 415.56 221.98 416.07 223.24 416.19 223.8 416.01 224.62 416.8 224.86 417.45 225.2 417.53 225.71 417.53 225.74 410.88 225.77 410.07 225.75 410.08 220.86 Z"
          data-name="Nemaha"
          data-stusps="NE"
          id="31127"
        />
        <path
          className="white"
          d="M 406.42 208.33 410.93 208.33 412.34 208.32 412.34 208.45 413.09 208.4 413.02 208.91 412.92 209.58 412.99 210.35 412.98 210.92 411.36 210.91 410.98 210.78 410.26 210.68 407.94 212.01 406.52 211.05 406.23 210.35 406.42 208.33 Z"
          data-name="Sarpy"
          data-stusps="NE"
          id="31153"
        />
        <path
          className="white"
          d="M 673.99 154.76 675.62 154.37 675.74 154.77 677.11 154.45 676.68 153 679.43 152.25 680.66 157.18 681.68 156.97 681.57 157.97 680.24 157.99 680.03 157.14 676.86 158.17 675 158.72 673.99 154.76 Z"
          data-name="Schuyler"
          data-stusps="NY"
          id="36097"
        />
        <path
          className="white"
          d="M 342.05 294.57 345.61 294.73 350.27 294.94 350.32 294.94 349.96 303.27 341.73 302.88 341.63 302.88 342.05 294.57 Z"
          data-name="Lipscomb"
          data-stusps="TX"
          id="48295"
        />
        <path
          className="white"
          d="M 667.01 210.76 667.81 208.57 668.62 203.82 668.14 203.37 668.88 201.67 672.16 202.2 673.21 202.81 672.63 204.14 672.12 207.67 671.12 209.93 667.56 210.65 667.56 210.65 667.01 210.76 Z"
          data-name="Fulton"
          data-stusps="PA"
          id="42057"
        />
        <path
          className="white"
          d="M 635.59 253.64 637.51 252.35 639.92 254.01 640.09 254.59 640.15 255.04 638.13 260.95 638.12 260.95 637.95 260.71 634.05 258.36 634.28 257.33 635.88 255.6 637.01 255.99 635.59 253.64 Z"
          data-name="Summers"
          data-stusps="WV"
          id="54089"
        />
        <path
          className="white"
          d="M 277.61 128.32 279.97 128.57 290.25 129.8 289.67 133.8 288.44 145.27 287 157.99 274.17 156.55 275.04 150.43 276.61 137.29 276.78 136.49 277.61 128.32 Z"
          data-name="Campbell"
          data-stusps="WY"
          id="56005"
        />
        <path
          className="white"
          d="M 645.43 457.43 645.16 454.95 653.52 453.94 654.23 459.79 647.05 460.58 645.79 460.78 645.43 457.43 Z"
          data-name="DeSoto"
          data-stusps="FL"
          id="12027"
        />
        <path
          className="white"
          d="M 604.45 371.72 604.31 372.92 603.29 373.92 603.44 376.8 603.1 377.34 598.98 377.82 598.82 374.6 599.18 373.86 597.82 373.14 597.73 372.33 604.45 371.72 Z"
          data-name="Lee"
          data-stusps="GA"
          id="13177"
        />
        <path
          className="white"
          d="M 153.97 147.78 157.14 148.51 157.23 149.36 161.33 150.3 161.15 151.11 162.79 151.48 161.83 155.8 160.84 155.76 160.22 155.58 158.89 155.95 157.57 154.38 154.67 152.92 152.79 151.51 153.6 147.92 153.97 147.78 Z"
          data-name="Jerome"
          data-stusps="ID"
          id="16053"
        />
        <path
          className="white"
          d="M 496.42 206.31 498.08 206.2 498 204.97 498.12 204.59 501.22 204.39 501.34 205.99 501.35 206.12 501.57 209.27 496.63 209.6 496.42 206.31 Z"
          data-name="Stark"
          data-stusps="IL"
          id="17175"
        />
        <path
          className="white"
          d="M 439.23 180.77 439.12 175.83 445.65 175.66 445.82 182.24 439.26 182.39 439.23 180.77 Z"
          data-name="Wright"
          data-stusps="IA"
          id="19197"
        />
        <path
          className="white"
          d="M 459.26 385.47 464.92 385.3 464.89 383.66 469 383.54 469.29 386.76 470.57 388.38 470.55 389.13 471.87 389.43 464.91 391.29 463.93 391.14 463.45 388.95 462 387.47 460.35 387.01 459.42 386 459.26 385.47 Z"
          data-name="Grant"
          data-stusps="LA"
          id="22043"
        />
        <path
          className="white"
          d="M 463.51 224 469.24 223.8 469.26 224.62 469.34 225.43 469.48 230.4 466.23 230.44 464.64 230.54 463.82 230.56 463.75 228.99 463.51 224 Z"
          data-name="Knox"
          data-stusps="MO"
          id="29103"
        />
        <path
          className="white"
          d="M 340.66 244.93 341.98 245.01 350.13 245.44 350.37 245.45 349.89 253.61 348.52 253.53 342.04 253.17 340.11 253.07 340.66 244.93 Z"
          data-name="Gove"
          data-stusps="KS"
          id="20063"
        />
        <path
          className="white"
          d="M 385.13 208.34 387.45 206.05 388.36 205.77 388.46 205.41 389.54 204.89 391.73 204.29 391.62 210.84 385.11 210.72 385.13 208.34 Z"
          data-name="Polk"
          data-stusps="NE"
          id="31143"
        />
        <path
          className="white"
          d="M 350.35 293.19 356.37 293.45 356.2 301.49 359.46 301.61 359.37 304.45 357.6 305.03 356.56 307.1 355.61 307.52 354.13 307.13 352.88 306.12 352.83 304.44 351.62 304.62 351 305.99 349.82 306.55 349.96 303.27 350.32 294.94 350.27 294.94 350.35 293.19 Z"
          data-name="Ellis"
          data-stusps="OK"
          id="40045"
        />
        <path
          className="white"
          d="M 364.62 345.53 372.91 345.72 372.77 352.64 372.75 353.96 364.36 353.71 364.62 345.53 Z"
          data-name="Archer"
          data-stusps="TX"
          id="48009"
        />
        <path
          className="white"
          d="M 657.97 250.43 658.1 250.3 658.66 250.27 658.55 250.28 658.13 250.82 657.97 250.43 Z"
          data-name="Lexington"
          data-stusps="VA"
          id="51678"
        />
        <path
          className="white"
          d="M 461.89 123.72 463.52 123.64 469.99 123.36 470.32 129.84 470.4 131.45 468.76 131.51 462.24 131.8 461.89 123.72 Z"
          data-name="Barron"
          data-stusps="WI"
          id="55005"
        />
        <path
          className="white"
          d="M 572.04 247.63 573.87 246.39 573.96 246.15 575.68 245.18 576.02 244.79 576.43 246.69 579.63 249.07 578.01 251.24 577.54 251.64 576.79 251.99 575.6 251.79 574.75 249.92 574.04 250.44 573.67 249.04 572.04 247.63 Z"
          data-name="Owen"
          data-stusps="KY"
          id="21187"
        />
        <path
          className="white"
          d="M 432.94 303.63 435.38 303.65 436.2 302.83 436.22 301.47 441.7 301.57 442.99 300.97 442.19 303.68 442.02 309.88 439.56 309.85 438.21 310.1 433.92 310.04 433.89 309.87 433.27 305.77 432.94 303.63 Z"
          data-name="Washington"
          data-stusps="AR"
          id="5143"
        />
        <path
          className="white"
          d="M 515.18 277.08 514.86 272.06 519.84 271.64 519.84 271.64 520.18 276.57 517.27 276.81 516.96 277.45 515.23 277.75 515.18 277.08 Z"
          data-name="Johnson"
          data-stusps="IL"
          id="17087"
        />
        <path
          className="white"
          d="M 426.73 158.39 433.32 158.29 434.98 158.27 435.09 164.79 433.14 164.82 432.43 164.84 426.8 164.91 426.73 158.39 Z"
          data-name="Martin"
          data-stusps="MN"
          id="27091"
        />
        <path
          className="white"
          d="M 328.95 260.64 335.13 260.98 335.46 261 334.99 269.17 335.1 270.93 328.57 270.55 328.44 268.82 328.95 260.64 Z"
          data-name="Kearny"
          data-stusps="KS"
          id="20093"
        />
        <path
          className="white"
          d="M 382.73 249.86 390.89 250.03 390.74 250.57 390.78 256.56 382.64 256.39 382.7 251.49 382.73 249.86 Z"
          data-name="Saline"
          data-stusps="KS"
          id="20169"
        />
        <path
          className="white"
          d="M 562.6 197.86 564.24 197.66 569.74 196.83 569.79 197.18 570.11 199.64 570.43 202.13 570.6 203.38 566.74 203.96 563 204.43 562.8 202.78 562.36 199.51 562.6 197.86 Z"
          data-name="Allen"
          data-stusps="IN"
          id="18003"
        />
        <path
          className="white"
          d="M 475.75 159.04 480.46 158.78 488.61 158.15 488.72 159.85 488.84 161.48 483.92 161.82 484.11 164.25 477.07 164.67 476.7 164.76 476.37 164.18 476.52 163.24 476.24 162.04 475.93 161.39 475.59 160.16 475.75 159.04 Z"
          data-name="Vernon"
          data-stusps="WI"
          id="55123"
        />
        <path
          className="white"
          d="M 531.33 378.59 531.28 377.85 531.37 375.58 531.5 372.27 531.52 371.85 531.55 370.74 539.39 370.14 538.01 370.72 538.34 372.58 536.88 376.08 537.54 376.33 536.83 377.14 536.07 379.76 537.7 381.82 531.67 382.27 531.47 380.53 531.33 378.59 Z"
          data-name="Choctaw"
          data-stusps="AL"
          id="1023"
        />
        <path
          className="white"
          d="M 565.89 214.35 566.06 214.14 565.85 212.44 565.9 212.12 565.73 210.78 567.63 210.53 571.44 209.97 571.61 211.3 571.69 211.98 571.94 214.1 571.94 214.1 572.03 214.91 566.07 215.71 565.89 214.35 Z"
          data-name="Jay"
          data-stusps="IN"
          id="18075"
        />
        <path
          className="white"
          d="M 514.23 287.4 515 287.14 515.59 287.56 519.43 287.28 519.37 287.72 519.75 292.37 519.59 292.39 519.48 292.39 518.33 291.06 517.75 290.83 516.45 290.91 514.55 289.97 514.11 289.96 514.25 289.74 513.62 288.76 514.25 287.97 514.23 287.4 Z"
          data-name="Hickman"
          data-stusps="KY"
          id="21105"
        />
        <path
          className="white"
          d="M 651.02 213.9 652.24 213.66 657.3 212.66 659.01 212.33 657.87 217.3 657.89 217.45 657.54 217.53 656.7 219.09 655.56 220.76 655.3 221.14 654.39 221.93 653.52 223.06 652.68 223.65 652.23 221.03 651.6 217.49 651.02 213.9 Z"
          data-name="Garrett"
          data-stusps="MD"
          id="24023"
        />
        <path
          className="white"
          d="M 389.45 94.51 392.71 94.59 400.59 94.75 400.69 96.39 400.77 97.69 400.56 99.03 401.44 100.87 401.09 103.4 401.09 104.99 401.03 106.04 401.04 106.06 400.7 106.16 394.69 106.09 389.49 105.97 389.65 99.42 389.33 99.41 389.45 94.51 Z"
          data-name="Cass"
          data-stusps="ND"
          id="38017"
        />
        <path
          className="white"
          d="M 639.21 292.67 640.02 290.97 640.28 288.98 639.66 287.39 640.44 287.01 641.9 286.84 644.81 286.47 645.18 290.26 644.74 293.84 645.51 295.9 645.76 296.91 645.04 297.02 643.11 297.15 642.56 297.74 642.56 296.95 642.19 296.66 642.47 295.76 642.47 295.15 642.05 294.85 641.73 294.34 641.45 294.15 641.2 293.81 641.01 293.68 640.15 293.81 639.21 292.67 Z"
          data-name="Iredell"
          data-stusps="NC"
          id="37097"
        />
        <path
          className="white"
          d="M 519.59 292.39 519.75 292.37 524.31 292.04 524.6 298.62 524.62 299.31 522.74 299.42 522.25 300.49 519.54 299.27 517.95 297.78 517.87 294.25 519.88 294.09 519.59 292.39 Z"
          data-name="Weakley"
          data-stusps="TN"
          id="47183"
        />
        <path
          className="white"
          d="M 628.16 278.64 630.89 278.39 633.14 278.11 635.36 281.47 635.27 281.84 634.17 281.82 633.78 283.64 632.21 284.76 630.76 284.36 629.43 283.06 627.99 282.5 627.78 282.08 628.23 280.96 627.96 279.66 628.16 278.64 Z"
          data-name="Ashe"
          data-stusps="NC"
          id="37009"
        />
        <path
          className="white"
          d="M 285.13 232.5 285.4 232.53 298.9 233.78 297.68 246.92 292.74 246.44 293.24 241.58 284.29 240.7 285.13 232.5 Z"
          data-name="Elbert"
          data-stusps="CO"
          id="8039"
        />
        <path
          className="white"
          d="M 587.15 317.33 590.2 316.99 591.49 317.41 594.24 321.05 593.44 322.09 592.14 322.04 592.04 322.36 591.67 322.68 590.63 322.78 590.12 322.57 589.58 322.63 587.24 323.17 587.17 322.53 586.82 319.78 587.16 318.68 587.15 317.33 Z"
          data-name="Gilmer"
          data-stusps="GA"
          id="13123"
        />
        <path
          className="white"
          d="M 490.23 228.6 491.32 227.92 492.38 225.9 493.46 227.13 494.77 227.08 497.58 225.86 497.84 229.74 497.88 230.29 489.35 230.75 490.28 229.02 490.23 228.6 Z"
          data-name="Cass"
          data-stusps="IL"
          id="17017"
        />
        <path
          className="white"
          d="M 455.22 201.66 456.84 201.59 461.7 201.4 461.99 207.92 458.72 208.05 455.47 208.17 455.22 201.66 Z"
          data-name="Mahaska"
          data-stusps="IA"
          id="19123"
        />
        <path
          className="white"
          d="M 686.21 214.05 686.22 214.04 687.14 213.54 690.44 213.21 691.9 213.61 692.09 214.52 693.39 215.04 693.73 215.19 693.56 215.47 693.58 215.63 693.49 215.86 693.15 216 692.93 216.34 692.77 216.76 692.76 217.09 692.63 217.25 692.4 217.3 692.25 217.43 692.25 217.58 692.08 217.75 691.25 217.38 690.21 217.54 689.87 217.06 688.07 215.62 687.03 215.4 686.01 214.38 686.21 214.05 Z"
          data-name="Howard"
          data-stusps="MD"
          id="24027"
        />
        <path
          className="white"
          d="M 502.91 346.73 508.27 346.43 508.58 351.31 510.79 351.44 510.93 353.64 510.05 353.7 509.37 355.07 502.53 353.22 502.44 351.65 503.56 350.8 502.91 346.73 Z"
          data-name="Carroll"
          data-stusps="MS"
          id="28015"
        />
        <path
          className="white"
          d="M 418.23 260.85 424.76 260.82 424.64 267.43 418.09 267.45 418.23 260.85 Z"
          data-name="Anderson"
          data-stusps="KS"
          id="20003"
        />
        <path
          className="white"
          d="M 410.31 151.93 416.66 151.95 418.43 151.93 418.46 158.46 410.45 158.45 410.28 158.45 410.31 151.93 Z"
          data-name="Murray"
          data-stusps="MN"
          id="27101"
        />
        <path
          className="white"
          d="M 362.37 210 365.48 210.11 372 210.35 372.38 210.36 372.17 216.89 372.12 217.06 369.5 217.67 365.6 217.38 362.73 217.18 362.21 217.05 362.1 216.5 362.37 210 Z"
          data-name="Buffalo"
          data-stusps="NE"
          id="31019"
        />
        <path
          className="white"
          d="M 365.62 155.84 366.02 155.87 371.44 156.06 373.06 156.11 373.15 157.74 372.94 164.3 366.06 164.03 365.13 161.03 363.87 160.68 364.74 160.11 364.75 158.8 366.17 157.35 365.62 155.84 Z"
          data-name="Brule"
          data-stusps="SD"
          id="46015"
        />
        <path
          className="white"
          d="M 413.04 354.22 413.05 353.24 413.54 353.29 414.57 352.61 415.98 353.03 417.04 352.8 418.8 353.35 419.98 354.15 421.69 354.74 421.72 354.79 421.69 354.8 418.65 355.36 417.35 355.15 415.95 356.23 415.22 356.28 415.05 356.17 414.17 357.13 412.99 357.78 413.04 354.22 Z"
          data-name="Delta"
          data-stusps="TX"
          id="48119"
        />
        <path
          className="white"
          d="M 211.12 198.9 211.45 199.04 208.37 217.94 195.57 215.68 195.85 214.05 195.36 213.96 197.76 199.26 198.07 198.36 199.01 198.85 200.16 198.33 201.49 198.7 202.02 198.23 202.91 198.6 205.62 198.5 207 197.84 209.15 198.63 211.12 198.9 Z"
          data-name="Duchesne"
          data-stusps="UT"
          id="49013"
        />
        <path
          className="white"
          d="M 495.91 159.34 498.44 159.12 503.27 158.74 504.9 158.82 506.54 158.67 506.82 161.94 507.05 165.21 502.19 165.66 497.27 165.81 497.77 164.49 498.79 164.04 498.56 160.71 496.73 160.59 495.9 159.34 495.91 159.34 Z"
          data-name="Columbia"
          data-stusps="WI"
          id="55021"
        />
        <path
          className="white"
          d="M 569.97 279.5 573.32 279.38 572.73 279.96 573.73 280.68 573.49 282.81 572.99 285.12 570.87 285.51 569.8 284.24 570.11 283.39 569.41 283.51 568.03 282 567.84 280.99 568.5 281.33 569.97 279.5 Z"
          data-name="Cumberland"
          data-stusps="KY"
          id="21057"
        />
        <path
          className="white"
          d="M 334.67 215.11 336.07 215.2 342.79 215.56 342.42 222.14 334.58 221.65 334.3 221.64 334.67 215.11 Z"
          data-name="Hayes"
          data-stusps="NE"
          id="31085"
        />
        <path
          className="white"
          d="M 539.76 202.19 546.34 201.51 546.86 206.42 545.24 206.58 540.26 207.07 539.76 202.19 Z"
          data-name="Pulaski"
          data-stusps="IN"
          id="18131"
        />
        <path
          className="white"
          d="M 419.6 182.6 426.18 182.57 426.19 184.19 427 184.18 427.03 189.14 423.79 189.16 420.54 189.17 420.53 184.22 419.62 184.23 419.6 182.6 Z"
          data-name="Sac"
          data-stusps="IA"
          id="19161"
        />
        <path
          className="white"
          d="M 410.48 245.36 416.99 245.37 416.89 248.21 418.3 248.36 418.31 251.86 411.77 251.86 411.77 247.58 411.09 246.92 410.42 247.05 410.47 246.72 410.48 245.36 Z"
          data-name="Shawnee"
          data-stusps="KS"
          id="20177"
        />
        <path
          className="white"
          d="M 572.88 258.21 573.6 257.46 573.84 256.35 575.72 256.8 576.23 256.29 576.79 256.67 576.61 257.57 577.58 258.94 575.58 259.48 574.26 260.83 572.77 260.52 572.42 260.93 572.04 259.56 571.96 259.08 572.88 258.21 Z"
          data-name="Anderson"
          data-stusps="KY"
          id="21005"
        />
        <path
          className="white"
          d="M 325.22 302.01 333.42 302.48 332.98 310.55 324.75 310.11 325.22 302.01 Z"
          data-name="Hutchinson"
          data-stusps="TX"
          id="48233"
        />
        <path
          className="white"
          d="M 339.54 164.7 352.91 165.46 353.43 165.49 353.18 170.41 353.26 172.87 342.21 172.25 339.07 172.04 339.54 164.7 Z"
          data-name="Todd"
          data-stusps="SD"
          id="46121"
        />
        <path
          className="white"
          d="M 375.15 131.59 384.91 131.96 384.87 133.59 384.66 143.39 374.9 143.04 375.07 138.42 374.93 138.1 375.15 131.59 Z"
          data-name="Spink"
          data-stusps="SD"
          id="46115"
        />
        <path
          className="white"
          d="M 14.42 214.74 12.72 214.23 12.81 213.68 12.92 212.97 13.81 212.62 14.86 212.84 14.97 213.19 14.8 214.23 15.04 214.49 14.88 214.75 14.42 214.74 Z"
          data-name="San Francisco"
          data-stusps="CA"
          id="6075"
        />
        <path
          className="white"
          d="M 707.18 210.51 707.84 210.31 708.82 210.23 709.2 209.78 709.72 209.68 710.61 208.24 711.32 208.86 712.52 209.91 713.06 211.31 713.11 212.39 713.62 213.79 714.61 214.31 715.44 215.57 714.28 215.55 714.04 216.52 713 217 712.25 218.55 709.78 219.24 708.04 213.38 707.46 211.45 707.18 210.51 Z"
          data-name="Kent"
          data-stusps="DE"
          id="10001"
        />
        <path
          className="white"
          d="M 422.88 248.57 422.98 246.98 422.92 241.53 425.59 241.52 426.05 241.46 426.34 241.87 427.18 241.99 426.91 243.29 427.67 244.21 428.13 244.81 428.52 245.48 428.63 245.56 427.05 245.55 426.97 249.52 426.75 249.31 424.81 249.71 422.91 250.06 422.88 248.57 Z"
          data-name="Leavenworth"
          data-stusps="KS"
          id="20103"
        />
        <path
          className="white"
          d="M 322.05 252 329.1 252.42 328.58 260.62 321.51 260.17 321.52 260.06 321.66 257.88 321.95 253.55 322.05 252 Z"
          data-name="Greeley"
          data-stusps="KS"
          id="20071"
        />
        <path
          className="white"
          d="M 589.28 163.06 590.91 162.71 594.28 162.11 595.38 166.21 594.22 167.28 594.79 167.76 595.04 168.41 593.67 169.05 593.67 169.07 593.68 169.19 593.75 170.35 593.78 170.79 590.82 171.32 590.52 169.68 590.31 168.59 590.2 168.01 589.28 163.06 Z"
          data-name="Macomb"
          data-stusps="MI"
          id="26099"
        />
        <path
          className="white"
          d="M 391.38 223.91 397.88 224.02 397.8 230.55 396.46 230.53 391.26 230.45 391.38 223.91 Z"
          data-name="Jefferson"
          data-stusps="NE"
          id="31095"
        />
        <path
          className="white"
          d="M 205.89 333.9 206.14 332.05 207.76 319.8 207.9 318.73 228.56 321.36 227.87 327.09 227.98 327.38 226.3 342.18 221.74 341.62 221.12 346.85 213.97 346 212.51 345.68 204.49 344.66 204.49 344.66 204.98 340.85 205.89 333.9 Z"
          data-name="Catron"
          data-stusps="NM"
          id="35003"
        />
        <path
          className="white"
          d="M 404.42 204.5 406.42 204.52 411.85 204.54 412.1 204.6 412.08 204.97 412.12 205.87 412.62 206.69 412.32 207.45 412.34 208.32 410.93 208.33 406.42 208.33 405.11 205.06 404.42 204.5 Z"
          data-name="Douglas"
          data-stusps="NE"
          id="31055"
        />
        <path
          className="white"
          d="M 689.65 282.23 690.62 277.15 690.62 276.4 693.26 277.02 693.84 278.08 695.73 278.33 697.04 280.05 697.24 281.71 696.57 281.57 694.67 283.51 692.88 285.4 691.86 284.54 690.99 282.75 689.65 282.23 Z"
          data-name="Edgecombe"
          data-stusps="NC"
          id="37065"
        />
        <path
          className="white"
          d="M 304.8 292.25 317.54 293.14 316.99 301.5 303.59 300.57 304.2 292.2 304.8 292.25 Z"
          data-name="Dallam"
          data-stusps="TX"
          id="48111"
        />
        <path
          className="white"
          d="M 541.14 332.22 542.79 332.14 549.35 331.68 549.82 337.46 549.21 337.5 548.89 337.3 548.17 337.57 541.59 337.96 541.14 332.22 Z"
          data-name="Winston"
          data-stusps="AL"
          id="1133"
        />
        <path
          className="white"
          d="M 625.29 409.36 625.73 409.26 625.83 408.1 626.05 407.61 627.04 407.09 627.54 407.11 627.65 407.69 629.61 408.75 630.23 413.78 628.58 414.02 628.25 413.62 626.87 413.79 625.51 413.81 625.23 413.95 624.96 410.74 625.29 409.36 Z"
          data-name="Gilchrist"
          data-stusps="FL"
          id="12041"
        />
        <path
          className="white"
          d="M 594.42 333.66 595.17 334.59 595.77 335.13 596.28 335.34 597.99 336.7 598.86 337.07 597.71 339.85 596.56 339.38 595.63 339.78 595.25 339.51 595.02 339.53 593.93 339.64 593.55 335.91 593.52 335.68 593.45 335.05 593.29 333.59 594.42 333.66 Z"
          data-name="DeKalb"
          data-stusps="GA"
          id="13089"
        />
        <path
          className="white"
          d="M 548.11 248.54 553.63 247.95 554.15 252.94 554.2 253.48 549.67 253.92 548.68 254.03 548.42 251.56 548.11 248.54 Z"
          data-name="Orange"
          data-stusps="IN"
          id="18117"
        />
        <path
          className="white"
          d="M 397.28 256.66 397.37 252.86 397.93 251.78 403.63 251.84 403.62 252.65 405.25 252.67 405.25 254.3 405.8 254.3 405.76 258.38 398.89 258.31 397.27 258.29 397.28 256.66 Z"
          data-name="Morris"
          data-stusps="KS"
          id="20127"
        />
        <path
          className="white"
          d="M 574.84 265.73 574.82 265.1 574.81 264.83 578.19 263.69 578.93 263.69 580.46 264.69 580.41 265.01 580.45 265.31 577.76 266.97 577.04 267.37 574.89 267.37 574.84 265.73 Z"
          data-name="Boyle"
          data-stusps="KY"
          id="21021"
        />
        <path
          className="white"
          d="M 459.59 377.23 461.57 377.18 469.6 376.97 469.73 381.06 469.35 383.22 469 383.54 464.89 383.66 464.92 385.3 459.26 385.47 459.33 384.11 460.77 380.99 459.59 377.23 Z"
          data-name="Winn"
          data-stusps="LA"
          id="22127"
        />
        <path
          className="white"
          d="M 456.04 151.13 457.77 151.07 460.91 150.96 460.98 152.58 464.22 152.46 464.44 157.33 459.75 157.51 459.43 157.79 456.37 157.91 456.15 157.65 456.29 157.46 456.04 151.13 Z"
          data-name="Olmsted"
          data-stusps="MN"
          id="27109"
        />
        <path
          className="white"
          d="M 446.24 270.99 447.06 270.99 447.22 271.27 452.81 271.32 453.07 272.68 453.09 278.55 446.53 278.52 446.54 275.8 446.56 272.63 446.24 270.99 Z"
          data-name="Polk"
          data-stusps="MO"
          id="29167"
        />
        <path
          className="white"
          d="M 602.03 220.68 602.26 220.1 602.21 219.4 601.81 217.89 602.23 217.86 606.46 217.49 606.89 217.34 607.02 219.11 608.13 219.02 608.97 222.33 607.26 222.46 607.35 223.58 605.56 223.74 605.65 224.59 604.05 225.01 602.4 225.12 602.03 220.68 Z"
          data-name="Fairfield"
          data-stusps="OH"
          id="39045"
        />
        <path
          className="white"
          d="M 425.96 296.06 425.95 294.41 426.03 293.05 431.8 293.04 431.81 294.07 431.84 296.19 432.37 299.93 432.76 302.51 429.19 302.56 425.93 302.59 425.96 296.06 Z"
          data-name="Delaware"
          data-stusps="OK"
          id="40041"
        />
        <path
          className="white"
          d="M 362.84 400.12 371.23 400.33 371.02 401.12 372.31 401.98 371.39 402.87 372.35 403.75 371.23 404.98 371.64 406.84 372.59 407.17 372.58 408.52 371.6 408.2 368.68 408.17 362.63 408.04 362.84 400.12 Z"
          data-name="Llano"
          data-stusps="TX"
          id="48299"
        />
        <path
          className="white"
          d="M 407.84 424.93 408.87 425.12 409.26 425.53 409.98 426.27 409.73 427.94 411.14 429.1 411.58 430.56 413.21 431.89 412.77 432.5 411.27 434.05 405.6 437.48 400.18 432.12 404.98 429.18 405.67 427.15 407.84 424.93 Z"
          data-name="Wharton"
          data-stusps="TX"
          id="48481"
        />
        <path
          className="white"
          d="M 671.8 219.98 672.22 219.93 672.64 220.22 672.15 221.36 671.88 220.84 671.8 219.98 Z"
          data-name="Winchester"
          data-stusps="VA"
          id="51840"
        />
        <path
          className="white"
          d="M 462.81 113.94 469.32 113.61 469.99 123.36 463.52 123.64 463.18 117.19 462.81 113.94 Z"
          data-name="Washburn"
          data-stusps="WI"
          id="55129"
        />
        <path
          className="white"
          d="M 652.5 234.27 653.82 231.76 653.29 229.68 655.33 228.74 655.57 227.98 659.27 230.1 660.6 230.87 660.4 232.31 660.43 232.9 659.71 234.07 659.29 235.69 659.06 236.68 659.03 236.79 658.25 238.06 658.04 238.06 657.13 238.06 655.44 237.78 654.13 236.14 652.42 235.71 652.76 235.07 652.5 234.27 Z"
          data-name="Pendleton"
          data-stusps="WV"
          id="54071"
        />
        <path
          className="white"
          d="M 512.35 265.56 513.09 263.44 512.83 262.23 519.14 261.75 519.42 265.86 519.48 266.67 512.87 267.19 512.75 265.54 512.35 265.56 Z"
          data-name="Franklin"
          data-stusps="IL"
          id="17055"
        />
        <path
          className="white"
          d="M 545.56 225.32 550.48 224.78 550.9 224.73 551.03 225.82 551.09 226.64 551.49 230.22 551.35 230.24 549.52 231.03 546.74 231.3 546.91 230.97 546.24 230.8 545.67 226.41 545.56 225.32 Z"
          data-name="Hendricks"
          data-stusps="IN"
          id="18063"
        />
        <path
          className="white"
          d="M 652.47 146.8 658.9 145.32 660.16 145.03 660.59 146.84 660.71 147.78 660.42 149.46 660.6 150.27 658.92 150.49 653.53 151.71 652.64 147.55 652.47 146.8 Z"
          data-name="Genesee"
          data-stusps="NY"
          id="36037"
        />
        <path
          className="white"
          d="M 631.91 430.34 636.1 429.85 636.18 430.39 638.77 430.06 638.6 430.3 639.9 431.77 642.59 432.44 642.69 433.25 639.35 433.64 639.44 434.47 632.09 435.33 632.42 434.31 632.43 433.15 632.07 431.7 631.91 430.34 Z"
          data-name="Hernando"
          data-stusps="FL"
          id="12053"
        />
        <path
          className="white"
          d="M 596.39 313.72 598.38 310.6 600.16 310.04 601.36 309.8 604.51 312.66 603.48 312.83 602.39 313.01 597.47 313.59 597.46 313.59 596.39 313.72 Z"
          data-name="Clay"
          data-stusps="NC"
          id="37043"
        />
        <path
          className="white"
          d="M 324.26 318.39 332.53 318.87 332.03 327.01 326.13 326.7 323.69 326.56 324.26 318.39 Z"
          data-name="Armstrong"
          data-stusps="TX"
          id="48011"
        />
        <path
          className="white"
          d="M 326.18 386.77 332.65 386.97 332.84 384.28 333.41 384.49 342.87 384.95 342.81 387.03 344.78 387.15 344.36 396.37 335.09 396.02 335.39 387.81 326.15 387.29 326.18 386.77 Z"
          data-name="Tom Green"
          data-stusps="TX"
          id="48451"
        />
        <path
          className="white"
          d="M 688.11 269.15 689.19 265.62 688.48 262.19 689.14 262.39 690.92 262.69 691.64 262.19 691.7 264.98 692.67 265.05 691.71 265.98 693.1 266.03 694.4 267.74 695.3 267.72 688.38 269.1 688.11 269.15 Z M 690.86 266.06 691.34 266.01 691.55 265.76 691.42 265.13 690.7 265.33 690.86 266.06 Z"
          data-name="Greensville"
          data-stusps="VA"
          fillRule="evenodd"
          id="51081"
        />
        <path
          className="white"
          d="M 289.47 158.24 301.03 159.38 300.99 159.86 300.65 163.39 300.12 168.83 299.45 175.77 299.41 176.13 291.64 175.4 291.04 175.32 287.75 174.98 288.02 171.71 289.47 158.24 Z"
          data-name="Niobrara"
          data-stusps="WY"
          id="56027"
        />
        <path
          className="white"
          d="M 305.33 270.69 310.23 271.06 320.78 271.78 320.46 276.57 320.3 279.03 320.11 281.88 320.02 283.22 319.97 284.01 315.25 283.67 310.08 283.29 307.92 283.05 305.51 282.86 304.24 282.77 305.33 270.69 Z"
          data-name="Baca"
          data-stusps="CO"
          id="8009"
        />
        <path
          className="white"
          d="M 586.82 314.83 588.57 314.63 591.47 314.29 594.46 313.94 593.78 314.71 595.03 315.81 595.45 317.4 594.78 320.41 594.4 321.32 594.24 321.05 591.49 317.41 590.2 316.99 587.15 317.33 587.04 316.96 586.82 314.83 Z"
          data-name="Fannin"
          data-stusps="GA"
          id="13111"
        />
        <path
          className="white"
          d="M 551.99 127.58 552.59 126.94 552.64 125.88 552.27 124.41 552.24 123.91 554.3 123.67 554.51 125.32 559.38 124.68 560.18 129.52 553.78 130.52 553.81 131.25 553.03 130.45 551.81 130.61 551.99 127.58 Z"
          data-name="Antrim"
          data-stusps="MI"
          id="26009"
        />
        <path
          className="white"
          d="M 471.11 230.35 476.94 230.13 477.09 230.83 477.05 232 477.62 232.43 478.18 233.03 478.16 233.58 478.14 234.14 479.08 234.9 473.14 235.18 473.17 235.72 471.26 235.79 471.11 230.35 Z"
          data-name="Marion"
          data-stusps="MO"
          id="29127"
        />
        <path
          className="white"
          d="M 365.38 223.19 371.88 223.42 371.67 229.95 366.76 229.79 366.49 229.78 365.14 229.73 365.38 223.19 Z"
          data-name="Franklin"
          data-stusps="NE"
          id="31061"
        />
        <path
          className="white"
          d="M 707.68 265.1 710.42 264.53 713.3 266.41 714.26 267.56 715.23 267.3 717.11 268.38 718.55 270.51 718.58 272.05 716.78 272.42 716.73 272.23 716.38 271.07 714.48 269.37 712.93 269.02 712.4 267.66 708.84 266.5 707.84 265.86 706.9 265.26 707.68 265.1 Z"
          data-name="Camden"
          data-stusps="NC"
          id="37029"
        />
        <path
          className="white"
          d="M 410.91 286.94 411.46 286.94 412.01 286.94 414.13 286.94 413.79 288.02 413.79 294.47 413.75 294.87 413.75 297.73 410.89 297.73 410.91 286.94 Z"
          data-name="Washington"
          data-stusps="OK"
          id="40147"
        />
        <path
          className="white"
          d="M 584.42 315.1 585.21 311.52 585 310.2 585.51 309.63 588.13 309 590.39 309.72 590.9 309.94 591.54 310.12 591.47 314.29 588.57 314.63 586.82 314.83 585.17 315.02 584.42 315.1 Z"
          data-name="Polk"
          data-stusps="TN"
          id="47139"
        />
        <path
          className="white"
          d="M 299.3 230.53 299.75 225.62 303.13 225.91 303.93 217.75 313.78 218.53 313.45 220.15 312.94 226.7 312.16 234.85 307.05 234.49 299.01 233.79 299.3 230.53 Z"
          data-name="Washington"
          data-stusps="CO"
          id="8121"
        />
        <path
          className="white"
          d="M 620.11 344.06 623.05 342.27 625.21 342.99 623.03 345.27 623.25 346.23 621.91 346.28 620.56 345.53 620.27 344.33 620.11 344.06 Z"
          data-name="Glascock"
          data-stusps="GA"
          id="13125"
        />
        <path
          className="white"
          d="M 403.63 251.84 403.66 248.57 405.27 248.59 405.31 246.16 406.15 246.43 407.59 245.43 409.78 245.79 410.42 247.05 411.09 246.92 411.77 247.58 411.77 251.86 411.78 254.32 405.8 254.3 405.25 254.3 405.25 252.67 403.62 252.65 403.63 251.84 Z"
          data-name="Wabaunsee"
          data-stusps="KS"
          id="20197"
        />
        <path
          className="white"
          d="M 566.89 269.71 568.13 269.32 568.65 269.6 570.54 269.31 572.05 270.08 573.75 269.26 574.66 269.91 573.86 270.56 573.51 272.01 573.18 272.78 571.43 273.46 570.94 274.55 570 274.05 570.2 273.52 568.69 271.53 566.95 270.42 566.89 269.71 Z"
          data-name="Taylor"
          data-stusps="KY"
          id="21217"
        />
        <path
          className="white"
          d="M 634.94 369.63 636.11 370.3 636.24 370.32 636.32 370.18 638.55 372.24 641.17 373.49 641.6 374.27 641.92 374.29 642.92 375.49 642.77 375.83 641.79 376.97 641.32 378.4 640.11 377.9 638.16 378.5 636.17 378.22 635.58 376.51 634.44 376.56 633.7 370.83 634.43 369.69 634.94 369.63 Z"
          data-name="Wayne"
          data-stusps="GA"
          id="13305"
        />
        <path
          className="white"
          d="M 565.68 122.23 567.28 122 570.26 121.56 572.12 121.22 572.99 127.71 566.54 128.69 565.68 122.23 Z"
          data-name="Montmorency"
          data-stusps="MI"
          id="26119"
        />
        <path
          className="white"
          d="M 475.38 261.36 475.08 253.57 476.32 254.02 478.34 253.3 479.08 253.46 479.55 262.65 477.07 262.74 477.13 263.84 475.7 263.88 475.48 263.68 475.38 261.36 Z"
          data-name="Gasconade"
          data-stusps="MO"
          id="29073"
        />
        <path
          className="white"
          d="M 396.92 246.84 396.95 246.49 396.96 245.2 398.59 245.24 398.54 247.69 403.66 248.57 403.63 251.84 397.93 251.78 397.39 251.76 397.42 249.73 396.87 249.98 396.92 246.84 Z"
          data-name="Geary"
          data-stusps="KS"
          id="20061"
        />
        <path
          className="white"
          d="M 509.37 355.07 510.05 353.7 510.93 353.64 513.95 353.45 516.12 353.32 516.31 356.64 516.5 359.97 509.98 360.4 510.04 361.24 508.29 361.33 506.3 361.55 507.35 360.5 509.37 355.07 Z"
          data-name="Attala"
          data-stusps="MS"
          id="28007"
        />
        <path
          className="white"
          d="M 41.96 76.2 45.95 77.7 47.99 78.43 48.53 80.1 47.12 79.93 45.39 80.98 45.67 82.08 44.07 85.21 44.62 86.44 39.02 84.55 36.62 83.52 36.29 82.72 37.96 82.38 38.4 80.99 40.04 81.6 41.96 76.2 Z"
          data-name="Benton"
          data-stusps="OR"
          id="41003"
        />
        <path
          className="white"
          d="M 395.83 385.99 399.26 384.03 402.82 384.41 406.96 391.6 405.57 392.33 405.63 392.65 401.14 395.17 397.9 389.5 395.83 385.99 Z"
          data-name="Limestone"
          data-stusps="TX"
          id="48293"
        />
        <path
          className="white"
          d="M 469.99 123.36 481.34 122.68 481.65 127.56 478.39 127.74 478.49 129.38 470.32 129.84 469.99 123.36 Z"
          data-name="Rusk"
          data-stusps="WI"
          id="55107"
        />
        <path
          className="white"
          d="M 501.99 139.23 510.28 138.57 510.42 140.22 508.66 140.38 509.19 146.9 508.83 146.93 507.21 147.08 502.64 147.45 501.99 139.23 Z"
          data-name="Waupaca"
          data-stusps="WI"
          id="55135"
        />
        <path
          className="white"
          d="M 359.46 301.61 365.94 301.88 370.79 301.97 370.68 308.58 359.31 308.22 359.37 304.45 359.46 301.61 Z"
          data-name="Dewey"
          data-stusps="OK"
          id="40043"
        />
        <path
          className="white"
          d="M 415.69 189.18 420.54 189.17 423.79 189.16 423.82 195.67 417.3 195.71 415.68 195.72 415.69 189.18 Z"
          data-name="Crawford"
          data-stusps="IA"
          id="19047"
        />
        <path
          className="white"
          d="M 436.71 188.98 439.97 188.92 443.22 188.85 443.39 195.34 441.74 195.38 436.84 195.49 436.71 188.98 Z"
          data-name="Boone"
          data-stusps="IA"
          id="19015"
        />
        <path
          className="white"
          d="M 667.11 273.14 670.11 272.59 672.35 272.19 673.31 278.02 671.02 278.36 667.88 278.87 667.11 273.14 Z"
          data-name="Person"
          data-stusps="NC"
          id="37145"
        />
        <path
          className="white"
          d="M 440.11 285.77 440.12 281.24 446.52 281.25 446.83 281.28 446.85 284.69 446.88 286.61 446.9 287.98 440.09 287.96 440.11 285.77 Z"
          data-name="Lawrence"
          data-stusps="MO"
          id="29109"
        />
        <path
          className="white"
          d="M 326.27 385 326.73 376.81 328.01 376.87 333.81 377.16 333.41 384.49 332.84 384.28 332.65 386.97 326.18 386.77 326.27 385 Z"
          data-name="Sterling"
          data-stusps="TX"
          id="48431"
        />
        <path
          className="white"
          d="M 576.12 288.95 576.96 285.96 578.44 285.36 581.78 286.05 583.17 288.36 582.59 288.9 581.27 290.46 580.11 290.82 579.9 293.31 578.01 293.25 576.99 293.97 576.68 293.89 577.14 292.86 576.31 290.88 576.12 288.95 Z"
          data-name="Fentress"
          data-stusps="TN"
          id="47049"
        />
        <path
          className="white"
          d="M 198.47 335.32 198.82 334.62 200.76 333.96 201.12 333.25 205.89 333.9 204.98 340.85 204.49 344.66 204.49 344.66 203.45 352.82 203.44 352.82 202.6 359.48 201.52 359.34 199.97 357.17 200.55 355.18 200.19 353.09 199.02 350.99 197.01 346.19 198.47 335.32 Z"
          data-name="Greenlee"
          data-stusps="AZ"
          id="4011"
        />
        <path
          className="white"
          d="M 582.16 238.28 582.58 238.82 582.8 239.44 583.81 240.75 583.82 240.86 581.68 242.33 581.25 242.49 580.73 242.31 580.32 239.03 579.24 237.1 579.35 237.08 579.43 237.06 579.58 236.77 579.85 236.64 580.11 236.75 580.36 237.3 580.92 237.95 582.06 238.16 582.16 238.28 Z"
          data-name="Campbell"
          data-stusps="KY"
          id="21037"
        />
        <path
          className="white"
          d="M 743.24 101.07 744.32 101.68 745.07 103.09 745.26 99.76 748.13 98.98 748.27 97.96 748.45 98.44 749.55 101.52 751.24 106.22 751.55 107.08 752.18 108.78 752.78 110.38 753.09 111.19 753.39 111.72 752.91 113.06 752.44 112.24 750.68 112.61 749.98 112.59 747.68 111.7 747.67 111.69 745.97 110.86 744.34 110.02 743.97 109.42 743.27 108 743.11 107.68 745.73 106.39 744.38 103.06 743.24 101.07 Z"
          data-name="Carroll"
          data-stusps="NH"
          id="33003"
        />
        <path
          className="white"
          d="M 674.66 149.05 674.99 148.97 676.18 150.84 676.68 153 677.11 154.45 675.74 154.77 675.62 154.37 673.99 154.76 673.07 153.13 669.98 153.84 669.63 152.36 669.71 150.81 669.93 150.19 674.66 149.05 Z"
          data-name="Yates"
          data-stusps="NY"
          id="36123"
        />
        <path
          className="white"
          d="M 667.25 293.14 668.72 291.89 670.5 290.42 673.15 292.04 670.53 296.7 668.98 296.06 667.26 294.08 667.25 293.14 Z"
          data-name="Lee"
          data-stusps="NC"
          id="37105"
        />
        <path
          className="white"
          d="M 623.69 306.22 626.31 305.93 626.44 305.91 627.54 305.8 629.03 305.66 630.44 307.93 631.57 310.18 632.26 310.42 631.39 312.01 630.97 316.75 630.83 317.05 628.4 315.81 625.87 313.79 625.53 313.62 624.43 312.73 623.69 306.22 Z"
          data-name="Spartanburg"
          data-stusps="SC"
          id="45083"
        />
        <path
          className="white"
          d="M 474.26 306.92 475.67 305.44 476.32 305.43 480.1 305.36 480.12 306.19 481.76 306.15 484.18 306.05 483.73 307.53 481.97 309.55 481.88 312.99 478.62 313.06 476.11 313.1 475.37 313.13 475.29 309.8 474.57 309.95 473.97 308.01 474.26 306.92 Z"
          data-name="Independence"
          data-stusps="AR"
          id="5063"
        />
        <path
          className="white"
          d="M 595.79 368.37 595.74 367.76 599.72 367.48 599.61 366.13 600.45 366.89 602.21 366.96 602.15 367.32 603.57 369.5 604.45 371.38 604.45 371.72 597.73 372.33 597.82 373.14 597.48 372.95 595.92 371.54 595.95 370.12 595.79 368.37 Z"
          data-name="Sumter"
          data-stusps="GA"
          id="13261"
        />
        <path
          className="white"
          d="M 547.7 244.44 547.54 242.79 552.9 242.27 553.44 242.21 553.97 246.47 553.52 247.1 553.63 247.95 548.11 248.54 547.7 244.44 Z"
          data-name="Lawrence"
          data-stusps="IN"
          id="18093"
        />
        <path
          className="white"
          d="M 565.34 236.99 567.28 235.38 568.34 234.49 570.57 234.24 570.4 241.12 570.39 241.47 569.44 241.89 565.88 242.32 565.34 236.99 Z"
          data-name="Ripley"
          data-stusps="IN"
          id="18137"
        />
        <path
          className="white"
          d="M 469.59 194.43 476.12 194.14 476.37 199.05 476.51 202.34 474.88 202.41 474.29 200.8 469.93 201.01 469.59 194.43 Z"
          data-name="Johnson"
          data-stusps="IA"
          id="19103"
        />
        <path
          className="white"
          d="M 598.66 270.34 600.1 268.52 601.45 270.16 603.43 270.88 604.14 272.17 604.12 273.73 603.08 274.87 601.08 276.06 601.02 276.66 599.78 276.72 599.38 275.95 598.36 273.38 598.17 271.71 598.66 270.34 Z"
          data-name="Leslie"
          data-stusps="KY"
          id="21131"
        />
        <path
          className="white"
          d="M 515.77 330.52 515.67 328.88 516.01 328.58 518.09 328.43 523.58 328.09 523.68 329.73 522.87 330.05 522.49 332.54 520.85 332.37 515.91 332.71 515.77 330.52 Z"
          data-name="Union"
          data-stusps="MS"
          id="28145"
        />
        <path
          className="white"
          d="M 564.73 162.16 571.19 161.3 572.14 167.72 571.86 167.88 568.84 168.29 565.6 168.71 564.73 162.16 Z"
          data-name="Clinton"
          data-stusps="MI"
          id="26037"
        />
        <path
          className="white"
          d="M 423 202.4 424.61 202.39 429.41 202.35 429.49 208.84 426.27 208.87 423.04 208.89 423 202.4 Z"
          data-name="Cass"
          data-stusps="IA"
          id="19029"
        />
        <path
          className="white"
          d="M 372.28 203.83 378.68 204.03 378.75 204.04 378.56 210.56 372.38 210.36 372 210.35 372.28 203.83 Z"
          data-name="Howard"
          data-stusps="NE"
          id="31093"
        />
        <path
          className="white"
          d="M 416.62 145.44 419.77 145.43 419.76 142.49 421.32 143.07 422.82 144.38 426.23 145.84 426.43 146.19 426.47 150.24 423.21 150.29 423.21 151.92 423.04 151.91 418.43 151.93 416.66 151.95 416.62 145.44 Z"
          data-name="Redwood"
          data-stusps="MN"
          id="27127"
        />
        <path
          className="white"
          d="M 390.19 393.96 397.9 389.5 401.14 395.17 397.36 397.31 397.06 397.4 393.47 399.5 390.19 393.96 Z"
          data-name="Falls"
          data-stusps="TX"
          id="48145"
        />
        <path
          className="white"
          d="M 395.25 435.54 399.89 431.82 400.18 432.12 405.6 437.48 405.34 442.86 404.01 442.88 404.09 441.83 403.61 442.33 400.06 442.15 398.96 439.53 397.64 438.26 397 436.34 395.25 435.54 Z"
          data-name="Jackson"
          data-stusps="TX"
          id="48239"
        />
        <path
          className="white"
          d="M 667.74 253.43 668.37 253.11 671.72 255.15 671.91 255.74 672.4 255.38 672.59 256.38 671.62 258.46 670.23 259.1 669.61 259.68 667.99 259.19 665.83 255.99 666.66 254.39 667.74 253.43 Z"
          data-name="Appomattox"
          data-stusps="VA"
          id="51011"
        />
        <path
          className="white"
          d="M 81.34 15.35 84.5 16.53 92.19 19.31 99.28 21.88 99.58 24.75 97.67 25.91 95.74 25.96 95.89 26.91 94.48 28.45 95.38 30.27 94.47 30.92 80.43 25.95 80.09 25.82 79.39 25.55 78.01 25.04 78.46 24.15 79.09 23.67 80.38 22.65 81.18 19.86 80.96 17.88 81.73 16.76 81.34 15.35 Z"
          data-name="Snohomish"
          data-stusps="WA"
          id="53061"
        />
        <path
          className="white"
          d="M 493.48 148.04 495.89 147.89 497.6 147.8 497.98 152.75 498.44 159.12 495.91 159.34 495.85 158.86 494.62 156.75 492.89 154.57 492.03 151.12 492.68 149.65 493.33 149.88 493.48 148.04 Z"
          data-name="Adams"
          data-stusps="WI"
          id="55001"
        />
        <path
          className="white"
          d="M 573.8 344.67 578.47 344.1 579.18 344.38 579.45 345.4 580.95 350.93 581.05 351.33 575.33 351.92 574.37 352.03 574.17 347.97 573.8 344.67 Z"
          data-name="Randolph"
          data-stusps="AL"
          id="1111"
        />
        <path
          className="white"
          d="M 618.11 387.12 618.38 384.75 620.45 384.52 620.23 383.83 621.46 383.68 622.16 389.64 621.42 390.11 620.82 388.3 618.58 388.51 618.42 387.25 618.11 387.12 Z"
          data-name="Lanier"
          data-stusps="GA"
          id="13173"
        />
        <path
          className="white"
          d="M 468.01 341.1 469.62 340.99 473.98 340.8 473.69 342.44 473.83 345.92 473.89 347.56 468.32 347.69 468.13 347.04 468.21 346.06 467.1 343.88 465.89 342.8 465.9 341.22 468.01 341.1 Z"
          data-name="Cleveland"
          data-stusps="AR"
          id="5025"
        />
        <path
          className="white"
          d="M 437.7 136.97 440.96 136.92 440.99 138.55 444.3 138.44 444.35 140.07 443.57 140.29 443.37 140.64 443.09 141.94 441.11 143.25 441.1 142.63 439.48 142.67 439.46 141.85 437.83 141.88 437.7 136.97 Z"
          data-name="Carver"
          data-stusps="MN"
          id="27019"
        />
        <path
          className="white"
          d="M 315.54 343.47 323.73 343.84 323.38 352.02 315.2 351.65 315.54 343.47 Z"
          data-name="Lubbock"
          data-stusps="TX"
          id="48303"
        />
        <path
          className="white"
          d="M 684.03 230.28 684.54 229.47 687.5 230.63 687.49 231.33 687.9 232.89 688.51 233.4 687.9 233.87 688.3 235.55 687.64 235.65 687.34 235.74 686.35 235.17 685.29 234.57 685.01 234.96 683.82 234.72 683.46 234.12 683.05 233.36 682.85 232.29 684.03 230.28 Z"
          data-name="Stafford"
          data-stusps="VA"
          id="51179"
        />
        <path
          className="white"
          d="M 503.8 152.28 507.63 151.95 507.78 153.61 508.19 158.52 506.54 158.67 504.9 158.82 503.27 158.74 503.09 156.55 504.14 156.36 503.65 155.51 503.8 152.28 Z"
          data-name="Green Lake"
          data-stusps="WI"
          id="55047"
        />
        <path
          className="white"
          d="M 590.63 398.07 591.63 396.31 591.54 395.97 591.56 395.97 592.39 395.93 597.95 395.69 599.49 395.6 601.05 395.52 599.75 397.78 599.5 399.7 597.67 400.32 595.72 401.73 593.38 400.6 593.25 399.48 591.58 399.38 591.43 398.01 590.63 398.07 Z"
          data-name="Gadsden"
          data-stusps="FL"
          id="12039"
        />
        <path
          className="white"
          d="M 495.49 180.79 496.73 180.72 501.52 180.44 502.79 180.36 503.12 183.99 503.29 185.96 499.22 186.32 495.99 186.59 495.49 180.79 Z"
          data-name="Stephenson"
          data-stusps="IL"
          id="17177"
        />
        <path
          className="white"
          d="M 414.08 230.66 414.13 230.66 420.55 230.65 420.59 237.16 417.33 237.18 414.07 237.18 414.08 230.66 Z"
          data-name="Brown"
          data-stusps="KS"
          id="20013"
        />
        <path
          className="white"
          d="M 567.47 181.81 569.11 181.63 573.95 180.92 574.93 187.81 574.38 187.9 573.84 187.99 568.67 188.84 568.52 187.64 568.25 187.67 567.47 181.81 Z"
          data-name="Hillsdale"
          data-stusps="MI"
          id="26059"
        />
        <path
          className="white"
          d="M 469.18 157.11 475.2 156.79 475.87 158.14 475.75 159.04 475.59 160.16 475.93 161.39 476.24 162.04 476.52 163.24 472.78 163.44 471.14 163.52 469.51 163.6 469.18 157.11 Z"
          data-name="Houston"
          data-stusps="MN"
          id="27055"
        />
        <path
          className="white"
          d="M 404.37 225.72 410.07 225.75 410.88 225.77 410.87 230.66 410.67 230.66 408.79 230.66 407.57 230.65 407.57 230.65 404.33 230.62 404.37 225.72 Z"
          data-name="Pawnee"
          data-stusps="NE"
          id="31133"
        />
        <path
          className="white"
          d="M 586.72 242.46 586.44 233.25 588.28 233.13 588.76 237.4 591.69 237.03 592.17 244.3 591.14 244.05 590.88 243.37 590.08 243.08 589.73 242.45 588.92 242.25 588.54 242.16 587.77 242.02 586.73 242.46 586.72 242.46 Z"
          data-name="Brown"
          data-stusps="OH"
          id="39015"
        />
        <path
          className="white"
          d="M 621.05 261.36 621.66 261.77 621.04 262.97 621.86 263.52 621.99 264.09 622.72 265.08 623.55 265.86 624.72 265.89 625.28 266.43 625.36 266.47 625.12 267.23 623.19 268.67 621.64 269.34 621.27 270.81 619.71 271.14 619.39 269.85 616.81 266.46 616.51 266.69 616.57 266.61 617.99 264.96 621.05 261.36 Z"
          data-name="Buchanan"
          data-stusps="VA"
          id="51027"
        />
        <path
          className="white"
          d="M 123.95 64.83 124.09 64.97 124.55 65.79 128.4 66.18 128.97 65.68 127.98 68.51 129.6 68.97 129.68 71.7 130.5 71.92 128.79 78.3 127.3 77.85 123.92 76.86 123.67 76.79 124.88 72.93 123.26 72.45 123.75 70.82 122.12 70.34 123.95 64.83 Z"
          data-name="Columbia"
          data-stusps="WA"
          id="53013"
        />
        <path
          className="white"
          d="M 652.85 448.11 653.42 448.05 660.01 447.32 660.14 448.11 659.05 449.65 661.37 452.27 662.5 452.52 663.91 455.08 664.46 455.25 660.55 455.65 660.77 457.32 659.07 457.53 659.28 459.22 654.23 459.79 654.23 459.79 653.52 453.94 652.85 448.11 Z"
          data-name="Highlands"
          data-stusps="FL"
          id="12055"
        />
        <path
          className="white"
          d="M 489.22 232.39 490.9 232.3 492.56 232.88 492.64 234.52 493.72 235.01 493.84 237.19 489.78 237.41 488.64 234.05 489.22 232.39 Z"
          data-name="Scott"
          data-stusps="IL"
          id="17171"
        />
        <path
          className="white"
          d="M 512.44 260.6 512.13 255.69 518.71 255.18 518.98 259.28 519.14 261.75 512.83 262.23 512.53 262.25 512.44 260.6 Z"
          data-name="Jefferson"
          data-stusps="IL"
          id="17081"
        />
        <path
          className="white"
          d="M 561.76 226.14 566.05 225.62 566.69 230.54 566.85 231.9 562.01 232.47 561.43 227.86 561.23 226.21 561.76 226.14 Z"
          data-name="Rush"
          data-stusps="IN"
          id="18139"
        />
        <path
          className="white"
          d="M 516.07 388.23 516.92 388.18 521 387.94 521.49 396.08 521.73 397.78 518.44 397.97 518.35 396.37 518.2 396.09 517.84 389.77 516.18 389.88 516.07 388.23 Z"
          data-name="Forrest"
          data-stusps="MS"
          id="28035"
        />
        <path
          className="white"
          d="M 524.16 283.73 524.06 282.62 524.06 282.21 526.17 281.32 527.78 282.69 528.62 283.5 529.21 284.74 529.71 285.83 530.09 286.94 524.42 287.33 524.16 283.73 Z"
          data-name="Marshall"
          data-stusps="KY"
          id="21157"
        />
        <path
          className="white"
          d="M 555.79 170 559.05 169.56 562.31 169.13 563.19 175.69 560.03 176.12 556.62 176.51 555.79 170 Z"
          data-name="Barry"
          data-stusps="MI"
          id="26015"
        />
        <path
          className="white"
          d="M 500.69 327.13 501.09 326.45 503.34 327.29 505.1 325.97 508.02 325.79 508.14 327.42 508.97 327.37 509.13 329.83 508.31 329.89 500.89 330.32 500.17 329 500.23 327.57 500.69 327.13 Z"
          data-name="Tate"
          data-stusps="MS"
          id="28137"
        />
        <path
          className="white"
          d="M 378.53 213.89 382.5 210.17 384.46 209.27 385.13 208.34 385.11 210.72 384.97 217.25 378.5 217.09 378.44 217.09 378.53 213.89 Z"
          data-name="Hamilton"
          data-stusps="NE"
          id="31081"
        />
        <path
          className="white"
          d="M 326.46 201.42 334.63 201.96 336.57 202.1 336.15 208.62 336.39 209.45 325.34 208.73 324.98 208.69 325.22 204.6 325.46 201.34 326.46 201.42 Z"
          data-name="Keith"
          data-stusps="NE"
          id="31101"
        />
        <path
          className="white"
          d="M 391.25 140.3 399.36 140.43 399.29 145.32 396.03 145.29 391.14 145.19 391.25 140.3 Z"
          data-name="Hamlin"
          data-stusps="SD"
          id="46057"
        />
        <path
          className="white"
          d="M 343.17 377.65 344.5 377.7 351.5 377.97 351.04 387.44 344.78 387.15 342.81 387.03 342.87 384.95 343.17 377.65 Z"
          data-name="Runnels"
          data-stusps="TX"
          id="48399"
        />
        <path
          className="white"
          d="M 177.87 238.1 178.11 237.99 184.75 239.15 185.1 239.41 203.72 242.47 203.3 243.32 203.48 245.05 204.48 246.76 204.87 248.64 204.15 249.27 192.81 247.47 178.66 245.1 175.55 244.53 176.39 239.34 177.87 238.1 Z"
          data-name="Wayne"
          data-stusps="UT"
          id="49055"
        />
        <path
          className="white"
          d="M 675.53 240.37 677.05 239.65 679.4 239.85 681.18 239.74 683.82 241.15 683.48 245.09 683.23 246.74 681.85 246.49 681.22 245.34 679.83 244.91 678.76 244.25 678.56 244.23 676.24 243.65 674.53 243.02 675.11 241.8 675.53 240.37 Z"
          data-name="Louisa"
          data-stusps="VA"
          id="51109"
        />
        <path
          className="white"
          d="M 194.24 135.3 196.02 136.22 199.76 137.25 200.71 136.54 202.08 136.93 200.97 142.58 198.7 142.14 197.9 141.89 196.76 141.11 194.21 138.44 193.5 138.54 194.24 135.3 Z"
          data-name="Madison"
          data-stusps="ID"
          id="16065"
        />
        <path
          className="white"
          d="M 378.73 202.41 381.44 202.48 382.27 201.94 385.26 201.72 387.04 201.75 386.99 204.22 386.93 205.83 382 206.02 381.3 206.54 378.84 206.47 378.75 204.04 378.68 204.03 378.73 202.41 Z"
          data-name="Nance"
          data-stusps="NE"
          id="31125"
        />
        <path
          className="white"
          d="M 431.31 83.25 439.44 83.05 439.42 82.07 448.2 81.92 448.56 85.14 448.67 91.15 449.09 98.17 439.86 98.38 439.78 94.98 439.33 94.59 439.74 93.22 438.27 93 437.98 93.4 436.28 92.03 436.45 91.35 435.56 90.07 432.62 91.3 431.48 90.78 431.31 83.25 Z"
          data-name="Itasca"
          data-stusps="MN"
          id="27061"
        />
        <path
          className="white"
          d="M 452.39 213.21 458.92 212.98 459.15 218.75 458.45 218.8 458.05 218.82 454.8 218.97 452.58 219.11 452.39 213.21 Z"
          data-name="Appanoose"
          data-stusps="IA"
          id="19007"
        />
        <path
          className="white"
          d="M 374.34 264.39 378.14 264.47 378.14 264.75 382.49 264.58 385.76 264.64 385.66 269.57 385.64 272.87 384.01 272.86 374.22 272.64 374.26 271.19 374.16 270.92 374.34 264.39 Z"
          data-name="Reno"
          data-stusps="KS"
          id="20155"
        />
        <path
          className="white"
          d="M 357.89 268.7 358.03 265.43 361.28 265.55 361.22 267.18 362.84 267.26 366.09 267.37 365.98 270.37 366.11 270.65 366.05 272.38 357.91 272.05 357.81 270.34 357.89 268.7 Z"
          data-name="Edwards"
          data-stusps="KS"
          id="20047"
        />
        <path
          className="white"
          d="M 565.08 275.62 565.93 275.29 566.86 276.28 568.48 276.4 569.05 278.28 570.03 279.13 569.97 279.5 568.5 281.33 567.84 280.99 568.03 282 567.75 281.76 565.82 281.8 565.03 276.77 564.65 276.27 565.08 275.62 Z"
          data-name="Metcalfe"
          data-stusps="KY"
          id="21169"
        />
        <path
          className="white"
          d="M 564.89 264.93 566.29 265.52 566.13 268.45 567.64 268.02 567.93 268.09 568.65 269.6 568.13 269.32 566.89 269.71 566.12 269.76 565.88 270.73 562.3 270.77 562.35 268.79 564.22 266.48 564.89 264.93 Z"
          data-name="Larue"
          data-stusps="KY"
          id="21123"
        />
        <path
          className="white"
          d="M 545.59 291.13 546.52 291.69 547.81 292.64 548.86 292.21 549 292.51 548.3 294.46 547.5 298.81 547.31 298.75 546.82 298.83 545.33 298.85 545.61 296.41 544.83 295.12 545.35 294 543.29 293.87 543.31 293.28 545.59 291.13 Z"
          data-name="Cheatham"
          data-stusps="TN"
          id="47021"
        />
        <path
          className="white"
          d="M 307.84 333.77 309.24 333.86 316.03 334.29 315.54 343.47 307.23 342.93 307.84 333.77 Z"
          data-name="Lamb"
          data-stusps="TX"
          id="48279"
        />
        <path
          className="white"
          d="M 301.76 325.14 309.79 325.71 309.24 333.86 307.84 333.77 301.16 333.31 301.25 332.05 301.58 327.54 301.76 325.14 Z"
          data-name="Parmer"
          data-stusps="TX"
          id="48369"
        />
        <path
          className="white"
          d="M 672.52 247.52 674.53 243.02 676.24 243.65 678.56 244.23 677.78 246.96 677.7 247.48 677.38 247.61 676.7 248.81 673.08 248.15 672.52 247.52 Z"
          data-name="Fluvanna"
          data-stusps="VA"
          id="51065"
        />
        <path
          className="white"
          d="M 663.23 255.75 664.45 256.85 664.99 256.82 663.24 258.36 662.51 258.03 662.06 256.32 663.23 255.75 Z"
          data-name="Lynchburg"
          data-stusps="VA"
          id="51680"
        />
        <path
          className="white"
          d="M 582.54 299.33 583.27 298.61 583.91 297.58 584.99 296.59 587.34 295.7 588.8 294.32 589.26 295.36 590.19 296.81 590.34 297.04 589.33 297.24 589.2 298.41 585.97 302.39 585.42 302.44 585.3 301.25 583.59 300.59 583.11 300.61 582.54 299.33 Z"
          data-name="Roane"
          data-stusps="TN"
          id="47145"
        />
        <path
          className="white"
          d="M 385.12 369.98 386.18 370 388.78 370.07 389.38 370.09 389.92 370.11 393.53 370.22 393.49 375.53 387.41 376.98 387.25 377.18 386.62 377.91 385.04 376.58 385.07 374.42 385.12 369.98 Z"
          data-name="Johnson"
          data-stusps="TX"
          id="48251"
        />
        <path
          className="white"
          d="M 464.77 241.9 471.12 241.82 473.4 241.7 473.41 241.97 477.5 241.89 478.09 245.17 474.86 245.23 474.87 246.9 467.89 247.1 467.85 243.81 464.77 243.8 464.77 241.9 Z"
          data-name="Audrain"
          data-stusps="MO"
          id="29007"
        />
        <path
          className="white"
          d="M 381.02 378.68 384.61 376.61 385.04 376.58 386.62 377.91 387.25 377.18 387.05 380.09 388.73 380.96 387.78 381.68 388.66 382.87 390.26 383.41 389.54 384.42 390.31 385.24 385.01 388.12 383.69 385.78 382.45 386.49 378.75 379.94 381.02 378.68 Z"
          data-name="Bosque"
          data-stusps="TX"
          id="48035"
        />
        <path
          className="white"
          d="M 533.45 312.3 534.22 312 533.67 311.7 533.91 311.11 538.04 310.21 539.16 310.31 540.37 311.62 540.96 318.19 540.51 319.09 540.22 319.11 536.7 319.36 534.65 319.52 534.26 314.07 533.45 312.3 Z"
          data-name="Wayne"
          data-stusps="TN"
          id="47181"
        />
        <path
          className="white"
          d="M 336.61 62.24 336.91 58.64 341.8 59.02 343.39 59.14 343 64.38 343.32 67.69 348.21 68.05 348.09 69.68 338.31 68.94 338.71 64.05 336.48 63.87 336.61 62.24 Z"
          data-name="Renville"
          data-stusps="ND"
          id="38075"
        />
        <path
          className="white"
          d="M 673.67 144.34 677.08 143.32 677 144.41 678.18 149.09 679.51 150.71 680.96 151.83 679.43 152.25 676.68 153 676.18 150.84 674.99 148.97 674.66 149.05 674.09 147.26 673.67 144.34 Z"
          data-name="Seneca"
          data-stusps="NY"
          id="36099"
        />
        <path
          className="white"
          d="M 567.83 257.24 567.75 257.51 566.75 259.41 567.2 259.75 566.13 261.88 564.72 263.38 563.87 263.53 562.23 262.42 561.85 261.2 560.5 260.33 561.24 259.46 563.68 258.3 566.41 258.06 567.83 257.24 Z"
          data-name="Bullitt"
          data-stusps="KY"
          id="21029"
        />
        <path
          className="white"
          d="M 351.31 196.44 359.24 196.82 365.78 197.08 365.92 197.09 365.67 203.32 365.79 203.6 365.48 210.11 362.37 210 351.03 209.47 350.84 209.19 350.97 202.95 351.31 196.44 Z"
          data-name="Custer"
          data-stusps="NE"
          id="31041"
        />
        <path
          className="white"
          d="M 583.92 267.42 585.04 267.54 585.28 266.24 586.54 266.54 587.55 266.27 589 269.25 588.96 269.98 587.39 271.72 587.07 273.43 586.82 273.18 583.44 270.49 583.92 267.42 Z"
          data-name="Rockcastle"
          data-stusps="KY"
          id="21203"
        />
        <path
          className="white"
          d="M 532.51 215.83 532.44 214.99 532.08 211.21 535.78 210.86 538.2 210.62 538.26 211.03 538.57 213.88 538.76 215.51 532.53 216.1 532.51 215.83 Z"
          data-name="Benton"
          data-stusps="IN"
          id="18007"
        />
        <path
          className="white"
          d="M 372.64 286.38 375.51 286.47 375.61 286.47 379.15 286.55 379.02 293.8 379.09 294.14 379.03 296.59 372.52 296.42 372.64 286.38 Z"
          data-name="Alfalfa"
          data-stusps="OK"
          id="40003"
        />
        <path
          className="white"
          d="M 350.7 285.53 350.81 285.53 355.89 285.77 357.64 285.85 358.92 285.9 360.07 288.2 361.22 289.37 361.07 293.58 356.37 293.45 350.35 293.19 350.7 285.53 Z"
          data-name="Harper"
          data-stusps="OK"
          id="40059"
        />
        <path
          className="white"
          d="M 316.99 301.5 325.22 302.01 324.75 310.11 324.74 310.18 316.46 309.68 316.47 309.53 316.99 301.5 Z"
          data-name="Moore"
          data-stusps="TX"
          id="48341"
        />
        <path
          className="white"
          d="M 393.44 310.71 393.5 306.63 401.44 306.72 401.38 312.39 401.29 315.7 393.37 315.59 393.44 310.71 Z"
          data-name="Lincoln"
          data-stusps="OK"
          id="40081"
        />
        <path
          className="white"
          d="M 548.68 254.03 549.67 253.92 554.2 253.48 554.15 252.94 554.94 252.86 555.23 255.31 554.5 258.14 554 258.42 553.57 258.67 552.95 259.44 552.48 258.85 552.33 257.33 552.32 257.23 550.67 257.39 550.58 256.28 548.96 256.5 548.68 254.03 Z"
          data-name="Crawford"
          data-stusps="IN"
          id="18025"
        />
        <path
          className="white"
          d="M 534.75 194.03 536.07 193.49 537.41 192.89 538.66 191.97 539.64 200.97 539.13 201.35 536.69 200.34 535.53 201.29 534.75 194.03 Z"
          data-name="Porter"
          data-stusps="IN"
          id="18127"
        />
        <path
          className="white"
          d="M 432.03 356.75 433.3 357.09 434.15 356.47 435.76 356.42 436.34 356.94 438.67 357.18 438.86 356.13 441.41 356.07 441.63 356.56 441.67 358.64 441.71 361.29 441.75 363.88 432.09 364.04 432.03 356.75 Z"
          data-name="Cass"
          data-stusps="TX"
          id="48067"
        />
        <path
          className="white"
          d="M 663.04 286.4 662.06 279.9 662.05 279.74 666.28 279.12 667.23 285.49 667.63 286.06 667.92 286.64 663.21 287.48 663.04 286.4 Z"
          data-name="Alamance"
          data-stusps="NC"
          id="37001"
        />
        <path
          className="white"
          d="M 540.34 264.34 540.87 264.64 541.11 264.77 542.28 265.15 542.98 265.73 543.52 266.43 544.13 265.24 544.27 264.33 544.67 263.44 545.15 263.28 545.06 263.83 546.11 263.6 546.28 264.85 547.15 264.7 547.79 266.59 547.99 267.79 546.11 268.79 544.9 270.23 543.36 270.09 539.14 268.43 539.29 267.65 541.02 266.43 540.18 265.77 540.34 264.34 Z"
          data-name="Daviess"
          data-stusps="KY"
          id="21059"
        />
        <path
          className="white"
          d="M 596.58 248.62 597.15 248.26 598.39 249.57 599.28 251.55 600.17 251.76 599.89 251.9 600.9 252.12 600.08 253.25 597.77 254.89 597.75 255.14 597.35 255.52 596.74 254.95 597.23 254.5 596.1 254.19 594.36 252.65 595.34 251.96 596.06 250.85 596.58 248.62 Z"
          data-name="Rowan"
          data-stusps="KY"
          id="21205"
        />
        <path
          className="white"
          d="M 344.05 91.91 346.92 91.71 347.61 92.44 347.65 94.19 348.57 96.85 347.81 97.49 337.16 96.77 337.53 91.88 344.01 92.36 344.05 91.91 Z"
          data-name="Oliver"
          data-stusps="ND"
          id="38065"
        />
        <path
          className="white"
          d="M 519.44 220.95 519.27 218.76 520.89 218.63 526.85 218.09 527 221.37 527.64 227.86 521.69 228.38 520.05 228.52 519.62 223.58 519.44 220.95 Z"
          data-name="Champaign"
          data-stusps="IL"
          id="17019"
        />
        <path
          className="white"
          d="M 588.55 259.82 588.7 260.37 589.75 259.96 590.25 259.7 591.38 261.25 593.31 261.05 594.24 261.7 592.87 262.85 591.91 265.33 590.93 264.72 589.08 265.24 588.35 263.88 588.86 263.32 588.77 260.78 588.04 260.57 588.55 259.82 Z"
          data-name="Estill"
          data-stusps="KY"
          id="21065"
        />
        <path
          className="white"
          d="M 128.55 115.46 134.57 117.08 134.14 118.7 133.06 118.4 132.1 119.86 130.2 119.35 129.33 122.62 127.35 122.38 126.19 121.19 125.99 120.24 126.19 120 126.85 118.42 127.39 117.63 127.13 116.44 128.55 115.46 Z"
          data-name="Payette"
          data-stusps="ID"
          id="16075"
        />
        <path
          className="white"
          d="M 519.43 287.28 519.19 284.01 524.16 283.73 524.42 287.33 524.72 292.01 524.38 292.04 524.31 292.04 519.75 292.37 519.37 287.72 519.43 287.28 Z"
          data-name="Graves"
          data-stusps="KY"
          id="21083"
        />
        <path
          className="white"
          d="M 458.72 208.05 461.99 207.92 465.25 207.77 465.47 212.7 458.92 212.98 458.72 208.05 Z"
          data-name="Wapello"
          data-stusps="IA"
          id="19179"
        />
        <path
          className="white"
          d="M 573.59 316.36 575.11 314.51 574.62 313.14 576.45 309.66 576.69 308.96 577.37 306.96 577.65 307.13 577.94 306.85 578.45 307.36 579.81 307.58 579.66 308.17 581.15 309.75 580.22 312.74 580.59 313.53 581.49 314.91 581.3 315.46 581.26 315.47 580.24 315.59 576.83 315.99 576.64 316.01 575.3 316.18 574.98 316.23 573.59 316.36 Z"
          data-name="Hamilton"
          data-stusps="TN"
          id="47065"
        />
        <path
          className="white"
          d="M 464.96 169.23 464.73 163.83 468.22 163.67 469.51 163.6 471.14 163.52 471.62 171.38 465.07 171.68 464.96 169.23 Z"
          data-name="Winneshiek"
          data-stusps="IA"
          id="19191"
        />
        <path
          className="white"
          d="M 426.27 208.87 429.49 208.84 432.76 208.81 432.83 213.65 426.31 213.71 426.27 208.87 Z"
          data-name="Adams"
          data-stusps="IA"
          id="19003"
        />
        <path
          className="white"
          d="M 524.64 247.65 529.23 247.21 529.78 247.17 530.18 252.43 529.55 252.49 526.71 252.75 526.65 252.21 525.09 252.31 524.48 251.85 524.83 249.84 524.64 247.65 Z"
          data-name="Richland"
          data-stusps="IL"
          id="17159"
        />
        <path
          className="white"
          d="M 484.27 225.08 484.2 223.36 490.82 223.13 490.9 224.78 494.54 224.64 494.48 225.17 492.38 225.9 491.32 227.92 490.23 228.6 488.89 228.8 487.48 226.58 484.34 226.75 484.27 225.08 Z"
          data-name="Schuyler"
          data-stusps="IL"
          id="17169"
        />
        <path
          className="white"
          d="M 495.66 255.72 495.74 255.46 496.61 254.14 496.61 253.24 496.6 253.23 498.71 253.13 503.6 252.87 503.94 257.36 504.2 261.05 501.29 261.21 501.18 259.96 499.16 259.69 497.4 257.58 495.59 255.96 495.66 255.72 Z"
          data-name="St. Clair"
          data-stusps="IL"
          id="17163"
        />
        <path
          className="white"
          d="M 674.57 256.12 676.76 249.88 676.7 248.81 677.38 247.61 677.7 247.48 678.83 248.02 679.35 248.95 679.16 249.34 679.2 252.97 678.43 253.32 677.95 254.91 676.41 256.52 674.57 256.12 Z"
          data-name="Cumberland"
          data-stusps="VA"
          id="51049"
        />
        <path
          className="white"
          d="M 502.75 173.86 507.66 173.42 508.97 173.34 510.93 173.24 510.95 173.41 511.49 179.79 509.21 179.95 508.48 180 507.78 180.05 503.29 180.33 502.75 173.86 Z"
          data-name="Rock"
          data-stusps="WI"
          id="55105"
        />
        <path
          className="white"
          d="M 452.24 124.04 456.96 123.89 456.9 122.27 461.82 122.11 461.89 123.72 462.24 131.8 454.14 132.13 454.15 130.72 454.32 130.51 454.94 129.72 455.43 128.58 455.56 127.79 455 127.17 454.42 126.18 454.02 125.6 453.42 125.52 452.37 125.36 452.23 124.14 452.24 124.04 Z"
          data-name="Polk"
          data-stusps="WI"
          id="55095"
        />
        <path
          className="white"
          d="M 688.02 222.78 688.57 221.93 688.63 221.84 688.63 221.84 689.19 222.31 690.1 222.84 690.21 223.35 689.54 223.76 689.13 223.53 688.43 223.04 688.02 222.78 Z"
          data-name="Arlington"
          data-stusps="VA"
          id="51013"
        />
        <path
          className="white"
          d="M 481.65 127.56 490.07 126.91 490.41 131.83 488.36 131.96 488.48 133.6 486.91 133.7 485.34 133.86 478.81 134.28 478.49 129.38 478.39 127.74 481.65 127.56 Z"
          data-name="Taylor"
          data-stusps="WI"
          id="55119"
        />
        <path
          className="white"
          d="M 700.41 263.49 701.36 259.84 700.43 257.77 702.49 256.09 702.97 254.11 703.02 254.67 706.82 257.51 705.58 258.29 703.64 261.07 701.07 264.62 700.87 264.57 700.69 264.33 700.74 264.12 700.5 263.95 700.64 263.63 700.42 263.67 700.41 263.49 Z"
          data-name="Isle of Wight"
          data-stusps="VA"
          id="51093"
        />
        <path
          className="white"
          d="M 451.25 157.83 451.3 157.82 456.15 157.65 456.37 157.91 459.43 157.79 459.68 164.05 458.26 164.11 458.26 164.11 453.93 164.29 451.82 164.36 451.48 164.37 451.25 157.83 Z"
          data-name="Mower"
          data-stusps="MN"
          id="27099"
        />
        <path
          className="white"
          d="M 427.58 146.96 429.69 146.94 439.03 146.75 439.06 146.96 438.9 147.58 438.77 147.69 438.74 148.13 438.61 148.17 438.72 148.31 438.64 148.5 439.04 148.85 437.83 150.53 438.01 150.85 438.14 152.18 437.46 152.47 433.15 150.48 431.5 148.72 429.14 148.11 427.58 146.96 Z"
          data-name="Nicollet"
          data-stusps="MN"
          id="27103"
        />
        <path
          className="white"
          d="M 181.82 93.14 183.97 92.08 185.39 91.88 186.06 88.54 189.29 89.25 189.47 88.44 195.68 89.83 195.05 90.26 195.08 91.4 193.55 91.92 192.3 91.64 191.93 93.28 190.96 93.06 189.6 93.84 189.56 94.99 187.13 95.9 186 95.17 182.88 96.93 181.83 93.17 181.82 93.14 Z"
          data-name="Deer Lodge"
          data-stusps="MT"
          id="30023"
        />
        <path
          className="white"
          d="M 405.06 151.9 405.06 151.9 410.11 151.93 410.31 151.93 410.28 158.45 405 158.41 405.06 151.9 Z"
          data-name="Pipestone"
          data-stusps="MN"
          id="27117"
        />
        <path
          className="white"
          d="M 382.86 417.39 383.84 416.57 389.21 421.92 389.18 421.96 384.56 424.78 383.99 424.41 381.8 423.08 381.6 422.32 381.3 422.45 380.09 420.44 379.7 420.45 382.8 417.44 382.86 417.39 Z"
          data-name="Caldwell"
          data-stusps="TX"
          id="48055"
        />
        <path
          className="white"
          d="M 700.06 242.33 701.38 240.87 702.23 240.66 703.62 240.67 705.62 243.03 705.61 243.27 706.58 244.11 706.57 244.72 702.76 244.68 701.44 242.85 700.06 242.33 Z"
          data-name="Lancaster"
          data-stusps="VA"
          id="51103"
        />
        <path
          className="white"
          d="M 450.51 237.35 450.75 237.2 450.63 235.7 453.3 235.56 456.56 235.58 459.01 235.53 459.02 237.18 458.96 237.42 458.99 242.6 457.77 242.23 456.98 244.46 456.07 244.54 455.32 242.9 453.65 242.52 453.17 241.63 452.94 241.01 450.63 240.3 450.51 237.35 Z"
          data-name="Chariton"
          data-stusps="MO"
          id="29041"
        />
        <path
          className="white"
          d="M 446.21 151.45 449.51 151.34 451.08 151.29 451.3 157.82 451.25 157.83 446.4 157.99 446.21 151.45 Z"
          data-name="Steele"
          data-stusps="MN"
          id="27147"
        />
        <path
          className="white"
          d="M 454.22 250.15 454.22 249.32 455.83 247.54 457.08 249.04 461.41 249.11 462.31 249.99 460.73 254.59 457.46 254.63 454.21 254.56 454.22 250.15 Z"
          data-name="Cooper"
          data-stusps="MO"
          id="29053"
        />
        <path
          className="white"
          d="M 422.23 111.11 427.75 111.05 427.94 111.37 428.77 111.41 429.05 122.2 422.54 122.29 422.4 116.03 422.37 112.73 422.23 111.11 Z"
          data-name="Todd"
          data-stusps="MN"
          id="27153"
        />
        <path
          className="white"
          d="M 439.66 280.13 439.68 275.78 446.54 275.8 446.53 278.52 446.52 281.25 440.12 281.24 439.65 281.23 439.66 280.13 Z"
          data-name="Dade"
          data-stusps="MO"
          id="29057"
        />
        <path
          className="white"
          d="M 413.41 215.97 413.31 214.81 413.75 214.04 413.63 213.83 413.97 213.76 419.81 213.74 420.03 216.99 420 219.77 417.72 219.74 414.4 219.7 414.64 219.35 414.16 218.42 413.25 217.87 412.64 216.86 413.41 215.99 413.41 215.97 Z"
          data-name="Fremont"
          data-stusps="IA"
          id="19071"
        />
        <path
          className="white"
          d="M 538.87 238.59 538.42 233.67 538.84 231.99 541.55 231.76 541.77 234.23 542.86 234.13 543.07 236.6 541.44 236.75 541.75 240.03 539.02 240.23 538.87 238.59 Z"
          data-name="Clay"
          data-stusps="IN"
          id="18021"
        />
        <path
          className="white"
          d="M 701.36 236.86 701.73 237.22 702.87 237.77 704.71 238.21 706.1 238.82 706.12 239.93 705.39 240.85 705.66 242.28 705.62 243.03 703.62 240.67 702.23 240.66 701.12 239.06 699.8 238.64 699.91 237.95 701.36 236.86 Z"
          data-name="Northumberland"
          data-stusps="VA"
          id="51133"
        />
        <path
          className="white"
          d="M 575.13 329.49 576.32 329.37 576.97 327.7 579.26 326.2 580.09 323.22 580.69 323.16 580.51 326.67 582.08 326.73 581.9 327.61 582.03 332.38 578.72 332.65 576.19 333.29 575.97 332.47 575.13 329.49 Z"
          data-name="Floyd"
          data-stusps="GA"
          id="13115"
        />
        <path
          className="white"
          d="M 503.6 252.87 505.24 252.75 505.1 251.11 510.15 250.78 511.86 250.76 512.1 255.15 509.01 255.07 507.15 256.15 505.8 255.97 503.94 257.36 503.6 252.87 Z"
          data-name="Clinton"
          data-stusps="IL"
          id="17027"
        />
        <path
          className="white"
          d="M 348.12 268.26 357.89 268.7 357.81 270.34 357.91 272.05 357.76 277.06 349.52 276.58 347.89 276.5 348.22 269.9 348.12 268.26 Z"
          data-name="Ford"
          data-stusps="KS"
          id="20057"
        />
        <path
          className="white"
          d="M 580.69 323.16 580.91 322.47 582.86 322.37 583.02 322.01 583.85 322.41 586.14 321.89 587.17 322.53 587.24 323.17 587.6 324.91 587.55 325.74 582.36 326.85 582.08 326.73 580.51 326.67 580.69 323.16 Z"
          data-name="Gordon"
          data-stusps="GA"
          id="13129"
        />
        <path
          className="white"
          d="M 557 218.45 556.65 215.45 560.73 214.96 561.43 220.64 561.72 223.11 557.58 223.63 557 218.45 Z"
          data-name="Madison"
          data-stusps="IN"
          id="18095"
        />
        <path
          className="white"
          d="M 348.52 253.53 349.89 253.61 358.06 253.99 358.26 253.99 358 260.51 357.94 262.14 348.42 261.72 348.17 261.71 348.52 253.53 Z"
          data-name="Ness"
          data-stusps="KS"
          id="20135"
        />
        <path
          className="white"
          d="M 155.48 141.25 158.51 141.92 167.6 143.96 166.16 150.55 165.47 150.4 165.11 152 162.79 151.48 161.15 151.11 161.33 150.3 157.23 149.36 157.14 148.51 153.97 147.78 155.48 141.25 Z"
          data-name="Lincoln"
          data-stusps="ID"
          id="16063"
        />
        <path
          className="white"
          d="M 690.6 169.62 690.43 167.54 691.59 167.18 691.87 167.27 697.23 166.02 696.59 168.53 697.12 168.77 696.59 170.47 694.56 171.71 694.07 171.94 690.44 172.93 690.62 170.22 690.6 169.62 Z"
          data-name="Wyoming"
          data-stusps="PA"
          id="42131"
        />
        <path
          className="white"
          d="M 556.92 229.51 556.8 228.41 561.43 227.86 562.01 232.47 562.22 234.4 561.43 234.5 557.53 234.98 556.92 229.51 Z"
          data-name="Shelby"
          data-stusps="IN"
          id="18145"
        />
        <path
          className="white"
          d="M 671.04 174.05 680.06 171.86 681.08 170.73 681.97 170.66 683.68 173.93 686.35 175.33 688.54 175.39 686.99 178.1 686.31 178.29 685.77 178.44 684.92 178.28 682.83 179.05 682.73 179.43 681.78 179.46 681.78 180.66 679.49 181.55 675.92 179.35 672.83 177.29 671.49 175.95 671.32 175.25 671.04 174.05 Z"
          data-name="Lycoming"
          data-stusps="PA"
          id="42081"
        />
        <path
          className="white"
          d="M 673.19 189.63 673.54 189.26 677.26 186.44 677.53 187.16 678.01 189.15 678.99 189.09 676.41 191.21 676.43 191.86 673.58 196.48 672.12 197.05 671.16 196.59 672.16 194.38 671.6 193.52 673.32 190.65 673.19 189.63 Z"
          data-name="Mifflin"
          data-stusps="PA"
          id="42087"
        />
        <path
          className="white"
          d="M 441.33 151.59 444.61 151.5 446.21 151.45 446.4 157.99 443.12 158.08 441.49 158.12 441.33 151.59 Z"
          data-name="Waseca"
          data-stusps="MN"
          id="27161"
        />
        <path
          className="white"
          d="M 574.98 167.31 578.24 166.77 581.5 166.25 581.79 167.89 582.77 172.83 578.89 173.52 576.29 173.88 576.15 173.89 574.98 167.31 Z"
          data-name="Livingston"
          data-stusps="MI"
          id="26093"
        />
        <path
          className="white"
          d="M 508.63 286.21 509.37 284.92 511.62 283 512.4 283.2 513.37 283.62 514.32 283.7 514.86 284.12 514.82 284.37 514.63 285.38 514.28 286.25 514.23 287.35 514.23 287.4 514.25 287.97 513.62 288.76 514.25 289.74 514.11 289.96 513.79 290.46 513.43 291.55 512.64 291.45 511.89 290.63 511.85 290.63 511.04 289.19 508.66 286.62 508.63 286.21 Z"
          data-name="Mississippi"
          data-stusps="MO"
          id="29133"
        />
        <path
          className="white"
          d="M 334.58 221.65 342.42 222.14 342.7 222.15 342.33 228.67 337.97 228.42 334.6 228.21 334.17 228.19 334.58 221.65 Z"
          data-name="Hitchcock"
          data-stusps="NE"
          id="31087"
        />
        <path
          className="white"
          d="M 561.02 136.04 567.49 135.22 568.45 141.72 565.2 142.18 561.9 142.61 561.02 136.04 Z"
          data-name="Roscommon"
          data-stusps="MI"
          id="26143"
        />
        <path
          className="white"
          d="M 617.1 291.94 617.7 291.38 618.26 290.03 619.23 289.67 620.94 290.95 621.78 290.64 623.29 294.13 622.6 295.92 621.7 296.75 621.42 296.69 621.22 296.31 620.38 295.96 619.77 294.66 619.06 294.82 617.49 293.28 617.1 291.94 Z"
          data-name="Yancey"
          data-stusps="NC"
          id="37199"
        />
        <path
          className="white"
          d="M 431.56 274.56 439.68 274.69 439.68 275.78 439.66 280.13 431.63 279.98 431.62 279.11 431.56 274.56 Z"
          data-name="Barton"
          data-stusps="MO"
          id="29011"
        />
        <path
          className="white"
          d="M 410.45 158.45 418.46 158.46 418.6 158.46 418.6 164.99 418.16 164.99 413.41 165.01 413.05 165.01 410.42 165 410.45 158.45 Z"
          data-name="Nobles"
          data-stusps="MN"
          id="27105"
        />
        <path
          className="white"
          d="M 640.08 277.31 641.01 277.16 643.08 276.82 644.51 276.67 647.16 276.38 647.88 281.89 647.93 282.27 646.33 281.67 645.16 281.84 641.49 283.4 641.29 281.68 639.55 280.49 639.3 279.53 640.08 277.31 Z"
          data-name="Surry"
          data-stusps="NC"
          id="37171"
        />
        <path
          className="white"
          d="M 307.36 194.15 307.54 193.33 307.96 188.46 317.29 189.21 317.57 189.22 317.28 192.53 317.77 194.2 317.3 199.91 306.95 199.06 307.36 194.15 Z"
          data-name="Morrill"
          data-stusps="NE"
          id="31123"
        />
        <path
          className="white"
          d="M 324.98 208.69 325.34 208.73 336.39 209.45 336.07 215.2 334.67 215.11 324.58 214.45 324.65 213.47 324.98 208.72 324.98 208.72 324.98 208.69 Z"
          data-name="Perkins"
          data-stusps="NE"
          id="31135"
        />
        <path
          className="white"
          d="M 360.73 111.42 371.69 111.92 372.13 111.94 371.84 118.38 370.7 118.33 367.4 118.19 365.49 118.1 363.91 118.01 362.51 117.95 360.39 117.83 360.73 111.42 Z"
          data-name="McIntosh"
          data-stusps="ND"
          id="38051"
        />
        <path
          className="white"
          d="M 282.56 295.76 289.07 296.33 289 297.15 292.27 297.44 292.13 299.09 298.69 299.61 298.41 301.24 298.03 306.11 297.46 312.55 293.49 312.37 292.2 311.65 288.9 304.2 288.18 304.53 282.83 304.11 282.66 302.61 283.79 300.76 282.72 297.57 282.56 295.76 Z"
          data-name="Harding"
          data-stusps="NM"
          id="35021"
        />
        <path
          className="white"
          d="M 584.03 203.56 589.25 202.86 589.85 205.02 590.64 204.89 590.98 205.14 591.46 208.15 591.48 208.55 590.03 208.78 584.78 208.98 584.77 208.85 584.49 206.86 584.03 203.56 Z"
          data-name="Hardin"
          data-stusps="OH"
          id="39065"
        />
        <path
          className="white"
          d="M 454.2 257.63 454.21 254.56 457.46 254.63 457.48 256.27 460.78 259.27 460.71 260.83 459.88 260.85 459.87 263.23 458.87 263.87 458.24 263.86 455.16 263.98 454.19 262.64 454.2 257.63 Z"
          data-name="Morgan"
          data-stusps="MO"
          id="29141"
        />
        <path
          className="white"
          d="M 367.75 60.64 369.61 60.73 374.26 60.92 374.04 66.21 374.4 66.23 374.27 69.49 374.13 72.76 371.26 72.63 367.59 72.46 367.75 69.19 367.91 65.93 367.5 65.91 367.75 60.64 Z"
          data-name="Towner"
          data-stusps="ND"
          id="38095"
        />
        <path
          className="white"
          d="M 434.45 137.03 437.7 136.97 437.83 141.88 434.57 141.94 434.59 143.58 431.33 143.65 431.3 142.01 431.25 139.09 431.19 138.72 431.17 137.08 434.45 137.03 Z"
          data-name="McLeod"
          data-stusps="MN"
          id="27085"
        />
        <path
          className="white"
          d="M 431.72 286.83 431.7 285.74 440.11 285.77 440.09 287.96 440.06 291.41 431.77 291.19 431.72 286.83 Z"
          data-name="Newton"
          data-stusps="MO"
          id="29145"
        />
        <path
          className="white"
          d="M 459.38 339.57 462.62 339.59 465.5 339.6 466.89 340.09 468.01 341.1 465.9 341.22 465.89 342.8 467.1 343.88 468.21 346.06 464.31 346.05 459.45 346.05 459.4 344.32 458.3 343.01 459.36 342.81 459.38 339.57 Z"
          data-name="Dallas"
          data-stusps="AR"
          id="5039"
        />
        <path
          className="white"
          d="M 554.53 136.88 561.02 136.04 561.9 142.61 558.71 142.98 555.36 143.4 554.53 136.88 Z"
          data-name="Missaukee"
          data-stusps="MI"
          id="26113"
        />
        <path
          className="white"
          d="M 476.35 287.63 482.92 287.42 482.94 288.51 484.59 288.47 484.73 294.59 480.51 294.81 480.48 294.81 479.82 294.83 476.9 294.93 476.45 294.95 476.19 289.54 476.35 287.63 Z"
          data-name="Oregon"
          data-stusps="MO"
          id="29149"
        />
        <path
          className="white"
          d="M 645.04 297.02 645.76 296.91 652.63 295.87 650.4 302.08 650.33 302.42 649.56 302.09 648.71 301.72 647.57 301.24 646.92 299.82 645.62 298.95 645.04 297.02 Z"
          data-name="Cabarrus"
          data-stusps="NC"
          id="37025"
        />
        <path
          className="white"
          d="M 450.82 133.87 451.3 133.86 451.46 138.23 450.98 138.25 449.95 137.67 448.87 138.36 448.56 137.97 448.38 135.61 448.13 135.62 448.12 135.35 448.07 133.95 450.82 133.87 Z"
          data-name="Ramsey"
          data-stusps="MN"
          id="27123"
        />
        <path
          className="white"
          d="M 601.61 210.06 603.05 209.93 602.79 206.02 606.36 205.45 606.89 205.29 608.53 204.78 609.12 204.59 609.38 206.8 609.86 210.92 605.77 211.43 605.73 211.07 601.74 211.44 601.61 210.06 Z"
          data-name="Knox"
          data-stusps="OH"
          id="39083"
        />
        <path
          className="white"
          d="M 602 214.31 601.74 211.44 605.73 211.07 605.77 211.43 609.86 210.92 610.07 211.12 610.2 212.26 610.52 215.03 610.67 216.37 610.26 217.15 607.56 217.39 606.89 217.34 606.46 217.49 602.23 217.86 602.25 217.16 602.13 215.73 602 214.31 Z"
          data-name="Licking"
          data-stusps="OH"
          id="39089"
        />
        <path
          className="white"
          d="M 324.24 219.28 324.58 214.45 334.67 215.11 334.3 221.64 324.12 220.99 324.24 219.28 Z"
          data-name="Chase"
          data-stusps="NE"
          id="31029"
        />
        <path
          className="white"
          d="M 462.62 334.62 463.82 333.81 466.7 333.78 466.69 332.96 469.14 332.91 469.72 332.91 469.83 337.83 469.62 340.99 468.01 341.1 466.89 340.09 465.5 339.6 462.62 339.59 462.62 334.62 Z"
          data-name="Grant"
          data-stusps="AR"
          id="5053"
        />
        <path
          className="white"
          d="M 317.57 189.22 326.14 189.8 325.76 194.82 326.91 194.9 326.46 201.42 325.46 201.34 325.22 204.6 317.35 204.01 317.62 200.76 317.3 199.91 317.77 194.2 317.28 192.53 317.57 189.22 Z"
          data-name="Garden"
          data-stusps="NE"
          id="31069"
        />
        <path
          className="white"
          d="M 422.07 102.93 426.91 102.89 427.12 110.58 427.75 111.05 422.23 111.11 422.19 106.21 422.07 104.56 422.07 102.93 Z"
          data-name="Wadena"
          data-stusps="MN"
          id="27159"
        />
        <path
          className="white"
          d="M 507.05 165.21 506.82 161.94 506.54 158.67 508.19 158.52 514.81 157.99 514.96 159.63 515.01 162.91 515.31 166.2 513.69 166.32 507.18 166.84 507.05 165.21 Z"
          data-name="Dodge"
          data-stusps="WI"
          id="55027"
        />
        <path
          className="white"
          d="M 451.08 151.29 451.15 151.28 456.04 151.13 456.29 157.46 456.15 157.65 451.3 157.82 451.08 151.29 Z"
          data-name="Dodge"
          data-stusps="MN"
          id="27039"
        />
        <path
          className="white"
          d="M 592.28 265.76 594.48 265.93 595.98 264.85 596.91 265.38 597.81 266.96 597.81 268.56 597.87 269.45 598.31 269.95 596.16 268.32 594.2 268.75 592.4 266.52 592.28 265.76 Z"
          data-name="Owsley"
          data-stusps="KY"
          id="21189"
        />
        <path
          className="white"
          d="M 547.4 157.69 546.64 151.15 553.11 150.36 553.93 156.88 554.33 160.15 551.21 160.56 547.79 160.96 547.4 157.69 Z"
          data-name="Newaygo"
          data-stusps="MI"
          id="26123"
        />
        <path
          className="white"
          d="M 552.25 143.8 555.36 143.4 558.71 142.98 559.56 149.57 553.11 150.36 552.25 143.8 Z"
          data-name="Osceola"
          data-stusps="MI"
          id="26133"
        />
        <path
          className="white"
          d="M 585.64 246.76 586.66 245.59 588.06 245.69 588.38 245.77 589.22 247.48 588.61 248.58 588.37 248.94 586.75 248.43 586 248.15 585.45 247.86 585.64 246.76 Z"
          data-name="Robertson"
          data-stusps="KY"
          id="21201"
        />
        <path
          className="white"
          d="M 657.15 302.14 660.52 300.8 664.28 300.57 665.18 302.25 667.09 302.44 665.47 303.71 665.91 305.24 665.39 307.18 664.19 307.58 660.55 308.12 661.44 306.18 660.58 303.68 659.6 302.28 658.62 303.02 657.15 302.14 Z"
          data-name="Richmond"
          data-stusps="NC"
          id="37153"
        />
        <path
          className="white"
          d="M 509.81 245.4 509.55 241.84 511.17 241.72 512.81 241.64 516.06 241.38 516.48 247.1 518.14 246.91 518.25 248.57 511.74 249.11 511.86 250.76 510.15 250.78 509.87 247.49 509.75 245.95 509.81 245.4 Z"
          data-name="Fayette"
          data-stusps="IL"
          id="17051"
        />
        <path
          className="white"
          d="M 518.93 214.65 522.14 214.36 521.35 207.31 522.99 207.1 523.98 216.12 524.03 216.66 526.66 216.47 526.85 218.09 520.89 218.63 519.27 218.76 518.93 214.65 Z"
          data-name="Ford"
          data-stusps="IL"
          id="17053"
        />
        <path
          className="white"
          d="M 589.25 253.23 590.92 251 592.76 250.84 594.24 252.98 594.36 252.65 596.1 254.19 597.23 254.5 596.74 254.95 595.58 254.95 595.61 255.85 594.4 255.7 592.98 256.45 590.82 254.09 589.38 253.86 589.25 253.23 Z"
          data-name="Bath"
          data-stusps="KY"
          id="21011"
        />
        <path
          className="white"
          d="M 582.12 252.39 583.73 252.09 584.08 251.58 584.44 251.54 585.6 250.26 587.34 252.2 589.34 252.89 589.25 253.23 589.07 253.61 587.91 254.88 584.96 256.18 583.47 255.52 583.67 254.21 582.91 253.74 582.62 253.65 582.12 252.39 Z"
          data-name="Bourbon"
          data-stusps="KY"
          id="21017"
        />
        <path
          className="white"
          d="M 334.26 410.99 343.77 411.33 349.67 411.54 349.47 415.6 346.05 415.32 345.36 418.78 344.86 419.67 344.98 423.9 343.37 423.84 333.73 423.45 334.26 410.99 Z"
          data-name="Edwards"
          data-stusps="TX"
          id="48137"
        />
        <path
          className="white"
          d="M 388.81 294.34 394.92 294.42 397.11 294.36 397.48 294.81 395.62 296.06 395.28 296.06 395.24 299.31 396.87 299.33 396.85 300.96 393.57 300.92 393.55 302.56 390.3 302.51 390.04 302.41 388.68 302.38 388.81 294.34 Z"
          data-name="Noble"
          data-stusps="OK"
          id="40103"
        />
        <path
          className="white"
          d="M 391.99 164.81 395.71 164.87 398.5 164.91 398.41 172.72 395.16 172.69 395.18 171.06 391.9 171.01 391.99 164.81 Z"
          data-name="Turner"
          data-stusps="SD"
          id="46125"
        />
        <path
          className="white"
          d="M 366.08 295.41 367.85 295.47 368.37 296.34 371.09 297.7 372.49 297.65 372.52 296.42 379.03 296.59 378.9 302.18 377.28 302.14 370.79 301.97 365.94 301.88 366.08 295.41 Z"
          data-name="Major"
          data-stusps="OK"
          id="40093"
        />
        <path
          className="white"
          d="M 396.03 145.29 399.29 145.32 405.09 145.39 405.08 148.83 405.06 151.9 405.06 151.9 399.16 151.86 395.91 151.81 396.03 145.29 Z"
          data-name="Brookings"
          data-stusps="SD"
          id="46011"
        />
        <path
          className="white"
          d="M 522.25 300.49 522.74 299.42 524.62 299.31 524.6 298.62 529.47 298.36 529.49 298.85 529.82 304 530.43 303.96 530.45 304.51 524.46 304.83 523.94 305.53 522.41 305.61 522.25 300.49 Z"
          data-name="Carroll"
          data-stusps="TN"
          id="47017"
        />
        <path
          className="white"
          d="M 426.78 391.33 428.97 389.41 429.67 390.21 434.14 391.14 434.37 391.76 434.94 391.62 435.7 393.19 436.57 393.54 437.7 394.98 439.45 395.92 440.91 397.28 435.63 398.59 435.33 398.7 433.95 398.13 433.76 397.95 431.09 397.32 429.4 396.54 429.1 394.88 427.51 392.05 427.21 391.64 426.78 391.33 Z"
          data-name="Angelina"
          data-stusps="TX"
          id="48005"
        />
        <path
          className="white"
          d="M 636.07 343.03 636.36 342.77 641.5 336.61 642.66 336.62 644.03 337.22 644.7 342.53 645.37 343.25 642.66 343.84 639.7 343.29 638.69 344.76 637.98 344.59 636.31 343.88 636.07 343.03 Z"
          data-name="Barnwell"
          data-stusps="SC"
          id="45011"
        />
        <path
          className="white"
          d="M 658.26 338.66 659.87 337.6 659.95 334.78 661.09 334.51 661.71 333.47 663.78 333.07 669.07 336.06 672.77 336.82 673.03 337.21 672.07 338.63 670.17 339.41 668.65 342.29 668.65 343.2 667.79 343.78 666.87 345.1 666.72 345.9 666.64 345.91 665.87 344.25 665.32 344.46 664.66 344.22 663.91 342.82 662.35 342.63 660.52 341.58 659.82 341.19 659.54 339.98 658.26 338.66 Z"
          data-name="Berkeley"
          data-stusps="SC"
          id="45015"
        />
        <path
          className="white"
          d="M 382.24 164.61 384.29 164.65 389.18 164.75 391.99 164.81 391.9 171.01 388.63 170.96 382.59 170.82 382.15 170.27 382.24 164.61 Z"
          data-name="Hutchinson"
          data-stusps="SD"
          id="46067"
        />
        <path
          className="white"
          d="M 651.64 341.14 655.79 337.54 656.24 338.53 658.26 338.66 659.54 339.98 659.82 341.19 660.52 341.58 662.35 342.63 661.95 342.91 662.61 343.4 663.35 343.94 663.58 345.06 662.23 345.77 662.95 346.48 662.55 346.49 660.56 346.26 658.78 346.34 658.19 344.31 658.42 342.79 656.08 342.64 654.65 342.92 652.99 341.41 651.64 341.14 Z"
          data-name="Dorchester"
          data-stusps="SC"
          id="45035"
        />
        <path
          className="white"
          d="M 636.19 311.62 645.27 310.28 645.71 310.85 646.22 312.56 645.84 313.86 646.39 315.49 637.76 316.22 637.69 315.03 636.35 313.09 636.62 312.12 636.19 311.62 Z"
          data-name="Chester"
          data-stusps="SC"
          id="45023"
        />
        <path
          className="white"
          d="M 356.44 345.26 364.62 345.53 364.36 353.71 356.2 353.42 356.39 347.14 356.44 345.26 Z"
          data-name="Baylor"
          data-stusps="TX"
          id="48023"
        />
        <path
          className="white"
          d="M 523.94 305.53 524.46 304.83 530.45 304.51 530.58 308.43 529.89 310 529.96 311.69 530.07 311.98 529.79 312.13 528.24 312.2 528.09 310.82 525.89 310.62 524.85 309.28 524.12 309.32 524.22 308.59 523.94 305.53 Z"
          data-name="Henderson"
          data-stusps="TN"
          id="47077"
        />
        <path
          className="white"
          d="M 389.3 158.2 392.55 158.27 395.81 158.34 395.71 164.87 391.99 164.81 389.18 164.75 389.3 158.2 Z"
          data-name="McCook"
          data-stusps="SD"
          id="46087"
        />
        <path
          className="white"
          d="M 665.34 181.69 666.22 178.54 665.79 176.52 671.32 175.25 671.49 175.95 672.83 177.29 675.92 179.35 679.49 181.55 679.59 182.02 677.03 183.71 674.74 184.69 674.61 184.59 672.57 182.63 670.79 182.69 669.68 181.46 668.35 181.82 667.97 180.43 666.38 182.72 665.97 182.4 665.34 181.69 Z"
          data-name="Clinton"
          data-stusps="PA"
          id="42035"
        />
        <path
          className="white"
          d="M 405.14 131.77 407.08 132.11 409.83 133.53 410.72 133.99 413.54 137.1 413.81 137.8 414.71 138.05 414.7 138.89 413.23 138.88 413.21 140.5 405.11 140.47 405.12 137.24 405.14 131.77 Z"
          data-name="Lac qui Parle"
          data-stusps="MN"
          id="27073"
        />
        <path
          className="white"
          d="M 521.99 315.9 522.95 315.83 524.01 313.61 525.04 313.14 528.27 312.92 528.19 314.38 528.54 320.18 527.15 320.28 522.26 320.65 521.99 315.9 Z"
          data-name="McNairy"
          data-stusps="TN"
          id="47109"
        />
        <path
          className="white"
          d="M 362.15 137.56 363.5 137.63 366.98 137.79 366.86 144.36 366.58 150.98 362.84 150.86 361.69 150.34 361.97 144.3 361.81 144.12 362.15 137.56 Z"
          data-name="Hyde"
          data-stusps="SD"
          id="46069"
        />
        <path
          className="white"
          d="M 449.96 361.13 450.44 361.13 452.23 361.09 454.42 361.04 454.57 366.7 455.62 368.22 455.57 369.14 456.13 371.55 454.7 371.61 454.72 372.44 452.56 372.49 451.47 372.51 451.27 365.93 450.8 365.53 451.17 363.97 449.82 361.95 449.96 361.13 Z"
          data-name="Webster"
          data-stusps="LA"
          id="22119"
        />
        <path
          className="white"
          d="M 333.81 377.16 336.3 377.3 343.17 377.65 342.87 384.95 333.41 384.49 333.81 377.16 Z"
          data-name="Coke"
          data-stusps="TX"
          id="48081"
        />
        <path
          className="white"
          d="M 445.48 169.14 451.98 168.94 452 169.74 452.18 175.47 445.65 175.66 445.48 169.14 Z"
          data-name="Cerro Gordo"
          data-stusps="IA"
          id="19033"
        />
        <path
          className="white"
          d="M 692.88 285.4 694.67 283.51 696.57 281.57 697.24 281.71 698.84 282.05 700.3 282.82 700.08 283.51 700.67 284.6 702.34 285.97 702.12 286.05 701.07 286.9 701.24 288.85 700.56 290.25 699.74 289.92 698.38 290.97 697.79 290.88 696.74 289.56 695.97 287.91 694.12 287.28 692.41 285.94 692.88 285.4 Z"
          data-name="Pitt"
          data-stusps="NC"
          id="37147"
        />
        <path
          className="white"
          d="M 458.46 169.51 464.96 169.23 465.07 171.68 465.21 174.97 458.68 175.25 458.46 169.51 Z"
          data-name="Chickasaw"
          data-stusps="IA"
          id="19037"
        />
        <path
          className="white"
          d="M 419.53 169.58 426.04 169.53 426.11 176.01 419.57 176.06 419.53 169.58 Z"
          data-name="Clay"
          data-stusps="IA"
          id="19041"
        />
        <path
          className="white"
          d="M 711.27 224.27 711.37 224.61 711.82 226.15 715.06 225.54 717.12 225.09 718.07 226.82 717.5 228.23 713.82 229.33 712.99 229.11 711.46 229.73 710.14 231.34 709.85 230.97 709.3 230.99 709.01 230.04 709.75 228.81 709.79 226.2 711.27 224.27 Z"
          data-name="Wicomico"
          data-stusps="MD"
          id="24045"
        />
        <path
          className="white"
          d="M 403.21 266.52 405.65 266.55 405.67 264.92 411.57 264.97 411.57 267.42 411.53 273.16 411.53 275.61 403.1 275.51 403.21 266.52 Z"
          data-name="Greenwood"
          data-stusps="KS"
          id="20073"
        />
        <path
          className="white"
          d="M 371.48 370.49 377.94 370.67 379.72 375.72 379.79 375.92 381.02 378.68 378.75 379.94 375.47 381.75 374.82 380.59 374.49 380.75 373.58 381.27 370.15 375.18 371.39 374.5 371.48 370.49 Z"
          data-name="Erath"
          data-stusps="TX"
          id="48143"
        />
        <path
          className="white"
          d="M 375.74 390.27 382.45 386.49 383.69 385.78 385.01 388.12 387.94 393.17 381.48 396.89 380.98 397.18 379.99 397.74 375.74 390.27 Z"
          data-name="Coryell"
          data-stusps="TX"
          id="48099"
        />
        <path
          className="white"
          d="M 516.08 230.49 520.03 230.18 520.26 232.81 520.6 236.65 518.94 236.77 518 235.46 516.9 235.55 516.8 234.46 515.47 234.54 515.34 233.17 515.18 231.54 516.08 230.49 Z"
          data-name="Moultrie"
          data-stusps="IL"
          id="17139"
        />
        <path
          className="white"
          d="M 589.08 265.24 590.93 264.72 591.91 265.33 592.28 265.76 592.4 266.52 594.2 268.75 592.68 270.77 592.05 270.91 591.11 270.98 589.11 269.65 588.96 269.98 589 269.25 587.55 266.27 587.88 265.56 589.08 265.24 Z"
          data-name="Jackson"
          data-stusps="KY"
          id="21109"
        />
        <path
          className="white"
          d="M 604.57 255.54 605.03 254.78 606.92 255.14 610.43 256.34 609.63 256.98 610.44 259.4 608.67 258.96 605.95 260.11 605.6 258.65 604.62 257.55 605.17 256.81 604.57 255.54 Z"
          data-name="Johnson"
          data-stusps="KY"
          id="21115"
        />
        <path
          className="white"
          d="M 438.88 164.73 443.29 164.62 444.27 164.59 445.35 164.56 445.48 169.14 438.99 169.31 438.88 164.73 Z"
          data-name="Winnebago"
          data-stusps="IA"
          id="19189"
        />
        <path
          className="white"
          d="M 590.51 276.75 592.47 276.1 593.61 274.46 595.13 274.61 597.33 275.81 598.12 275.78 598.53 276.19 595.37 279.41 594.4 281.41 593.07 280.81 592.52 279.47 591.15 278.63 590.51 276.75 Z"
          data-name="Knox"
          data-stusps="KY"
          id="21121"
        />
        <path
          className="white"
          d="M 468.28 201.09 469.93 201.01 474.29 200.8 474.88 202.41 475.1 207.32 471.83 207.47 468.58 207.61 468.28 201.09 Z"
          data-name="Washington"
          data-stusps="IA"
          id="19183"
        />
        <path
          className="white"
          d="M 560.85 292.7 561.59 291.49 563.07 290.39 563 290 564.28 289.97 565.33 290.03 565.64 292.97 566.4 293.22 566.02 293.86 566.2 295.27 565.4 296.07 564.65 295.71 562.43 296.53 561.22 293.17 560.85 292.7 Z"
          data-name="Smith"
          data-stusps="TN"
          id="47159"
        />
        <path
          className="white"
          d="M 302.04 321.26 302.3 317.67 302.36 316.95 315.86 317.87 315.32 326.06 309.79 325.71 301.76 325.14 302.04 321.26 Z"
          data-name="Deaf Smith"
          data-stusps="TX"
          id="48117"
        />
        <path
          className="white"
          d="M 393.7 277.88 403.08 277.96 403.07 281.21 403.02 286.92 399.64 286.88 394.37 286.82 393.66 286.81 393.7 277.88 Z"
          data-name="Cowley"
          data-stusps="KS"
          id="20035"
        />
        <path
          className="white"
          d="M 524.48 274.64 525.37 274.88 525.49 275.02 525.98 274.96 527.66 277.19 528.23 279.52 527.77 280.8 528.22 282.31 527.78 282.69 526.17 281.32 524.06 282.21 523.98 281.36 524.1 281.35 524.53 280.74 524.75 279.75 523.94 278.49 523.19 277.21 523.54 276.26 523.76 275.09 524.44 274.63 524.48 274.64 Z"
          data-name="Livingston"
          data-stusps="KY"
          id="21139"
        />
        <path
          className="white"
          d="M 568.11 175.05 569.76 174.82 576.15 173.89 576.29 173.88 577.2 180.51 573.95 180.92 569.11 181.63 568.11 175.05 Z"
          data-name="Jackson"
          data-stusps="MI"
          id="26075"
        />
        <path
          className="white"
          d="M 166.72 235.91 172.72 236.98 177.87 238.1 176.39 239.34 175.55 244.53 173.92 244.35 166.56 242.94 168.13 241.76 168.82 239.77 166.72 235.91 Z"
          data-name="Piute"
          data-stusps="UT"
          id="49031"
        />
        <path
          className="white"
          d="M 418.43 151.93 423.04 151.91 423.21 151.92 423.32 152.19 423.34 153.55 426.59 153.51 426.66 158.39 423.38 158.43 418.6 158.46 418.46 158.46 418.43 151.93 Z"
          data-name="Cottonwood"
          data-stusps="MN"
          id="27033"
        />
        <path
          className="white"
          d="M 541.09 144.89 545.77 144.56 546.22 147.89 546.64 151.15 541.22 151.71 541.24 151.31 540.84 149.88 540.52 148.91 540.52 148.91 539.89 148.01 539.63 147.35 540.31 146.49 540.65 146.06 541.05 144.99 541.09 144.89 Z"
          data-name="Mason"
          data-stusps="MI"
          id="26105"
        />
        <path
          className="white"
          d="M 185.22 171.23 190.26 172.17 193.68 172.8 193.68 172.8 193.94 174.25 193.16 175.57 193.7 176.37 193.96 179.59 191.61 183.65 189.42 183.13 187.87 184.01 186.31 182.59 186.69 181.52 185.9 180.04 185.34 180.31 185.11 176.82 185.89 175.31 184.52 171.07 185.22 171.23 185.22 171.23 Z"
          data-name="Cache"
          data-stusps="UT"
          id="49005"
        />
        <path
          className="white"
          d="M 211.69 195.44 215.77 196.1 222.41 197.1 225.27 197.55 224.79 200.84 224.32 203.92 222.76 203.27 223.02 201.34 222.67 199.89 219.93 199.46 219.73 200.73 218.29 201.48 217.96 199.77 212.83 200.15 211.45 199.04 211.12 198.9 211.69 195.44 Z"
          data-name="Daggett"
          data-stusps="UT"
          id="49009"
        />
        <path
          className="white"
          d="M 516.98 307.85 517.76 308.2 519.56 305.95 519.19 305.72 522.41 305.61 523.94 305.53 524.22 308.59 524.12 309.32 523.3 311.25 520.83 312.58 517.17 312.77 516.98 307.85 Z"
          data-name="Madison"
          data-stusps="TN"
          id="47113"
        />
        <path
          className="white"
          d="M 250.31 176.99 250.76 173.74 262.85 175.43 270.91 176.4 270.95 176.4 270.14 182.91 268.67 195.92 265.06 195.48 264.18 202.95 256.5 201.94 249.98 201.05 249.27 200.96 241.41 199.91 242.3 192.42 243 187.51 248.92 188.37 249.86 180.26 250.31 176.99 Z"
          data-name="Carbon"
          data-stusps="WY"
          id="56007"
        />
        <path
          className="white"
          d="M 354.55 442.65 364.4 442.8 364.4 442.8 364.2 451.14 364.08 453.85 354.33 454.1 354.34 450.96 354.34 450.83 354.55 442.65 Z"
          data-name="La Salle"
          data-stusps="TX"
          id="48283"
        />
        <path
          className="white"
          d="M 568.64 384.25 568.48 382.56 569.29 382.34 569.12 380.84 574.88 380.31 575.58 388.26 570.19 389.02 569.07 388.93 568.66 384.82 568.64 384.25 Z"
          data-name="Coffee"
          data-stusps="AL"
          id="1031"
        />
        <path
          className="white"
          d="M 445.65 175.66 452.18 175.47 452.38 182.06 445.82 182.24 445.65 175.66 Z"
          data-name="Franklin"
          data-stusps="IA"
          id="19069"
        />
        <path
          className="white"
          d="M 405.63 392.65 405.57 392.33 406.96 391.6 414.18 387.77 415 387.1 415.41 387.82 414.95 389.91 414.83 390.77 415.4 390.85 416.27 393.03 415.18 394.27 415.12 396.28 414.55 397.59 411.15 397.63 406.86 399.83 406.83 398.2 406.55 397.9 406.41 397.88 405.43 394.61 405.63 392.65 Z"
          data-name="Leon"
          data-stusps="TX"
          id="48289"
        />
        <path
          className="white"
          d="M 633.77 354.74 636.23 353.6 636.43 353.5 638.93 355.22 641.35 355.99 641.81 357.78 643.52 359.65 643.8 360.45 638.46 362.88 637.67 361.35 635.13 361.09 635.58 358.2 633.47 356.1 633.77 354.74 Z"
          data-name="Bulloch"
          data-stusps="GA"
          id="13031"
        />
        <path
          className="white"
          d="M 330.91 244.34 332.18 244.41 340.66 244.93 340.11 253.07 335.56 252.8 330.32 252.49 330.91 244.34 Z"
          data-name="Logan"
          data-stusps="KS"
          id="20109"
        />
        <path
          className="white"
          d="M 439.26 182.39 445.82 182.24 446.37 183.86 446.51 188.76 443.22 188.85 439.97 188.92 439.85 184 439.26 182.39 Z"
          data-name="Hamilton"
          data-stusps="IA"
          id="19079"
        />
        <path
          className="white"
          d="M 385.01 388.12 390.31 385.24 394.18 383.08 395.83 385.99 397.9 389.5 390.19 393.96 389.13 394.61 387.94 393.17 385.01 388.12 Z"
          data-name="McLennan"
          data-stusps="TX"
          id="48309"
        />
        <path
          className="white"
          d="M 685.26 256.95 686 256.8 687.2 255.13 689.34 255.65 690.45 255.31 691.03 256.34 691.38 256.16 691.96 258.71 692.07 259.53 689.14 262.39 688.48 262.19 685.33 260.81 684.59 261.09 683.86 258.18 685.26 256.95 Z"
          data-name="Dinwiddie"
          data-stusps="VA"
          id="51053"
        />
        <path
          className="white"
          d="M 497.58 225.86 497.9 225.21 501.1 225.28 502.66 224.64 503.23 225.22 503.6 225.76 503.77 227.94 502.03 228.08 502.06 229.18 501.1 229.52 497.84 229.74 497.58 225.86 Z"
          data-name="Menard"
          data-stusps="IL"
          id="17129"
        />
        <path
          className="white"
          d="M 316.08 212.83 324.65 213.47 324.58 214.45 324.24 219.28 315.43 218.66 315.82 213.65 316.08 212.83 Z"
          data-name="Phillips"
          data-stusps="CO"
          id="8095"
        />
        <path
          className="white"
          d="M 606.89 217.34 607.56 217.39 610.26 217.15 611.31 217.06 611.46 218.75 612.89 218.61 612.97 219.47 613.04 220.3 613.87 220.23 614.04 223.56 612.4 223.7 610.86 223.83 610.8 223.29 609.06 223.44 608.97 222.33 608.13 219.02 607.02 219.11 606.89 217.34 Z"
          data-name="Perry"
          data-stusps="OH"
          id="39127"
        />
        <path
          className="white"
          d="M 700.79 249.06 701.58 247.9 700.98 245.61 702.66 246.21 704.61 246.6 704.84 248.42 705.64 248.8 705.16 249.16 706.21 250.36 706.75 250.99 706.61 251.44 704.74 251.99 701.81 249.86 700.79 249.06 Z"
          data-name="Gloucester"
          data-stusps="VA"
          id="51073"
        />
        <path
          className="white"
          d="M 665.88 273.36 666.04 263.16 667.91 263.04 669.02 263.38 669.36 264.21 670.93 264.33 671.53 263.25 671.74 264.89 673.15 265.84 674.06 268.81 675.83 269.89 674.01 268.96 673.3 270.07 673.3 272.02 672.35 272.19 670.11 272.59 667.11 273.14 665.88 273.36 Z"
          data-name="Halifax"
          data-stusps="VA"
          id="51083"
        />
        <path
          className="white"
          d="M 234.02 260.77 234.34 260.79 236.17 258.56 236.78 258.89 237.76 257.63 238.85 257.77 239.3 260.48 240.06 261.42 239.37 264.06 232.05 263.12 232.21 262.05 233.71 261.75 234.02 260.77 Z"
          data-name="San Juan"
          data-stusps="CO"
          id="8111"
        />
        <path
          className="white"
          d="M 456.47 194.96 463.04 194.7 463.32 201.33 461.7 201.4 456.84 201.59 456.63 199.86 456.47 194.96 Z"
          data-name="Poweshiek"
          data-stusps="IA"
          id="19157"
        />
        <path
          className="white"
          d="M 641.15 381.52 643.51 382.4 644.58 381.83 644.5 382.48 647.39 384.16 647.49 384.4 647.72 385.71 647.36 387.44 647.16 388.46 647.57 389.57 646.5 389.45 646.16 389.49 645.63 389.71 644.42 389.59 643.8 389.38 642.74 389.42 642.17 389.03 641.39 388.82 640.4 388.89 639.78 388.43 639.72 388.42 639.19 384.28 638.68 384.18 638.63 383.94 640.12 383.04 641.15 381.52 Z"
          data-name="Camden"
          data-stusps="GA"
          id="13039"
        />
        <path
          className="white"
          d="M 407.93 312.43 407.95 308.34 408.73 308.34 410.38 308.35 413.65 308.37 414.46 308.37 414.46 310.81 415.27 310.81 415.28 314.07 413.6 314.08 413.6 315.72 412.79 315.73 412.79 317.36 411.16 317.35 409.53 317.35 409.53 314.06 407.93 314.06 407.93 312.43 Z"
          data-name="Okmulgee"
          data-stusps="OK"
          id="40111"
        />
        <path
          className="white"
          d="M 290.75 327.01 291.25 327.04 291.39 325.4 294.65 325.67 294.78 324.03 296.41 324.17 296.54 322.52 298.18 322.66 298.3 320.98 302.04 321.26 301.76 325.14 301.58 327.54 301.25 332.05 301.16 333.31 301.14 333.5 294.65 333.01 290.28 332.68 290.75 327.01 Z"
          data-name="Curry"
          data-stusps="NM"
          id="35009"
        />
        <path
          className="white"
          d="M 326.91 194.9 334.79 195.42 335.06 195.44 334.63 201.96 326.46 201.42 326.91 194.9 Z"
          data-name="Arthur"
          data-stusps="NE"
          id="31005"
        />
        <path
          className="white"
          d="M 379.79 375.92 382.41 374.41 385.07 374.42 385.04 376.58 384.61 376.61 381.02 378.68 379.79 375.92 Z"
          data-name="Somervell"
          data-stusps="TX"
          id="48425"
        />
        <path
          className="white"
          d="M 447.64 257.32 447.74 250.88 447.67 250.33 447.67 250.06 454.22 250.15 454.21 254.56 454.2 257.63 450.9 257.62 450.9 258.17 447.64 258.14 447.64 257.32 Z"
          data-name="Pettis"
          data-stusps="MO"
          id="29159"
        />
        <path
          className="white"
          d="M 317.35 204.01 325.22 204.6 324.98 208.69 324.98 208.72 317.79 208.19 316.88 208.12 317.1 207.27 317.35 204.01 Z"
          data-name="Deuel"
          data-stusps="NE"
          id="31049"
        />
        <path
          className="white"
          d="M 615.8 347.93 616.49 347.84 618.27 346.51 618.67 345.34 620.27 344.33 620.56 345.53 621.91 346.28 623.16 347.93 623.95 348.08 624.83 349.92 624.9 351.75 621.07 353.26 620.43 352.56 618.24 353.8 618.11 353.87 617.61 352.34 616.73 352.13 615.77 350.51 616.07 349.72 615.8 347.93 Z"
          data-name="Washington"
          data-stusps="GA"
          id="13303"
        />
        <path
          className="white"
          d="M 620 365.58 620.75 364.63 620.55 364.34 620.98 364.32 622.46 362.69 622.91 361.87 623.72 362.07 624 361.96 624.19 362 625.61 367.22 626.61 368.15 625.84 368.78 625.06 369.12 623.61 367.68 620.77 366.55 620 365.58 Z"
          data-name="Wheeler"
          data-stusps="GA"
          id="13309"
        />
        <path
          className="white"
          d="M 42.59 69.57 42.82 68.98 51.47 72.21 50.89 74.76 49.94 74.69 48.5 75.72 49.37 76.95 48.26 77.92 47.99 78.43 45.95 77.7 41.96 76.2 40.61 75.7 40.46 75.26 42.59 69.57 Z"
          data-name="Polk"
          data-stusps="OR"
          id="41053"
        />
        <path
          className="white"
          d="M 608.74 336.94 610.47 336.03 610.58 335.49 613.29 336.36 615.25 336.22 616.03 336.74 615.23 338.4 615.51 340.5 613.38 342.96 612.36 342.59 611.24 340.75 611.29 339.79 609.91 338.67 608.74 336.94 Z"
          data-name="Greene"
          data-stusps="GA"
          id="13133"
        />
        <path
          className="white"
          d="M 486.91 133.7 488.48 133.6 488.36 131.96 490.41 131.83 498.63 131.23 501.31 131.02 501.45 132.69 501.99 139.23 493.66 139.8 492.06 139.92 487.34 140.25 486.91 133.7 Z"
          data-name="Marathon"
          data-stusps="WI"
          id="55073"
        />
        <path
          className="white"
          d="M 482.42 324.51 483.56 324.46 483.52 323.1 484.37 322.7 485.72 322.67 485.76 324.37 486.61 325.17 486.69 327.65 487.51 327.63 487.55 329.29 487.66 332.57 488.51 332.56 488.59 335.06 487.76 335.09 485.81 333.04 483.91 331.04 482.57 331.06 481.44 330.26 481.41 329.16 482.53 329.14 482.42 324.51 Z"
          data-name="Monroe"
          data-stusps="AR"
          id="5095"
        />
        <path
          className="white"
          d="M 520.19 165.81 521.62 165.67 522.09 165.63 522.48 165.59 522.55 166.84 523.07 167.95 522.81 168.9 523.67 170.18 523.93 171.81 524.05 171.94 524.15 172.06 520.71 172.36 520.53 170.32 520.52 170.19 520.31 167.46 520.28 167.15 520.27 167.06 520.19 165.81 Z"
          data-name="Milwaukee"
          data-stusps="WI"
          id="55079"
        />
        <path
          className="white"
          d="M 469.32 113.61 477.5 113.19 477.7 116.44 480.95 116.23 481.34 122.68 469.99 123.36 469.32 113.61 Z"
          data-name="Sawyer"
          data-stusps="WI"
          id="55113"
        />
        <path
          className="white"
          d="M 487.68 145.14 487.34 140.25 492.06 139.92 493.66 139.8 493.9 143.06 495.49 142.95 495.89 147.89 493.48 148.04 491.08 148.22 487.95 148.44 487.86 148.12 487.68 145.14 Z"
          data-name="Wood"
          data-stusps="WI"
          id="55141"
        />
        <path
          className="white"
          d="M 726.03 175.72 726.12 175.31 726.15 175.22 726.16 175.13 727.07 175.47 727.02 175.77 726.65 176.78 726.71 177.05 726.69 177.13 725.73 177.3 725.75 177.09 725.76 177 725.81 176.6 726.03 175.72 Z"
          data-name="New York"
          data-stusps="NY"
          id="36061"
        />
        <path
          className="white"
          d="M 366.82 92.07 369.56 92.19 379.36 92.59 379.76 92.85 379.72 94.22 379.9 99.13 379.69 105.67 371.96 105.4 366.62 105.14 366.97 98.6 366.82 92.07 Z"
          data-name="Stutsman"
          data-stusps="ND"
          id="38093"
        />
        <path
          className="white"
          d="M 514.9 350.1 516.72 348.89 519.42 348.44 519.42 348.45 519.52 350.08 519.72 353.08 519.51 354.76 517.85 354.87 517.95 356.53 516.31 356.64 516.12 353.32 513.95 353.45 513.78 350.68 514.9 350.1 Z"
          data-name="Choctaw"
          data-stusps="MS"
          id="28019"
        />
        <path
          className="white"
          d="M 362.84 150.86 366.58 150.98 371.64 151.15 371.44 156.06 366.02 155.87 365.62 155.84 365.79 154.96 362.96 152.58 362.84 150.86 Z"
          data-name="Buffalo"
          data-stusps="SD"
          id="46017"
        />
        <path
          className="white"
          d="M 443.19 225.37 448.88 225.18 449 229.23 449.08 229.55 449.11 230.78 443.34 231.08 443.24 227.83 443.19 225.37 Z"
          data-name="Grundy"
          data-stusps="MO"
          id="29079"
        />
        <path
          className="white"
          d="M 424.88 237.87 424.97 237.13 425.93 236.49 425.92 235.8 426.96 235.78 427.52 235.29 427.36 234.85 427.25 233.96 431.23 233.93 431.26 235.29 431.33 239.36 424.21 239.38 423.88 239 424.42 238.56 424.84 238.22 424.88 237.87 Z"
          data-name="Buchanan"
          data-stusps="MO"
          id="29021"
        />
        <path
          className="white"
          d="M 359.77 378.31 361 378.34 364.1 378.46 368.01 385.64 366.53 385.84 366.17 387.28 362.71 389.56 361.91 389.42 361.1 389.95 360.97 390.18 359.31 389.77 359.77 378.31 Z"
          data-name="Brown"
          data-stusps="TX"
          id="48049"
        />
        <path
          className="white"
          d="M 302.18 375.42 310.37 375.91 309.88 384.09 309.39 384.06 302.16 383.61 301.65 383.58 302.18 375.42 Z"
          data-name="Ector"
          data-stusps="TX"
          id="48135"
        />
        <path
          className="white"
          d="M 326.15 387.29 335.39 387.81 335.09 396.02 330.67 395.9 325.62 395.72 326.15 387.29 Z"
          data-name="Irion"
          data-stusps="TX"
          id="48235"
        />
        <path
          className="white"
          d="M 208.37 217.94 211.45 199.04 212.83 200.15 217.96 199.77 218.29 201.48 219.73 200.73 219.93 199.46 222.67 199.89 223.02 201.34 222.76 203.27 224.32 203.92 224.29 204.09 223.02 212.2 222.9 212.98 222.03 218.75 221.42 222.79 220.96 225.85 220.04 226.41 207.67 224.49 206.66 224.19 206.75 222.32 208.34 219.49 209.73 218.16 208.37 217.94 Z"
          data-name="Uintah"
          data-stusps="UT"
          id="49047"
        />
        <path
          className="white"
          d="M 603.57 369.5 609.24 368.91 609.58 372.2 609.68 373.15 606.61 373.51 605.86 373.06 604.31 372.92 604.45 371.72 604.45 371.38 603.57 369.5 Z"
          data-name="Crisp"
          data-stusps="GA"
          id="13081"
        />
        <path
          className="white"
          d="M 498.83 218.15 500.23 217.3 501.63 217.17 502.63 214.65 503.17 214.21 503.09 213.43 506.28 213.18 506.51 215.67 507.36 216.01 507.82 221.05 502.95 221.51 501.34 221.64 501.16 219.45 498.18 219.65 498.68 218.55 498.83 218.15 Z"
          data-name="Tazewell"
          data-stusps="IL"
          id="17179"
        />
        <path
          className="white"
          d="M 595.16 229.69 596.34 226.86 600.36 226.98 604.15 226.65 604.32 228.56 604.51 231.04 604.55 231.61 604.32 232.39 595.92 233.04 595.14 231.8 595.12 230.81 595.16 229.69 Z"
          data-name="Ross"
          data-stusps="OH"
          id="39141"
        />
        <path
          className="white"
          d="M 572.99 285.12 573.49 282.81 573.73 280.68 573.36 280.13 575.25 281.03 576.01 280.34 577.14 282.17 577.5 284.65 577.89 284.79 576.03 284.85 573.28 285.08 573.07 285.1 572.99 285.12 Z"
          data-name="Clinton"
          data-stusps="KY"
          id="21053"
        />
        <path
          className="white"
          d="M 218.05 244.65 228.14 246.08 228.58 242.91 241.56 244.64 240.68 251.55 238.68 251.29 231.37 249.76 231.85 251.29 233.98 252.27 233.39 253.47 217.36 251.23 217.39 251.01 217.43 248.88 218.05 244.65 Z"
          data-name="Montrose"
          data-stusps="CO"
          id="8085"
        />
        <path
          className="white"
          d="M 317.54 293.14 319.52 293.28 322.64 293.48 325.71 293.67 325.22 302.01 316.99 301.5 317.54 293.14 Z"
          data-name="Sherman"
          data-stusps="TX"
          id="48421"
        />
        <path
          className="white"
          d="M 445.85 213.4 452.39 213.21 452.58 219.11 452.03 219.15 449.03 219.28 448.61 219.29 446 219.38 445.85 213.4 Z"
          data-name="Wayne"
          data-stusps="IA"
          id="19185"
        />
        <path
          className="white"
          d="M 307.02 351.15 315.2 351.65 314.71 359.72 312.61 359.61 306.49 359.23 307.02 351.15 Z"
          data-name="Terry"
          data-stusps="TX"
          id="48445"
        />
        <path
          className="white"
          d="M 644.52 449.08 652.85 448.11 653.52 453.94 645.16 454.95 644.52 449.08 Z"
          data-name="Hardee"
          data-stusps="FL"
          id="12049"
        />
        <path
          className="white"
          d="M 616.26 205.92 616.83 205.85 616.53 202.21 619.16 201.14 621.24 201.09 621.45 202.7 622.27 202.6 622.5 204.27 622.62 205.09 622.95 207.55 622.1 207.68 622.33 209.38 618.19 209.93 617.84 207.15 616.44 207.33 616.26 205.92 Z"
          data-name="Tuscarawas"
          data-stusps="OH"
          id="39157"
        />
        <path
          className="white"
          d="M 490.47 187.02 495.99 186.59 499.22 186.32 499.62 191.36 493.41 191.82 492.99 191.83 493 191.67 493.16 190.57 492.84 189.89 492.78 189.76 492.73 188.52 492.03 187.76 491.14 187.34 490.47 187.02 Z"
          data-name="Carroll"
          data-stusps="IL"
          id="17015"
        />
        <path
          className="white"
          d="M 580.13 227.65 581.28 227.5 583.82 227.39 585.84 227.29 586.18 233.27 582.46 233.45 582.37 233.13 581.03 233.23 580.72 228.35 580.13 227.65 Z"
          data-name="Warren"
          data-stusps="OH"
          id="39165"
        />
        <path
          className="white"
          d="M 590.14 199.4 594.53 198.72 595.35 204.19 592.59 204.61 592.54 204.9 590.98 205.14 590.64 204.89 589.85 205.02 589.25 202.86 589.03 201.22 589.61 199.48 590.14 199.4 Z"
          data-name="Wyandot"
          data-stusps="OH"
          id="39175"
        />
        <path
          className="white"
          d="M 389.16 439.2 394.64 434.77 395.25 435.54 397 436.34 397.64 438.26 398.96 439.53 400.06 442.15 396.58 443.56 395.3 444.46 395.94 445.95 395.54 446.35 393.34 445.13 391.49 445.04 391.14 443.97 391.56 440.87 390.86 439.41 389.16 439.2 Z"
          data-name="Victoria"
          data-stusps="TX"
          id="48469"
        />
        <path
          className="white"
          d="M 606.05 332.13 606.59 332.73 608.08 332.79 610.45 333.85 610.05 334.6 610.58 335.49 610.47 336.03 608.74 336.94 607.28 335.06 606.89 334.87 606.45 334.86 604.46 333.47 606.05 332.13 Z"
          data-name="Oconee"
          data-stusps="GA"
          id="13219"
        />
        <path
          className="white"
          d="M 610.45 333.85 610.87 332.72 610.16 331.9 610.37 330.96 612.38 329.78 613.64 330.23 614.71 329.57 615.31 330.03 617.99 330.53 616.61 331.66 615.17 334.55 615.89 335.37 615.25 336.22 613.29 336.36 610.58 335.49 610.05 334.6 610.45 333.85 Z"
          data-name="Oglethorpe"
          data-stusps="GA"
          id="13221"
        />
        <path
          className="white"
          d="M 592.59 348.66 593.26 348.11 596.53 348.12 596.84 350.95 596.53 351.14 596.6 351.9 593.09 352.24 592.55 352.74 592.25 351.51 592.59 348.66 Z"
          data-name="Pike"
          data-stusps="GA"
          id="13231"
        />
        <path
          className="white"
          d="M 609.38 206.8 616.26 205.92 616.44 207.33 617.84 207.15 618.19 209.93 617.71 211.37 617.05 211.45 610.2 212.26 610.07 211.12 609.86 210.92 609.38 206.8 Z"
          data-name="Coshocton"
          data-stusps="OH"
          id="39031"
        />
        <path
          className="white"
          d="M 364.36 353.71 372.75 353.96 372.48 361.24 372.44 362.28 370.1 362.18 364.16 361.97 364.36 353.71 Z"
          data-name="Young"
          data-stusps="TX"
          id="48503"
        />
        <path
          className="white"
          d="M 604.77 340.72 607.33 342.17 607.73 347.16 603.52 348.42 603.32 347.52 603.53 347.25 602.25 344.04 602.7 342.66 604.97 341.44 604.77 340.72 Z"
          data-name="Jasper"
          data-stusps="GA"
          id="13159"
        />
        <path
          className="white"
          d="M 594.21 329.32 594.11 328.35 593.9 326.5 598.62 325.97 599.22 326.82 598.43 328.64 597.38 329 597.33 329.3 596.69 331.33 597.04 331.58 594.38 330.76 594.21 329.32 Z"
          data-name="Forsyth"
          data-stusps="GA"
          id="13117"
        />
        <path
          className="white"
          d="M 266.01 399.67 279.9 392.39 287.83 399.37 290.06 401.43 283.85 405.78 282.22 405.67 264.92 400.24 266.01 399.67 Z"
          data-name="Jeff Davis"
          data-stusps="TX"
          id="48243"
        />
        <path
          className="white"
          d="M 392.01 424.92 396.4 424.88 397.72 425.93 401.5 430.49 399.89 431.82 395.25 435.54 394.64 434.77 390.36 429.47 390.99 425.8 392.01 424.92 Z"
          data-name="Lavaca"
          data-stusps="TX"
          id="48285"
        />
        <path
          className="white"
          d="M 341.73 302.88 349.96 303.27 349.82 306.55 349.61 311.46 341.34 311.09 341.73 302.88 Z"
          data-name="Hemphill"
          data-stusps="TX"
          id="48211"
        />
        <path
          className="white"
          d="M 444.43 144.98 446.67 144.9 447.69 144.87 447.74 146.22 450.99 146.12 451.15 151.28 451.08 151.29 449.51 151.34 446.21 151.45 444.61 151.5 444.43 144.98 Z"
          data-name="Rice"
          data-stusps="MN"
          id="27131"
        />
        <path
          className="white"
          d="M 375.76 279.23 383.89 279.38 383.92 279.76 383.81 286.65 380.15 286.57 379.15 286.55 375.61 286.47 375.76 279.23 Z"
          data-name="Harper"
          data-stusps="KS"
          id="20077"
        />
        <path
          className="white"
          d="M 625.93 373.75 627.65 373.54 627.56 372.81 627.98 372.78 632.77 375.63 631.66 376.49 631.09 377.78 629.94 378.17 628.9 378.29 628.56 377.35 626.89 377.54 626.18 375.92 625.93 373.75 Z"
          data-name="Bacon"
          data-stusps="GA"
          id="13005"
        />
        <path
          className="white"
          d="M 534.16 259.69 537.44 259.45 537.58 261.91 538.12 263.78 537.58 264.09 536.6 264.08 535.8 264.65 535.61 265.56 534.78 265.56 534.26 265.09 534.42 264.77 534.16 259.69 Z"
          data-name="Vanderburgh"
          data-stusps="IN"
          id="18163"
        />
        <path
          className="white"
          d="M 307.23 342.93 315.54 343.47 315.2 351.65 307.02 351.15 307.23 342.93 Z"
          data-name="Hockley"
          data-stusps="TX"
          id="48219"
        />
        <path
          className="white"
          d="M 577.35 203.72 580.65 203.24 580.54 202.41 583.77 201.67 584.03 203.56 584.49 206.86 581.23 207.33 579.47 206.75 576.98 207.1 576.65 204.64 577.35 203.72 Z"
          data-name="Allen"
          data-stusps="OH"
          id="39003"
        />
        <path
          className="white"
          d="M 401.29 315.7 401.38 312.39 407.93 312.43 407.93 314.06 409.53 314.06 409.53 317.35 411.16 317.35 411.16 318.98 404.09 318.95 404.11 315.62 402.63 317.05 401.3 316.86 401.29 315.7 Z"
          data-name="Okfuskee"
          data-stusps="OK"
          id="40107"
        />
        <path
          className="white"
          d="M 446.9 287.98 446.88 286.61 450.99 286.57 451.57 289.85 451.56 295.83 449.87 295.87 447.49 295.92 447.51 289.9 446.92 289.9 446.9 287.98 Z"
          data-name="Stone"
          data-stusps="MO"
          id="29209"
        />
        <path
          className="white"
          d="M 715.74 179.93 716.65 179.39 718 178.58 718.9 179.57 719 180.52 719.77 179.84 720.61 179.74 720.69 179.98 720.56 180.72 720.1 181.25 719.37 182.03 720.67 183.28 720.32 183.71 719.21 185.12 718.91 186.09 718.83 185.9 717.43 186.43 716.82 185.6 715.67 184.05 716.57 182.45 715.74 179.93 Z"
          data-name="Somerset"
          data-stusps="NJ"
          id="34035"
        />
        <path
          className="white"
          d="M 454.73 278.54 454.72 277.18 457.98 277.15 460.47 277.11 460.75 284.88 458.66 284.92 457.48 284.92 457.35 284.64 455.03 284.66 455 281.91 454.76 281.26 454.73 278.54 Z"
          data-name="Webster"
          data-stusps="MO"
          id="29225"
        />
        <path
          className="white"
          d="M 387.24 61.36 389.39 61.42 396.15 61.56 396.15 62.59 396.63 64.07 397.03 65.86 397.4 66.98 397.65 67.84 397.09 69.41 397.01 70.16 397.01 70.22 387.29 69.96 387.1 66.67 387.24 61.36 Z"
          data-name="Pembina"
          data-stusps="ND"
          id="38067"
        />
        <path
          className="white"
          d="M 689.13 223.53 689.54 223.76 690.21 223.35 690.41 224.29 690.43 224.41 688.81 224.35 689.13 223.53 Z"
          data-name="Alexandria"
          data-stusps="VA"
          id="51510"
        />
        <path
          className="white"
          d="M 621 279.58 620.57 279.64 619.51 279.79 620.39 279.04 621.36 278.68 620.99 277.98 621.51 278.5 621.51 278.82 621 279.58 Z"
          data-name="Bristol"
          data-stusps="VA"
          id="51520"
        />
        <path
          className="white"
          d="M 659.34 251.04 660.02 250.58 660.16 250.88 659.63 251.91 659.61 251.31 659.34 251.04 Z"
          data-name="Buena Vista"
          data-stusps="VA"
          id="51530"
        />
        <path
          className="white"
          d="M 691.05 254.91 691.04 254.94 691.02 254.95 691 254.97 690.98 254.98 690.97 255 690.92 255 690.92 255 690.89 255.01 690.88 255.03 690.8 254.49 690.48 254.25 691.26 253.93 691.36 253.64 691.51 253.93 691.31 254.26 691.36 254.74 691.05 254.91 Z"
          data-name="Colonial Heights"
          data-stusps="VA"
          id="51570"
        />
        <path
          className="white"
          d="M 437.03 240.69 437.04 239.33 443.57 239.24 443.72 245.2 442.52 245.06 440.38 246.29 440.48 245.29 439.86 246.26 438.69 246.49 437.66 245.19 437.09 245.33 437.03 240.69 Z"
          data-name="Ray"
          data-stusps="MO"
          id="29177"
        />
        <path
          className="white"
          d="M 688.02 222.78 688.43 223.04 688.31 223.12 688.07 223.06 687.82 223.12 687.73 222.99 687.76 222.81 687.67 222.74 687.76 222.78 688.02 222.78 Z"
          data-name="Falls Church"
          data-stusps="VA"
          id="51610"
        />
        <path
          className="white"
          d="M 633.22 297.61 642.19 296.66 642.56 296.95 642.56 297.74 642.73 298.36 642.7 299.43 634.88 300.24 633.57 297.76 633.2 297.69 633.22 297.61 Z"
          data-name="Lincoln"
          data-stusps="NC"
          id="37109"
        />
        <path
          className="white"
          d="M 450.36 352.55 450.4 346 450.57 343.53 451.16 343.67 451.87 343.49 453.72 345.85 456.16 346.76 456.14 352.84 454.49 353.12 452.22 353.1 450.36 353.09 450.36 352.55 Z"
          data-name="Nevada"
          data-stusps="AR"
          id="5099"
        />
        <path
          className="white"
          d="M 684.26 225.96 683.97 225.85 683.98 225.7 684.47 225.96 684.85 225.89 684.61 226.34 684.26 225.96 Z"
          data-name="Manassas Park"
          data-stusps="VA"
          id="51685"
        />
        <path
          className="white"
          d="M 546.34 201.51 551.87 200.86 552.08 202.52 554.03 203.09 554.11 203.92 550.95 204.33 551.13 205.95 546.86 206.42 546.34 201.51 Z"
          data-name="Fulton"
          data-stusps="IN"
          id="18049"
        />
        <path
          className="white"
          d="M 384.01 272.86 385.64 272.87 385.66 269.57 393.83 269.68 393.7 277.88 383.91 277.73 384.01 272.86 Z"
          data-name="Sedgwick"
          data-stusps="KS"
          id="20173"
        />
        <path
          className="white"
          d="M 662.51 241.76 663.12 241.48 663.34 242.46 662.98 242.97 661.91 242.51 662.51 241.76 Z"
          data-name="Staunton"
          data-stusps="VA"
          id="51790"
        />
        <path
          className="white"
          d="M 216.61 256.36 219.93 256.84 228.4 257.74 228.92 259.23 232.3 258.99 234.02 260.77 233.71 261.75 232.21 262.05 232.05 263.12 227.82 262.69 217.82 261.33 215.52 263.83 216.61 256.36 Z"
          data-name="Dolores"
          data-stusps="CO"
          id="8033"
        />
        <path
          className="white"
          d="M 739.6 156.15 740 155.52 739.89 155.08 742.21 154.11 742.74 153.87 743.63 154.9 744.46 155.88 746.03 155.56 746.72 157.03 744.96 157.79 746.04 158.46 747.09 160.17 746.97 160.21 746.51 160.66 746.15 160.43 745.24 160.86 744.44 161.42 742.91 160.31 741.76 158.41 741.42 158.6 740.52 159.07 740.14 157.65 739.84 156.79 739.6 156.15 Z"
          data-name="Middlesex"
          data-stusps="CT"
          id="9007"
        />
        <path
          className="white"
          d="M 553.14 359.08 555.41 358.9 554.99 354.89 554.94 354.48 559.25 354.13 560.81 354.93 560.98 356.65 562.12 357.8 562.12 358.74 563.52 359.76 562.92 359.87 562.99 360.69 558.2 361.14 558.29 361.97 555.03 362.2 553.43 362.35 553.33 361.1 553.14 359.08 Z"
          data-name="Chilton"
          data-stusps="AL"
          id="1021"
        />
        <path
          className="white"
          d="M 132.05 123.33 135.19 124.14 135.38 124.46 138.12 129.14 138.33 129.26 137.27 133.52 136.03 138.24 132.06 137.26 130.8 135.31 130.74 133.29 129.54 133.04 130.88 130.01 131.74 126.72 131.2 126.58 132.05 123.33 Z"
          data-name="Ada"
          data-stusps="ID"
          id="16001"
        />
        <path
          className="white"
          d="M 372.75 353.96 372.77 352.64 379.72 352.79 379.71 353.42 380.67 353.43 380.45 361.54 378.33 361.46 372.48 361.24 372.75 353.96 Z"
          data-name="Jack"
          data-stusps="TX"
          id="48237"
        />
        <path
          className="white"
          d="M 560.81 354.93 560.79 353.65 561.09 353.35 566.11 352.86 568.7 352.61 568.75 352.88 569.17 357.99 569.38 359.2 564.41 359.68 564.11 359.43 563.52 359.76 562.12 358.74 562.12 357.8 560.98 356.65 560.81 354.93 Z"
          data-name="Coosa"
          data-stusps="AL"
          id="1037"
        />
        <path
          className="white"
          d="M 522.99 207.1 531.59 206.07 531.8 208.23 532.08 211.21 532.44 214.99 532.51 215.83 526.66 216.47 524.03 216.66 523.98 216.12 522.99 207.1 Z"
          data-name="Iroquois"
          data-stusps="IL"
          id="17075"
        />
        <path
          className="white"
          d="M 418.1 279.72 424.58 279.69 424.79 280.51 424.86 286.89 421.12 286.92 419.83 286.92 418.11 286.93 418.1 279.72 Z"
          data-name="Labette"
          data-stusps="KS"
          id="20099"
        />
        <path
          className="white"
          d="M 476.36 299.58 478.27 299.55 478.2 297.91 479.9 297.87 479.82 294.83 480.48 294.81 482.59 297.01 482.93 299.19 481.58 299.76 481.76 306.15 480.12 306.19 480.1 305.36 476.32 305.43 476.71 304.31 476.36 299.58 Z"
          data-name="Sharp"
          data-stusps="AR"
          id="5135"
        />
        <path
          className="white"
          d="M 590.98 205.14 592.54 204.9 592.59 204.61 595.35 204.19 598.98 203.61 599.12 204.72 597.75 205.13 598.14 207.86 597.4 209.07 594.1 209.35 593.94 208.28 593.65 208.21 591.48 208.55 591.46 208.15 590.98 205.14 Z"
          data-name="Marion"
          data-stusps="OH"
          id="39101"
        />
        <path
          className="white"
          d="M 569.72 365.53 572.34 364.23 571.78 363.95 573.2 363.79 573.02 362.16 574.63 361.72 578.11 363.27 578.93 363.18 579.16 364.82 579.49 368.13 572.72 368.83 571.91 367.51 571.96 368.08 571.63 368.12 570.37 367.07 569.72 365.53 Z"
          data-name="Macon"
          data-stusps="AL"
          id="1087"
        />
        <path
          className="white"
          d="M 612.5 305.84 613.82 305.16 614.89 303.01 617.15 305 618.2 307.88 616.57 308.52 615.74 309.51 615.5 309.49 615.16 309.46 613.45 310.26 613.45 310.26 611.8 311.03 610.98 310.62 611.93 309 612.5 305.84 Z"
          data-name="Transylvania"
          data-stusps="NC"
          id="37175"
        />
        <path
          className="white"
          d="M 571.44 209.97 571.07 207.04 576.02 206.4 576.13 207.21 576.43 209.41 576.72 211.6 576.93 213.25 577.26 213.39 577.26 213.39 571.94 214.1 571.94 214.1 571.69 211.98 571.61 211.3 571.44 209.97 Z"
          data-name="Mercer"
          data-stusps="OH"
          id="39107"
        />
        <path
          className="white"
          d="M 575.33 351.92 581.05 351.33 582.25 355.74 582.29 355.91 582.73 356.52 583.46 357.88 580.94 358.53 576.3 358.89 576.03 359.06 575.33 351.92 Z"
          data-name="Chambers"
          data-stusps="AL"
          id="1017"
        />
        <path
          className="white"
          d="M 374.65 244.74 382.83 244.96 382.73 249.86 382.7 251.49 374.54 251.29 374.68 246.72 374.6 246.37 374.65 244.74 Z"
          data-name="Lincoln"
          data-stusps="KS"
          id="20105"
        />
        <path
          className="white"
          d="M 493.23 404.16 498.81 403.9 498.92 406.22 499.34 408.01 500.6 409.55 500.46 410.84 499.42 412.42 498.79 412.21 498.13 412 497.15 412.91 494.81 410.31 493.79 409.86 493.03 409.49 492.07 407.74 492.07 405.44 493.23 404.16 Z"
          data-name="Livingston"
          data-stusps="LA"
          id="22063"
        />
        <path
          className="white"
          d="M 572.99 127.71 572.12 121.22 578.69 120.11 579.8 121.23 580.8 123.25 579.77 123.13 578.9 122.71 578.39 123.16 578.62 124.1 578.75 125.22 580.06 126.07 580.51 126.11 580.63 126.51 572.99 127.72 572.99 127.71 Z"
          data-name="Alpena"
          data-stusps="MI"
          id="26007"
        />
        <path
          className="white"
          d="M 573.95 180.92 577.2 180.51 582.19 179.6 583.31 186.33 581.66 186.63 578.1 187.26 574.93 187.81 573.95 180.92 Z"
          data-name="Lenawee"
          data-stusps="MI"
          id="26091"
        />
        <path
          className="white"
          d="M 89.42 219.81 95.1 230.72 90.43 250.36 89.49 248.95 84.31 241.19 82.51 238.49 80.29 235.16 75.55 228.01 76.7 228.35 89.42 219.81 Z"
          data-name="Esmeralda"
          data-stusps="NV"
          id="32009"
        />
        <path
          className="white"
          d="M 394.52 361.98 395.16 361.99 395.32 361.99 395.66 362 397.47 362.05 398.11 362.07 401.11 362.14 402.64 362.18 402.59 365.35 402.58 365.68 402.49 370.01 402.39 370.37 394.3 370.24 394.37 367.53 394.38 367.2 394.4 366.29 394.42 365.79 394.43 365.22 394.52 361.98 Z"
          data-name="Dallas"
          data-stusps="TX"
          id="48113"
        />
        <path
          className="white"
          d="M 423.82 195.67 428.7 195.64 428.77 200.52 429.38 200.51 429.41 202.35 424.61 202.39 424.59 200.57 423.86 200.57 423.82 195.67 Z"
          data-name="Audubon"
          data-stusps="IA"
          id="19009"
        />
        <path
          className="white"
          d="M 366.79 237.95 374.62 238.21 374.88 238.22 374.65 244.74 374.6 246.37 366.6 246.11 366.45 246.1 366.79 237.95 Z"
          data-name="Osborne"
          data-stusps="KS"
          id="20141"
        />
        <path
          className="white"
          d="M 366.76 229.79 371.67 229.95 373.3 230 374.88 230.05 374.62 238.21 366.79 237.95 366.47 237.93 366.76 229.79 Z"
          data-name="Smith"
          data-stusps="KS"
          id="20183"
        />
        <path
          className="white"
          d="M 679.59 270.84 682.51 270.26 683.83 270 686.08 269.56 686.23 270.33 686.49 272.68 685.68 276.37 684.17 276.53 683.57 275.91 680.83 276.04 681.14 275.19 679.59 270.84 Z"
          data-name="Warren"
          data-stusps="NC"
          id="37185"
        />
        <path
          className="white"
          d="M 374.26 60.92 375.88 60.98 387.24 61.36 387.1 66.67 387.29 69.96 382.41 69.8 374.27 69.49 374.4 66.23 374.04 66.21 374.26 60.92 Z"
          data-name="Cavalier"
          data-stusps="ND"
          id="38019"
        />
        <path
          className="white"
          d="M 321.62 102.11 332.36 103.01 332.95 103.06 332.5 109.58 333.02 111.1 326.51 110.56 326.62 109.11 321.06 108.66 321.62 102.11 Z"
          data-name="Hettinger"
          data-stusps="ND"
          id="38041"
        />
        <path
          className="white"
          d="M 554.03 203.09 556.16 202.83 557.74 202.59 558.42 203.36 559.26 209.91 556.03 210.32 554.96 210.45 554.11 203.92 554.03 203.09 Z"
          data-name="Wabash"
          data-stusps="IN"
          id="18169"
        />
        <path
          className="white"
          d="M 472.04 212.39 471.83 207.47 475.1 207.32 476.74 207.26 476.82 208.9 477.05 213.8 476.52 213.83 472.11 214.03 472.04 212.39 Z"
          data-name="Henry"
          data-stusps="IA"
          id="19087"
        />
        <path
          className="white"
          d="M 498.5 397.33 498.81 397.32 502.05 397.15 502.15 398.93 502.65 399.18 503.81 402.48 504.07 403.74 504.19 406.39 504.33 409.06 505.8 411.38 503.14 410.3 500.46 410.84 500.6 409.55 499.34 408.01 498.92 406.22 498.81 403.9 498.65 400.62 498.5 397.33 Z"
          data-name="Tangipahoa"
          data-stusps="LA"
          id="22105"
        />
        <path
          className="white"
          d="M 479.98 366.8 480.97 363.23 482.91 360.79 482.91 360.32 485.63 360.23 484.97 361.56 484.59 365.05 483.76 366.17 483.84 367.73 483.1 368.28 480.7 368.37 480.63 366.78 479.98 366.8 Z"
          data-name="West Carroll"
          data-stusps="LA"
          id="22123"
        />
        <path
          className="white"
          d="M 560.59 317.52 567.54 316.92 571.56 316.55 571.83 317.68 572.15 318.86 569.45 323.62 566.13 326.67 565.48 326.84 565.03 327.07 564.79 326.22 563.84 324.66 563.3 324.71 561.23 324.9 561.19 324.9 561.06 324.92 561.06 324.92 560.5 324.35 560.47 318.56 561.53 318.45 560.59 317.52 Z"
          data-name="Jackson"
          data-stusps="AL"
          id="1071"
        />
        <path
          className="white"
          d="M 554.11 203.92 554.96 210.45 556.03 210.32 556.23 211.93 554.08 212.2 551.91 212.47 551.13 205.95 550.95 204.33 554.11 203.92 Z"
          data-name="Miami"
          data-stusps="IN"
          id="18103"
        />
        <path
          className="white"
          d="M 546.74 231.3 549.52 231.03 551.35 230.24 551.49 230.22 552.6 230.07 553.16 235.57 551.27 235.81 547.9 236.15 547.61 236.05 547.41 234.28 546.57 233.82 546.93 231.96 546.74 231.3 Z"
          data-name="Morgan"
          data-stusps="IN"
          id="18109"
        />
        <path
          className="white"
          d="M 374.09 277.55 374.22 272.64 384.01 272.86 383.91 277.73 383.89 279.38 375.76 279.23 374.04 279.18 374.09 277.55 Z"
          data-name="Kingman"
          data-stusps="KS"
          id="20095"
        />
        <path
          className="white"
          d="M 651.11 260.97 651.75 260.33 653.34 260.91 652.56 262.58 651.09 261.86 651.11 260.97 Z"
          data-name="Roanoke"
          data-stusps="VA"
          id="51161"
        />
        <path
          className="white"
          d="M 419.81 213.74 426.31 213.71 426.35 216.96 426.57 219.82 424.37 219.8 422.46 219.79 420.55 219.78 420 219.77 420.03 216.99 419.81 213.74 Z"
          data-name="Page"
          data-stusps="IA"
          id="19145"
        />
        <path
          className="white"
          d="M 426.31 213.71 432.83 213.65 432.92 219.81 432.02 219.83 430.62 219.83 427.93 219.83 426.57 219.82 426.35 216.96 426.31 213.71 Z"
          data-name="Taylor"
          data-stusps="IA"
          id="19173"
        />
        <path
          className="white"
          d="M 391.03 243.5 391.13 238.6 397.08 238.7 396.96 245.2 396.95 246.49 396.92 246.84 390.96 246.76 391.03 243.5 Z"
          data-name="Clay"
          data-stusps="KS"
          id="20027"
        />
        <path
          className="white"
          d="M 350.56 237.28 358.31 237.63 358.69 237.64 358.3 245.8 350.37 245.45 350.13 245.44 350.56 237.28 Z"
          data-name="Graham"
          data-stusps="KS"
          id="20065"
        />
        <path
          className="white"
          d="M 342.04 253.17 348.52 253.53 348.17 261.71 341.65 261.35 342.04 253.17 Z"
          data-name="Lane"
          data-stusps="KS"
          id="20101"
        />
        <path
          className="white"
          d="M 391.35 133.78 394.91 133.84 399.46 133.94 399.44 137.19 399.36 140.43 391.25 140.3 391.35 133.78 Z"
          data-name="Codington"
          data-stusps="SD"
          id="46029"
        />
        <path
          className="white"
          d="M 410.43 89.92 416.97 89.9 417.01 90.23 417.03 96.45 410.42 96.44 410.43 89.92 Z"
          data-name="Mahnomen"
          data-stusps="MN"
          id="27087"
        />
        <path
          className="white"
          d="M 335.56 252.8 340.11 253.07 342.04 253.17 341.65 261.35 335.46 261 335.13 260.98 335.56 252.8 Z"
          data-name="Scott"
          data-stusps="KS"
          id="20171"
        />
        <path
          className="white"
          d="M 342.44 236.85 350.28 237.27 350.56 237.28 350.13 245.44 341.98 245.01 342.44 236.85 Z"
          data-name="Sheridan"
          data-stusps="KS"
          id="20179"
        />
        <path
          className="white"
          d="M 469.21 295.26 469.67 295.25 471.7 295.16 476.45 294.95 476.9 294.93 479.82 294.83 479.9 297.87 478.2 297.91 478.27 299.55 476.36 299.58 469.28 299.71 469.24 299.39 469.21 295.26 Z"
          data-name="Fulton"
          data-stusps="AR"
          id="5049"
        />
        <path
          className="white"
          d="M 385.08 326.87 396.45 327.05 396.4 331.13 392.25 331.34 393.09 333.53 389.86 333.48 386.6 333.43 386.64 330.16 385.01 330.13 385.08 326.87 Z"
          data-name="Garvin"
          data-stusps="OK"
          id="40049"
        />
        <path
          className="white"
          d="M 442.99 300.97 443.25 299.61 444.07 299.61 446.46 299.62 447.08 301.51 448.16 302.9 449.25 302.89 449.78 303.71 449.76 305.84 448.69 307.47 448.81 309.69 446.1 309.65 442.96 309.61 442.82 309.89 442.02 309.88 442.19 303.68 442.99 300.97 Z"
          data-name="Madison"
          data-stusps="AR"
          id="5087"
        />
        <path
          className="white"
          d="M 416.09 362.63 421.72 362.57 422.95 362.57 423.87 362.57 424.19 361.6 424.23 361.79 424.21 363.68 424.23 368.21 424.23 369.91 424.04 370.39 421.39 369.28 420.1 369.24 419.22 369.27 417.22 367.75 416.58 367.12 416.09 362.63 Z"
          data-name="Wood"
          data-stusps="TX"
          id="48499"
        />
        <path
          className="white"
          d="M 429.55 355 429.99 355.83 430.53 355.64 431.4 355.94 432.03 356.75 432.09 364.04 431.27 364.06 431.04 363.58 430.26 363.19 429.45 362.13 429.55 355 Z"
          data-name="Morris"
          data-stusps="TX"
          id="48343"
        />
        <path
          className="white"
          d="M 384.98 217.25 391.5 217.38 391.38 223.91 384.89 223.78 384.84 223.78 384.98 217.25 Z"
          data-name="Fillmore"
          data-stusps="NE"
          id="31059"
        />
        <path
          className="white"
          d="M 417.22 367.75 419.22 369.27 420.1 369.24 421.39 369.28 424.04 370.39 424.23 369.91 426.43 370.41 426.51 370.9 426.88 370.5 426.92 373.62 426.96 377.98 419.39 378.07 419.09 377.86 418.93 376.26 419.55 373.96 417.23 371.63 417.22 367.75 Z"
          data-name="Smith"
          data-stusps="TX"
          id="48423"
        />
        <path
          className="white"
          d="M 403.59 373.88 407.66 373.97 409.58 373.92 419.55 373.96 418.93 376.26 419.09 377.86 419.39 378.07 419.9 379.03 409.93 380.51 409.9 380.38 409.1 379.21 408.45 376.65 407.64 376.74 404.69 374.44 403.6 374.14 403.59 373.88 Z"
          data-name="Henderson"
          data-stusps="TX"
          id="48213"
        />
        <path
          className="white"
          d="M 687.94 152.94 689.47 152.6 691.64 151.93 692.81 155.07 695.57 154.3 695.83 155.3 697.99 154.77 698.9 154.55 700 157.96 700.67 158.14 699 158.44 698.91 158.46 697.93 158.71 693.46 159.81 690.15 160.61 690.02 159.99 689.77 159.19 689.33 155.64 687.94 152.94 Z"
          data-name="Broome"
          data-stusps="NY"
          id="36007"
        />
        <path
          className="white"
          d="M 675.37 223.7 675.86 222.92 680.68 223.34 680.19 225.49 680.96 226.53 682.09 227.92 684.03 230.28 682.85 232.29 683.05 233.36 681.54 233.62 679.93 231.64 678.77 230.79 677.85 228.76 677.48 228.86 676.53 228.77 675.68 227.3 673.94 226.24 674.85 225.53 675.37 223.7 Z"
          data-name="Fauquier"
          data-stusps="VA"
          id="51061"
        />
        <path
          className="white"
          d="M 409.21 413.86 409.6 413.77 413.91 413.48 413.93 416.39 413.25 416.41 411.37 415.02 413.56 422.04 411.19 423.16 410.18 423.17 409.91 421.76 408.74 421.13 408.72 418.66 409.34 417.98 408.34 416.76 407.6 415.48 408.14 414.2 409.21 413.86 Z"
          data-name="Waller"
          data-stusps="TX"
          id="48473"
        />
        <path
          className="white"
          d="M 396.33 336.83 397.14 336.83 397.18 333.59 398.01 333.6 402.87 333.65 402.86 335.26 404.52 335.29 404.49 340.18 403.76 340.99 401.71 340.97 401.16 340.07 396.29 339.83 396.33 336.83 Z"
          data-name="Johnston"
          data-stusps="OK"
          id="40069"
        />
        <path
          className="white"
          d="M 408.02 402.66 412.96 401.9 413.49 406.28 413.91 413.48 409.6 413.77 409.21 413.86 409.2 412.28 408.22 411.89 408.34 410.9 409.44 410.02 408.76 409.77 407.69 406.86 408.02 402.66 Z"
          data-name="Grimes"
          data-stusps="TX"
          id="48185"
        />
        <path
          className="white"
          d="M 419.31 318.86 420.24 318.26 420.95 318.9 422.55 319.47 423.62 318.57 425.45 315.77 426.13 316.59 427.74 316.89 427.55 317.84 429.1 318.27 429.12 320.54 427.37 320.55 427.39 323.26 420.9 323.3 420.88 321.4 419.26 321.4 419.31 318.86 Z"
          data-name="Haskell"
          data-stusps="OK"
          id="40061"
        />
        <path
          className="white"
          d="M 427.39 323.26 427.37 320.55 429.12 320.54 429.1 318.27 430.07 317.63 431.34 318.78 432.47 318.15 434.05 318.62 434.92 317 434.96 317.33 434.93 319.09 434.87 323.09 434.83 325.5 434.82 326.32 434.78 329.35 434.76 331.11 434.73 333.5 427.34 333.59 427.31 330.33 425.42 330.35 425.39 327.08 426.35 327.08 426.33 325.45 427.42 325.44 427.39 323.26 Z"
          data-name="Le Flore"
          data-stusps="OK"
          id="40079"
        />
        <path
          className="white"
          d="M 539.39 370.14 537.45 369.02 537.61 367.94 540.31 365.88 540.75 365.61 540.97 365.97 542.31 365.87 542.37 366.69 545.63 366.42 545.89 369.71 546.71 369.64 546.79 370.44 546.11 370.47 546.18 372.99 544.55 373.12 544.75 375.51 544.05 375.83 537.54 376.33 536.88 376.08 538.34 372.58 538.01 370.72 539.39 370.14 Z"
          data-name="Marengo"
          data-stusps="AL"
          id="1091"
        />
        <path
          className="white"
          d="M 624.88 215.67 630.96 214.99 630.95 215.04 631.09 215.91 630.56 216.74 631.2 217.49 631.31 217.61 630.95 218.63 629.99 219.87 628.84 221.4 628.74 220.76 625.04 220.72 624.76 218.81 623.77 215.83 624.88 215.67 Z"
          data-name="Monroe"
          data-stusps="OH"
          id="39111"
        />
        <path
          className="white"
          d="M 532.1 352.19 532.23 347.54 537.42 347.33 539.08 347.19 539.67 354.17 537.71 355.75 534.9 356.73 534.6 357.53 531.94 357.81 532.04 354.16 532.1 352.19 Z"
          data-name="Pickens"
          data-stusps="AL"
          id="1107"
        />
        <path
          className="white"
          d="M 642.51 210.35 644.08 209.02 644.45 207.9 643.76 207.32 645.66 206.94 648.04 207.4 649.73 205.87 650.44 206.41 651.84 207.45 652.53 207.36 651.4 211.23 652.55 212.43 651.94 213.45 652.24 213.66 651.02 213.9 646.83 214.68 644.61 215.08 643.81 211.32 642.51 210.35 Z"
          data-name="Fayette"
          data-stusps="PA"
          id="42051"
        />
        <path
          className="white"
          d="M 652.42 235.71 654.13 236.14 655.44 237.78 657.13 238.06 658.04 238.06 658.2 238.73 656.85 242.24 655.86 243.11 652.83 242.86 651.32 242.23 651.44 242.1 651.05 241.37 651.94 240.38 652.36 238.84 652.23 238.24 652.39 237.29 652.42 235.71 Z"
          data-name="Highland"
          data-stusps="VA"
          id="51091"
        />
        <path
          className="white"
          d="M 624.56 225.78 624.9 225.78 626.21 224.71 627 223.79 627.79 223.3 627.87 223.13 629.17 222.71 629.87 224.86 626.87 226.19 626.73 226.99 624.74 226.3 624.56 225.78 Z"
          data-name="Pleasants"
          data-stusps="WV"
          id="54073"
        />
        <path
          className="white"
          d="M 505.84 342.4 508.34 342.83 512.44 342.58 512.61 345.31 512.67 346.14 508.27 346.43 502.91 346.73 502.73 345.9 502.64 344.25 505.92 343.79 505.84 342.4 Z"
          data-name="Grenada"
          data-stusps="MS"
          id="28043"
        />
        <path
          className="white"
          d="M 493.07 350.02 492.99 348.39 494.64 348.31 494.31 341.34 497.54 341.21 497.7 344.48 498.14 353.52 496.53 353.61 496.59 354.71 494.05 354.85 493.3 354.88 493.07 350.02 Z"
          data-name="Sunflower"
          data-stusps="MS"
          id="28133"
        />
        <path
          className="white"
          d="M 626.73 226.99 626.87 226.19 629.87 224.86 631.29 224.09 631.79 225.64 631.49 226.1 633.5 228.94 631.02 231.29 630.56 231.37 628.94 230.95 628.6 231.28 627.29 231.41 626.12 228.69 626.44 227.06 626.73 226.99 Z"
          data-name="Ritchie"
          data-stusps="WV"
          id="54085"
        />
        <path
          className="white"
          d="M 631.79 225.64 633.93 222.63 635.25 222.01 635.76 221.9 636.4 222.23 636.81 223.5 635.99 224.98 637.4 226.59 636.5 227.3 635.21 229.01 634.79 228.99 633.5 228.94 631.49 226.1 631.79 225.64 Z"
          data-name="Doddridge"
          data-stusps="WV"
          id="54017"
        />
        <path
          className="white"
          d="M 634.79 228.99 635.21 229.01 636.5 227.3 637.44 227.52 641.06 227.74 641.29 230.53 640.54 232.29 640.55 234.36 640.93 235.09 639.94 235.03 639.39 233.3 637.69 233.09 637.21 232.29 635.24 230.6 634.79 228.99 Z"
          data-name="Lewis"
          data-stusps="WV"
          id="54041"
        />
        <path
          className="white"
          d="M 641.61 222.01 643.24 221.86 645.19 220.21 645.9 220.41 646.35 222.99 644.65 224.3 642.57 224.78 641.99 224.33 641.61 222.01 Z"
          data-name="Taylor"
          data-stusps="WV"
          id="54091"
        />
        <path
          className="white"
          d="M 574.38 187.9 574.93 187.81 578.1 187.26 581.66 186.63 582.24 191.01 575.75 191.94 575.68 191.4 575.13 191.48 574.86 189.55 574.38 187.9 Z"
          data-name="Fulton"
          data-stusps="OH"
          id="39051"
        />
        <path
          className="white"
          d="M 598.14 363.57 598.99 362.93 600.14 360.63 601.77 360.3 601.65 360.61 604.48 361.02 604.8 362.5 604.5 362.66 604.83 364.38 604.08 364.44 602.21 366.96 600.45 366.89 599.61 366.13 598.98 366.17 598.27 365.01 598.14 363.57 Z"
          data-name="Macon"
          data-stusps="GA"
          id="13193"
        />
        <path
          className="white"
          d="M 454.25 310.2 457.51 310.18 459.68 310.16 459.72 313.41 459.19 315.04 459.29 320.47 458.59 320.56 458.29 320.46 456.67 320.78 456.11 321.61 455.89 320.58 452.71 318.05 452.38 317.78 452.36 315.1 453.47 315.1 453.44 312.65 454.26 312.66 454.25 310.2 Z"
          data-name="Pope"
          data-stusps="AR"
          id="5115"
        />
        <path
          className="white"
          d="M 591.67 361.16 592.54 361.29 594.71 360.31 594.62 360.85 595.84 363.02 596.12 365.22 595.62 366.52 595.74 367.76 595.79 368.37 594.25 368.53 592.09 366.88 591.93 366.9 591.43 361.95 591.67 361.16 Z"
          data-name="Marion"
          data-stusps="GA"
          id="13197"
        />
        <path
          className="white"
          d="M 595.84 363.02 595.98 362.73 598.14 363.57 598.27 365.01 598.98 366.17 599.61 366.13 599.72 367.48 595.74 367.76 595.62 366.52 596.12 365.22 595.84 363.02 Z"
          data-name="Schley"
          data-stusps="GA"
          id="13249"
        />
        <path
          className="white"
          d="M 488.84 161.48 490.47 161.35 490.69 164.63 490.94 168.68 489.99 168.12 489.28 168 488.73 167.98 487.65 168.21 486.05 168.12 484.43 168.97 484.11 164.25 483.92 161.82 488.84 161.48 Z"
          data-name="Richland"
          data-stusps="WI"
          id="55103"
        />
        <path
          className="white"
          d="M 459.68 310.16 462.41 310.15 462.39 308.79 465.64 308.72 465.67 310.08 468.39 310.06 468.44 316.6 464.93 316.63 464.9 315 459.19 315.04 459.72 313.41 459.68 310.16 Z"
          data-name="Van Buren"
          data-stusps="AR"
          id="5141"
        />
        <path
          className="white"
          d="M 462.02 371.43 464.49 371.36 464.45 370.55 467.74 370.47 467.79 372.11 469.49 373.69 469.52 374.5 469.6 376.97 461.57 377.18 462.19 375.5 462.02 371.43 Z"
          data-name="Jackson"
          data-stusps="LA"
          id="22049"
        />
        <path
          className="white"
          d="M 707.84 265.86 708.84 266.5 712.4 267.66 712.93 269.02 714.48 269.37 716.38 271.07 716.73 272.23 716.25 272.65 714.79 273.38 714.29 272.5 712.08 270.69 710.64 270.29 708.95 268.27 708.01 266.66 707.84 265.86 Z"
          data-name="Pasquotank"
          data-stusps="NC"
          id="37139"
        />
        <path
          className="white"
          d="M 701.05 251.49 701.81 251.6 701.94 252.1 702.24 252.34 700.98 252.15 701.05 251.49 Z"
          data-name="Williamsburg"
          data-stusps="VA"
          id="51830"
        />
        <path
          className="white"
          d="M 706.32 254.59 706.88 254.43 706.91 254.2 707.07 254.08 708.44 253.74 708.9 254.23 708.83 254.87 708.73 255.92 708.88 256.04 708.47 257.5 707.71 257.14 706.55 256.04 706.32 254.59 Z"
          data-name="Hampton"
          data-stusps="VA"
          id="51650"
        />
        <path
          className="white"
          d="M 469.57 289.69 469.82 289.6 469.73 284.76 476.26 284.63 476.35 287.63 476.19 289.54 476.45 294.95 471.7 295.16 469.67 295.25 469.57 289.69 Z"
          data-name="Howell"
          data-stusps="MO"
          id="29091"
        />
        <path
          className="white"
          d="M 679.43 152.25 680.96 151.83 679.51 150.71 682.43 150.11 685.09 149.38 686.24 153.4 686.78 155.48 684.37 155.63 684.61 156.67 682.82 156.72 681.68 156.97 680.66 157.18 679.43 152.25 Z"
          data-name="Tompkins"
          data-stusps="NY"
          id="36109"
        />
        <path
          className="white"
          d="M 278.46 225.21 279.37 224.49 279.9 224.67 280.27 223.76 281.68 223.07 281.62 223.62 281.59 223.9 281.59 223.9 281.59 223.9 281.14 224.46 281.01 224.44 281.04 224.2 280.77 224.18 280.1 225.38 278.43 225.64 278.46 225.21 Z"
          data-name="Broomfield"
          data-stusps="CO"
          id="8014"
        />
        <path
          className="white"
          d="M 370.67 313.48 375.43 313.6 375.45 316.87 378.68 316.94 378.5 326.74 370.36 326.53 370.48 321.98 370.52 321.62 370.63 315.11 370.67 313.48 Z"
          data-name="Caddo"
          data-stusps="OK"
          id="40015"
        />
        <path
          className="white"
          d="M 367.03 331.33 367.17 326.44 370.36 326.53 378.5 326.74 378.56 327.07 378.49 330 377.68 329.98 377.6 333.25 376.01 333.21 375.18 334.28 371.92 334.73 369.47 334.94 369.53 333.03 366.98 332.96 367.03 331.33 Z"
          data-name="Comanche"
          data-stusps="OK"
          id="40031"
        />
        <path
          className="white"
          d="M 477.53 270.65 480.81 270.53 480.86 272.17 483.21 272.1 483.28 274.16 480.93 274.18 480.98 275.83 482.53 275.81 482.6 277.44 476.08 277.61 474.46 277.65 474.32 274.37 473.51 274.41 473.39 270.8 477.53 270.65 Z"
          data-name="Dent"
          data-stusps="MO"
          id="29065"
        />
        <path
          className="white"
          d="M 489.88 279.78 492.65 279.6 492.61 278.75 497.6 278.51 497.78 282.81 499.47 282.72 499.51 283.56 498.94 283.58 498.43 284.52 497.42 285.93 496 285.92 491.08 286.2 490.19 283.93 489.44 283.96 489.36 282.31 489.96 281.74 489.88 279.78 Z"
          data-name="Wayne"
          data-stusps="MO"
          id="29223"
        />
        <path
          className="white"
          d="M 265.89 255.23 276.97 256.53 276.31 262.97 274.74 260.84 272.78 262.92 272.38 262.12 269.96 262.69 268.45 261.18 267.44 257.66 265.89 255.23 Z"
          data-name="Custer"
          data-stusps="CO"
          id="8027"
        />
        <path
          className="white"
          d="M 459.72 289.82 469.57 289.69 469.67 295.25 469.21 295.26 466.18 295.38 463.47 295.47 462.94 295.49 459.79 295.6 459.72 289.82 Z"
          data-name="Ozark"
          data-stusps="MO"
          id="29153"
        />
        <path
          className="white"
          d="M 479.36 397.79 480.38 397.76 481.2 398.08 481.12 399.41 480.9 400.71 482.61 400.86 481.62 399.6 482.68 399.59 483.25 400.34 482.93 401.92 482.07 402.73 482.75 403.07 484.41 402.9 485.53 402.43 486.41 404.28 486.76 404.42 485.16 407.09 484.02 407.4 482.43 407.47 480.51 407.53 479.62 407.55 480.01 407.28 479.56 406.34 479.84 403.72 478.42 401.02 478.5 398.63 479.36 397.79 Z"
          data-name="Pointe Coupee"
          data-stusps="LA"
          id="22077"
        />
        <path
          className="white"
          d="M 271.12 224.07 275.14 224.46 275.1 224.87 274.76 228.01 273.35 227.63 270.74 225.56 270.68 224.8 271.12 224.07 Z"
          data-name="Gilpin"
          data-stusps="CO"
          id="8047"
        />
        <path
          className="white"
          d="M 258.96 233.54 261.02 234.02 262.21 233.59 263.25 233.71 262.39 234.95 262.16 238.2 261.56 238.77 261.74 239.7 256.06 239 256.53 237.19 257.32 237.07 257.71 234.6 258.96 233.54 Z"
          data-name="Lake"
          data-stusps="CO"
          id="8065"
        />
        <path
          className="white"
          d="M 354.45 399.5 360.79 399.69 360.87 400.05 362.84 400.12 362.63 408.04 357.11 407.86 354.18 407.77 354.32 403.81 354.45 399.5 Z"
          data-name="Mason"
          data-stusps="TX"
          id="48319"
        />
        <path
          className="white"
          d="M 344.92 369.45 353.12 369.8 353.13 369.91 352.82 378.04 351.5 377.97 344.5 377.7 344.92 369.45 Z"
          data-name="Taylor"
          data-stusps="TX"
          id="48441"
        />
        <path
          className="white"
          d="M 353.13 369.91 353.41 369.92 361.32 370.18 361 378.34 359.77 378.31 352.82 378.04 353.13 369.91 Z"
          data-name="Callahan"
          data-stusps="TX"
          id="48059"
        />
        <path
          className="white"
          d="M 348.04 353.14 356.2 353.42 355.93 361.7 353.71 361.63 347.75 361.34 348.04 353.14 Z"
          data-name="Haskell"
          data-stusps="TX"
          id="48207"
        />
        <path
          className="white"
          d="M 385.42 302.32 388.68 302.38 390.04 302.41 390.3 302.51 390.26 305.78 390.73 305.3 392.54 306.56 393.5 306.63 393.44 310.71 385.29 310.55 385.42 302.32 Z"
          data-name="Logan"
          data-stusps="OK"
          id="40083"
        />
        <path
          className="white"
          d="M 378.68 316.94 380.83 317.58 382.26 317.32 382.7 317.82 383.65 317.65 385.19 317.86 385.04 326.54 385.08 326.87 385.01 330.13 378.49 330 378.56 327.07 378.5 326.74 378.68 316.94 Z"
          data-name="Grady"
          data-stusps="OK"
          id="40051"
        />
        <path
          className="white"
          d="M 431.38 368.31 431.42 372.63 433.38 373.11 433.19 373.66 426.92 373.62 426.88 370.5 426.88 370.5 429.51 369.48 430.67 368.03 431.38 368.31 Z"
          data-name="Gregg"
          data-stusps="TX"
          id="48183"
        />
        <path
          className="white"
          d="M 698 143.77 698.42 142.86 698.05 141.21 698.51 140.92 698.64 141.36 699.91 139.99 703.01 140.86 703.03 139.38 704.81 139.63 706.57 139.84 706.69 141.39 707.82 143.6 707.23 145.94 705.41 146.52 701.22 150.69 698.38 152.29 698.49 150.33 697.62 148.58 698.33 146.8 698 143.77 Z"
          data-name="Otsego"
          data-stusps="NY"
          id="36077"
        />
        <path
          className="white"
          d="M 689.81 244.25 690.9 241.64 691.87 241.8 692.04 241.66 693.47 243.56 694.78 244.58 696.66 244.73 699.3 246.93 699.23 247.68 697.88 247.69 697.98 246.71 696.17 247.33 693.78 246.65 691.84 245.33 690.37 245.24 689.81 244.25 Z"
          data-name="King William"
          data-stusps="VA"
          id="51101"
        />
        <path
          className="white"
          d="M 122.26 36.81 122.61 36.95 123.86 37.02 125.29 38.59 125.81 37.95 127.23 38.6 127.28 39.6 129.17 41.23 129.87 40.19 131.34 39.64 131.77 39.73 132.63 42.95 135.36 42.81 135.99 43.44 132.82 53.95 131.09 53.43 118.18 49.45 122.26 36.81 Z"
          data-name="Lincoln"
          data-stusps="WA"
          id="53043"
        />
        <path
          className="white"
          d="M 618.18 379.53 623.03 379.28 623.55 379.96 626.62 379.6 626.82 381.29 625.68 381.37 626.34 383.1 621.46 383.68 620.23 383.83 620.24 382.08 618.18 379.53 Z"
          data-name="Atkinson"
          data-stusps="GA"
          id="13003"
        />
        <path
          className="white"
          d="M 135.99 43.44 137.71 43.33 139.4 45.08 140.77 40.36 142.02 40.74 146.94 42.22 146.58 43.48 145.28 47.99 143.32 54.87 142.76 56.86 132.82 53.95 135.99 43.44 Z"
          data-name="Spokane"
          data-stusps="WA"
          id="53063"
        />
        <path
          className="white"
          d="M 579.14 319.89 580.33 318.77 581.26 315.47 581.3 315.46 583.1 315.25 583.89 315.16 583.99 317.27 583.26 319.21 583.63 320.55 582.45 321.26 583.02 322.01 582.86 322.37 580.91 322.47 580.7 320.63 578.87 320.82 579.14 319.89 Z"
          data-name="Whitfield"
          data-stusps="GA"
          id="13313"
        />
        <path
          className="white"
          d="M 380.77 455.35 380.61 456.48 382.53 456.84 382.79 457.5 383.4 457.82 383.88 457.36 384.21 458.01 384.99 457.98 385.94 457.91 388.41 457.56 388.03 458.16 389.85 457.7 390.87 458.7 391.26 458.43 390.9 458.67 391.76 457.2 392.45 456.21 393.29 458.49 393.27 458.53 392.5 459.43 391.65 460.71 390.43 462.95 390.25 463.32 388.54 463.6 379.94 463.52 378.26 462.04 378.48 457.38 380.77 455.35 Z"
          data-name="Nueces"
          data-stusps="TX"
          id="48355"
        />
        <path
          className="white"
          d="M 647.85 224.06 649.51 222.96 652.72 223.86 655.32 223.1 655.04 225.55 655.93 225.65 655.43 227.86 653.17 228.08 648.87 227.65 648.02 226.27 647.77 226.02 647.85 224.06 Z"
          data-name="Tucker"
          data-stusps="WV"
          id="54093"
        />
        <path
          className="white"
          d="M 330.37 402.96 344.07 403.46 343.77 411.33 334.26 410.99 330.02 410.81 330.37 402.96 Z"
          data-name="Sutton"
          data-stusps="TX"
          id="48435"
        />
        <path
          className="white"
          d="M 726.08 111.44 726.37 109.98 727.27 110.06 727.57 108.44 727.74 106.91 729.85 106.91 729.66 105.09 730.43 105.2 731.41 105.33 733.12 104.62 734.94 104.73 735.49 105.73 735.37 107.17 735.33 107.27 735.33 107.28 735.05 108.14 735.44 108.9 735.01 110.58 735.2 111.86 735.02 112.64 731.27 112.43 729.53 112.24 727.47 112.07 726.53 112.08 726.43 111.79 726.08 111.44 Z"
          data-name="Orange"
          data-stusps="VT"
          id="50017"
        />
        <path
          className="white"
          d="M 381.21 400.86 384.49 401.56 389.45 403.83 390.19 404.16 391.98 409.39 389.06 410.38 388.49 410.06 384.84 408.47 381.94 409.75 381.14 409.31 380.56 408.55 380.44 407.55 379.03 405.99 377.52 406.04 378.99 403.04 381.21 400.86 Z"
          data-name="Williamson"
          data-stusps="TX"
          id="48491"
        />
        <path
          className="white"
          d="M 63.25 197.07 64.48 195.76 64.94 192.02 65.98 192.49 67.45 191.83 71.55 191.77 67.17 196.38 63.26 197.07 63.25 197.07 Z"
          data-name="Storey"
          data-stusps="NV"
          id="32029"
        />
        <path
          className="white"
          d="M 490.82 223.13 490.48 216.53 490.4 214.89 496.95 214.52 497.02 216.15 498.67 216.06 498.83 218.15 498.68 218.55 498.18 219.65 496.63 220.9 495.64 223.6 494.54 224.64 490.9 224.78 490.82 223.13 Z"
          data-name="Fulton"
          data-stusps="IL"
          id="17057"
        />
        <path
          className="white"
          d="M 474.98 253.58 474.87 246.9 474.86 245.23 478.09 245.17 480.26 245.12 480.34 247.88 480.48 250.67 478.26 250.76 478.34 253.3 476.32 254.02 475.08 253.57 474.98 253.58 Z"
          data-name="Montgomery"
          data-stusps="MO"
          id="29139"
        />
        <path
          className="white"
          d="M 616.05 370.57 619.85 365.25 620 365.58 620.77 366.55 623.61 367.68 625.06 369.12 624.84 369.05 622.21 371.44 621.77 372.15 619.71 372.42 617.32 372.06 616.62 371.5 616.1 370.86 616.05 370.57 Z"
          data-name="Telfair"
          data-stusps="GA"
          id="13271"
        />
        <path
          className="white"
          d="M 613.57 387.51 616.52 387.27 618.11 387.12 618.42 387.25 618.58 388.51 620.82 388.3 621.42 390.11 620.3 390.26 620.09 390.65 619.69 391.46 619.99 394.61 617.14 394.74 616.34 394.77 614.04 392.73 614.45 391.52 616.06 390.65 614.38 389.68 613.57 387.51 Z"
          data-name="Lowndes"
          data-stusps="GA"
          id="13185"
        />
        <path
          className="white"
          d="M 660.46 322.19 665.27 317.31 666.3 316.99 666.71 317.06 667.24 317.12 668.27 318.11 668.04 319.07 669.2 320.57 669.5 322.54 673.16 325.74 670.5 326.64 668.16 326.19 667.37 326.57 664.14 325.52 663.03 325.69 662.39 324.61 663.55 323.62 663.35 323.37 661.67 322.75 661.2 322.33 660.46 322.19 Z"
          data-name="Florence"
          data-stusps="SC"
          id="45041"
        />
        <path
          className="white"
          d="M 449.2 103.05 459.01 102.7 459.22 104.59 459.36 107.74 459.42 109.21 449.52 109.57 449.4 106.57 449.3 106.3 449.22 104.72 449.2 103.05 Z"
          data-name="Carlton"
          data-stusps="MN"
          id="27017"
        />
        <path
          className="white"
          d="M 689.75 311.95 690.1 311.59 691.93 312.05 693.43 313.69 695.24 317.23 694.99 318.59 694.86 319.62 694.69 320.97 693.93 321 693.64 320.47 691.67 320.35 689.46 320.74 687.78 321.24 685.45 322.65 684.05 321.62 683.39 321.16 683.34 319.9 684.5 318.68 684.41 317.04 684.81 316.58 686.36 316.82 686.91 315.44 688.77 314.89 689.75 311.95 Z"
          data-name="Brunswick"
          data-stusps="NC"
          id="37019"
        />
        <path
          className="white"
          d="M 416.57 80.12 421.03 80.11 420.43 81.89 421.5 82.88 421.71 91.51 421.9 93.15 421.93 96.4 417.03 96.45 417.01 90.23 416.97 89.9 416.97 86.64 416.65 86.64 416.59 81.75 416.57 80.12 Z"
          data-name="Clearwater"
          data-stusps="MN"
          id="27029"
        />
        <path
          className="white"
          d="M 421.71 91.51 426.6 91.51 428.25 91.48 428.56 102.87 426.91 102.89 422.07 102.93 421.93 96.4 421.9 93.15 421.71 91.51 Z"
          data-name="Hubbard"
          data-stusps="MN"
          id="27057"
        />
        <path
          className="white"
          d="M 566.95 312.48 569.02 312.42 569.35 310.98 571.62 310.17 574.22 311.73 574.62 313.14 575.11 314.51 573.59 316.36 571.56 316.55 567.54 316.92 567.12 312.7 566.95 312.48 Z"
          data-name="Marion"
          data-stusps="TN"
          id="47115"
        />
        <path
          className="white"
          d="M 366.38 254.3 374.42 254.55 374.5 254.94 374.41 257.84 374.28 262.73 367.88 262.53 366.11 262.47 366.16 260.83 366.38 254.3 Z"
          data-name="Barton"
          data-stusps="KS"
          id="20009"
        />
        <path
          className="white"
          d="M 306.98 102.38 310.15 102.71 310.32 101.03 312.79 101.28 317.68 101.75 321.62 102.11 321.06 108.66 320.14 108.59 306.47 107.27 306.55 106.44 306.92 102.96 306.98 102.38 Z"
          data-name="Slope"
          data-stusps="ND"
          id="38087"
        />
        <path
          className="white"
          d="M 492.84 415.13 493.59 414.23 498.01 413.03 497.36 415.51 498.01 418.24 495.99 417.72 494.25 418.11 493.76 416.75 493.2 416.79 492.84 415.13 Z"
          data-name="St. James"
          data-stusps="LA"
          id="22093"
        />
        <path
          className="white"
          d="M 558.71 142.98 561.9 142.61 565.2 142.18 566.12 148.65 559.56 149.57 558.71 142.98 Z"
          data-name="Clare"
          data-stusps="MI"
          id="26035"
        />
        <path
          className="white"
          d="M 593.45 289.51 593.78 289.19 593.93 287.21 594.45 287.14 594.61 286.5 596.1 286.01 597.42 287.58 598.42 287.47 598.11 290.78 597.86 290.99 595.23 291.39 594.61 290.98 593.58 289.84 593.45 289.51 Z"
          data-name="Union"
          data-stusps="TN"
          id="47173"
        />
        <path
          className="white"
          d="M 545.24 206.58 546.86 206.42 551.13 205.95 551.91 212.47 548.91 212.83 548.66 210.36 546.49 210.6 545.59 209.87 545.24 206.58 Z"
          data-name="Cass"
          data-stusps="IN"
          id="18017"
        />
        <path
          className="white"
          d="M 485.15 208.54 490.07 208.34 490.4 214.89 490.48 216.53 485.55 216.67 485.15 208.54 Z"
          data-name="Warren"
          data-stusps="IL"
          id="17187"
        />
        <path
          className="white"
          d="M 604.21 285.75 606.34 283.18 607.9 282.01 608.87 282.28 610.57 281.07 613.93 280.57 614.12 282.01 612.88 283.41 613.27 283.81 612.99 284.26 609.61 286.18 607.62 288.23 606.13 286.44 604.86 287.69 604.12 286.07 604.21 285.75 Z"
          data-name="Hawkins"
          data-stusps="TN"
          id="47073"
        />
        <path
          className="white"
          d="M 456.49 322.37 462.83 322.19 463.96 321.45 463.36 323.7 464.22 324.46 461.01 325.34 461.01 326.08 461.26 326.42 456.09 326.48 456.11 328.1 452.82 328.16 452.5 326.25 456.49 322.37 Z"
          data-name="Perry"
          data-stusps="AR"
          id="5105"
        />
        <path
          className="white"
          d="M 483.91 216.7 485.55 216.67 490.48 216.53 490.82 223.13 484.2 223.36 483.91 216.7 Z"
          data-name="McDonough"
          data-stusps="IL"
          id="17109"
        />
        <path
          className="white"
          d="M 580.16 158.04 583.39 157.52 584.46 163.95 581.22 164.6 581.5 166.25 578.24 166.77 577.2 160.17 576.92 158.53 580.16 158.04 Z"
          data-name="Genesee"
          data-stusps="MI"
          id="26049"
        />
        <path
          className="white"
          d="M 512.61 345.31 517.52 345 517.54 344.69 520.01 344.51 520.11 346.1 520.41 346.64 520.48 347.82 519.39 347.9 519.42 348.44 516.72 348.89 514.9 350.1 512.92 350.23 512.67 346.14 512.61 345.31 Z"
          data-name="Webster"
          data-stusps="MS"
          id="28155"
        />
        <path
          className="white"
          d="M 446.53 278.52 453.09 278.55 454.73 278.54 454.76 281.26 455 281.91 455.03 284.66 446.85 284.69 446.83 281.28 446.52 281.25 446.53 278.52 Z"
          data-name="Greene"
          data-stusps="MO"
          id="29077"
        />
        <path
          className="white"
          d="M 689.65 282.23 690.99 282.75 691.86 284.54 692.88 285.4 692.41 285.94 691.08 287.5 690.76 287.57 689.96 287.71 687.21 288.03 686.99 288.28 686.15 288.14 685.04 286.13 684.5 285.89 684.73 285.67 688.41 283.07 689.5 282.84 689.65 282.23 Z"
          data-name="Wilson"
          data-stusps="NC"
          id="37195"
        />
        <path
          className="white"
          d="M 532.67 294.18 535.13 294.45 536.68 293.57 538.56 293.42 538.68 293.9 539.81 293.93 539.79 295.56 539.25 296.95 538.93 296.61 535.61 295.99 533.31 296.21 533.36 295.81 532.67 294.18 Z"
          data-name="Houston"
          data-stusps="TN"
          id="47083"
        />
        <path
          className="white"
          d="M 312.08 367.79 312.21 367.8 320.39 368.23 319.84 376.44 318.55 376.38 311.59 375.99 312.08 367.79 Z"
          data-name="Martin"
          data-stusps="TX"
          id="48317"
        />
        <path
          className="white"
          d="M 690.86 266.06 690.7 265.33 691.42 265.13 691.55 265.76 691.34 266.01 690.86 266.06 Z"
          data-name="Emporia"
          data-stusps="VA"
          id="51595"
        />
        <path
          className="white"
          d="M 609.86 249.46 609.88 249.3 609.84 248.01 609.37 247.52 609.3 246.84 609.22 246.06 609.76 246.32 610.5 246.01 613.26 247.71 614.07 247.29 614.65 248.97 614.62 250.66 616.25 252.26 614.83 254.45 613.6 256.19 613.74 256.56 613.35 256.05 612.2 255.36 612.26 254.93 612.37 254.18 610.87 252.73 609.53 251.55 609.76 250.24 609.86 249.46 Z"
          data-name="Wayne"
          data-stusps="WV"
          id="54099"
        />
        <path
          className="white"
          d="M 679.39 138.73 682.38 137.81 683.32 138.07 682.9 137.06 685.04 137.91 686.28 137.93 687.11 138.69 686.96 139.6 687.79 139.5 689.45 144.98 684.29 146.63 682.79 145.43 681.51 145.81 680.22 142.95 679.39 138.73 Z"
          data-name="Onondaga"
          data-stusps="NY"
          id="36067"
        />
        <path
          className="white"
          d="M 566.74 203.96 570.6 203.38 571.07 207.04 571.07 207.04 571.44 209.97 567.63 210.53 566.74 203.96 Z"
          data-name="Adams"
          data-stusps="IN"
          id="18001"
        />
        <path
          className="white"
          d="M 577.08 336.61 579.82 336.38 582.37 336.01 582.59 336.14 582.75 337.73 582.74 339.59 579.09 341.16 578.33 341.22 577.75 339.09 577.08 336.61 Z"
          data-name="Haralson"
          data-stusps="GA"
          id="13143"
        />
        <path
          className="white"
          d="M 399.36 140.43 399.44 137.19 405.12 137.24 405.11 140.47 405.1 143.74 405.09 145.39 399.29 145.32 399.36 140.43 Z"
          data-name="Deuel"
          data-stusps="SD"
          id="46039"
        />
        <path
          className="white"
          d="M 489.36 117.24 499.09 116.4 499.15 117.17 500.81 117.11 500.7 116.31 502.42 116.24 503.12 124.33 498.92 124.57 498.12 124.69 497.94 123.04 489.82 123.66 489.36 117.24 Z"
          data-name="Oneida"
          data-stusps="WI"
          id="55085"
        />
        <path
          className="white"
          d="M 551.48 195.08 551.57 195.89 552.2 200.76 551.87 200.86 546.34 201.51 545.81 196.59 545.72 195.77 551.48 195.08 Z"
          data-name="Marshall"
          data-stusps="IN"
          id="18099"
        />
        <path
          className="white"
          d="M 465.25 207.77 468.58 207.61 471.83 207.47 472.04 212.39 465.47 212.7 465.25 207.77 Z"
          data-name="Jefferson"
          data-stusps="IA"
          id="19101"
        />
        <path
          className="white"
          d="M 567.49 135.22 573.99 134.24 574.99 140.75 571.17 141.31 568.45 141.72 567.49 135.22 Z"
          data-name="Ogemaw"
          data-stusps="MI"
          id="26129"
        />
        <path
          className="white"
          d="M 418.23 260.03 418.21 255.13 418.32 254.32 424.85 254.28 424.72 255.1 424.76 260.82 418.23 260.85 418.23 260.03 Z"
          data-name="Franklin"
          data-stusps="KS"
          id="20059"
        />
        <path
          className="white"
          d="M 396.15 61.56 399.84 61.64 406.34 61.71 406.31 67.02 406.5 70.27 397.01 70.16 397.09 69.41 397.65 67.84 397.4 66.98 397.03 65.86 396.63 64.07 396.15 62.59 396.15 61.56 Z"
          data-name="Kittson"
          data-stusps="MN"
          id="27069"
        />
        <path
          className="white"
          d="M 583.98 221.59 583.79 218.54 591.4 218.07 590.99 222.76 590.12 222.8 587.41 222.7 585.69 222.05 584.02 222.15 583.98 221.59 Z"
          data-name="Clark"
          data-stusps="OH"
          id="39023"
        />
        <path
          className="white"
          d="M 566.19 311.3 566.7 309.52 566.31 306.82 567.22 307.1 570.45 306.25 572.57 308.41 571.62 310.17 569.35 310.98 569.02 312.42 566.95 312.48 566.19 311.3 Z"
          data-name="Grundy"
          data-stusps="TN"
          id="47061"
        />
        <path
          className="white"
          d="M 622.44 232.37 624.41 229.93 626.12 228.69 627.29 231.41 628.6 231.28 627.27 233.33 627.25 233.75 626.34 234.27 624.66 233.65 623.93 234.23 623.23 232.65 622.44 232.37 Z"
          data-name="Wirt"
          data-stusps="WV"
          id="54105"
        />
        <path
          className="white"
          d="M 551.56 269.52 552.67 268.29 554.3 269.2 556.26 268.49 558.73 268.73 559.96 270.83 560.5 271.83 559.9 272.77 558.53 273.16 558.07 273.11 553.88 273.91 553.53 273.16 551.59 272.73 550.5 269.77 551.56 269.52 Z"
          data-name="Grayson"
          data-stusps="KY"
          id="21085"
        />
        <path
          className="white"
          d="M 489.44 239.81 489.42 238.64 489.78 237.41 493.84 237.19 495.99 237.06 496.38 241.9 494 242.74 494.07 243.7 490.15 243.73 489.89 245.01 489.7 244.56 489.98 243.48 489.44 239.81 Z"
          data-name="Greene"
          data-stusps="IL"
          id="17061"
        />
        <path
          className="white"
          d="M 512.07 396.59 513.27 396.52 515.73 396.13 516.99 396.69 518.2 396.09 518.35 396.37 518.44 397.97 518.72 402.9 515.42 403.07 515.56 405.54 513.9 405.9 513.09 406.86 512.86 406.43 511.5 405.11 510.92 403.4 510.82 402.94 510.6 401.85 511.23 400.06 511.81 398.29 512.07 396.59 Z"
          data-name="Pearl River"
          data-stusps="MS"
          id="28109"
        />
        <path
          className="white"
          d="M 356.2 353.42 364.36 353.71 364.16 361.97 361.87 361.9 355.93 361.7 356.2 353.42 Z"
          data-name="Throckmorton"
          data-stusps="TX"
          id="48447"
        />
        <path
          className="white"
          d="M 253.43 153.67 259.23 154.5 259.49 154.69 273.34 156.46 273.35 156.88 271.69 169.92 270.91 176.4 262.85 175.43 250.76 173.74 250.52 173.57 251.39 167.18 251.97 167.26 252.88 160.75 253.59 154.24 253.43 153.67 Z"
          data-name="Natrona"
          data-stusps="WY"
          id="56025"
        />
        <path
          className="white"
          d="M 554.5 258.14 555.23 255.31 554.94 252.86 558.24 252.6 558.42 254.23 559.72 255.49 559.82 256.84 560.76 256.86 560.76 258.17 560.67 259.74 560.26 260.05 559.92 260.3 559.63 260.57 559.14 261.02 558.13 260.39 556.46 260.32 555.23 258.99 554.5 258.14 Z"
          data-name="Harrison"
          data-stusps="IN"
          id="18061"
        />
        <path
          className="white"
          d="M 476.82 208.9 482.77 208.6 482.78 208.66 482.92 209.6 482.89 210.83 482.46 211.64 481.67 212.51 481.03 213.44 481.09 214.21 480.8 215.25 480.79 215.74 479.49 215.54 476.52 213.83 477.05 213.8 476.82 208.9 Z"
          data-name="Des Moines"
          data-stusps="IA"
          id="19057"
        />
        <path
          className="white"
          d="M 524.07 352.79 526.34 352.62 532.1 352.19 532.04 354.16 531.94 357.81 531.9 358.99 524.53 359.56 524.07 352.79 Z"
          data-name="Noxubee"
          data-stusps="MS"
          id="28103"
        />
        <path
          className="white"
          d="M 647.93 282.27 647.88 281.89 654.29 280.91 654.59 283.02 654.94 285.6 652.27 285.73 652.36 286.31 649.65 287.21 648.31 285.69 647.86 286.07 647.52 284.91 648.45 284.16 648.31 282.66 647.93 282.27 Z"
          data-name="Forsyth"
          data-stusps="NC"
          id="37067"
        />
        <path
          className="white"
          d="M 600.78 282.27 603.76 281.9 608.22 281.36 610.57 281.07 608.87 282.28 607.9 282.01 606.34 283.18 604.21 285.75 603.86 285.92 602.54 285.62 602.69 284.71 602.06 283.34 600.78 282.27 Z"
          data-name="Hancock"
          data-stusps="TN"
          id="47067"
        />
        <path
          className="white"
          d="M 302.22 147.41 310.38 148.2 324.77 149.46 324.79 148.27 325.71 145.59 326.31 145.15 326.65 143.78 327.88 144.28 328.93 144.2 330.53 142.91 329.72 152.59 329.16 157.95 328.93 158.3 327.51 157.97 327 158.18 318.35 157.49 320.08 155.54 320.28 154.47 301.68 152.81 302.22 147.41 Z"
          data-name="Pennington"
          data-stusps="SD"
          id="46103"
        />
        <path
          className="white"
          d="M 280.1 225.38 280.77 224.18 281.04 224.2 281.01 224.44 281.14 224.46 281.59 223.9 288.41 224.58 293.32 225.04 299.75 225.62 299.3 230.53 299.3 230.53 299.15 230.52 299.06 230.51 299.05 230.51 299.04 230.51 299.03 230.51 299.03 230.51 298.99 230.51 298.86 230.49 298.78 230.49 298.58 230.47 298.57 230.47 298.57 230.47 298.53 230.46 298.36 230.45 298.34 230.45 298.08 230.42 298.04 230.42 298.01 230.41 298.01 230.41 298.01 230.41 297.99 230.41 297.99 230.41 297.98 230.41 297.98 230.41 297.98 230.41 297.98 230.41 297.97 230.41 297.97 230.41 297.97 230.41 297.97 230.41 297.95 230.41 297.9 230.4 297.89 230.4 297.85 230.4 297.78 230.39 297.78 230.39 297.68 230.38 297.65 230.38 297.59 230.37 297.54 230.37 297.52 230.37 297.52 230.37 297.45 230.36 297.4 230.36 297.26 230.34 297.22 230.34 297.2 230.34 297.2 230.34 297.15 230.33 296.99 230.32 296.98 230.32 296.98 230.32 296.85 230.31 296.84 230.3 296.66 230.28 296.5 230.27 296.5 230.27 296.39 230.26 296.22 230.24 296.06 230.23 296.05 230.23 295.98 230.22 295.91 230.22 295.91 230.22 295.83 230.21 295.68 230.19 295.63 230.19 295.55 230.18 295.45 230.18 295.43 230.18 295.42 230.18 295.42 230.18 295.41 230.18 295.41 230.18 295.4 230.18 295.4 230.18 295.39 230.17 295.39 230.17 295.38 230.17 295.37 230.17 295.36 230.17 295.3 230.17 295.3 230.17 295.29 230.17 295.27 230.16 295.26 230.16 295.23 230.16 295.22 230.16 295.02 230.14 295.02 230.14 295 230.14 295 230.14 295 230.14 294.99 230.14 294.91 230.13 294.86 230.13 294.74 230.12 294.74 230.12 294.73 230.12 294.73 230.12 294.73 230.12 294.73 230.12 294.68 230.11 294.68 230.11 294.66 230.11 294.65 230.11 294.65 230.11 294.65 230.11 294.65 230.11 294.62 230.11 294.59 230.1 294.59 230.1 294.55 230.1 294.55 230.1 294.55 230.1 294.55 230.1 294.55 230.1 294.55 230.1 294.55 230.1 294.54 230.1 294.54 230.1 294.54 230.1 294.54 230.1 294.54 230.1 294.54 230.1 294.54 230.1 294.54 230.1 294.54 230.1 294.54 230.1 294.54 230.1 294.54 230.1 294.54 230.1 294.54 230.1 294.54 230.1 294.54 230.1 294.54 230.1 294.54 230.1 294.54 230.1 294.54 230.1 294.54 230.1 294.54 230.1 294.54 230.1 294.54 230.1 294.54 230.1 294.54 230.1 294.53 230.1 294.53 230.1 294.53 230.1 294.53 230.1 294.53 230.1 294.53 230.1 294.47 230.09 294.46 230.09 294.46 230.09 294.46 230.09 294.45 230.09 294.31 230.08 294.18 230.07 294.17 230.07 294.13 230.06 294.13 230.06 294.09 230.06 294.08 230.06 294.06 230.06 294.06 230.06 294.02 230.05 294.02 230.05 294.02 230.05 294.02 230.05 294.02 230.05 294.02 230.05 294.01 230.05 294.01 230.05 293.91 230.04 293.91 230.04 293.85 230.04 293.78 230.03 293.77 230.03 293.73 230.03 293.71 230.03 293.69 230.02 293.65 230.02 293.65 230.02 293.65 230.02 293.64 230.02 293.64 230.02 293.64 230.02 293.64 230.02 293.64 230.02 293.64 230.02 293.63 230.02 293.59 230.02 293.59 230.02 293.53 230.01 293.52 230.01 293.52 230.01 293.5 230.01 293.41 230 293.41 230 293.38 230 293.38 230 293.36 230 293.36 230 293.2 229.98 293.2 229.98 293.18 229.98 293.1 229.97 293.1 229.97 293 229.97 292.99 229.96 292.99 229.96 292.93 229.96 292.9 229.96 292.82 229.95 292.82 229.95 292.73 229.94 292.69 229.94 292.55 229.93 292.55 229.93 292.51 229.92 292.28 229.91 292.28 229.91 292.22 229.9 292.14 229.89 292.13 229.89 292.13 229.89 292.08 229.89 292.01 229.88 292 229.88 292 229.88 291.8 229.86 291.8 229.86 291.79 229.86 291.76 229.86 291.76 229.86 291.75 229.86 291.75 229.86 291.74 229.86 291.74 229.86 291.73 229.86 291.73 229.86 291.71 229.86 291.6 229.85 291.52 229.84 291.46 229.83 291.46 229.83 291.45 229.83 291.4 229.83 291.4 229.83 291.34 229.82 291.2 229.81 291.2 229.81 291.2 229.81 291.2 229.81 291.18 229.81 291.17 229.81 291.17 229.81 291.16 229.81 291.13 229.8 291.13 229.8 291.04 229.8 291.04 229.8 291.04 229.8 291.03 229.8 291.03 229.8 290.96 229.79 290.96 229.79 290.93 229.79 290.92 229.79 290.9 229.78 290.9 229.78 290.88 229.78 290.87 229.78 290.83 229.78 290.83 229.78 290.79 229.77 290.78 229.77 290.72 229.77 290.72 229.77 290.7 229.77 290.69 229.77 290.68 229.77 290.67 229.77 290.67 229.77 290.66 229.77 290.66 229.77 290.65 229.77 290.65 229.77 290.65 229.77 290.65 229.76 290.64 229.76 290.59 229.76 290.56 229.76 290.52 229.75 290.52 229.75 290.48 229.75 290.48 229.75 290.46 229.75 290.45 229.75 290.43 229.75 290.43 229.75 290.42 229.75 290.4 229.74 290.39 229.74 290.38 229.74 290.38 229.74 290.36 229.74 290.36 229.74 290.36 229.74 290.35 229.74 290.35 229.74 290.35 229.74 290.35 229.74 290.35 229.74 290.35 229.74 290.35 229.74 290.34 229.74 290.33 229.74 290.33 229.74 290.31 229.74 290.31 229.74 290.3 229.73 290.3 229.73 290.3 229.73 290.3 229.73 290.3 229.73 290.3 229.73 290.29 229.73 290.29 229.73 290.29 229.73 290.29 229.73 290.27 229.73 290.26 229.73 290.24 229.73 290.24 229.73 290.24 229.73 290.23 229.73 290.22 229.73 290.22 229.73 290.21 229.73 290.2 229.73 290.18 229.72 290.16 229.72 290.11 229.72 290.1 229.72 290.1 229.72 290.1 229.72 289.97 229.71 289.84 229.69 289.84 229.69 289.81 229.69 289.63 229.67 289.63 229.67 289.57 229.67 289.57 229.67 289.55 229.67 289.53 229.67 289.53 229.67 289.52 229.66 289.49 229.66 289.49 229.66 289.49 229.66 289.49 229.66 289.49 229.66 289.49 229.66 289.49 229.66 289.49 229.66 289.49 229.66 289.48 229.66 289.48 229.66 289.48 229.66 289.48 229.66 289.47 229.66 289.46 229.66 289.45 229.66 289.44 229.66 289.43 229.66 289.42 229.66 289.4 229.65 289.35 229.65 289.31 229.65 289.29 229.64 289.29 229.64 289.28 229.64 289.27 229.64 289.27 229.64 289.26 229.64 289.25 229.64 289.25 229.64 289.24 229.64 289.22 229.64 289.2 229.63 289.19 229.63 289.18 229.63 289.18 229.63 289.17 229.63 289.17 229.63 289.17 229.63 289.16 229.63 289.1 229.62 289.08 229.62 289.06 229.62 289.05 229.62 289.05 229.62 289.04 229.62 289.04 229.62 289.04 229.62 289.04 229.62 289.04 229.62 289.04 229.62 289.04 229.62 289.03 229.62 289.03 229.62 289.03 229.62 289.03 229.62 289.03 229.62 289.02 229.62 289.02 229.62 289.02 229.62 289.02 229.62 289.02 229.62 289.02 229.62 289.01 229.62 289.01 229.62 289.01 229.62 289 229.62 289 229.61 288.97 229.61 288.97 229.61 288.95 229.61 288.94 229.61 288.94 229.61 288.94 229.61 288.93 229.61 288.93 229.61 288.93 229.61 288.92 229.61 288.92 229.61 288.92 229.61 288.92 229.61 288.92 229.61 288.92 229.61 288.91 229.61 288.91 229.61 288.89 229.6 288.89 229.6 288.88 229.6 288.85 229.6 288.81 229.6 288.81 229.6 288.79 229.59 288.78 229.59 288.78 229.59 288.77 229.59 288.77 229.59 288.77 229.59 288.76 229.59 288.76 229.59 288.75 229.59 288.75 229.59 288.75 229.59 288.75 229.59 288.75 229.59 288.75 229.59 288.75 229.59 288.75 229.59 288.74 229.59 288.74 229.59 288.74 229.59 288.73 229.59 288.73 229.59 288.73 229.59 288.73 229.59 288.73 229.59 288.73 229.59 288.72 229.59 288.72 229.59 288.72 229.59 288.72 229.59 288.71 229.59 288.7 229.59 288.7 229.59 288.69 229.58 288.62 229.58 288.61 229.58 288.54 229.57 288.49 229.56 288.48 229.56 288.48 229.56 288.48 229.56 288.48 229.56 288.47 229.56 288.44 229.56 288.42 229.56 288.41 229.56 288.4 229.55 288.38 229.55 288.35 229.55 288.35 229.55 288.32 229.55 288.21 229.54 288.21 229.54 288.21 229.54 288.19 229.53 288.07 229.52 288.07 229.52 288.07 229.52 288.07 229.52 288.06 229.52 288.06 229.52 288.06 229.52 288.06 229.52 288.06 229.52 288.06 229.52 288.06 229.52 288.06 229.52 288.06 229.52 288 229.52 287.94 229.51 287.94 229.51 287.78 229.49 287.71 229.49 287.7 229.49 287.68 229.48 287.68 229.48 287.68 229.48 287.68 229.48 287.68 229.48 287.68 229.48 287.68 229.48 287.68 229.48 287.68 229.48 287.68 229.48 287.63 229.48 287.5 229.46 287.5 229.46 287.5 229.46 287.49 229.46 287.46 229.46 287.45 229.46 287.39 229.45 285.84 229.28 285.48 229.23 282.2 228.9 284.44 228.58 284.14 227.52 286.2 227.74 286.64 226.33 286.06 226.13 284.74 226.2 283.68 227.95 279.86 227.69 280.1 225.38 Z"
          data-name="Adams"
          data-stusps="CO"
          id="8001"
        />
        <path
          className="white"
          d="M 632.56 381.55 634.11 381.79 635.22 380.33 637.09 379.75 636.17 378.22 638.16 378.5 640.11 377.9 641.32 378.4 640.89 381.53 641.15 381.52 640.12 383.04 638.63 383.94 638.68 384.18 636.57 383.92 636.39 385.19 635.57 385.3 634.14 384.05 633.93 382.41 632.56 381.55 Z"
          data-name="Brantley"
          data-stusps="GA"
          id="13025"
        />
        <path
          className="white"
          d="M 512.87 267.19 519.48 266.67 519.84 271.64 514.86 272.06 513.18 272.11 512.87 267.19 Z"
          data-name="Williamson"
          data-stusps="IL"
          id="17199"
        />
        <path
          className="white"
          d="M 476.12 194.14 476.04 192.5 482.59 192.16 482.78 195.45 482.95 198.72 476.37 199.05 476.12 194.14 Z"
          data-name="Cedar"
          data-stusps="IA"
          id="19031"
        />
        <path
          className="white"
          d="M 523.58 328.09 523.84 327.9 523.63 325.05 529.11 324.68 529.67 324.92 530.08 330.12 526.77 330.34 526.71 329.51 523.68 329.73 523.58 328.09 Z"
          data-name="Prentiss"
          data-stusps="MS"
          id="28117"
        />
        <path
          className="white"
          d="M 385.11 210.72 391.62 210.84 391.5 217.38 384.98 217.25 384.97 217.25 385.11 210.72 Z"
          data-name="York"
          data-stusps="NE"
          id="31185"
        />
        <path
          className="white"
          d="M 378.75 204.04 378.84 206.47 381.3 206.54 382 206.02 386.93 205.83 386.99 204.22 388.48 204.25 388.46 205.41 388.36 205.77 387.45 206.05 385.13 208.34 384.46 209.27 382.5 210.17 378.53 213.89 378.61 210.93 378.56 210.56 378.75 204.04 Z"
          data-name="Merrick"
          data-stusps="NE"
          id="31121"
        />
        <path
          className="white"
          d="M 352.39 137.06 362.15 137.56 361.81 144.12 350.39 143.54 349.14 143.1 349.39 140.47 348.07 139.19 348.68 138.24 349.53 139.31 350.58 139.43 352.15 138.07 352.39 137.06 Z"
          data-name="Sully"
          data-stusps="SD"
          id="46119"
        />
        <path
          className="white"
          d="M 380.67 353.43 387.44 353.56 388.71 353.59 389.08 353.65 388.86 358.27 388.71 361.86 386.41 361.78 384.27 361.7 380.45 361.54 380.67 353.43 Z"
          data-name="Wise"
          data-stusps="TX"
          id="48497"
        />
        <path
          className="white"
          d="M 495.78 167.56 497.17 166.59 497.27 165.81 502.19 165.66 507.05 165.21 507.18 166.84 507.66 173.42 502.75 173.86 502.56 173.66 496.25 174.11 495.78 167.56 Z"
          data-name="Dane"
          data-stusps="WI"
          id="55025"
        />
        <path
          className="white"
          d="M 359.53 190.33 359.88 190.34 365.86 190.56 366.03 190.57 365.78 197.08 359.24 196.82 359.53 190.33 Z"
          data-name="Loup"
          data-stusps="NE"
          id="31115"
        />
        <path
          className="white"
          d="M 516.06 241.38 520.95 241.01 521.02 241.83 522.63 241.7 523.02 246.59 518.14 246.91 516.48 247.1 516.06 241.38 Z"
          data-name="Effingham"
          data-stusps="IL"
          id="17049"
        />
        <path
          className="white"
          d="M 303.32 207 306.04 207.23 310.4 207.6 316.42 208.08 316.08 212.83 315.82 213.65 315.43 218.66 313.78 218.53 303.93 217.75 304.05 216.12 302.4 215.97 303.32 207 Z"
          data-name="Logan"
          data-stusps="CO"
          id="8075"
        />
        <path
          className="white"
          d="M 335.05 277.49 341.28 277.82 341.55 277.96 341.2 285.11 337.85 284.96 336.5 284.9 334.67 284.81 335.05 277.49 Z"
          data-name="Seward"
          data-stusps="KS"
          id="20175"
        />
        <path
          className="white"
          d="M 566.69 230.54 570.5 230.07 570.93 230.06 573.72 229.76 574.01 232.21 574.19 233.84 574.19 233.84 570.57 234.24 568.34 234.49 567.28 235.38 566.85 231.9 566.69 230.54 Z"
          data-name="Franklin"
          data-stusps="IN"
          id="18047"
        />
        <path
          className="white"
          d="M 587.77 154.86 587.96 154.61 586.78 148.31 593.71 146.92 594.22 148.93 595.44 151.8 596.27 155.47 596.68 156.49 589.98 157.84 589.54 155.39 587.91 155.67 587.77 154.86 Z"
          data-name="Sanilac"
          data-stusps="MI"
          id="26151"
        />
        <path
          className="white"
          d="M 582.19 179.6 585.47 179.07 589.03 178.46 590.44 179.34 590.26 180.22 589.66 181.26 588.91 181.65 588.81 182.53 588.12 183.15 587.6 184.07 588.04 185.32 587.64 185.53 585.8 185.87 583.31 186.33 583.31 186.33 582.19 179.6 Z"
          data-name="Monroe"
          data-stusps="MI"
          id="26115"
        />
        <path
          className="white"
          d="M 689.85 146.22 696.15 144.22 698 143.77 698.33 146.8 697.62 148.58 698.49 150.33 698.38 152.29 698.9 154.55 697.99 154.77 695.83 155.3 695.57 154.3 692.81 155.07 691.64 151.93 689.85 146.22 Z"
          data-name="Chenango"
          data-stusps="NY"
          id="36017"
        />
        <path
          className="white"
          d="M 634.83 211.08 634.36 208.38 633.75 204.94 633.55 203.85 633.29 202.39 635.57 201.98 638.64 204.25 642.79 205.05 642.29 205.89 643.6 205.97 643.27 206.88 643.76 207.32 644.45 207.9 644.08 209.02 642.51 210.35 637.98 210.44 635.01 212.1 634.83 211.08 Z"
          data-name="Washington"
          data-stusps="PA"
          id="42125"
        />
        <path
          className="white"
          d="M 190.26 335.65 191.8 335.9 191.97 336.07 193.15 337.89 198.47 335.32 197.01 346.19 199.02 350.99 200.19 353.09 200.55 355.18 199.97 357.17 201.52 359.34 199.93 359.14 199.7 359.14 196.42 358.66 180.01 356.45 180.23 354.81 180.34 354.43 182.1 341.9 182.89 341.93 182.24 339.97 182.73 338.37 184.45 337.73 187.26 337.65 189.97 337.76 190.26 335.65 Z"
          data-name="Graham"
          data-stusps="AZ"
          id="4009"
        />
        <path
          className="white"
          d="M 515.69 225.55 515.62 224.73 517.8 221.1 519.44 220.95 519.62 223.58 520.05 228.52 520.17 229.99 520.03 230.18 516.08 230.49 515.69 225.55 Z"
          data-name="Piatt"
          data-stusps="IL"
          id="17147"
        />
        <path
          className="white"
          d="M 374.88 238.22 382.95 238.44 382.99 238.73 382.88 243.33 382.83 243.88 382.83 244.96 374.65 244.74 374.88 238.22 Z"
          data-name="Mitchell"
          data-stusps="KS"
          id="20123"
        />
        <path
          className="white"
          d="M 492.49 272.62 498.29 272.32 498.34 273.15 498.68 278.5 497.6 278.51 492.61 278.75 492.35 273.48 492.49 272.62 Z"
          data-name="Madison"
          data-stusps="MO"
          id="29123"
        />
        <path
          className="white"
          d="M 365.6 217.38 369.5 217.67 372.12 217.06 371.92 223.43 371.88 223.42 365.38 223.19 365.6 217.38 Z"
          data-name="Kearney"
          data-stusps="NE"
          id="31099"
        />
        <path
          className="white"
          d="M 586.18 233.27 585.84 227.29 590.36 227.04 591.61 226.97 591.77 227.35 591.97 230.11 589.43 232.68 589.1 233.49 588.28 233.13 586.44 233.25 586.18 233.27 Z"
          data-name="Clinton"
          data-stusps="OH"
          id="39027"
        />
        <path
          className="white"
          d="M 651.51 176.56 658.16 175.04 659.17 175.41 659.95 179.12 662.31 178.63 663.24 181.87 657.31 182.63 656.61 183.8 656.02 182.72 652.22 181.25 650.6 182.28 650.63 180.07 652.17 180.08 651.51 176.56 Z"
          data-name="Elk"
          data-stusps="PA"
          id="42047"
        />
        <path
          className="white"
          d="M 334.29 327.12 340.56 327.44 342.49 327.53 342.09 335.67 340.54 335.59 333.86 335.29 334.29 327.12 Z"
          data-name="Hall"
          data-stusps="TX"
          id="48191"
        />
        <path
          className="white"
          d="M 630.6 270.11 632.88 268.16 631.87 267.41 633.14 265.36 634.71 264.26 636.41 263.58 636.64 263.52 636.21 264.08 639.01 266.11 637.96 266.91 638.36 267.66 635.46 269.1 633.71 268.89 631.64 271.06 630.6 270.11 Z"
          data-name="Bland"
          data-stusps="VA"
          id="51021"
        />
        <path
          className="white"
          d="M 667.33 232.66 668.22 229.86 668.85 229.99 670.19 227.82 671.89 228.32 672.06 228.7 671.63 229.2 671.76 231.35 670.57 233.54 670.62 234.56 670.32 235.68 666.94 234.59 667.33 232.66 Z"
          data-name="Page"
          data-stusps="VA"
          id="51139"
        />
        <path
          className="white"
          d="M 153.02 127.56 154.75 128.82 156.56 129.28 156.88 130.88 156 133.6 157.17 134.5 156.93 134.99 157.9 136.2 157.18 136.94 156.9 138.9 158.79 139.47 158.51 141.92 155.48 141.25 148.71 139.66 150.59 132.03 151.33 131.92 151.78 129.51 153.02 127.56 Z"
          data-name="Camas"
          data-stusps="ID"
          id="16025"
        />
        <path
          className="white"
          d="M 544.44 244.78 547.7 244.44 548.11 248.54 548.42 251.56 546.13 251.78 545.48 252.45 544.89 252.3 544.33 246.44 544.44 244.78 Z"
          data-name="Martin"
          data-stusps="IN"
          id="18101"
        />
        <path
          className="white"
          d="M 691.79 291.65 693.46 291.17 693.89 291.67 696.74 289.56 697.79 290.88 698.38 290.97 697.79 291.27 697.49 293.32 696.61 293.22 697.17 294.49 696.07 296.71 694.26 298.29 693.94 297.92 693.17 295.79 692.04 295.36 691.65 291.9 691.79 291.65 Z"
          data-name="Lenoir"
          data-stusps="NC"
          id="37107"
        />
        <path
          className="white"
          d="M 390.89 250.03 390.96 246.76 396.92 246.84 396.87 249.98 397.42 249.73 397.39 251.76 397.93 251.78 397.37 252.86 397.28 256.66 390.78 256.56 390.74 250.57 390.89 250.03 Z"
          data-name="Dickinson"
          data-stusps="KS"
          id="20041"
        />
        <path
          className="white"
          d="M 368.68 408.17 371.6 408.2 372.58 408.52 376.22 409.72 375.42 411.02 373.26 416.94 371.32 418.78 368.58 414.94 368.68 408.17 Z"
          data-name="Blanco"
          data-stusps="TX"
          id="48031"
        />
        <path
          className="white"
          d="M 441.35 413.34 444.87 413.27 447.97 413.19 447.94 413.54 448.11 414.5 448.15 415.64 448.15 416.74 448.11 416.78 447.56 417.36 446.49 418.64 446.14 419.77 445.79 420.19 445.94 418.75 445.63 418.22 442.81 417.32 441.4 414.86 441.79 414.03 441.35 413.34 Z"
          data-name="Orange"
          data-stusps="TX"
          id="48361"
        />
        <path
          className="white"
          d="M 663.97 273.71 662.03 274.05 662.12 273.33 661.08 273 661.3 272.67 662.57 272.79 662.79 271.9 663.42 272.5 664.47 272.91 663.97 273.71 Z"
          data-name="Danville"
          data-stusps="VA"
          id="51590"
        />
        <path
          className="white"
          d="M 641.32 378.4 641.79 376.97 642.77 375.83 645.38 377.74 649.04 378.06 648.86 379.05 648.6 379.83 647.74 381.29 647.22 381.58 647.36 382.57 647.19 383.68 647.39 384.16 644.5 382.48 644.58 381.83 643.51 382.4 641.15 381.52 640.89 381.53 641.32 378.4 Z"
          data-name="Glynn"
          data-stusps="GA"
          id="13127"
        />
        <path
          className="white"
          d="M 188.49 34.33 190.46 34.83 193.09 35.5 196.98 36.42 200.17 37.17 211.5 39.75 209.46 49.5 204.62 48.31 203.9 51.56 194.27 49.33 193.93 48.64 194.81 47.94 194.68 47.19 193.28 46.28 193.85 44.56 193.08 43.6 192.34 43.65 190.64 42.47 191.71 40.64 191.23 39.47 191.49 38.65 190.62 37.69 189.02 38.06 188.11 36.42 188.89 35.18 188.49 34.33 Z"
          data-name="Glacier"
          data-stusps="MT"
          id="30035"
        />
        <path
          className="white"
          d="M 311.87 56.23 320.18 57.12 325.57 57.63 325.07 62.87 325.74 62.93 325.59 64.56 311.13 63.1 311.55 59.09 311.87 56.23 Z"
          data-name="Divide"
          data-stusps="ND"
          id="38023"
        />
        <path
          className="white"
          d="M 632.75 199.34 633.29 202.39 633.55 203.85 632.76 203.99 632.01 204.21 632.16 203.18 631.66 201.84 630.8 200.78 631.26 199.98 631.9 199.95 632.75 199.34 Z"
          data-name="Hancock"
          data-stusps="WV"
          id="54029"
        />
        <path
          className="white"
          d="M 449.25 302.89 451.97 302.89 452.51 302.9 457.39 302.86 457.51 303.67 457.52 305.2 457.51 310.18 454.25 310.2 448.81 310.23 448.81 309.69 448.69 307.47 449.76 305.84 449.78 303.71 449.25 302.89 Z"
          data-name="Newton"
          data-stusps="AR"
          id="5101"
        />
        <path
          className="white"
          d="M 654.76 464.83 665.39 463.6 665.97 459.85 667.48 471.78 667.68 473.2 661 474.1 660.35 469.07 655.35 469.71 655.14 468.06 654.76 464.83 Z"
          data-name="Hendry"
          data-stusps="FL"
          id="12051"
        />
        <path
          className="white"
          d="M 594.4 321.32 594.78 320.41 596.69 320.3 597.98 318.26 599.32 318.45 599.24 320.41 600.01 322.52 598.71 323.37 598.06 324.42 596.06 323.77 594.5 322.53 594.4 321.32 Z"
          data-name="Lumpkin"
          data-stusps="GA"
          id="13187"
        />
        <path
          className="white"
          d="M 501.34 205.99 503.79 205.81 505.73 205.68 505.38 206.54 508.17 206.32 509.8 206.18 510.06 209.54 508.45 209.64 504.01 210.09 504.29 209.08 501.57 209.27 501.35 206.12 501.34 205.99 Z"
          data-name="Marshall"
          data-stusps="IL"
          id="17123"
        />
        <path
          className="white"
          d="M 573.67 403.78 575.86 402.61 581.85 402.14 581.64 399.67 582.49 399.59 583.32 399.53 583.87 406.44 584.36 411.67 583.71 411.24 582.67 411.12 581.18 410.01 580.65 409.49 579.01 408.87 576.99 407.5 573.81 406.06 573.67 403.78 Z"
          data-name="Bay"
          data-stusps="FL"
          id="12005"
        />
        <path
          className="white"
          d="M 516.5 359.97 521.27 359.67 522.67 359.81 522.92 359.66 523.35 366.23 516.93 366.64 516.5 359.97 Z"
          data-name="Neshoba"
          data-stusps="MS"
          id="28099"
        />
        <path
          className="white"
          d="M 542.38 327.2 543.55 325.51 543.62 322.68 544.9 322.64 545.69 323.44 546.26 323.24 546.84 323.1 548.8 324.4 549.33 331.41 549.35 331.68 542.79 332.14 542.38 327.2 Z"
          data-name="Lawrence"
          data-stusps="AL"
          id="1079"
        />
        <path
          className="white"
          d="M 260.49 271.1 261.23 264.56 269.92 265.43 268.95 268.26 269.16 268.66 268.9 268.97 264.85 272.41 260.41 271.93 260.49 271.1 Z"
          data-name="Alamosa"
          data-stusps="CO"
          id="8003"
        />
        <path
          className="white"
          d="M 639.86 409.69 639.96 409.67 641.72 408.9 642.11 407.96 643.61 406.94 647.44 406.39 648.56 407.81 648.66 408.53 648.92 410.41 649.26 412.73 650.24 414.61 650.95 414.49 650.8 414.86 647.01 416.41 645.89 415.65 645.04 413.51 643.85 413 641.21 413.7 640.42 414.38 639.97 409.97 639.86 409.69 Z"
          data-name="Putnam"
          data-stusps="FL"
          id="12107"
        />
        <path
          className="white"
          d="M 596.51 378.09 598.98 377.82 603.1 377.34 603.44 376.8 603.85 376.76 603.85 377.23 604.21 380.66 602.25 380.9 601.89 380.99 600.75 381.19 597.21 381.55 597.45 381.14 596.58 379.48 596.51 378.09 Z"
          data-name="Dougherty"
          data-stusps="GA"
          id="13095"
        />
        <path
          className="white"
          d="M 588.31 389.35 589.92 389.25 593.04 389 592.64 394.15 591.56 395.97 591.54 395.97 590.55 394.92 590.17 393.77 590.07 392.93 589.17 391.91 588.74 391.19 588.75 390.74 588.51 389.75 588.31 389.35 Z"
          data-name="Seminole"
          data-stusps="GA"
          id="13253"
        />
        <path
          className="white"
          d="M 497.12 390.83 498.49 390.76 498.81 397.32 498.5 397.33 495.4 397.48 494.31 397.53 490.53 397.71 490.31 392.4 489.7 391.7 490.16 391.34 490.92 391.14 497.12 390.83 Z"
          data-name="Amite"
          data-stusps="MS"
          id="28005"
        />
        <path
          className="white"
          d="M 512.06 337.05 516.19 336.8 516.31 338.44 517.96 338.33 518.3 343.25 517.48 343.31 517.54 344.69 517.52 345 512.61 345.31 512.44 342.58 512.06 337.05 Z"
          data-name="Calhoun"
          data-stusps="MS"
          id="28013"
        />
        <path
          className="white"
          d="M 523.79 372.85 531.5 372.27 531.37 375.58 531.28 377.85 531.33 378.59 528.87 379.46 525.94 380.1 524.33 380.32 523.79 372.85 Z"
          data-name="Clarke"
          data-stusps="MS"
          id="28023"
        />
        <path
          className="white"
          d="M 363.8 131.1 375.08 131.59 375.15 131.59 374.93 138.1 366.98 137.79 363.5 137.63 363.8 131.1 Z"
          data-name="Faulk"
          data-stusps="SD"
          id="46049"
        />
        <path
          className="white"
          d="M 495.14 384.35 500.32 384.07 500.89 384.32 503.02 383.61 503.39 390.5 503.13 390.51 498.49 390.76 497.12 390.83 496.89 385.91 495.21 385.99 495.14 384.35 Z"
          data-name="Lincoln"
          data-stusps="MS"
          id="28085"
        />
        <path
          className="white"
          d="M 629.94 245.93 634.24 242.3 635.44 240.86 634.4 240.48 635.66 239.29 637.76 239.54 637.42 240.04 638.68 242.73 641.78 243.9 638.27 248.15 635.65 248.11 634 246.2 632.51 246.55 629.94 245.93 629.94 245.93 Z"
          data-name="Nicholas"
          data-stusps="WV"
          id="54067"
        />
        <path
          className="white"
          d="M 620.65 239.33 621.15 239.36 621.94 240.18 621.25 240.98 622.02 243.24 619.59 244.95 619.58 246.37 618.53 247.67 617.7 247.34 617.48 245.74 617.07 243.87 616.54 241.38 618.01 240.2 620.65 239.33 Z"
          data-name="Putnam"
          data-stusps="WV"
          id="54079"
        />
        <path
          className="white"
          d="M 253.93 301.74 255.28 300.51 254.13 300.17 254.36 298.45 257.29 298.76 257.17 297.4 262.6 297.95 262.54 298.39 262.29 300.42 260.8 316.05 253.36 315.31 252.59 315.24 252.94 311.92 252.97 311.49 253.32 307.63 253.93 301.74 Z"
          data-name="Santa Fe"
          data-stusps="NM"
          id="35049"
        />
        <path
          className="white"
          d="M 556.5 189.16 561.67 188.52 562.51 188.41 563.02 188.35 563.6 192.73 557.1 193.58 556.5 189.16 Z"
          data-name="LaGrange"
          data-stusps="IN"
          id="18087"
        />
        <path
          className="white"
          d="M 432.5 169.44 432.43 164.84 433.14 164.82 435.09 164.79 438.88 164.73 438.99 169.31 439.12 175.83 432.61 175.95 432.5 169.44 Z"
          data-name="Kossuth"
          data-stusps="IA"
          id="19109"
        />
        <path
          className="white"
          d="M 579.06 150.9 579.31 151.08 581.04 148.35 581.24 148.04 581.29 147.81 582.05 149.19 586.78 148.31 587.96 154.61 587.77 154.86 584.57 155.44 584.85 157.07 583.36 157.34 583.39 157.52 580.16 158.04 579.65 154.82 579.41 153.2 579.15 151.57 579.06 150.9 Z"
          data-name="Tuscola"
          data-stusps="MI"
          id="26157"
        />
        <path
          className="white"
          d="M 728.91 174.67 729.05 173.42 729.13 173.31 729.56 173.31 730.37 172.93 730.8 172.42 732.38 171.58 732.39 171.48 733.19 172.41 734.11 174.5 734.24 174.81 734.75 175.97 735.03 177.06 734.22 177.57 733.93 177.76 732.05 178.47 730.43 178.77 730.3 177.73 730.48 177.46 730.37 177.23 730.34 176.96 730.17 176.4 730.09 176.23 730.13 176.12 730.32 175.49 729.47 175.11 728.91 174.67 Z"
          data-name="Nassau"
          data-stusps="NY"
          id="36059"
        />
        <path
          className="white"
          d="M 382.41 69.8 387.29 69.96 397.01 70.22 396.99 70.38 397.08 72.29 397.07 73.91 397.15 75.54 396.97 76.74 387.41 76.51 382.52 76.36 382.3 73.07 382.41 69.8 Z"
          data-name="Walsh"
          data-stusps="ND"
          id="38099"
        />
        <path
          className="white"
          d="M 351.2 332.42 353.93 332.53 354.08 328.45 357.85 328.58 358.18 326.94 360.65 326.85 362.24 326.39 362.08 329.15 363.58 329.21 362.76 330.38 361.79 331.29 360.53 334.27 360.72 336.18 359.93 335.01 358.79 334.02 358.1 333.9 357.66 335.04 356.89 334.71 356.83 334.7 355.13 334.44 354.87 335.05 353.37 334.87 352.35 333.82 351.56 332.8 351.2 332.42 Z"
          data-name="Jackson"
          data-stusps="OK"
          id="40065"
        />
        <path
          className="white"
          d="M 609.56 346.68 610.64 346.86 612.02 346.34 614.91 346.68 615.1 348.61 615.8 347.93 616.07 349.72 615.77 350.51 614.67 349.48 611.29 351.44 609.95 348.02 609.56 346.68 Z"
          data-name="Baldwin"
          data-stusps="GA"
          id="13009"
        />
        <path
          className="white"
          d="M 348.42 261.72 357.94 262.14 358.14 262.33 358.1 263.52 358.03 265.43 357.89 268.7 348.12 268.26 348.2 266.62 348.42 261.72 Z"
          data-name="Hodgeman"
          data-stusps="KS"
          id="20083"
        />
        <path
          className="white"
          d="M 598.39 249.57 599.99 248.97 599.66 247.34 600.51 245.73 602.31 246.22 603.7 247.4 606.03 247.45 606.74 247.56 606.73 249.85 606.39 250.58 604.97 251.42 603.02 251.42 600.96 250.22 600.17 251.76 599.28 251.55 598.39 249.57 Z"
          data-name="Carter"
          data-stusps="KY"
          id="21043"
        />
        <path
          className="white"
          d="M 433.15 150.48 437.46 152.47 438.14 152.18 438.01 150.85 441.31 150.77 441.33 151.59 441.49 158.12 434.98 158.27 433.32 158.29 433.24 153.4 433.15 150.48 Z"
          data-name="Blue Earth"
          data-stusps="MN"
          id="27013"
        />
        <path
          className="white"
          d="M 476.26 376.63 478.1 374.84 478.21 373.21 480.21 371.71 482.74 371.61 482.87 373.28 481.57 374.58 482.62 375.41 482.77 377.49 482.25 380.01 482.54 380.55 481.55 381.47 481.15 379.85 480.33 379.88 479.09 381.58 477.87 381.42 476.46 380 475.7 378.24 476.72 377.74 476.26 376.63 Z"
          data-name="Franklin"
          data-stusps="LA"
          id="22041"
        />
        <path
          className="white"
          d="M 350.88 322.59 352.5 322.65 352.57 321.02 358.33 321.28 358.94 321.81 359.54 322.69 359.75 326.16 360.65 326.85 358.18 326.94 357.85 328.58 354.08 328.45 353.29 327.59 353.24 324.29 350.81 324.2 350.88 322.59 Z"
          data-name="Greer"
          data-stusps="OK"
          id="40055"
        />
        <path
          className="white"
          d="M 323.73 343.84 331.92 344.21 331.55 352.4 323.38 352.02 323.73 343.84 Z"
          data-name="Crosby"
          data-stusps="TX"
          id="48107"
        />
        <path
          className="white"
          d="M 406.86 399.83 411.15 397.63 414.55 397.59 416.29 397.86 415.9 399.6 416.92 400.65 416.95 401.03 415.33 401.01 412.96 401.9 408.02 402.66 407.4 400.33 406.86 399.83 Z"
          data-name="Madison"
          data-stusps="TX"
          id="48313"
        />
        <path
          className="white"
          d="M 660.6 150.27 660.42 149.46 660.71 147.78 663.18 147.22 662.99 148.21 665.45 147.59 665.78 151.09 666.34 152.77 667.9 152.45 668.24 154.21 665.88 154.68 666.05 155.54 665.22 155.72 665.45 156.93 663.8 157.23 663.62 156.42 660.85 156.95 660.49 156.79 661.39 153.95 660.6 150.27 Z"
          data-name="Livingston"
          data-stusps="NY"
          id="36051"
        />
        <path
          className="white"
          d="M 701.17 266.54 701.18 266.54 703.88 265.88 706.9 265.26 707.84 265.86 708.01 266.66 708.95 268.27 707.42 269.12 705.86 270.15 705.53 270.6 703.99 269.6 701.22 269.15 701.17 266.54 Z"
          data-name="Gates"
          data-stusps="NC"
          id="37073"
        />
        <path
          className="white"
          d="M 518.72 402.9 520.33 402.25 526.11 401.89 526.29 407.24 525.03 407.37 523.23 407.9 521.58 408.7 519.85 409.24 519.65 409.32 519.04 408.34 518.72 402.9 Z"
          data-name="Harrison"
          data-stusps="MS"
          id="28047"
        />
        <path
          className="white"
          d="M 572.67 220.66 572.45 218.73 572.03 214.91 571.94 214.1 577.26 213.39 577.67 216.35 578.45 221.55 577.59 221.69 572.86 222.32 572.67 220.66 Z"
          data-name="Darke"
          data-stusps="OH"
          id="39037"
        />
        <path
          className="white"
          d="M 537.38 288.4 541.82 287.94 542 287.93 545.34 287.58 544.94 289.08 545.59 291.13 543.31 293.28 543.29 293.87 543.05 294.07 539.81 293.93 538.68 293.9 538.56 293.42 537.38 288.4 Z"
          data-name="Montgomery"
          data-stusps="TN"
          id="47125"
        />
        <path
          className="white"
          d="M 621.42 390.11 622.16 389.64 624.28 390.06 625.82 391.84 628.94 392.17 629.13 394.16 627.38 394.25 624.28 394.4 620.08 394.61 619.99 394.61 619.69 391.46 620.09 390.65 620.3 390.26 621.42 390.11 Z"
          data-name="Echols"
          data-stusps="GA"
          id="13101"
        />
        <path
          className="white"
          d="M 524.42 287.33 530.09 286.94 530.62 287.66 530.81 288.19 531.1 289.07 531.56 290.52 531.38 291.51 531.34 291.52 530.22 291.63 524.72 292.01 524.42 287.33 Z"
          data-name="Calloway"
          data-stusps="KY"
          id="21035"
        />
        <path
          className="white"
          d="M 463.25 218.48 465.7 218.32 469.08 218.07 469.24 223.8 463.51 224 463.45 223.18 463.25 218.48 Z"
          data-name="Scotland"
          data-stusps="MO"
          id="29199"
        />
        <path
          className="white"
          d="M 706.57 139.84 709.53 140.2 710.12 139.97 711.77 139.38 712.07 139.04 712.36 140.62 713.56 139.98 714.02 141.12 713.61 143.59 713.95 146.07 714.15 146.32 714.44 146.87 711.78 148.03 708.98 147.36 707.23 145.94 707.82 143.6 706.69 141.39 706.57 139.84 Z"
          data-name="Schoharie"
          data-stusps="NY"
          id="36095"
        />
        <path
          className="white"
          d="M 649.65 287.21 652.36 286.31 652.27 285.73 654.94 285.6 655.17 287.32 656.16 295.24 654.37 295.56 654.36 295.57 653.72 294.16 651.48 292.54 651.35 291.85 649.97 291.96 649.36 291.73 648.64 290.1 649.99 289.72 650.3 288.8 649.65 287.21 Z"
          data-name="Davidson"
          data-stusps="NC"
          id="37057"
        />
        <path
          className="white"
          d="M 617.96 188.15 623.47 187.21 623.47 187.21 623.73 188.64 624.19 191.23 624.42 192.59 624.68 193.98 623.47 194.19 622.08 194.42 621.91 194.45 619.59 194.84 619.08 194.93 618.97 194.23 618.74 192.82 618.63 192.15 618.18 189.5 617.96 188.15 Z"
          data-name="Portage"
          data-stusps="OH"
          id="39133"
        />
        <path
          className="white"
          d="M 607.33 342.17 611.24 340.75 612.36 342.59 613.38 342.96 613.77 343.77 612.18 344.94 612.02 346.34 610.64 346.86 609.56 346.68 609.31 346.72 607.73 347.16 607.33 342.17 Z"
          data-name="Putnam"
          data-stusps="GA"
          id="13237"
        />
        <path
          className="white"
          d="M 556.03 210.32 559.26 209.91 561.98 209.58 562.2 211.21 562.66 214.74 560.73 214.96 556.65 215.45 556.59 214.91 556.23 211.93 556.03 210.32 Z"
          data-name="Grant"
          data-stusps="IN"
          id="18053"
        />
        <path
          className="white"
          d="M 577.76 266.97 580.45 265.31 580.41 265.01 580.61 265.46 583.92 267.42 583.44 270.49 582.57 270.08 580.36 272.59 580.44 271.41 580.06 270.3 577.98 269.26 577.76 266.97 Z"
          data-name="Lincoln"
          data-stusps="KY"
          id="21137"
        />
        <path
          className="white"
          d="M 601.27 329.61 602.2 330.67 605.49 330.93 606.05 332.13 604.46 333.47 602.69 333.9 602.01 333.31 600.74 332.03 601.27 329.61 Z"
          data-name="Barrow"
          data-stusps="GA"
          id="13013"
        />
        <path
          className="white"
          d="M 414.25 116.06 422.4 116.03 422.54 122.29 422.54 122.56 414.4 122.58 414.25 116.06 Z"
          data-name="Douglas"
          data-stusps="MN"
          id="27041"
        />
        <path
          className="white"
          d="M 365.92 197.09 372.29 197.33 372.39 197.33 372.18 203.83 365.79 203.6 365.67 203.32 365.92 197.09 Z"
          data-name="Valley"
          data-stusps="NE"
          id="31175"
        />
        <path
          className="white"
          d="M 400.39 89.84 410.43 89.92 410.42 96.44 408.79 96.45 400.69 96.39 400.59 94.75 400.54 94.01 400.36 90.94 400.39 89.84 Z"
          data-name="Norman"
          data-stusps="MN"
          id="27107"
        />
        <path
          className="white"
          d="M 570.41 289.65 570.96 287.78 573.35 286.89 573.58 286.7 576.12 288.95 576.31 290.88 577.14 292.86 576.68 293.89 575.37 293.89 571.91 292.67 570.62 291.55 570.44 290.18 570.41 289.65 Z"
          data-name="Overton"
          data-stusps="TN"
          id="47133"
        />
        <path
          className="white"
          d="M 687.64 235.65 688.3 235.55 689.75 235.24 690.17 236.11 691.83 236.7 691.3 238.2 693.26 240.06 691.8 240.38 691.87 241.8 690.9 241.64 689.81 244.25 689.07 244.64 687.35 242.89 684.56 241.34 685.99 238.78 687.64 235.65 Z"
          data-name="Caroline"
          data-stusps="VA"
          id="51033"
        />
        <path
          className="white"
          d="M 349.15 322.52 350.88 322.59 350.81 324.2 353.24 324.29 353.29 327.59 354.08 328.45 353.93 332.53 351.2 332.42 349.9 331.06 348.82 331.31 348.78 331.32 348.93 327.83 349.15 322.52 Z"
          data-name="Harmon"
          data-stusps="OK"
          id="40057"
        />
        <path
          className="white"
          d="M 549.81 310.45 551.33 308.25 552.05 304.74 552.54 304.89 553.52 304.54 554.28 304.93 554.25 308.62 555.17 310.89 555.47 310.91 555.49 311.63 553.39 313.23 552.11 313.14 550.82 312.31 549.81 310.45 Z"
          data-name="Marshall"
          data-stusps="TN"
          id="47117"
        />
        <path
          className="white"
          d="M 448.3 195.21 449.93 195.17 456.47 194.96 456.63 199.86 456.84 201.59 455.22 201.66 448.77 201.87 448.43 200.13 448.3 195.21 Z"
          data-name="Jasper"
          data-stusps="IA"
          id="19099"
        />
        <path
          className="white"
          d="M 316.46 309.68 324.74 310.18 324.26 318.39 315.86 317.87 316.46 309.68 Z"
          data-name="Potter"
          data-stusps="TX"
          id="48375"
        />
        <path
          className="white"
          d="M 561.25 299.15 562.17 298.67 563.35 298.81 565.48 300.56 565.57 300.89 564.1 303.47 564.39 304.43 562.81 304.84 560.89 303.95 561.5 299.88 561.25 299.15 Z"
          data-name="Cannon"
          data-stusps="TN"
          id="47015"
        />
        <path
          className="white"
          d="M 148.71 139.66 155.48 141.25 153.97 147.78 153.6 147.92 152.79 151.51 150.13 150.59 149.9 148.73 148.9 148.27 149.75 146.64 149.18 145.4 148.1 145.2 147.43 144.99 148.71 139.66 Z"
          data-name="Gooding"
          data-stusps="ID"
          id="16047"
        />
        <path
          className="white"
          d="M 692.83 251.69 693.23 251.64 693.51 249.4 694.94 250.1 697.99 250.19 698.09 250.69 698.59 250.83 699.02 253.56 698.43 253.64 697.56 253.36 697 252.44 696.01 253.26 695.04 252.8 692.75 252.92 692.83 251.69 Z"
          data-name="Charles City"
          data-stusps="VA"
          id="51036"
        />
        <path
          className="white"
          d="M 690.76 287.57 691.08 287.5 692.41 285.94 694.12 287.28 695.97 287.91 696.74 289.56 693.89 291.67 693.46 291.17 691.79 291.65 691.27 290.65 690.76 287.57 Z"
          data-name="Greene"
          data-stusps="NC"
          id="37079"
        />
        <path
          className="white"
          d="M 432.69 180.89 439.23 180.77 439.26 182.39 439.85 184 439.97 188.92 436.71 188.98 433.46 189.06 433.38 184.1 432.75 184.11 432.72 182.51 432.69 180.89 Z"
          data-name="Webster"
          data-stusps="IA"
          id="19187"
        />
        <path
          className="white"
          d="M 510.42 140.22 515.27 139.89 516 139.78 516.58 146.26 513.72 146.48 512.09 146.63 509.19 146.9 508.66 140.38 510.42 140.22 Z"
          data-name="Outagamie"
          data-stusps="WI"
          id="55087"
        />
        <path
          className="white"
          d="M 519.84 271.64 519.48 266.67 519.42 265.86 524.37 265.45 524.82 271.24 524.26 271.29 519.84 271.64 519.84 271.64 Z"
          data-name="Saline"
          data-stusps="IL"
          id="17165"
        />
        <path
          className="white"
          d="M 350.39 143.54 361.81 144.12 361.97 144.3 361.69 150.34 361.22 151.16 362.35 151.66 362.28 152.5 360.2 151.8 358.62 151.84 357.96 150.58 358.63 149.73 356.08 148.35 352.35 147.26 352.16 145.66 349.58 145.1 350.39 143.54 Z"
          data-name="Hughes"
          data-stusps="SD"
          id="46065"
        />
        <path
          className="white"
          d="M 371.23 400.33 371.67 400.25 371.38 398.31 379.9 398.39 381.02 400.39 381.21 400.86 378.99 403.04 377.52 406.04 376.27 408.6 376.22 409.72 372.58 408.52 372.59 407.17 371.64 406.84 371.23 404.98 372.35 403.75 371.39 402.87 372.31 401.98 371.02 401.12 371.23 400.33 Z"
          data-name="Burnet"
          data-stusps="TX"
          id="48053"
        />
        <path
          className="white"
          d="M 732.07 88.21 734.8 87.28 735.89 86.91 737.32 86.44 737.14 87.26 738.02 88.31 737.83 89 737.64 90.62 737.24 91.95 738.29 93.3 738.95 93.87 739.33 94.74 738.94 95.51 739.32 96.34 738.62 97.24 738.3 98.32 737.44 98.95 737.25 99.09 736.99 100.13 736.76 100.31 734.93 98.96 735.64 97.61 734.64 96.86 735.16 95.4 734.04 95.01 734.61 93.41 732.94 92.84 732.36 92.65 732.42 90.29 732.07 88.21 Z"
          data-name="Essex"
          data-stusps="VT"
          id="50009"
        />
        <path
          className="white"
          d="M 700.06 242.33 701.44 242.85 702.76 244.68 706.57 244.72 706.55 245.32 706.77 245.7 705.03 246.09 704.61 246.6 702.66 246.21 700.98 245.61 700.28 245.27 699.01 243.54 699.32 242.91 700.06 242.33 Z"
          data-name="Middlesex"
          data-stusps="VA"
          id="51119"
        />
        <path
          className="white"
          d="M 479.08 253.46 479.81 253.26 481.25 254.82 483.46 254.93 485.18 256.01 485.9 256.21 487.95 254.97 488.37 254.19 488.51 254.1 488.63 257.34 488.67 258.29 488.55 259.39 488.26 262.3 485.44 262.41 483.58 262.55 479.82 262.74 479.55 262.65 479.08 253.46 Z"
          data-name="Franklin"
          data-stusps="MO"
          id="29071"
        />
        <path
          className="white"
          d="M 604.31 372.92 605.86 373.06 606.61 373.51 607.09 376.92 608.35 376.79 609.59 377.69 609.74 379.16 609.51 379.28 609.84 380.23 610.02 382.19 609.07 382.53 608.31 382.35 604.4 382.73 604.21 380.66 603.85 377.23 603.85 376.76 603.44 376.8 603.29 373.92 604.31 372.92 Z"
          data-name="Worth"
          data-stusps="GA"
          id="13321"
        />
        <path
          className="white"
          d="M 631.1 190.18 634.82 189.44 636.44 189.42 637.29 190.1 636.56 191.6 637.18 194.33 632.02 195.34 631.86 194.42 631.83 194.3 631.57 192.77 631.1 190.18 Z"
          data-name="Lawrence"
          data-stusps="PA"
          id="42073"
        />
        <path
          className="white"
          d="M 462.54 360.89 462.56 360.89 466.07 360.82 470.47 360.74 472.9 360.66 472.91 360.66 472.67 361.48 473.31 364.66 473.16 366.01 470.73 368.59 467.69 368.83 467.64 367.19 465.99 367.23 465.12 365.8 462.67 365.67 462.63 364.57 462.54 360.89 Z"
          data-name="Union"
          data-stusps="LA"
          id="22111"
        />
        <path
          className="white"
          d="M 385.44 191.14 391.96 191.26 391.85 197.78 385.35 197.67 385.38 194.4 385.44 191.14 Z"
          data-name="Madison"
          data-stusps="NE"
          id="31119"
        />
        <path
          className="white"
          d="M 247.2 352.55 247.02 354.33 246.45 354.27 244.64 372.33 240.75 371.95 240.51 372.49 240.51 373.58 240.23 374.36 241 375.53 241.79 376.2 241.74 376.18 234.29 375.43 229.39 374.91 231.02 359.38 231.39 356.08 237.96 356.81 238.04 355.98 247.2 352.55 Z"
          data-name="Dona Ana"
          data-stusps="NM"
          id="35013"
        />
        <path
          className="white"
          d="M 517.84 177.03 519.47 176.87 519.37 175.78 524.73 175.3 524.6 175.77 524.73 176.99 525.07 178.61 523.71 178.72 519.51 179.06 519.27 179.07 518.05 179.19 517.84 177.03 Z"
          data-name="Kenosha"
          data-stusps="WI"
          id="55059"
        />
        <path
          className="white"
          d="M 488.16 175.5 496.3 174.93 496.73 180.72 495.49 180.79 495.49 180.79 491.36 181.04 488.54 181.23 488.16 175.5 Z"
          data-name="Lafayette"
          data-stusps="WI"
          id="55065"
        />
        <path
          className="white"
          d="M 493.83 265.03 496.17 263.52 496.16 263.29 496.16 263.29 496.7 263.88 496.93 264 498.13 264.62 498.84 265.24 499.97 266.02 500.77 266.04 500.54 266.95 501.2 267.64 500.27 268.8 498.8 271.73 497.46 271.84 493.37 268.14 495.28 266.09 493.83 265.03 Z"
          data-name="Ste. Genevieve"
          data-stusps="MO"
          id="29186"
        />
        <path
          className="white"
          d="M 697.56 253.36 698.43 253.64 699.02 253.56 700.36 253.46 701.07 254.05 702.48 253.21 702.97 254.11 702.49 256.09 700.43 257.77 699.04 259.08 698.44 257.03 695.31 256.52 697.02 253.78 697.56 253.36 Z"
          data-name="Surry"
          data-stusps="VA"
          id="51181"
        />
        <path
          className="white"
          d="M 661.37 274.17 661.41 274.16 662.03 274.05 663.97 273.71 665.88 273.36 667.11 273.14 667.88 278.87 666.28 279.12 662.05 279.74 661.37 274.17 Z"
          data-name="Caswell"
          data-stusps="NC"
          id="37033"
        />
        <path
          className="white"
          d="M 554.35 183.5 560.92 182.66 561.67 188.52 556.5 189.16 554.65 189.38 555 188.58 554.35 183.5 Z"
          data-name="St. Joseph"
          data-stusps="MI"
          id="26149"
        />
        <path
          className="white"
          d="M 407.77 116.02 414.25 116.06 414.4 122.58 407.89 122.57 407.91 119.29 407.75 117.65 407.77 116.02 Z"
          data-name="Grant"
          data-stusps="MN"
          id="27051"
        />
        <path
          className="white"
          d="M 635.31 293.44 635.44 293.25 635.68 292.83 636.73 292.5 636.94 292.26 638.54 291.78 639.21 292.67 640.15 293.81 641.01 293.68 641.2 293.81 641.45 294.15 641.73 294.34 642.05 294.85 642.47 295.15 642.47 295.76 642.19 296.66 633.22 297.61 634.5 295.3 635.31 293.44 Z"
          data-name="Catawba"
          data-stusps="NC"
          id="37035"
        />
        <path
          className="white"
          d="M 324.12 220.99 334.3 221.64 334.58 221.65 334.17 228.19 332.91 228.11 331.01 227.99 326.83 227.71 323.66 227.48 324.1 221.19 324.12 220.99 Z"
          data-name="Dundy"
          data-stusps="NE"
          id="31057"
        />
        <path
          className="white"
          d="M 542.68 252.34 544.57 252.62 544.89 252.3 545.48 252.45 546.13 251.78 548.42 251.56 548.68 254.03 548.96 256.5 547.32 256.93 547.41 257.76 544.06 258.11 543.18 257.65 542.68 252.34 Z"
          data-name="Dubois"
          data-stusps="IN"
          id="18037"
        />
        <path
          className="white"
          d="M 569.79 197.18 574.7 196.52 574.82 197.35 576.46 197.14 576.57 197.95 577 201.24 576.18 201.36 570.43 202.13 570.11 199.64 569.79 197.18 Z"
          data-name="Paulding"
          data-stusps="OH"
          id="39125"
        />
        <path
          className="white"
          d="M 758.39 147.44 758.83 146.44 759.76 146.67 760.87 147.62 760.49 148.81 759.15 148.21 758.39 147.44 Z"
          data-name="Bristol"
          data-stusps="RI"
          id="44001"
        />
        <path
          className="white"
          d="M 374.16 164.34 379.42 164.53 382.24 164.61 382.15 170.27 374.06 166.77 374.16 164.34 Z"
          data-name="Douglas"
          data-stusps="SD"
          id="46043"
        />
        <path
          className="white"
          d="M 667.48 471.78 677.54 470.55 678.35 470.31 679.17 470.48 679.76 470.4 680.97 470.25 681.4 470.33 681.4 471.73 681.38 474.76 681.38 474.88 681.48 476.23 681.55 477.04 681.55 477.08 679.97 477.28 678.44 477.51 677.92 477.83 671.81 478.57 671.76 478.15 668.42 478.53 667.68 473.2 667.48 471.78 Z"
          data-name="Broward"
          data-stusps="FL"
          id="12011"
        />
        <path
          className="white"
          d="M 350.72 229.12 355.98 229.37 358.65 229.48 358.7 229.48 358.31 237.63 350.56 237.28 350.28 237.27 350.72 229.12 Z"
          data-name="Norton"
          data-stusps="KS"
          id="20137"
        />
        <path
          className="white"
          d="M 542.38 138.28 548.02 137.69 548.79 144.25 545.77 144.56 541.09 144.89 541.47 143.88 542.33 141.58 542.44 140.5 542.29 138.96 542.38 138.28 Z"
          data-name="Manistee"
          data-stusps="MI"
          id="26101"
        />
        <path
          className="white"
          d="M 58.49 197.48 60.3 197.99 61.04 197.48 62.2 197.5 63.25 197.07 63.26 197.07 63.91 198.4 65.18 198.76 64.78 200.87 61.8 199.47 58.21 198.49 58.49 197.48 Z"
          data-name="Carson City"
          data-stusps="NV"
          id="32510"
        />
        <path
          className="white"
          d="M 635.2 289.02 636.11 288.32 639.66 287.39 640.28 288.98 640.02 290.97 639.21 292.67 638.54 291.78 636.94 292.26 636.73 292.5 635.68 292.83 635.45 292.32 635.2 289.02 Z"
          data-name="Alexander"
          data-stusps="NC"
          id="37003"
        />
        <path
          className="white"
          d="M 637.2 273.02 640.55 271.58 641.57 270.91 642.4 270.46 643.03 269.65 646.3 273.45 645.57 274.83 644.36 274.86 644.51 276.67 643.08 276.82 641.01 277.16 639.62 275.67 639.93 275.13 640.05 274.78 639.83 274.74 639.64 274.95 639.47 274.82 639.44 275.15 639.28 275.31 637.2 273.02 Z"
          data-name="Carroll"
          data-stusps="VA"
          id="51035"
        />
        <path
          className="white"
          d="M 19.23 181.08 27.33 183.61 28.33 183.32 30.21 183.92 31.79 185.04 31.5 185.5 31.05 186.48 29.76 188.67 29.97 190.98 30.91 192.87 29.9 194.04 22.37 191.72 21.57 190.66 21.85 189.54 20.89 188.55 21.83 186.31 19.2 184.11 18.25 182.27 19.07 181.35 18.54 180.87 19.23 181.08 Z"
          data-name="Colusa"
          data-stusps="CA"
          id="6011"
        />
        <path
          className="white"
          d="M 536.88 252.54 538.5 252.21 539.49 252.7 540.12 252.01 542.12 251.96 542.68 252.34 543.18 257.65 539.84 257.98 539.54 257.73 539.31 255.19 537.97 255.42 537 253.8 536.88 252.54 Z"
          data-name="Pike"
          data-stusps="IN"
          id="18125"
        />
        <path
          className="white"
          d="M 559.73 278.26 560.34 278.34 560.38 276.17 562.68 276.29 565.08 275.62 564.65 276.27 565.03 276.77 565.82 281.8 565.33 281.95 562.46 284.41 560.88 282.99 560.77 281.23 560.22 281.93 559.17 280.73 559.73 278.26 Z"
          data-name="Barren"
          data-stusps="KY"
          id="21009"
        />
        <path
          className="white"
          d="M 428.77 111.41 430.33 112.25 431.73 111.67 432.85 112.68 432.25 113.43 432.46 114.95 439.83 114.8 439.91 118.05 440.6 121.06 432.86 121.24 433.95 122.09 430.77 122.17 429.05 122.2 428.77 111.41 Z"
          data-name="Morrison"
          data-stusps="MN"
          id="27097"
        />
        <path
          className="white"
          d="M 403.1 275.51 411.53 275.61 411.51 279.68 411.47 280.11 411.47 281.32 403.07 281.21 403.08 277.96 403.1 275.51 Z"
          data-name="Elk"
          data-stusps="KS"
          id="20049"
        />
        <path
          className="white"
          d="M 497.6 278.51 498.68 278.5 498.34 273.15 502.61 272.85 503.09 281.73 501.69 281.8 501.25 283.47 499.51 283.56 499.47 282.72 497.78 282.81 497.6 278.51 Z"
          data-name="Bollinger"
          data-stusps="MO"
          id="29017"
        />
        <path
          className="white"
          d="M 379.09 294.14 388.79 294.34 388.81 294.34 388.68 302.38 385.42 302.32 378.9 302.18 379.03 296.59 379.09 294.14 Z"
          data-name="Garfield"
          data-stusps="OK"
          id="40047"
        />
        <path
          className="white"
          d="M 423.68 402.61 427.87 398.51 429.4 396.54 431.09 397.32 433.76 397.95 433.95 398.13 432.41 399.03 434.33 408.09 434.46 408.76 431.3 408.81 430.58 408.84 429.4 408.77 429.71 407.87 427.51 407.23 426.05 405.3 424.74 405.05 424.8 403.4 423.68 402.61 Z"
          data-name="Polk"
          data-stusps="TX"
          id="48373"
        />
        <path
          className="white"
          d="M 641.06 227.74 642.11 227.38 643.82 228.54 645.14 228.82 644.76 230.14 644.82 234.05 643.19 234.38 642.71 235.42 642.18 235.71 640.93 235.09 640.55 234.36 640.54 232.29 641.29 230.53 641.06 227.74 Z"
          data-name="Upshur"
          data-stusps="WV"
          id="54097"
        />
        <path
          className="white"
          d="M 541.82 356.78 546.48 356.48 546.69 358.9 545.94 359.79 546.18 363.08 545.36 363.15 545.63 366.42 542.37 366.69 542.31 365.87 540.97 365.97 541.29 364.86 542.08 364.65 540.8 363.92 540.71 361.68 539.71 361.57 540.55 360.6 540.22 360.05 540.57 358.95 541.67 357.88 541.82 356.78 Z"
          data-name="Hale"
          data-stusps="AL"
          id="1065"
        />
        <path
          className="white"
          d="M 448.78 375.81 451.1 375.76 451.75 375.78 455.18 375.69 455.64 377.32 456.77 380.59 454.9 380.63 454.91 381.93 453.04 381.44 451.65 380.4 450.03 378.32 450.05 376.61 448.78 375.81 Z"
          data-name="Red River"
          data-stusps="LA"
          id="22081"
        />
        <path
          className="white"
          d="M 503.94 257.36 505.8 255.97 507.15 256.15 509.01 255.07 512.1 255.15 512.13 255.69 512.44 260.6 505.83 260.94 504.2 261.05 503.94 257.36 Z"
          data-name="Washington"
          data-stusps="IL"
          id="17189"
        />
        <path
          className="white"
          d="M 419.57 176.06 426.11 176.01 426.18 182.57 419.6 182.6 419.57 176.06 Z"
          data-name="Buena Vista"
          data-stusps="IA"
          id="19021"
        />
        <path
          className="white"
          d="M 398.89 258.31 405.76 258.38 405.67 264.92 405.65 266.55 403.21 266.52 398.49 266.49 398.59 261.56 398.89 258.31 Z"
          data-name="Chase"
          data-stusps="KS"
          id="20017"
        />
        <path
          className="white"
          d="M 633.47 356.1 635.58 358.2 635.13 361.09 634.2 361.01 630.76 360.69 630.33 360.12 631.62 356.69 632.62 355.8 633.47 356.1 Z"
          data-name="Candler"
          data-stusps="GA"
          id="13043"
        />
        <path
          className="white"
          d="M 575.75 191.94 582.24 191.01 582.43 192.38 583.11 197.02 578.18 197.73 577.51 192.81 575.9 193.03 575.75 191.94 Z"
          data-name="Henry"
          data-stusps="OH"
          id="39069"
        />
        <path
          className="white"
          d="M 611.85 386.82 612.63 384.28 612.33 381.99 613.18 381.91 613.55 381.41 615.38 383.23 615.96 385.97 616.69 386.55 616.52 387.27 613.57 387.51 612.28 387.23 611.85 386.82 Z"
          data-name="Cook"
          data-stusps="GA"
          id="13075"
        />
        <path
          className="white"
          d="M 377.98 369.78 385.12 369.98 385.07 374.42 382.41 374.41 379.79 375.92 379.72 375.72 377.94 370.67 377.98 369.78 Z"
          data-name="Hood"
          data-stusps="TX"
          id="48221"
        />
        <path
          className="white"
          d="M 686.35 235.17 685.72 235.51 685.01 234.96 685.29 234.57 686.35 235.17 Z"
          data-name="Fredericksburg"
          data-stusps="VA"
          id="51630"
        />
        <path
          className="white"
          d="M 683.27 265.51 682.74 260.79 683.41 261.36 684.59 261.09 685.33 260.81 688.48 262.19 689.19 265.62 688.11 269.15 686.08 269.56 683.83 270 683.27 265.51 Z"
          data-name="Brunswick"
          data-stusps="VA"
          id="51025"
        />
        <path
          className="white"
          d="M 456.19 223.52 458.65 223.42 463.45 223.18 463.51 224 463.75 228.99 456.5 229.25 456.37 229.25 456.19 223.52 Z"
          data-name="Adair"
          data-stusps="MO"
          id="29001"
        />
        <path
          className="white"
          d="M 611.29 351.44 614.67 349.48 615.77 350.51 616.73 352.13 617.61 352.34 618.11 353.87 618.24 353.8 618.19 354.79 614.16 357.66 610.56 352.07 611.29 351.44 Z"
          data-name="Wilkinson"
          data-stusps="GA"
          id="13319"
        />
        <path
          className="white"
          d="M 309.79 325.71 315.32 326.06 317.96 326.21 317.47 334.38 316.03 334.29 309.24 333.86 309.79 325.71 Z"
          data-name="Castro"
          data-stusps="TX"
          id="48069"
        />
        <path
          className="white"
          d="M 629.59 329.33 630.18 329.09 631.94 328.58 633.14 330.51 636.21 331.09 631.17 337.3 630.94 337.02 629.58 336.23 629.44 336.2 629.65 335.48 628.03 333.96 628.86 331.81 627.94 330.02 629.59 329.33 Z"
          data-name="Edgefield"
          data-stusps="SC"
          id="45037"
        />
        <path
          className="white"
          d="M 707.24 199.75 707.26 199.74 707.44 199.65 707.56 199.58 708.91 199.46 710 199.75 709.52 200.59 709.48 201.61 709.14 202.27 708.94 203.1 708.66 203.51 709.04 204.1 709.58 204.33 709.55 205.19 709.71 205.9 708.84 206.48 709.33 207.17 710.3 207.96 710.61 208.24 709.72 209.68 709.2 209.78 708.82 210.23 707.84 210.31 707.18 210.51 706.73 209 706.73 209 704.9 202.55 705.11 202.5 705.25 201.75 705.63 200.97 706.29 200.24 707.24 199.75 Z"
          data-name="New Castle"
          data-stusps="DE"
          id="10003"
        />
        <path
          className="white"
          d="M 458.92 212.98 465.47 212.7 465.7 218.32 463.25 218.48 461.78 218.57 459.15 218.75 458.92 212.98 Z"
          data-name="Davis"
          data-stusps="IA"
          id="19051"
        />
        <path
          className="white"
          d="M 424.85 254.28 427.02 254.27 431.41 254.22 431.43 257.79 431.43 259.1 431.43 259.1 431.45 260.77 424.76 260.82 424.72 255.1 424.85 254.28 Z"
          data-name="Miami"
          data-stusps="KS"
          id="20121"
        />
        <path
          className="white"
          d="M 353.26 172.87 358.06 173.1 362.42 173.3 366.27 173.47 366.09 177.1 363.88 177.62 362.14 178.57 360.21 178.23 354.24 176.65 353.11 175.72 353.26 172.87 Z"
          data-name="Keya Paha"
          data-stusps="NE"
          id="31103"
        />
        <path
          className="white"
          d="M 247.2 352.55 247.77 346.17 257.56 347.13 257.42 348.75 263.89 349.34 263.6 352.61 263.32 355.82 261.96 364.11 269.98 364.78 269.22 374.58 268.08 374.49 264.3 374.16 254.72 373.27 250.74 372.9 247.48 372.59 244.64 372.33 246.45 354.27 247.02 354.33 247.2 352.55 Z"
          data-name="Otero"
          data-stusps="NM"
          id="35035"
        />
        <path
          className="white"
          d="M 652.63 295.87 654.36 295.57 654.37 295.56 655.66 296.22 656.82 297.75 656.45 300.07 657.15 302.14 656.42 301.27 655.62 302.3 653.85 301.65 652.7 302.43 650.33 302.42 650.4 302.08 652.63 295.87 Z"
          data-name="Stanly"
          data-stusps="NC"
          id="37167"
        />
        <path
          className="white"
          d="M 565.55 341.99 566.99 340.24 566.52 338.79 567.9 337.28 569.75 336.29 571.44 336.54 571.41 335.91 574.53 335.82 574.75 336.09 573.37 339.43 573.36 342.22 571.28 343.77 571.25 343.22 568.09 343.51 567.05 341.93 565.55 341.99 Z"
          data-name="Calhoun"
          data-stusps="AL"
          id="1015"
        />
        <path
          className="white"
          d="M 442.82 347.55 444.79 347.56 444.82 342.68 445.97 342.69 449.46 343.81 450.57 343.53 450.4 346 450.36 352.55 446.64 352.52 445.81 352.22 444.93 350.16 442.68 348.96 442.63 347.77 442.82 347.55 Z"
          data-name="Hempstead"
          data-stusps="AR"
          id="5057"
        />
        <path
          className="white"
          d="M 504.15 246.35 504.89 245.74 509.81 245.4 509.75 245.95 509.87 247.49 510.15 250.78 505.1 251.11 504.89 248.65 504.28 247.86 504.29 247.86 504.15 246.35 Z"
          data-name="Bond"
          data-stusps="IL"
          id="17005"
        />
        <path
          className="white"
          d="M 534.89 222.5 534.36 221.82 536.89 218.85 538.98 217.56 539.26 220.41 539.77 225.33 535.01 225.8 534.7 225.67 534.89 222.5 Z"
          data-name="Fountain"
          data-stusps="IN"
          id="18045"
        />
        <path
          className="white"
          d="M 440.96 136.92 440.99 134.97 442.09 133.63 442.21 133.56 442.28 133.58 442.46 133.48 442.5 133.42 442.58 133.34 442.58 133.18 442.3 132.81 444.09 131.78 444.22 131.79 445.38 132.34 446.1 133 446.94 133.62 447.16 134.08 447.41 134.37 447.39 134.96 447.38 135.65 448.13 135.62 448.38 135.61 448.56 137.97 448.87 138.36 448.62 138.87 447.93 139.84 446.91 140.25 446.54 140.37 444.35 140.07 444.3 138.44 440.99 138.55 440.96 136.92 Z"
          data-name="Hennepin"
          data-stusps="MN"
          id="27053"
        />
        <path
          className="white"
          d="M 335.1 270.93 341.62 271.28 341.36 276.18 341.28 277.82 335.05 277.49 334.73 277.47 335.1 270.93 Z"
          data-name="Haskell"
          data-stusps="KS"
          id="20081"
        />
        <path
          className="white"
          d="M 627.46 287.96 629.51 287.44 631.52 287.24 633.93 287.87 635.2 289.02 635.45 292.32 635.68 292.83 635.44 293.25 635.31 293.44 632.32 293.7 629.67 292.2 627.93 290.78 628.74 288.62 627.46 287.96 Z"
          data-name="Caldwell"
          data-stusps="NC"
          id="37027"
        />
        <path
          className="white"
          d="M 356.37 293.45 361.07 293.58 361.22 289.37 361.87 290.04 363.54 290.14 366.14 293.68 366.08 295.41 365.94 301.88 359.46 301.61 356.2 301.49 356.37 293.45 Z"
          data-name="Woodward"
          data-stusps="OK"
          id="40153"
        />
        <path
          className="white"
          d="M 510.48 310.4 511.72 305.75 512.43 305.8 512.73 306.32 516.98 307.85 517.17 312.77 515.58 312.85 515.6 313.52 513.08 313.63 512.66 313.67 511.13 313.71 511.02 311.01 510.48 310.4 Z"
          data-name="Haywood"
          data-stusps="TN"
          id="47075"
        />
        <path
          className="white"
          d="M 700.61 175.59 703.43 177.61 702.47 178.56 703.61 179.75 704.53 180.79 703.12 181.44 702.72 181.78 701.57 182.4 700.82 183.27 698.61 182.18 696.57 180.73 696.72 180.61 699.95 178.03 699.06 176.55 699.95 175.57 700.61 175.59 Z"
          data-name="Carbon"
          data-stusps="PA"
          id="42025"
        />
        <path
          className="white"
          d="M 287.75 174.98 291.04 175.32 289.2 193.29 280.4 192.29 280.66 190.69 281.94 177.72 282.27 174.44 287.75 174.98 Z"
          data-name="Platte"
          data-stusps="WY"
          id="56031"
        />
        <path
          className="white"
          d="M 389.86 333.48 393.09 333.53 392.25 331.34 396.4 331.13 396.39 331.95 398.03 331.96 398.01 333.6 397.18 333.59 397.14 336.83 396.33 336.83 394.84 336.82 394.7 336 389.83 335.93 389.86 333.48 Z"
          data-name="Murray"
          data-stusps="OK"
          id="40099"
        />
        <path
          className="white"
          d="M 372.38 210.36 378.56 210.56 378.61 210.93 378.53 213.89 378.44 217.09 372.17 216.89 372.38 210.36 Z"
          data-name="Hall"
          data-stusps="NE"
          id="31079"
        />
        <path
          className="white"
          d="M 720.27 137.07 720.27 136.82 719.56 134.83 719.72 134.2 720.02 133.94 722.76 132.82 725.01 132.49 725.53 134.59 725.53 135.23 726.18 136.18 726.2 138.48 726.22 140.97 720.44 143.49 720.35 142.6 720 140.65 720.27 137.07 Z"
          data-name="Rensselaer"
          data-stusps="NY"
          id="36083"
        />
        <path
          className="white"
          d="M 691.93 312.05 695 310.36 697.08 311.93 696.44 312.92 695.7 314.7 695.24 317.23 693.43 313.69 691.93 312.05 Z"
          data-name="New Hanover"
          data-stusps="NC"
          id="37129"
        />
        <path
          className="white"
          d="M 515.91 332.71 520.85 332.37 522.49 332.54 522.88 337.98 517.96 338.33 516.31 338.44 516.19 336.8 515.91 332.71 Z"
          data-name="Pontotoc"
          data-stusps="MS"
          id="28115"
        />
        <path
          className="white"
          d="M 325.71 293.67 333.88 294.15 333.42 302.44 333.42 302.48 325.22 302.01 325.71 293.67 Z"
          data-name="Hansford"
          data-stusps="TX"
          id="48195"
        />
        <path
          className="white"
          d="M 364.4 442.8 372.1 442.96 372.08 443.63 371.88 454.02 364.08 453.85 364.2 451.14 364.4 442.8 Z"
          data-name="McMullen"
          data-stusps="TX"
          id="48311"
        />
        <path
          className="white"
          d="M 452.22 353.1 454.49 353.12 456.14 352.84 456.13 354.21 458.34 354.21 458.36 360.96 455.07 361.03 454.42 361.04 452.23 361.09 450.44 361.13 450.47 356.6 451.1 356.62 452.22 353.1 Z"
          data-name="Columbia"
          data-stusps="AR"
          id="5027"
        />
        <path
          className="white"
          d="M 612.67 326.36 614.25 326.42 617.28 324.52 617.86 325.28 618.07 325.82 618.56 327.05 619.87 328.16 620.79 329.35 620.85 329.43 621.44 330.36 620.23 330.18 620.07 330.01 618.82 330.17 617.99 330.53 615.31 330.03 614.71 329.57 612.4 327.41 612.67 326.36 Z"
          data-name="Elbert"
          data-stusps="GA"
          id="13105"
        />
        <path
          className="white"
          d="M 496.38 241.9 496.73 246.83 494.85 246.95 494.9 248.45 494.57 248.39 493.11 247.79 492.3 247.81 492.04 247.68 491.07 247.94 489.89 245.01 490.15 243.73 494.07 243.7 494 242.74 496.38 241.9 Z"
          data-name="Jersey"
          data-stusps="IL"
          id="17083"
        />
        <path
          className="white"
          d="M 342.7 222.15 350.75 222.57 350.49 229.11 346.4 228.9 342.62 228.69 342.33 228.67 342.7 222.15 Z"
          data-name="Red Willow"
          data-stusps="NE"
          id="31145"
        />
        <path
          className="white"
          d="M 461.7 201.4 463.32 201.33 468.28 201.09 468.58 207.61 465.25 207.77 461.99 207.92 461.7 201.4 Z"
          data-name="Keokuk"
          data-stusps="IA"
          id="19107"
        />
        <path
          className="white"
          d="M 520.95 241.01 520.71 238.01 527.39 237.36 527.79 241.21 522.63 241.7 521.02 241.83 520.95 241.01 Z"
          data-name="Cumberland"
          data-stusps="IL"
          id="17035"
        />
        <path
          className="white"
          d="M 622.21 371.44 624.84 369.05 625.06 369.12 625.84 368.78 626.61 368.15 627.65 368.1 627.57 367.84 628.41 367.79 628.72 370.22 627.28 370.39 627.02 372.39 627.56 372.81 627.65 373.54 625.93 373.75 622.54 374.19 622.21 371.44 Z"
          data-name="Jeff Davis"
          data-stusps="GA"
          id="13161"
        />
        <path
          className="white"
          d="M 586.77 349.15 586.86 348.52 592.42 347.97 592.59 348.66 592.25 351.51 592.55 352.74 592.49 352.94 592.67 353.81 593.05 354.38 592.11 355.18 590.04 355.42 589.18 355.04 587.41 355.16 586.77 349.15 Z"
          data-name="Meriwether"
          data-stusps="GA"
          id="13199"
        />
        <path
          className="white"
          d="M 606.09 322.19 607.1 318.39 607.46 318.13 607.49 318.21 608.53 318.79 609.5 319.34 610.59 319.62 611.53 320.48 610.5 321.77 607.09 322.5 606.09 322.19 Z"
          data-name="Stephens"
          data-stusps="GA"
          id="13257"
        />
        <path
          className="white"
          d="M 623.62 357.87 626.22 357.94 628.06 358.69 627.83 360.39 627.83 360.4 624.07 361.69 624 361.96 623.72 362.07 622.91 361.87 622.43 361.56 623.62 357.87 Z"
          data-name="Treutlen"
          data-stusps="GA"
          id="13283"
        />
        <path
          className="white"
          d="M 608.98 353.28 610.56 352.07 614.16 357.66 611.37 359.57 610.11 360.68 608.64 356.9 608.04 356.85 607.79 355.4 608.98 353.28 Z"
          data-name="Twiggs"
          data-stusps="GA"
          id="13289"
        />
        <path
          className="white"
          d="M 238.68 251.29 239.32 252.74 239.29 254.33 239.94 256.07 238.85 257.77 237.76 257.63 236.78 258.89 236.17 258.56 235.52 256.89 234.17 256.27 234.41 254.3 233.39 253.47 233.98 252.27 231.85 251.29 231.37 249.76 238.68 251.29 Z"
          data-name="Ouray"
          data-stusps="CO"
          id="8091"
        />
        <path
          className="white"
          d="M 414.13 286.94 417.34 286.93 418.11 286.93 419.83 286.92 419.48 287.99 419.51 294.46 413.79 294.47 413.79 288.02 414.13 286.94 Z"
          data-name="Nowata"
          data-stusps="OK"
          id="40105"
        />
        <path
          className="white"
          d="M 673.31 278.02 672.35 272.19 673.3 272.02 676.74 271.4 677.54 271.24 677.02 271.87 677.02 273.04 678.23 278.31 677.81 280.24 678 281.36 675.7 280.75 674.66 281.01 673.74 280.85 673.31 278.02 Z"
          data-name="Granville"
          data-stusps="NC"
          id="37077"
        />
        <path
          className="white"
          d="M 685.82 223.81 686.68 223.61 686.78 224.08 686.41 224.26 686.09 224.35 685.82 223.81 Z"
          data-name="Fairfax"
          data-stusps="VA"
          id="51059"
        />
        <path
          className="white"
          d="M 393.83 269.68 393.86 266.4 398.49 266.49 403.21 266.52 403.1 275.51 403.08 277.96 393.7 277.88 393.83 269.68 Z"
          data-name="Butler"
          data-stusps="KS"
          id="20015"
        />
        <path
          className="white"
          d="M 688.63 221.84 689.55 220.43 690.24 220.88 691.92 221.96 691.1 223.22 690.41 224.29 690.21 223.35 690.1 222.84 689.19 222.31 688.63 221.84 Z"
          data-name="District of Columbia"
          data-stusps="DC"
          id="11001"
        />
        <path
          className="white"
          d="M 15.59 223.94 17.26 227.4 19.22 228.97 19.63 229.67 20.27 231.51 22.19 233.96 21.19 233.78 20.47 233.04 18.34 233.87 18.04 232.08 17.57 231.16 16.88 230.9 15.6 230.95 15 230.72 14.41 230.5 13.2 228.92 12.7 227.55 12.49 226.87 12.37 226.76 12.48 225.08 15.18 225.3 15.59 223.94 Z"
          data-name="Santa Cruz"
          data-stusps="CA"
          id="6087"
        />
        <path
          className="white"
          d="M 331.75 430.72 332.48 430.65 333.59 427.28 333.73 423.45 343.37 423.84 343.01 433.91 333.79 433.61 333.74 433.3 332.89 432.71 332.18 431.94 331.85 430.82 331.75 430.72 Z"
          data-name="Kinney"
          data-stusps="TX"
          id="48271"
        />
        <path
          className="white"
          d="M 652.68 223.65 653.52 223.06 654.39 221.93 655.3 221.14 655.56 220.76 657.48 220.67 660.03 221.65 659.13 225.73 660.16 227.71 659.27 230.1 655.57 227.98 655.43 227.86 655.93 225.65 655.04 225.55 655.32 223.1 652.72 223.86 652.68 223.65 Z"
          data-name="Grant"
          data-stusps="WV"
          id="54023"
        />
        <path
          className="white"
          d="M 522.92 359.66 524.53 359.56 531.9 358.99 531.79 363.1 531.71 365.64 523.35 366.23 522.92 359.66 Z"
          data-name="Kemper"
          data-stusps="MS"
          id="28069"
        />
        <path
          className="white"
          d="M 98.95 191.37 105 182.32 106.34 180.32 109.63 181.14 111.34 174.39 117.53 175.94 117.36 176.61 117.13 176.93 114.24 188.78 113.01 193.45 109.91 206.69 108.82 210.71 98.03 208.04 91.13 207.72 90.93 206.6 92.53 205.65 92.69 202.54 94.65 201.88 94.69 201.05 95.91 200.36 97.58 200.22 98.3 198.84 98.41 196.33 99.57 193.83 98.95 191.37 Z"
          data-name="Lander"
          data-stusps="NV"
          id="32015"
        />
        <path
          className="white"
          d="M 432.85 112.68 432.86 106.04 432.64 102.77 439.96 102.65 440.04 106.65 439.78 113.02 439.97 113.17 439.79 113.34 439.83 114.8 432.46 114.95 432.25 113.43 432.85 112.68 Z"
          data-name="Crow Wing"
          data-stusps="MN"
          id="27035"
        />
        <path
          className="white"
          d="M 313.37 88.08 320.62 88.8 321.47 88.88 320.86 95.41 318.31 95.18 317.68 101.75 312.79 101.28 313.44 94.71 312.71 94.64 313.37 88.08 Z"
          data-name="Billings"
          data-stusps="ND"
          id="38007"
        />
        <path
          className="white"
          d="M 374.41 257.84 382.61 258.03 382.49 264.58 378.14 264.75 378.14 264.47 374.34 264.39 374.38 263.15 374.28 262.73 374.41 257.84 Z"
          data-name="Rice"
          data-stusps="KS"
          id="20159"
        />
        <path
          className="white"
          d="M 560.59 121.21 559.3 112 559.48 112.03 561.87 113.2 563.2 113.9 563.79 113.48 564.91 113.42 566.57 113.91 566.03 113.99 567.28 122 565.68 122.23 560.79 122.86 560.59 121.21 Z"
          data-name="Cheboygan"
          data-stusps="MI"
          id="26031"
        />
        <path
          className="white"
          d="M 526.85 218.09 526.66 216.47 532.51 215.83 532.53 216.1 532.89 220.35 533.06 222.28 533.28 224.85 533.51 227.26 533.17 227.56 532.31 227.4 527.64 227.86 527 221.37 526.85 218.09 Z"
          data-name="Vermilion"
          data-stusps="IL"
          id="17183"
        />
        <path
          className="white"
          d="M 513.09 406.86 513.9 405.9 515.56 405.54 515.42 403.07 518.72 402.9 519.04 408.34 519.65 409.32 519.05 409.56 517.8 410.53 517.47 411.31 517.02 411.59 516.24 411.84 514.84 411.23 514.31 409.54 513.48 407.6 513.09 406.86 Z"
          data-name="Hancock"
          data-stusps="MS"
          id="28045"
        />
        <path
          className="white"
          d="M 486.82 309.34 498.32 308.89 498.59 313.8 495.28 313.92 493.6 313.88 487.03 314.32 486.82 309.34 Z"
          data-name="Poinsett"
          data-stusps="AR"
          id="5111"
        />
        <path
          className="white"
          d="M 559.77 393.42 561.35 393.31 563.38 393.16 566.22 392.93 567.07 404.57 566.82 404.54 563.19 404.54 560.48 404.98 559.77 393.42 Z"
          data-name="Okaloosa"
          data-stusps="FL"
          id="12091"
        />
        <path
          className="white"
          d="M 56.72 46.47 57.99 46.96 58.54 47.12 57.12 51.12 56.06 51.29 54.99 50.85 54.9 50.82 54.38 49.87 54.75 49 54.36 48.01 53.41 47.87 51.9 47.13 51.77 46.26 51.32 46.39 52.01 44.66 56.72 46.47 Z"
          data-name="Wahkiakum"
          data-stusps="WA"
          id="53069"
        />
        <path
          className="white"
          d="M 497.6 147.8 502.64 147.45 507.21 147.08 507.63 151.95 503.8 152.28 497.98 152.75 497.6 147.8 Z"
          data-name="Waushara"
          data-stusps="WI"
          id="55137"
        />
        <path
          className="white"
          d="M 526.77 330.34 530.08 330.12 532.8 329.93 532.72 332.62 532.58 337.07 527.26 337.41 526.77 330.34 Z"
          data-name="Itawamba"
          data-stusps="MS"
          id="28057"
        />
        <path
          className="white"
          d="M 569.94 245.96 570.17 246.12 570.75 245.9 571.75 244.9 572.47 244.49 573.51 245.87 573.96 246.15 573.87 246.39 572.04 247.63 570.68 248.01 570.05 248.18 567.92 245.48 568.75 245.26 569.34 245.55 569.94 245.96 Z"
          data-name="Carroll"
          data-stusps="KY"
          id="21041"
        />
        <path
          className="white"
          d="M 654.37 295.56 656.16 295.24 660.78 294.36 662.61 299.04 664.28 300.57 660.52 300.8 657.15 302.14 656.45 300.07 656.82 297.75 655.66 296.22 654.37 295.56 Z"
          data-name="Montgomery"
          data-stusps="NC"
          id="37123"
        />
        <path
          className="white"
          d="M 288.44 145.27 297.97 146.2 302.29 146.67 302.22 147.41 301.68 152.81 301.13 158.35 301.03 159.38 289.47 158.24 287 157.99 288.44 145.27 Z"
          data-name="Weston"
          data-stusps="WY"
          id="56045"
        />
        <path
          className="white"
          d="M 600.06 197.85 604.23 197.26 604.9 200.42 606.35 202.06 606.62 203.72 606.89 205.29 606.36 205.45 602.79 206.02 602.15 203.87 602.28 203.03 601.38 203.13 600.84 203.21 600.06 197.85 Z"
          data-name="Richland"
          data-stusps="OH"
          id="39139"
        />
        <path
          className="white"
          d="M 343.32 189.45 351.41 189.93 351.11 196.43 344.83 196.1 342.99 195.98 343.32 189.45 Z"
          data-name="Thomas"
          data-stusps="NE"
          id="31171"
        />
        <path
          className="white"
          d="M 654.4 331.74 655.48 329.75 658.27 328.19 659.21 327.2 662.39 324.61 663.03 325.69 664.14 325.52 663.72 326.89 662.59 328.06 663.07 328.88 661.71 333.47 661.09 334.51 659.95 334.78 657.22 335.17 655.25 333.27 654.35 332.03 654.4 331.74 Z"
          data-name="Clarendon"
          data-stusps="SC"
          id="45027"
        />
        <path
          className="white"
          d="M 723.88 180.41 723.71 179.68 723.74 179.66 724.1 179.29 724.24 179.24 725.28 178.86 725.43 178.51 725.72 178.75 725.83 179.21 726.17 179.61 726.29 179.85 725.97 179.77 725.41 180.92 724.33 181.93 723.5 182.33 723.45 181.48 723.85 181.11 723.88 180.41 Z"
          data-name="Richmond"
          data-stusps="NY"
          id="36085"
        />
        <path
          className="white"
          d="M 567.83 257.24 567.84 256.69 570.82 257.46 571.39 257.67 572.88 258.21 571.96 259.08 572.04 259.56 568.65 260.55 567.2 259.75 566.75 259.41 567.75 257.51 567.83 257.24 Z"
          data-name="Spencer"
          data-stusps="KY"
          id="21215"
        />
        <path
          className="white"
          d="M 375.42 411.02 380.47 415.34 381.19 415.96 381.69 416.39 382.86 417.39 382.8 417.44 379.7 420.45 380.09 420.44 378.96 421.38 378.03 422.39 377.79 421.46 377.55 420.58 376.09 419.34 373.26 416.94 375.42 411.02 Z"
          data-name="Hays"
          data-stusps="TX"
          id="48209"
        />
        <path
          className="white"
          d="M 666.86 140.75 667.31 140.51 668.38 140.33 670.18 139.75 672.04 139.6 672.7 139.46 674.06 138.45 675 137.97 675.56 137.46 676.98 142.23 677.08 143.32 673.67 144.34 671.33 144.9 670.07 144.64 669.67 144.84 667.95 145.23 666.86 140.75 Z"
          data-name="Wayne"
          data-stusps="NY"
          id="36117"
        />
        <path
          className="white"
          d="M 695.73 278.33 696.48 277.02 696.65 276.84 698.78 277.73 699.37 279.08 701.82 278.62 701.83 279.97 703.3 278.88 704.15 279.49 704.32 280.43 704.99 278.91 706.21 279.02 705.98 279.21 705.42 282.05 703.5 283.65 700.3 282.82 698.84 282.05 697.24 281.71 697.04 280.05 695.73 278.33 Z"
          data-name="Martin"
          data-stusps="NC"
          id="37117"
        />
        <path
          className="white"
          d="M 382.99 236.81 391.16 236.97 391.13 238.6 391.03 243.5 382.88 243.33 382.99 238.73 382.95 238.44 382.99 236.81 Z"
          data-name="Cloud"
          data-stusps="KS"
          id="20029"
        />
        <path
          className="white"
          d="M 374.9 143.04 384.66 143.39 386.29 143.44 386.29 145.07 386.12 151.62 379.66 151.42 374.68 151.26 374.9 143.04 Z"
          data-name="Beadle"
          data-stusps="SD"
          id="46005"
        />
        <path
          className="white"
          d="M 570.09 226.52 570.24 226.23 573.27 225.9 573.27 225.9 573.62 228.9 573.72 229.76 570.93 230.06 570.5 230.07 570.09 226.52 Z"
          data-name="Union"
          data-stusps="IN"
          id="18161"
        />
        <path
          className="white"
          d="M 357.89 278.69 365.86 278.93 366 279.1 365.78 286.15 363.84 286.08 359.66 285.93 358.92 285.9 357.64 285.85 357.89 278.69 Z"
          data-name="Comanche"
          data-stusps="KS"
          id="20033"
        />
        <path
          className="white"
          d="M 628.56 278.12 629.11 277.53 629.87 276.19 633.98 274.37 636.61 273.87 637.2 273.02 639.28 275.31 639.08 275.25 639.04 275.51 639.11 275.78 639.52 275.81 639.43 276.18 639.65 276.07 639.62 275.67 641.01 277.16 640.08 277.31 640.08 277.31 637.61 277.6 635.85 277.78 633.14 278.11 630.89 278.39 628.16 278.64 628.56 278.12 Z"
          data-name="Grayson"
          data-stusps="VA"
          id="51077"
        />
        <path
          className="white"
          d="M 610.11 360.68 611.37 359.57 614.16 357.66 615.94 360.54 615.32 360.05 613.46 362.4 612.94 363.79 610.22 361.63 610.11 360.68 Z"
          data-name="Bleckley"
          data-stusps="GA"
          id="13023"
        />
        <path
          className="white"
          d="M 589.98 157.84 596.68 156.49 597.16 157.7 598.42 159.36 598.41 160.4 598.04 161.7 598.45 164.06 598.24 166.49 597.46 168.22 596.23 169.03 595.56 167.23 596.37 166.33 595.38 166.21 594.28 162.11 590.91 162.71 589.98 157.84 Z"
          data-name="St. Clair"
          data-stusps="MI"
          id="26147"
        />
        <path
          className="white"
          d="M 559.3 112 560.59 121.21 557.5 121.6 557.06 122.03 555.58 120.49 556.13 120.4 557.36 120 557.89 119.29 556.94 119.04 556.12 119.01 555.01 117.54 554.75 116.67 555.34 115.24 556.41 114.2 555.64 112.89 557.6 112.78 558.74 111.91 559.3 112 Z"
          data-name="Emmet"
          data-stusps="MI"
          id="26047"
        />
        <path
          className="white"
          d="M 306.47 107.27 320.14 108.59 319.57 114.89 316.65 114.62 313.81 114.35 310.85 114.06 305.81 113.55 306.47 107.27 Z"
          data-name="Bowman"
          data-stusps="ND"
          id="38011"
        />
        <path
          className="white"
          d="M 558.42 203.36 562.8 202.78 563 204.43 563.62 209.37 561.98 209.58 559.26 209.91 558.42 203.36 Z"
          data-name="Huntington"
          data-stusps="IN"
          id="18069"
        />
        <path
          className="white"
          d="M 474.88 202.41 476.51 202.34 476.59 203.98 480.76 203.8 480.29 205.4 480.79 206.04 481.4 206.92 482.03 206.95 482.66 207.89 482.77 208.6 476.82 208.9 476.74 207.26 475.1 207.32 474.88 202.41 Z"
          data-name="Louisa"
          data-stusps="IA"
          id="19115"
        />
        <path
          className="white"
          d="M 499.22 186.32 503.29 185.96 506.41 185.68 506.49 186.69 507.62 186.59 509.74 186.39 510.12 191.29 503.49 191.92 503.36 191.56 500.45 191.84 499.62 191.36 499.22 186.32 Z"
          data-name="Ogle"
          data-stusps="IL"
          id="17141"
        />
        <path
          className="white"
          d="M 374.88 230.05 378.2 230.15 381.06 230.22 383.14 230.28 382.99 236.81 382.95 238.44 374.88 238.22 374.62 238.21 374.88 230.05 Z"
          data-name="Jewell"
          data-stusps="KS"
          id="20089"
        />
        <path
          className="white"
          d="M 382.88 243.33 391.03 243.5 390.96 246.76 390.89 250.03 382.73 249.86 382.83 244.96 382.83 243.88 382.88 243.33 Z"
          data-name="Ottawa"
          data-stusps="KS"
          id="20143"
        />
        <path
          className="white"
          d="M 391.26 230.45 396.46 230.53 397.8 230.55 398.41 230.56 399.39 230.57 399.35 233.83 399.29 238.73 397.08 238.7 391.13 238.6 391.16 236.97 391.26 230.45 Z"
          data-name="Washington"
          data-stusps="KS"
          id="20201"
        />
        <path
          className="white"
          d="M 393.33 317.22 393.37 315.59 401.29 315.7 401.3 316.86 398.95 316.64 398.88 326.22 398.3 325.38 397.19 325.71 396.5 324.99 395.17 326.04 393.22 325.63 393.33 317.22 Z"
          data-name="Pottawatomie"
          data-stusps="OK"
          id="40125"
        />
        <path
          className="white"
          d="M 556.63 311 558.28 311.52 560.65 309.51 560.36 310.01 560.74 311 561.01 311.16 560.24 313 560.24 314.98 559.54 315.12 558.9 313.05 556.68 311.81 556.63 311 Z"
          data-name="Moore"
          data-stusps="TN"
          id="47127"
        />
        <path
          className="white"
          d="M 410.97 340.21 414.28 340.22 423.98 340.18 424.02 344.27 422.92 343.84 422.49 344.44 422.03 345.42 421.61 345.5 420.96 345.61 419.47 345.6 418.25 345.29 417.76 344.52 417.02 344.51 415.99 344.92 414.93 345.1 414.12 345.54 412.1 344.56 411.8 340.81 410.97 340.21 Z"
          data-name="Choctaw"
          data-stusps="OK"
          id="40023"
        />
        <path
          className="white"
          d="M 411.16 318.98 411.16 317.35 412.79 317.36 412.79 315.73 413.6 315.72 413.6 314.08 415.28 314.07 420.92 314.06 420.95 318.9 420.24 318.26 419.31 318.86 416.99 320.27 416.78 319.73 414.63 321.09 412.86 320.93 412.28 321.73 411.13 321.57 411.16 318.98 Z"
          data-name="McIntosh"
          data-stusps="OK"
          id="40091"
        />
        <path
          className="white"
          d="M 415.94 332.03 418.38 332.01 418.37 330.39 425.42 330.35 427.31 330.33 427.34 333.59 425.64 333.6 425.68 338.54 424.05 338.55 423.98 340.18 414.28 340.22 414.28 333.66 415.94 333.66 415.94 332.03 Z"
          data-name="Pushmataha"
          data-stusps="OK"
          id="40127"
        />
        <path
          className="white"
          d="M 639.01 266.11 639.72 265.38 642.46 263.66 642.97 264.78 643.98 264.24 643.98 265.57 643.65 265.37 643.58 265.38 643.3 265.56 643.04 265.84 643.02 265.9 643.02 266.02 643.16 266.32 643.35 266.53 644.04 267.22 644.23 268.43 643.94 268.94 643.03 269.65 642.4 270.46 641.57 270.91 638.8 268.48 638.36 267.66 637.96 266.91 639.01 266.11 Z"
          data-name="Pulaski"
          data-stusps="VA"
          id="51155"
        />
        <path
          className="white"
          d="M 623.19 268.67 625.12 267.23 625.36 266.47 626.38 267.03 628.15 266.68 628.52 266.3 629.19 265.67 629.97 265.15 630.77 263.74 633.14 265.36 631.87 267.41 632.88 268.16 630.6 270.11 630 270.04 627.09 272.14 625.53 271.87 623.42 269.21 623.19 268.67 Z"
          data-name="Tazewell"
          data-stusps="VA"
          id="51185"
        />
        <path
          className="white"
          d="M 628.84 221.4 629.99 219.87 631.43 219.74 633.66 221.69 635.25 222.01 633.93 222.63 631.79 225.64 631.29 224.09 629.87 224.86 629.17 222.71 627.87 223.13 628.37 222.03 628.84 221.4 Z"
          data-name="Tyler"
          data-stusps="WV"
          id="54095"
        />
        <path
          className="white"
          d="M 637.89 217.92 638.68 218.28 641.52 217.8 645.19 220.21 643.24 221.86 641.61 222.01 640.22 221.43 637.01 221.33 636.64 219.58 637.34 217.97 637.89 217.92 Z"
          data-name="Marion"
          data-stusps="WV"
          id="54049"
        />
        <path
          className="white"
          d="M 581.15 309.75 582.04 308.39 582.35 308.42 584.61 309.4 584.32 309.84 585.07 309.96 585 310.2 585.21 311.52 584.42 315.1 583.89 315.16 583.1 315.25 581.3 315.46 581.49 314.91 580.59 313.53 580.22 312.74 581.15 309.75 Z"
          data-name="Bradley"
          data-stusps="TN"
          id="47011"
        />
        <path
          className="white"
          d="M 566.57 113.91 566.78 113.97 567.88 115.05 568.45 116.1 569.75 116.02 570.94 115.95 571.98 116.76 574 117.2 575.42 117.82 576.88 117.54 578.49 118.85 578.35 119.78 578.69 120.11 572.12 121.22 570.26 121.56 567.28 122 566.03 113.99 566.57 113.91 Z"
          data-name="Presque Isle"
          data-stusps="MI"
          id="26141"
        />
        <path
          className="white"
          d="M 498.29 272.32 498.8 271.73 500.27 268.8 501.2 267.64 501.36 267.81 502.39 267.12 503.48 267.97 504.8 268.65 504.96 268.98 505.29 269.65 506.48 270.25 507.55 270.69 507.87 272.01 508.12 272.84 508.08 273.04 508.03 273.25 506.47 272.52 502.61 272.85 498.34 273.15 498.29 272.32 Z"
          data-name="Perry"
          data-stusps="MO"
          id="29157"
        />
        <path
          className="white"
          d="M 701.07 264.62 703.64 261.07 705.58 258.29 706.82 257.51 707.56 257.57 707.5 258.86 707.15 259.92 707.28 261.3 707.68 265.1 706.9 265.26 703.88 265.88 701.18 266.54 700.89 266.33 701.07 264.62 Z"
          data-name="Suffolk"
          data-stusps="VA"
          id="51800"
        />
        <path
          className="white"
          d="M 309.39 384.06 309.88 384.09 318.1 384.56 317.51 395.29 309.03 394.69 309.39 384.06 Z"
          data-name="Upton"
          data-stusps="TX"
          id="48461"
        />
        <path
          className="white"
          d="M 363.16 414.81 368.58 414.94 371.32 418.78 367.45 422.29 367.34 422.2 365.26 422.71 363.02 421.5 363.16 414.81 Z"
          data-name="Kendall"
          data-stusps="TX"
          id="48259"
        />
        <path
          className="white"
          d="M 451.9 295.82 454.43 295.76 458.55 295.64 458.09 295.79 458.22 302.85 457.39 302.86 452.51 302.9 451.97 302.89 451.77 296.12 451.9 295.82 Z"
          data-name="Boone"
          data-stusps="AR"
          id="5009"
        />
        <path
          className="white"
          d="M 403.07 281.21 411.47 281.32 411.46 286.94 410.91 286.94 407.65 286.93 403.4 286.92 403.02 286.92 403.07 281.21 Z"
          data-name="Chautauqua"
          data-stusps="KS"
          id="20019"
        />
        <path
          className="white"
          d="M 421.69 354.8 421.72 354.79 424.13 354.72 424.57 354.55 424.6 361.2 424.19 361.6 423.87 362.57 422.95 362.57 421.72 362.57 421.69 354.8 Z"
          data-name="Franklin"
          data-stusps="TX"
          id="48159"
        />
        <path
          className="white"
          d="M 532.58 337.07 532.72 332.62 541.14 332.22 541.59 337.96 541.72 339.59 540.1 339.73 536.76 339.9 536.61 337.97 536.02 337.45 532.56 337.6 532.58 337.07 Z"
          data-name="Marion"
          data-stusps="AL"
          id="1093"
        />
        <path
          className="white"
          d="M 377.28 302.14 378.9 302.18 385.42 302.32 385.29 310.55 377.13 310.39 377.28 302.14 Z"
          data-name="Kingfisher"
          data-stusps="OK"
          id="40073"
        />
        <path
          className="white"
          d="M 389.21 421.92 391.22 419.88 394.03 417.02 394.12 417.37 396.95 415.83 397.79 415.01 400.19 415.31 400.59 417.21 401.43 418.76 396.4 424.88 392.01 424.92 392.2 424.63 389.18 421.96 389.21 421.92 Z"
          data-name="Fayette"
          data-stusps="TX"
          id="48149"
        />
        <path
          className="white"
          d="M 663.62 191.76 663.43 191.62 666.47 190.8 666.9 190.78 665.64 192.31 666.66 193.21 666.45 194.43 667.71 195.67 666.59 199.53 666.35 200.67 664.01 199.97 664.04 201.1 661.23 200.04 661.92 199.07 661.71 196.42 662.78 194.42 662.62 193.51 663.62 191.76 Z"
          data-name="Blair"
          data-stusps="PA"
          id="42013"
        />
        <path
          className="white"
          d="M 655.87 199.76 656.98 193.5 657.11 193.06 662.84 191.89 663.62 191.76 662.62 193.51 662.78 194.42 661.71 196.42 661.92 199.07 661.23 200.04 660.95 200.99 661 201.73 657.72 202.36 657.32 201.83 656.95 201.72 655.09 202.08 655.66 200.58 655.87 199.77 655.87 199.76 Z"
          data-name="Cambria"
          data-stusps="PA"
          id="42021"
        />
        <path
          className="white"
          d="M 377.56 442.28 379.06 441.75 381.3 442.76 382.62 445.15 384.9 445.7 385 446.89 387.89 448.09 385.09 452.24 384.63 452.89 380.5 451.95 380.65 451.83 376.16 442.76 377.56 442.28 Z"
          data-name="Bee"
          data-stusps="TX"
          id="48025"
        />
        <path
          className="white"
          d="M 371.64 151.15 374.68 151.26 379.66 151.42 379.52 156.28 373.06 156.11 371.44 156.06 371.64 151.15 Z"
          data-name="Jerauld"
          data-stusps="SD"
          id="46073"
        />
        <path
          className="white"
          d="M 395.81 158.34 399.08 158.38 405 158.41 404.96 163.99 404.95 164.97 402.96 164.95 398.5 164.91 395.71 164.87 395.81 158.34 Z"
          data-name="Minnehaha"
          data-stusps="SD"
          id="46099"
        />
        <path
          className="white"
          d="M 713.82 229.33 717.5 228.23 718.07 226.82 717.12 225.09 719.46 224.57 721.5 224.09 721.52 226.63 721.32 226.93 721.12 228.8 721.01 230.64 720.91 231.35 720.49 232.82 714.88 234.77 714.11 233.99 715.72 232.67 715.26 230.99 713.82 229.33 Z"
          data-name="Worcester"
          data-stusps="MD"
          id="24047"
        />
        <path
          className="white"
          d="M 361.32 370.18 361.61 370.19 369.87 370.41 371.48 370.49 371.39 374.5 370.15 375.18 364.1 378.46 361 378.34 361.32 370.18 Z"
          data-name="Eastland"
          data-stusps="TX"
          id="48133"
        />
        <path
          className="white"
          d="M 302.16 383.61 309.39 384.06 309.03 394.69 307.62 394.59 307.08 392.56 305.64 391.17 304.4 391.01 303.25 389.75 301.74 390.34 302.16 383.61 Z"
          data-name="Crane"
          data-stusps="TX"
          id="48103"
        />
        <path
          className="white"
          d="M 425.98 164.92 426.53 164.92 426.8 164.91 432.43 164.84 432.5 169.44 426.04 169.53 425.98 164.92 Z"
          data-name="Emmet"
          data-stusps="IA"
          id="19063"
        />
        <path
          className="white"
          d="M 428.7 195.64 430.33 195.61 435.22 195.53 435.31 200.43 435.86 200.43 435.89 202.26 429.41 202.35 429.38 200.51 428.77 200.52 428.7 195.64 Z"
          data-name="Guthrie"
          data-stusps="IA"
          id="19077"
        />
        <path
          className="white"
          d="M 331.92 344.21 340.11 344.57 339.76 352.78 331.55 352.4 331.92 344.21 Z"
          data-name="Dickens"
          data-stusps="TX"
          id="48125"
        />
        <path
          className="white"
          d="M 551.21 160.56 554.33 160.15 557.77 159.72 557.98 161.37 558.18 163.01 559.05 169.56 555.79 170 552.51 170.4 552.31 168.75 552.18 167.65 551.83 165.48 551.4 162.21 551.21 160.56 Z"
          data-name="Kent"
          data-stusps="MI"
          id="26081"
        />
        <path
          className="white"
          d="M 421.07 129.07 422.7 129.07 427.58 129 427.6 130.63 427.78 138.78 421.23 138.86 421.22 133.96 421.09 132.34 421.07 129.07 Z"
          data-name="Kandiyohi"
          data-stusps="MN"
          id="27067"
        />
        <path
          className="white"
          d="M 439.03 146.75 439.59 145.57 439.25 145.12 444.43 144.98 444.61 151.5 441.33 151.59 441.31 150.77 438.01 150.85 437.83 150.53 439.04 148.85 438.64 148.5 438.72 148.31 438.61 148.17 438.74 148.13 438.77 147.69 438.9 147.58 439.06 146.96 439.03 146.75 Z"
          data-name="Le Sueur"
          data-stusps="MN"
          id="27079"
        />
        <path
          className="white"
          d="M 671.33 242.66 671.82 242.29 672.22 242.46 672.25 243.16 671.58 243.51 671.33 243.56 671.33 242.66 Z"
          data-name="Charlottesville"
          data-stusps="VA"
          id="51540"
        />
        <path
          className="white"
          d="M 445.82 182.24 452.38 182.06 452.77 183.66 452.95 188.57 449.74 188.68 446.51 188.76 446.37 183.86 445.82 182.24 Z"
          data-name="Hardin"
          data-stusps="IA"
          id="19083"
        />
        <path
          className="white"
          d="M 590.57 378.74 594.11 378.04 594.95 378.26 596.08 378.14 596.51 378.09 596.58 379.48 597.45 381.14 597.21 381.55 596.89 381.24 595.85 381.64 593.85 381.95 591.39 382.16 590.77 380.99 590.94 380.72 590.57 378.74 Z"
          data-name="Calhoun"
          data-stusps="GA"
          id="13037"
        />
        <path
          className="white"
          d="M 332.72 236.28 342.14 236.83 342.44 236.85 341.98 245.01 340.66 244.93 332.18 244.41 332.72 236.28 Z"
          data-name="Thomas"
          data-stusps="KS"
          id="20193"
        />
        <path
          className="white"
          d="M 251.61 261.81 253.21 262.01 253.03 263.65 261.23 264.56 260.49 271.1 250.9 269.97 250.41 269.9 250.97 265 251.61 261.81 Z"
          data-name="Rio Grande"
          data-stusps="CO"
          id="8105"
        />
        <path
          className="white"
          d="M 419.8 208.9 423.04 208.89 426.27 208.87 426.31 213.71 419.81 213.74 419.8 208.9 Z"
          data-name="Montgomery"
          data-stusps="IA"
          id="19137"
        />
        <path
          className="white"
          d="M 316.42 208.08 316.88 208.12 317.79 208.19 324.98 208.72 324.98 208.72 324.65 213.47 316.08 212.83 316.42 208.08 Z"
          data-name="Sedgwick"
          data-stusps="CO"
          id="8115"
        />
        <path
          className="white"
          d="M 398.28 203.32 403.04 203.75 404.42 204.5 405.11 205.06 406.42 208.33 406.23 210.35 406.52 211.05 406.09 211.61 404.46 211.58 404.47 211.04 398.15 210.96 398.28 203.32 Z"
          data-name="Saunders"
          data-stusps="NE"
          id="31155"
        />
        <path
          className="white"
          d="M 599.32 318.45 599.67 317.32 600.34 316.97 601.53 316.86 601.86 316.63 602.93 317.82 602.48 319.26 603.48 321.4 602.79 322.22 600.85 322.25 600.01 322.52 599.24 320.41 599.32 318.45 Z"
          data-name="White"
          data-stusps="GA"
          id="13311"
        />
        <path
          className="white"
          d="M 614.16 357.66 618.19 354.79 619.69 354.46 620.91 355.37 623.04 356.03 623.62 357.87 622.43 361.56 622.91 361.87 622.46 362.69 620.98 364.32 620.55 364.34 618.95 365.47 615.94 360.54 614.16 357.66 Z"
          data-name="Laurens"
          data-stusps="GA"
          id="13175"
        />
        <path
          className="white"
          d="M 596.07 223.46 595.88 221.23 602.03 220.68 602.4 225.12 604.05 225.01 604.15 226.65 600.36 226.98 596.34 226.86 596.07 223.46 Z"
          data-name="Pickaway"
          data-stusps="OH"
          id="39129"
        />
        <path
          className="white"
          d="M 595.92 233.04 604.32 232.39 604.62 236.6 601.11 236.93 598.62 237.23 597.61 236.3 596.87 235.7 595.82 235.79 595.92 233.04 Z"
          data-name="Pike"
          data-stusps="OH"
          id="39131"
        />
        <path
          className="white"
          d="M 436.71 227.9 443.24 227.83 443.34 231.08 443.46 234.36 436.99 234.42 436.94 229.99 436.72 229.81 436.71 227.9 Z"
          data-name="Daviess"
          data-stusps="MO"
          id="29061"
        />
        <path
          className="white"
          d="M 379.72 352.79 379.9 344.89 380.31 344.85 380.32 345.09 381.64 345.66 382.63 345.11 383.33 344.27 384.73 343.06 385.7 343.51 385.88 344.38 386.42 344.82 386.47 344.86 387.6 344.5 387.63 344.56 387.44 353.56 380.67 353.43 379.71 353.42 379.72 352.79 Z"
          data-name="Montague"
          data-stusps="TX"
          id="48337"
        />
        <path
          className="white"
          d="M 299.06 358.73 306.49 359.23 312.61 359.61 312.21 367.8 312.08 367.79 298.48 366.94 298.57 365.7 298.9 360.79 299.06 358.73 Z"
          data-name="Gaines"
          data-stusps="TX"
          id="48165"
        />
        <path
          className="white"
          d="M 634.2 361.01 635.13 361.09 637.67 361.35 638.46 362.88 638.98 363.75 639.63 363.95 639.04 364.83 636.97 365.06 635.42 364.66 634.2 361.01 Z"
          data-name="Evans"
          data-stusps="GA"
          id="13109"
        />
        <path
          className="white"
          d="M 426.11 176.01 432.61 175.95 432.69 180.89 432.72 182.51 426.18 182.57 426.11 176.01 Z"
          data-name="Pocahontas"
          data-stusps="IA"
          id="19151"
        />
        <path
          className="white"
          d="M 710.06 199.68 710.87 198.66 711.57 198.44 712.57 197.95 712.69 197.81 713.03 197.42 713.58 197.05 714.9 199.02 717.37 200.05 718.76 201.52 718.39 202.21 717.61 203.67 716.24 202.92 713.76 201.55 710.91 201.04 710.79 200.68 709.88 200.14 710.06 199.68 Z"
          data-name="Gloucester"
          data-stusps="NJ"
          id="34015"
        />
        <path
          className="white"
          d="M 513.66 105.28 513.19 100.43 514.8 100.25 514.64 98.64 513.95 98.7 513.67 95.85 515.54 95.81 517.19 96.26 518.41 96.8 519.71 97.78 520.12 98.92 521.18 100.19 522.88 101.29 523.22 102.64 525.73 102.55 526.47 102.3 527.2 108.82 525.56 108.99 525.9 112.26 524.26 112.43 521 112.77 520.51 107.87 513.97 108.53 513.66 105.28 Z"
          data-name="Marquette"
          data-stusps="MI"
          id="26103"
        />
        <path
          className="white"
          d="M 357.97 68.68 359.61 68.76 367.75 69.19 367.59 72.46 363.16 72.23 363.26 78.82 363.09 82.09 359.84 81.92 358.21 81.82 357.9 78.52 357.78 71.94 357.97 68.68 Z"
          data-name="Pierce"
          data-stusps="ND"
          id="38069"
        />
        <path
          className="white"
          d="M 444.77 114.71 446.71 114.54 449.7 114.47 449.8 117.79 448.65 117.83 448.83 122.53 443.93 122.62 443.74 117.98 444.86 117.95 444.77 114.71 Z"
          data-name="Kanabec"
          data-stusps="MN"
          id="27065"
        />
        <path
          className="white"
          d="M 332.53 318.87 340.97 319.27 340.56 327.44 334.29 327.12 332.03 327.01 332.53 318.87 Z"
          data-name="Donley"
          data-stusps="TX"
          id="48129"
        />
        <path
          className="white"
          d="M 692.04 190.09 695.75 188.46 697.8 187.2 697.86 185.88 699.15 184.83 705.41 187.94 705.15 188.75 703.92 192.39 701.82 194.98 698.03 193.06 697 192.54 696.02 191.87 692.04 190.09 Z"
          data-name="Berks"
          data-stusps="PA"
          id="42011"
        />
        <path
          className="white"
          d="M 366.98 137.79 374.93 138.1 375.07 138.42 374.9 143.04 374.68 151.26 371.64 151.15 366.58 150.98 366.86 144.36 366.98 137.79 Z"
          data-name="Hand"
          data-stusps="SD"
          id="46059"
        />
        <path
          className="white"
          d="M 327.51 157.97 328.93 158.3 329.16 157.95 329.72 152.59 342.51 153.47 342.32 156.36 340.19 156.92 339.54 164.7 327.45 163.84 327.19 162.18 327.51 157.97 Z"
          data-name="Jackson"
          data-stusps="SD"
          id="46071"
        />
        <path
          className="white"
          d="M 423.79 189.16 427.03 189.14 430.24 189.1 430.33 195.61 428.7 195.64 423.82 195.67 423.79 189.16 Z"
          data-name="Carroll"
          data-stusps="IA"
          id="19027"
        />
        <path
          className="white"
          d="M 568.84 168.29 571.86 167.88 572.14 167.72 574.98 167.31 576.15 173.89 569.76 174.82 568.84 168.29 Z"
          data-name="Ingham"
          data-stusps="MI"
          id="26065"
        />
        <path
          className="white"
          d="M 28.95 231.01 34.14 228.11 34.02 227.04 44.49 225.09 45.73 233.09 47.24 235.12 46.32 235.2 44.45 234.76 40.27 234.99 38.99 235.71 37.75 237.26 36.75 236.98 31.56 239.92 28.64 237.11 27.69 234.97 28.18 234.39 27.83 233.84 28.95 231.01 Z"
          data-name="Merced"
          data-stusps="CA"
          id="6047"
        />
        <path
          className="white"
          d="M 469.21 186.23 472.47 186.12 475.73 185.95 476.04 192.5 476.12 194.14 469.59 194.43 469.21 186.23 Z"
          data-name="Linn"
          data-stusps="IA"
          id="19113"
        />
        <path
          className="white"
          d="M 372.12 217.06 372.17 216.89 378.44 217.09 378.5 217.09 378.32 223.62 371.92 223.43 372.12 217.06 Z"
          data-name="Adams"
          data-stusps="NE"
          id="31001"
        />
        <path
          className="white"
          d="M 597.04 331.58 596.69 331.33 597.33 329.3 600.18 330.15 601.27 329.61 600.74 332.03 602.01 333.31 601.23 334.25 600.48 335.16 599.45 336.36 598.86 337.07 597.99 336.7 596.28 335.34 595.77 335.13 595.17 334.59 594.42 333.66 594.59 333.07 595.83 332.74 597.04 331.58 Z"
          data-name="Gwinnett"
          data-stusps="GA"
          id="13135"
        />
        <path
          className="white"
          d="M 53.82 137.51 53.93 137.55 56.59 138.39 59.61 139.43 61.79 140.11 64.44 140.93 67.13 141.76 71.64 143.12 74.2 143.89 73.52 146.15 72.09 150.99 69.63 159.2 62.46 157.06 50.58 153.4 48.94 152.89 52.47 141.67 53.4 138.36 53.82 137.51 Z"
          data-name="Modoc"
          data-stusps="CA"
          id="6049"
        />
        <path
          className="white"
          d="M 582.03 332.38 581.9 327.61 582.08 326.73 582.36 326.85 587.55 325.74 587.81 326.81 588.16 332.06 586.92 332.18 584.22 332.55 584.01 332.43 582.06 332.64 582.03 332.38 Z"
          data-name="Bartow"
          data-stusps="GA"
          id="13015"
        />
        <path
          className="white"
          d="M 641.92 374.29 643.4 373.36 644.3 370.86 645.35 371.83 647.28 371.24 648.86 371.58 649.86 373.2 649.88 373.64 649.43 374.75 648.85 375.96 648.65 377.02 649.07 377.87 649.04 378.06 645.38 377.74 642.77 375.83 642.92 375.49 641.92 374.29 Z"
          data-name="McIntosh"
          data-stusps="GA"
          id="13191"
        />
        <path
          className="white"
          d="M 597.47 313.59 602.39 313.01 603.48 312.83 602.07 315.12 602.27 316.16 601.86 316.63 601.53 316.86 600.34 316.97 599.64 314.92 597.94 314.69 597.47 313.59 Z"
          data-name="Towns"
          data-stusps="GA"
          id="13281"
        />
        <path
          className="white"
          d="M 348.82 331.31 349.9 331.06 351.2 332.42 351.56 332.8 352.35 333.82 353.37 334.87 354.87 335.05 355.13 334.44 356.83 334.7 356.61 340.54 355.45 341.06 353.85 340.19 351.99 340.23 348.57 337.63 348.63 335.99 348.82 331.31 Z"
          data-name="Hardeman"
          data-stusps="TX"
          id="48197"
        />
        <path
          className="white"
          d="M 642.78 187.15 644.45 190.63 649.13 189.06 649.97 188.09 650.1 188.41 650.49 190.71 650.99 193.26 648.5 198.55 647.88 198.77 644.83 196.32 644.51 196.58 642.78 187.15 Z"
          data-name="Armstrong"
          data-stusps="PA"
          id="42005"
        />
        <path
          className="white"
          d="M 489.57 231.45 489.35 230.75 497.88 230.29 498 231.93 499.3 236.81 495.99 237.06 493.84 237.19 493.72 235.01 492.64 234.52 492.56 232.88 490.9 232.3 489.22 232.39 489.57 231.45 Z"
          data-name="Morgan"
          data-stusps="IL"
          id="17137"
        />
        <path
          className="white"
          d="M 439.23 208.7 440.87 208.67 442.42 208.53 445.71 208.46 445.85 213.4 439.33 213.58 439.23 208.7 Z"
          data-name="Clarke"
          data-stusps="IA"
          id="19039"
        />
        <path
          className="white"
          d="M 605.59 351.61 605.91 352.26 606.57 352.74 608.09 352.77 608.98 353.28 607.79 355.4 608.04 356.85 606.92 356.79 606.32 356.52 604.5 356.01 602.93 353.92 603.34 353.56 605.22 351.69 605.59 351.61 Z"
          data-name="Bibb"
          data-stusps="GA"
          id="13021"
        />
        <path
          className="white"
          d="M 482.78 195.45 485.92 195.46 488.78 195.04 491.08 195.75 491.08 196.38 490.81 196.97 490.85 198.21 490.52 198.59 489.81 198.95 489.22 199.73 488.49 199.85 487.68 199.96 487.04 200.59 485.91 201.23 484.71 201.33 484.59 198.63 482.95 198.72 482.78 195.45 Z"
          data-name="Scott"
          data-stusps="IA"
          id="19163"
        />
        <path
          className="white"
          d="M 399.39 230.57 404.24 230.62 404.33 230.62 407.57 230.65 407.56 232.27 407.54 238.8 402.58 238.76 399.29 238.73 399.35 233.83 399.39 230.57 Z"
          data-name="Marshall"
          data-stusps="KS"
          id="20117"
        />
        <path
          className="white"
          d="M 684.29 146.63 689.45 144.98 689.85 146.22 691.64 151.93 689.47 152.6 687.94 152.94 686.24 153.4 685.09 149.38 684.29 146.63 Z"
          data-name="Cortland"
          data-stusps="NY"
          id="36023"
        />
        <path
          className="white"
          d="M 400.31 412.48 404.93 411.07 405.87 410.96 407.83 410.68 408.22 411.89 409.2 412.28 409.21 413.86 408.14 414.2 407.6 415.48 408.34 416.76 408.11 417.07 405.95 416.26 400.59 417.21 400.19 415.31 397.79 415.01 398.78 413.51 400.31 412.48 Z"
          data-name="Washington"
          data-stusps="TX"
          id="48477"
        />
        <path
          className="white"
          d="M 628.6 231.28 628.94 230.95 630.56 231.37 631.53 234.38 631.01 235.75 632.2 236.75 631.66 237.81 631.07 239 629.86 238.57 628.32 234.96 627.25 233.75 627.27 233.33 628.6 231.28 Z"
          data-name="Calhoun"
          data-stusps="WV"
          id="54013"
        />
        <path
          className="white"
          d="M 630.56 231.37 631.02 231.29 633.5 228.94 634.79 228.99 635.24 230.6 637.21 232.29 636.3 232.67 632.2 236.75 631.01 235.75 631.53 234.38 630.56 231.37 Z"
          data-name="Gilmer"
          data-stusps="WV"
          id="54021"
        />
        <path
          className="white"
          d="M 344.07 403.46 354.32 403.81 354.18 407.77 357.11 407.86 357.03 411.85 349.67 411.54 343.77 411.33 344.07 403.46 Z"
          data-name="Kimble"
          data-stusps="TX"
          id="48267"
        />
        <path
          className="white"
          d="M 274.38 231.39 274.76 228.01 275.1 224.87 275.95 224.95 278.46 225.21 278.43 225.64 280.1 225.38 279.86 227.69 279.35 230.92 278.88 230.88 279.44 231.01 279.52 230.89 279.48 231.93 279.41 231.98 279.09 232.29 277.39 234.74 276.42 237.43 274.53 239.71 274.51 239.71 273.52 239.6 274.06 234.49 274.38 231.39 Z"
          data-name="Jefferson"
          data-stusps="CO"
          id="8059"
        />
        <path
          className="white"
          d="M 509.54 221.74 512.84 221.47 517.8 221.1 515.62 224.73 515.69 225.55 509.93 226.12 509.54 221.74 Z"
          data-name="De Witt"
          data-stusps="IL"
          id="17039"
        />
        <path
          className="white"
          d="M 467.74 370.47 467.69 368.83 470.73 368.59 473.16 366.01 474.59 366.18 475.64 367.08 475.18 368.49 475.72 370 474.5 372.01 473.94 374.35 472.81 374.74 469.52 374.5 469.49 373.69 467.79 372.11 467.74 370.47 Z"
          data-name="Ouachita"
          data-stusps="LA"
          id="22073"
        />
        <path
          className="white"
          d="M 520.83 312.58 523.3 311.25 524.12 309.32 524.85 309.28 525.89 310.62 528.09 310.82 528.24 312.2 528.27 312.92 525.04 313.14 524.01 313.61 522.95 315.83 521.99 315.9 521.71 314.38 520.83 312.58 Z"
          data-name="Chester"
          data-stusps="TN"
          id="47023"
        />
        <path
          className="white"
          d="M 320.81 360.03 322.93 360.16 329.01 360.43 328.58 368.61 328.57 368.68 320.39 368.23 320.81 360.03 Z"
          data-name="Borden"
          data-stusps="TX"
          id="48033"
        />
        <path
          className="white"
          d="M 523.35 366.23 531.71 365.64 531.55 370.74 531.52 371.85 531.5 372.27 523.79 372.85 523.35 366.23 Z"
          data-name="Lauderdale"
          data-stusps="MS"
          id="28075"
        />
        <path
          className="white"
          d="M 553.11 150.36 559.56 149.57 560.47 156.09 553.93 156.88 553.11 150.36 Z"
          data-name="Mecosta"
          data-stusps="MI"
          id="26107"
        />
        <path
          className="white"
          d="M 391.96 191.26 396.84 191.34 396.74 197.86 393.47 197.81 391.85 197.78 391.96 191.26 Z"
          data-name="Stanton"
          data-stusps="NE"
          id="31167"
        />
        <path
          className="white"
          d="M 471.18 142.9 476.06 142.62 476.43 149.18 476.8 152.32 474.6 152.79 474.59 154.23 473.22 154.31 472.97 154 471.34 153.66 471.61 152.29 470.47 150.92 471.52 149.46 471.18 142.9 Z"
          data-name="Trempealeau"
          data-stusps="WI"
          id="55121"
        />
        <path
          className="white"
          d="M 431.11 228.18 431.15 223.29 436.66 223.25 436.71 227.9 436.72 229.81 431.14 229.81 431.11 228.18 Z"
          data-name="Gentry"
          data-stusps="MO"
          id="29075"
        />
        <path
          className="white"
          d="M 272.36 330.34 272.8 325.49 279.76 326.1 279.9 324.47 281.53 324.6 281.67 322.96 284.94 323.23 284.68 326.51 287.48 326.74 286.73 336.57 283.45 336.29 283.3 337.94 273.44 337.02 273.58 335.37 271.9 335.21 272.36 330.34 Z"
          data-name="De Baca"
          data-stusps="NM"
          id="35011"
        />
        <path
          className="white"
          d="M 411.78 254.32 411.77 251.86 418.31 251.86 418.32 254.32 418.21 255.13 418.23 260.03 411.7 260.04 411.72 255.14 411.78 254.32 Z"
          data-name="Osage"
          data-stusps="KS"
          id="20139"
        />
        <path
          className="white"
          d="M 541.55 231.76 541.11 226.84 545.67 226.41 546.24 230.8 546.91 230.97 546.74 231.3 546.93 231.96 546.57 233.82 542.86 234.13 541.77 234.23 541.55 231.76 Z"
          data-name="Putnam"
          data-stusps="IN"
          id="18133"
        />
        <path
          className="white"
          d="M 529.7 267.07 530.59 267.32 531.09 267.13 531.52 266.56 530.93 265.61 531.07 265.05 532.94 267.49 533.73 267.42 534.34 269.71 531.63 272.95 530.29 271.79 529.59 272.66 529.47 272.2 528.51 271.45 528.49 271.4 527.96 269.95 528.3 269.11 529.32 268.17 529.7 267.07 Z"
          data-name="Union"
          data-stusps="KY"
          id="21225"
        />
        <path
          className="white"
          d="M 653.74 321.64 654.07 319.34 655.34 318.77 656.18 317.46 657.01 318.1 657.92 317.14 659.45 320.2 658.83 320.98 660.46 322.19 661.2 322.33 661.67 322.75 659.11 325.02 658.23 324.32 656.5 322.93 653.88 322.71 653.74 321.64 Z"
          data-name="Lee"
          data-stusps="SC"
          id="45061"
        />
        <path
          className="white"
          d="M 532.53 216.1 538.76 215.51 538.98 217.56 536.89 218.85 534.36 221.82 534.89 222.5 533.68 222.61 533.06 222.28 532.89 220.35 532.53 216.1 Z"
          data-name="Warren"
          data-stusps="IN"
          id="18171"
        />
        <path
          className="white"
          d="M 432.76 208.81 436.01 208.76 439.23 208.7 439.33 213.58 432.83 213.65 432.76 208.81 Z"
          data-name="Union"
          data-stusps="IA"
          id="19175"
        />
        <path
          className="white"
          d="M 462.69 186.54 465.95 186.41 469.21 186.23 469.59 194.43 463.04 194.7 462.69 186.54 Z"
          data-name="Benton"
          data-stusps="IA"
          id="19011"
        />
        <path
          className="white"
          d="M 691.83 236.7 692.5 236.73 692.6 236.3 693.32 237.54 694.81 237.51 695.58 239.11 697.84 240.47 700.06 242.33 699.32 242.91 699.01 243.54 697.97 242.44 695.89 243.12 695.68 242.26 694.04 241.73 693.26 240.06 691.3 238.2 691.83 236.7 Z"
          data-name="Essex"
          data-stusps="VA"
          id="51057"
        />
        <path
          className="white"
          d="M 33.37 115.85 34.8 115.23 36.75 115.99 37.71 115.84 39.9 116.53 42.2 115.16 44.1 114.89 45.58 115.08 46.76 114.29 48.39 114.85 45.05 124.66 44.79 125.29 42.03 133.44 39.06 132.43 34.82 131.09 31.36 129.93 29.98 129.32 28.76 128.99 30.65 123.6 32 119.75 33.37 115.85 Z"
          data-name="Jackson"
          data-stusps="OR"
          id="41029"
        />
        <path
          className="white"
          d="M 673.58 196.48 676.43 191.86 676.41 191.21 678.99 189.09 681.56 188.57 684.23 189.03 684.14 189.25 680.97 190.86 676.56 195.44 675.1 197.91 674.75 198.5 673.58 196.48 Z"
          data-name="Juniata"
          data-stusps="PA"
          id="42067"
        />
        <path
          className="white"
          d="M 709.67 183.99 710.12 183.16 712.1 181.13 712.29 180.96 713.06 179.23 714.22 179.85 715.74 179.93 716.57 182.45 715.67 184.05 716.82 185.6 715.62 187.46 714.61 187.84 714.27 187.58 713.73 186.86 712.92 186.98 712.4 186.86 712.01 186.17 712.01 185.64 711.46 184.44 710.49 184.12 709.8 184.42 709.67 183.99 Z"
          data-name="Hunterdon"
          data-stusps="NJ"
          id="34019"
        />
        <path
          className="white"
          d="M 354.51 434.2 364.54 434.5 364.4 442.8 354.55 442.65 354.33 442.65 354.51 434.2 Z"
          data-name="Frio"
          data-stusps="TX"
          id="48163"
        />
        <path
          className="white"
          d="M 634.88 300.24 642.7 299.43 643.31 300.11 642.57 300.42 642.15 302.07 642.62 304.16 642.08 304.44 642.06 304.4 637.58 304.82 637.41 302.94 636.66 301.7 634.88 300.24 Z"
          data-name="Gaston"
          data-stusps="NC"
          id="37071"
        />
        <path
          className="white"
          d="M 541.22 151.71 546.64 151.15 547.4 157.69 541.59 158.27 541.28 157.49 540.43 156.1 540.16 155.16 540.46 154.1 541.2 152.63 541.22 151.71 Z"
          data-name="Oceana"
          data-stusps="MI"
          id="26127"
        />
        <path
          className="white"
          d="M 364.61 431.49 370.53 433.97 371.09 434.2 374.57 438.62 376.06 440.44 372.08 443.63 372.1 442.96 364.4 442.8 364.4 442.8 364.54 434.5 364.61 431.49 Z"
          data-name="Atascosa"
          data-stusps="TX"
          id="48013"
        />
        <path
          className="white"
          d="M 482.5 190.52 492.84 189.89 493.16 190.57 493 191.67 492.99 191.83 492.95 192.7 492.77 193.45 492.82 194.06 491.99 194.67 491.91 194.73 491.08 195.49 491.08 195.75 488.78 195.04 485.92 195.46 482.78 195.45 482.59 192.16 482.5 190.52 Z"
          data-name="Clinton"
          data-stusps="IA"
          id="19045"
        />
        <path
          className="white"
          d="M 509.74 186.39 513.02 186.1 514.65 185.96 514.79 187.59 514.69 188.52 515.16 194.12 515.29 195.78 513.74 195.93 512.25 196.03 510.56 196.23 510.12 191.29 509.74 186.39 Z"
          data-name="DeKalb"
          data-stusps="IL"
          id="17037"
        />
        <path
          className="white"
          d="M 558.18 163.01 559.82 162.79 564.73 162.16 565.6 168.71 562.31 169.13 559.05 169.56 558.18 163.01 Z"
          data-name="Ionia"
          data-stusps="MI"
          id="26067"
        />
        <path
          className="white"
          d="M 473.4 241.7 473.27 236.82 473.17 235.72 473.14 235.18 479.08 234.9 479.53 235.26 480.95 236.46 477.05 239.43 477.5 241.89 473.41 241.97 473.4 241.7 Z"
          data-name="Ralls"
          data-stusps="MO"
          id="29173"
        />
        <path
          className="white"
          d="M 598.6 345.8 599.24 345.51 599.46 344.88 600.63 344.1 601.12 342.72 601.36 343.19 602.25 344.04 603.53 347.25 603.32 347.52 602.96 347.24 599.78 347.5 598.47 347.64 598.85 346.01 598.6 345.8 Z"
          data-name="Butts"
          data-stusps="GA"
          id="13035"
        />
        <path
          className="white"
          d="M 403.66 176.06 413.06 176.09 413.05 182.63 404.45 182.59 403.81 181.08 402.92 180.2 402.47 179.49 402.52 178.48 403.13 177.58 403.7 176.63 403.66 176.06 Z"
          data-name="Plymouth"
          data-stusps="IA"
          id="19149"
        />
        <path
          className="white"
          d="M 263.09 251.47 264.73 250.53 265.38 248.76 264.22 246.89 273.68 247.84 275.03 247.98 274.89 248.91 279.29 249.31 279.06 251.77 278.58 256.68 276.97 256.53 265.89 255.23 263.21 251.92 263.09 251.47 Z"
          data-name="Fremont"
          data-stusps="CO"
          id="8043"
        />
        <path
          className="white"
          d="M 402.59 365.35 406.09 365.36 406.1 364.84 409.58 364.91 409.58 373.92 407.66 373.97 403.59 373.88 403.88 373.31 402.39 370.37 402.49 370.01 402.58 365.68 402.59 365.35 Z"
          data-name="Kaufman"
          data-stusps="TX"
          id="48257"
        />
        <path
          className="white"
          d="M 609.31 387.88 611.96 387.66 611.85 386.82 612.28 387.23 613.57 387.51 614.38 389.68 616.06 390.65 614.45 391.52 614.04 392.73 616.34 394.77 613.99 394.87 612.15 394.96 609.97 395.07 609.31 387.88 Z"
          data-name="Brooks"
          data-stusps="GA"
          id="13027"
        />
        <path
          className="white"
          d="M 502.57 236.57 505.01 236.37 505.28 239.67 510.99 239.26 511.17 241.72 509.55 241.84 509.81 245.4 504.89 245.74 504.15 246.35 503.28 246.41 502.57 236.57 Z"
          data-name="Montgomery"
          data-stusps="IL"
          id="17135"
        />
        <path
          className="white"
          d="M 620.19 252.07 619.61 250.35 620.67 249.84 621.13 248.37 623.93 247.72 626.16 249.47 627.42 251.69 625.87 253.08 627.13 255.53 626.28 256.2 625.74 255.79 623.96 255.67 622.64 253.42 619.59 252.91 620.19 252.07 Z"
          data-name="Boone"
          data-stusps="WV"
          id="54005"
        />
        <path
          className="white"
          d="M 652.73 426.11 652.58 425.5 653.31 424.23 654.2 424.99 655.79 424.82 656.65 425.67 658.49 424.85 658.76 426.05 660.33 428.5 657.95 428.81 654.6 429.27 653.07 428.89 652.32 428.98 652.15 427.59 652.73 426.11 Z"
          data-name="Seminole"
          data-stusps="FL"
          id="12117"
        />
        <path
          className="white"
          d="M 598.79 388.22 603.02 387.79 603.18 389.63 604.02 390.85 604.37 395.34 603.69 395.37 601.05 395.52 599.49 395.6 598.79 388.22 Z"
          data-name="Grady"
          data-stusps="GA"
          id="13131"
        />
        <path
          className="white"
          d="M 318.84 128.68 320.27 114.95 321.08 115.02 323.38 115.23 325.39 115.4 328.31 115.65 331.46 115.9 332.6 115.99 331.93 124.86 331.3 133.01 318.55 131.93 318.84 128.68 Z"
          data-name="Perkins"
          data-stusps="SD"
          id="46105"
        />
        <path
          className="white"
          d="M 532.8 329.93 532.87 327.68 542.38 327.2 542.79 332.14 541.14 332.22 532.72 332.62 532.8 329.93 Z"
          data-name="Franklin"
          data-stusps="AL"
          id="1059"
        />
        <path
          className="white"
          d="M 404.77 354.41 404.88 348.46 405.13 348.86 406.01 348.1 406.49 347.45 407.24 347.86 408.12 346.88 408.46 346.3 409.83 346.12 411.84 345.49 412.59 345.7 413.26 345.77 413.1 346.38 413.05 353.24 413.04 354.22 406.17 355.28 404.76 355.48 404.77 354.41 Z"
          data-name="Fannin"
          data-stusps="TX"
          id="48147"
        />
        <path
          className="white"
          d="M 637.22 181.95 639.17 179 642.21 178.38 643.64 178.09 644.22 181.09 644.8 181.47 645 182.48 645.18 183.44 643.44 184.05 642.68 187.1 639.97 187.62 638.34 187.94 637.22 181.95 Z"
          data-name="Venango"
          data-stusps="PA"
          id="42121"
        />
        <path
          className="white"
          d="M 498.12 124.69 498.92 124.57 503.12 124.33 504.75 124.18 504.85 125.8 508.14 125.51 508.4 128.78 509.06 130.38 504.53 130.76 504.68 132.43 501.45 132.69 501.31 131.02 498.63 131.23 498.12 124.69 Z"
          data-name="Langlade"
          data-stusps="WI"
          id="55067"
        />
        <path
          className="white"
          d="M 516.96 277.45 517.27 276.81 520.18 276.57 523.75 279.65 523.88 281.37 523.26 281.43 522.79 281.15 521.99 280.67 520.71 280.23 519.8 280.04 518.51 279.35 517.07 278.89 516.96 277.45 Z"
          data-name="Massac"
          data-stusps="IL"
          id="17127"
        />
        <path
          className="white"
          d="M 652.73 426.11 652.15 427.59 652.32 428.98 653.07 428.89 654.6 429.27 657.95 428.81 660.33 428.5 662.57 430.75 663.07 433.3 659.16 433.78 655.53 434.23 649.67 434.96 649.22 431.17 648.68 426.98 648.84 426.59 652.73 426.11 Z"
          data-name="Orange"
          data-stusps="FL"
          id="12095"
        />
        <path
          className="white"
          d="M 659.17 175.41 659.23 175.09 662.18 174.47 664.91 176.69 665.79 176.52 666.22 178.54 665.34 181.69 663.24 181.87 662.31 178.63 659.95 179.12 659.17 175.41 Z"
          data-name="Cameron"
          data-stusps="PA"
          id="42023"
        />
        <path
          className="white"
          d="M 625.53 271.87 627.09 272.14 630 270.04 630.6 270.11 631.64 271.06 632.59 271.93 633.98 274.37 629.87 276.19 629.11 277.53 628.78 277.42 627.25 274.89 624.76 272.56 625.53 271.87 Z"
          data-name="Smyth"
          data-stusps="VA"
          id="51173"
        />
        <path
          className="white"
          d="M 513.5 321.27 515.89 321.1 518.54 320.91 518.69 320.9 518.86 323.46 517.82 324.35 518.09 328.43 516.01 328.58 515.67 328.88 514.85 328.93 514.51 324.02 513.68 324.08 513.5 321.27 Z"
          data-name="Benton"
          data-stusps="MS"
          id="28009"
        />
        <path
          className="white"
          d="M 545.54 181.21 547.53 180.98 547.91 184.21 548.53 190.07 544.65 190.51 544.33 190.54 542.7 190.72 542.68 190.72 540.1 190.98 541.8 189.37 542.97 187.67 543.98 184.4 544.37 183.41 545.54 181.21 Z"
          data-name="Berrien"
          data-stusps="MI"
          id="26021"
        />
        <path
          className="white"
          d="M 526.71 252.75 529.55 252.49 529.92 254.52 529.53 256.14 530.06 257.73 529.52 258.37 528.98 258.49 527.15 258.63 526.71 252.75 Z"
          data-name="Edwards"
          data-stusps="IL"
          id="17047"
        />
        <path
          className="white"
          d="M 401.3 316.86 402.63 317.05 404.11 315.62 404.09 318.95 404.07 322.22 403.31 322.21 403.28 326.06 402.69 326.82 401.95 325.94 399.88 326.01 399.61 327.03 398.88 326.22 398.95 316.64 401.3 316.86 Z"
          data-name="Seminole"
          data-stusps="OK"
          id="40133"
        />
        <path
          className="white"
          d="M 570.39 241.47 570.4 241.12 570.95 241.3 572.27 239.97 573.96 239.1 574.44 239.62 574.78 240.34 574.21 241.19 574.42 241.29 574.36 241.54 570.39 241.98 570.39 241.47 Z"
          data-name="Ohio"
          data-stusps="IN"
          id="18115"
        />
        <path
          className="white"
          d="M 279.52 230.89 279.81 230.79 279.89 230.25 280.15 230.2 280.18 229.86 280.77 230.13 281.01 230.44 281.35 230.47 281.56 231.04 282.59 230.52 281.91 229.79 281.91 229.8 281.91 229.81 281.9 229.81 281.9 229.84 281.85 229.66 282.02 229.71 282.2 228.9 285.48 229.23 285.84 229.28 287.39 229.45 287.45 229.46 287.46 229.46 287.49 229.46 287.5 229.46 287.5 229.46 287.5 229.46 287.63 229.48 287.68 229.48 287.68 229.48 287.68 229.48 287.68 229.48 287.68 229.48 287.68 229.48 287.68 229.48 287.68 229.48 287.68 229.48 287.68 229.48 287.7 229.49 287.71 229.49 287.78 229.49 287.94 229.51 287.94 229.51 288 229.52 288.06 229.52 288.06 229.52 288.06 229.52 288.06 229.52 288.06 229.52 288.06 229.52 288.06 229.52 288.06 229.52 288.06 229.52 288.07 229.52 288.07 229.52 288.07 229.52 288.07 229.52 288.19 229.53 288.21 229.54 288.21 229.54 288.21 229.54 288.32 229.55 288.35 229.55 288.35 229.55 288.38 229.55 288.4 229.55 288.41 229.56 288.42 229.56 288.44 229.56 288.47 229.56 288.48 229.56 288.48 229.56 288.48 229.56 288.48 229.56 288.49 229.56 288.54 229.57 288.61 229.58 288.62 229.58 288.69 229.58 288.7 229.59 288.7 229.59 288.71 229.59 288.72 229.59 288.72 229.59 288.72 229.59 288.72 229.59 288.73 229.59 288.73 229.59 288.73 229.59 288.73 229.59 288.73 229.59 288.73 229.59 288.74 229.59 288.74 229.59 288.74 229.59 288.75 229.59 288.75 229.59 288.75 229.59 288.75 229.59 288.75 229.59 288.75 229.59 288.75 229.59 288.75 229.59 288.76 229.59 288.76 229.59 288.77 229.59 288.77 229.59 288.77 229.59 288.78 229.59 288.78 229.59 288.79 229.59 288.81 229.6 288.81 229.6 288.85 229.6 288.88 229.6 288.89 229.6 288.89 229.6 288.91 229.61 288.91 229.61 288.92 229.61 288.92 229.61 288.92 229.61 288.92 229.61 288.92 229.61 288.92 229.61 288.93 229.61 288.93 229.61 288.93 229.61 288.94 229.61 288.94 229.61 288.94 229.61 288.95 229.61 288.97 229.61 288.97 229.61 289 229.61 289 229.62 289.01 229.62 289.01 229.62 289.01 229.62 289.02 229.62 289.02 229.62 289.02 229.62 289.02 229.62 289.02 229.62 289.02 229.62 289.03 229.62 289.03 229.62 289.03 229.62 289.03 229.62 289.03 229.62 289.04 229.62 289.04 229.62 289.04 229.62 289.04 229.62 289.04 229.62 289.04 229.62 289.04 229.62 289.05 229.62 289.05 229.62 289.06 229.62 289.08 229.62 289.1 229.62 289.16 229.63 289.17 229.63 289.17 229.63 289.17 229.63 289.18 229.63 289.18 229.63 289.19 229.63 289.2 229.63 289.22 229.64 289.24 229.64 289.25 229.64 289.25 229.64 289.26 229.64 289.27 229.64 289.27 229.64 289.28 229.64 289.29 229.64 289.29 229.64 289.31 229.65 289.35 229.65 289.4 229.65 289.42 229.66 289.43 229.66 289.44 229.66 289.45 229.66 289.46 229.66 289.47 229.66 289.48 229.66 289.48 229.66 289.48 229.66 289.48 229.66 289.49 229.66 289.49 229.66 289.49 229.66 289.49 229.66 289.49 229.66 289.49 229.66 289.49 229.66 289.49 229.66 289.49 229.66 289.52 229.66 289.53 229.67 289.53 229.67 289.55 229.67 289.57 229.67 289.57 229.67 289.63 229.67 289.63 229.67 289.81 229.69 289.84 229.69 289.84 229.69 289.97 229.71 290.1 229.72 290.1 229.72 290.1 229.72 290.11 229.72 290.16 229.72 290.18 229.72 290.2 229.73 290.21 229.73 290.22 229.73 290.22 229.73 290.23 229.73 290.24 229.73 290.24 229.73 290.24 229.73 290.26 229.73 290.27 229.73 290.29 229.73 290.29 229.73 290.29 229.73 290.29 229.73 290.3 229.73 290.3 229.73 290.3 229.73 290.3 229.73 290.3 229.73 290.3 229.73 290.31 229.74 290.31 229.74 290.33 229.74 290.33 229.74 290.34 229.74 290.35 229.74 290.35 229.74 290.35 229.74 290.35 229.74 290.35 229.74 290.35 229.74 290.35 229.74 290.36 229.74 290.36 229.74 290.36 229.74 290.38 229.74 290.38 229.74 290.39 229.74 290.4 229.74 290.42 229.75 290.43 229.75 290.43 229.75 290.45 229.75 290.46 229.75 290.48 229.75 290.48 229.75 290.52 229.75 290.52 229.75 290.56 229.76 290.59 229.76 290.64 229.76 290.65 229.76 290.65 229.77 290.65 229.77 290.65 229.77 290.66 229.77 290.66 229.77 290.67 229.77 290.67 229.77 290.68 229.77 290.69 229.77 290.7 229.77 290.72 229.77 290.72 229.77 290.78 229.77 290.79 229.77 290.83 229.78 290.83 229.78 290.87 229.78 290.88 229.78 290.9 229.78 290.9 229.78 290.92 229.79 290.93 229.79 290.96 229.79 290.96 229.79 291.03 229.8 291.03 229.8 291.04 229.8 291.04 229.8 291.04 229.8 291.13 229.8 291.13 229.8 291.16 229.81 291.17 229.81 291.17 229.81 291.18 229.81 291.2 229.81 291.2 229.81 291.2 229.81 291.2 229.81 291.34 229.82 291.4 229.83 291.4 229.83 291.45 229.83 291.46 229.83 291.46 229.83 291.52 229.84 291.6 229.85 291.71 229.86 291.73 229.86 291.73 229.86 291.74 229.86 291.74 229.86 291.75 229.86 291.75 229.86 291.76 229.86 291.76 229.86 291.79 229.86 291.8 229.86 291.8 229.86 292 229.88 292 229.88 292.01 229.88 292.08 229.89 292.13 229.89 292.13 229.89 292.14 229.89 292.22 229.9 292.28 229.91 292.28 229.91 292.51 229.92 292.55 229.93 292.55 229.93 292.69 229.94 292.73 229.94 292.82 229.95 292.82 229.95 292.9 229.96 292.93 229.96 292.99 229.96 292.99 229.96 293 229.97 293.1 229.97 293.1 229.97 293.18 229.98 293.2 229.98 293.2 229.98 293.36 230 293.36 230 293.38 230 293.38 230 293.41 230 293.41 230 293.5 230.01 293.52 230.01 293.52 230.01 293.53 230.01 293.59 230.02 293.59 230.02 293.63 230.02 293.64 230.02 293.64 230.02 293.64 230.02 293.64 230.02 293.64 230.02 293.64 230.02 293.65 230.02 293.65 230.02 293.65 230.02 293.69 230.02 293.71 230.03 293.73 230.03 293.77 230.03 293.78 230.03 293.85 230.04 293.91 230.04 293.91 230.04 294.01 230.05 294.01 230.05 294.02 230.05 294.02 230.05 294.02 230.05 294.02 230.05 294.02 230.05 294.02 230.05 294.06 230.06 294.06 230.06 294.08 230.06 294.09 230.06 294.13 230.06 294.13 230.06 294.17 230.07 294.18 230.07 294.31 230.08 294.45 230.09 294.46 230.09 294.46 230.09 294.46 230.09 294.47 230.09 294.53 230.1 294.53 230.1 294.53 230.1 294.53 230.1 294.53 230.1 294.53 230.1 294.54 230.1 294.54 230.1 294.54 230.1 294.54 230.1 294.54 230.1 294.54 230.1 294.54 230.1 294.54 230.1 294.54 230.1 294.54 230.1 294.54 230.1 294.54 230.1 294.54 230.1 294.54 230.1 294.54 230.1 294.54 230.1 294.54 230.1 294.54 230.1 294.54 230.1 294.54 230.1 294.54 230.1 294.54 230.1 294.54 230.1 294.54 230.1 294.54 230.1 294.54 230.1 294.55 230.1 294.55 230.1 294.55 230.1 294.55 230.1 294.55 230.1 294.55 230.1 294.55 230.1 294.59 230.1 294.59 230.1 294.62 230.11 294.65 230.11 294.65 230.11 294.65 230.11 294.65 230.11 294.66 230.11 294.68 230.11 294.68 230.11 294.73 230.12 294.73 230.12 294.73 230.12 294.73 230.12 294.74 230.12 294.74 230.12 294.86 230.13 294.91 230.13 294.99 230.14 295 230.14 295 230.14 295 230.14 295.02 230.14 295.02 230.14 295.22 230.16 295.23 230.16 295.26 230.16 295.27 230.16 295.29 230.17 295.3 230.17 295.3 230.17 295.36 230.17 295.37 230.17 295.38 230.17 295.39 230.17 295.39 230.17 295.4 230.18 295.4 230.18 295.41 230.18 295.41 230.18 295.42 230.18 295.42 230.18 295.43 230.18 295.45 230.18 295.55 230.18 295.63 230.19 295.68 230.19 295.83 230.21 295.91 230.22 295.91 230.22 295.98 230.22 296.05 230.23 296.06 230.23 296.22 230.24 296.39 230.26 296.5 230.27 296.5 230.27 296.66 230.28 296.84 230.3 296.85 230.31 296.98 230.32 296.98 230.32 296.99 230.32 297.15 230.33 297.2 230.34 297.2 230.34 297.22 230.34 297.26 230.34 297.4 230.36 297.45 230.36 297.52 230.37 297.52 230.37 297.54 230.37 297.59 230.37 297.65 230.38 297.68 230.38 297.78 230.39 297.78 230.39 297.85 230.4 297.89 230.4 297.9 230.4 297.95 230.41 297.97 230.41 297.97 230.41 297.97 230.41 297.97 230.41 297.98 230.41 297.98 230.41 297.98 230.41 297.98 230.41 297.99 230.41 297.99 230.41 298.01 230.41 298.01 230.41 298.01 230.41 298.04 230.42 298.08 230.42 298.34 230.45 298.36 230.45 298.53 230.46 298.57 230.47 298.57 230.47 298.58 230.47 298.78 230.49 298.86 230.49 298.99 230.51 299.03 230.51 299.03 230.51 299.04 230.51 299.05 230.51 299.06 230.51 299.15 230.52 299.3 230.53 299.3 230.53 299.01 233.79 298.9 233.78 285.4 232.53 285.13 232.5 281.58 232.15 279.48 231.93 279.52 230.89 Z"
          data-name="Arapahoe"
          data-stusps="CO"
          id="8005"
        />
        <path
          className="white"
          d="M 374.54 251.29 382.7 251.49 382.64 256.39 382.61 258.03 374.41 257.84 374.5 254.94 374.42 254.55 374.54 251.29 Z"
          data-name="Ellsworth"
          data-stusps="KS"
          id="20053"
        />
        <path
          className="white"
          d="M 324.74 310.18 324.75 310.11 332.98 310.55 332.97 310.67 332.53 318.87 324.26 318.39 324.74 310.18 Z"
          data-name="Carson"
          data-stusps="TX"
          id="48065"
        />
        <path
          className="white"
          d="M 349.52 276.58 357.76 277.06 357.71 278.49 357.89 278.69 357.64 285.85 355.89 285.77 350.81 285.53 350.7 285.53 349.39 285.47 349.68 278.24 349.52 276.58 Z"
          data-name="Clark"
          data-stusps="KS"
          id="20025"
        />
        <path
          className="white"
          d="M 526.02 348.5 529.13 347.94 528.31 345.62 529.97 345.07 531.15 343.62 532.35 343.54 532.32 344.41 532.23 347.54 532.1 352.19 526.34 352.62 526.02 348.5 Z"
          data-name="Lowndes"
          data-stusps="MS"
          id="28087"
        />
        <path
          className="white"
          d="M 499.27 299.44 499.76 299.12 500.32 298.12 501.06 297.37 501 296.36 500.93 295.81 499.91 295.33 499.7 294.5 499.48 293.84 498.46 293.89 498.57 293.02 499.41 291.3 502.28 291.15 502.4 295.43 502.52 295.67 502.99 302.98 500.79 303.13 497.96 303.33 496.75 303.41 497.14 302.42 497.76 301.14 498.63 300.59 498.81 299.73 499.27 299.44 Z"
          data-name="Dunklin"
          data-stusps="MO"
          id="29069"
        />
        <path
          className="white"
          d="M 404.4 220.83 410.08 220.86 410.07 225.75 404.37 225.72 404.4 220.83 Z"
          data-name="Johnson"
          data-stusps="NE"
          id="31097"
        />
        <path
          className="white"
          d="M 714.61 187.84 715.62 187.46 716.82 185.6 717.43 186.43 718.83 185.9 718.91 186.09 719.11 187.02 721.45 187.87 720.78 188.78 719.9 189.69 720.5 190.43 718.52 190.06 718.57 190.31 718.67 190.28 718.67 190.41 718.55 190.68 718.46 190.64 718.48 190.62 717.95 190.13 717.71 189.91 716.59 189.33 715.94 188.77 715.09 188.21 714.61 187.84 Z"
          data-name="Mercer"
          data-stusps="NJ"
          id="34021"
        />
        <path
          className="white"
          d="M 636.96 304.87 637.58 304.82 642.06 304.4 642.08 304.44 642.23 304.89 642.04 305.87 642.38 306.37 643.86 304.93 644.4 305.47 645.35 307.74 645.68 309.69 645.27 310.28 636.19 311.62 636.47 311.23 635.63 309.24 635.47 307.6 636.65 307.19 636.96 304.87 Z"
          data-name="York"
          data-stusps="SC"
          id="45091"
        />
        <path
          className="white"
          d="M 565.88 270.73 566.12 269.76 566.89 269.71 566.95 270.42 568.69 271.53 570.2 273.52 570 274.05 570.94 274.55 570.57 275.05 568.48 276.4 566.86 276.28 565.93 275.29 565.52 273.06 565.88 270.73 Z"
          data-name="Green"
          data-stusps="KY"
          id="21087"
        />
        <path
          className="white"
          d="M 300.12 168.83 307.68 169.54 307.65 173.63 307.06 180.15 307.56 180.2 306.97 186.71 307.57 186.77 307.43 188.4 298.29 187.59 298.32 187.31 298.75 182.92 299.2 178.23 299.41 176.13 299.45 175.77 300.12 168.83 Z"
          data-name="Sioux"
          data-stusps="NE"
          id="31165"
        />
        <path
          className="white"
          d="M 438.99 169.31 445.48 169.14 445.65 175.66 439.12 175.83 438.99 169.31 Z"
          data-name="Hancock"
          data-stusps="IA"
          id="19081"
        />
        <path
          className="white"
          d="M 519.51 179.06 523.71 178.72 525.07 178.61 525.15 179.95 525.01 181.09 524.93 182.23 524.95 182.3 525.57 183.91 525.58 183.94 526.25 184.94 523.63 185.17 522.82 185.23 522.55 185.26 520.09 185.47 519.96 183.83 519.96 183.83 519.81 182.19 519.66 180.56 519.51 179.06 Z"
          data-name="Lake"
          data-stusps="IL"
          id="17097"
        />
        <path
          className="white"
          d="M 451.18 328.76 451.17 328.22 452.82 328.16 456.11 328.1 457.75 328.05 457.66 330.58 459.28 330.58 460.35 331.38 460.63 333.01 458.74 333.01 458.29 335.22 451.14 335.25 451.09 329.86 451.18 328.76 Z"
          data-name="Garland"
          data-stusps="AR"
          id="5051"
        />
        <path
          className="white"
          d="M 561.72 223.11 561.43 220.64 566.66 220.02 566.81 221.18 567.01 221.36 567.32 223.82 567.22 225.46 566.05 225.62 561.76 226.14 561.58 224.51 561.72 223.11 Z"
          data-name="Henry"
          data-stusps="IN"
          id="18065"
        />
        <path
          className="white"
          d="M 459.02 237.18 464.71 237.06 464.77 241.9 464.77 243.8 463.08 243.82 458.99 242.6 458.96 237.42 459.02 237.18 Z"
          data-name="Randolph"
          data-stusps="MO"
          id="29175"
        />
        <path
          className="white"
          d="M 539.02 240.23 541.75 240.03 547.2 239.53 547.54 242.79 547.7 244.44 544.44 244.78 542.52 245 541.59 245.06 541.12 245.04 539.49 245.19 539.02 240.23 Z"
          data-name="Greene"
          data-stusps="IN"
          id="18055"
        />
        <path
          className="white"
          d="M 424.79 280.51 431.64 280.46 431.67 283.81 431.7 285.74 431.72 286.83 430.29 286.85 426.04 286.88 425.85 286.88 424.86 286.89 424.79 280.51 Z"
          data-name="Cherokee"
          data-stusps="KS"
          id="20021"
        />
        <path
          className="white"
          d="M 545.05 220.51 549.34 220.09 549.95 220 551.59 219.78 552.13 224.56 550.9 224.73 550.48 224.78 545.56 225.32 545.05 220.51 Z"
          data-name="Boone"
          data-stusps="IN"
          id="18011"
        />
        <path
          className="white"
          d="M 358.99 216.65 361.82 216.9 362.21 217.05 362.73 217.18 365.6 217.38 365.38 223.19 358.9 222.92 358.73 222.91 358.99 216.65 Z"
          data-name="Phelps"
          data-stusps="NE"
          id="31137"
        />
        <path
          className="white"
          d="M 332.91 228.11 334.17 228.19 334.6 228.21 337.97 228.42 342.33 228.67 342.62 228.69 342.14 236.83 332.72 236.28 332.36 236.26 332.91 228.11 Z"
          data-name="Rawlins"
          data-stusps="KS"
          id="20153"
        />
        <path
          className="white"
          d="M 339.76 352.78 348.04 353.14 347.75 361.34 345.29 361.25 339.36 360.94 339.76 352.78 Z"
          data-name="Stonewall"
          data-stusps="TX"
          id="48433"
        />
        <path
          className="white"
          d="M 682.82 156.72 684.61 156.67 684.37 155.63 686.78 155.48 686.24 153.4 687.94 152.94 689.33 155.64 689.77 159.19 690.02 159.99 690.15 160.61 689.6 160.74 685.14 161.8 684.99 161.83 683.79 162.09 683.04 159.24 682.82 156.72 Z"
          data-name="Tioga"
          data-stusps="NY"
          id="36107"
        />
        <path
          className="white"
          d="M 372.48 190.79 378.92 190.99 378.99 191.34 378.9 194.26 378.8 197.52 372.39 197.33 372.29 197.33 372.48 190.79 Z"
          data-name="Wheeler"
          data-stusps="NE"
          id="31183"
        />
        <path
          className="white"
          d="M 372.39 197.33 378.8 197.52 378.86 197.92 378.73 202.41 378.68 204.03 372.28 203.83 372.18 203.83 372.39 197.33 Z"
          data-name="Greeley"
          data-stusps="NE"
          id="31077"
        />
        <path
          className="white"
          d="M 631.64 271.06 633.71 268.89 635.46 269.1 638.36 267.66 638.8 268.48 641.57 270.91 640.55 271.58 637.2 273.02 636.61 273.87 633.98 274.37 632.59 271.93 631.64 271.06 Z"
          data-name="Wythe"
          data-stusps="VA"
          id="51197"
        />
        <path
          className="white"
          d="M 456.98 244.46 457.77 242.23 458.99 242.6 463.08 243.82 461.29 248.59 461.41 249.11 457.08 249.04 455.83 247.54 455.66 246.47 456.98 244.46 Z"
          data-name="Howard"
          data-stusps="MO"
          id="29089"
        />
        <path
          className="white"
          d="M 544.33 190.54 544.65 190.51 548.53 190.07 548.53 190.07 550.83 189.81 551.48 195.08 545.72 195.77 545.81 196.59 544.99 196.68 545.25 194.04 544.52 192.6 544.33 190.54 Z"
          data-name="St. Joseph"
          data-stusps="IN"
          id="18141"
        />
        <path
          className="white"
          d="M 434.56 380.98 442.26 380.76 443.1 381.75 444.2 382.35 444.72 383.26 445.13 383.98 445.96 385.92 445.78 387.39 445.5 388.08 444.5 387.62 443.1 388.44 441.38 387.5 436.43 386.96 435.85 383.81 435.53 383.4 434.58 381.93 434.56 380.98 Z"
          data-name="Shelby"
          data-stusps="TX"
          id="48419"
        />
        <path
          className="white"
          d="M 378.49 330 385.01 330.13 386.64 330.16 386.6 333.43 386.53 337.51 377.55 337.32 377.63 333.58 377.6 333.25 377.68 329.98 378.49 330 Z"
          data-name="Stephens"
          data-stusps="OK"
          id="40137"
        />
        <path
          className="white"
          d="M 262.29 300.42 268 301 271.53 302.53 272.74 303.66 272.86 303.39 277 303.51 282.83 304.11 288.18 304.53 288.9 304.2 292.2 311.65 293.49 312.37 293.26 315.17 289.86 314.87 285.58 316.42 285.69 315.03 267.68 313.4 267.37 316.68 260.8 316.05 262.29 300.42 Z"
          data-name="San Miguel"
          data-stusps="NM"
          id="35047"
        />
        <path
          className="white"
          d="M 438.59 252.32 438.63 250.74 442.72 250.27 447.67 250.33 447.74 250.88 447.64 257.32 439.49 257.29 438.67 257.28 438.59 252.32 Z"
          data-name="Johnson"
          data-stusps="MO"
          id="29101"
        />
        <path
          className="white"
          d="M 379.12 184.46 385.6 184.62 385.44 191.14 385.38 194.4 378.9 194.26 378.99 191.34 378.92 190.99 379.12 184.46 Z"
          data-name="Antelope"
          data-stusps="NE"
          id="31003"
        />
        <path
          className="white"
          d="M 459.31 392.26 459.86 392.25 463.45 388.95 463.93 391.14 464.91 391.29 471.87 389.43 473.94 391.85 473.72 392.04 473.11 392.61 471.37 392.38 471.47 395.94 471.99 399.1 470.82 399.09 469.15 398.46 467.6 399.43 467.17 400.5 465.73 400.54 465.33 400.5 463.43 400.69 462.08 400.72 461.81 393.97 460.96 392.77 459.6 392.52 459.31 392.26 Z"
          data-name="Rapides"
          data-stusps="LA"
          id="22079"
        />
        <path
          className="white"
          d="M 427.35 420.19 436.15 420.01 437.53 420.03 437.67 426.12 437.4 426.25 436.54 426.06 434.53 425.97 430.99 426.91 430.5 426.42 428.58 427.45 426.79 426.37 426.83 424.92 428.47 422.4 428.55 421.28 427.35 420.19 Z"
          data-name="Chambers"
          data-stusps="TX"
          id="48071"
        />
        <path
          className="white"
          d="M 426.04 169.53 432.5 169.44 432.61 175.95 426.11 176.01 426.04 169.53 Z"
          data-name="Palo Alto"
          data-stusps="IA"
          id="19147"
        />
        <path
          className="white"
          d="M 545.15 300.58 545.33 300.25 545.33 298.85 546.82 298.83 547.31 298.75 547.62 299.79 549.2 298.44 551.34 298.54 554.09 299.59 554.5 302.92 553.52 304.54 552.54 304.89 552.05 304.74 549.6 303.94 549.15 303.56 548.52 303.69 548.01 303.42 545.17 302.64 545.22 300.93 545.15 300.58 Z"
          data-name="Williamson"
          data-stusps="TN"
          id="47187"
        />
        <path
          className="white"
          d="M 27.16 111.92 26.86 112.75 28.73 113.42 30.38 114.78 32.95 115.08 33.37 115.85 32 119.75 30.65 123.6 28.76 128.99 27.08 128.53 25.87 128.05 24.66 127.68 22.7 127.07 20.38 126.24 20.99 124.51 20.8 123.43 22.42 121.83 21.84 119.2 19.94 117.75 21.15 115.87 22.82 116.38 24.54 114.2 27.16 111.92 Z"
          data-name="Josephine"
          data-stusps="OR"
          id="41033"
        />
        <path
          className="white"
          d="M 544.98 219.84 544.57 215.75 549.16 215.26 550.11 215.16 551.18 216.15 551.51 219.12 551.59 219.78 549.95 220 549.34 220.09 545.05 220.51 544.98 219.84 Z"
          data-name="Clinton"
          data-stusps="IN"
          id="18023"
        />
        <path
          className="white"
          d="M 483.58 262.55 485.44 262.41 488.26 262.3 489.8 264.44 490.47 264.58 490.75 271 483.96 271.26 483.58 262.55 Z"
          data-name="Washington"
          data-stusps="MO"
          id="29221"
        />
        <path
          className="white"
          d="M 623.47 187.21 622.97 184.31 629.83 183.12 629.86 183.32 630.4 186.25 630.74 188.15 631.08 190.02 624.19 191.23 623.73 188.64 623.47 187.21 623.47 187.21 Z"
          data-name="Trumbull"
          data-stusps="OH"
          id="39155"
        />
        <path
          className="white"
          d="M 365.79 203.6 372.18 203.83 372.28 203.83 372 210.35 365.48 210.11 365.79 203.6 Z"
          data-name="Sherman"
          data-stusps="NE"
          id="31163"
        />
        <path
          className="white"
          d="M 577.91 275.2 580.36 272.59 582.57 270.08 583.44 270.49 586.82 273.18 587.07 273.43 587.12 275.59 586.47 277.18 585.61 277.53 583.35 279.32 581.57 277.36 580.24 277.96 579.16 277.33 577.99 276.52 577.91 275.2 Z"
          data-name="Pulaski"
          data-stusps="KY"
          id="21199"
        />
        <path
          className="white"
          d="M 560.03 176.12 563.19 175.69 568.11 175.05 569.11 181.63 567.47 181.81 560.92 182.66 560.03 176.12 Z"
          data-name="Calhoun"
          data-stusps="MI"
          id="26025"
        />
        <path
          className="white"
          d="M 495.99 237.06 499.3 236.81 502.57 236.57 503.28 246.41 496.73 246.83 496.38 241.9 495.99 237.06 Z"
          data-name="Macoupin"
          data-stusps="IL"
          id="17117"
        />
        <path
          className="white"
          d="M 371.84 118.38 372.13 111.94 384.75 112.37 385.11 112.38 384.91 118.89 384.1 118.86 379.59 118.72 376.83 118.6 375.53 118.54 371.84 118.38 371.84 118.38 Z"
          data-name="Dickey"
          data-stusps="ND"
          id="38021"
        />
        <path
          className="white"
          d="M 252.48 124.75 259.94 125.86 266.09 126.83 274.41 127.99 274.42 127.99 277.61 128.32 276.78 136.49 271.43 135.84 271.13 135.9 258.51 134.11 255.59 130.98 253.84 130.31 252.94 128.88 252.83 125.12 252.48 124.75 Z"
          data-name="Sheridan"
          data-stusps="WY"
          id="56033"
        />
        <path
          className="white"
          d="M 670.53 296.7 673.15 292.04 673.79 290.71 677.21 291.36 678.04 291.67 680.63 294.37 680.56 294.75 679.92 295.25 679.57 296.31 676.74 296.42 674.69 297.7 672.28 298.65 670.04 297.54 670.53 296.7 Z"
          data-name="Harnett"
          data-stusps="NC"
          id="37085"
        />
        <path
          className="white"
          d="M 394.69 106.09 400.7 106.16 401.04 106.06 401.09 106.18 401.61 107.38 402.04 109.84 402.83 111.29 403.43 112.03 403.48 113.9 403.99 116.46 403.74 117.62 403.72 117.72 403.85 119.25 397.05 119.15 395.14 119.12 394.74 117.96 394.84 112.79 394.57 112.6 394.69 106.09 Z"
          data-name="Richland"
          data-stusps="ND"
          id="38077"
        />
        <path
          className="white"
          d="M 358.5 245.81 366.45 246.1 366.6 246.11 366.24 254.29 358.26 253.99 358.06 253.99 358.5 245.81 Z"
          data-name="Ellis"
          data-stusps="KS"
          id="20051"
        />
        <path
          className="white"
          d="M 663.86 236.6 664.33 235.49 665.24 236.67 664.05 237.5 664.11 237 663.86 236.6 Z"
          data-name="Harrisonburg"
          data-stusps="VA"
          id="51660"
        />
        <path
          className="white"
          d="M 464.22 324.46 465.31 324.53 465.95 326.46 466.17 324.79 469.09 324.77 469.07 323.13 470.71 323.12 471.49 323.1 471.57 328.54 471.17 330.41 472.4 330.39 472.49 332.87 469.72 332.91 469.14 332.91 469.1 331.28 467.48 331.31 467.49 330.49 465.96 330.52 465.96 329.67 464.26 329.4 464.25 328.05 462.63 328.05 462.63 326.41 461.26 326.42 461.01 326.08 461.01 325.34 464.22 324.46 Z"
          data-name="Pulaski"
          data-stusps="AR"
          id="5119"
        />
        <path
          className="white"
          d="M 416.99 245.37 416.98 241.83 417.26 241.56 422.92 241.53 422.98 246.98 422.88 248.57 421.45 248.8 419.48 248.15 418.3 248.36 416.89 248.21 416.99 245.37 Z"
          data-name="Jefferson"
          data-stusps="KS"
          id="20087"
        />
        <path
          className="white"
          d="M 720.74 170.12 723.45 165.72 723.44 165.8 723.98 167.15 725.72 168.91 726.3 171.44 726.33 171.6 723.92 170.98 721.11 170.22 720.74 170.12 720.74 170.12 Z"
          data-name="Rockland"
          data-stusps="NY"
          id="36087"
        />
        <path
          className="white"
          d="M 711.78 148.03 714.44 146.87 714.15 146.32 720.44 143.49 721.38 147.11 720.39 150.32 718.85 149.73 718.24 151.52 714.88 152.06 712.58 151.56 711.22 151.26 711.78 148.03 Z"
          data-name="Greene"
          data-stusps="NY"
          id="36039"
        />
        <path
          className="white"
          d="M 447.98 266.37 454.49 266.39 454.47 269.39 452.83 269.41 452.81 271.32 447.22 271.27 447.06 270.99 447.09 269.36 447.93 269.37 447.98 266.37 Z"
          data-name="Hickory"
          data-stusps="MO"
          id="29085"
        />
        <path
          className="white"
          d="M 414.4 122.58 422.54 122.56 422.7 129.07 421.07 129.07 414.56 129.11 414.4 122.58 Z"
          data-name="Pope"
          data-stusps="MN"
          id="27121"
        />
        <path
          className="white"
          d="M 696.84 274.89 696.59 274.16 697.82 273.14 698.27 273.13 705.58 271.63 705.47 273.5 706.78 275.61 708.17 276.37 707.06 277.1 706.21 279.02 704.99 278.91 704.32 280.43 704.15 279.49 703.3 278.88 701.83 279.97 701.82 278.62 699.37 279.08 698.78 277.73 696.65 276.84 698.02 275.9 696.84 274.89 Z"
          data-name="Bertie"
          data-stusps="NC"
          id="37015"
        />
        <path
          className="white"
          d="M 538.66 191.97 538.98 191.73 540.1 190.98 542.68 190.72 542.7 190.72 544.33 190.54 544.52 192.6 545.25 194.04 544.99 196.68 543.33 196.87 542.17 199.1 541.2 200.11 540.43 200.36 539.64 200.97 538.66 191.97 Z"
          data-name="LaPorte"
          data-stusps="IN"
          id="18091"
        />
        <path
          className="white"
          d="M 452.21 208.28 455.47 208.17 458.72 208.05 458.92 212.98 452.39 213.21 452.21 208.28 Z"
          data-name="Monroe"
          data-stusps="IA"
          id="19135"
        />
        <path
          className="white"
          d="M 638.34 325.72 639.58 325.64 638.74 324.63 640.11 323.12 641.38 324.88 643.61 325.11 645.19 326.25 646.15 328.39 645.79 331.02 646.4 330.27 647.88 330.52 646.15 331.74 645.49 332.06 644.01 333.1 640.17 332.12 637.31 329.72 637.36 329.43 638.34 325.72 Z"
          data-name="Lexington"
          data-stusps="SC"
          id="45063"
        />
        <path
          className="white"
          d="M 691.87 241.8 691.8 240.38 693.26 240.06 694.04 241.73 695.68 242.26 695.89 243.12 697.97 242.44 699.01 243.54 700.28 245.27 700.98 245.61 701.58 247.9 700.79 249.06 700.19 248.48 699.23 247.68 699.3 246.93 696.66 244.73 694.78 244.58 693.47 243.56 692.04 241.66 691.87 241.8 Z"
          data-name="King and Queen"
          data-stusps="VA"
          id="51097"
        />
        <path
          className="white"
          d="M 402.82 384.41 409.9 380.38 409.93 380.51 409.78 381.44 410.42 381.42 411.08 384.66 412.76 385.2 412.99 386.48 414.07 386.99 414.18 387.77 406.96 391.6 402.82 384.41 Z"
          data-name="Freestone"
          data-stusps="TX"
          id="48161"
        />
        <path
          className="white"
          d="M 560.18 129.52 566.54 128.69 567.49 135.22 561.02 136.04 560.18 129.52 Z"
          data-name="Crawford"
          data-stusps="MI"
          id="26039"
        />
        <path
          className="white"
          d="M 460.29 369.01 461.04 365.72 462.67 365.67 465.12 365.8 465.99 367.23 467.64 367.19 467.69 368.83 467.74 370.47 464.45 370.55 464.49 371.36 462.02 371.43 460.39 371.47 460.29 369.01 Z"
          data-name="Lincoln"
          data-stusps="LA"
          id="22061"
        />
        <path
          className="white"
          d="M 392.06 186.36 396.93 186.45 396.91 188.08 399.62 188.12 399.63 188.12 399.58 191.38 396.84 191.34 391.96 191.26 392.06 186.36 Z"
          data-name="Wayne"
          data-stusps="NE"
          id="31179"
        />
        <path
          className="white"
          d="M 660.78 294.36 664.07 293.74 667.25 293.14 667.26 294.08 668.98 296.06 670.53 296.7 670.04 297.54 672.28 298.65 672.31 298.99 669.9 298.64 668.64 299.87 667.09 302.44 665.18 302.25 664.28 300.57 662.61 299.04 660.78 294.36 Z"
          data-name="Moore"
          data-stusps="NC"
          id="37125"
        />
        <path
          className="white"
          d="M 618.07 325.82 624.02 319.85 624.1 320.16 625.27 321.12 624.06 322.57 625.73 324.7 625.7 326.89 624.89 327.83 621.66 328.11 620.79 329.35 619.87 328.16 618.56 327.05 618.07 325.82 Z"
          data-name="Abbeville"
          data-stusps="SC"
          id="45001"
        />
        <path
          className="white"
          d="M 300.99 159.86 302.62 160 315.4 161.22 314.63 170.17 308.08 169.58 307.68 169.54 300.12 168.83 300.65 163.39 300.99 159.86 Z"
          data-name="Fall River"
          data-stusps="SD"
          id="46047"
        />
        <path
          className="white"
          d="M 696.18 214.56 695.49 214.95 694.37 214.36 694.11 214.28 693.7 214.16 693.26 214.03 692.94 212.58 692.9 212.42 693.14 212.18 694.12 211.97 695.53 211.65 695.85 213.07 696.18 214.56 Z"
          data-name="Baltimore"
          data-stusps="MD"
          id="24005"
        />
        <path
          className="white"
          d="M 538.76 307.76 539.79 306.84 541.8 307.39 543.58 306.41 543.5 307.83 544.41 308.43 544.9 309.2 544.62 310.38 542.23 310.34 542.28 311.04 540.37 311.62 539.16 310.31 538.04 310.21 538.93 308.52 538.76 307.76 Z"
          data-name="Lewis"
          data-stusps="TN"
          id="47101"
        />
        <path
          className="white"
          d="M 224.32 203.92 224.79 200.84 225.27 197.55 236.67 199.26 241.41 199.91 249.27 200.96 249.98 201.05 249.03 208.63 247.24 209.51 246.29 215.49 243.33 215.08 236.56 214.19 223.02 212.2 224.29 204.09 224.32 203.92 Z"
          data-name="Moffat"
          data-stusps="CO"
          id="8081"
        />
        <path
          className="white"
          d="M 620.47 337.35 620.93 337.12 623.17 341.76 625.88 342.19 625.21 342.99 623.05 342.27 620.11 344.06 618.6 340.91 618.12 340.66 617.84 340.25 618.52 339.12 619.56 339.2 620.47 337.35 Z"
          data-name="Warren"
          data-stusps="GA"
          id="13301"
        />
        <path
          className="white"
          d="M 627.83 360.4 627.5 361.61 627.57 367.84 627.65 368.1 626.61 368.15 625.61 367.22 624.19 362 624 361.96 624.07 361.69 627.83 360.4 Z"
          data-name="Montgomery"
          data-stusps="GA"
          id="13209"
        />
        <path
          className="white"
          d="M 487.76 335.09 488.59 335.06 488.51 332.56 487.66 332.57 487.55 329.29 494.61 329.02 494.97 329.18 494.79 329.49 495.43 330.36 495.16 331.18 495.16 331.19 495 332.43 495.17 333.25 494.18 333.89 493.93 334.81 492.83 334.33 492.29 334.76 492.53 335.75 491.6 335.98 491.22 336.82 490.38 337.08 490.6 337.82 490.44 338.27 489.77 338.53 489.7 339.07 489.69 339.14 489.36 339.12 486.99 339.22 487.58 338.72 487.76 335.09 Z"
          data-name="Phillips"
          data-stusps="AR"
          id="5107"
        />
        <path
          className="white"
          d="M 405.02 77.21 416.43 77.26 416.45 79.81 416.57 80.12 416.59 81.75 414.98 81.72 414.97 81.18 405.22 81.17 405 80.07 405.02 77.21 Z"
          data-name="Pennington"
          data-stusps="MN"
          id="27113"
        />
        <path
          className="white"
          d="M 232.05 263.12 239.37 264.06 238.85 268.15 237.87 276.12 230.01 275.12 224.28 274.38 225.99 271.79 226.19 270.33 227.42 269.27 227.92 268.04 229.37 267.71 230.56 266.53 231.14 263.94 232.05 263.12 Z"
          data-name="La Plata"
          data-stusps="CO"
          id="8067"
        />
        <path
          className="white"
          d="M 617.05 211.45 617.71 211.37 618.19 209.93 622.33 209.38 622.44 210.18 624.09 209.95 624.67 214.09 622.46 214.47 621.5 215.71 619.83 215.93 619.98 217.04 618.32 217.24 618.09 215.57 617.55 215.64 617.05 211.45 Z"
          data-name="Guernsey"
          data-stusps="OH"
          id="39059"
        />
        <path
          className="white"
          d="M 442.95 336.31 443.16 339.38 444.79 339.4 444.82 342.68 444.79 347.56 442.82 347.55 442.79 347.55 442.68 346.71 441.34 345.12 440.99 344.28 441.17 343.59 440.55 341.46 440.6 339.42 438.2 339.35 437.98 336.29 442.95 336.31 Z"
          data-name="Howard"
          data-stusps="AR"
          id="5061"
        />
        <path
          className="white"
          d="M 349.46 315.15 355.98 315.43 356.04 313.79 359.29 313.91 359.26 314.73 359.09 321.27 358.41 321.24 358.33 321.28 352.57 321.02 352.5 322.65 350.88 322.59 349.15 322.52 349.27 319.65 349.46 315.15 Z"
          data-name="Beckham"
          data-stusps="OK"
          id="40009"
        />
        <path
          className="white"
          d="M 359.31 308.22 370.68 308.58 370.55 313.21 370.67 313.48 370.63 315.11 359.26 314.73 359.29 313.91 359.12 313.1 359.31 308.22 Z"
          data-name="Custer"
          data-stusps="OK"
          id="40039"
        />
        <path
          className="white"
          d="M 566.54 128.69 572.99 127.71 572.99 127.72 573.99 134.24 567.49 135.22 566.54 128.69 Z"
          data-name="Oscoda"
          data-stusps="MI"
          id="26135"
        />
        <path
          className="white"
          d="M 422.95 304.24 424.32 304.23 424.3 302.6 425.93 302.59 429.19 302.56 429.13 312.36 424.24 312.4 424.22 309.14 422.1 309.15 422.62 308.43 421.89 306.32 422.95 304.24 Z"
          data-name="Cherokee"
          data-stusps="OK"
          id="40021"
        />
        <path
          className="white"
          d="M 385.19 317.83 386.93 318.78 387.15 320.18 389.19 321.64 389.99 322.8 390.27 325.01 393.22 325.63 395.17 326.04 396.5 324.99 396.45 327.05 385.08 326.87 385.04 326.54 385.19 317.86 385.19 317.83 Z"
          data-name="McClain"
          data-stusps="OK"
          id="40087"
        />
        <path
          className="white"
          d="M 660.73 264.22 661.81 260.46 662.51 258.03 663.24 258.36 664.99 256.82 665.28 256.94 665.83 255.99 667.99 259.19 669.61 259.68 669.02 263.38 667.91 263.04 666.04 263.16 664.5 263.55 663.94 262.41 661.99 262.4 660.73 264.22 Z"
          data-name="Campbell"
          data-stusps="VA"
          id="51031"
        />
        <path
          className="white"
          d="M 471.14 163.52 472.78 163.44 476.52 163.24 476.37 164.18 476.7 164.76 476.87 165.06 476.79 165.61 477.55 166.3 478.23 166.66 478.97 167.74 478.6 168.37 478 169.3 477.48 170.07 477.54 171.1 471.62 171.38 471.14 163.52 Z"
          data-name="Allamakee"
          data-stusps="IA"
          id="19005"
        />
        <path
          className="white"
          d="M 283.14 375.7 287.27 376.01 293.62 376.46 293.15 383.02 288.59 382.69 288.42 381.67 285.75 380.25 285.4 377.99 284.47 378.26 283.14 375.7 Z"
          data-name="Loving"
          data-stusps="TX"
          id="48301"
        />
        <path
          className="white"
          d="M 345.29 361.25 347.75 361.34 353.71 361.63 353.41 369.92 353.13 369.91 353.12 369.8 344.92 369.45 345.29 361.25 Z"
          data-name="Jones"
          data-stusps="TX"
          id="48253"
        />
        <path
          className="white"
          d="M 456.14 352.84 456.16 346.76 457.31 346.87 459.06 345.85 459.45 346.05 464.31 346.05 464.32 347.29 463.38 348.68 462.2 348.94 462.34 350.81 461.43 351.08 461.63 351.95 462.41 352.1 462.62 353.07 463.4 352.97 463.58 353.68 464.4 353.54 464.82 354.2 463.35 354.46 458.34 354.21 456.13 354.21 456.14 352.84 Z"
          data-name="Ouachita"
          data-stusps="AR"
          id="5103"
        />
        <path
          className="white"
          d="M 694.26 298.29 696.07 296.71 697.17 294.49 696.61 293.22 697.49 293.32 702.52 295.28 703.79 295.28 704.68 299.81 705.23 300.09 703.98 300.65 703.95 300.86 701.83 298.48 700.34 299.11 697.98 298.35 695.27 298.78 694.26 298.29 Z"
          data-name="Jones"
          data-stusps="NC"
          id="37103"
        />
        <path
          className="white"
          d="M 595.72 401.73 597.67 400.32 599.5 399.7 599.75 397.78 601.05 395.52 603.69 395.37 604.37 395.34 605.63 395.28 606.42 398.06 605.47 399.09 605 399.89 605.31 402.94 602.59 403.21 601.8 402.73 594.79 403.5 594.7 402.88 595.72 401.73 Z"
          data-name="Leon"
          data-stusps="FL"
          id="12073"
        />
        <path
          className="white"
          d="M 301.44 258.62 311.19 259.35 310.59 267.68 310.23 271.06 305.33 270.69 300.42 270.3 301.44 258.62 Z"
          data-name="Bent"
          data-stusps="CO"
          id="8011"
        />
        <path
          className="white"
          d="M 528.8 320.16 530.43 320.04 531.33 319.97 532.14 321.29 533.06 321.79 532.89 326.9 532.87 327.68 532.8 329.93 530.08 330.12 529.67 324.92 529.11 324.68 528.8 320.16 Z"
          data-name="Tishomingo"
          data-stusps="MS"
          id="28141"
        />
        <path
          className="white"
          d="M 518.44 397.97 521.73 397.78 525.83 397.51 526.04 400.8 526.11 401.89 520.33 402.25 518.72 402.9 518.44 397.97 Z"
          data-name="Stone"
          data-stusps="MS"
          id="28131"
        />
        <path
          className="white"
          d="M 379.57 86.09 386.12 86.29 385.91 92.79 386.19 94.42 379.72 94.22 379.76 92.85 379.36 92.59 379.52 87.69 379.57 86.09 Z"
          data-name="Griggs"
          data-stusps="ND"
          id="38039"
        />
        <path
          className="white"
          d="M 594.24 321.05 594.4 321.32 594.5 322.53 596.06 323.77 598.06 324.42 598.19 325.57 598.62 325.97 593.9 326.5 593.81 325.63 593.63 324 592.65 324.11 592.04 322.36 592.14 322.04 593.44 322.09 594.24 321.05 Z"
          data-name="Dawson"
          data-stusps="GA"
          id="13085"
        />
        <path
          className="white"
          d="M 389.08 353.65 395.98 354 397.4 354.06 397.7 354.22 397.62 356.89 397.52 360.19 397.47 362.05 395.66 362 395.32 361.99 395.16 361.99 394.52 361.98 392.1 361.93 389.38 361.88 388.71 361.86 388.86 358.27 389.08 353.65 Z"
          data-name="Denton"
          data-stusps="TX"
          id="48121"
        />
        <path
          className="white"
          d="M 518.69 320.9 521.69 320.69 521.87 323.26 522.96 323.18 523.09 325.09 523.63 325.05 523.84 327.9 523.58 328.09 518.09 328.43 517.82 324.35 518.86 323.46 518.69 320.9 Z"
          data-name="Tippah"
          data-stusps="MS"
          id="28139"
        />
        <path
          className="white"
          d="M 584.01 332.43 584.22 332.55 586.92 332.18 587.17 334.67 587.5 335.47 587.7 337.31 587.63 337.65 584.96 338.09 583.82 337.85 582.75 337.73 582.59 336.14 582.37 336.01 582.28 335.1 583.4 335 584.01 332.43 Z"
          data-name="Paulding"
          data-stusps="GA"
          id="13223"
        />
        <path
          className="white"
          d="M 405.1 143.74 409.94 143.78 410.1 145.42 410.11 151.93 405.06 151.9 405.08 148.83 405.09 145.39 405.1 143.74 Z"
          data-name="Lincoln"
          data-stusps="MN"
          id="27081"
        />
        <path
          className="white"
          d="M 604.32 232.39 604.55 231.61 607.95 231.63 608 232.32 609.71 232.19 609.85 234.15 610.1 237.79 608.32 238.05 607.21 238.13 605.56 238.26 605.42 236.53 604.62 236.6 604.32 232.39 Z"
          data-name="Jackson"
          data-stusps="OH"
          id="39079"
        />
        <path
          className="white"
          d="M 297.74 193.29 307.36 194.15 306.95 199.06 306.75 199.86 297.2 199.02 297.2 199.02 297.51 195.8 297.59 194.88 297.74 193.29 Z"
          data-name="Banner"
          data-stusps="NE"
          id="31007"
        />
        <path
          className="white"
          d="M 551.27 235.81 553.16 235.57 555.58 235.26 556.22 240.22 556.26 240.78 552.77 241.18 552.01 241.27 551.27 235.81 Z"
          data-name="Brown"
          data-stusps="IN"
          id="18013"
        />
        <path
          className="white"
          d="M 406.39 189.1 415.69 189.18 415.68 195.72 409.31 195.66 408.86 194.83 409.23 193.62 407.96 192.72 407.27 192.25 407.34 191.01 406.24 190 406.39 189.1 Z"
          data-name="Monona"
          data-stusps="IA"
          id="19133"
        />
        <path
          className="white"
          d="M 203.66 100.66 204.97 100.97 205.7 100.39 206.93 99.21 209.46 97.97 209.65 96.73 210.85 95.79 211.13 94.57 214.86 95.21 218.48 95.92 218.21 96.86 216.17 107.18 215.35 107.02 215.1 108.25 214.3 108.1 213.69 111.36 212.1 111.05 210.75 117.61 210.1 120.09 209.61 122.75 209.4 123.86 209.25 124.64 208.79 127.48 207.87 126.93 207.74 126.08 207.11 125.18 206.98 124.23 206.54 123.27 206.01 122.07 205.4 121.43 207.97 110.26 209.03 104.79 206.6 104.3 205.36 102.08 204.55 101.91 204.66 101.37 204.11 101.25 204.17 100.99 203.62 100.88 203.66 100.66 Z"
          data-name="Gallatin"
          data-stusps="MT"
          id="30031"
        />
        <path
          className="white"
          d="M 678.6 163.28 683.79 162.09 683.79 162.09 684.99 161.83 685.14 161.8 689.6 160.74 691.59 167.18 690.43 167.54 690.6 169.62 681.97 170.66 681.08 170.73 678.6 163.28 Z"
          data-name="Bradford"
          data-stusps="PA"
          id="42015"
        />
        <path
          className="white"
          d="M 630.94 351.15 631.7 349.04 635.18 347.86 636.74 348.5 635.73 353.2 636.23 353.6 633.77 354.74 632.31 353.85 630.94 351.15 Z"
          data-name="Jenkins"
          data-stusps="GA"
          id="13165"
        />
        <path
          className="white"
          d="M 651.11 260.97 651.09 261.86 650.35 261.93 649.69 261.63 651.11 260.97 Z"
          data-name="Salem"
          data-stusps="VA"
          id="51775"
        />
        <path
          className="white"
          d="M 574.66 269.91 575.1 269.88 574.89 267.37 577.04 267.37 577.76 266.97 577.98 269.26 580.06 270.3 580.44 271.41 580.36 272.59 577.91 275.2 577.14 275.56 575.61 274.14 575.26 272.83 573.51 272.01 573.86 270.56 574.66 269.91 Z"
          data-name="Casey"
          data-stusps="KY"
          id="21045"
        />
        <path
          className="white"
          d="M 707.42 269.12 708.95 268.27 710.64 270.29 712.08 270.69 714.29 272.5 714.79 273.38 714.39 273.7 711.84 274.78 711.22 274.78 710.94 273.92 708.18 273.76 707.39 271.35 707.42 269.12 Z"
          data-name="Perquimans"
          data-stusps="NC"
          id="37143"
        />
        <path
          className="white"
          d="M 516.31 356.64 517.95 356.53 517.85 354.87 519.51 354.76 519.72 353.08 521.65 352.95 524.07 352.79 524.53 359.56 522.92 359.66 522.67 359.81 521.27 359.67 516.5 359.97 516.31 356.64 Z"
          data-name="Winston"
          data-stusps="MS"
          id="28159"
        />
        <path
          className="white"
          d="M 520.03 230.18 520.17 229.99 520.05 228.52 521.69 228.38 527.64 227.86 527.34 229.54 527.55 231.54 526.2 232.29 520.26 232.81 520.03 230.18 Z"
          data-name="Douglas"
          data-stusps="IL"
          id="17041"
        />
        <path
          className="white"
          d="M 482.22 185.61 485.46 185.43 485.37 183.79 487.88 183.64 488.44 184.07 488.89 184.74 488.75 185.54 489.22 186.24 490.14 186.86 490.47 187.02 491.14 187.34 492.03 187.76 492.73 188.52 492.78 189.76 492.84 189.89 482.5 190.52 482.22 185.61 Z"
          data-name="Jackson"
          data-stusps="IA"
          id="19097"
        />
        <path
          className="white"
          d="M 522.49 332.54 522.87 330.05 523.68 329.73 526.71 329.51 526.77 330.34 527.26 337.41 524.61 337.59 524.53 337.88 522.88 337.98 522.49 332.54 Z"
          data-name="Lee"
          data-stusps="MS"
          id="28081"
        />
        <path
          className="white"
          d="M 508.72 277.44 512.11 277.19 512.21 281.51 513.69 282.04 514.33 283.02 514.32 283.7 513.37 283.62 512.4 283.2 511.62 283 510.83 282.8 510.38 281.69 509.19 280.17 508.89 278.96 508.69 278.83 508.15 278.47 508.43 277.64 508.72 277.44 Z"
          data-name="Alexander"
          data-stusps="IL"
          id="17003"
        />
        <path
          className="white"
          d="M 563.87 263.53 564.72 263.38 566.13 261.88 567.2 259.75 568.65 260.55 572.04 259.56 572.42 260.93 571.77 261.98 570.97 261.69 569.06 264.5 568.43 265.42 567.64 268.02 566.13 268.45 566.29 265.52 564.89 264.93 563.95 264.1 563.87 263.53 Z"
          data-name="Nelson"
          data-stusps="KY"
          id="21179"
        />
        <path
          className="white"
          d="M 385.76 264.64 390.65 264.74 393.89 264.77 393.86 266.4 393.83 269.68 385.66 269.57 385.76 264.64 Z"
          data-name="Harvey"
          data-stusps="KS"
          id="20079"
        />
        <path
          className="white"
          d="M 409.94 143.78 416.5 143.79 416.62 145.44 416.66 151.95 410.31 151.93 410.11 151.93 410.1 145.42 409.94 143.78 Z"
          data-name="Lyon"
          data-stusps="MN"
          id="27083"
        />
        <path
          className="white"
          d="M 125.99 120.24 126.19 121.19 127.35 122.38 129.33 122.62 132.05 123.33 131.2 126.58 131.74 126.72 130.88 130.01 129.54 133.04 128.69 132.51 128.41 131.15 126.76 128.54 126.47 126.14 125.6 125.73 124.43 123.87 125.18 121.18 125.99 120.24 Z"
          data-name="Canyon"
          data-stusps="ID"
          id="16027"
        />
        <path
          className="white"
          d="M 439.68 274.69 439.71 269.78 443.53 269.86 443.51 270.95 446.24 270.99 446.56 272.63 446.54 275.8 439.68 275.78 439.68 274.69 Z"
          data-name="Cedar"
          data-stusps="MO"
          id="29039"
        />
        <path
          className="white"
          d="M 485.72 322.67 487.33 322.62 487.24 319.85 495.57 319.5 497.15 319.34 497.27 323.93 486.58 324.33 486.61 325.17 485.76 324.37 485.72 322.67 Z"
          data-name="St. Francis"
          data-stusps="AR"
          id="5123"
        />
        <path
          className="white"
          d="M 690.41 189.29 692.04 190.09 696.02 191.87 697 192.54 695 194.21 691.5 196.17 688.7 191.28 690.41 189.29 Z"
          data-name="Lebanon"
          data-stusps="PA"
          id="42075"
        />
        <path
          className="white"
          d="M 555.21 276.65 557.15 278.15 558.06 277.61 559.73 278.26 559.17 280.73 558.64 280.76 555.85 284.06 555.88 283.47 553.07 283.31 552.54 282.36 551.38 280.26 551.82 276.77 553.7 276.41 555.21 276.65 Z"
          data-name="Warren"
          data-stusps="KY"
          id="21227"
        />
        <path
          className="white"
          d="M 654.23 459.79 659.28 459.22 659.07 457.53 660.77 457.32 660.55 455.65 664.46 455.25 665.61 455.82 665.97 459.85 665.39 463.6 654.76 464.83 654.23 459.79 Z"
          data-name="Glades"
          data-stusps="FL"
          id="12043"
        />
        <path
          className="white"
          d="M 626.37 342.12 627.2 341.19 627.36 341.02 630.94 337.02 631.17 337.3 631.67 337.9 632.78 338.36 633.01 339.33 632.98 340.63 634.46 341.2 634.6 342.27 630.65 343.13 629.26 342.04 627.85 342.79 626.7 342.15 626.37 342.12 Z"
          data-name="Richmond"
          data-stusps="GA"
          id="13245"
        />
        <path
          className="white"
          d="M 644.81 286.47 647.86 286.07 648.31 285.69 649.65 287.21 650.3 288.8 649.99 289.72 648.64 290.1 649.36 291.73 645.4 290.02 645.18 290.26 644.81 286.47 Z"
          data-name="Davie"
          data-stusps="NC"
          id="37059"
        />
        <path
          className="white"
          d="M 442.92 330.39 443.83 329.5 444.66 329.51 446.3 328.83 451.18 328.76 451.09 329.86 451.14 335.25 451.15 336.34 450.06 336.34 442.95 336.31 442.92 330.39 Z"
          data-name="Montgomery"
          data-stusps="AR"
          id="5097"
        />
        <path
          className="white"
          d="M 516.35 205.59 521.09 205.07 521.35 207.31 522.14 214.36 518.93 214.65 517.28 214.81 516.92 212.17 512 212.65 511.71 209.38 511.45 206.03 516.35 205.59 Z"
          data-name="Livingston"
          data-stusps="IL"
          id="17105"
        />
        <path
          className="white"
          d="M 548.91 212.83 551.91 212.47 554.08 212.2 556.23 211.93 556.59 214.91 553.74 215.27 551.13 215.6 551.18 216.15 550.11 215.16 549.16 215.26 548.91 212.83 Z"
          data-name="Howard"
          data-stusps="IN"
          id="18067"
        />
        <path
          className="white"
          d="M 689.6 160.74 690.15 160.61 693.46 159.81 697.93 158.71 698.91 158.46 700.88 165.14 697.23 166.02 691.87 167.27 691.59 167.18 689.6 160.74 Z"
          data-name="Susquehanna"
          data-stusps="PA"
          id="42115"
        />
        <path
          className="white"
          d="M 635.01 212.1 637.98 210.44 642.51 210.35 643.81 211.32 644.61 215.08 642.27 215.5 637.24 216.4 635.81 216.65 635.01 212.1 Z"
          data-name="Greene"
          data-stusps="PA"
          id="42059"
        />
        <path
          className="white"
          d="M 637.24 216.4 642.27 215.5 644.61 215.08 646.83 214.68 646.79 216.58 645.67 219.55 645.9 220.41 645.19 220.21 641.52 217.8 638.68 218.28 637.89 217.92 637.45 216.43 637.24 216.4 Z"
          data-name="Monongalia"
          data-stusps="WV"
          id="54061"
        />
        <path
          className="white"
          d="M 448.61 219.29 449.03 219.28 452.03 219.15 452.58 219.11 454.8 218.97 458.05 218.82 458.52 219.35 458.22 221.51 458.65 223.42 456.19 223.52 456.17 222.71 448.83 222.99 448.66 221.32 448.61 219.29 Z"
          data-name="Putnam"
          data-stusps="MO"
          id="29171"
        />
        <path
          className="white"
          d="M 637.43 401.79 638.97 401.6 639.95 409.12 639.96 409.67 639.86 409.69 638.3 407.61 635.97 407.75 633.37 406.52 635.15 405.66 635.76 404.21 637.43 402.43 637.43 401.79 Z"
          data-name="Bradford"
          data-stusps="FL"
          id="12007"
        />
        <path
          className="white"
          d="M 612.61 273.88 613.29 273.81 612.86 274.33 613.02 274.73 612.38 274.58 612.61 273.88 Z"
          data-name="Norton"
          data-stusps="VA"
          id="51720"
        />
        <path
          className="white"
          d="M 312.61 359.61 314.71 359.72 320.81 360.03 320.39 368.23 312.21 367.8 312.61 359.61 Z"
          data-name="Dawson"
          data-stusps="TX"
          id="48115"
        />
        <path
          className="white"
          d="M 278.86 240.16 284.29 240.7 293.24 241.58 292.74 246.44 292.17 252.96 279.06 251.77 279.29 249.31 279.6 246.56 277.66 246.31 278.43 245.07 278.86 240.16 Z"
          data-name="El Paso"
          data-stusps="CO"
          id="8041"
        />
        <path
          className="white"
          d="M 353.71 361.63 355.93 361.7 361.87 361.9 361.73 366.58 361.61 370.19 361.32 370.18 353.41 369.92 353.71 361.63 Z"
          data-name="Shackelford"
          data-stusps="TX"
          id="48417"
        />
        <path
          className="white"
          d="M 517.44 172.69 520.71 172.36 524.15 172.06 525.01 173.07 524.9 174.67 524.73 175.3 519.37 175.78 519.47 176.87 517.84 177.03 517.44 172.69 Z"
          data-name="Racine"
          data-stusps="WI"
          id="55101"
        />
        <path
          className="white"
          d="M 646.54 159.63 647.54 159.6 648.88 161.03 651.88 159.83 654.86 157.94 655.12 158.22 657.08 157.76 659.18 167.59 655.12 168.43 650.6 169.37 649.7 169.56 648.6 169.78 646.54 159.63 Z"
          data-name="Cattaraugus"
          data-stusps="NY"
          id="36009"
        />
        <path
          className="white"
          d="M 417.33 237.18 420.59 237.16 423.85 237.15 424.88 237.87 424.84 238.22 424.42 238.56 423.88 239 424.21 239.38 424.82 240.1 425.81 241.11 426.05 241.46 425.59 241.52 422.92 241.53 417.26 241.56 417.33 237.18 Z"
          data-name="Atchison"
          data-stusps="KS"
          id="20005"
        />
        <path
          className="white"
          d="M 74.52 4.61 76.67 5.1 77.44 4.94 78.35 4.02 78.92 4.06 80.05 5.46 80.39 7.33 79.3 8.12 79.34 9.03 78.87 9.98 78.22 10.26 78.01 11.34 77.07 11.2 76.56 10.55 75.35 9.66 74.41 8.34 74.27 6.49 74.52 4.61 Z"
          data-name="San Juan"
          data-stusps="WA"
          id="53055"
        />
        <path
          className="white"
          d="M 467.18 150.61 467.71 151.21 469.07 151.81 470.1 152.97 471.14 153.62 471.34 153.66 472.97 154 473.22 154.31 474.18 155.52 475.15 156.68 475.2 156.79 469.18 157.11 464.44 157.33 464.22 152.46 464.15 150.84 467.18 150.61 Z"
          data-name="Winona"
          data-stusps="MN"
          id="27169"
        />
        <path
          className="white"
          d="M 631.71 208.89 631.88 208.28 632.19 208.38 634.36 208.38 634.83 211.08 631.6 211.31 631.46 210.43 631.68 209.01 631.71 208.89 Z"
          data-name="Ohio"
          data-stusps="WV"
          id="54069"
        />
        <path
          className="white"
          d="M 607.64 327.49 608.32 326.91 608.89 326.15 611.15 326.27 612 325.49 612.67 326.36 612.4 327.41 614.71 329.57 613.64 330.23 612.38 329.78 610.37 330.96 609.78 330.86 608.67 330.38 608.23 330.25 608.54 328.94 607.64 327.49 Z"
          data-name="Madison"
          data-stusps="GA"
          id="13195"
        />
        <path
          className="white"
          d="M 508.03 273.25 508.08 273.04 508.71 272.43 513.18 272.11 514.86 272.06 515.18 277.08 512.11 277.19 508.72 277.44 509.39 276.98 509.36 276.02 508.6 274.96 507.91 273.81 508.03 273.25 Z"
          data-name="Union"
          data-stusps="IL"
          id="17181"
        />
        <path
          className="white"
          d="M 604.63 339.38 606.62 335.32 606.89 334.87 607.28 335.06 608.74 336.94 609.91 338.67 611.29 339.79 611.24 340.75 607.33 342.17 604.77 340.72 604.74 339.85 604.63 339.38 Z"
          data-name="Morgan"
          data-stusps="GA"
          id="13211"
        />
        <path
          className="white"
          d="M 507.95 389.51 510.13 389.4 510.07 388.57 512.81 388.42 513.27 396.52 512.07 396.59 512.07 396.59 510.33 396.69 510.25 395.32 508.88 395.4 508.54 394.32 506.98 393.6 506.69 390.6 506.63 389.5 507.95 389.51 Z"
          data-name="Marion"
          data-stusps="MS"
          id="28091"
        />
        <path
          className="white"
          d="M 540.37 311.62 542.28 311.04 542.23 310.34 544.62 310.38 545.67 310.58 545.99 310.48 545.83 313.16 546.1 313.25 546.44 318.67 540.51 319.09 540.96 318.19 540.37 311.62 Z"
          data-name="Lawrence"
          data-stusps="TN"
          id="47099"
        />
        <path
          className="white"
          d="M 25.94 93.87 30.6 95.65 29.97 97.38 30.78 97.67 30.18 99.26 30.88 99.71 29.72 102.78 30.54 103.08 29.41 106.3 28.57 106.07 27.98 107.7 27.16 107.41 25.88 111.35 24.2 111.05 22.61 112.37 20.59 112.03 20.71 110.52 21.73 108.53 21.23 106.57 20.84 105.98 17.78 104.86 19.2 102.88 20.16 101.35 20.82 100.23 21.33 99.43 21.3 98.74 22.23 98.22 23.8 96.8 25.37 94.81 25.94 93.87 Z"
          data-name="Coos"
          data-stusps="OR"
          id="41011"
        />
        <path
          className="white"
          d="M 392.66 151.77 395.91 151.81 399.16 151.86 399.08 158.38 395.81 158.34 392.55 158.27 392.66 151.77 Z"
          data-name="Lake"
          data-stusps="SD"
          id="46079"
        />
        <path
          className="white"
          d="M 515.66 199.05 520.51 198.52 520.51 198.52 521.05 203.42 521.21 204.78 521.09 205.07 516.35 205.59 515.66 199.05 Z"
          data-name="Grundy"
          data-stusps="IL"
          id="17063"
        />
        <path
          className="white"
          d="M 563.74 155.66 567 155.22 570.25 154.77 571.17 161.11 571.19 161.3 564.73 162.16 563.74 155.66 Z"
          data-name="Gratiot"
          data-stusps="MI"
          id="26057"
        />
        <path
          className="white"
          d="M 342.49 327.53 348.93 327.83 348.78 331.32 348.82 331.31 348.63 335.99 342.09 335.67 342.49 327.53 Z"
          data-name="Childress"
          data-stusps="TX"
          id="48075"
        />
        <path
          className="white"
          d="M 342.62 228.69 346.4 228.9 350.49 229.11 350.72 229.12 350.28 237.27 342.44 236.85 342.14 236.83 342.62 228.69 Z"
          data-name="Decatur"
          data-stusps="KS"
          id="20039"
        />
        <path
          className="white"
          d="M 645.85 254.51 646.21 253.78 646.6 252.49 646.75 251.61 647.56 250.26 648.5 248.88 650.29 248.52 651.22 249.55 653.31 249.33 654.3 249.96 654.88 249.27 655.54 249.39 654.85 251.45 652.58 251.11 651.4 253.25 650.03 254.55 648.31 255.84 647.04 255.52 645.82 254.56 645.85 254.51 Z M 650.12 252.57 650.48 252.33 650.2 251.91 650.32 251.46 649.98 251.32 649.93 252.11 650.12 252.57 Z"
          data-name="Alleghany"
          data-stusps="VA"
          fillRule="evenodd"
          id="51005"
        />
        <path
          className="white"
          d="M 504.61 281.64 506.66 279.49 508.69 278.83 508.89 278.96 509.19 280.17 510.38 281.69 510.83 282.8 511.62 283 509.37 284.92 508.63 286.21 507.9 286.24 506.05 286.57 506.06 285.39 504.34 282.39 504.61 281.64 Z"
          data-name="Scott"
          data-stusps="MO"
          id="29201"
        />
        <path
          className="white"
          d="M 68.03 317.5 68.6 316.27 69.79 316.22 69.92 315.53 72.27 316.05 73.75 317.38 73.88 317.47 74.01 317.55 73.95 317.88 75.56 318.21 76.4 318.44 77.32 318.71 80.69 319.42 92.55 321.9 91.25 328.65 89.49 335.35 89.09 337.33 81.88 336.58 80.45 336.43 76.62 336.02 72.16 335.56 72.25 334.55 72.31 333.89 72 332.76 71.88 332.63 71.61 332.34 70.73 332.54 70.71 331.92 71.07 330.25 70.79 329.48 70.84 329.14 71.02 328.94 71.19 329.02 71.34 328.85 71.34 328.84 71.54 328.07 71.56 326.56 71.57 325.82 71.35 324.13 70.89 322.53 69.97 320.31 68.72 318.08 68.03 317.51 68.03 317.5 Z"
          data-name="San Diego"
          data-stusps="CA"
          id="6073"
        />
        <path
          className="white"
          d="M 484.71 201.33 485.91 201.23 487.04 200.59 487.68 199.96 488.49 199.85 489.22 199.73 489.81 198.95 490.52 198.59 490.85 198.21 490.81 196.97 491.08 196.38 491.08 195.75 491.08 195.49 491.91 194.73 491.99 194.67 492.3 196.67 493.31 197.2 493.04 198.33 492.94 199.18 491.05 199.79 489.71 200.95 489.84 203.39 480.77 203.79 480.8 203.69 480.86 203.13 481.33 202.08 482.19 201.91 482.79 202.01 483.57 201.49 484.71 201.33 Z"
          data-name="Rock Island"
          data-stusps="IL"
          id="17161"
        />
        <path
          className="white"
          d="M 560.69 249.6 561.4 248.7 562.49 248.56 564.7 248.3 565.78 248.17 566.79 248.44 567.11 249.17 566.9 249.62 566.9 249.62 566.33 250.06 566.04 250.78 564.77 251.26 564.34 251.95 564.23 252.69 564.13 253.38 563.67 254.34 562.73 254.97 562.06 254.85 562.41 253.43 561.61 252.49 558.81 252.53 558.69 251.21 559.19 250.9 560.26 250.75 560.69 249.6 Z"
          data-name="Clark"
          data-stusps="IN"
          id="18019"
        />
        <path
          className="white"
          d="M 579.24 237.1 580.32 239.03 580.73 242.31 581.25 242.49 579.6 242.98 578.34 242.94 578.42 241.45 577.6 237.75 577.82 237.82 578.6 237.23 579.24 237.1 Z"
          data-name="Kenton"
          data-stusps="KY"
          id="21117"
        />
        <path
          className="white"
          d="M 529.59 272.66 530.29 271.79 531.63 272.95 531.79 274.27 533 273.95 533.77 274.67 529.68 277.99 529.65 278.79 528.41 279.91 528.23 279.52 527.66 277.19 525.98 274.96 525.49 275.02 525.37 274.88 525.37 274.88 526.45 273.89 528.29 273.47 529.68 272.96 529.59 272.66 Z"
          data-name="Crittenden"
          data-stusps="KY"
          id="21055"
        />
        <path
          className="white"
          d="M 695.82 223.98 696.38 223.44 696.98 224.27 698.33 224.14 698.51 225.07 698.97 225.93 699.2 227.4 699.8 228.39 700.59 229.02 701.67 229.83 701.88 230.35 701.86 231.18 701.12 231.63 700.13 230.51 698.32 229.87 697.03 228.66 696.86 227.97 695.74 224.74 695.82 223.98 Z"
          data-name="Calvert"
          data-stusps="MD"
          id="24009"
        />
        <path
          className="white"
          d="M 403.85 119.25 403.72 117.72 403.74 117.62 407.75 117.65 407.91 119.29 407.89 122.57 407.88 125.84 400.2 125.76 400.09 125.61 400 125.14 400.34 124.49 401.42 123.61 402.38 123.04 402.94 122.13 403.52 121.48 403.73 120.44 403.85 119.25 Z"
          data-name="Traverse"
          data-stusps="MN"
          id="27155"
        />
        <path
          className="white"
          d="M 487.28 360.03 490.35 359.91 491.16 359.92 490.53 363.14 490.66 366.43 494.5 366.26 495.03 366.72 494.59 367.07 494.51 368.06 492.4 368 492.5 370.49 490.9 371.15 490.75 368.06 489.41 368.18 489.4 368.16 489.3 368.07 488.89 367.68 488.52 366.1 489.15 365.32 488.24 365.09 487.51 364.44 487.41 363.76 487.76 363.06 488.79 362.27 488.73 361.35 487.7 360.59 487.18 360.17 487.28 360.03 Z"
          data-name="Issaquena"
          data-stusps="MS"
          id="28055"
        />
        <path
          className="white"
          d="M 436.34 219.73 438.36 219.68 439.44 219.63 441.94 219.53 442.89 219.49 443.07 221.46 443.19 225.37 443.24 227.83 436.71 227.9 436.66 223.25 436.39 221.64 436.34 219.73 Z"
          data-name="Harrison"
          data-stusps="MO"
          id="29081"
        />
        <path
          className="white"
          d="M 208.87 311.53 217.84 312.72 218.68 306.3 218.7 306.16 230.07 307.62 230.17 306.8 231.81 307 231.7 307.83 236.65 308.39 237.74 308.52 238.19 310.22 239.65 315.4 237.53 315.15 236.73 322.3 229.08 321.39 228.56 321.36 207.9 318.73 208.87 311.53 208.87 311.53 Z"
          data-name="Cibola"
          data-stusps="NM"
          id="35006"
        />
        <path
          className="white"
          d="M 596.08 185.02 596.52 184.39 597.21 184.84 597.28 185.81 596.57 186.2 596.08 185.02 Z M 588.49 187.59 590.98 187.14 591.78 187.02 592.03 186.97 593.49 187.3 594.15 187.97 595.59 188.54 596.47 187.21 596.8 186.95 598.57 187.55 599.09 188.35 598.58 188.76 595.5 189.64 593.87 189.9 590.03 190.47 588.83 189.82 588.49 187.59 Z"
          data-name="Ottawa"
          data-stusps="OH"
          fillRule="evenodd"
          id="39123"
        />
        <path
          className="white"
          d="M 424.24 312.4 429.13 312.36 434.26 312.3 434.65 314.96 434.91 316.9 434.92 317 434.05 318.62 432.47 318.15 431.34 318.78 430.07 317.63 429.1 318.27 427.55 317.84 427.74 316.89 426.13 316.59 425.45 315.77 424.9 315.72 424.18 314.52 424.24 312.4 Z"
          data-name="Sequoyah"
          data-stusps="OK"
          id="40135"
        />
        <path
          className="white"
          d="M 714.29 191.97 715.13 192.18 715.33 193.56 715.13 193.79 714.33 194.89 714.31 194.9 713.57 195.61 713.45 195.93 713.42 196.02 713.55 196.49 713.69 196.97 713.58 197.05 713.03 197.42 712.69 197.81 711.89 197.8 712.02 196.55 711.23 195.95 711.55 195.61 712.04 195.12 712.07 195.09 712.08 195.07 712.1 195.05 712.1 195.04 712.09 195.04 711.05 194.45 711.47 193.57 712.83 193.83 713.35 194.05 714.29 191.97 Z"
          data-name="Philadelphia"
          data-stusps="PA"
          id="42101"
        />
        <path
          className="white"
          d="M 399.16 151.86 405.06 151.9 405 158.41 405 158.41 399.08 158.38 399.16 151.86 Z"
          data-name="Moody"
          data-stusps="SD"
          id="46101"
        />
        <path
          className="white"
          d="M 320.18 284.02 322.08 284.14 327.31 284.43 328.36 284.49 332.49 284.7 334.67 284.81 336.5 284.9 335.86 294.25 333.88 294.15 325.71 293.67 322.64 293.48 319.52 293.28 320.18 284.02 Z"
          data-name="Texas"
          data-stusps="OK"
          id="40139"
        />
        <path
          className="white"
          d="M 454.14 132.13 462.24 131.8 462.58 133.44 462.81 138.39 454.38 138.66 454.54 137.16 454.33 135.65 453.76 134.86 454.55 133.93 454.5 133.74 454.14 132.41 454.14 132.13 Z"
          data-name="St. Croix"
          data-stusps="WI"
          id="55109"
        />
        <path
          className="white"
          d="M 562.32 334.31 563.71 332.78 565.21 332.38 565.23 332.1 569.34 331.71 569.54 333.39 570.24 333.42 571.41 335.91 571.44 336.54 569.75 336.29 567.9 337.28 566.52 338.79 565.2 337.83 564.15 336.23 562.73 336.46 562.25 337.34 561.55 337.41 561.97 335.46 562.32 334.31 Z"
          data-name="Etowah"
          data-stusps="AL"
          id="1055"
        />
        <path
          className="white"
          d="M 458.59 320.56 459.29 320.47 459.19 315.04 464.9 315 464.93 316.63 464.93 318.38 464.3 319.24 464.47 321.42 463.96 321.45 462.83 322.19 456.49 322.37 456.47 321.77 458.59 320.56 Z"
          data-name="Conway"
          data-stusps="AR"
          id="5029"
        />
        <path
          className="white"
          d="M 464.31 346.05 468.21 346.06 468.13 347.04 468.32 347.69 468.73 351.71 467.82 355.09 468.22 355.26 468.28 355.37 467.02 355.96 464.82 354.2 464.4 353.54 463.58 353.68 463.4 352.97 462.62 353.07 462.41 352.1 461.63 351.95 461.43 351.08 462.34 350.81 462.2 348.94 463.38 348.68 464.32 347.29 464.31 346.05 Z"
          data-name="Calhoun"
          data-stusps="AR"
          id="5013"
        />
        <path
          className="white"
          d="M 573.76 252.41 575.03 251.51 575.6 251.79 576.79 251.99 577.54 251.64 577.99 254.18 578.13 254.57 576.17 255.83 576.23 256.29 575.72 256.8 573.84 256.35 573.88 253.56 574.37 252.4 573.76 252.41 Z"
          data-name="Franklin"
          data-stusps="KY"
          id="21073"
        />
        <path
          className="white"
          d="M 642.68 187.1 643.44 184.05 645.18 183.44 645 182.48 646.1 182.27 645.92 181.33 648.67 180.89 649.02 182.76 649.92 187.54 649.97 188.09 649.13 189.06 644.45 190.63 642.78 187.15 642.68 187.1 Z"
          data-name="Clarion"
          data-stusps="PA"
          id="42031"
        />
        <path
          className="white"
          d="M 501.45 132.69 504.68 132.43 504.82 134.05 508.1 133.76 508.23 135.39 511.53 135.11 514.76 134.86 515.14 138.11 515.03 138.35 515.27 139.89 510.42 140.22 510.28 138.57 501.99 139.23 501.45 132.69 Z"
          data-name="Shawano"
          data-stusps="WI"
          id="55115"
        />
        <path
          className="white"
          d="M 581.43 385.46 585.31 385.22 586.77 385.06 586.78 385.32 586.55 386.03 586.7 387.4 588.01 388.76 588.31 389.35 588.51 389.75 588.75 390.74 588.28 390.78 586.42 390.96 583.37 391.28 580.85 391.55 580.53 387.73 576.9 388.16 577.49 386.73 580.45 386.86 581.43 385.46 Z"
          data-name="Houston"
          data-stusps="AL"
          id="1069"
        />
        <path
          className="white"
          d="M 533.06 321.79 535.01 321.82 535.95 323.23 537.82 324.45 542.05 322.2 543.62 322.68 543.55 325.51 542.38 327.2 532.87 327.68 532.89 326.9 533.06 321.79 Z"
          data-name="Colbert"
          data-stusps="AL"
          id="1033"
        />
        <path
          className="white"
          d="M 668.08 447.97 674.26 447.2 675.78 450.46 677.01 452.57 675.53 452.75 675.66 453.85 668.95 454.69 668.08 447.97 Z"
          data-name="St. Lucie"
          data-stusps="FL"
          id="12111"
        />
        <path
          className="white"
          d="M 641.35 355.99 641.6 355.46 643.66 353.55 644.69 354.14 645.44 354.31 645.6 354.34 647.1 355.66 647.24 356.68 647.66 357.14 648.45 358 648.68 359.1 648.37 359.89 648.5 360.08 647.7 359.99 644.9 363.12 644.64 363.03 643.8 360.45 643.52 359.65 641.81 357.78 641.35 355.99 Z"
          data-name="Effingham"
          data-stusps="GA"
          id="13103"
        />
        <path
          className="white"
          d="M 519.55 185.52 520.09 185.47 522.55 185.26 522.82 185.23 523.63 185.17 526.25 184.94 526.54 185.36 526.54 185.36 526.54 185.37 527.35 186.17 527.46 186.27 527.73 187.13 528.39 188.89 528.57 189.37 528.59 189.41 528.77 189.6 528.77 189.77 528.76 190.03 528.9 190.5 529.26 191.12 529.38 191.31 529.73 191.92 530.19 192.22 530.32 192.66 530.35 192.96 530.67 196.31 530.77 197.43 527.07 197.79 526.92 196.7 526.56 196.16 525.19 196.32 525 194.69 523.31 194.35 523.28 194.06 523.62 194.02 523.94 193.98 523.96 193.96 524.16 193.95 524.31 193.82 524.42 193.76 524.48 193.69 524.49 193.61 524.84 193.26 524.72 192.29 524.67 191.93 524.66 191.83 524.42 189.76 524.37 189.11 524.01 188.15 520.73 188.56 519.49 188.7 519.43 188.15 519.34 187.19 519.65 186.68 519.55 185.52 Z"
          data-name="Cook"
          data-stusps="IL"
          id="17031"
        />
        <path
          className="white"
          d="M 424.53 273.15 424.65 271.51 424.64 267.43 431.52 267.36 431.53 268.29 431.55 274.02 431.55 274.19 424.54 274.24 424.53 273.15 Z"
          data-name="Bourbon"
          data-stusps="KS"
          id="20011"
        />
        <path
          className="white"
          d="M 327.73 277.05 328.2 277.08 334.73 277.47 335.05 277.49 334.67 284.81 332.49 284.7 328.36 284.49 327.31 284.43 327.73 277.05 Z"
          data-name="Stevens"
          data-stusps="KS"
          id="20189"
        />
        <path
          className="white"
          d="M 506.72 412.64 507.84 412.77 510.04 411.84 511.8 412.46 513.62 412.08 514.62 412.44 514.96 412.62 514.14 413.13 513.74 413.95 512.16 414.61 511.16 415.17 511.16 415.21 508.5 416.67 510.02 417.16 510.24 418.05 509.41 417.44 508.62 417.61 507.74 416.72 506.56 417.39 506.41 416.74 506.63 416.2 506.72 412.64 Z"
          data-name="Orleans"
          data-stusps="LA"
          id="22071"
        />
        <path
          className="white"
          d="M 730.61 135.05 730.87 134.99 730.91 134.98 731.79 134.75 732.56 134.55 736.67 133.52 737.49 133.32 737.59 133.29 738.14 133.15 739.95 132.69 741.31 134.46 741.08 135.93 741.64 136.46 741.3 138.91 741.61 139.95 741.25 140.88 740.34 138.74 738.66 138.96 736.29 140.14 735.61 139.46 733.07 139.55 732.68 138.5 731.23 138.61 731.11 136.92 730.31 136.48 730.61 135.05 Z"
          data-name="Franklin"
          data-stusps="MA"
          id="25011"
        />
        <path
          className="white"
          d="M 573.99 134.24 581.64 133.02 581.7 133.51 581.89 136.42 581.11 137.14 580.66 137.91 579.56 138.15 579.3 140.07 574.99 140.75 573.99 134.24 Z"
          data-name="Iosco"
          data-stusps="MI"
          id="26069"
        />
        <path
          className="white"
          d="M 721.29 191.42 722.97 189.12 725.13 188.69 727 189.56 727.5 188.68 728.72 189.06 728.9 191.51 729.04 192.85 729.37 195.01 729.42 195.72 729.43 195.88 728.75 198.69 727.84 201.28 726.57 201.8 725.75 200.82 725.94 200.38 725.13 196.62 724.09 195.23 721.29 191.42 Z"
          data-name="Ocean"
          data-stusps="NJ"
          id="34029"
        />
        <path
          className="white"
          d="M 289.11 61.8 299.46 63.11 302.15 63.43 301.95 65.05 303.58 65.25 303.39 66.88 310.65 67.69 310.36 70.47 309.89 75.07 309.21 74.92 308.77 73.83 307.42 74.14 303.86 71.93 302.09 72.17 300.35 71.67 299.56 70.97 298.13 72.4 295.86 71.83 295.85 71.43 295.56 72.09 291.75 71.02 289.88 71.17 287.25 72.11 288.26 68.26 289.11 61.8 Z"
          data-name="Roosevelt"
          data-stusps="MT"
          id="30085"
        />
        <path
          className="white"
          d="M 622.19 301.14 622.03 301.64 622.46 302.54 621.34 305.56 621.55 306.42 620.64 306.47 620.01 307.04 618.87 307.61 618.2 307.88 617.15 305 614.89 303.01 615.91 302.17 618.2 302.68 618.7 302.06 621.07 300.67 622.19 301.14 Z"
          data-name="Henderson"
          data-stusps="NC"
          id="37089"
        />
        <path
          className="white"
          d="M 688.19 131.72 691.49 131.9 696.33 126.74 698.19 131.96 697.37 133.64 697.4 133.67 697.44 133.66 697.44 133.66 697.45 133.65 697.47 133.63 697.47 133.62 697.47 133.61 697.47 133.59 697.48 133.59 697.49 133.59 697.5 133.6 697.5 133.63 697.51 133.66 697.52 133.68 697.55 133.71 697.55 133.74 697.55 133.74 697.56 133.78 697.56 133.79 697.57 133.8 697.59 133.8 697.6 133.8 697.61 133.79 697.61 133.78 697.61 133.78 697.61 133.76 697.6 133.75 697.59 133.74 697.59 133.73 697.59 133.72 697.59 133.71 697.6 133.69 697.62 133.68 697.63 133.68 697.63 133.66 697.62 133.63 697.62 133.63 697.63 133.62 697.64 133.62 697.65 133.62 697.66 133.64 697.67 133.66 697.69 133.67 697.72 133.68 697.74 133.7 697.74 133.7 697.75 133.7 697.75 133.71 697.77 133.72 697.79 133.72 697.83 133.71 697.89 133.71 697.9 133.71 697.91 133.7 697.92 133.71 697.92 133.71 697.94 133.71 697.95 133.71 697.95 133.72 697.96 133.74 697.98 133.78 697.98 133.8 697.98 133.81 697.99 133.81 698 133.81 698.02 133.82 698.04 133.82 698.05 133.82 698.07 133.83 698.08 133.83 698.1 133.82 698.12 133.82 698.12 133.82 698.14 133.82 698.15 133.83 698.17 133.83 698.19 133.84 698.22 133.84 698.23 133.84 698.25 133.84 698.27 133.85 698.3 133.86 698.32 133.87 698.34 133.88 698.43 133.9 698.45 133.9 698.48 133.9 698.51 133.89 698.52 133.89 698.54 133.88 698.56 133.88 698.58 133.87 698.59 133.86 698.6 133.85 698.61 133.84 698.61 133.84 698.63 133.83 698.65 133.8 698.66 133.79 698.68 133.77 698.69 133.76 698.7 133.75 698.71 133.75 698.73 133.75 698.74 133.76 698.75 133.76 698.76 133.77 698.76 133.78 698.75 133.79 698.73 133.8 698.72 133.81 698.72 133.82 698.72 133.84 698.72 133.85 698.73 133.87 698.74 133.88 698.75 133.88 698.77 133.88 698.79 133.88 697.58 137.7 698.51 140.92 698.05 141.21 695.47 142.03 695.04 140.74 693.68 141.11 693.04 139.15 690.09 137.39 687.92 138.08 687.09 134.9 687.33 131.67 688.19 131.72 Z"
          data-name="Oneida"
          data-stusps="NY"
          id="36065"
        />
        <path
          className="white"
          d="M 582.24 191.01 581.66 186.63 583.31 186.33 583.31 186.33 585.8 185.87 587.64 185.53 588.38 186.22 589.52 185.85 591.02 186.73 592.03 186.97 591.78 187.02 590.98 187.14 588.49 187.59 586.32 187.94 586.11 188.28 584.64 190.57 582.84 192.32 582.43 192.38 582.24 191.01 Z"
          data-name="Lucas"
          data-stusps="OH"
          id="39095"
        />
        <path
          className="white"
          d="M 396.07 344.09 396.23 344.08 396.69 344.06 396.81 344.89 397.52 345.94 398.41 345.54 398.68 346.05 399.68 346.25 400.16 345.41 400.52 344.66 401.53 345.3 401.6 345.35 401.55 346.28 401.86 346.5 402.63 346.53 402.96 347.37 403.99 347.25 404.51 347.88 404.88 348.46 404.77 354.41 397.7 354.22 397.4 354.06 395.98 354 396.07 344.09 Z"
          data-name="Grayson"
          data-stusps="TX"
          id="48181"
        />
        <path
          className="white"
          d="M 557.18 368.15 557.21 368.73 557.64 367.13 559.67 366.87 562.27 367.64 562.65 367.85 562.56 368.75 562.65 368.99 563 368.91 563.17 369.1 563.61 369.25 563.84 369.4 563.91 370.07 564.21 373.05 564.37 374.68 563.67 374.73 557.1 375.34 556.98 373.71 556.17 373.79 555.87 370.46 557.44 370.33 556.5 369.46 557.18 368.15 Z"
          data-name="Lowndes"
          data-stusps="AL"
          id="1085"
        />
        <path
          className="white"
          d="M 18.87 172.23 31.95 176.44 32.26 176.49 32.65 178.24 32.98 178.12 31.96 179.08 31.14 181.7 33.19 182.28 31.79 185.04 30.21 183.92 28.33 183.32 27.33 183.61 19.23 181.08 20.49 177.33 18.28 176.63 18.97 174.14 18.87 172.23 Z"
          data-name="Glenn"
          data-stusps="CA"
          id="6021"
        />
        <path
          className="white"
          d="M 500.09 353.92 500.87 353.19 500.18 352.56 502.53 353.22 509.37 355.07 507.35 360.5 506.3 361.55 500.13 359.2 499.86 359.44 498.71 357.89 500.27 357.02 500.09 353.92 Z"
          data-name="Holmes"
          data-stusps="MS"
          id="28051"
        />
        <path
          className="white"
          d="M 259.61 78.83 260.35 77.73 261.76 77.29 262.85 75.9 263.97 75.73 266.07 76.47 266.58 75.28 268.59 76.16 271.61 76.57 273.14 76.57 273.7 75.46 275.31 75.75 275.69 75.08 277.1 75.03 278.52 73.43 278.84 71.96 279.88 72.12 280.64 72.23 280.41 73.9 281.64 74.06 280.77 80.43 279.86 83.64 281.48 83.86 281.05 87.11 282.12 87.25 281.33 93.27 281.29 93.54 273.27 92.46 263.55 90.78 258.06 90.1 257.53 89.53 258.61 87.36 258.19 86.8 258.25 82.47 258.62 80.53 259.46 79.75 259.61 78.83 Z"
          data-name="Garfield"
          data-stusps="MT"
          id="30033"
        />
        <path
          className="white"
          d="M 485.96 350.35 493.07 350.02 493.3 354.88 494.05 354.85 494.68 356.1 494.79 357.96 494.44 358.1 491.08 358.24 491.16 359.92 490.35 359.91 487.28 360.03 487.86 359.19 486.87 358.41 487.28 357.7 488.05 357.73 488.33 356.8 488.53 355.81 488.22 355.06 487.59 354.96 487.27 353.68 487.68 352.84 487.12 352.22 486.71 351.58 486.41 351.02 485.96 350.35 Z"
          data-name="Washington"
          data-stusps="MS"
          id="28151"
        />
        <path
          className="white"
          d="M 546.61 171.11 547.6 170.98 547.74 170.96 552.51 170.4 555.79 170 556.62 176.51 553.54 176.9 546.41 177.76 546.66 175.44 546.63 173.74 546.62 173.44 546.62 171.2 546.61 171.11 Z"
          data-name="Allegan"
          data-stusps="MI"
          id="26005"
        />
        <path
          className="white"
          d="M 491.16 359.92 491.08 358.24 494.44 358.1 495.13 358.06 495.32 361.32 493.76 363.03 494.81 363.36 494.13 365.02 495.37 366.05 494.5 366.26 490.66 366.43 490.53 363.14 491.16 359.92 Z"
          data-name="Sharkey"
          data-stusps="MS"
          id="28125"
        />
        <path
          className="white"
          d="M 391.62 210.84 398.11 210.96 398.04 217.18 398 217.49 391.5 217.38 391.62 210.84 Z"
          data-name="Seward"
          data-stusps="NE"
          id="31159"
        />
        <path
          className="white"
          d="M 443.57 239.24 443.55 237.61 450.51 237.35 450.63 240.3 452.94 241.01 453.17 241.63 451.76 241.33 451.37 242.73 449.89 243.11 449.9 244.23 448.96 244.7 447.78 243.49 447.6 244.79 445.28 244.39 443.72 245.2 443.57 239.24 Z"
          data-name="Carroll"
          data-stusps="MO"
          id="29033"
        />
        <path
          className="white"
          d="M 226.3 342.18 245.9 344.35 247.51 344.44 247.36 346.1 247.77 346.17 247.2 352.55 238.04 355.98 237.96 356.81 231.39 356.08 231.02 359.38 226.08 358.83 224.08 358.15 224.64 355.37 223.98 353.84 224.08 351.96 222.97 350.88 223.44 349.68 223.38 347.12 221.12 346.85 221.74 341.62 226.3 342.18 Z"
          data-name="Sierra"
          data-stusps="NM"
          id="35051"
        />
        <path
          className="white"
          d="M 325.44 66.19 333.57 66.91 336.82 67.18 336.55 70.45 337.19 70.5 336.67 77.05 337.31 77.1 337.05 80.4 330.55 79.86 330.41 81.55 328.21 80.94 327.27 80.03 327.37 78.47 328.69 76.88 327.42 75.26 325.43 74.19 325.86 69.52 325.14 69.45 325.44 66.19 Z"
          data-name="Mountrail"
          data-stusps="ND"
          id="38061"
        />
        <path
          className="white"
          d="M 588.28 233.13 589.1 233.49 589.43 232.68 591.97 230.11 595.16 229.69 595.12 230.81 595.14 231.8 595.92 233.04 595.82 235.79 592.59 236.93 591.69 237.03 588.76 237.4 588.28 233.13 Z"
          data-name="Highland"
          data-stusps="OH"
          id="39071"
        />
        <path
          className="white"
          d="M 664.14 325.52 667.37 326.57 668.16 326.19 670.5 326.64 673.16 325.74 673.34 326.09 672.16 328.06 672.1 330.34 670.7 332.05 668.97 335.46 669.07 336.06 663.78 333.07 661.71 333.47 663.07 328.88 662.59 328.06 663.72 326.89 664.14 325.52 Z"
          data-name="Williamsburg"
          data-stusps="SC"
          id="45089"
        />
        <path
          className="white"
          d="M 357.96 150.58 358.62 151.84 360.2 151.8 362.28 152.5 362.35 151.66 361.22 151.16 361.69 150.34 362.84 150.86 362.96 152.58 365.79 154.96 365.62 155.84 366.17 157.35 364.75 158.8 364.74 160.11 363.87 160.68 365.13 161.03 366.06 164.03 366.06 164.03 362.83 163.89 361.61 163.83 361.82 159.28 361.39 158.81 360.13 159.8 358.85 160.14 356.9 160.08 356.56 159.74 355.07 160.02 353.52 159.41 352.84 159.69 352.05 159.27 351.82 156.81 352.14 150.77 352.16 150.28 357.96 150.58 Z"
          data-name="Lyman"
          data-stusps="SD"
          id="46085"
        />
        <path
          className="white"
          d="M 328.57 368.68 328.58 368.61 336.75 369.05 336.3 377.3 333.81 377.16 328.01 376.87 328.57 368.68 Z"
          data-name="Mitchell"
          data-stusps="TX"
          id="48335"
        />
        <path
          className="white"
          d="M 409.58 364.91 411.84 364.94 413.5 366.26 414.57 366.19 416.19 367.29 416.58 367.12 417.22 367.75 417.23 371.63 419.55 373.96 409.58 373.92 409.58 364.91 Z"
          data-name="Van Zandt"
          data-stusps="TX"
          id="48467"
        />
        <path
          className="white"
          d="M 371.28 386.04 376.27 383.19 375.47 381.75 378.75 379.94 382.45 386.49 375.74 390.27 374.26 391.12 371.28 386.04 Z"
          data-name="Hamilton"
          data-stusps="TX"
          id="48193"
        />
        <path
          className="white"
          d="M 488.07 150.19 487.95 148.44 491.08 148.22 493.48 148.04 493.33 149.88 492.68 149.65 492.03 151.12 492.89 154.57 494.62 156.75 495.85 158.86 495.91 159.34 495.9 159.34 488.72 159.85 488.61 158.15 488.28 153.46 488.28 153.46 488.07 150.19 Z"
          data-name="Juneau"
          data-stusps="WI"
          id="55057"
        />
        <path
          className="white"
          d="M 515.14 138.11 515.45 138.21 518.43 137.83 518.39 138.09 518.53 139.12 518.03 139.86 518.57 140.44 519.42 140.54 519.94 139.64 520.31 138.96 521.48 138.26 521.64 137.97 522.18 144.1 520.54 144.26 520.7 145.89 518.6 146.09 516.58 146.26 516 139.78 515.27 139.89 515.03 138.35 515.14 138.11 Z"
          data-name="Brown"
          data-stusps="WI"
          id="55009"
        />
        <path
          className="white"
          d="M 478.81 134.28 485.34 133.86 486.91 133.7 487.34 140.25 487.68 145.14 484.41 145.4 481.14 145.6 481.05 143.96 479.41 144.06 479.32 142.44 479.03 137.54 478.92 135.9 478.81 134.28 Z"
          data-name="Clark"
          data-stusps="WI"
          id="55019"
        />
        <path
          className="white"
          d="M 359.09 321.27 368.5 321.58 370.02 321.48 370.48 321.98 370.36 326.53 367.17 326.44 367.03 331.33 364.31 331.25 364.34 330.43 362.76 330.38 363.58 329.21 362.08 329.15 362.24 326.39 360.65 326.85 359.75 326.16 359.54 322.69 358.94 321.81 358.33 321.28 358.41 321.24 359.09 321.27 Z"
          data-name="Kiowa"
          data-stusps="OK"
          id="40075"
        />
        <path
          className="white"
          d="M 484.34 226.75 487.48 226.58 488.89 228.8 490.23 228.6 490.28 229.02 489.35 230.75 489.57 231.45 484.96 231.67 484.56 231.62 484.34 226.75 Z"
          data-name="Brown"
          data-stusps="IL"
          id="17009"
        />
        <path
          className="white"
          d="M 22.37 191.72 29.9 194.04 29.93 195.05 31.15 195.95 31.26 198.24 32.27 198.7 31.53 199.51 32.25 201.45 32.35 201.6 32.65 201.54 32.87 201.69 32.86 201.99 32.53 202.31 32.56 202.73 32.49 202.84 32.17 202.97 32.22 203.16 31.76 203.17 31.59 203.36 32.21 204.22 31.34 206.24 29.99 206.82 28.48 206.35 29.54 202.05 26.04 201.03 24.71 201.55 23.48 200.66 23.34 197.65 22.77 196.54 22.64 193.57 21.19 192.6 21.03 191.72 21.42 191.4 22.37 191.72 Z"
          data-name="Yolo"
          data-stusps="CA"
          id="6113"
        />
        <path
          className="white"
          d="M 475.7 225.39 484.27 225.08 484.34 226.75 484.56 231.62 484.66 233.26 478.16 233.58 478.18 233.03 477.62 232.43 477.05 232 477.09 230.83 476.94 230.13 476.94 230.11 476.19 228.77 475.94 227.68 475.65 225.96 475.7 225.39 Z"
          data-name="Adams"
          data-stusps="IL"
          id="17001"
        />
        <path
          className="white"
          d="M 302.4 215.97 304.05 216.12 303.93 217.75 303.13 225.91 299.75 225.62 293.32 225.04 293.94 218.48 294.29 215.21 302.4 215.97 Z"
          data-name="Morgan"
          data-stusps="CO"
          id="8087"
        />
        <path
          className="white"
          d="M 703.87 96.84 705.88 96.19 708.99 95.26 712.89 93.97 713.09 94.73 713.45 95.7 713.24 96.99 713.6 97.51 714.15 97.84 714.14 97.91 714.12 98.89 714.29 99.87 714.4 101.48 714.99 102.37 715.06 102.43 715.36 102.69 713.85 103.3 713.69 104.4 711.62 105.9 708.45 107.03 706.21 102.01 705.95 102.11 703.87 96.84 Z"
          data-name="Clinton"
          data-stusps="NY"
          id="36019"
        />
        <path
          className="white"
          d="M 670.49 216.59 671.03 212.48 672.56 211.64 672.94 211.94 674.1 211.58 675.58 211.67 675.91 212.82 676.2 213.25 675.88 214.39 674.91 215.88 674.43 216.25 674.3 217.21 673.77 218.14 673.85 218.39 671.2 216.97 670.49 216.59 Z"
          data-name="Berkeley"
          data-stusps="WV"
          id="54003"
        />
        <path
          className="white"
          d="M 496.25 174.11 502.56 173.66 502.75 173.86 503.29 180.33 502.79 180.36 501.52 180.44 496.73 180.72 496.3 174.93 496.25 174.11 Z"
          data-name="Green"
          data-stusps="WI"
          id="55045"
        />
        <path
          className="white"
          d="M 626.44 352.71 626.56 351.75 628.14 351.07 629.86 351.46 630.94 351.15 632.31 353.85 633.77 354.74 633.47 356.1 632.62 355.8 631.62 356.69 630.33 360.12 630.76 360.69 628.86 361.44 627.83 360.39 628.06 358.69 626.22 357.94 623.62 357.87 624.91 357.33 624.31 356.5 626.22 354.96 625.58 354.28 626.44 352.71 Z"
          data-name="Emanuel"
          data-stusps="GA"
          id="13107"
        />
        <path
          className="white"
          d="M 611.95 376.92 612.47 374.66 612.35 373.73 614.43 373.51 614.59 374.95 615.61 375.34 617.02 374.71 619.91 374.47 619.07 375.76 618.51 378.38 617.98 378.56 614.83 378.85 613.33 377.54 612 377.37 611.95 376.92 Z"
          data-name="Irwin"
          data-stusps="GA"
          id="13155"
        />
        <path
          className="white"
          d="M 507.78 153.61 514.33 153.07 514.24 152.23 517.54 151.93 517.61 152.8 518.24 159.34 514.96 159.63 514.81 157.99 508.19 158.52 507.78 153.61 Z"
          data-name="Fond du Lac"
          data-stusps="WI"
          id="55039"
        />
        <path
          className="white"
          d="M 358 260.51 366.16 260.83 366.11 262.47 367.88 262.53 367.71 267.42 366.09 267.37 362.84 267.26 361.22 267.18 361.28 265.55 358.03 265.43 358.1 263.52 358.14 262.33 357.94 262.14 358 260.51 Z"
          data-name="Pawnee"
          data-stusps="KS"
          id="20145"
        />
        <path
          className="white"
          d="M 505.47 337.4 508.75 337.22 508.72 336.68 512.03 336.51 512.06 337.05 512.44 342.58 508.34 342.83 505.84 342.4 505.59 337.84 505.47 337.4 Z"
          data-name="Yalobusha"
          data-stusps="MS"
          id="28161"
        />
        <path
          className="white"
          d="M 426.59 153.51 433.24 153.4 433.32 158.29 426.73 158.39 426.66 158.39 426.59 153.51 Z"
          data-name="Watonwan"
          data-stusps="MN"
          id="27165"
        />
        <path
          className="white"
          d="M 676.86 158.17 680.03 157.14 680.24 157.99 681.57 157.97 681.68 156.97 682.82 156.72 683.04 159.24 683.79 162.09 683.79 162.09 678.6 163.28 678.05 163.41 676.86 158.17 Z"
          data-name="Chemung"
          data-stusps="NY"
          id="36015"
        />
        <path
          className="white"
          d="M 498.71 322.13 506.66 321.69 507.21 321.66 507.76 321.63 508.02 325.79 505.1 325.97 503.34 327.29 501.09 326.45 500.69 327.13 500.51 324.58 498.81 324.44 499.72 323.74 499.78 323.16 498.71 322.13 Z"
          data-name="DeSoto"
          data-stusps="MS"
          id="28033"
        />
        <path
          className="white"
          d="M 369.6 82.41 379.09 82.78 379.36 82.81 379.25 86.08 379.57 86.09 379.52 87.69 369.78 87.3 369.45 85.68 369.6 82.41 Z"
          data-name="Eddy"
          data-stusps="ND"
          id="38027"
        />
        <path
          className="white"
          d="M 350.75 222.57 352.23 222.61 358.73 222.91 358.9 222.92 358.65 229.48 355.98 229.37 350.72 229.12 350.49 229.11 350.75 222.57 Z"
          data-name="Furnas"
          data-stusps="NE"
          id="31065"
        />
        <path
          className="white"
          d="M 488.52 386.31 495.21 385.99 496.89 385.91 497.12 390.83 490.92 391.14 490.16 391.34 489.7 391.7 489.33 391.72 488.67 391.26 488.52 386.31 Z"
          data-name="Franklin"
          data-stusps="MS"
          id="28037"
        />
        <path
          className="white"
          d="M 628.18 174.13 630.64 172.53 632.83 170.59 632.96 169.88 633.54 169.32 634.53 169.33 635.72 168.23 636.73 167.49 637.76 166.62 638.27 169.23 638.76 171.72 640.88 171.32 641.4 174.11 628.62 176.54 628.18 174.13 Z"
          data-name="Erie"
          data-stusps="PA"
          id="42049"
        />
        <path
          className="white"
          d="M 397.88 224.02 397.92 223.65 397.97 220.76 404.4 220.83 404.37 225.72 404.33 230.62 404.24 230.62 399.39 230.57 398.41 230.56 397.8 230.55 397.88 224.02 Z"
          data-name="Gage"
          data-stusps="NE"
          id="31067"
        />
        <path
          className="white"
          d="M 396.84 191.34 399.58 191.38 403.33 191.42 403.32 192.81 403.28 197.95 398.35 197.89 396.74 197.86 396.84 191.34 Z"
          data-name="Cuming"
          data-stusps="NE"
          id="31039"
        />
        <path
          className="white"
          d="M 344.36 396.37 352.62 396.69 352.52 399.44 354.45 399.5 354.32 403.81 344.07 403.46 344.36 396.37 Z"
          data-name="Menard"
          data-stusps="TX"
          id="48327"
        />
        <path
          className="white"
          d="M 698.39 204.06 699.82 203.73 704.9 202.55 706.73 209 703.62 209.93 702.35 209.8 702.63 209.61 703.04 209.11 702.79 208.4 702.42 208.49 702.18 207.72 701.09 206.5 698.85 204.65 698.39 204.06 Z"
          data-name="Cecil"
          data-stusps="MD"
          id="24015"
        />
        <path
          className="white"
          d="M 514.96 159.63 518.24 159.34 519.88 159.2 520.2 162.48 519.89 162.52 520.19 165.81 515.31 166.2 515.01 162.91 514.96 159.63 Z"
          data-name="Washington"
          data-stusps="WI"
          id="55131"
        />
        <path
          className="white"
          d="M 184.66 132.46 185.01 130.83 192.31 132.36 191.97 133.98 194.4 134.48 194.24 135.3 193.5 138.54 194.21 138.44 196.76 141.11 197.9 141.89 185.69 139.44 184.06 139.1 183.26 139 184.66 132.46 Z"
          data-name="Jefferson"
          data-stusps="ID"
          id="16051"
        />
        <path
          className="white"
          d="M 326.13 326.7 332.03 327.01 334.29 327.12 333.86 335.29 332.37 335.23 325.67 334.87 326.13 326.7 Z"
          data-name="Briscoe"
          data-stusps="TX"
          id="48045"
        />
        <path
          className="white"
          d="M 371.96 105.4 379.69 105.67 384.94 105.84 384.75 112.37 372.13 111.94 371.69 111.92 371.96 105.4 Z"
          data-name="LaMoure"
          data-stusps="ND"
          id="38045"
        />
        <path
          className="white"
          d="M 340.11 344.57 347.47 344.88 348.29 344.91 348.04 353.14 339.76 352.78 340.11 344.57 Z"
          data-name="King"
          data-stusps="TX"
          id="48269"
        />
        <path
          className="white"
          d="M 467.89 247.1 474.87 246.9 474.98 253.58 471.96 254.34 469.77 256.3 467.51 256.26 466.59 255.07 466.6 253.73 467.72 251.81 467.28 250.86 467.89 247.1 Z"
          data-name="Callaway"
          data-stusps="MO"
          id="29027"
        />
        <path
          className="white"
          d="M 323.66 227.48 326.83 227.71 331.01 227.99 332.91 228.11 332.36 236.26 323.11 235.65 323.12 235.54 323.42 230.94 323.66 227.48 Z"
          data-name="Cheyenne"
          data-stusps="KS"
          id="20023"
        />
        <path
          className="white"
          d="M 323.38 352.02 331.55 352.4 331.15 360.42 329.01 360.43 322.93 360.16 323.38 352.02 Z"
          data-name="Garza"
          data-stusps="TX"
          id="48169"
        />
        <path
          className="white"
          d="M 497.98 152.75 503.8 152.28 503.65 155.51 504.14 156.36 503.09 156.55 503.27 158.74 498.44 159.12 497.98 152.75 Z"
          data-name="Marquette"
          data-stusps="WI"
          id="55077"
        />
        <path
          className="white"
          d="M 604.48 361.02 606.34 359.79 606.32 356.53 606.32 356.52 606.92 356.79 608.04 356.85 608.64 356.9 610.11 360.68 610.22 361.63 609.81 361.67 608.58 363.99 607.46 364.1 606.92 364.15 604.83 364.38 604.5 362.66 604.8 362.5 604.48 361.02 Z"
          data-name="Houston"
          data-stusps="GA"
          id="13153"
        />
        <path
          className="white"
          d="M 490.07 208.34 489.99 206.69 496.42 206.31 496.63 209.6 496.95 214.52 490.4 214.89 490.07 208.34 Z"
          data-name="Knox"
          data-stusps="IL"
          id="17095"
        />
        <path
          className="white"
          d="M 508.54 95.88 508.37 96.25 508.21 97.65 509.53 97.11 511.07 95.88 512.3 95.05 513.4 95.86 513.67 95.85 513.95 98.7 514.64 98.64 514.8 100.25 513.19 100.43 513.66 105.28 506.35 105.97 505.62 97.86 507.26 97.71 507.1 96.09 508.54 95.88 Z"
          data-name="Baraga"
          data-stusps="MI"
          id="26013"
        />
        <path
          className="white"
          d="M 476.51 202.34 476.37 199.05 482.95 198.72 484.59 198.63 484.71 201.33 483.57 201.49 482.79 202.01 482.19 201.91 481.33 202.08 480.86 203.13 480.8 203.69 480.77 203.79 480.76 203.8 476.59 203.98 476.51 202.34 Z"
          data-name="Muscatine"
          data-stusps="IA"
          id="19139"
        />
        <path
          className="white"
          d="M 548.8 324.4 553.16 326.47 553.93 326.51 555.43 325.69 556.17 326.34 557.16 325.63 557.67 326.26 557.64 326.37 557.49 329.59 557.6 330.84 549.33 331.41 548.8 324.4 Z"
          data-name="Morgan"
          data-stusps="AL"
          id="1103"
        />
        <path
          className="white"
          d="M 701.81 249.86 704.74 251.99 706.61 251.44 706.45 251.95 707.31 252.48 706.45 253.33 706.91 254.2 706.88 254.43 706.32 254.59 703.87 252.59 703.5 252.82 703.25 252.39 701.94 252.1 701.81 251.6 701.05 251.49 700.44 250.66 701.81 249.86 Z"
          data-name="York"
          data-stusps="VA"
          id="51199"
        />
        <path
          className="white"
          d="M 667.17 240.5 668.38 239.21 668.2 238.91 672.94 239.83 673.38 239.89 675.53 240.37 675.11 241.8 674.53 243.02 672.52 247.52 672.55 248.18 670.46 249.17 670.11 249.4 669.69 248.36 666.4 243.77 667.15 242.98 667.17 240.5 Z M 671.33 242.66 671.33 243.56 671.58 243.51 672.25 243.16 672.22 242.46 671.82 242.29 671.33 242.66 Z"
          data-name="Albemarle"
          data-stusps="VA"
          fillRule="evenodd"
          id="51003"
        />
        <path
          className="white"
          d="M 711.92 244.32 712.57 244.01 713.57 243.85 714.4 244.17 714.2 244.5 714.48 244.95 714.25 245.3 714.88 245.55 715.04 245.34 715.86 245.42 716.52 244.93 716.69 245.2 716.08 246.91 716.01 247.68 715.51 248.55 715.48 249.56 715.36 250.65 714.46 252.36 713.89 253.05 713.28 252.96 712.62 251.35 711.83 249.52 712.05 247.89 711.89 246.4 711.92 244.32 Z"
          data-name="Northampton"
          data-stusps="VA"
          id="51131"
        />
        <path
          className="white"
          d="M 574.63 237.6 575.55 236.69 576.12 236.9 576.74 237.48 577.6 237.75 578.42 241.45 578.34 242.94 577.75 243.49 575.8 242.16 575.51 242.2 575.64 241.74 574.96 241.54 574.42 241.29 574.21 241.19 574.78 240.34 574.44 239.62 573.96 239.1 573.62 238.74 574.1 238.19 574.63 237.6 Z"
          data-name="Boone"
          data-stusps="KY"
          id="21015"
        />
        <path
          className="white"
          d="M 317.51 170.41 322.79 170.85 327.29 171.2 327.21 175.23 327.13 181.68 327.1 188.23 326.95 189.87 326.14 189.8 317.57 189.22 317.29 189.21 316.8 187.51 317.21 181.16 316.9 180.95 317.43 174.47 317.51 170.41 Z"
          data-name="Sheridan"
          data-stusps="NE"
          id="31161"
        />
        <path
          className="white"
          d="M 478.62 313.06 481.88 312.99 481.97 309.55 483.73 307.53 484.18 306.05 486.72 306.02 486.82 309.34 487.03 314.32 487.1 315.99 483.84 316.08 483.74 314.42 482.3 314.62 478.65 314.72 478.62 313.06 Z"
          data-name="Jackson"
          data-stusps="AR"
          id="5067"
        />
        <path
          className="white"
          d="M 27.12 223.27 31.66 220.81 34.09 219.89 35.93 220.04 36.94 220.79 38.73 214.28 41.52 220.16 44.49 225.08 44.49 225.09 34.02 227.04 34.14 228.11 28.95 231.01 28.37 229.83 26.34 229.82 26.21 227.14 27.52 225.46 27.12 223.26 27.12 223.27 Z"
          data-name="Stanislaus"
          data-stusps="CA"
          id="6099"
        />
        <path
          className="white"
          d="M 534.08 252.15 534.2 251.73 534.38 250.75 535.41 249.93 535.96 248.36 535.51 247.1 535.26 246.63 535.04 246.21 535.27 245.62 539.22 245.33 539.49 245.19 541.12 245.04 541.59 245.06 540.08 247.03 539.64 246.89 539.82 248.28 539.32 249.31 540.12 252.01 539.49 252.7 538.5 252.21 536.88 252.54 536.48 253.3 532.81 255.07 532.93 254.74 533.26 253.87 534.09 253.19 533.94 252.65 534.08 252.15 Z"
          data-name="Knox"
          data-stusps="IN"
          id="18083"
        />
        <path
          className="white"
          d="M 672.97 285.29 674.15 285.1 674.32 283.97 675.07 283.86 675.67 281.99 674.66 281.01 675.7 280.75 678 281.36 682.13 283.06 683.2 284.41 680.3 287.12 678.06 290.22 677.21 291.36 673.79 290.71 672.46 290.43 672.82 287.2 673 285.77 672.97 285.29 Z"
          data-name="Wake"
          data-stusps="NC"
          id="37183"
        />
        <path
          className="white"
          d="M 328.57 270.55 335.1 270.93 334.73 277.47 328.2 277.08 328.57 270.55 Z"
          data-name="Grant"
          data-stusps="KS"
          id="20067"
        />
        <path
          className="white"
          d="M 526.11 401.89 526.04 400.8 526.86 400.77 533.71 400.3 533.72 400.38 534.09 403.91 534.45 407.17 534.24 407.7 533.64 407.63 533.26 408.18 532.41 407.86 531.45 408.09 530.92 407.69 530.08 407.59 529.5 407.98 528.74 407.95 527.86 407.82 527.55 407.78 526.29 407.24 526.11 401.89 Z"
          data-name="Jackson"
          data-stusps="MS"
          id="28059"
        />
        <path
          className="white"
          d="M 508.31 329.89 509.13 329.83 512.11 329.65 512.96 330.26 514.49 330.03 515.77 330.52 515.91 332.71 516.19 336.8 512.06 337.05 512.03 336.51 508.72 336.68 508.31 329.89 Z"
          data-name="Lafayette"
          data-stusps="MS"
          id="28071"
        />
        <path
          className="white"
          d="M 623.74 195.82 626.47 195.36 626.38 194.81 627.53 195.17 631.86 194.42 632.02 195.34 632.75 199.34 631.9 199.95 631.26 199.98 630.8 200.78 629.61 200.71 627.95 200.95 627 200.26 626.74 198.69 624.3 199.09 623.75 195.87 623.74 195.82 Z"
          data-name="Columbiana"
          data-stusps="OH"
          id="39029"
        />
        <path
          className="white"
          d="M 480.34 247.88 481.46 247.83 481.5 248.96 482.66 248.9 482.7 250.02 484.95 249.93 485.18 256.01 483.46 254.93 481.25 254.82 479.81 253.26 479.08 253.46 478.34 253.3 478.26 250.76 480.48 250.67 480.34 247.88 Z"
          data-name="Warren"
          data-stusps="MO"
          id="29219"
        />
        <path
          className="white"
          d="M 421.62 401.96 422.83 401.07 423.68 402.61 424.8 403.4 424.74 405.05 426.05 405.3 427.51 407.23 429.71 407.87 429.4 408.77 429.36 408.97 424.29 411.59 423.31 412.07 423.67 411.46 421.97 410.46 421.13 408.62 421.62 401.96 Z"
          data-name="San Jacinto"
          data-stusps="TX"
          id="48407"
        />
        <path
          className="white"
          d="M 54.31 211.36 55.93 213.4 58.94 213 59.47 214.97 59.07 215.69 59.52 216.87 58.9 217.44 59.53 218.46 61 219.45 62.63 220.82 62.95 222.11 62.5 223.57 63.82 225.17 63.39 226.72 62.04 227.69 61.63 226.79 60.3 224.62 59.52 224.64 58.84 223.46 56.87 224.1 56.32 224.89 53.92 225.18 52.45 224.73 50.21 222.65 49.23 223.35 45.62 223.52 45.9 224.82 44.69 224.11 44.49 225.08 41.52 220.16 44.28 218.43 44.18 217.66 45.38 217.53 45.94 216.72 51.65 211.84 54.31 211.36 Z"
          data-name="Tuolumne"
          data-stusps="CA"
          id="6109"
        />
        <path
          className="white"
          d="M 604.4 382.73 608.31 382.35 609.07 382.53 610.02 382.19 612.33 381.99 612.63 384.28 611.85 386.82 611.96 387.66 609.31 387.88 604.93 388.28 604.87 387.61 604.65 387.15 604.8 386.93 604.4 382.73 Z"
          data-name="Colquitt"
          data-stusps="GA"
          id="13071"
        />
        <path
          className="white"
          d="M 613.38 342.96 615.51 340.5 616.02 340.85 618.12 340.66 618.6 340.91 620.11 344.06 620.27 344.33 618.67 345.34 618.27 346.51 616.49 347.84 615.8 347.93 615.1 348.61 614.91 346.68 612.02 346.34 612.18 344.94 613.77 343.77 613.38 342.96 Z"
          data-name="Hancock"
          data-stusps="GA"
          id="13141"
        />
        <path
          className="white"
          d="M 520.26 232.81 526.2 232.29 527.55 231.54 527.98 235.37 527.2 235.45 527.39 237.36 520.71 238.01 520.6 236.65 520.26 232.81 Z"
          data-name="Coles"
          data-stusps="IL"
          id="17029"
        />
        <path
          className="white"
          d="M 497.84 229.74 501.1 229.52 502.06 229.18 502.03 228.08 503.77 227.94 505.13 227.83 506.35 228.85 509.06 228.67 509.21 230.61 508.77 230.41 508.02 231.42 506.28 232.07 506.38 233.27 505.59 233.32 505.66 234.13 504.84 234.19 504.87 234.73 505.01 236.37 502.57 236.57 499.3 236.81 498 231.93 497.88 230.29 497.84 229.74 Z"
          data-name="Sangamon"
          data-stusps="IL"
          id="17167"
        />
        <path
          className="white"
          d="M 542.86 234.13 546.57 233.82 547.41 234.28 547.61 236.05 546.83 236.34 547.2 239.53 541.75 240.03 541.44 236.75 543.07 236.6 542.86 234.13 Z"
          data-name="Owen"
          data-stusps="IN"
          id="18119"
        />
        <path
          className="white"
          d="M 335.46 261 341.65 261.35 348.17 261.71 348.42 261.72 348.2 266.62 341.7 266.27 341.62 271.28 335.1 270.93 334.99 269.17 335.46 261 Z"
          data-name="Finney"
          data-stusps="KS"
          id="20055"
        />
        <path
          className="white"
          d="M 480.95 236.46 481.08 236.57 481.51 237.41 482.21 237.51 482.78 238.31 483.2 239.16 484.72 239.97 484.75 239.99 486.2 241.03 487.9 242.52 488.03 243.11 481.31 243.42 481.36 245.07 480.26 245.12 478.09 245.17 477.5 241.89 477.05 239.43 480.95 236.46 Z"
          data-name="Pike"
          data-stusps="MO"
          id="29163"
        />
        <path
          className="white"
          d="M 263.6 352.61 270.13 353.07 270.73 349.95 270.77 348.2 271.9 335.21 273.58 335.37 273.44 337.02 283.3 337.94 283.45 336.29 286.73 336.57 288.36 336.71 287.97 341.65 289.94 341.8 289.68 344.87 292.96 345.1 292.83 346.73 289.51 346.5 288.54 349.72 287.93 357.8 287.16 357.75 270.86 356.46 270.13 364.8 269.98 364.78 261.96 364.11 263.32 355.82 263.6 352.61 Z"
          data-name="Chaves"
          data-stusps="NM"
          id="35005"
        />
        <path
          className="white"
          d="M 457.46 254.63 460.73 254.59 462.31 249.99 464.11 252.05 463.96 253.37 462.7 259.26 460.78 259.27 457.48 256.27 457.46 254.63 Z"
          data-name="Moniteau"
          data-stusps="MO"
          id="29135"
        />
        <path
          className="white"
          d="M 230.19 74.39 230.87 74.55 232.73 73.65 235.23 72.96 236 69.76 237.41 70.2 237.9 69.78 239.86 69.94 241.23 70.55 243.38 69.52 245.13 70.06 247.15 70 248.03 71.46 249.26 73.39 252.29 74.37 254.54 75.77 254.88 75.51 254.03 80.54 250.49 80.12 250.37 80.8 248.74 80.53 247.97 83.71 249.61 83.99 248.77 88.88 248.23 90.48 243.36 89.63 238.47 88.78 238.36 89.45 238.35 89.47 238.33 89.59 238.32 89.66 238.32 89.67 238.3 89.78 238.29 89.86 238.28 89.86 233.69 89.03 233.84 87.39 232.92 86.67 234.24 85.23 235.21 79.8 233.74 79.54 233.88 78.72 232.25 78.42 232.4 77.61 230.78 77.31 231.08 75.68 229.99 75.48 230.19 74.39 Z"
          data-name="Fergus"
          data-stusps="MT"
          id="30027"
        />
        <path
          className="white"
          d="M 427.6 130.63 429.23 130.62 432.63 130.54 432.65 131.37 434.27 131.31 434.34 132.15 434.45 137.03 431.17 137.08 431.19 138.72 427.78 138.78 427.6 130.63 Z"
          data-name="Meeker"
          data-stusps="MN"
          id="27093"
        />
        <path
          className="white"
          d="M 228.56 321.36 229.08 321.39 236.73 322.3 241.71 322.84 243.4 323.95 248.7 326.27 248.36 329.66 256.03 330.44 255.24 338.63 253.23 338.43 252.89 341.74 247.85 341.03 247.51 344.44 245.9 344.35 226.3 342.18 227.98 327.38 227.87 327.09 228.56 321.36 Z"
          data-name="Socorro"
          data-stusps="NM"
          id="35053"
        />
        <path
          className="white"
          d="M 683.2 284.41 685.68 276.37 687.75 277.14 690.34 276.84 690.62 276.4 690.62 277.15 689.65 282.23 689.5 282.84 688.41 283.07 684.73 285.67 684.5 285.89 683.79 285.61 683.2 284.41 Z"
          data-name="Nash"
          data-stusps="NC"
          id="37127"
        />
        <path
          className="white"
          d="M 342.44 139.29 343.94 139.82 345.51 138.79 348.07 139.19 349.39 140.47 349.14 143.1 350.39 143.54 349.58 145.1 352.16 145.66 352.35 147.26 356.08 148.35 358.63 149.73 357.96 150.58 352.16 150.28 352.14 150.77 342.95 150.23 341.33 150.13 341.7 146.86 342.13 140.35 342.44 139.29 Z"
          data-name="Stanley"
          data-stusps="SD"
          id="46117"
        />
        <path
          className="white"
          d="M 585.97 302.39 589.2 298.41 589.33 297.24 590.34 297.04 591.8 298.33 592.05 298.59 592.16 300.35 592.9 301.51 592.15 302.3 590.47 301.66 587.16 301.84 586.92 302.66 586.27 302.63 585.97 302.39 Z"
          data-name="Loudon"
          data-stusps="TN"
          id="47105"
        />
        <path
          className="white"
          d="M 569.99 301.28 570.04 301.06 570.91 301.14 571.28 301.2 571.14 300.93 571.27 300.75 571.56 300.9 571.91 300.55 572.71 300.62 575.13 300.21 575.12 300.76 575.41 301.26 575.33 302.12 573.2 305.28 572.69 305.72 571.21 306.14 570.47 304.6 569.87 301.94 569.99 301.28 Z"
          data-name="Van Buren"
          data-stusps="TN"
          id="47175"
        />
        <path
          className="white"
          d="M 315.2 351.65 323.38 352.02 322.93 360.16 320.81 360.03 314.71 359.72 315.2 351.65 Z"
          data-name="Lynn"
          data-stusps="TX"
          id="48305"
        />
        <path
          className="white"
          d="M 704.61 246.6 705.03 246.09 706.77 245.7 707.18 246.42 707.83 247.74 708.05 248.63 707.91 249.95 706.26 249.02 705.76 248.71 705.64 248.8 704.84 248.42 704.61 246.6 Z"
          data-name="Mathews"
          data-stusps="VA"
          id="51115"
        />
        <path
          className="white"
          d="M 657.89 217.45 658.35 217.35 659.63 217.75 659.69 216.97 660.76 215.3 661.62 213.48 662.19 213.93 662.86 214.86 663.67 214.93 662.38 217.08 661.58 219.52 660.03 221.65 657.48 220.67 655.56 220.76 656.7 219.09 657.54 217.53 657.89 217.45 Z"
          data-name="Mineral"
          data-stusps="WV"
          id="54057"
        />
        <path
          className="white"
          d="M 615.02 234.8 615.12 234.49 615.69 233.59 616.17 233.29 617.23 233.83 618.06 234.93 618.04 235.97 620.22 238.39 620.65 239.33 618.01 240.2 616.54 241.38 617.07 243.87 614.3 242.03 614.9 241.62 614.6 240.68 614.08 238.81 613.84 238.03 614.49 237.51 614.65 235.92 615.02 234.8 Z"
          data-name="Mason"
          data-stusps="WV"
          id="54053"
        />
        <path
          className="white"
          d="M 143.32 54.87 148.56 56.24 149.32 55.58 152.58 56.49 150.57 63.8 149 63.08 144.17 61.82 142.06 59.32 142.21 58.8 142.76 56.86 143.32 54.87 Z"
          data-name="Benewah"
          data-stusps="ID"
          id="16009"
        />
        <path
          className="white"
          d="M 189.66 152.07 196.19 153.39 203.72 154.82 203.53 155.86 202.69 160.41 201.94 164.33 200.05 164.77 199.18 164.51 199.51 162.14 198.82 162.99 197.72 162.06 194.23 161.54 194.2 164.52 193.88 164.74 192.06 164.09 190.03 163.98 190.19 160.09 189.83 158.05 187.87 158.03 187.62 156.73 188.16 155.51 187.99 154.22 189.13 153.37 189.66 152.07 Z"
          data-name="Caribou"
          data-stusps="ID"
          id="16029"
        />
        <path
          className="white"
          d="M 540.26 207.07 545.24 206.58 545.59 209.87 543.18 210.12 543.22 213.42 538.57 213.88 538.26 211.03 538.2 210.62 537.99 208.72 539.61 208.55 539.45 207.16 540.26 207.07 Z"
          data-name="White"
          data-stusps="IN"
          id="18181"
        />
        <path
          className="white"
          d="M 550.18 94.61 551 94.35 553.66 93.81 553.09 95.75 553.42 98.03 554.38 99.38 555.97 99.46 558.12 98.63 559.11 99.08 560.65 99.17 560.98 98.62 561.43 97.9 563.1 97.81 564.25 96.73 565.3 97 565.34 97.91 565.44 99.77 566.3 101.86 566.2 102.17 566.3 103.44 567.58 104.06 568.4 104.9 569.72 105.46 570.39 104.08 571.67 104.03 573.28 103.99 575.1 105.51 574.73 107.05 574 107.22 572.93 106.82 571.08 107.26 569.56 106.95 567.33 107.19 566.89 107.31 565.21 107.23 564.97 105.61 563.35 105.84 563.11 104.22 553.34 105.6 553.1 103.96 551.48 104.19 550.18 94.61 Z"
          data-name="Chippewa"
          data-stusps="MI"
          id="26033"
        />
        <path
          className="white"
          d="M 575.56 397.64 575.79 395.96 576.3 395.92 577.26 396.67 579.17 396.54 579.33 394.88 581.25 394.72 582.14 395.47 582.49 399.59 581.64 399.67 581.85 402.14 575.86 402.61 573.67 403.78 575.67 401.68 574.52 399.01 575.56 397.64 Z"
          data-name="Washington"
          data-stusps="FL"
          id="12133"
        />
        <path
          className="white"
          d="M 443.1 388.44 444.5 387.62 445.5 388.08 446.28 389.17 447.28 389.58 446.91 390.25 447.76 390.99 448.25 391.98 448.16 393.37 449.17 394.13 449.38 395.57 449.41 395.57 449.16 395.71 444.42 396.12 442.36 396.6 442.2 391.44 443.16 390.37 443.1 388.44 Z"
          data-name="Sabine"
          data-stusps="TX"
          id="48403"
        />
        <path
          className="white"
          d="M 427.77 383.46 435.53 383.4 435.85 383.81 436.43 386.96 437.86 388.14 438.04 389.32 437.59 392.39 437.49 394.68 437.74 394.87 437.7 394.98 436.57 393.54 435.7 393.19 434.94 391.62 434.37 391.76 434.14 391.14 429.67 390.21 428.97 389.41 428.02 388.44 427.13 384.44 427.77 383.46 Z"
          data-name="Nacogdoches"
          data-stusps="TX"
          id="48347"
        />
        <path
          className="white"
          d="M 683.97 225.85 684.26 225.96 684.25 226.85 683.51 227.2 683.97 225.85 Z"
          data-name="Manassas"
          data-stusps="VA"
          id="51683"
        />
        <path
          className="white"
          d="M 463.47 295.47 466.18 295.38 469.21 295.26 469.24 299.39 469.28 299.71 469.3 301.35 468.49 302.13 468.78 302.14 468.81 303.52 467.17 303.55 467.19 305.18 465.56 305.21 465.54 303.58 465.47 301.71 464.41 301.05 464.48 299.97 463.41 299.89 462.56 298.19 463.48 297.57 463.47 295.47 Z"
          data-name="Baxter"
          data-stusps="AR"
          id="5005"
        />
        <path
          className="white"
          d="M 68.86 307.91 69.37 306.95 70.09 307.09 71.33 305.48 74.32 305.84 74.32 306.13 76.65 306.67 78.26 307.32 78.54 307.36 81.34 307.95 81.45 307.39 91.5 309.56 107.2 312.72 107.37 311.88 121.47 314.59 121.25 315.26 120.83 315.81 119.77 316.67 119.26 317.14 119.58 317.76 119.49 318.46 119.13 319.11 119.13 320.45 119.12 321.26 118.89 321.73 118.45 322.27 118.19 323.31 118.07 324.37 116.69 325.32 115.97 326.32 112.72 325.78 102.49 323.86 92.55 321.9 80.69 319.42 77.32 318.71 76.4 318.44 75.56 318.21 73.95 317.88 74.01 317.55 73.88 317.47 73.75 317.38 72.27 316.05 69.92 315.53 70.04 314.97 71.17 313.85 72.13 312.91 70.4 311.5 68.81 307.95 68.86 307.91 Z"
          data-name="Riverside"
          data-stusps="CA"
          id="6065"
        />
        <path
          className="white"
          d="M 3.46 188.95 6.11 189.61 9.78 190.13 10.87 189.57 14.73 190.86 15.29 191.64 16.53 195.27 15.87 197.12 16.24 197.49 16.9 198.48 17.89 205.63 16.79 206.1 16.85 206.4 15.28 206.6 15.06 206.4 14.56 204.84 12.06 203.54 10.17 200.54 8.63 200.59 8.62 200.56 7.89 200.28 7.88 199.52 7.96 198.38 7.26 196.37 6.23 195.28 5.33 193.84 5.26 193.15 4.52 190.73 3.69 189.57 3.46 188.95 Z"
          data-name="Sonoma"
          data-stusps="CA"
          id="6097"
        />
        <path
          className="white"
          d="M 612.45 321.17 612.49 321.2 613.37 321.49 613.43 321.47 614.43 321.17 615.27 321.26 615.95 322.55 616.34 323.29 617.17 324.37 617.28 324.52 614.25 326.42 612.67 326.36 612 325.49 611.96 322.76 612.45 321.17 Z"
          data-name="Hart"
          data-stusps="GA"
          id="13147"
        />
        <path
          className="white"
          d="M 181.65 126.67 184.08 127.27 184.61 123.94 184.68 123.92 184.74 123.24 186.22 122.44 186.6 122.45 187.98 122.98 189.66 123.55 190.69 124.39 191.39 122.95 192.52 122.41 193.29 123.06 194.53 123.6 195.79 123.68 198.08 123.63 198.73 124.78 200.3 124.15 201.46 124.44 200.88 127.37 198.53 126.89 198.22 128.48 197.4 128.32 196.84 130.73 195.92 131.39 194.29 131.07 193.95 132.7 192.31 132.36 185.01 130.83 184.66 132.46 180.6 131.59 181.65 126.67 Z"
          data-name="Clark"
          data-stusps="ID"
          id="16033"
        />
        <path
          className="white"
          d="M 558.24 252.6 558.81 252.53 561.61 252.49 562.41 253.43 562.06 254.85 561.73 254.79 561.47 255.64 560.76 256.69 560.76 256.86 559.82 256.84 559.72 255.49 558.42 254.23 558.24 252.6 Z"
          data-name="Floyd"
          data-stusps="IN"
          id="18043"
        />
        <path
          className="white"
          d="M 555.85 284.06 558.64 280.76 559.17 280.73 560.22 281.93 560.77 281.23 560.88 282.99 562.46 284.41 562.99 285.72 562.66 286.18 561.04 286.25 559.15 286.34 556.01 286.48 555.84 285.96 555.85 284.06 Z"
          data-name="Allen"
          data-stusps="KY"
          id="21003"
        />
        <path
          className="white"
          d="M 534.26 265.09 534.78 265.56 535.61 265.56 535.8 264.65 536.6 264.08 537.58 264.09 538.12 263.78 538.55 263.54 539.9 264.1 540.34 264.34 540.18 265.77 541.02 266.43 539.29 267.65 539.14 268.43 538.21 268.87 537.91 269.23 534.34 269.71 533.73 267.42 532.94 267.49 531.07 265.05 531.11 264.89 531.82 264.58 532.86 265.36 534.09 264.93 534.26 265.09 Z"
          data-name="Henderson"
          data-stusps="KY"
          id="21101"
        />
        <path
          className="white"
          d="M 706.04 218.33 705.91 217.2 706.91 214.33 708.04 213.38 709.78 219.24 710.86 222.87 708.6 222.02 707.15 222.94 705.9 222.18 707.26 220.11 706.04 218.33 Z"
          data-name="Caroline"
          data-stusps="MD"
          id="24011"
        />
        <path
          className="white"
          d="M 488.63 257.34 489.5 257.68 489.74 257.04 491.9 256.5 493.48 256.41 494.57 258.5 494.53 258.55 494.44 258.68 494.16 259.72 494.39 261.35 494.6 261.65 495.07 262.34 496.16 263.29 496.17 263.52 493.83 265.03 490.72 265.86 490.47 264.58 489.8 264.44 488.26 262.3 488.55 259.39 488.67 258.29 488.63 257.34 Z"
          data-name="Jefferson"
          data-stusps="MO"
          id="29099"
        />
        <path
          className="white"
          d="M 210.75 117.61 212.1 111.05 213.69 111.36 214.3 108.1 215.1 108.25 215.35 107.02 216.17 107.18 218.21 96.86 218.48 95.92 223.36 96.86 224.99 97.31 224.67 98.23 223.46 104.77 224.4 104.95 222.92 113.13 222.2 116.43 224.37 116.82 227.72 117.41 227.89 117.54 227.35 120.62 224.73 120.15 220.33 119.44 215.23 118.63 214.21 118.23 210.75 117.6 210.75 117.61 Z"
          data-name="Park"
          data-stusps="MT"
          id="30067"
        />
        <path
          className="white"
          d="M 410.88 225.77 417.53 225.74 417.54 225.81 418.62 226.23 418.5 227.13 419.21 228.01 419.76 228.63 419.46 229.35 419.93 230.15 420.42 230.1 421.01 230.65 420.55 230.65 414.13 230.66 414.08 230.66 410.87 230.66 410.88 225.77 Z"
          data-name="Richardson"
          data-stusps="NE"
          id="31147"
        />
        <path
          className="white"
          d="M 284.94 323.23 285.58 316.42 289.86 314.87 293.26 315.17 293.49 312.37 297.46 312.55 298.03 306.11 303.14 306.5 302.98 308.7 302.36 316.95 302.3 317.67 302.04 321.26 298.3 320.98 298.18 322.66 296.54 322.52 296.41 324.17 294.78 324.03 294.65 325.67 291.39 325.4 291.25 327.04 290.75 327.01 287.48 326.74 284.68 326.51 284.94 323.23 Z"
          data-name="Quay"
          data-stusps="NM"
          id="35037"
        />
        <path
          className="white"
          d="M 320.14 108.59 321.06 108.66 326.62 109.11 326.51 110.56 333.02 111.1 332.79 113.95 332.63 115.99 332.6 115.99 331.46 115.9 328.31 115.65 325.39 115.4 323.38 115.23 321.08 115.02 320.27 114.95 319.57 114.89 320.14 108.59 Z"
          data-name="Adams"
          data-stusps="ND"
          id="38001"
        />
        <path
          className="white"
          d="M 373.03 341.11 373.17 341.05 373.44 340.25 373.99 339.72 374.69 339.94 376.14 340.34 377.01 340.6 377.5 340.1 377.74 339.86 378.09 340.81 378.08 341.85 378.31 342.73 379.51 342.87 380.42 342.98 380.3 344.23 380.31 344.85 379.9 344.89 379.72 352.79 372.77 352.64 372.91 345.72 373.03 341.11 Z"
          data-name="Clay"
          data-stusps="TX"
          id="48077"
        />
        <path
          className="white"
          d="M 70.79 75.21 73.62 76.17 75.82 71.48 76.97 68.14 77.16 68.31 78.35 68.49 79.73 69.66 79.74 71.01 80.61 71.1 81.3 70.67 83.19 71.13 83.54 71.42 83.05 73.12 83.85 74.28 82.59 76.22 80.87 77.53 80.07 77.33 79.41 78.95 81.09 79.84 82.84 81.9 82.46 82.75 85.46 83.74 85.48 84.06 84.78 88.02 85.63 89.2 76.08 86.04 67.64 83.15 67.29 82.94 67.9 81.98 67.79 79.29 70.06 78.95 70.37 78.32 69.77 76.68 70.93 75.44 70.79 75.21 Z"
          data-name="Wasco"
          data-stusps="OR"
          id="41065"
        />
        <path
          className="white"
          d="M 610.92 277.05 613.04 275.2 616.17 274.67 616.26 274.82 617.29 276.54 617.85 277.82 618.46 279.46 618.73 279.89 615.79 280.3 613.93 280.57 610.57 281.07 608.22 281.36 608.57 279.76 610.31 278.41 610.92 277.05 Z"
          data-name="Scott"
          data-stusps="VA"
          id="51169"
        />
        <path
          className="white"
          d="M 692.67 265.05 699.04 259.08 700.43 257.77 701.36 259.84 700.41 263.49 699.98 263.56 699.77 263.76 699.91 264.16 700.19 264.17 699.99 264.37 700.44 264.45 700.87 264.57 701.07 264.62 700.89 266.33 701.18 266.54 701.17 266.54 701.15 266.54 697.36 267.31 696.96 267.39 695.3 267.72 694.4 267.74 693.1 266.03 691.71 265.98 692.67 265.05 Z"
          data-name="Southampton"
          data-stusps="VA"
          id="51175"
        />
        <path
          className="white"
          d="M 517.61 152.8 519.24 152.64 523.5 152.22 523.43 152.58 523.68 153.75 524.12 154.53 524.09 155.37 524.2 156.18 523.27 158.48 523.29 158.86 519.88 159.2 518.24 159.34 517.61 152.8 Z"
          data-name="Sheboygan"
          data-stusps="WI"
          id="55117"
        />
        <path
          className="white"
          d="M 607.84 302.18 608.19 302.23 612.5 305.84 611.93 309 610.98 310.62 611.8 311.03 610.31 311.73 609.58 310.34 608.13 309 607.93 307.47 607.14 307.77 605.92 305.95 605.4 303.39 607.05 302.09 607.84 302.18 Z"
          data-name="Jackson"
          data-stusps="NC"
          id="37099"
        />
        <path
          className="white"
          d="M 71.04 250.25 70.7 251.25 71.67 253.4 71.24 254.08 71.87 254.95 71.83 256.73 73.19 258.86 72.46 260.04 72.67 265.57 73.02 266.16 72.84 268.47 72.43 268.47 72.05 269.88 71.27 269.64 59.65 266.84 55.73 265.85 48.14 263.94 49.46 258.94 50.65 254.76 51.5 255 52.15 252.47 51.32 252.24 51.76 250.59 51.07 250.38 51.59 250.11 53.15 249.16 55.64 249.84 56.08 248.17 58.07 248.73 59.4 249.09 61 249.51 61.45 247.9 71.04 250.25 Z"
          data-name="Tulare"
          data-stusps="CA"
          id="6107"
        />
        <path
          className="white"
          d="M 606.27 298.53 606.28 298.51 607.13 298.22 607.61 297.43 608.57 297.06 609.29 296.74 610.38 296.69 610.53 296.43 610.8 297.33 612.1 298.47 612.84 299.6 614.1 300.17 613.95 302.23 614.89 303.01 613.82 305.16 612.5 305.84 608.19 302.23 607.84 302.18 608.22 301.4 607.52 299.21 606.16 298.78 606.27 298.53 Z"
          data-name="Haywood"
          data-stusps="NC"
          id="37087"
        />
        <path
          className="white"
          d="M 168.24 315.01 169.14 314.64 169.51 315.4 168.7 315.89 170.21 315.99 170.1 317.14 170.58 316.27 172.97 316.12 174.37 317.85 175.22 317.57 177.15 319.46 178.76 320.62 179.88 320.15 180.29 320.92 179.54 325.92 191.39 327.63 190.26 335.65 189.97 337.76 187.26 337.65 184.45 337.73 182.73 338.37 182.24 339.97 182.89 341.93 182.1 341.9 179.63 342.72 179.03 342.46 177.34 343.63 176.22 345.14 174.25 339.12 174.12 337.88 173.43 335.37 172.24 331.08 170.93 332.34 170.06 331.14 168.78 328.62 169.19 327.77 168.23 325.75 168.56 324.22 167.77 324.12 168.48 322.82 168.5 321.3 164.68 320.51 165.85 317.85 166.33 316.37 167.73 315.93 168.24 315.01 Z"
          data-name="Gila"
          data-stusps="AZ"
          id="4007"
        />
        <path
          className="white"
          d="M 42.97 172.49 43.61 174.06 42.42 175.15 41.6 177.3 42.32 179.07 43.8 181.6 44.33 183.79 45.03 184.64 43.55 185.66 41.22 185.1 40.24 186.77 38.67 188.07 35.21 187.93 35.06 187.68 31.05 186.48 31.5 185.5 31.79 185.04 33.19 182.28 31.14 181.7 31.96 179.08 32.98 178.12 32.65 178.24 32.26 176.49 31.95 176.44 32.49 174.81 36.02 175.91 38.09 174.47 38.92 174.76 40.49 172.79 42.97 172.49 Z"
          data-name="Butte"
          data-stusps="CA"
          id="6007"
        />
        <path
          className="white"
          d="M 649.67 434.96 655.53 434.23 659.16 433.78 663.07 433.3 664.23 443.33 664.05 443.61 664.59 446.77 660.01 447.32 659.79 446.04 658.48 444.06 656.79 443.48 656.54 442.35 654.47 441.05 653.69 440.19 655.14 440.78 655.52 439.32 653.67 439.54 653.53 438.44 652.38 438.58 651.56 436.43 649.86 436.53 649.67 434.96 Z"
          data-name="Osceola"
          data-stusps="FL"
          id="12097"
        />
        <path
          className="white"
          d="M 518.05 179.19 519.27 179.07 519.51 179.06 519.66 180.56 519.81 182.19 519.96 183.83 519.96 183.83 520.09 185.47 519.55 185.52 519.28 185.55 517.92 185.67 517.37 185.72 514.65 185.96 513.02 186.1 512.45 179.71 512.45 179.71 515.24 179.45 518.05 179.19 Z"
          data-name="McHenry"
          data-stusps="IL"
          id="17111"
        />
        <path
          className="white"
          d="M 562.2 211.21 563.01 211.11 565.73 210.78 565.9 212.12 565.85 212.44 566.06 214.14 565.89 214.35 562.66 214.74 562.2 211.21 Z"
          data-name="Blackford"
          data-stusps="IN"
          id="18009"
        />
        <path
          className="white"
          d="M 600.08 253.25 600.9 252.12 599.89 251.9 600.17 251.76 600.96 250.22 603.02 251.42 604.97 251.42 605.68 252.52 603.97 254.8 601.38 255.09 600.16 254.32 600.08 253.25 Z"
          data-name="Elliott"
          data-stusps="KY"
          id="21063"
        />
        <path
          className="white"
          d="M 512.81 388.42 513.9 388.36 516.07 388.23 516.18 389.88 517.84 389.77 518.2 396.09 516.99 396.69 515.73 396.13 513.27 396.52 512.81 388.42 Z"
          data-name="Lamar"
          data-stusps="MS"
          id="28073"
        />
        <path
          className="white"
          d="M 561.86 238.62 563.63 238.39 565.34 236.99 565.88 242.32 564.51 242.49 564.59 243.04 563.38 244.42 562.58 244.55 561.81 244.33 560.95 244.89 560.35 239.98 560.21 238.85 561.86 238.62 Z"
          data-name="Jennings"
          data-stusps="IN"
          id="18079"
        />
        <path
          className="white"
          d="M 462.7 259.26 463.96 253.37 464.55 254.46 466.59 255.07 467.51 256.26 469.77 256.3 469.34 258.28 467.51 258.29 468.33 259.53 467.21 260.82 464.04 260.84 464.06 259.26 462.7 259.26 Z"
          data-name="Cole"
          data-stusps="MO"
          id="29051"
        />
        <path
          className="white"
          d="M 378.5 217.09 384.97 217.25 384.98 217.25 384.84 223.78 378.39 223.62 378.32 223.62 378.5 217.09 Z"
          data-name="Clay"
          data-stusps="NE"
          id="31035"
        />
        <path
          className="white"
          d="M 722.51 160.62 721.95 157.82 720.72 154.57 720.37 151.31 723.82 151.86 726.55 151.67 726.68 150.1 726.74 150.17 727.66 154.5 728.29 157.51 728.39 158 728.84 160.19 728.13 160.4 726.87 160.98 723.3 162.47 722.87 163.58 722.52 163.32 722.51 160.62 Z"
          data-name="Dutchess"
          data-stusps="NY"
          id="36027"
        />
        <path
          className="white"
          d="M 371.26 72.63 374.13 72.76 374.27 69.49 382.41 69.8 382.3 73.07 382.52 76.36 380.89 76.31 380.78 79.57 379.47 79.53 379.41 81.52 378.15 81.45 377.61 79.85 376.03 80.71 376.61 80.15 376 78.67 373.58 79.89 373.51 78.7 372.61 79.25 372.68 77.64 371.09 76.68 371.26 72.63 Z"
          data-name="Ramsey"
          data-stusps="ND"
          id="38071"
        />
        <path
          className="white"
          d="M 607.75 195.34 607.55 193.95 608.91 193.74 608.75 192.55 610.15 192.32 609.94 190.91 611.28 190.68 611.83 190.58 613.74 190.23 614.02 190.19 614.43 192.85 614.87 195.63 610.74 196.28 608.56 196.59 607.94 196.69 607.75 195.34 Z"
          data-name="Medina"
          data-stusps="OH"
          id="39103"
        />
        <path
          className="white"
          d="M 409.43 328.77 409.5 323.48 411.13 321.57 412.28 321.73 412.86 320.93 414.63 321.09 416.78 319.73 416.99 320.27 419.31 318.86 419.26 321.4 420.88 321.4 420.9 323.3 418.46 323.86 418.37 330.39 418.38 332.01 415.94 332.03 412.68 332.03 412.68 330.4 409.43 330.4 409.43 328.77 Z"
          data-name="Pittsburg"
          data-stusps="OK"
          id="40121"
        />
        <path
          className="white"
          d="M 648.5 198.55 650.99 193.26 650.49 190.71 656.38 189.65 656.98 192.72 657.11 193.06 656.98 193.5 655.87 199.76 655.16 199.42 654.13 200.63 653.18 199.97 649.88 199.78 648.62 199.43 648.5 198.55 Z"
          data-name="Indiana"
          data-stusps="PA"
          id="42063"
        />
        <path
          className="white"
          d="M 646.61 317.12 648.51 315.23 648.73 316.36 652 315.39 651.48 314.38 653.55 313 655.14 314.95 656.13 316.89 656.17 317.42 656.18 317.46 655.34 318.77 654.07 319.34 653.74 321.64 652.36 323.19 651.72 323.11 651.79 323.28 650.63 323.81 647.55 322.32 647.99 320.57 648.56 318.39 646.61 317.12 Z"
          data-name="Kershaw"
          data-stusps="SC"
          id="45055"
        />
        <path
          className="white"
          d="M 357.11 407.86 362.63 408.04 368.68 408.17 368.58 414.94 363.16 414.81 356.95 414.71 357.03 411.85 357.11 407.86 Z"
          data-name="Gillespie"
          data-stusps="TX"
          id="48171"
        />
        <path
          className="white"
          d="M 386.41 361.78 388.71 361.86 389.38 361.88 392.1 361.93 394.52 361.98 394.43 365.22 394.42 365.79 394.4 366.29 394.38 367.2 394.37 367.53 394.3 370.24 393.53 370.22 389.92 370.11 389.38 370.09 388.78 370.07 386.18 370 386.41 361.78 Z"
          data-name="Tarrant"
          data-stusps="TX"
          id="48439"
        />
        <path
          className="white"
          d="M 402.64 362.18 403.43 362.19 406.11 362.22 406.1 364.84 406.09 365.36 402.59 365.35 402.64 362.18 Z"
          data-name="Rockwall"
          data-stusps="TX"
          id="48397"
        />
        <path
          className="white"
          d="M 669.02 263.38 669.61 259.68 670.23 259.1 671.62 258.46 671.61 259.35 674.01 259.94 675.83 260.99 675.75 264.7 674.06 268.81 673.15 265.84 671.74 264.89 671.53 263.25 670.93 264.33 669.36 264.21 669.02 263.38 Z"
          data-name="Charlotte"
          data-stusps="VA"
          id="51037"
        />
        <path
          className="white"
          d="M 671.62 258.46 672.59 256.38 672.4 255.38 673.91 256.44 674.57 256.12 676.41 256.52 677.95 254.91 678.27 256.26 678.79 259.63 678.31 260.05 675.83 260.99 674.01 259.94 671.61 259.35 671.62 258.46 Z"
          data-name="Prince Edward"
          data-stusps="VA"
          id="51147"
        />
        <path
          className="white"
          d="M 70.9 30.26 74.21 31.5 73.75 32.72 73.98 33.17 74.99 33.25 75.65 34.69 75.76 35.13 75.8 35.15 77.09 35.62 78.17 36.01 78.37 37.39 79.98 39.15 81.99 39.15 83.95 40.26 84.35 41.12 86.7 42.6 84.67 45.3 83.49 45.95 83.77 47.9 79.9 46.54 78.48 47.19 74.1 44.9 73.32 44.57 73.26 43.23 71.14 41.63 71.35 40.92 70.7 40.08 69.92 38.33 70.17 36.4 69.61 35.3 69.2 34.04 69.23 32.73 70.9 30.26 Z"
          data-name="Pierce"
          data-stusps="WA"
          id="53053"
        />
        <path
          className="white"
          d="M 37.85 261.27 48.14 263.94 55.73 265.85 59.65 266.84 71.27 269.64 72.05 269.88 73.4 270.01 77.93 271.09 77.26 272.7 77.68 273.39 76.95 275.57 73.64 289.79 73.08 289.65 71.39 289.25 62.63 287.28 53.61 285.15 53.7 285.77 52.26 284.95 48.07 283.87 47.81 282.62 45.29 281.4 44.83 281.29 45.68 277.91 44.32 277.34 44.9 275.6 43.08 275.24 43.52 273.56 41.27 272.96 41.7 271.28 40.58 270.99 41.03 269.3 40.5 269.16 38.21 266.77 38.66 265.08 36.97 264.63 37.85 261.27 Z"
          data-name="Kern"
          data-stusps="CA"
          id="6029"
        />
        <path
          className="white"
          d="M 616.98 401.93 618.96 401.7 619.63 404.45 620.71 404.4 624.22 406.24 625.83 408.1 625.73 409.26 625.29 409.36 618.7 410.13 618.14 410.2 617.71 408.99 616.98 401.93 Z"
          data-name="Lafayette"
          data-stusps="FL"
          id="12067"
        />
        <path
          className="white"
          d="M 590.14 342.84 590.92 342.26 592.43 341.66 592.76 341.68 593.53 342.79 593.83 343.18 593.96 345.29 593.45 347.18 592.42 347.27 591.79 346.01 590.18 344.6 590.14 342.84 Z"
          data-name="Fayette"
          data-stusps="GA"
          id="13113"
        />
        <path
          className="white"
          d="M 153.62 126.12 155.2 125.42 156 125.61 155.71 126.83 157.51 127.26 158.76 129.21 159.74 128.35 161.65 129.29 162.62 129.26 162.6 130.36 164.99 132.82 165.7 132.22 166.18 133.61 167.92 136.14 167.99 136.76 169.39 136.77 169.94 138.61 169.39 141.05 173.13 141.88 172.8 143.43 177.67 144.47 176.97 147.74 173.72 147.05 172.41 153.62 173.22 153.79 172.88 155.43 171.87 156.2 170.94 155.94 170.22 154.62 168.77 154.67 169.5 151.29 170.32 151.47 171.74 144.87 167.6 143.96 158.51 141.92 158.79 139.47 156.9 138.9 157.18 136.94 157.9 136.2 156.93 134.99 157.17 134.5 156 133.6 156.88 130.88 156.56 129.28 154.75 128.82 153.02 127.56 153.17 126.49 153.62 126.12 Z"
          data-name="Blaine"
          data-stusps="ID"
          id="16013"
        />
        <path
          className="white"
          d="M 559.73 246.41 560.03 246.54 560.87 245.42 560.95 244.89 561.81 244.33 562.58 244.55 562.75 246.03 564.53 246.94 564.7 248.3 562.49 248.56 561.4 248.7 560.69 249.6 560.46 249.35 560.1 249.4 559.73 246.41 Z"
          data-name="Scott"
          data-stusps="IN"
          id="18143"
        />
        <path
          className="white"
          d="M 411.57 264.97 411.58 263.56 411.7 263.31 411.7 260.04 418.23 260.03 418.23 260.85 418.09 267.45 411.57 267.42 411.57 264.97 Z"
          data-name="Coffey"
          data-stusps="KS"
          id="20031"
        />
        <path
          className="white"
          d="M 581.01 247.57 581.45 247.77 582.09 247.09 584.93 246.32 584.84 246.85 585.64 246.76 585.45 247.86 586 248.15 586.75 248.43 585.6 250.26 584.44 251.54 584.08 251.58 583.73 252.09 582.12 252.39 582.23 252.07 581.38 250.25 579.93 248.66 580.96 248.23 581.01 247.57 Z"
          data-name="Harrison"
          data-stusps="KY"
          id="21097"
        />
        <path
          className="white"
          d="M 471.99 401.24 474.97 401.12 478.42 401.02 479.84 403.72 479.56 406.34 480.01 407.28 479.62 407.55 480.95 409.44 476.07 409.38 475.92 410.11 474.93 409.91 474.31 410.89 473.47 411.5 473.18 410.7 473.17 410.56 472.89 410.57 472.86 409.62 471.69 408.16 467.66 408.28 468.8 407.15 471.37 407.07 472.18 406.49 472.75 404.49 472.69 402.73 471.99 401.24 Z"
          data-name="St. Landry"
          data-stusps="LA"
          id="22097"
        />
        <path
          className="white"
          d="M 444.15 128.62 450.65 128.47 450.72 130.62 450.82 133.87 448.07 133.95 448.12 135.35 448.13 135.62 447.38 135.65 447.39 134.96 447.41 134.37 447.16 134.08 446.94 133.62 446.1 133 445.38 132.34 444.22 131.79 444.15 128.62 Z"
          data-name="Anoka"
          data-stusps="MN"
          id="27003"
        />
        <path
          className="white"
          d="M 447.78 243.49 448.96 244.7 449.9 244.23 449.89 243.11 451.37 242.73 451.76 241.33 453.17 241.63 453.65 242.52 455.32 242.9 456.07 244.54 456.98 244.46 455.66 246.47 455.83 247.54 454.22 249.32 454.22 250.15 447.67 250.06 447.78 243.49 Z"
          data-name="Saline"
          data-stusps="MO"
          id="29195"
        />
        <path
          className="white"
          d="M 294.42 77.2 294.21 78.83 297.47 79.23 297.27 80.86 302.15 81.43 301.96 83.06 302.99 83.17 302.62 86.45 303.8 86.59 304.78 90 304.62 92.61 302.98 95.05 300.42 95.59 294.96 94.95 294.55 93.8 292.91 93.61 293.05 92.52 291.4 92.32 291.87 88.49 290.83 88.36 292.18 81.9 292.79 77 294.42 77.2 Z"
          data-name="Dawson"
          data-stusps="MT"
          id="30021"
        />
        <path
          className="white"
          d="M 360.21 178.23 362.14 178.57 363.88 177.62 366.09 177.1 366.23 177.52 365.86 190.56 359.88 190.34 360.15 183.8 360.21 178.23 Z"
          data-name="Rock"
          data-stusps="NE"
          id="31149"
        />
        <path
          className="white"
          d="M 326.14 189.8 326.95 189.87 327.1 188.23 335.21 188.87 334.79 195.42 326.91 194.9 325.76 194.82 326.14 189.8 Z"
          data-name="Grant"
          data-stusps="NE"
          id="31075"
        />
        <path
          className="white"
          d="M 382.52 76.36 387.41 76.51 387.59 79.78 387.41 86.33 386.12 86.29 379.57 86.09 379.25 86.08 379.36 82.81 379.41 81.52 379.47 79.53 380.78 79.57 380.89 76.31 382.52 76.36 Z"
          data-name="Nelson"
          data-stusps="ND"
          id="38063"
        />
        <path
          className="white"
          d="M 644.23 268.43 644.51 267.86 647.09 267.23 649.38 265.06 650.1 264.76 650.51 267.77 649.27 269.78 647.75 270.8 647.25 272.59 646.3 273.45 643.03 269.65 643.94 268.94 644.23 268.43 Z"
          data-name="Floyd"
          data-stusps="VA"
          id="51063"
        />
        <path
          className="white"
          d="M 336.5 284.9 337.85 284.96 341.2 285.11 342.41 285.16 349.39 285.47 350.7 285.53 350.35 293.19 350.27 294.94 345.61 294.73 342.05 294.57 341.34 294.53 336.93 294.3 335.86 294.25 336.5 284.9 Z"
          data-name="Beaver"
          data-stusps="OK"
          id="40007"
        />
        <path
          className="white"
          d="M 413.49 406.28 417.24 408.54 421.13 408.62 421.97 410.46 423.67 411.46 423.31 412.07 424.29 411.59 425.43 414.91 422.25 417.54 420.41 416.34 420.1 415.9 419.01 416 418.18 414.88 417.65 415.23 415.76 416.23 413.93 416.39 413.91 413.48 413.49 406.28 Z"
          data-name="Montgomery"
          data-stusps="TX"
          id="48339"
        />
        <path
          className="white"
          d="M 672.94 239.83 673.81 237.92 674.16 238.03 674.49 238.54 674.82 238.56 676.57 236.62 677.38 236.45 679.07 234.74 681.03 234.68 681.1 234.1 682.23 234.51 682.14 235.02 679.4 239.85 677.05 239.65 675.53 240.37 673.38 239.89 672.94 239.83 Z"
          data-name="Orange"
          data-stusps="VA"
          id="51137"
        />
        <path
          className="white"
          d="M 658.04 238.06 658.25 238.06 659.03 236.79 659.06 236.68 664.38 239.13 664.75 239.06 667.17 240.5 667.15 242.98 666.4 243.77 665.79 245.77 664.5 247.38 663.51 246.86 662.18 247.62 661.7 247.26 656.63 244.82 657.05 243.24 655.86 243.11 656.85 242.24 658.2 238.73 658.04 238.06 Z M 662.51 241.76 661.91 242.51 662.98 242.97 663.34 242.46 663.12 241.48 662.51 241.76 Z M 664.77 243.99 665.22 244.31 665.95 244 665.85 242.93 664.88 243.3 664.77 243.99 Z"
          data-name="Augusta"
          data-stusps="VA"
          fillRule="evenodd"
          id="51015"
        />
        <path
          className="white"
          d="M 623.93 234.23 624.66 233.65 626.34 234.27 627.25 233.75 628.32 234.96 629.86 238.57 631.07 239 630.51 239.98 629.69 240.86 625.51 241.17 624.57 240.03 624.02 238.96 623.62 234.59 623.93 234.23 Z"
          data-name="Roane"
          data-stusps="WV"
          id="54087"
        />
        <path
          className="white"
          d="M 571.56 316.55 573.59 316.36 574.98 316.23 575.3 316.18 574.43 318.34 574.26 319.19 574.4 320.55 573.9 321.75 573.95 322.31 573.36 323.24 572.69 320.9 572.15 318.86 571.83 317.68 571.56 316.55 Z"
          data-name="Dade"
          data-stusps="GA"
          id="13083"
        />
        <path
          className="white"
          d="M 177.25 125.73 181.65 126.67 180.6 131.59 184.66 132.46 183.26 139 182.91 140.56 181.29 140.3 180.94 141.93 179.29 141.58 178.5 144.64 177.67 144.47 172.8 143.43 173.13 141.88 169.39 141.05 169.94 138.61 169.39 136.77 167.99 136.76 168.72 135.9 173.53 134.07 174.28 133.27 174.91 133.81 173.96 132.08 174.68 128.58 175.24 128.71 175.96 125.44 177.25 125.73 Z"
          data-name="Butte"
          data-stusps="ID"
          id="16023"
        />
        <path
          className="white"
          d="M 468.39 310.06 474.57 309.95 475.29 309.8 475.37 313.13 475.39 314.6 474.58 315 474.6 316.46 470.61 316.54 468.44 316.6 468.39 310.06 Z"
          data-name="Cleburne"
          data-stusps="AR"
          id="5023"
        />
        <path
          className="white"
          d="M 556.59 214.91 556.65 215.45 557 218.45 551.51 219.12 551.18 216.15 551.13 215.6 553.74 215.27 556.59 214.91 Z"
          data-name="Tipton"
          data-stusps="IN"
          id="18159"
        />
        <path
          className="white"
          d="M 263.25 233.71 264.87 234.23 265.84 232.89 268.23 231.25 268.11 230.73 268.88 230.81 271.64 231.06 274.38 231.39 274.06 234.49 273.52 239.6 274.51 239.71 273.68 247.84 264.22 246.89 265.39 244.86 265.25 243.6 263.89 242.1 262.66 242.02 261.74 239.7 261.56 238.77 262.16 238.2 262.39 234.95 263.25 233.71 Z"
          data-name="Park"
          data-stusps="CO"
          id="8093"
        />
        <path
          className="white"
          d="M 542.7 100.39 542.26 96.98 542.56 96.9 547.22 96.45 549.94 94.69 550.18 94.61 551.48 104.19 543.32 105.27 542.7 100.39 Z"
          data-name="Luce"
          data-stusps="MI"
          id="26095"
        />
        <path
          className="white"
          d="M 405.22 81.17 414.97 81.18 414.98 81.72 414.99 83.36 413.37 83.37 413.37 85.01 406.85 85 406.85 83.36 405.21 83.35 405.22 81.17 Z"
          data-name="Red Lake"
          data-stusps="MN"
          id="27125"
        />
        <path
          className="white"
          d="M 596.53 348.12 598.52 348.1 598.47 347.64 599.78 347.5 600.16 352.64 599.06 352.75 598.95 351.67 596.6 351.9 596.53 351.14 596.84 350.95 596.53 348.12 Z"
          data-name="Lamar"
          data-stusps="GA"
          id="13171"
        />
        <path
          className="white"
          d="M 576.83 315.99 580.24 315.59 581.26 315.47 580.33 318.77 579.14 319.89 578.24 319.84 578.08 318.35 577.1 318.45 576.83 315.99 Z"
          data-name="Catoosa"
          data-stusps="GA"
          id="13047"
        />
        <path
          className="white"
          d="M 470.7 322.1 472.34 321.85 474.08 322.7 475.62 322.58 475.68 324.63 477.38 324.59 477.47 329.24 478.47 330.1 478.61 331.44 477.96 332.79 477.54 332.8 473.35 332.85 472.49 332.87 472.4 330.39 471.17 330.41 471.57 328.54 471.49 323.1 470.71 323.12 470.7 322.1 Z"
          data-name="Lonoke"
          data-stusps="AR"
          id="5085"
        />
        <path
          className="white"
          d="M 637.31 424.59 643.29 423.89 644.21 431.66 644.62 435.6 644.69 436.29 643.04 436.41 642.69 433.25 642.59 432.44 639.9 431.77 638.6 430.3 638.77 430.06 640.07 427.5 637.31 424.59 Z"
          data-name="Sumter"
          data-stusps="FL"
          id="12119"
        />
        <path
          className="white"
          d="M 586.84 341.83 586.99 341.41 589.42 339.28 590.13 338.24 591.52 336.67 591.89 336.45 591.77 335.99 591.94 335.02 592.83 333.3 591.94 331.73 592.77 329.66 594.21 329.32 594.38 330.76 597.04 331.58 595.83 332.74 594.59 333.07 594.42 333.66 593.29 333.59 593.45 335.05 593.52 335.68 593.55 335.91 593.93 339.64 592.23 339.81 592.27 340.18 592.34 340.84 592.43 341.66 590.92 342.26 590.14 342.84 589.83 342.71 588.7 342.83 586.31 343.09 586.84 342.86 586.84 341.83 Z"
          data-name="Fulton"
          data-stusps="GA"
          id="13121"
        />
        <path
          className="white"
          d="M 550.9 224.73 552.13 224.56 556.52 224.06 556.64 225.14 556.44 225.42 556.8 228.41 556.92 229.51 552.6 230.07 551.49 230.22 551.09 226.64 551.03 225.82 550.9 224.73 Z"
          data-name="Marion"
          data-stusps="IN"
          id="18097"
        />
        <path
          className="white"
          d="M 417.53 225.71 422.81 225.73 424.48 226 424.81 228.18 424.57 229.31 425.29 229.74 425.57 232.52 425.2 232.54 424.3 233.22 423.41 232.59 422.13 231.7 421.01 230.65 420.42 230.1 419.93 230.15 419.46 229.35 419.76 228.63 419.21 228.01 418.5 227.13 418.62 226.23 417.54 225.81 417.53 225.74 417.53 225.71 Z"
          data-name="Holt"
          data-stusps="MO"
          id="29087"
        />
        <path
          className="white"
          d="M 533.77 274.67 533.63 275.22 533.11 275.81 533.93 277.27 535.95 278.84 535.7 281.28 535.39 281.67 533.59 282.8 533.29 282.65 530.47 278.82 529.65 278.79 529.68 277.99 533.77 274.67 Z"
          data-name="Caldwell"
          data-stusps="KY"
          id="21033"
        />
        <path
          className="white"
          d="M 224.78 73.36 230.19 74.39 229.99 75.48 231.08 75.68 230.78 77.31 232.4 77.61 232.25 78.42 233.88 78.72 233.74 79.54 235.21 79.8 234.24 85.23 232.92 86.67 233.84 87.39 233.69 89.03 232.73 88.87 231.01 87.41 226.94 87.48 226.1 88.04 224.33 87.6 222.68 85.47 222.45 84.43 222.72 84.22 223.54 79.35 221.94 79.02 222.49 75.02 222.94 74.12 224.57 74.44 224.78 73.36 Z"
          data-name="Judith Basin"
          data-stusps="MT"
          id="30045"
        />
        <path
          className="white"
          d="M 475.72 370 476.88 369.72 477.4 368.71 478.4 368.9 479.98 366.8 480.63 366.78 480.7 368.37 483.1 368.28 482.94 369.11 482.52 369.79 482.74 371.61 480.21 371.71 478.21 373.21 478.1 374.84 476.26 376.63 474.88 376.4 474.6 374.34 473.94 374.35 474.5 372.01 475.72 370 Z"
          data-name="Richland"
          data-stusps="LA"
          id="22083"
        />
        <path
          className="white"
          d="M 603.52 348.42 607.73 347.16 609.31 346.72 609.56 346.68 609.95 348.02 611.29 351.44 610.56 352.07 608.98 353.28 608.09 352.77 606.57 352.74 605.91 352.26 605.59 351.61 605.18 350.13 603.52 348.42 Z"
          data-name="Jones"
          data-stusps="GA"
          id="13169"
        />
        <path
          className="white"
          d="M 559.38 124.68 561.01 124.49 560.79 122.86 565.68 122.23 566.54 128.69 560.18 129.52 559.38 124.68 Z"
          data-name="Otsego"
          data-stusps="MI"
          id="26137"
        />
        <path
          className="white"
          d="M 344.83 196.1 351.11 196.43 351.31 196.44 350.97 202.95 344.44 202.59 344.83 196.1 Z"
          data-name="Logan"
          data-stusps="NE"
          id="31113"
        />
        <path
          className="white"
          d="M 332.5 101.38 337.38 101.76 337.26 103.38 342.69 103.79 342.35 108.65 345.6 108.87 345.79 110.52 343.42 112.26 343.48 112.93 342 113.12 341.99 113.65 338.54 115.26 337.68 114.63 337.1 115.07 336.03 114.42 334.85 114.49 334.77 113.73 332.79 113.95 333.02 111.1 332.5 109.58 332.95 103.06 332.36 103.01 332.5 101.38 Z"
          data-name="Grant"
          data-stusps="ND"
          id="38037"
        />
        <path
          className="white"
          d="M 404.09 318.95 411.16 318.98 411.13 321.57 409.5 323.48 409.43 328.77 404.57 328.75 404.59 325.62 403.28 326.06 403.31 322.21 404.07 322.22 404.09 318.95 Z"
          data-name="Hughes"
          data-stusps="OK"
          id="40063"
        />
        <path
          className="white"
          d="M 656.38 189.65 655.53 185.38 655.8 183.94 656.61 183.8 657.31 182.63 663.24 181.87 665.34 181.69 665.97 182.4 666.38 182.72 665.48 183.69 666.71 185.59 666.59 186.51 665.28 186.75 664.54 188.98 664 189.2 663.1 191.26 663.43 191.62 663.62 191.76 662.84 191.89 657.11 193.06 656.98 192.72 656.38 189.65 Z"
          data-name="Clearfield"
          data-stusps="PA"
          id="42033"
        />
        <path
          className="white"
          d="M 342.32 156.36 344.12 156.66 345.26 158.07 345.87 158.22 345.92 158.76 346.65 159.14 348.72 158.1 352.05 159.27 352.84 159.69 353.52 159.41 353.29 163.83 353.43 165.49 352.91 165.46 339.54 164.7 340.19 156.92 342.32 156.36 Z"
          data-name="Mellette"
          data-stusps="SD"
          id="46095"
        />
        <path
          className="white"
          d="M 318.1 384.56 326.27 385 326.18 386.77 326.15 387.29 325.62 395.72 317.51 395.29 318.1 384.56 Z"
          data-name="Reagan"
          data-stusps="TX"
          id="48383"
        />
        <path
          className="white"
          d="M 424.21 363.68 431.04 363.58 431.27 364.06 431.81 364.88 431.35 365.67 431.38 368.31 430.67 368.03 429.51 369.48 426.88 370.5 426.88 370.5 426.51 370.9 426.43 370.41 424.23 369.91 424.23 368.21 424.21 363.68 Z"
          data-name="Upshur"
          data-stusps="TX"
          id="48459"
        />
        <path
          className="white"
          d="M 653.75 260.49 654.51 259.55 654.55 258.94 654.35 259 653.94 258.62 654.28 258.46 655.23 257.51 655.57 256.92 656.02 256.67 656.48 257.13 656.61 257.15 657.2 257.15 658.27 255.34 659.11 254.41 658.92 253.57 660.69 255.19 663.23 255.75 662.06 256.32 662.51 258.03 661.81 260.46 660.73 264.22 660.33 265.26 658.47 264.88 656.96 263.05 656.1 262.42 654.03 262.08 653.72 261.32 653.75 260.49 Z"
          data-name="Bedford"
          data-stusps="VA"
          id="51019"
        />
        <path
          className="white"
          d="M 582.43 192.38 582.84 192.32 584.64 190.57 586.11 188.28 586.32 187.94 588.49 187.59 588.83 189.82 589.43 194.46 589.66 196.11 583.11 197.02 582.43 192.38 Z"
          data-name="Wood"
          data-stusps="OH"
          id="39173"
        />
        <path
          className="white"
          d="M 618.32 217.24 619.98 217.04 619.83 215.93 621.5 215.71 622.46 214.47 624.67 214.09 624.88 215.67 623.77 215.83 624.76 218.81 625.04 220.72 623.42 221.07 622.14 220.42 622.33 221.6 620.64 221.81 620.44 220.35 619.6 220.45 619.38 218.79 618.53 218.89 618.32 217.24 Z"
          data-name="Noble"
          data-stusps="OH"
          id="39121"
        />
        <path
          className="white"
          d="M 431.3 408.81 434.46 408.76 434.33 408.09 442.02 408 441.27 409.88 441.88 411.45 441.35 413.34 441.79 414.03 441.4 414.86 440.41 414.36 438.8 414.72 438.54 415.71 436.06 415.82 433.59 415.87 431.3 408.81 Z"
          data-name="Hardin"
          data-stusps="TX"
          id="48199"
        />
        <path
          className="white"
          d="M 65.73 85.46 66.77 84.18 66.21 83.18 67.29 82.94 67.64 83.15 76.08 86.04 85.63 89.2 85.02 89.56 83.88 93.95 77.97 92.07 77.45 93.68 75.28 92.97 74.75 94.59 73.15 94.06 63.29 90.7 63.87 88.84 65.24 87.16 65.73 85.46 Z"
          data-name="Jefferson"
          data-stusps="OR"
          id="41031"
        />
        <path
          className="white"
          d="M 540.29 391.78 540.67 391.18 542.41 390.33 542.8 388.64 543.46 389 544.28 388.85 545.95 389.82 546.3 394.42 546.57 394.45 546.57 394.45 546.75 395.3 546.17 396.97 547.81 398.71 548.16 399.23 549.55 399.99 550.28 400.61 550.34 401.6 549.93 402.66 549.77 403.48 550.33 404.39 551.14 404.72 550.13 405.43 549.88 406.57 548.89 407.84 546.66 408.59 544.04 409.18 542.81 409.06 544.18 408.2 544.28 407.35 543.08 406.32 542.2 405.19 541.83 404.44 542.26 403.21 542 402.56 541.65 401.33 540.35 400.81 539.96 399.54 541.19 398.06 540.54 396.94 541.38 396 540.67 395.44 540.95 393.9 540.33 393.16 540.84 392.03 540.29 391.78 Z"
          data-name="Baldwin"
          data-stusps="AL"
          id="1003"
        />
        <path
          className="white"
          d="M 137.56 263.08 138.14 260.09 139.43 260.36 154.65 263.26 155.68 263.45 156.74 263.64 161.07 264.43 161.17 264.44 161.14 265.39 159.65 267.47 158.52 270.36 158.53 271.89 157.75 272.78 158.08 274.19 157.7 275.74 156.73 276.55 156.09 276.35 154.83 277.32 153.71 277.17 153.03 277.61 151.34 277.59 149.12 278.61 148.15 278.69 147.5 279.79 146.05 279.41 145.33 280.38 145.62 281.99 145.18 282.84 145.38 283.85 144.8 284.95 143.84 290.17 143.77 290.55 140.5 308.57 139.69 313.21 139.02 313.6 136.39 312.85 135.07 314.13 133.79 314.28 133.14 313.56 128.45 312.32 126.86 311.17 126.87 311.11 126.51 310.27 125.26 308.93 124.31 307.79 123.62 307.65 123.87 306.39 123.41 305.03 123.14 302.8 122.86 302.08 121.84 300.09 121.14 298.81 121.48 297.49 121.64 296.36 122.02 295.11 122.3 294.12 122.62 294.19 123.1 293.93 123.34 291.53 123.26 288.61 122.83 287.73 123.14 286.3 123.61 284.69 123.21 283.8 123.4 282.21 123.6 280.65 124.33 279.79 123.99 279 123.67 278.1 123.75 276.81 123.95 275.74 123.97 275.65 124.21 275.03 125.34 275 126.03 274.67 126.93 274.64 127.86 274.84 128.16 275.33 128.74 275.5 129.3 275.23 129.98 275.42 130.39 276.19 130.55 277.11 131.15 277.77 131.95 278.32 132.95 278.34 133.26 277.84 134.11 276.65 135.19 275.43 135.45 274 135.67 272.93 136.67 267.63 137.56 263.08 Z"
          data-name="Mohave"
          data-stusps="AZ"
          id="4015"
        />
        <path
          className="white"
          d="M 133.68 347.78 145.15 349.68 151.96 350.74 158.6 351.78 165.7 352.95 168.85 353.23 173.67 353.93 173.94 353.92 180.23 354.81 180.01 356.45 178.16 369.68 168.3 368.39 166.57 368.15 166.02 372.04 162.7 371.57 162.44 373.41 147.05 364.93 132.19 356.67 133.68 347.78 Z"
          data-name="Pima"
          data-stusps="AZ"
          id="4019"
        />
        <path
          className="white"
          d="M 264.85 272.41 268.9 268.97 269.16 268.66 272.15 267.51 273.7 268.33 273.59 274.52 273.02 280.12 272.03 280.02 271.57 279.97 269.03 279.71 267.3 279.53 264.54 279.25 264.51 279.24 263.81 278.3 265.06 273.79 264.85 272.41 Z"
          data-name="Costilla"
          data-stusps="CO"
          id="8023"
        />
        <path
          className="white"
          d="M 590.26 410.21 590.48 409.38 598.11 408.69 598.5 409.21 599.39 408.74 601.46 409.14 601.54 409.28 601.75 409.99 601.54 410.53 600.3 410.54 599.49 410.21 598.44 410.59 597.8 411.08 598.15 412.52 597.55 413.04 596.13 413.62 594.87 415.1 593.29 415.94 590.63 417.51 588.68 416.63 587.6 416.28 587.75 415.41 589.23 414.02 590.38 413.85 589.91 411.57 590.26 410.21 Z"
          data-name="Franklin"
          data-stusps="FL"
          id="12037"
        />
        <path
          className="white"
          d="M 533.69 239.06 538.87 238.59 539.02 240.23 539.49 245.19 539.22 245.33 535.27 245.62 535.28 245.58 535.14 244.38 534.36 243.89 534.36 242.83 533.51 242.07 533.22 241.03 533.18 240.87 534.03 239.95 533.73 239.29 533.69 239.06 Z"
          data-name="Sullivan"
          data-stusps="IN"
          id="18153"
        />
        <path
          className="white"
          d="M 402.96 164.95 404.95 164.97 408.43 164.99 410.42 165 413.05 165.01 413.03 169.55 403.85 169.48 403.46 169.51 403.2 168.88 403.86 168.72 403.95 167.83 404 167.11 403.01 166.19 403.15 165.53 402.96 164.95 Z"
          data-name="Lyon"
          data-stusps="IA"
          id="19119"
        />
        <path
          className="white"
          d="M 573.55 323.89 576.16 323.75 580.09 323.22 579.26 326.2 576.97 327.7 576.32 329.37 575.13 329.49 574.83 328.42 574.15 326 573.89 325.09 573.55 323.89 Z"
          data-name="Chattooga"
          data-stusps="GA"
          id="13055"
        />
        <path
          className="white"
          d="M 517.07 278.89 518.51 279.35 519.8 280.04 520.71 280.23 521.99 280.67 522.79 281.15 523.26 281.43 523.88 281.37 523.98 281.36 524.06 282.21 524.06 282.62 524.16 283.73 519.19 284.01 519.14 283.88 516.99 278.87 517.01 278.87 517.07 278.89 Z"
          data-name="McCracken"
          data-stusps="KY"
          id="21145"
        />
        <path
          className="white"
          d="M 459.15 218.75 461.78 218.57 463.25 218.48 463.45 223.18 458.65 223.42 458.22 221.51 458.52 219.35 458.05 218.82 458.45 218.8 459.15 218.75 Z"
          data-name="Schuyler"
          data-stusps="MO"
          id="29197"
        />
        <path
          className="white"
          d="M 366.27 173.47 371.88 173.68 376.69 173.84 376.94 174.5 377.53 175.16 378.19 175.39 379.25 176.02 379.17 177.93 379.23 178.37 375.38 177.91 374.39 177.32 371.15 176.52 369.95 175.52 366.09 177.1 366.27 173.47 Z"
          data-name="Boyd"
          data-stusps="NE"
          id="31015"
        />
        <path
          className="white"
          d="M 109.31 257.23 111.74 257.54 126.68 260.88 137.56 263.08 136.67 267.63 135.67 272.93 135.45 274 135.19 275.43 134.11 276.65 133.26 277.84 132.95 278.34 131.95 278.32 131.15 277.77 130.55 277.11 130.39 276.19 129.98 275.42 129.3 275.23 128.74 275.5 128.16 275.33 127.86 274.84 126.93 274.64 126.03 274.67 125.34 275 124.21 275.03 123.97 275.65 123.95 275.74 123.75 276.81 123.67 278.1 123.99 279 124.33 279.79 123.6 280.65 123.4 282.21 123.21 283.8 123.61 284.69 123.14 286.3 122.83 287.73 123.26 288.61 123.34 291.53 123.1 293.93 122.62 294.19 122.3 294.12 122.02 295.11 121.64 296.36 119.48 293.2 116.46 288.79 115 286.66 113.2 284.03 111.94 282.19 108.92 277.74 108.92 277.73 106.46 274.14 107.12 271.12 106.55 270 109.31 257.23 Z"
          data-name="Clark"
          data-stusps="NV"
          id="32003"
        />
        <path
          className="white"
          d="M 735.02 112.64 735.2 111.86 735.01 110.58 735.44 108.9 735.05 108.14 735.33 107.28 735.33 107.27 735.37 107.17 735.49 105.73 734.94 104.73 734.69 104.29 734.43 103.1 734.28 102.22 734.68 101.43 735.37 100.95 736.31 100.66 736.76 100.31 736.99 100.13 737.25 99.09 737.44 98.95 738.75 100.01 740.39 100.06 740.83 100.95 742.65 100.49 743.24 101.07 744.38 103.06 745.73 106.39 743.11 107.68 743.27 108 743.97 109.42 744.34 110.02 744.84 111.16 744.06 111.53 743.19 111.95 743.53 113.15 742.82 114.56 741.7 115.29 740.75 114.48 740.5 115.04 740.18 116.08 738.05 116.73 734.3 116.28 734.34 116.22 734.32 113.93 734.95 112.93 735.02 112.64 Z"
          data-name="Grafton"
          data-stusps="NH"
          id="33009"
        />
        <path
          className="white"
          d="M 657.96 140.94 657.97 140.94 660.51 140.81 660.62 140.79 661.29 140.68 662.91 141.46 664.61 142.01 665.24 141.58 666.86 140.75 667.95 145.23 666.38 145.59 666.81 147.3 665.45 147.59 662.99 148.21 663.18 147.22 660.71 147.78 660.59 146.84 660.16 145.03 658.9 145.32 658.29 142.45 657.96 140.94 Z"
          data-name="Monroe"
          data-stusps="NY"
          id="36055"
        />
        <path
          className="white"
          d="M 597.61 236.3 598.62 237.23 601.11 236.93 604.62 236.6 605.42 236.53 605.56 238.26 607.21 238.13 607.3 240.06 606.84 241.49 605.99 241.56 606.57 243.07 605.58 243.69 604.91 243.17 604.43 241.82 604.3 241.07 604.07 240.65 603.93 240.39 603.17 240.75 602.19 241.14 601.95 241.43 601.8 241.62 600.86 242.45 600.7 243.08 600.11 243.55 599.1 243.53 598.77 243.87 598.66 243.49 597.61 236.3 Z"
          data-name="Scioto"
          data-stusps="OH"
          id="39145"
        />
        <path
          className="white"
          d="M 419.83 286.92 421.12 286.92 424.86 286.89 425.85 286.88 425.46 286.98 425.99 287.94 426.03 293.05 425.95 294.41 425.96 296.06 421.08 296.09 421.07 294.45 419.51 294.46 419.48 287.99 419.83 286.92 Z"
          data-name="Craig"
          data-stusps="OK"
          id="40035"
        />
        <path
          className="white"
          d="M 631.17 337.3 636.21 331.09 637.31 329.72 640.17 332.12 644.01 333.1 641.5 336.61 636.36 342.77 636.07 343.03 636.04 342.92 634.62 342.37 634.6 342.27 634.46 341.2 632.98 340.63 633.01 339.33 632.78 338.36 631.67 337.9 631.17 337.3 Z"
          data-name="Aiken"
          data-stusps="SC"
          id="45003"
        />
        <path
          className="white"
          d="M 725.01 132.49 724.6 130.85 724.57 130.74 723.28 125.45 727.01 124.57 727.25 124.79 728.67 124.18 729.34 124.01 729.58 124.82 729.15 124.81 729.69 127.69 727.9 128.13 728.75 131.69 728.77 131.68 729.94 131.42 730.87 134.99 730.61 135.05 729.63 135.3 729.57 135.32 727.9 135.75 726.18 136.18 725.53 135.23 725.53 134.59 725.01 132.49 Z"
          data-name="Bennington"
          data-stusps="VT"
          id="50003"
        />
        <path
          className="white"
          d="M 362.83 163.89 366.06 164.03 365.87 164.62 367.99 165.48 369.06 167.51 370.22 168.72 371.37 168.99 371.7 170.6 373 170.94 374.1 172.29 376.35 173.06 376.69 173.84 371.88 173.68 366.27 173.47 362.42 173.3 362.83 163.89 Z"
          data-name="Gregory"
          data-stusps="SD"
          id="46053"
        />
        <path
          className="white"
          d="M 320.9 270.01 328.57 270.55 328.2 277.08 327.73 277.05 320.46 276.57 320.78 271.78 320.88 270.29 320.9 270.01 Z"
          data-name="Stanton"
          data-stusps="KS"
          id="20187"
        />
        <path
          className="white"
          d="M 567.64 268.02 568.43 265.42 569.06 264.5 570.01 265.82 572.8 265.97 574.84 265.73 574.89 267.37 575.1 269.88 574.66 269.91 573.75 269.26 572.05 270.08 570.54 269.31 568.65 269.6 567.93 268.09 567.64 268.02 Z"
          data-name="Marion"
          data-stusps="KY"
          id="21155"
        />
        <path
          className="white"
          d="M 343.37 423.84 344.98 423.9 351.72 424.06 354.85 424.15 354.51 434.2 343.01 433.91 343.37 423.84 Z"
          data-name="Uvalde"
          data-stusps="TX"
          id="48463"
        />
        <path
          className="white"
          d="M 678.27 256.26 684.77 256.86 685.26 256.95 683.86 258.18 684.59 261.09 683.41 261.36 682.74 260.79 681.58 261.24 678.79 259.63 678.27 256.26 Z"
          data-name="Nottoway"
          data-stusps="VA"
          id="51135"
        />
        <path
          className="white"
          d="M 161.17 264.44 163.92 264.93 178.28 267.41 178.39 267.43 180.32 267.77 183.54 268.26 188.34 269.02 182.5 306.31 180.29 320.92 179.88 320.15 178.76 320.62 177.15 319.46 175.22 317.57 174.37 317.85 172.97 316.12 170.58 316.27 170.1 317.14 170.21 315.99 168.7 315.89 169.51 315.4 169.14 314.64 168.24 315.01 169.29 308.74 165.74 308.15 166.31 304.78 162.69 304.28 157.57 303.48 158.12 300.15 156.46 299.84 156.82 297.75 155.19 297.92 153.06 296.07 152.41 296.09 149.17 294.58 148.93 293.75 146.57 291.64 146.22 291.02 143.84 290.17 144.8 284.95 145.38 283.85 145.18 282.84 145.62 281.99 145.33 280.38 146.05 279.41 147.5 279.79 148.15 278.69 149.12 278.61 151.34 277.59 153.03 277.61 153.71 277.17 154.83 277.32 156.09 276.35 156.73 276.55 157.7 275.74 158.08 274.19 157.75 272.78 158.53 271.89 158.52 270.36 159.65 267.47 161.14 265.39 161.17 264.44 Z"
          data-name="Coconino"
          data-stusps="AZ"
          id="4005"
        />
        <path
          className="white"
          d="M 42.24 291.33 42.87 290.97 43.22 289.83 43.68 287.96 45.29 281.4 47.81 282.62 48.07 283.87 52.26 284.95 53.7 285.77 54.61 291.89 55.18 295.6 55.24 296.71 54.54 297.21 54.36 297.93 53.81 298.42 53.33 298.32 52.28 298.07 51.01 298.61 49.42 299.28 49.23 299.81 49.07 299.75 47.42 298.49 46.8 298.25 45.22 296.5 44.99 295.39 44.97 294.58 44.88 294.49 44.39 293.97 43.6 292.85 42.49 291.49 42.24 291.33 Z M 40.81 297.63 41.26 297.74 42.51 298.11 42.29 299.08 41.8 299.08 40.27 298.67 40.81 297.63 Z M 35.42 312.18 36.66 311.9 37.82 313.02 37.61 313.74 36.98 313.85 35.74 313.19 35.42 312.18 Z"
          data-name="Ventura"
          data-stusps="CA"
          fillRule="evenodd"
          id="6111"
        />
        <path
          className="white"
          d="M 736.01 155.93 736.61 155.66 736.97 157.34 738.48 157.17 739.6 156.15 739.84 156.79 740.14 157.65 740.52 159.07 741.42 158.6 741.76 158.41 742.91 160.31 744.44 161.42 744.28 161.53 743.46 161.39 742.68 161.67 742.67 161.68 742.26 162.18 741.29 162.56 740.8 162.22 739.55 163.02 739.2 162.99 738.7 162.94 738.29 163.4 738.12 163.59 738.1 163.61 737.76 164.26 736.98 164.73 736.83 165.38 736.44 165.16 736.56 163.61 736.44 163.19 736.59 162.66 735.74 162.26 735.1 161.71 734.47 161.4 733.97 160.95 732.54 160.78 732.26 160.44 731.93 159.82 732.86 159.4 733.56 159.27 734.21 158.96 734.14 158.11 735.21 157.19 735.12 156.84 736.01 155.93 Z"
          data-name="New Haven"
          data-stusps="CT"
          id="9009"
        />
        <path
          className="white"
          d="M 160.84 155.76 161.83 155.8 163.9 155.85 165 156.82 165.7 156.63 167.54 154.65 168.77 154.67 170.22 154.62 170.94 155.94 171.87 156.2 172.58 157.06 174.97 157.59 173.99 162.5 172.7 168.7 172.69 168.7 169.19 168.01 165.7 167.33 161.17 166.45 158.04 165.66 154.67 164.91 156.4 156.92 159.42 157.6 159.86 155.78 160.84 155.76 Z"
          data-name="Cassia"
          data-stusps="ID"
          id="16031"
        />
        <path
          className="white"
          d="M 544.06 258.11 547.41 257.76 547.3 258.95 548.07 261.62 547.64 261.34 547.47 261.72 546.58 262.29 545.88 263.04 545.15 263.28 544.67 263.44 544.27 264.33 544.13 265.24 543.52 266.43 542.98 265.73 542.28 265.15 541.11 264.77 540.87 264.64 540.82 263.71 543.39 259.79 544.21 259.72 544.06 258.11 Z"
          data-name="Spencer"
          data-stusps="IN"
          id="18147"
        />
        <path
          className="white"
          d="M 567.92 245.48 570.05 248.18 570.68 248.01 569.23 249.88 568.73 250.01 567.71 249.62 566.9 249.62 567.11 249.17 566.79 248.44 566.69 248.22 566.52 247.08 566.26 246.08 566.92 245.57 567.8 245.51 567.92 245.48 Z"
          data-name="Trimble"
          data-stusps="KY"
          id="21223"
        />
        <path
          className="white"
          d="M 537.44 259.45 539.61 258.57 539.54 257.73 539.84 257.98 543.18 257.65 544.06 258.11 544.21 259.72 543.39 259.79 540.82 263.71 540.87 264.64 540.34 264.34 539.9 264.1 538.55 263.54 538.12 263.78 537.58 261.91 537.44 259.45 Z"
          data-name="Warrick"
          data-stusps="IN"
          id="18173"
        />
        <path
          className="white"
          d="M 726.22 140.97 726.2 138.48 726.18 136.18 727.9 135.75 729.57 135.32 729.63 135.3 730.61 135.05 730.31 136.48 731.11 136.92 731.23 138.61 731.67 142.08 730.86 142.12 731.14 143.04 731.8 143.49 732.18 143.3 732.08 146.77 732.89 148.65 731.84 148.9 730.37 149.26 726.74 150.17 726.68 150.1 726.26 149.56 726.24 144.17 726.22 140.97 Z"
          data-name="Berkshire"
          data-stusps="MA"
          id="25003"
        />
        <path
          className="white"
          d="M 525.91 387.63 532.23 387.18 532.26 387.45 532.92 393.21 533.16 395.38 526.55 395.82 526.43 395.66 525.91 387.63 Z"
          data-name="Greene"
          data-stusps="MS"
          id="28041"
        />
        <path
          className="white"
          d="M 414.4 219.7 417.72 219.74 420 219.77 420.55 219.78 422.46 219.79 422.82 221.65 422.81 225.73 417.53 225.71 417.45 225.2 416.8 224.86 416.01 224.62 416.19 223.8 416.07 223.24 415.56 221.98 415.41 221.41 415.16 220.85 415.13 220.78 414.52 220.81 414.4 219.7 Z"
          data-name="Atchison"
          data-stusps="MO"
          id="29005"
        />
        <path
          className="white"
          d="M 211.55 291.82 233.33 294.7 238.2 295.32 236.65 308.39 231.7 307.83 231.81 307 230.17 306.8 230.07 307.62 218.7 306.16 218.68 306.3 217.84 312.72 208.87 311.53 209.41 307.45 209.89 303.89 210.54 299.16 211.23 294.14 211.55 291.82 Z"
          data-name="McKinley"
          data-stusps="NM"
          id="35031"
        />
        <path
          className="white"
          d="M 703.94 136.15 707.25 136.52 708 136.33 713.42 134.91 713.44 134.98 713.62 135.41 714.04 136.47 712.07 139.04 711.77 139.38 710.12 139.97 709.53 140.2 706.57 139.84 704.81 139.63 704.25 136.4 703.94 136.15 Z"
          data-name="Montgomery"
          data-stusps="NY"
          id="36057"
        />
        <path
          className="white"
          d="M 663.21 287.48 667.92 286.64 667.63 286.06 670.27 285.91 671.28 285.68 672.97 285.29 673 285.77 672.82 287.2 672.46 290.43 673.79 290.71 673.15 292.04 670.5 290.42 668.72 291.89 667.25 293.14 664.07 293.74 663.21 287.48 Z"
          data-name="Chatham"
          data-stusps="NC"
          id="37037"
        />
        <path
          className="white"
          d="M 704.53 180.79 707.03 179.16 708.87 176.71 709.42 177.35 710.07 178.01 709.88 178.79 709.9 179.95 709.86 179.98 709.03 180.7 709.04 181.67 709.42 183.14 709.58 183.68 708.71 184.43 707.83 185.55 706.61 184.96 706.62 183.93 705.16 183.82 702.72 181.78 703.12 181.44 704.53 180.79 Z"
          data-name="Northampton"
          data-stusps="PA"
          id="42095"
        />
        <path
          className="white"
          d="M 573.35 286.89 573.54 286.07 573.28 285.08 576.03 284.85 577.89 284.79 578.36 284.77 580.79 284.67 581.78 286.05 578.44 285.36 576.96 285.96 576.12 288.95 573.58 286.7 573.35 286.89 Z"
          data-name="Pickett"
          data-stusps="TN"
          id="47137"
        />
        <path
          className="white"
          d="M 584.36 411.67 583.87 406.44 588.37 406.04 587.93 408.14 588.72 409.37 590.26 410.21 589.91 411.57 590.38 413.85 589.23 414.02 587.75 415.41 587.6 416.28 586.92 416.06 585.42 416.6 584.42 414.81 584.05 413.25 584.44 411.72 584.36 411.67 Z"
          data-name="Gulf"
          data-stusps="FL"
          id="12045"
        />
        <path
          className="white"
          d="M 123.95 64.83 122.12 70.34 123.75 70.82 123.26 72.45 124.88 72.93 123.67 76.79 118.84 75.35 115.73 74.41 114.81 74.13 110.78 72.93 110.78 72.93 111.53 72.59 111.74 70.37 111.18 69.11 111.56 68.74 113.87 68.72 115.34 68.24 115.96 67.18 117.72 66.6 118.47 64.99 120.85 63.82 123.95 64.83 Z"
          data-name="Walla Walla"
          data-stusps="WA"
          id="53071"
        />
        <path
          className="white"
          d="M 570.51 344.94 569.99 345.55 571.65 345.39 571.87 344.81 573.8 344.67 574.17 347.97 574.37 352.03 569.27 352.54 568.75 352.88 568.7 352.61 566.11 352.86 565.97 351.14 566.8 351.08 566.66 349.16 568.85 348.99 568.75 347.33 569.56 346.98 569.67 345.02 570.51 344.94 Z"
          data-name="Clay"
          data-stusps="AL"
          id="1027"
        />
        <path
          className="white"
          d="M 487.1 315.99 487.03 314.32 493.6 313.88 495.28 313.92 495.48 318.86 495.57 319.5 487.24 319.85 487.1 315.99 Z"
          data-name="Cross"
          data-stusps="AR"
          id="5037"
        />
        <path
          className="white"
          d="M 124.43 123.87 125.6 125.73 126.47 126.14 126.76 128.54 128.41 131.15 128.69 132.51 129.54 133.04 130.74 133.29 130.8 135.31 132.06 137.26 132.94 138.08 132.64 138.68 133.25 139.54 135.42 141.48 136.1 140.49 137.95 141.54 138.07 142.24 140.2 142.43 142.6 143.5 141.68 146.53 147.46 147.9 144.05 162.4 140.16 161.53 135.77 160.46 132.34 159.64 125.83 158.02 121.7 156.98 116.2 155.52 116.08 155.49 117.94 148.35 120.06 140.28 121.14 136.18 123.99 125.44 124.43 123.87 Z"
          data-name="Owyhee"
          data-stusps="ID"
          id="16073"
        />
        <path
          className="white"
          d="M 514.57 114.61 513.97 108.53 520.51 107.87 521 112.77 521.17 114.4 520.12 114.51 520.46 117.81 518.67 118 518 117.46 516.83 117.4 516.4 116.85 515.73 117.16 515.61 117.12 514.95 116.92 514.52 116.53 515.22 115.44 514.59 114.62 514.57 114.61 Z"
          data-name="Dickinson"
          data-stusps="MI"
          id="26043"
        />
        <path
          className="white"
          d="M 229.33 43.53 231.94 44.04 233.09 44.25 236.37 44.89 244.63 46.42 244.77 46.44 244.27 48.03 243.09 54.5 243.46 55.39 243.21 56.75 242.8 56.69 241.99 59.6 241.58 59.53 241.26 62.54 238.84 62.13 239.14 60.47 237.65 60.25 237.95 58.62 228.22 56.74 227.9 58.37 226.27 58.05 228.92 45.08 229.33 43.53 Z"
          data-name="Hill"
          data-stusps="MT"
          id="30041"
        />
        <path
          className="white"
          d="M 58.21 198.49 61.8 199.47 64.78 200.87 68.33 201.88 67.99 203.12 66.45 203.43 65.35 205.21 65.08 208.18 65.93 208.35 65.19 212.25 62.3 207.83 62.27 207.79 58.71 202.32 57.63 200.65 57.98 199.35 58.21 198.49 Z"
          data-name="Douglas"
          data-stusps="NV"
          id="32005"
        />
        <path
          className="white"
          d="M 272.03 280.02 273.02 280.12 273.54 280.17 279.4 280.77 285.34 281.32 290.33 281.71 289.07 296.33 282.56 295.76 276.01 295.17 276.09 294.35 268.83 293.64 269.31 290.96 268.94 290.09 269.6 289.35 268.82 288.13 269.38 286.57 269.17 285.72 270.14 284.98 271.37 285.12 271.62 282.79 272.19 281.55 272.03 280.02 Z"
          data-name="Colfax"
          data-stusps="NM"
          id="35007"
        />
        <path
          className="white"
          d="M 202.6 359.48 203.44 352.82 203.45 352.82 206.53 353.22 206.14 356.51 209.45 356.92 209.24 358.57 211.01 358.78 210 367.05 209.72 371.16 214.69 371.74 214.6 372.56 214.66 373.28 214.04 378.65 213.68 381.8 205.56 380.86 203.06 380.58 199.98 380.2 201.08 371.41 201.77 365.96 202.6 359.48 Z"
          data-name="Hidalgo"
          data-stusps="NM"
          id="35023"
        />
        <path
          className="white"
          d="M 653.85 301.65 655.62 302.3 656.42 301.27 657.15 302.14 658.62 303.02 659.6 302.28 660.58 303.68 661.44 306.18 660.55 308.12 660.5 308.13 658.15 308.47 654.32 309.01 653.85 301.65 Z"
          data-name="Anson"
          data-stusps="NC"
          id="37007"
        />
        <path
          className="white"
          d="M 686.28 137.93 687.15 137.85 687.92 138.08 690.09 137.39 693.04 139.15 693.68 141.11 695.04 140.74 695.47 142.03 698.05 141.21 698.42 142.86 698 143.77 696.15 144.22 689.85 146.22 689.45 144.98 687.79 139.5 686.96 139.6 687.11 138.69 686.28 137.93 Z"
          data-name="Madison"
          data-stusps="NY"
          id="36053"
        />
        <path
          className="white"
          d="M 429.19 302.56 432.76 302.51 432.94 303.63 433.27 305.77 433.89 309.87 433.92 310.04 434.26 312.3 429.13 312.36 429.19 302.56 Z"
          data-name="Adair"
          data-stusps="OK"
          id="40001"
        />
        <path
          className="white"
          d="M 557.1 375.34 563.67 374.73 564.18 380.55 563.36 380.63 563.57 383.08 560.31 383.38 558.08 383.54 556.83 381.61 556.65 379.34 556.51 377.88 556.28 375.42 557.1 375.34 Z"
          data-name="Butler"
          data-stusps="AL"
          id="1013"
        />
        <path
          className="white"
          d="M 552.36 351.38 553.11 351.14 554.5 349.56 555.33 349.51 557.57 346.76 559.96 345.45 559.92 345.04 560.48 344.99 560.55 345.81 562.19 345.66 562.37 347.76 563.03 348.39 562.87 349.5 561.37 350.69 560.77 351.93 561.09 353.35 560.79 353.65 560.81 354.93 559.25 354.13 554.94 354.48 554.99 354.89 553.51 354.09 552.51 352.9 552.36 351.38 Z"
          data-name="Shelby"
          data-stusps="AL"
          id="1117"
        />
        <path
          className="white"
          d="M 611.73 372.09 616.41 371.5 616.62 371.5 617.32 372.06 619.71 372.42 619.91 374.47 617.02 374.71 615.61 375.34 614.59 374.95 614.43 373.51 612.35 373.73 612.19 373.06 611.73 372.09 Z"
          data-name="Ben Hill"
          data-stusps="GA"
          id="13017"
        />
        <path
          className="white"
          d="M 599.03 341.4 599.62 340.77 600.55 338.81 600.6 337.03 602.74 338.27 604.42 339.02 604.63 339.38 604.74 339.85 604.77 340.72 604.97 341.44 602.7 342.66 602.25 344.04 601.36 343.19 601.12 342.72 600.68 342.05 598.9 341.62 599.03 341.4 Z"
          data-name="Newton"
          data-stusps="GA"
          id="13217"
        />
        <path
          className="white"
          d="M 618.24 353.8 620.43 352.56 621.07 353.26 624.9 351.75 626.04 352.64 626.44 352.71 625.58 354.28 626.22 354.96 624.31 356.5 624.91 357.33 623.62 357.87 623.04 356.03 620.91 355.37 619.69 354.46 618.19 354.79 618.24 353.8 Z"
          data-name="Johnson"
          data-stusps="GA"
          id="13167"
        />
        <path
          className="white"
          d="M 445.35 164.56 449.02 164.45 451.48 164.37 451.82 164.36 451.98 168.94 445.48 169.14 445.35 164.56 Z"
          data-name="Worth"
          data-stusps="IA"
          id="19195"
        />
        <path
          className="white"
          d="M 383.14 230.28 384.73 230.31 385.37 230.33 390.59 230.43 391.26 230.45 391.16 236.97 382.99 236.81 383.14 230.28 Z"
          data-name="Republic"
          data-stusps="KS"
          id="20157"
        />
        <path
          className="white"
          d="M 583.35 279.32 585.61 277.53 586.47 277.18 586.39 277.5 587.42 277.32 587.37 279.48 586.85 279.98 587.89 282.42 589.31 283.86 589.3 283.86 588.79 283.92 585.15 284.28 580.9 284.66 582.84 280.78 583.44 280.52 583.35 279.32 Z"
          data-name="McCreary"
          data-stusps="KY"
          id="21147"
        />
        <path
          className="white"
          d="M 444.72 383.26 451.71 383.1 451.76 385.55 453.41 385.52 453.5 388.81 455.12 388.78 455.2 392.03 452.72 392.09 451.92 393.75 450.43 393.79 450.19 395.51 449.41 395.57 449.38 395.57 449.17 394.13 448.16 393.37 448.25 391.98 447.76 390.99 446.91 390.25 447.28 389.58 446.28 389.17 445.5 388.08 445.78 387.39 445.96 385.92 445.13 383.98 444.72 383.26 Z"
          data-name="Sabine"
          data-stusps="LA"
          id="22085"
        />
        <path
          className="white"
          d="M 496.69 251.1 496.69 251.1 496.11 252.02 496.37 252.73 496.6 253.23 496.61 253.24 496.61 254.14 495.74 255.46 495.66 255.72 494.75 254.88 494.65 254.49 495.5 252.19 496.69 251.1 Z"
          data-name="St. Louis"
          data-stusps="MO"
          id="29189"
        />
        <path
          className="white"
          d="M 502.28 291.15 506.19 290.94 506.05 286.57 507.9 286.24 508.63 286.21 508.66 286.62 511.04 289.19 511.85 290.63 511.07 290.71 510.71 291.87 509.62 291.87 508.62 291.78 508.26 292.49 508.79 293.21 509.12 293.87 508.84 294.68 509.38 295.43 509.23 296.07 508.9 296.1 507.81 294.91 506 294.72 505.7 295.51 502.52 295.67 502.4 295.43 502.28 291.15 Z"
          data-name="New Madrid"
          data-stusps="MO"
          id="29143"
        />
        <path
          className="white"
          d="M 227.89 117.54 229.36 117.79 229.67 116.03 230.72 116.21 230.86 115.4 232.31 113.97 234.71 112.98 236.89 113.35 237.08 112.25 237.91 112.39 238.13 111.18 238.89 111.4 240.26 110.98 241.95 111.37 242.84 110.98 242.31 112.57 243.57 113.34 244.1 114.55 243.52 115.05 243.04 116.6 242.64 119.06 250.63 120.27 248.67 122.39 247.87 123.92 247.99 124.08 244.63 123.57 243.02 123.32 237.14 122.36 236.61 122.15 230.33 121.15 227.35 120.62 227.89 117.54 Z"
          data-name="Carbon"
          data-stusps="MT"
          id="30009"
        />
        <path
          className="white"
          d="M 723.74 176.54 724.67 176.79 724.7 176.73 724.61 176.5 724.69 176.22 724.71 176.1 724.81 176.02 724.92 175.83 725.11 175.75 725.53 175.33 725.58 175.24 725.72 175.3 725.73 175.25 725.82 175.29 725.79 175.43 725.81 175.44 726.03 175.72 725.81 176.6 725.76 177 725.75 177.09 725.73 177.3 725.68 177.72 725.65 177.97 725.65 177.98 725.46 178.43 725.43 178.51 725.28 178.86 724.24 179.24 724.39 178.77 724.44 178.61 724.64 178 724.55 177.86 724.4 177.31 723.66 177.33 723.74 176.54 Z"
          data-name="Hudson"
          data-stusps="NJ"
          id="34017"
        />
        <path
          className="white"
          d="M 642.08 304.44 642.62 304.16 642.15 302.07 642.57 300.42 643.31 300.11 642.7 299.43 642.73 298.36 642.56 297.74 643.11 297.15 645.04 297.02 645.62 298.95 646.92 299.82 647.57 301.24 648.71 301.72 649.56 302.09 646.61 305.95 645.64 306.72 644.46 305.53 644.4 305.47 643.86 304.93 642.38 306.37 642.04 305.87 642.23 304.89 642.08 304.44 Z"
          data-name="Mecklenburg"
          data-stusps="NC"
          id="37119"
        />
        <path
          className="white"
          d="M 83.54 71.42 83.74 71.59 84.44 71.24 86.89 71.13 87.5 70.91 87.79 70.81 88.36 70.98 89.19 72.22 89.42 72.3 90.12 75.94 89.8 76.61 87.88 76.64 87.14 77.64 85.79 81.08 86.51 82.8 85.46 83.74 82.46 82.75 82.84 81.9 81.09 79.84 79.41 78.95 80.07 77.33 80.87 77.53 82.59 76.22 83.85 74.28 83.05 73.12 83.54 71.42 Z"
          data-name="Sherman"
          data-stusps="OR"
          id="41055"
        />
        <path
          className="white"
          d="M 582.46 233.45 586.18 233.27 586.44 233.25 586.72 242.46 585.46 242.28 584.27 242.12 584.02 241.7 583.88 241.47 583.82 240.86 583.81 240.75 582.8 239.44 582.58 238.82 582.16 238.28 582.11 235.34 582.24 235.1 581.68 234.46 582.46 233.45 Z"
          data-name="Clermont"
          data-stusps="OH"
          id="39025"
        />
        <path
          className="white"
          d="M 546.57 394.45 547.86 394.35 549.38 394.22 551.22 394.08 553.63 393.88 551.74 395.42 551.42 396.92 551.78 399.32 552.33 399.42 552.65 401.3 553.53 402.29 555.06 403.27 554.68 404.9 553.42 405.8 553.56 406.75 552.93 406.88 552.08 406.9 550.47 407.41 548.89 407.84 549.88 406.57 550.13 405.43 551.14 404.72 550.33 404.39 549.77 403.48 549.93 402.66 550.34 401.6 550.28 400.61 549.55 399.99 548.16 399.23 547.81 398.71 546.17 396.97 546.75 395.3 546.57 394.45 546.57 394.45 Z"
          data-name="Escambia"
          data-stusps="FL"
          id="12033"
        />
        <path
          className="white"
          d="M 638.69 344.76 639.7 343.29 642.66 343.84 645.37 343.25 647.05 344.37 647.39 344.75 645.15 346.74 645.03 348.71 643.98 350.23 642.85 350.85 642.5 349.22 641.63 348.05 640.94 347.26 640.71 345.91 639.96 345.45 638.94 344.81 638.69 344.76 Z"
          data-name="Allendale"
          data-stusps="SC"
          id="45005"
        />
        <path
          className="white"
          d="M 541.59 337.96 548.17 337.57 548.89 337.3 549.21 337.5 550.3 339.36 552.37 339.78 552.59 340.58 551.82 341.18 551.21 343.71 549.37 344.68 549.36 345.77 548.05 346.38 548.15 346.69 547.34 346.73 547.22 345.35 546.39 345.43 545.54 345.21 545.4 343.58 543.75 343.66 543.43 340.36 541.79 340.41 541.72 339.59 541.59 337.96 Z"
          data-name="Walker"
          data-stusps="AL"
          id="1127"
        />
        <path
          className="white"
          d="M 514.65 185.96 517.37 185.72 517.92 185.67 519.28 185.55 519.55 185.52 519.65 186.68 519.34 187.19 519.43 188.15 519.49 188.7 519.64 190.34 519.66 190.65 519.78 191.97 519.78 191.97 519.93 193.62 518.34 193.79 517.93 193.84 515.16 194.12 514.69 188.52 514.79 187.59 514.65 185.96 Z"
          data-name="Kane"
          data-stusps="IL"
          id="17089"
        />
        <path
          className="white"
          d="M 510.56 196.23 512.25 196.03 513.74 195.93 515.29 195.78 515.66 199.05 516.35 205.59 511.45 206.03 511.71 209.38 510.06 209.54 509.8 206.18 508.17 206.32 507.85 202.45 507.41 197.29 507.33 196.48 510.56 196.23 Z"
          data-name="LaSalle"
          data-stusps="IL"
          id="17099"
        />
        <path
          className="white"
          d="M 557.65 197.87 559.34 198.22 562.6 197.86 562.36 199.51 562.8 202.78 558.42 203.36 557.74 202.59 557.42 200.12 557.9 200.06 557.65 197.87 Z"
          data-name="Whitley"
          data-stusps="IN"
          id="18183"
        />
        <path
          className="white"
          d="M 432.61 175.95 439.12 175.83 439.23 180.77 432.69 180.89 432.61 175.95 Z"
          data-name="Humboldt"
          data-stusps="IA"
          id="19091"
        />
        <path
          className="white"
          d="M 569.06 264.5 570.97 261.69 571.77 261.98 572.42 260.93 572.77 260.52 574.26 260.83 574.27 261.02 574.79 261.47 574.81 264.83 574.82 265.1 574.84 265.73 572.8 265.97 570.01 265.82 569.06 264.5 Z"
          data-name="Washington"
          data-stusps="KY"
          id="21229"
        />
        <path
          className="white"
          d="M 604.01 266.37 604.24 264.07 606.4 264.15 606.79 264.41 608.25 264.59 608.33 265.59 609.4 265.23 610.56 267.76 610.26 268.07 608.96 268.3 606.8 270.45 606.42 270.06 605.3 269.28 604.41 269.56 604.01 266.37 Z"
          data-name="Knott"
          data-stusps="KY"
          id="21119"
        />
        <path
          className="white"
          d="M 521 387.94 524.26 387.74 525.91 387.63 526.43 395.66 526.55 395.82 526.65 397.46 525.83 397.51 521.73 397.78 521.49 396.08 521 387.94 Z"
          data-name="Perry"
          data-stusps="MS"
          id="28111"
        />
        <path
          className="white"
          d="M 512.1 255.15 511.86 250.76 511.74 249.11 518.25 248.57 518.53 252.71 518.71 255.18 512.13 255.69 512.1 255.15 Z"
          data-name="Marion"
          data-stusps="IL"
          id="17121"
        />
        <path
          className="white"
          d="M 568.73 250.01 569.23 249.88 570.68 248.01 572.04 247.63 573.67 249.04 574.04 250.44 574.75 249.92 575.6 251.79 575.03 251.51 573.76 252.41 569.48 252.49 568.33 250.68 568.73 250.01 Z"
          data-name="Henry"
          data-stusps="KY"
          id="21103"
        />
        <path
          className="white"
          d="M 584.96 256.18 587.91 254.88 590.06 258.13 589.3 259.41 589.75 259.96 588.7 260.37 588.55 259.82 585.79 259.73 585.52 258.97 584.61 259.57 584.42 259.47 585.13 257.07 584.96 256.18 Z"
          data-name="Clark"
          data-stusps="KY"
          id="21049"
        />
        <path
          className="white"
          d="M 577.54 251.64 578.01 251.24 579.63 249.07 579.93 248.66 581.38 250.25 582.23 252.07 582.12 252.39 582.62 253.65 582.91 253.74 579.99 255.52 579.8 255.87 579.32 254.78 578.13 254.57 577.99 254.18 577.54 251.64 Z"
          data-name="Scott"
          data-stusps="KY"
          id="21209"
        />
        <path
          className="white"
          d="M 443.93 122.62 448.83 122.53 448.93 125.77 450.51 125.74 450.65 128.47 444.15 128.62 444.07 125.91 443.93 122.62 Z"
          data-name="Isanti"
          data-stusps="MN"
          id="27059"
        />
        <path
          className="white"
          d="M 555.58 235.26 557.53 234.98 561.43 234.5 561.86 238.62 560.21 238.85 560.35 239.98 559.5 240.6 556.26 240.78 556.22 240.22 555.58 235.26 Z"
          data-name="Bartholomew"
          data-stusps="IN"
          id="18005"
        />
        <path
          className="white"
          d="M 439.51 259.54 439.47 259.19 439.49 257.29 447.64 257.32 447.64 258.14 447.62 263.86 447.13 263.99 439.83 263.91 439.45 263.89 439.51 259.54 Z"
          data-name="Henry"
          data-stusps="MO"
          id="29083"
        />
        <path
          className="white"
          d="M 523.8 380.39 524.33 380.32 525.94 380.1 528.87 379.46 531.33 378.59 531.47 380.53 531.67 382.27 531.83 383.7 532.23 387.18 525.91 387.63 524.26 387.74 523.8 380.39 Z"
          data-name="Wayne"
          data-stusps="MS"
          id="28153"
        />
        <path
          className="white"
          d="M 469 383.54 469.35 383.22 469.73 381.06 474.64 380.9 474.99 392.18 474.69 391.87 473.72 392.04 473.94 391.85 471.87 389.43 470.55 389.13 470.57 388.38 469.29 386.76 469 383.54 Z"
          data-name="LaSalle"
          data-stusps="LA"
          id="22059"
        />
        <path
          className="white"
          d="M 625.84 291.12 626.4 290.27 627.93 290.78 629.67 292.2 632.32 293.7 635.31 293.44 634.5 295.3 633.22 297.61 633.2 297.69 632.76 297.87 630.77 297.74 629.73 297.25 628.74 298.14 627.64 295.5 625.59 294.11 626.62 292.49 625.84 291.12 Z"
          data-name="Burke"
          data-stusps="NC"
          id="37023"
        />
        <path
          className="white"
          d="M 577.26 213.39 578.58 212.74 578.32 210.83 583.15 210.14 583.57 213.34 583.51 214.11 583.62 215.81 580.75 215.88 577.67 216.35 577.26 213.39 577.26 213.39 Z"
          data-name="Shelby"
          data-stusps="OH"
          id="39149"
        />
        <path
          className="white"
          d="M 609.58 202.68 616.42 201.58 616.53 202.21 616.83 205.85 616.26 205.92 609.38 206.8 609.12 204.59 608.53 204.78 608.22 202.91 609.58 202.68 Z"
          data-name="Holmes"
          data-stusps="OH"
          id="39075"
        />
        <path
          className="white"
          d="M 690.34 174.28 690.44 172.93 694.07 171.94 694.56 171.71 696.59 170.47 699.06 171.62 700.32 174.36 701.13 174.68 700.61 175.59 699.95 175.57 699.06 176.55 699.95 178.03 696.72 180.61 696.57 180.73 696.19 181.04 693.4 180.75 692.26 177.25 691.6 177.54 690.64 176.18 690.34 174.28 Z"
          data-name="Luzerne"
          data-stusps="PA"
          id="42079"
        />
        <path
          className="white"
          d="M 632.26 310.42 636.01 310.77 636.47 311.23 636.19 311.62 636.62 312.12 636.35 313.09 637.69 315.03 637.76 316.22 637.8 317.03 637.96 317.69 636.24 318.89 634.4 317.44 633.8 317.06 630.97 316.75 631.39 312.01 632.26 310.42 Z"
          data-name="Union"
          data-stusps="SC"
          id="45087"
        />
        <path
          className="white"
          d="M 662.18 247.62 663.51 246.86 664.5 247.38 665.79 245.77 666.4 243.77 669.69 248.36 670.11 249.4 670.46 249.17 670.67 250.1 670.09 249.96 669.38 251.37 668.13 251.62 668.37 253.11 667.74 253.43 667.26 253.42 665.44 250.85 664.13 250.61 663.86 249.52 662.74 249.02 662.26 249.33 662.5 248.25 662.18 247.62 Z"
          data-name="Nelson"
          data-stusps="VA"
          id="51125"
        />
        <path
          className="white"
          d="M 86.7 42.6 86.7 42.6 87.97 43.02 89.76 45.67 90.05 47.42 95.05 49.11 94.52 50.71 96.11 51.27 95.55 52.88 102.41 55.16 102.7 57.29 103.02 57.6 99.6 68.57 87.46 64.59 78.12 61.35 80.35 54.95 82.01 55.49 82.02 53.13 84.6 49.69 83.77 47.9 83.49 45.95 84.67 45.3 86.7 42.6 Z"
          data-name="Yakima"
          data-stusps="WA"
          id="53077"
        />
        <path
          className="white"
          d="M 579.6 242.98 581.25 242.49 581.68 242.33 583.82 240.86 583.88 241.47 584.02 241.7 585.02 246.08 584.93 246.32 582.09 247.09 581.45 247.77 581.01 247.57 579.6 242.98 Z"
          data-name="Pendleton"
          data-stusps="KY"
          id="21191"
        />
        <path
          className="white"
          d="M 351.03 209.47 362.37 210 362.1 216.5 362.21 217.05 361.82 216.9 358.99 216.65 358.2 216.33 354.16 216.15 350.71 215.97 351.03 209.47 Z"
          data-name="Dawson"
          data-stusps="NE"
          id="31047"
        />
        <path
          className="white"
          d="M 132.06 137.26 136.03 138.24 137.27 133.52 138.33 129.26 139.69 129.61 140.99 128.99 142.48 128.83 143.76 127.89 144.53 126.69 145.12 126.95 146.08 125.35 149.32 125.13 151.16 122.93 150.84 122.26 151.46 122.57 151.59 124.73 152.33 125.75 153.41 125.85 153.62 126.12 153.17 126.49 153.02 127.56 151.78 129.51 151.33 131.92 150.59 132.03 148.71 139.66 147.43 144.99 148.1 145.2 147.46 147.9 141.68 146.53 142.6 143.5 140.2 142.43 138.07 142.24 137.95 141.54 136.1 140.49 135.42 141.48 133.25 139.54 132.64 138.68 132.94 138.08 132.06 137.26 Z"
          data-name="Elmore"
          data-stusps="ID"
          id="16039"
        />
        <path
          className="white"
          d="M 570.25 154.77 572.94 154.08 572.74 152.45 574.36 152.24 574.46 153.06 576.31 152.82 577.67 152.63 577.78 153.44 579.41 153.2 579.65 154.82 580.16 158.04 576.92 158.53 577.2 160.17 571.17 161.11 570.25 154.77 Z"
          data-name="Saginaw"
          data-stusps="MI"
          id="26145"
        />
        <path
          className="white"
          d="M 547.47 261.72 547.64 261.34 548.07 261.62 547.3 258.95 547.41 257.76 547.32 256.93 548.96 256.5 550.58 256.28 550.67 257.39 552.32 257.23 552.33 257.33 552.48 258.85 552.95 259.44 552.94 259.45 552.46 260.27 552.22 260.34 551.73 260.49 551.81 261.82 552.17 263.02 550.82 263.09 550.69 264.12 550.2 263.94 550.01 263.88 549.02 263.53 548.04 262.42 547.5 261.7 547.47 261.72 Z"
          data-name="Perry"
          data-stusps="IN"
          id="18123"
        />
        <path
          className="white"
          d="M 553.63 393.88 553.65 393.88 557.46 393.6 559.02 393.48 559.77 393.42 560.48 404.98 559.65 405.11 558.56 405.43 554.75 406.51 553.56 406.75 553.42 405.8 554.68 404.9 555.06 403.27 553.53 402.29 552.65 401.3 552.33 399.42 551.78 399.32 551.42 396.92 551.74 395.42 553.63 393.88 Z"
          data-name="Santa Rosa"
          data-stusps="FL"
          id="12113"
        />
        <path
          className="white"
          d="M 500.89 330.32 508.31 329.89 508.72 336.68 508.75 337.22 505.47 337.4 505.05 337.52 502.29 337.66 502.19 335.69 501.23 335.06 500.94 331.13 500.89 330.32 Z"
          data-name="Panola"
          data-stusps="MS"
          id="28107"
        />
        <path
          className="white"
          d="M 481.34 397.97 482.4 397.09 481.82 396.33 481.35 395.49 481.81 394.44 483.43 393.74 483.69 391.97 486.27 391.09 488.67 391.26 489.33 391.72 489.7 391.7 490.31 392.4 490.53 397.71 488.65 397.79 487.88 397.82 481.2 398.08 481.34 397.97 Z"
          data-name="Wilkinson"
          data-stusps="MS"
          id="28157"
        />
        <path
          className="white"
          d="M 604.62 257.55 605.6 258.65 605.95 260.11 607.36 263.4 606.79 264.41 606.4 264.15 605.23 262.77 603.94 262.01 603.33 262.58 601.46 261.63 601.14 260.85 600.89 259.86 602.98 257.68 602.66 257.14 604.62 257.55 Z"
          data-name="Magoffin"
          data-stusps="KY"
          id="21153"
        />
        <path
          className="white"
          d="M 352.27 117.35 354.96 117.51 356.82 117.63 360.38 117.83 360.39 117.83 362.51 117.95 362.2 124.47 352.8 123.95 353.17 122.93 354.5 122.26 353.66 118.83 352.27 117.35 Z"
          data-name="Campbell"
          data-stusps="SD"
          id="46021"
        />
        <path
          className="white"
          d="M 568.92 297.2 570.88 295.72 574.02 296.34 574.82 297.25 575.28 298.46 575.43 300.63 575.12 300.76 575.13 300.21 572.71 300.62 571.91 300.55 571.56 300.9 571.27 300.75 571.14 300.93 571.28 301.2 570.91 301.14 570.04 301.06 569.99 301.28 569.68 301.19 568.71 300.73 569.44 300.34 568.72 298.05 568.92 297.2 Z"
          data-name="White"
          data-stusps="TN"
          id="47185"
        />
        <path
          className="white"
          d="M 273.34 156.46 274.17 156.55 287 157.99 289.47 158.24 288.02 171.71 287.75 174.98 282.27 174.44 281.94 177.72 281.26 177.65 280.36 180.23 278.25 180.02 277.07 179.58 277.76 178.27 278.15 177.31 270.95 176.4 270.91 176.4 271.69 169.92 273.35 156.88 273.34 156.46 Z"
          data-name="Converse"
          data-stusps="WY"
          id="56009"
        />
        <path
          className="white"
          d="M 583.89 315.16 584.42 315.1 585.17 315.02 586.82 314.83 587.04 316.96 587.15 317.33 587.16 318.68 586.82 319.78 587.17 322.53 586.14 321.89 583.85 322.41 583.02 322.01 582.45 321.26 583.63 320.55 583.26 319.21 583.99 317.27 583.89 315.16 Z"
          data-name="Murray"
          data-stusps="GA"
          id="13213"
        />
        <path
          className="white"
          d="M 146.58 43.48 151.67 44.94 153.36 45.13 152.83 47.01 155.03 47.62 152.58 56.49 149.32 55.58 148.56 56.24 143.32 54.87 145.28 47.99 146.58 43.48 Z"
          data-name="Kootenai"
          data-stusps="ID"
          id="16055"
        />
        <path
          className="white"
          d="M 686.93 249.45 687.74 248.56 687.76 248.57 687.91 248.65 688.03 248.72 688.03 248.71 688.06 248.71 688.07 248.69 688.3 248.78 688.37 248.63 688.42 248.67 688.57 248.77 688.7 248.64 688.67 248.61 688.67 248.58 688.6 248.51 688.58 248.49 688.57 248.49 688.55 248.43 688.55 248.39 688.56 248.29 688.54 248.27 688.56 248.27 688.65 248.26 688.68 248.25 688.72 248.23 688.73 248.28 688.9 248.23 688.87 248.15 688.98 248.1 688.99 248.12 689.05 248.12 689.15 248.15 689.15 248.15 690.18 249.2 689.99 250.97 686.99 249.85 686.93 249.45 Z"
          data-name="Richmond"
          data-stusps="VA"
          id="51159"
        />
        <path
          className="white"
          d="M 670.46 249.17 672.55 248.18 672.52 247.52 673.08 248.15 676.7 248.81 676.76 249.88 674.57 256.12 673.91 256.44 672.4 255.38 671.91 255.74 671.72 255.15 668.37 253.11 668.13 251.62 669.38 251.37 670.09 249.96 670.67 250.1 670.46 249.17 Z"
          data-name="Buckingham"
          data-stusps="VA"
          id="51029"
        />
        <path
          className="white"
          d="M 663.67 214.93 664.66 215.01 666.47 214.73 666.81 215.04 668.47 215.51 668.83 216.56 669 217.62 668.38 219.25 668.48 219.99 668.32 221.02 668.65 221.52 667.52 223.12 666.58 222.46 665.71 222.89 660.03 221.65 661.58 219.52 662.38 217.08 663.67 214.93 Z"
          data-name="Hampshire"
          data-stusps="WV"
          id="54027"
        />
        <path
          className="white"
          d="M 514.57 114.61 514.59 114.62 515.22 115.44 514.52 116.53 514.95 116.92 515.61 117.12 515.71 118.47 510.88 118.76 507.59 119.05 506.99 113.59 507.05 113.6 507.37 114.03 507.95 113.95 508.16 113.47 509.03 113.28 510.63 113.91 511 113.65 511.98 114.17 512.8 114.02 513.73 114.23 514.57 114.61 Z"
          data-name="Florence"
          data-stusps="WI"
          id="55037"
        />
        <path
          className="white"
          d="M 130.2 17.76 137.99 20.22 137.33 21.3 137.09 23.18 137.52 24.6 137.13 27 135.82 29.29 134.84 30.01 134.36 32.93 134.44 34.16 133.52 34.84 133.25 35.83 132.4 36.09 132.19 37.43 131.53 37.73 129.9 37.47 130.22 38.72 129.87 40.19 129.17 41.23 127.28 39.6 127.23 38.6 125.81 37.95 125.29 38.59 123.86 37.02 123.97 36.95 127.04 27.34 126.72 27.24 127.74 24.05 128.14 24.18 130.2 17.76 Z"
          data-name="Ferry"
          data-stusps="WA"
          id="53019"
        />
        <path
          className="white"
          d="M 592.55 352.74 593.09 352.24 596.6 351.9 598.95 351.67 599.06 352.75 599.22 354.32 599.32 355.23 598.31 357.47 597.67 356.62 596.85 356.53 595.28 356.1 593.05 354.38 592.67 353.81 592.49 352.94 592.55 352.74 Z"
          data-name="Upson"
          data-stusps="GA"
          id="13293"
        />
        <path
          className="white"
          d="M 495.28 313.92 498.59 313.8 500.85 313.7 501.3 314.18 501.73 315.03 501.27 316.17 500.62 316.77 501.7 317.17 501.82 318.04 501.77 318.78 501.96 319.64 500.88 319.5 500.59 320.22 500.39 321 499.35 321.25 498.81 321.5 498.71 322.13 499.78 323.16 499.72 323.74 498.81 324.44 498.78 324.46 497.45 325.22 497.35 325.22 497.27 323.93 497.15 319.34 495.57 319.5 495.48 318.86 495.28 313.92 Z"
          data-name="Crittenden"
          data-stusps="AR"
          id="5035"
        />
        <path
          className="white"
          d="M 553.93 156.88 560.47 156.09 563.74 155.66 564.73 162.16 559.82 162.79 558.18 163.01 557.98 161.37 557.77 159.72 554.33 160.15 553.93 156.88 Z"
          data-name="Montcalm"
          data-stusps="MI"
          id="26117"
        />
        <path
          className="white"
          d="M 547.45 132.78 550.08 132.45 550.32 127.6 550.91 128.54 551.47 128.14 551.99 127.58 551.81 130.61 553.03 130.45 553.81 131.25 554.53 136.88 548.02 137.69 547.45 132.78 Z"
          data-name="Grand Traverse"
          data-stusps="MI"
          id="26055"
        />
        <path
          className="white"
          d="M 408.79 96.45 410.42 96.44 417.03 96.45 421.93 96.4 422.07 102.93 422.07 104.56 420.98 104.6 409.01 104.59 409.04 99.71 408.79 96.45 Z"
          data-name="Becker"
          data-stusps="MN"
          id="27005"
        />
        <path
          className="white"
          d="M 405 158.41 405 158.41 410.28 158.45 410.45 158.45 410.42 165 408.43 164.99 404.95 164.97 404.96 163.99 405 158.41 Z"
          data-name="Rock"
          data-stusps="MN"
          id="27133"
        />
        <path
          className="white"
          d="M 405.11 140.47 413.21 140.5 413.23 138.88 414.7 138.89 414.71 138.05 417.9 140.79 418.11 141.49 419.01 141.82 419.76 142.49 419.77 145.43 416.62 145.44 416.5 143.79 409.94 143.78 405.1 143.74 405.11 140.47 Z"
          data-name="Yellow Medicine"
          data-stusps="MN"
          id="27173"
        />
        <path
          className="white"
          d="M 484.95 249.93 488.6 249.13 489.24 248.49 489.32 248.76 490.27 249.56 490.86 249.6 491.63 248.81 492.05 247.82 492.3 247.81 493.11 247.79 494.57 248.39 494.9 248.45 495.59 248.57 495.94 248.77 497.38 249.62 497.37 250.44 496.2 250.22 494.3 249.02 493.46 250.37 492.6 250.32 492.06 251.54 491.93 251.78 491.31 253.04 489.32 253.24 488.51 254.1 488.37 254.19 487.95 254.97 485.9 256.21 485.18 256.01 484.95 249.93 Z"
          data-name="St. Charles"
          data-stusps="MO"
          id="29183"
        />
        <path
          className="white"
          d="M 610.43 256.34 610.7 254.86 612.26 254.93 612.2 255.36 613.35 256.05 613.74 256.56 614.28 257.27 615.02 257.92 615.17 258.22 613.88 259.05 614.13 259.81 611.7 259.9 611.47 259.75 610.44 259.4 609.63 256.98 610.43 256.34 Z"
          data-name="Martin"
          data-stusps="KY"
          id="21159"
        />
        <path
          className="white"
          d="M 384.16 434.53 388.78 430.75 390.36 429.47 394.64 434.77 389.16 439.2 387.34 438.03 384.71 440.09 381.79 436.42 384.16 434.53 Z"
          data-name="DeWitt"
          data-stusps="TX"
          id="48123"
        />
        <path
          className="white"
          d="M 333.88 294.15 335.86 294.25 336.93 294.3 341.34 294.53 342.05 294.57 341.63 302.88 333.42 302.44 333.88 294.15 Z"
          data-name="Ochiltree"
          data-stusps="TX"
          id="48357"
        />
        <path
          className="white"
          d="M 650.12 252.57 649.93 252.11 649.98 251.32 650.32 251.46 650.2 251.91 650.48 252.33 650.12 252.57 Z"
          data-name="Covington"
          data-stusps="VA"
          id="51580"
        />
        <path
          className="white"
          d="M 608.98 273.97 609.71 273.23 610.65 272.77 610.99 272.07 610.78 271.07 612.99 269.13 613.09 269.05 613.15 269 613.47 270.43 614.94 272.2 616.72 273.23 617.2 272.87 617.82 274.03 616.26 274.82 616.17 274.67 613.04 275.2 610.92 277.05 609.65 276.31 608.96 275.45 609.18 274.96 608.98 273.97 Z M 612.61 273.88 612.38 274.58 613.02 274.73 612.86 274.33 613.29 273.81 612.61 273.88 Z"
          data-name="Wise"
          data-stusps="VA"
          fillRule="evenodd"
          id="51195"
        />
        <path
          className="white"
          d="M 580.61 300.75 582.24 299.4 582.54 299.33 583.11 300.61 583.59 300.59 583.74 301.78 582.87 302.18 582.93 304.49 581.71 304.67 582.04 305.65 581.35 306.76 580.42 306.41 579.81 307.58 578.45 307.36 577.94 306.85 577.64 306.25 578.07 304.67 580.61 300.75 Z"
          data-name="Rhea"
          data-stusps="TN"
          id="47143"
        />
        <path
          className="white"
          d="M 512.55 304.6 513.5 304.43 514.76 302.21 515.6 302.75 516.14 304.71 519.19 305.72 519.56 305.95 517.76 308.2 516.98 307.85 512.73 306.32 512.43 305.8 512.63 304.95 512.55 304.6 Z"
          data-name="Crockett"
          data-stusps="TN"
          id="47033"
        />
        <path
          className="white"
          d="M 489.87 300.88 489.8 298.68 497.22 298.42 497.26 299.52 499.27 299.44 498.81 299.73 498.63 300.59 497.76 301.14 497.14 302.42 496.75 303.41 496.5 304.01 489.4 304.33 489.79 302.19 490.82 300.84 489.87 300.88 Z"
          data-name="Greene"
          data-stusps="AR"
          id="5055"
        />
        <path
          className="white"
          d="M 52.25 312.32 54.11 312.33 55.61 314.26 56.72 315.69 55.86 316.56 55.15 315.97 53.7 315.52 53.62 314.61 52.6 313.06 52.25 312.32 Z M 50.33 320.64 50.97 321.9 52.11 323.9 53.31 325.66 52.04 325.81 51.22 324.73 50.08 322.7 49.48 320.83 50.33 320.64 Z M 53.7 285.77 53.61 285.15 62.63 287.28 71.39 289.25 73.08 289.65 71.42 297.86 71.09 299.97 70.07 302.2 69.61 303.02 69.32 303.49 69.15 303.77 68.36 304.79 67.98 304.72 67.23 305.44 67.41 306.07 65.23 305.55 64.47 305.41 64.12 306.2 63.13 306.72 62.55 306.99 62.39 307.4 61.74 308.02 61.2 308.76 60.96 308.51 60.06 308.65 59.19 308.88 58.71 309 57.81 308.61 57.59 308.39 57.29 308.1 56.63 307.87 56.29 307.01 56.97 306.56 57.03 304.96 56.65 303.14 55.96 301.8 54.67 301.26 53.42 301.08 52.37 300.86 51.26 301.22 50.62 300.4 49.23 299.81 49.42 299.28 51.01 298.61 52.28 298.07 53.33 298.32 53.81 298.42 54.36 297.93 54.54 297.21 55.24 296.71 55.18 295.6 54.61 291.89 53.7 285.77 Z"
          data-name="Los Angeles"
          data-stusps="CA"
          fillRule="evenodd"
          id="6037"
        />
        <path
          className="white"
          d="M 249.98 201.05 256.5 201.94 256.43 203.38 256.84 203.3 257.91 204.61 258.64 204.37 259.07 205.17 259.19 206.32 257.79 209.45 258.26 211.83 258.16 212.77 257.92 214.63 258.21 214.75 257.35 221.13 257.33 222.6 257.31 222.72 256.88 222.64 251.41 221.98 251.64 220.4 251.77 218.72 252.08 216.2 246.29 215.49 247.24 209.51 249.03 208.63 249.98 201.05 Z"
          data-name="Routt"
          data-stusps="CO"
          id="8107"
        />
        <path
          className="white"
          d="M 576.19 333.29 578.72 332.65 582.03 332.38 582.06 332.64 584.01 332.43 583.4 335 582.28 335.1 582.37 336.01 579.82 336.38 577.08 336.61 576.77 335.45 576.19 333.29 Z"
          data-name="Polk"
          data-stusps="GA"
          id="13233"
        />
        <path
          className="white"
          d="M 519.84 271.64 524.26 271.29 524.48 274.64 524.44 274.63 523.76 275.09 523.54 276.26 523.19 277.21 523.94 278.49 524.75 279.75 524.53 280.74 524.1 281.35 523.98 281.36 523.88 281.37 523.75 279.65 520.18 276.57 519.84 271.64 Z"
          data-name="Pope"
          data-stusps="IL"
          id="17151"
        />
        <path
          className="white"
          d="M 576.01 280.34 577.45 279.08 577.58 278.23 579.16 277.33 580.24 277.96 581.57 277.36 583.35 279.32 583.44 280.52 582.84 280.78 580.9 284.66 580.79 284.67 580.79 284.67 578.36 284.77 577.89 284.79 577.5 284.65 577.14 282.17 576.01 280.34 Z"
          data-name="Wayne"
          data-stusps="KY"
          id="21231"
        />
        <path
          className="white"
          d="M 18.34 233.87 20.47 233.04 21.19 233.78 21.59 235.08 23.23 237.89 22.76 238.57 24.38 239.81 24.66 240.68 24.18 242.77 25.25 242.99 25.71 244.39 27.43 247.39 27.29 248.68 29.23 248.16 29.99 248.76 31.14 250.91 31.77 251.23 32.12 250.02 31.74 248.91 32.76 250.04 33.23 251.49 32.26 252.57 35.04 256.82 36.56 258.5 37.17 258.69 37.54 261.19 29.14 258.89 19.79 256.24 19.12 255.02 18.47 253.99 18.56 252.25 18.08 251.2 17.47 250.8 17.14 249.16 16.59 247.62 15.38 245.99 14.73 245.5 14.1 244.05 14.38 242.24 14.3 240.29 14.4 238.29 15.41 237.51 16.26 238.24 17.38 237.07 18.18 235.33 18.47 234.63 18.34 233.87 Z"
          data-name="Monterey"
          data-stusps="CA"
          id="6053"
        />
        <path
          className="white"
          d="M 591.56 395.97 592.64 394.15 593.04 389 594.42 388.66 596.09 388.5 596.65 388.45 598.79 388.22 599.49 395.6 597.95 395.69 592.39 395.93 591.56 395.97 Z"
          data-name="Decatur"
          data-stusps="GA"
          id="13087"
        />
        <path
          className="white"
          d="M 472.11 214.03 476.52 213.83 479.49 215.54 480.79 215.74 480.78 216.24 479.89 216.94 479.87 216.96 479 216.98 477.71 217.52 477.24 218.12 477 219.04 477.4 219.47 477.28 220.58 477.44 221.57 476.79 221.99 475.64 221.6 475.31 221.04 474.64 220.54 473.96 219.84 473.78 219.11 473.02 218.93 472.79 218.41 472.32 217.97 472.11 214.03 Z"
          data-name="Lee"
          data-stusps="IA"
          id="19111"
        />
        <path
          className="white"
          d="M 365.89 277.31 374.09 277.55 374.04 279.18 375.76 279.23 375.61 286.47 375.51 286.47 372.64 286.38 368.92 286.25 365.78 286.15 366 279.1 365.86 278.93 365.89 277.31 Z"
          data-name="Barber"
          data-stusps="KS"
          id="20007"
        />
        <path
          className="white"
          d="M 321.51 260.17 328.58 260.62 328.95 260.64 328.44 268.82 328.57 270.55 320.9 270.01 321.33 262.98 321.51 260.17 Z"
          data-name="Hamilton"
          data-stusps="KS"
          id="20075"
        />
        <path
          className="white"
          d="M 781.61 57.01 780.31 57.48 778.69 58.95 776.17 60.64 774.42 61.96 774.07 61.92 771.63 55.14 770.83 53.36 768.48 47.06 764.92 48.11 763.47 48.64 762.23 45.37 750.7 49.52 746.84 50.9 746.37 48.52 747.47 44.38 749 38.6 749.77 35.7 751.12 30.86 751.96 30.68 752.67 30.73 753.62 30.67 753.75 31.55 754.83 33.94 755.98 34.2 757.04 34.52 758.01 33.37 759.44 32.27 760.29 31.81 760.26 31.14 761.18 30.47 761.85 30.44 762.87 29.92 762.51 29.33 762.6 28.69 763.76 28.28 764.68 28.22 765.51 28.45 766.69 28.89 768.15 29.47 768.88 29.65 770.23 30.77 771.87 31.26 773.82 36.27 775.22 39.83 777.61 45.77 779.35 50.23 780.07 52.09 780.6 52.32 780.25 53.48 781.05 54.01 780.87 55.11 781.51 55.94 781.61 57.01 Z"
          data-name="Aroostook"
          data-stusps="ME"
          id="23003"
        />
        <path
          className="white"
          d="M 762.76 135.15 763.49 135.15 763.62 135.22 763.71 135.68 763.27 136.32 763 136.15 762.67 135.71 762.76 135.15 Z M 754.38 139.97 755.32 139.23 755.49 138.91 755.79 138.74 756.01 138.57 755.87 138.48 755.85 138.35 756 138.3 755.92 138.11 756.03 137.89 755.9 137.63 756.31 137.5 755.59 136.37 756.31 135.85 756.9 135.82 757.68 136.36 757.73 136.39 758.46 136.68 758.85 137.14 759.14 136.24 759.64 135.86 759.64 135.29 760.28 134.94 760.9 135.67 761.08 135.32 761.52 135.04 762.15 137.57 761.96 137.75 761.86 137.85 761.01 138.72 760.55 139.19 760.32 139.41 759.64 140.1 759.28 140.45 757.87 141.84 757.1 142.59 756.73 142.8 756.54 142.16 755.47 142.52 754.91 142.71 754.63 141.79 754.39 141.07 754.52 140.45 754.38 139.97 Z"
          data-name="Norfolk"
          data-stusps="MA"
          fillRule="evenodd"
          id="25021"
        />
        <path
          className="white"
          d="M 526.47 102.3 528.24 101.72 529.31 102.74 530.55 102.91 531.28 102.27 531.82 100.76 532.75 101.06 533.75 101.82 534.88 100.46 538.16 98.12 538.76 97.68 540.61 97.44 542.26 96.98 542.7 100.39 536.21 101.18 536.61 104.44 533.35 104.8 533.73 108.08 527.2 108.82 526.47 102.3 Z"
          data-name="Alger"
          data-stusps="MI"
          id="26003"
        />
        <path
          className="white"
          d="M 450.19 395.51 450.43 393.79 451.92 393.75 452.72 392.09 455.2 392.03 459.14 392.01 459.31 392.26 459.6 392.52 460.96 392.77 461.81 393.97 462.08 400.72 461.86 401 459.58 401.04 452.34 401.13 451.51 401.58 450.27 401.27 450.64 400.38 450.31 399.59 450.47 398.81 450.58 398 450.41 396.55 450.47 395.49 450.19 395.51 Z"
          data-name="Vernon"
          data-stusps="LA"
          id="22115"
        />
        <path
          className="white"
          d="M 725.73 177.3 726.69 177.13 726.71 177.05 726.65 176.78 727.31 177.01 727.32 177.02 728.07 177.33 728.21 177.22 728.34 177.46 728.75 178.11 729.42 179.3 727.92 180.37 727.35 180.15 727.05 180.04 726.31 179.86 726.29 179.85 726.17 179.61 725.83 179.21 725.72 178.75 725.43 178.51 725.46 178.43 725.65 177.98 725.65 177.97 725.68 177.72 725.73 177.3 Z"
          data-name="Kings"
          data-stusps="NY"
          id="36047"
        />
        <path
          className="white"
          d="M 262.54 298.39 264.82 298.72 265.47 298.04 267.38 295.97 267.74 294.01 268.83 293.64 276.09 294.35 276.01 295.17 282.56 295.76 282.72 297.57 283.79 300.76 282.66 302.61 282.83 304.11 277 303.51 272.86 303.39 272.74 303.66 271.53 302.53 268 301 262.29 300.42 262.54 298.39 Z"
          data-name="Mora"
          data-stusps="NM"
          id="35033"
        />
        <path
          className="white"
          d="M 423.98 340.18 424.05 338.55 425.68 338.54 425.64 333.6 427.34 333.59 434.73 333.5 434.7 336.27 434.67 339.45 434.64 342.64 434.62 344.12 434.59 346.97 434.56 349.8 433.89 350.11 433.19 349.22 432.29 349.16 430.96 348.54 430.69 348.29 430.15 347.79 428.97 347.96 428.01 347.28 427.42 346.64 426.76 345.87 425.74 345.68 424.98 344.89 424.12 344.31 424.02 344.27 423.98 340.18 Z"
          data-name="McCurtain"
          data-stusps="OK"
          id="40089"
        />
        <path
          className="white"
          d="M 89.42 72.3 90.52 72.67 92.25 72.78 93.21 73 94.4 72.41 95.4 72.48 96.48 72.29 93.08 82.6 94.71 83.13 94.17 84.77 95.82 85.28 95.29 86.92 94.81 87.05 85.48 84.06 85.46 83.74 86.51 82.8 85.79 81.08 87.14 77.64 87.88 76.64 89.8 76.61 90.12 75.94 89.42 72.3 Z"
          data-name="Gilliam"
          data-stusps="OR"
          id="41021"
        />
        <path
          className="white"
          d="M 111.07 108.52 112.38 108.01 115.58 106 120.71 107.43 121.81 108.9 121.35 110.52 125.04 111.62 124.93 111.75 125.41 112.47 126.17 112.31 126.79 113.29 127.96 113.64 127.84 114.44 128.61 114.94 128.58 115.44 128.55 115.46 127.13 116.44 127.39 117.63 126.85 118.42 126.19 120 125.99 120.24 125.18 121.18 124.43 123.87 123.99 125.44 121.14 136.18 120.06 140.28 117.94 148.35 116.08 155.49 113.67 154.85 110.77 154.11 107.67 153.3 104.15 152.36 99.59 151.14 99.59 151.14 101.02 146.06 100.79 145.82 104.12 133.78 108.46 117.62 109.97 112.59 110.88 109.35 111.07 108.52 Z"
          data-name="Malheur"
          data-stusps="OR"
          id="41045"
        />
        <path
          className="white"
          d="M 752.44 149.43 757.12 147.89 757.72 146.97 758.09 147.12 758.39 147.44 759.15 148.21 758.66 149.11 757.46 150.46 753.17 151.86 753.17 151.86 752.92 151.04 752.44 149.44 752.44 149.43 Z"
          data-name="Kent"
          data-stusps="RI"
          id="44003"
        />
        <path
          className="white"
          d="M 398.5 164.91 402.96 164.95 403.15 165.53 403.01 166.19 404 167.11 403.95 167.83 403.86 168.72 403.2 168.88 403.46 169.51 403.55 169.71 403.97 170.2 404.6 170.21 404.82 171.67 405.09 172.22 404.91 172.81 400.04 172.74 398.41 172.72 398.5 164.91 Z"
          data-name="Lincoln"
          data-stusps="SD"
          id="46083"
        />
        <path
          className="white"
          d="M 556.65 379.34 556.83 381.61 558.08 383.54 560.31 383.38 561.14 385.61 560.57 386.75 560.85 389.63 559.66 389.54 559.71 388.41 548.97 389.29 552.81 384.08 553.13 381.73 554.37 380.19 556.65 379.34 Z"
          data-name="Conecuh"
          data-stusps="AL"
          id="1035"
        />
        <path
          className="white"
          d="M 584.96 338.09 587.63 337.65 587.7 337.31 589.3 337.17 590.13 338.24 589.42 339.28 586.99 341.41 586.84 341.83 585.31 342.01 584.96 338.09 Z"
          data-name="Douglas"
          data-stusps="GA"
          id="13097"
        />
        <path
          className="white"
          d="M 620.93 337.12 623.06 335.86 623.55 336.19 624.38 335.86 624.44 337.78 627.2 341.19 626.37 342.12 625.88 342.19 623.17 341.76 620.93 337.12 Z"
          data-name="McDuffie"
          data-stusps="GA"
          id="13189"
        />
        <path
          className="white"
          d="M 140.24 111.6 140.3 109.92 141.23 107.79 140.9 106.12 141.49 104.61 143.91 101.25 143.39 100.23 143.94 99.36 144.45 99.61 146.16 98.72 146.05 99.18 163.05 103.41 162.33 104.15 161.27 109.05 159.71 110.31 157.39 111.49 155.78 110.18 154.8 110.7 154.21 112.17 152.53 112.48 152.06 112.98 152.56 114.3 152.37 116.17 151.09 117.53 150.27 117.2 149.28 118.67 147.56 118.73 139.7 116.71 139.14 118.34 137.79 117.92 138.64 114.68 139.46 114.89 140.24 111.6 Z"
          data-name="Valley"
          data-stusps="ID"
          id="16085"
        />
        <path
          className="white"
          d="M 552.77 241.18 556.26 240.78 559.5 240.6 560.35 239.98 560.95 244.89 560.87 245.42 560.03 246.54 559.73 246.41 559.37 246.02 556.63 245.82 553.97 246.47 553.44 242.21 552.9 242.27 552.77 241.18 Z"
          data-name="Jackson"
          data-stusps="IN"
          id="18071"
        />
        <path
          className="white"
          d="M 429.41 202.35 435.89 202.26 436.01 208.76 432.76 208.81 429.49 208.84 429.41 202.35 Z"
          data-name="Adair"
          data-stusps="IA"
          id="19001"
        />
        <path
          className="white"
          d="M 348.2 266.62 348.12 268.26 348.22 269.9 347.89 276.5 341.36 276.18 341.62 271.28 341.7 266.27 348.2 266.62 Z"
          data-name="Gray"
          data-stusps="KS"
          id="20069"
        />
        <path
          className="white"
          d="M 592.05 270.91 592.68 270.77 594.2 268.75 596.16 268.32 598.31 269.95 598.66 270.34 598.17 271.71 598.36 273.38 599.38 275.95 598.12 275.78 597.33 275.81 595.13 274.61 593.61 274.46 593.24 273.29 591.85 272.5 592.05 270.91 Z"
          data-name="Clay"
          data-stusps="KY"
          id="21051"
        />
        <path
          className="white"
          d="M 577.75 243.49 578.34 242.94 579.6 242.98 581.01 247.57 580.96 248.23 579.93 248.66 579.63 249.07 576.43 246.69 576.02 244.79 576 243.94 577.75 243.49 Z"
          data-name="Grant"
          data-stusps="KY"
          id="21081"
        />
        <path
          className="white"
          d="M 422.54 122.29 429.05 122.2 430.77 122.17 433.95 122.09 435.15 123.87 434.9 125 435.64 126.12 435.76 127.35 437.04 128.65 436.48 130.17 434.27 131.31 432.65 131.37 432.63 130.54 429.23 130.62 427.6 130.63 427.58 129 422.7 129.07 422.54 122.56 422.54 122.29 Z"
          data-name="Stearns"
          data-stusps="MN"
          id="27145"
        />
        <path
          className="white"
          d="M 435.63 398.59 440.91 397.28 442.27 396.93 442.36 396.6 444.42 396.12 445.22 400.06 444.87 413.27 441.35 413.34 441.88 411.45 441.27 409.88 442.02 408 441.63 407.08 442.32 405.89 441.68 404.99 441.09 405.06 440.67 403.08 440.2 402.99 439.59 401.03 439.82 400.48 439.09 399.76 439.18 398.91 437.31 398.45 435.71 399.1 435.63 398.59 Z"
          data-name="Jasper"
          data-stusps="TX"
          id="48241"
        />
        <path
          className="white"
          d="M 317.02 410.17 330.02 410.81 334.26 410.99 333.73 423.45 333.59 427.28 332.48 430.65 331.75 430.72 331.01 429.96 330.41 429.25 328.67 428.13 327.69 426.3 326.43 425.96 325.56 425.04 324.54 424.99 323.76 423.87 323.79 422.69 322.83 422.21 322.34 420.79 321.5 420.34 320.69 420.21 319.76 419.6 318.21 420.08 317.23 419.98 316.47 419.73 317.02 410.17 Z"
          data-name="Val Verde"
          data-stusps="TX"
          id="48465"
        />
        <path
          className="white"
          d="M 413.26 345.77 413.64 345.81 414.12 345.54 414.93 345.1 415.99 344.92 417.02 344.51 417.76 344.52 418.25 345.29 419.47 345.6 420.96 345.61 421.61 345.5 421.69 354.74 419.98 354.15 418.8 353.35 417.04 352.8 415.98 353.03 414.57 352.61 413.54 353.29 413.05 353.24 413.1 346.38 413.26 345.77 Z"
          data-name="Lamar"
          data-stusps="TX"
          id="48277"
        />
        <path
          className="white"
          d="M 413.65 308.37 414.53 307.52 414.52 302.62 415.06 302.63 416.7 302.62 417.42 304.26 419.42 304.25 422.95 304.24 421.89 306.32 422.62 308.43 422.1 309.15 420.66 308.98 417.16 310.07 416.23 308.36 414.46 308.37 413.65 308.37 Z"
          data-name="Wagoner"
          data-stusps="OK"
          id="40145"
        />
        <path
          className="white"
          d="M 206.65 224.19 206.66 224.19 207.67 224.49 220.04 226.41 220.96 225.85 220.59 228.32 219.91 232.86 218.05 244.65 203.72 242.47 204.27 242.03 203.49 240.82 204.02 239.57 203.52 239.42 203.12 237.89 203.61 237.58 202.67 234.42 203.29 234.19 203.32 233.12 204.51 233.33 205.38 234.03 204.97 233.12 204.13 233.13 203.39 232.11 204.54 230.29 204.71 229.29 205.48 228.66 205.29 227.71 206.69 225.22 206.65 224.19 Z"
          data-name="Grand"
          data-stusps="UT"
          id="49019"
        />
        <path
          className="white"
          d="M 384.91 131.96 385.11 125.43 393.11 125.62 393.21 126.17 395.03 126.21 394.95 131.1 394.91 133.84 391.35 133.78 384.87 133.59 384.91 131.96 Z"
          data-name="Day"
          data-stusps="SD"
          id="46037"
        />
        <path
          className="white"
          d="M 462.24 131.8 468.76 131.51 468.83 133.15 469.12 134.85 469.3 138.11 469.47 141.34 462.97 141.65 462.81 138.39 462.58 133.44 462.24 131.8 Z"
          data-name="Dunn"
          data-stusps="WI"
          id="55033"
        />
        <path
          className="white"
          d="M 623.71 280.85 625.16 278.82 625.81 278.48 628.56 278.12 628.16 278.64 627.96 279.66 628.23 280.96 627.78 282.08 627.99 282.5 628.43 283.43 627.46 283.52 626.46 283.55 625.44 284.58 625.32 284.88 625.14 285.34 622.95 283.67 623.71 280.85 Z"
          data-name="Johnson"
          data-stusps="TN"
          id="47091"
        />
        <path
          className="white"
          d="M 642.85 350.85 643.98 350.23 645.03 348.71 645.15 346.74 647.39 344.75 649.27 346.92 650.85 348.01 652.38 350.27 651.8 351.2 651.39 352.02 649.22 349.78 645.44 354.31 644.69 354.14 643.66 353.55 643.47 353.45 643.4 352.53 642.87 350.95 642.85 350.85 Z"
          data-name="Hampton"
          data-stusps="SC"
          id="45049"
        />
        <path
          className="white"
          d="M 533.64 304.28 533.73 303.79 535.47 304.35 537.5 303.52 537.36 306.84 538.76 307.76 538.93 308.52 538.04 310.21 533.91 311.11 533.67 311.7 533.1 311.34 534.03 309.82 532.94 308 532.81 306.21 533.64 304.28 Z"
          data-name="Perry"
          data-stusps="TN"
          id="47135"
        />
        <path
          className="white"
          d="M 545.34 287.58 546.16 287.49 549.92 287.08 550.67 286.99 553.04 286.7 553.74 286.85 552.17 291.43 551.23 291.55 550.26 292.7 548.86 292.21 547.81 292.64 546.52 291.69 545.59 291.13 544.94 289.08 545.34 287.58 Z"
          data-name="Robertson"
          data-stusps="TN"
          id="47147"
        />
        <path
          className="white"
          d="M 195.68 89.83 195.69 89.06 197.37 88.85 199.52 87.61 201.4 87.32 201.19 86.43 202.84 86.45 203.75 85.62 206.87 86.26 204.9 96 206.52 96.34 205.7 100.39 204.97 100.97 203.66 100.66 202.29 99.25 200.19 98.91 198.42 100.54 195.83 98.27 196.16 97.33 195.65 92.36 196.04 91.5 195.08 91.4 195.05 90.26 195.68 89.83 Z"
          data-name="Jefferson"
          data-stusps="MT"
          id="30043"
        />
        <path
          className="white"
          d="M 209.88 80.17 211.4 80.48 211.73 78.85 214.99 79.5 216.66 79.63 216.94 78.2 217.94 78.4 217.41 79.44 219.69 80.84 220.2 82.09 221.41 82.93 221.26 83.79 222.45 84.43 222.68 85.47 224.33 87.6 226.1 88.04 226.94 87.48 225.11 96.63 224.99 97.31 223.36 96.86 218.48 95.92 214.86 95.21 214.9 94.09 214.31 93.54 215.7 91.29 214.95 90.43 213.37 90.14 213.46 88.99 212.5 87.87 213.02 86.26 212 85.94 211.82 83.9 211.35 83.41 209.8 81.74 209.88 80.17 Z"
          data-name="Meagher"
          data-stusps="MT"
          id="30059"
        />
        <path
          className="white"
          d="M 493.66 139.8 501.99 139.23 502.64 147.45 497.6 147.8 495.89 147.89 495.49 142.95 493.9 143.06 493.66 139.8 Z"
          data-name="Portage"
          data-stusps="WI"
          id="55097"
        />
        <path
          className="white"
          d="M 615.45 291.11 615.46 289.97 616.36 288.83 617.96 288.33 618.95 286.46 619.81 286.36 621.06 288.07 620.43 288.66 619.93 288.62 619.22 289.08 618.35 289.81 618.26 290.03 617.7 291.38 617.1 291.94 616.41 292.58 615.54 292.3 615.64 291.3 615.45 291.11 Z"
          data-name="Unicoi"
          data-stusps="TN"
          id="47171"
        />
        <path
          className="white"
          d="M 645.08 149.58 646.1 149.35 646.7 149.53 646.93 149.73 647.03 150.04 647.32 149.95 647.75 149.94 647.88 149.63 647.74 149.34 648.86 148.71 649.02 148.36 650.79 148.27 651.97 147.51 652.64 147.55 653.53 151.71 653.25 151.88 653.9 153.34 654.86 157.94 651.88 159.83 648.88 161.03 647.54 159.6 646.54 159.63 645.77 159.16 645.38 159.26 645.55 158.36 646.09 157.63 646.13 156.75 647.09 156.03 647.91 155.27 648.47 154.26 648.34 154.02 648.14 153.64 647.74 152.93 647.25 152.65 647.12 151.76 646.78 151.45 646.3 151.45 645.35 150.92 645.31 149.71 645.09 149.58 645.08 149.58 Z"
          data-name="Erie"
          data-stusps="NY"
          id="36029"
        />
        <path
          className="white"
          d="M 642.46 263.66 643.97 262.81 644.9 261.86 646.34 260.6 647.37 260.96 648.82 262.82 649.38 265.06 647.09 267.23 644.51 267.86 644.23 268.43 644.04 267.22 643.35 266.53 643.68 266.27 643.65 265.93 644.05 265.99 643.98 265.87 644.29 265.48 644.22 265.26 644.01 265.29 644.02 265.51 643.97 265.6 643.98 265.57 643.98 264.24 642.97 264.78 642.46 263.66 Z"
          data-name="Montgomery"
          data-stusps="VA"
          id="51121"
        />
        <path
          className="white"
          d="M 517.96 338.33 522.88 337.98 524.53 337.88 524.86 342.82 521.54 343.03 521.61 344.12 520.01 344.51 517.54 344.69 517.48 343.31 518.3 343.25 517.96 338.33 Z"
          data-name="Chickasaw"
          data-stusps="MS"
          id="28017"
        />
        <path
          className="white"
          d="M 569.44 241.89 570.39 241.47 570.39 241.98 574.36 241.54 574.42 241.29 574.96 241.54 575.64 241.74 575.51 242.2 575.47 242.37 575.47 243.6 574.82 243.6 573.29 244.02 572.47 244.49 571.75 244.9 570.75 245.9 570.17 246.12 569.94 245.96 569.44 241.89 Z"
          data-name="Switzerland"
          data-stusps="IN"
          id="18155"
        />
        <path
          className="white"
          d="M 567.01 221.36 572.67 220.66 572.86 222.32 573.27 225.9 570.24 226.23 570.09 226.52 567.9 226.77 567.22 225.46 567.32 223.82 567.01 221.36 Z"
          data-name="Wayne"
          data-stusps="IN"
          id="18177"
        />
        <path
          className="white"
          d="M 578.13 254.57 579.32 254.78 579.8 255.87 579.53 258.06 579.12 260.82 578.32 261.18 577.25 260 577.58 258.94 576.61 257.57 576.79 256.67 576.23 256.29 576.17 255.83 578.13 254.57 Z"
          data-name="Woodford"
          data-stusps="KY"
          id="21239"
        />
        <path
          className="white"
          d="M 111.97 339.73 112.27 339.33 112.86 339.59 113.7 339.6 114.48 339.62 115.23 339.07 116.47 338.05 116.76 336.98 116.62 336.53 116.71 335.59 116.41 334.52 116.31 334.47 120.34 335.11 121.86 326.8 126.84 327.71 126.54 329.37 136.52 331.13 134.54 342.77 133.68 347.78 132.19 356.67 125.82 353.05 109.65 343.74 109.78 343.2 110.14 342.71 109.89 342.39 110.22 341.88 110.15 341.4 110.99 340.92 111.97 339.73 Z"
          data-name="Yuma"
          data-stusps="AZ"
          id="4027"
        />
        <path
          className="white"
          d="M 327.45 163.84 339.54 164.7 339.07 172.04 327.29 171.2 327.11 168.73 327.45 163.84 Z"
          data-name="Bennett"
          data-stusps="SD"
          id="46007"
        />
        <path
          className="white"
          d="M 705.42 282.05 705.98 279.21 706.21 279.02 707.06 277.1 708.17 276.37 709.62 276.02 711.22 274.78 711.84 274.78 711.92 276.86 712.54 277.79 712.03 279.39 712.38 281.08 708.74 281.67 705.53 282.31 705.42 282.05 Z"
          data-name="Washington"
          data-stusps="NC"
          id="37187"
        />
        <path
          className="white"
          d="M 565.57 300.89 565.82 300.74 568.71 300.73 569.68 301.19 569.99 301.28 569.87 301.94 570.47 304.6 571.21 306.14 570.45 306.25 567.22 307.1 566.31 306.82 565.12 306 564.39 304.43 564.1 303.47 565.57 300.89 Z"
          data-name="Warren"
          data-stusps="TN"
          id="47177"
        />
        <path
          className="white"
          d="M 556.52 224.06 557.58 223.63 561.72 223.11 561.58 224.51 561.76 226.14 561.23 226.21 561.43 227.86 556.8 228.41 556.44 225.42 556.64 225.14 556.52 224.06 Z"
          data-name="Hancock"
          data-stusps="IN"
          id="18059"
        />
        <path
          className="white"
          d="M 466.98 277.04 466.93 274.57 467.91 274.52 470.21 274.48 473.51 274.41 474.32 274.37 474.46 277.65 476.08 277.61 476.26 284.63 469.73 284.76 467.29 284.79 466.98 277.04 Z"
          data-name="Texas"
          data-stusps="MO"
          id="29215"
        />
        <path
          className="white"
          d="M 354.16 216.15 358.2 216.33 358.99 216.65 358.73 222.91 352.23 222.61 352.31 220.97 353.94 221.06 354.16 216.15 Z"
          data-name="Gosper"
          data-stusps="NE"
          id="31073"
        />
        <path
          className="white"
          d="M 450.72 130.62 454.32 130.51 454.15 130.72 454.14 132.13 454.14 132.41 454.5 133.74 454.55 133.93 453.76 134.86 454.33 135.65 454.54 137.16 454.38 138.66 454.38 138.67 454.36 138.81 453.93 140.44 454.11 140.61 451.11 140.41 451.14 139.08 450.98 138.25 451.46 138.23 451.3 133.86 450.82 133.87 450.72 130.62 Z"
          data-name="Washington"
          data-stusps="MN"
          id="27163"
        />
        <path
          className="white"
          d="M 700.82 183.27 701.57 182.4 702.72 181.78 705.16 183.82 706.62 183.93 706.61 184.96 707.83 185.55 706.96 186.74 706.2 188.32 705.41 187.94 699.15 184.83 700.22 183.97 700.82 183.27 Z"
          data-name="Lehigh"
          data-stusps="PA"
          id="42077"
        />
        <path
          className="white"
          d="M 412.96 401.9 415.33 401.01 416.95 401.03 416.92 400.65 419.87 398.25 419.88 400.51 420.5 402 421.62 401.96 421.13 408.62 417.24 408.54 413.49 406.28 412.96 401.9 Z"
          data-name="Walker"
          data-stusps="TX"
          id="48471"
        />
        <path
          className="white"
          d="M 379.66 151.42 386.12 151.62 386.18 151.62 386 158.11 384.42 158.05 379.56 157.91 379.48 157.58 379.52 156.28 379.66 151.42 Z"
          data-name="Sanborn"
          data-stusps="SD"
          id="46111"
        />
        <path
          className="white"
          d="M 554.28 304.93 555.74 304.57 558.04 305.85 558.89 304.9 560.44 305.36 560.93 308.72 560.65 309.51 558.28 311.52 556.63 311 555.47 310.91 555.17 310.89 554.25 308.62 554.28 304.93 Z"
          data-name="Bedford"
          data-stusps="TN"
          id="47003"
        />
        <path
          className="white"
          d="M 320.39 368.23 328.57 368.68 328.01 376.87 326.73 376.81 319.84 376.44 320.39 368.23 Z"
          data-name="Howard"
          data-stusps="TX"
          id="48227"
        />
        <path
          className="white"
          d="M 379.22 486.18 385.2 486.93 386.21 486.71 387.25 485.12 389.94 485.14 390.43 487.12 391.03 491.3 391.14 492.52 391.23 493.39 391.04 493.8 390.19 493.57 389 494.04 387.96 494.25 387.49 494.64 387.58 495.27 387.36 495.8 386.51 495.79 385.98 495.05 385.27 495.03 384.49 494.27 383.83 493.93 382.8 492.63 381.91 492.3 380.87 492.12 380.26 491.68 379.13 491.61 379.15 490.44 379.22 486.18 Z"
          data-name="Cameron"
          data-stusps="TX"
          id="48061"
        />
        <path
          className="white"
          d="M 220.64 138.7 221.3 139.95 223.11 140.1 223.43 141.65 222.87 142.73 223.54 143.17 225.37 142.66 225.94 141.26 227.42 140.77 228.68 141.58 230.07 144.07 231.64 146.53 231.4 148.03 234.64 148.56 236.23 149.08 236.14 149.64 237.78 149.9 237.64 150.71 239.27 150.96 239.19 151.51 240.82 151.77 240.73 152.31 242.32 152.83 244.84 153 252.52 154.1 252.6 153.55 253.43 153.67 253.59 154.24 252.88 160.75 251.97 167.26 251.39 167.18 250.52 173.57 250.76 173.74 250.31 176.99 248.69 176.77 233.08 174.44 229.06 173.8 229.57 170.6 229.94 165.65 229.09 165.5 229.25 164.69 226.99 161.89 226.19 160.31 224.97 158.73 224.28 158.57 224.4 157.22 223.41 155.44 223.15 153.5 223.44 151.6 222.62 151.47 222.93 149.64 218.87 148.91 220.64 138.7 Z"
          data-name="Fremont"
          data-stusps="WY"
          id="56013"
        />
        <path
          className="white"
          d="M 93.36 34.33 93.55 35.35 94.32 36.29 94.74 38.29 96.15 38.91 97.39 40.98 99.02 41.72 100.34 43.68 104.08 44.9 104.09 45.65 104.93 46.04 104.42 47.81 103.57 48.62 103.76 51.35 103.37 54.21 102.41 55.16 95.55 52.88 96.11 51.27 94.52 50.71 95.05 49.11 90.05 47.42 89.76 45.67 87.97 43.02 86.7 42.6 88.14 41.83 87.78 40.12 88.45 39.18 87.41 38.65 87.38 37.28 88.51 36.22 92.58 34.2 93.36 34.33 Z"
          data-name="Kittitas"
          data-stusps="WA"
          id="53037"
        />
        <path
          className="white"
          d="M 433.92 310.04 438.21 310.1 439.56 309.85 442.02 309.88 442.82 309.89 441.73 311.76 440.36 311.76 440.35 313.38 441.17 313.4 440.42 315.83 439.38 315.76 439.56 316.91 438 317.58 437.87 317.54 437.1 317.75 435.27 315.85 434.91 316.9 434.65 314.96 434.26 312.3 433.92 310.04 Z"
          data-name="Crawford"
          data-stusps="AR"
          id="5033"
        />
        <path
          className="white"
          d="M 396.93 186.45 397.07 178.84 397.75 179.45 398.57 179.29 399.94 179.93 400.01 179.97 400.33 180.64 401.45 180.72 401.27 181.76 401.97 182.47 402.39 183.21 401.08 183.25 400.97 187.83 400.97 187.87 400.81 188.13 399.63 188.12 399.62 188.12 396.91 188.08 396.93 186.45 Z"
          data-name="Dixon"
          data-stusps="NE"
          id="31051"
        />
        <path
          className="white"
          d="M 494.57 258.5 495.27 257.49 495.47 256.39 495.59 255.96 497.4 257.58 499.16 259.69 501.18 259.96 501.29 261.21 499.26 261.3 499.37 262.94 496.93 264 496.7 263.88 496.16 263.29 496.16 263.29 495.07 262.34 494.6 261.65 494.39 261.35 494.16 259.72 494.44 258.68 494.53 258.55 494.57 258.5 Z"
          data-name="Monroe"
          data-stusps="IL"
          id="17133"
        />
        <path
          className="white"
          d="M 524.37 265.45 524.37 265.44 527.91 265 529.13 265.84 529.02 266.05 529.7 267.07 529.32 268.17 528.3 269.11 527.96 269.95 528.49 271.4 527.75 271.01 524.82 271.24 524.37 265.45 Z"
          data-name="Gallatin"
          data-stusps="IL"
          id="17059"
        />
        <path
          className="white"
          d="M 721.11 170.22 723.92 170.98 726.33 171.6 726.37 172.51 726.34 173.18 726.34 173.26 726.32 173.92 726.31 174.08 726.26 174.44 726.16 175.13 726.15 175.22 726.12 175.31 726.03 175.72 725.81 175.44 725.79 175.43 725.82 175.29 725.73 175.25 725.72 175.3 725.58 175.24 725.53 175.33 725.11 175.75 724.92 175.83 724.81 176.02 724.71 176.1 724.69 176.22 724.61 176.5 724.7 176.73 724.67 176.79 723.74 176.54 723.76 176.15 723.82 175.84 723.96 175.01 723.29 173.91 722.94 173.11 722.46 173.02 720.81 172.62 720.91 171.73 721.11 170.22 Z"
          data-name="Bergen"
          data-stusps="NJ"
          id="34003"
        />
        <path
          className="white"
          d="M 700.3 282.82 703.5 283.65 705.42 282.05 705.53 282.31 708.74 281.67 709.84 283.13 711.97 283.97 711.46 284.83 710.06 285.08 711.91 288.01 710.8 288.07 710.63 290.62 707.37 291.65 706.44 291.09 705.28 290.38 701.24 288.85 701.07 286.9 702.12 286.05 702.34 285.97 700.67 284.6 700.08 283.51 700.3 282.82 Z"
          data-name="Beaufort"
          data-stusps="NC"
          id="37013"
        />
        <path
          className="white"
          d="M 443.22 188.85 446.51 188.76 449.74 188.68 449.93 195.17 448.3 195.21 443.39 195.34 443.22 188.85 Z"
          data-name="Story"
          data-stusps="IA"
          id="19169"
        />
        <path
          className="white"
          d="M 697.82 273.14 698.28 268.61 699.05 267.94 697.36 267.31 701.15 266.54 701.17 266.54 701.22 269.15 703.99 269.6 705.53 270.6 705.58 271.63 698.27 273.13 697.82 273.14 Z"
          data-name="Hertford"
          data-stusps="NC"
          id="37091"
        />
        <path
          className="white"
          d="M 598.62 325.97 598.19 325.57 598.06 324.42 598.71 323.37 600.01 322.52 600.85 322.25 602.79 322.22 603.76 323.48 603.06 324.82 604 326.06 601.27 329.61 600.18 330.15 597.33 329.3 597.38 329 598.43 328.64 599.22 326.82 598.62 325.97 Z"
          data-name="Hall"
          data-stusps="GA"
          id="13139"
        />
        <path
          className="white"
          d="M 467.21 260.82 468.33 259.53 467.51 258.29 469.34 258.28 469.77 256.3 471.96 254.34 474.98 253.58 475.08 253.57 475.38 261.36 472.14 261.41 467.22 261.64 467.21 260.82 Z"
          data-name="Osage"
          data-stusps="MO"
          id="29151"
        />
        <path
          className="white"
          d="M 449.11 230.78 449.08 229.55 456.37 229.25 456.5 229.25 456.56 235.58 453.3 235.56 450.63 235.7 449.21 235.73 449.11 230.78 Z"
          data-name="Linn"
          data-stusps="MO"
          id="29115"
        />
        <path
          className="white"
          d="M 635.57 385.3 636.39 385.19 636.57 383.92 638.68 384.18 639.19 384.28 639.72 388.42 639.09 388.39 638.34 389.28 637.81 390.03 637.8 391.16 637.76 391.87 638.44 392.82 638.57 394.17 638.6 395.78 638.48 396.65 638.58 397.27 638.42 397.33 637.71 397.56 636.91 397.61 636.29 397.58 635.66 396.58 635.7 395.62 635.12 394.8 635.2 393.95 635.81 389.63 631.35 389.97 630.92 385.82 635.57 385.3 Z"
          data-name="Charlton"
          data-stusps="GA"
          id="13049"
        />
        <path
          className="white"
          d="M 603.76 323.48 604.83 322.2 606.09 322.19 607.09 322.5 607.47 325.07 608.5 326.17 608.32 326.91 607.64 327.49 606.28 326.45 605.01 326.76 604 326.06 603.06 324.82 603.76 323.48 Z"
          data-name="Banks"
          data-stusps="GA"
          id="13011"
        />
        <path
          className="white"
          d="M 603.97 254.8 605.68 252.52 604.97 251.42 606.39 250.58 606.73 249.85 609.35 249.04 609.86 249.46 609.76 250.24 609.53 251.55 610.87 252.73 612.37 254.18 612.26 254.93 610.7 254.86 610.43 256.34 606.92 255.14 605.03 254.78 604.57 255.54 603.97 254.8 Z"
          data-name="Lawrence"
          data-stusps="KY"
          id="21127"
        />
        <path
          className="white"
          d="M 409.93 380.51 419.9 379.03 419.62 380.64 419.98 381.88 419.62 383.55 420.16 383.7 420.43 385 422.37 387.02 422.65 387.9 422.42 388.22 416.35 389.2 414.95 389.91 415.41 387.82 415 387.1 414.18 387.77 414.07 386.99 412.99 386.48 412.76 385.2 411.08 384.66 410.42 381.42 409.78 381.44 409.93 380.51 Z"
          data-name="Anderson"
          data-stusps="TX"
          id="48001"
        />
        <path
          className="white"
          d="M 207.28 67.85 208.75 68.47 209.24 66.4 212.49 67.09 212.83 65.47 216.08 66.14 221.55 67.24 220.24 68.93 222.32 70.77 223.54 71 223.24 72.48 224.88 72.82 224.78 73.36 224.57 74.44 222.94 74.12 222.49 75.02 221.94 79.02 223.54 79.35 222.72 84.22 222.45 84.43 221.26 83.79 221.41 82.93 220.2 82.09 219.69 80.84 217.41 79.44 217.94 78.4 216.94 78.2 216.66 79.63 214.99 79.5 211.73 78.85 211.4 80.48 209.88 80.17 208.18 79.81 209.04 75.78 207.14 75.1 206.85 74.24 206.03 73.9 207.28 67.85 Z"
          data-name="Cascade"
          data-stusps="MT"
          id="30013"
        />
        <path
          className="white"
          d="M 351.41 189.93 352.81 190.01 359.53 190.33 359.24 196.82 351.31 196.44 351.11 196.43 351.41 189.93 Z"
          data-name="Blaine"
          data-stusps="NE"
          id="31009"
        />
        <path
          className="white"
          d="M 521.69 320.69 522.26 320.65 527.15 320.28 528.54 320.18 528.8 320.16 529.11 324.68 523.63 325.05 523.09 325.09 522.96 323.18 521.87 323.26 521.69 320.69 Z"
          data-name="Alcorn"
          data-stusps="MS"
          id="28003"
        />
        <path
          className="white"
          d="M 653.53 151.71 658.92 150.49 660.6 150.27 661.39 153.95 660.49 156.79 660.85 156.95 657.08 157.76 655.12 158.22 654.86 157.94 653.9 153.34 653.25 151.88 653.53 151.71 Z"
          data-name="Wyoming"
          data-stusps="NY"
          id="36121"
        />
        <path
          className="white"
          d="M 612.4 223.7 614.04 223.56 614.19 225.29 617.3 224.99 617.57 227.5 618.22 228.28 619.65 228.11 619.83 229.21 619.45 229.78 619.47 229.85 616.38 230.19 611.82 230.6 611.68 228.9 610.99 227.24 610.87 225.55 612.54 225.42 612.4 223.7 Z"
          data-name="Athens"
          data-stusps="OH"
          id="39009"
        />
        <path
          className="white"
          d="M 715.06 102.43 716.23 101.39 715.99 98.92 718.94 99.51 720.56 99.39 722.2 100.47 722.57 100.56 722.68 102.31 723.17 102.32 722.97 103.36 723.4 104.14 722.89 104.13 722.76 105.93 722.92 105.93 722.86 107.08 722.8 108.35 722.23 107.09 721.74 105.94 717.31 107.87 716.97 107.03 716.57 106.19 716.62 105.65 716.67 104.46 716.05 103.29 715.36 102.69 715.06 102.43 Z"
          data-name="Chittenden"
          data-stusps="VT"
          id="50007"
        />
        <path
          className="white"
          d="M 553.97 294.34 554.47 292.89 555.02 293.61 555.98 292.42 558.35 292.61 558.52 291.95 558.9 292.82 559.7 291.92 560.85 292.7 561.22 293.17 562.43 296.53 562.4 296.83 563.35 298.81 562.17 298.67 561.25 299.15 559.73 299.17 555.43 296.94 554.74 296.36 553.97 294.34 Z"
          data-name="Wilson"
          data-stusps="TN"
          id="47189"
        />
        <path
          className="white"
          d="M 393.53 370.22 394.3 370.24 402.39 370.37 403.88 373.31 403.59 373.88 403.6 374.14 404.69 374.44 396.48 379.15 395.76 379.56 393.49 375.53 393.53 370.22 Z"
          data-name="Ellis"
          data-stusps="TX"
          id="48139"
        />
        <path
          className="white"
          d="M 379.99 397.74 380.98 397.18 381.48 396.89 387.94 393.17 389.13 394.61 390.19 393.96 393.47 399.5 390.4 401.27 389.45 403.83 384.49 401.56 381.21 400.86 381.02 400.39 379.9 398.39 379.99 397.74 Z"
          data-name="Bell"
          data-stusps="TX"
          id="48027"
        />
        <path
          className="white"
          d="M 185.69 188.09 185.54 190.32 185.95 191 185.63 191.63 186.39 193.64 183.28 193.83 183.46 191.91 182.77 191.78 178.59 193.96 176.38 187.51 177.01 187.43 181.03 186.93 185.69 188.09 Z"
          data-name="Davis"
          data-stusps="UT"
          id="49011"
        />
        <path
          className="white"
          d="M 395.62 296.06 396.66 297.04 397.65 296.76 398.48 295.5 399.51 295.06 400.21 296.66 400.06 297.31 401.27 297.64 402.17 298.61 403.04 298.56 402.2 299.71 403.08 300.04 403.96 299.41 404.32 300.29 405.94 301.41 407 301.43 406.82 302.62 406.37 302.61 401.77 302.56 401.44 302.63 398.44 302.62 398.46 300.98 396.85 300.96 396.87 299.33 395.24 299.31 395.28 296.06 395.62 296.06 Z"
          data-name="Pawnee"
          data-stusps="OK"
          id="40117"
        />
        <path
          className="white"
          d="M 144.58 228.29 145.39 224.48 145.87 222.08 147.85 212.73 148.02 211.92 151.06 212.53 151.45 212.43 157.15 213.6 171.26 216.37 172.84 216.64 174.93 217.03 174.48 221.33 176.96 222.08 176.06 227.17 175.01 228.66 173.99 228.48 172.33 230.02 171.94 232.63 170.4 233.35 168.38 232.87 166.99 234.74 160.13 233.45 148.63 231.15 144.17 230.27 144.58 228.29 Z"
          data-name="Millard"
          data-stusps="UT"
          id="49027"
        />
        <path
          className="white"
          d="M 513.69 166.32 515.31 166.2 520.19 165.81 520.27 167.06 520.28 167.15 520.31 167.46 520.52 170.19 520.53 170.32 520.71 172.36 517.44 172.69 514.19 172.96 513.9 169.64 513.69 166.32 Z"
          data-name="Waukesha"
          data-stusps="WI"
          id="55133"
        />
        <path
          className="white"
          d="M 677.38 220.28 677.38 220.28 677.52 219.53 677.74 218.29 678.24 216.37 678.87 216.31 679.05 216.29 680.25 216.33 680.86 216.66 681.8 217.02 682.47 217.51 682.47 217.52 682.22 218.22 681.8 218.8 681.97 219.55 682.61 219.72 683 220.22 684.57 220.17 685.04 220.19 684.27 221.77 683.94 222.47 682.82 224.78 682.63 224.84 682.42 224.09 680.68 223.34 675.86 222.92 677.07 221.35 677.38 220.28 Z"
          data-name="Loudoun"
          data-stusps="VA"
          id="51107"
        />
        <path
          className="white"
          d="M 201.94 164.33 202.69 160.41 203.53 155.86 203.72 154.82 203.9 153.83 204.75 149.25 207.91 149.87 207.64 151.35 210.87 151.94 210.37 153.97 209.21 160.49 208.71 160.4 208.48 161.7 208.94 161.78 208.06 166.71 208.72 166.82 208.17 170.04 214.97 171.35 212.84 184.4 212.32 184.32 198.74 181.91 200.16 173.97 201.35 167.42 201.94 164.33 Z"
          data-name="Lincoln"
          data-stusps="WY"
          id="56023"
        />
        <path
          className="white"
          d="M 614.65 248.97 615.08 247.34 617.48 245.74 617.7 247.34 618.53 247.67 619.58 246.37 621.14 246.4 621.13 248.37 620.67 249.84 619.61 250.35 620.19 252.07 619.35 252.21 616.48 253.61 614.83 254.45 616.25 252.26 614.62 250.66 614.65 248.97 Z"
          data-name="Lincoln"
          data-stusps="WV"
          id="54043"
        />
        <path
          className="white"
          d="M 390.61 176.98 391.06 177.06 391.55 176.7 392.6 176.91 393.14 176.73 394.02 176.98 394.34 177.61 395.01 178.16 395.47 178.53 396.94 178.73 397.07 178.84 396.93 186.45 392.06 186.36 392.09 184.73 390.45 184.7 390.61 176.98 Z"
          data-name="Cedar"
          data-stusps="NE"
          id="31027"
        />
        <path
          className="white"
          d="M 267.37 316.68 267.68 313.4 285.69 315.03 285.58 316.42 284.94 323.23 281.67 322.96 281.53 324.6 279.9 324.47 279.76 326.1 272.8 325.49 272.36 330.34 265.78 329.73 266.6 324.88 267.37 316.68 Z"
          data-name="Guadalupe"
          data-stusps="NM"
          id="35019"
        />
        <path
          className="white"
          d="M 306.11 244.4 312.67 244.89 322.49 245.44 322.05 252 321.95 253.55 305.32 252.37 305.57 250.92 306.11 244.4 Z"
          data-name="Cheyenne"
          data-stusps="CO"
          id="8017"
        />
        <path
          className="white"
          d="M 590.18 223.87 596.07 223.46 596.34 226.86 595.16 229.69 591.97 230.11 591.77 227.35 591.61 226.97 590.36 227.04 590.18 223.87 Z"
          data-name="Fayette"
          data-stusps="OH"
          id="39047"
        />
        <path
          className="white"
          d="M 590.03 208.78 591.48 208.55 593.65 208.21 593.94 208.28 594.1 209.35 594.64 213.11 595.74 212.95 596.05 214.85 595.62 215.6 591.31 216.14 591.14 213.97 590.31 214.02 590.03 208.78 Z"
          data-name="Union"
          data-stusps="OH"
          id="39159"
        />
        <path
          className="white"
          d="M 395.11 407.55 400.68 404.35 401.56 405.01 400.99 406.02 402.47 406.29 404.92 407.92 405.2 409.18 406.32 410.27 405.87 410.96 404.93 411.07 400.31 412.48 398.64 412.03 396.5 409.61 395.83 407.9 395.11 407.55 Z"
          data-name="Burleson"
          data-stusps="TX"
          id="48051"
        />
        <path
          className="white"
          d="M 707.31 252.48 707.39 252.52 708.07 253.33 708.44 253.74 707.07 254.08 706.91 254.2 706.45 253.33 707.31 252.48 Z"
          data-name="Poquoson"
          data-stusps="VA"
          id="51735"
        />
        <path
          className="white"
          d="M 352.8 123.95 362.2 124.47 362.33 124.48 362 131 354.68 130.61 354.1 129.73 354.64 128.06 353.84 126.3 351.99 125 352.8 123.95 Z"
          data-name="Walworth"
          data-stusps="SD"
          id="46129"
        />
        <path
          className="white"
          d="M 489.23 115.65 490.74 115.54 490.29 109.57 494.16 110.33 501.45 111.73 502.83 112.4 503.63 112.79 503.78 114.48 502.28 114.61 502.42 116.24 500.7 116.31 500.81 117.11 499.15 117.17 499.09 116.4 489.36 117.24 489.23 115.65 Z"
          data-name="Vilas"
          data-stusps="WI"
          id="55125"
        />
        <path
          className="white"
          d="M 531.67 382.27 537.7 381.82 537.89 382.37 537.74 382.58 538.1 383.77 538.45 383.96 538.83 383.91 538.81 384.36 539.83 384.86 540.28 384.9 540.61 385.32 540.92 385.51 540.52 386.47 541.36 387.36 541.12 388.69 540.29 388.88 540.67 391.18 540.29 391.78 539.5 392.18 534.53 392.54 532.92 393.21 532.26 387.45 532.23 387.18 531.83 383.7 531.67 382.27 Z"
          data-name="Washington"
          data-stusps="AL"
          id="1129"
        />
        <path
          className="white"
          d="M 307.05 234.49 312.16 234.85 323.12 235.54 323.11 235.65 322.87 239.3 322.59 243.82 322.49 245.44 312.67 244.89 306.11 244.4 306.37 242.71 307.05 234.49 Z"
          data-name="Kit Carson"
          data-stusps="CO"
          id="8063"
        />
        <path
          className="white"
          d="M 642.49 465.82 643.81 466.04 648.5 465.53 654.76 464.83 655.14 468.06 655.35 469.71 655.57 471.44 653.9 471.66 654.15 473.63 652.64 473.81 651.38 473.96 650.88 473.75 649.33 471.87 648.74 471.63 647.75 471.74 646.77 472.43 645.85 472.25 644.84 471.59 643.48 469.34 642.95 467.52 642.82 466.41 642.49 465.82 Z"
          data-name="Lee"
          data-stusps="FL"
          id="12071"
        />
        <path
          className="white"
          d="M 743.63 154.9 744.33 154.32 744.77 154.48 745.46 153.67 745.18 153.24 746.14 151.51 747.61 152.24 747.71 152.02 748.99 151.95 750.61 151.83 751.93 151.25 752.92 151.04 753.17 151.86 753.17 151.86 754.05 155.29 754.06 155.3 753.48 155.56 753.86 156.64 753.7 157.38 753.24 157.19 752.27 157.6 751.42 158.12 750.4 158.47 749.91 158.92 748.86 158.88 748.46 159.31 747.75 159.94 747.09 160.17 746.04 158.46 744.96 157.79 746.72 157.03 746.03 155.56 744.46 155.88 743.63 154.9 Z"
          data-name="New London"
          data-stusps="CT"
          id="9011"
        />
        <path
          className="white"
          d="M 534.23 234.89 533.99 232.44 536.17 232.23 538.84 231.99 538.42 233.67 538.87 238.59 533.69 239.06 533.51 238.07 533.79 237.52 534.46 237.32 534.24 235.03 534.23 234.89 Z"
          data-name="Vigo"
          data-stusps="IN"
          id="18167"
        />
        <path
          className="white"
          d="M 570.51 344.94 571.18 344.18 571.28 343.77 573.36 342.22 573.37 339.43 574.75 336.09 575.26 335.75 576.77 335.45 577.08 336.61 577.75 339.09 578.33 341.22 578.95 343.51 579.18 344.38 578.47 344.1 573.8 344.67 571.87 344.81 571.65 345.39 569.99 345.55 570.51 344.94 Z"
          data-name="Cleburne"
          data-stusps="AL"
          id="1029"
        />
        <path
          className="white"
          d="M 486.95 404.43 487.61 403.36 494.18 402.81 494.17 403.17 493.23 404.16 492.07 405.44 492.07 407.74 493.03 409.49 493.79 409.86 492.24 409.92 491.71 410.39 489.99 410.62 489.73 410.44 488.13 409.98 488.73 408.62 488.75 408.05 488.7 407.06 488.49 406.74 487.33 407.11 487.88 406.53 486.71 405.47 486.95 404.43 Z"
          data-name="East Baton Rouge"
          data-stusps="LA"
          id="22033"
        />
        <path
          className="white"
          d="M 555.03 362.2 558.29 361.97 558.2 361.14 562.99 360.69 563.53 366.29 562.76 366.44 562.27 367.64 559.67 366.87 557.64 367.13 557.21 368.73 557.18 368.15 555.41 364.58 555.03 362.2 Z"
          data-name="Autauga"
          data-stusps="AL"
          id="1001"
        />
        <path
          className="white"
          d="M 532.92 393.21 534.53 392.54 539.5 392.18 540.29 391.78 540.84 392.03 540.33 393.16 540.95 393.9 540.67 395.44 541.38 396 540.54 396.94 541.19 398.06 539.96 399.54 540.35 400.81 539.53 401.62 539.55 402.69 539.34 403.5 539.03 404.38 539.13 406.24 538.74 407.8 537.77 407.86 536.76 407.97 535.81 407.09 534.93 406.79 534.45 407.17 534.09 403.91 533.72 400.38 533.71 400.3 533.16 395.38 532.92 393.21 Z"
          data-name="Mobile"
          data-stusps="AL"
          id="1097"
        />
        <path
          className="white"
          d="M 571.17 141.31 574.99 140.75 579.3 140.07 579.28 140.22 579.34 142.12 578.11 142.7 578.06 143.62 576.78 143.87 575.74 144.5 575.45 145.54 573.5 145.78 573.26 144.17 571.62 144.4 571.17 141.31 Z"
          data-name="Arenac"
          data-stusps="MI"
          id="26011"
        />
        <path
          className="white"
          d="M 352.62 396.69 352.91 389.1 354.32 390.42 356.09 390.07 357.47 390.79 359.31 389.77 360.97 390.18 361.1 389.95 360.79 399.69 354.45 399.5 352.52 399.44 352.62 396.69 Z"
          data-name="McCulloch"
          data-stusps="TX"
          id="48307"
        />
        <path
          className="white"
          d="M 584.46 163.95 589.28 163.06 590.2 168.01 590.31 168.59 590.52 169.68 590.82 171.32 589.87 171.48 589.15 171.62 587.59 171.91 585.97 172.21 584.33 172.52 582.77 172.83 581.79 167.89 581.5 166.25 581.22 164.6 584.46 163.95 Z"
          data-name="Oakland"
          data-stusps="MI"
          id="26125"
        />
        <path
          className="white"
          d="M 520.01 344.51 521.61 344.12 521.54 343.03 524.86 342.82 525.03 345.29 528.46 345.05 528.64 345.16 528.64 345.17 528.63 345.17 528.63 345.18 528.63 345.19 528.62 345.19 528.62 345.2 528.61 345.2 528.61 345.2 528.6 345.2 528.6 345.2 528.6 345.2 528.59 345.19 528.59 345.19 528.58 345.18 528.58 345.17 528.57 345.17 528.57 345.16 528.57 345.16 528.56 345.15 528.55 345.15 528.55 345.14 528.54 345.14 528.54 345.14 528.53 345.13 528.52 345.13 528.51 345.13 528.51 345.14 528.5 345.14 528.5 345.14 528.5 345.14 528.49 345.14 528.49 345.14 528.49 345.14 528.49 345.15 528.48 345.16 528.48 345.16 528.47 345.17 528.47 345.17 528.47 345.19 528.47 345.21 528.46 345.23 528.46 345.25 528.46 345.26 528.46 345.26 528.47 345.27 528.47 345.29 528.48 345.31 528.47 345.32 528.47 345.32 528.46 345.32 528.45 345.32 528.42 345.34 528.41 345.35 528.39 345.37 528.37 345.39 528.36 345.4 528.35 345.4 528.33 345.4 528.32 345.41 528.31 345.41 528.31 345.43 528.3 345.45 528.3 345.48 528.3 345.49 528.3 345.5 528.3 345.52 528.3 345.54 528.3 345.56 528.3 345.57 528.3 345.59 528.31 345.61 528.31 345.62 528.31 345.62 528.31 345.62 529.13 347.94 526.02 348.5 525.94 347.4 524.38 347.5 520.48 347.82 520.41 346.64 520.11 346.1 520.01 344.51 Z"
          data-name="Clay"
          data-stusps="MS"
          id="28025"
        />
        <path
          className="white"
          d="M 362.51 117.95 363.91 118.01 365.49 118.1 367.4 118.19 370.7 118.33 371.84 118.38 371.84 118.38 375.53 118.54 375.28 125.07 362.33 124.48 362.2 124.47 362.51 117.95 Z"
          data-name="McPherson"
          data-stusps="SD"
          id="46089"
        />
        <path
          className="white"
          d="M 525.83 397.51 526.65 397.46 526.55 395.82 533.16 395.38 533.71 400.3 526.86 400.77 526.04 400.8 525.83 397.51 Z"
          data-name="George"
          data-stusps="MS"
          id="28039"
        />
        <path
          className="white"
          d="M 59.43 38.85 59.69 38.92 62.11 39.84 61.91 40.38 74.1 44.9 78.48 47.19 79.9 46.54 83.77 47.9 84.6 49.69 82.02 53.13 82.01 55.49 80.35 54.95 80.35 54.94 73.79 52.65 72.72 52.29 71.14 51.74 71.09 51.73 58.54 47.12 57.99 46.96 56.72 46.47 59.43 38.85 Z"
          data-name="Lewis"
          data-stusps="WA"
          id="53041"
        />
        <path
          className="white"
          d="M 643.05 244.49 642.78 242.21 644.23 241.12 645.86 239.17 647.21 239.22 649.37 237.05 650.01 233.25 650.78 234.28 652.5 234.27 652.76 235.07 652.42 235.71 652.39 237.29 652.23 238.24 652.36 238.84 651.94 240.38 651.05 241.37 651.44 242.1 651.32 242.23 650.63 243.02 649.82 244.12 649.72 245.55 649.53 246.52 646.52 247.58 645.06 247.63 643.37 246.6 643.05 244.49 Z"
          data-name="Pocahontas"
          data-stusps="WV"
          id="54075"
        />
        <path
          className="white"
          d="M 627.42 251.69 627.74 252.01 628.6 251.85 629.08 251.63 630.13 253.16 633.49 252.88 635.59 253.64 637.01 255.99 635.88 255.6 634.28 257.33 634.05 258.36 632.52 258.85 632.36 260.14 630.73 258.89 628 255.53 627.13 255.53 625.87 253.08 627.42 251.69 Z"
          data-name="Raleigh"
          data-stusps="WV"
          id="54081"
        />
        <path
          className="white"
          d="M 622.71 260.89 623.38 259.2 623.18 258.67 624.58 257.66 623.52 256.76 625.74 255.79 626.28 256.2 627.13 255.53 628 255.53 630.73 258.89 632.36 260.14 631.23 261.31 631.6 262.12 631.28 261.98 628.77 261.2 625.81 260.91 623.4 261.61 622.71 260.89 Z"
          data-name="Wyoming"
          data-stusps="WV"
          id="54109"
        />
        <path
          className="white"
          d="M 469.26 224.62 475.79 224.48 475.7 225.39 475.65 225.96 475.94 227.68 476.19 228.77 476.94 230.11 476.94 230.13 471.11 230.35 469.48 230.4 469.34 225.43 469.26 224.62 Z"
          data-name="Lewis"
          data-stusps="MO"
          id="29111"
        />
        <path
          className="white"
          d="M 178.16 369.68 180.01 356.45 196.42 358.66 199.7 359.14 199.93 359.14 201.52 359.34 202.6 359.48 201.77 365.96 201.08 371.41 199.98 380.2 187.29 378.57 177 377.23 177.72 371.89 178.16 369.68 Z"
          data-name="Cochise"
          data-stusps="AZ"
          id="4003"
        />
        <path
          className="white"
          d="M 347.65 94.19 350.42 94.37 350.62 91.17 351.59 91.23 358.74 91.65 358.88 98.18 358.45 104.7 350.93 104.25 349.37 103.1 349.53 102.24 348.08 98.98 347.81 97.49 348.57 96.85 347.65 94.19 Z"
          data-name="Burleigh"
          data-stusps="ND"
          id="38015"
        />
        <path
          className="white"
          d="M 354.68 130.61 362 131 363.8 131.1 363.5 137.63 362.15 137.56 352.39 137.06 352.7 134.66 354.19 134.86 353.66 133.33 354.68 130.61 Z"
          data-name="Potter"
          data-stusps="SD"
          id="46107"
        />
        <path
          className="white"
          d="M 365.78 286.15 368.92 286.25 372.64 286.38 372.52 296.42 372.49 297.65 371.09 297.7 368.37 296.34 367.85 295.47 366.08 295.41 366.14 293.68 363.54 290.14 361.87 290.04 361.22 289.37 360.07 288.2 358.92 285.9 359.66 285.93 363.84 286.08 365.78 286.15 Z"
          data-name="Woods"
          data-stusps="OK"
          id="40151"
        />
        <path
          className="white"
          d="M 588.79 283.92 589.3 283.86 589.31 283.86 592.95 283.46 592.96 283.46 593.07 284 593.63 285.06 593.91 285.56 594.33 286.39 594.61 286.5 594.45 287.14 593.93 287.21 593.78 289.19 593.45 289.51 592.95 288.97 592.54 290.39 590.1 290.41 590.04 291.71 587.95 291.21 588.44 289.84 587.73 286.46 587.93 285.61 588.89 285.45 589.08 285 588.79 283.92 Z"
          data-name="Campbell"
          data-stusps="TN"
          id="47013"
        />
        <path
          className="white"
          d="M 332.41 85.18 334.55 85.39 337.27 87.05 338.68 86.37 339.51 86.61 342.27 86.18 342.94 87.05 342 87.76 342.84 89.88 342.96 91.33 344.05 91.91 344.01 92.36 337.53 91.88 337.16 96.77 332.9 96.43 332.32 95.84 332.8 89.87 332.02 89.81 332.41 85.18 Z"
          data-name="Mercer"
          data-stusps="ND"
          id="38057"
        />
        <path
          className="white"
          d="M 660.55 308.12 664.19 307.58 664.46 307.54 668.37 310.3 668.58 310.45 666.71 317.06 666.3 316.99 664.43 314.72 664.15 313.26 662.89 313.12 663.46 311.45 661.72 310.15 660.5 308.13 660.55 308.12 Z"
          data-name="Marlboro"
          data-stusps="SC"
          id="45069"
        />
        <path
          className="white"
          d="M 332.79 113.95 334.77 113.73 334.85 114.49 336.03 114.42 337.1 115.07 337.68 114.63 338.54 115.26 341.99 113.65 342 113.12 343.48 112.93 343.42 112.26 345.79 110.52 347.78 108.3 349.88 108.79 351.63 108.19 352.06 109.43 351.84 111.55 350.8 113.46 350.91 114.85 352.11 117.34 348.83 117.14 344.31 116.84 340.93 116.61 338.41 116.44 335.3 116.2 332.63 115.99 332.79 113.95 Z"
          data-name="Sioux"
          data-stusps="ND"
          id="38085"
        />
        <path
          className="white"
          d="M 715.33 193.56 715.82 193 716.75 192.49 717.11 191.56 717.9 191.26 718.46 190.64 718.55 190.68 718.67 190.41 718.67 190.28 718.57 190.31 718.52 190.06 720.5 190.43 721.29 191.42 724.09 195.23 725.13 196.62 725.94 200.38 725.75 200.82 724.92 201.14 721.94 200.36 720.48 198.81 720.26 198.71 718.77 197.9 717.55 198.14 716.69 196.45 715.72 195.85 715.69 195.8 715.8 195.61 715.51 195.66 715.36 195.66 715.18 195.59 715.15 195.53 715.16 195.4 715.08 195.37 715.02 195.22 714.31 194.9 714.33 194.89 715.13 193.79 715.33 193.56 Z"
          data-name="Burlington"
          data-stusps="NJ"
          id="34005"
        />
        <path
          className="white"
          d="M 16.43 211.47 17.47 211.58 18.78 214.05 20.18 214.61 20.64 215.32 20.71 215.5 20.46 215.6 20.4 215.74 20.68 216.12 20.91 216.25 21.02 216.53 22.46 216.53 27.38 216.48 27.71 216.48 27.3 217.89 26.17 221.72 27.12 223.27 27.12 223.26 21.27 221.49 20.04 221.76 18.04 220.95 17.78 220.59 17.4 219.87 17.3 219.54 17.61 219.47 17.42 218.31 17.63 217.14 17.64 216.58 17.64 216.57 17.04 215.75 16.65 215.05 16.78 214.48 15.99 213.78 15.86 213.06 16.44 212.81 16.43 211.47 Z"
          data-name="Alameda"
          data-stusps="CA"
          id="6001"
        />
        <path
          className="white"
          d="M 140.4 248.62 147.42 250.01 149.18 250.08 148.86 251.77 152.19 252.42 152.02 253.3 155.27 254.07 155.36 253.59 157.41 253.97 155.68 263.45 154.65 263.26 139.43 260.36 138.14 260.09 138.46 258.42 139.19 254.7 139.97 250.75 140.4 248.62 Z"
          data-name="Washington"
          data-stusps="UT"
          id="49053"
        />
        <path
          className="white"
          d="M 553.88 273.91 558.07 273.11 558.53 273.16 560.4 275.25 560.38 276.17 560.34 278.34 559.73 278.26 558.06 277.61 557.15 278.15 555.21 276.65 553.88 273.91 Z"
          data-name="Edmonson"
          data-stusps="KY"
          id="21061"
        />
        <path
          className="white"
          d="M 39.6 205.61 43.11 205.51 45.57 207.45 47.37 207.79 50.71 207.96 52.47 206.81 53.61 206.95 54.62 205.77 54.97 206 53.93 209.68 51.89 209.29 49.82 209.44 48.48 208.89 45.14 209.67 44.62 210.54 41.61 210.88 40.03 211.67 38.51 211.15 38.45 209.58 39.6 205.61 Z"
          data-name="Amador"
          data-stusps="CA"
          id="6005"
        />
        <path
          className="white"
          d="M 586.47 277.18 587.12 275.59 587.07 273.43 587.39 271.72 588.96 269.98 589.11 269.65 591.11 270.98 592.05 270.91 591.85 272.5 593.24 273.29 593.61 274.46 592.47 276.1 590.51 276.75 589.17 277.23 587.96 276.74 587.42 277.32 586.39 277.5 586.47 277.18 Z"
          data-name="Laurel"
          data-stusps="KY"
          id="21125"
        />
        <path
          className="white"
          d="M 501.3 314.18 501.93 313.89 502.33 314.02 502.44 314.37 505.12 314.32 507.61 313.83 508.72 314.37 509 321.55 507.76 321.63 507.21 321.66 506.66 321.69 498.71 322.13 498.81 321.5 499.35 321.25 500.39 321 500.59 320.22 500.88 319.5 501.96 319.64 501.77 318.78 501.82 318.04 501.7 317.17 500.62 316.77 501.27 316.17 501.73 315.03 501.3 314.18 Z"
          data-name="Shelby"
          data-stusps="TN"
          id="47157"
        />
        <path
          className="white"
          d="M 503.71 311.21 504.28 311.59 505.92 309.66 508.54 309.17 510.48 310.4 511.02 311.01 511.13 313.71 509.23 313.99 508.72 314.37 507.61 313.83 505.12 314.32 502.44 314.37 502.33 314.02 502.64 313.21 502.23 312.49 502.3 311.48 503.52 311.57 503.71 311.21 Z"
          data-name="Tipton"
          data-stusps="TN"
          id="47167"
        />
        <path
          className="white"
          d="M 418.02 273.18 424.53 273.15 424.54 274.24 424.58 279.69 418.1 279.72 418.04 279.72 418.02 273.18 Z"
          data-name="Neosho"
          data-stusps="KS"
          id="20133"
        />
        <path
          className="white"
          d="M 598.77 243.87 599.1 243.53 600.11 243.55 600.7 243.08 600.86 242.45 601.8 241.62 601.95 241.43 602.14 242.05 601.16 244.96 600.51 245.73 599.66 247.34 599.99 248.97 598.39 249.57 597.15 248.26 596.58 248.62 594.54 247.95 593.41 246.29 593.44 244.64 593.04 244.11 593.09 244.07 593.24 243.36 594.56 242.74 596.02 243.17 596.99 243.19 597.91 243.81 598.48 244.18 598.77 243.87 Z"
          data-name="Lewis"
          data-stusps="KY"
          id="21135"
        />
        <path
          className="white"
          d="M 411.53 275.61 411.53 273.16 418.02 273.18 418.04 279.72 411.51 279.68 411.53 275.61 Z"
          data-name="Wilson"
          data-stusps="KS"
          id="20205"
        />
        <path
          className="white"
          d="M 502.3 106.34 506.35 105.97 513.66 105.28 513.97 108.53 514.57 114.61 513.73 114.23 512.8 114.02 511.98 114.17 511 113.65 510.63 113.91 509.03 113.28 508.16 113.47 507.95 113.95 507.37 114.03 507.05 113.6 506.99 113.59 506.23 113.41 505.3 113.6 503.63 112.79 502.83 112.4 502.45 107.98 502.3 106.34 Z"
          data-name="Iron"
          data-stusps="MI"
          id="26071"
        />
        <path
          className="white"
          d="M 545.55 279.65 546.69 279.3 547.23 279.34 548.7 279.44 551.38 280.26 552.54 282.36 551.88 282.55 550.71 285.5 550.67 286.99 549.92 287.08 546.16 287.49 545.55 279.65 Z"
          data-name="Logan"
          data-stusps="KY"
          id="21141"
        />
        <path
          className="white"
          d="M 329.1 252.42 330.32 252.49 335.56 252.8 335.13 260.98 328.95 260.64 328.58 260.62 329.1 252.42 Z"
          data-name="Wichita"
          data-stusps="KS"
          id="20203"
        />
        <path
          className="white"
          d="M 528.23 279.52 528.41 279.91 529.65 278.79 530.47 278.82 533.29 282.65 531.48 283.74 529.21 284.74 528.62 283.5 527.78 282.69 528.22 282.31 527.77 280.8 528.23 279.52 Z"
          data-name="Lyon"
          data-stusps="KY"
          id="21143"
        />
        <path
          className="white"
          d="M 459.43 157.79 459.75 157.51 464.44 157.33 469.18 157.11 469.51 163.6 468.22 163.67 464.73 163.83 463.38 163.89 459.68 164.05 459.43 157.79 Z"
          data-name="Fillmore"
          data-stusps="MN"
          id="27045"
        />
        <path
          className="white"
          d="M 354.85 424.15 361.86 424.43 362.03 425.78 362.76 425.6 364.8 423.25 364.61 431.49 364.54 434.5 354.51 434.2 354.85 424.15 Z"
          data-name="Medina"
          data-stusps="TX"
          id="48325"
        />
        <path
          className="white"
          d="M 418.6 158.46 423.38 158.43 426.66 158.39 426.73 158.39 426.8 164.91 426.53 164.92 425.98 164.92 421.88 164.96 419.51 164.98 418.6 164.99 418.6 158.46 Z"
          data-name="Jackson"
          data-stusps="MN"
          id="27063"
        />
        <path
          className="white"
          d="M 589.25 253.23 589.38 253.86 590.82 254.09 592.98 256.45 592.77 256.67 593.04 257.98 592.4 258.42 590.06 258.13 587.91 254.88 589.07 253.61 589.25 253.23 Z"
          data-name="Montgomery"
          data-stusps="KY"
          id="21173"
        />
        <path
          className="white"
          d="M 178.75 199.9 181.31 201.42 182.44 200.88 187.26 199.58 187.48 199.38 187.44 201.14 186.66 201.94 187.29 203.53 188.37 203.73 188.9 205.29 190.51 205.57 190.93 206.21 191.4 208.07 190.68 210.12 191.28 210.38 192.72 212.66 192.59 213.47 195.36 213.96 195.85 214.05 195.57 215.68 189.9 214.7 184.15 213.67 182.33 213.38 182.93 212.45 182.13 210.83 180.54 211.42 178.12 213.27 177.52 213.06 178.44 211.05 177.02 208.47 178.09 205.43 177.81 204.31 178.24 202.37 178.16 199.94 178.75 199.9 Z"
          data-name="Utah"
          data-stusps="UT"
          id="49049"
        />
        <path
          className="white"
          d="M 358.26 253.99 366.24 254.29 366.38 254.3 366.16 260.83 358 260.51 358.26 253.99 Z"
          data-name="Rush"
          data-stusps="KS"
          id="20165"
        />
        <path
          className="white"
          d="M 724.34 95.25 726.83 95.68 726.46 97.61 728.2 98.1 727.84 99.81 727.55 101.21 727.51 101.59 725.8 100.97 725.49 102.72 723.75 102.33 723.17 102.32 722.68 102.31 722.57 100.56 722.2 100.47 720.56 99.39 721.11 97.64 721.99 97.8 722.21 95.42 722.89 95.24 723.77 95.02 724.34 95.25 Z"
          data-name="Lamoille"
          data-stusps="VT"
          id="50015"
        />
        <path
          className="white"
          d="M 79.57 12.27 80.58 12.56 81.34 15.35 81.73 16.76 80.96 17.88 81.18 19.86 80.38 22.65 79.09 23.67 78.46 24.15 78.27 21.94 77.52 21.21 77.97 21.04 78.22 20.52 77.66 19.58 78.32 18.15 78.25 17.02 77.5 16.1 77.46 14.68 78.4 13.88 79.57 12.27 Z"
          data-name="Island"
          data-stusps="WA"
          id="53029"
        />
        <path
          className="white"
          d="M 379.25 176.02 379.64 176.25 380.29 176.53 381.38 176.93 381.44 176.95 382.02 177.56 382.97 178.42 384.14 178.35 384.78 177.81 385.19 176.81 385.46 176.59 386.24 176.74 387.62 177.04 388.53 176.91 389.03 176.83 390.18 176.9 390.61 176.98 390.45 184.7 385.6 184.62 379.12 184.46 379.05 184.19 379.23 178.37 379.17 177.93 379.25 176.02 Z"
          data-name="Knox"
          data-stusps="NE"
          id="31107"
        />
        <path
          className="white"
          d="M 712.89 93.97 714.88 93.35 714.58 94.71 714.83 95.09 715.46 95.3 715.38 98.27 715.99 98.92 716.23 101.39 715.06 102.43 714.99 102.37 714.4 101.48 714.29 99.87 714.12 98.89 714.14 97.91 714.15 97.84 713.6 97.51 713.24 96.99 713.45 95.7 713.09 94.73 712.89 93.97 Z"
          data-name="Grand Isle"
          data-stusps="VT"
          id="50013"
        />
        <path
          className="white"
          d="M 664.77 243.99 664.88 243.3 665.85 242.93 665.95 244 665.22 244.31 664.77 243.99 Z"
          data-name="Waynesboro"
          data-stusps="VA"
          id="51820"
        />
        <path
          className="white"
          d="M 617.98 378.56 618.51 378.38 619.07 375.76 619.91 374.47 619.71 372.42 621.77 372.15 622.21 371.44 622.54 374.19 625.93 373.75 626.18 375.92 626.89 377.54 626.39 377.6 626.62 379.6 623.55 379.96 623.03 379.28 618.18 379.53 617.98 378.56 Z"
          data-name="Coffee"
          data-stusps="GA"
          id="13069"
        />
        <path
          className="white"
          d="M 63.26 197.07 67.17 196.38 71.55 191.77 72.08 191.33 73.08 191.6 72.96 191.97 73.47 191.64 75.45 190.5 75.1 190.7 73.44 194.4 72.77 196.88 74.15 199.36 75.29 200.86 75.83 202.45 76.71 203.57 76.52 204.29 74.38 203.71 74 203.73 72 205.75 71.53 207.5 73.2 207.95 72.68 209.59 70.93 216.24 67.18 215.29 65.77 213.14 65.19 212.25 65.93 208.35 65.08 208.18 65.35 205.21 66.45 203.43 67.99 203.12 68.33 201.88 64.78 200.87 65.18 198.76 63.91 198.4 63.26 197.07 Z"
          data-name="Lyon"
          data-stusps="NV"
          id="32019"
        />
        <path
          className="white"
          d="M 238.19 310.22 244.91 311.01 245.44 311.07 246.97 311.21 247.46 311.29 252.94 311.92 252.59 315.24 252.42 316.87 253.88 317.02 253.72 318.59 249.65 318.16 249.65 317.74 249.52 317.54 245.46 317.02 244.84 317.64 240.11 317.1 239.65 315.4 238.19 310.22 Z"
          data-name="Bernalillo"
          data-stusps="NM"
          id="35001"
        />
        <path
          className="white"
          d="M 451.82 164.36 453.93 164.29 458.26 164.11 458.26 164.11 458.46 169.51 452 169.74 451.98 168.94 451.82 164.36 Z"
          data-name="Mitchell"
          data-stusps="IA"
          id="19131"
        />
        <path
          className="white"
          d="M 435.22 195.53 436.84 195.49 441.74 195.38 441.87 200.31 442.25 201.97 440.75 202.17 435.89 202.26 435.86 200.43 435.31 200.43 435.22 195.53 Z"
          data-name="Dallas"
          data-stusps="IA"
          id="19049"
        />
        <path
          className="white"
          d="M 634.99 455.08 641.72 454.41 642.07 457.76 642.15 457.78 645.43 457.43 645.79 460.78 642.41 461.14 642.59 462.81 640.65 463 638.95 460.62 637.6 458.3 637.11 457.45 635.71 455.79 634.99 455.08 Z"
          data-name="Sarasota"
          data-stusps="FL"
          id="12115"
        />
        <path
          className="white"
          d="M 138.4 72.41 138.6 71.54 138.97 70.24 143.11 71.37 144.95 70.1 146.94 70.69 146.29 73.29 147.24 74.03 146.61 76.34 142.06 75.45 140.52 81.64 139.52 82.46 139.24 83.84 138.5 84.01 138 82.74 137.91 81.68 137.72 80.89 137.72 79.57 137.33 78.98 138.23 78.07 138.53 77.58 138.17 76.9 138.44 75.9 138.27 74.85 137.69 73.67 138.33 72.71 138.4 72.41 Z"
          data-name="Nez Perce"
          data-stusps="ID"
          id="16069"
        />
        <path
          className="white"
          d="M 341.36 276.18 347.89 276.5 349.52 276.58 349.68 278.24 349.39 285.47 342.41 285.16 341.2 285.11 341.55 277.96 341.28 277.82 341.36 276.18 Z"
          data-name="Meade"
          data-stusps="KS"
          id="20119"
        />
        <path
          className="white"
          d="M 511.85 290.63 511.89 290.63 512.64 291.45 513.43 291.55 513.79 290.46 514.11 289.96 514.55 289.97 516.45 290.91 517.75 290.83 518.33 291.06 519.48 292.39 517.51 292.53 513.76 292.73 511.73 292.95 510.64 293.07 508.79 293.21 508.26 292.49 508.62 291.78 509.62 291.87 510.71 291.87 511.07 290.71 511.85 290.63 Z"
          data-name="Fulton"
          data-stusps="KY"
          id="21075"
        />
        <path
          className="white"
          d="M 745.79 70.11 747.22 72.86 750.86 79.29 752.19 78.44 752.72 79.37 754.38 78.42 756.18 81.58 756 82.71 756.54 83.47 757.74 82.78 759.42 86.1 759.88 85.87 760.72 87.05 760.69 87.66 760.65 87.83 759.4 87.97 759.5 88.29 759.35 89.22 759.97 89.45 760.03 89.91 758.85 90.26 757.96 90.75 757.56 91.29 757.12 90.51 756.14 90.12 756.3 89.41 752.45 89.84 752.87 89.35 750.43 86.67 748.77 88.53 748.04 86.54 746.31 83.51 746.86 83.23 744.57 78.74 744.54 78.43 744.66 77.88 744.33 77.37 744.29 76.66 743.89 76.3 744.28 75.53 744.64 75.47 745.15 75.9 745.87 75.76 746.5 75.77 746.22 74.95 745.55 74.67 744.55 73.8 744.67 72.65 744.96 71.84 745.52 70.98 745.79 70.11 Z"
          data-name="Franklin"
          data-stusps="ME"
          id="23007"
        />
        <path
          className="white"
          d="M 750.64 123.55 750.31 123 750.6 121.65 750.78 120.35 750.96 119.13 751.02 118.45 751.08 117.93 753.07 118.78 753.17 118.82 754.93 119.55 754.63 120.81 757.36 119.97 757.87 118.92 759 119.46 759.85 119.6 759.7 120.64 759.51 121.46 759.35 122.57 759.39 123.3 759.41 123.63 758.76 123.88 757.76 123.9 757.36 124.35 756.52 124.82 756.45 125.42 756.38 125.95 755.62 126.07 755.14 126.15 754.99 126.4 754.82 126.7 754.78 126.77 755.15 127.76 754.27 128.05 753.6 127.77 752.34 127.64 752.31 127.37 751.24 127.17 750.65 126 750.29 125.28 751.22 124.65 750.64 123.55 Z"
          data-name="Rockingham"
          data-stusps="NH"
          id="33015"
        />
        <path
          className="white"
          d="M 651.49 142.24 652.47 146.8 652.64 147.55 651.97 147.51 650.79 148.27 649.02 148.36 648.86 148.71 647.74 149.34 647.88 149.63 647.75 149.94 647.32 149.95 647.03 150.04 646.93 149.73 646.7 149.53 646.1 149.35 645.08 149.58 644.27 149.51 644.29 148.59 644.32 148.41 644.39 148.01 644.01 146.74 643.61 146.03 646.64 144.32 650.37 142.51 651.49 142.24 Z"
          data-name="Niagara"
          data-stusps="NY"
          id="36063"
        />
        <path
          className="white"
          d="M 628.62 176.54 641.4 174.11 642.21 178.38 639.17 179 637.22 181.95 635.47 182.46 629.86 183.32 629.83 183.12 629.24 179.92 628.62 176.54 Z"
          data-name="Crawford"
          data-stusps="PA"
          id="42039"
        />
        <path
          className="white"
          d="M 611.82 230.6 616.38 230.19 619.47 229.85 619.83 231.23 619.73 231.3 618.94 231.81 619.28 232.6 619.72 233.68 619.06 234.46 618.06 234.93 617.23 233.83 616.17 233.29 615.69 233.59 615.12 234.49 615.02 234.8 614.94 234 611.53 234.04 611.25 230.65 611.82 230.6 Z"
          data-name="Meigs"
          data-stusps="OH"
          id="39105"
        />
        <path
          className="white"
          d="M 421.61 345.5 422.03 345.42 422.49 344.44 422.92 343.84 424.02 344.27 424.12 344.31 424.98 344.89 425.74 345.68 426.76 345.87 427.42 346.64 428.01 347.28 428.97 347.96 430.15 347.79 430.69 348.29 430.47 348.63 430.53 355.64 429.99 355.83 429.55 355 429.49 354.77 424.57 354.55 424.13 354.72 421.72 354.79 421.69 354.74 421.61 345.5 Z"
          data-name="Red River"
          data-stusps="TX"
          id="48387"
        />
        <path
          className="white"
          d="M 608.32 238.05 610.1 237.79 609.85 234.15 611.53 234.04 614.94 234 615.02 234.8 614.65 235.92 614.49 237.51 613.84 238.03 614.08 238.81 614.6 240.68 614.9 241.62 614.3 242.03 613.48 242.12 613.4 242.4 612.21 242.47 612.06 240.74 610.3 240.89 609.88 239.21 608.4 239.3 608.32 238.05 Z"
          data-name="Gallia"
          data-stusps="OH"
          id="39053"
        />
        <path
          className="white"
          d="M 388.63 170.96 391.9 171.01 395.18 171.06 395.16 172.69 395.08 177.78 395.01 178.16 394.34 177.61 394.02 176.98 393.14 176.73 392.6 176.91 391.55 176.7 391.06 177.06 390.61 176.98 390.18 176.9 389.03 176.83 388.53 176.91 388.63 170.96 Z"
          data-name="Yankton"
          data-stusps="SD"
          id="46135"
        />
        <path
          className="white"
          d="M 469.28 299.71 476.36 299.58 476.71 304.31 476.32 305.43 475.67 305.44 474.26 306.92 472.46 305.65 470.27 305.88 470.94 303.86 468.78 302.14 468.49 302.13 469.3 301.35 469.28 299.71 Z"
          data-name="Izard"
          data-stusps="AR"
          id="5065"
        />
        <path
          className="white"
          d="M 159.71 110.31 161.27 109.05 162.33 104.15 163.05 103.41 164.69 101.85 162.83 98.61 163.15 97.26 164.7 98.37 167.06 96.68 167.17 97.22 167.75 97.67 168.69 98.9 169.81 99.41 170.42 98.43 171.32 98.49 172.94 97.71 174.06 96.99 174.23 96.19 174.83 96.25 175.06 96.66 175.54 97.53 175.94 98.03 176.57 98.6 176.28 100.09 176.66 101.01 176.38 101.99 176.61 102.89 176.31 104 177.05 105.96 177.6 108.18 178.33 108.9 178.94 109.84 178.9 110.86 178.53 111.83 178.01 112.56 178.42 113.99 178.99 114.27 179.85 115.17 180.68 114.88 181.98 116.31 182.16 117.45 182.53 119.09 182.16 120.03 182.65 121.3 182.46 122.17 182.98 123.37 183.77 124.25 184.61 123.94 184.08 127.27 181.65 126.67 177.25 125.73 177.32 124.06 176.4 121.18 175.59 121.64 171.67 119.34 169.61 115.73 169.2 113.6 167.53 113.45 168.13 111.73 167.91 110.87 164.85 112.91 165.14 113.57 163.65 115.16 161.94 115.46 161.05 113.54 160.09 113.15 159.33 111.42 159.71 110.31 Z"
          data-name="Lemhi"
          data-stusps="ID"
          id="16059"
        />
        <path
          className="white"
          d="M 419.39 378.07 426.96 377.98 427.01 383.45 427.77 383.46 427.13 384.44 428.02 388.44 428.97 389.41 426.78 391.33 425.19 390.51 425.21 389.59 424.1 388.39 422.42 388.22 422.65 387.9 422.37 387.02 420.43 385 420.16 383.7 419.62 383.55 419.98 381.88 419.62 380.64 419.9 379.03 419.39 378.07 Z"
          data-name="Cherokee"
          data-stusps="TX"
          id="48073"
        />
        <path
          className="white"
          d="M 445.32 361.22 445.44 361.22 446.76 361.19 449.96 361.13 449.82 361.95 451.17 363.97 450.8 365.53 451.27 365.93 451.47 372.51 452.56 372.49 451.76 372.74 452.1 373.27 451.75 375.78 451.1 375.76 450.2 375.09 449.86 374.1 449.26 374.09 448.01 372.66 447.59 372.87 447.39 371.09 446.25 370.23 446.66 369.23 445.9 367.81 445.94 366.96 445.28 366.55 445.9 365.61 445.25 365.47 445.84 364.25 444.9 362.59 445.32 361.22 Z"
          data-name="Bossier"
          data-stusps="LA"
          id="22015"
        />
        <path
          className="white"
          d="M 441.81 367.4 441.78 365.44 441.75 363.88 441.71 361.29 445.32 361.22 444.9 362.59 445.84 364.25 445.25 365.47 445.9 365.61 445.28 366.55 445.94 366.96 445.9 367.81 446.66 369.23 446.25 370.23 447.39 371.09 447.59 372.87 448.01 372.66 449.26 374.09 449.86 374.1 450.2 375.09 451.1 375.76 448.78 375.81 447.93 374.33 446.35 373.83 443.43 376.69 441.98 376.71 441.92 373.57 441.91 373.03 441.85 369.81 441.81 367.4 Z"
          data-name="Caddo"
          data-stusps="LA"
          id="22017"
        />
        <path
          className="white"
          d="M 18.31 208.56 20.06 209.69 20.87 209.59 21.63 209.57 24.17 210.57 24.51 210.32 25.18 211.45 26.17 211.64 27.53 210.66 28.94 211.06 28.24 215.96 27.71 216.48 27.38 216.48 22.46 216.53 21.02 216.53 20.91 216.25 20.68 216.12 20.4 215.74 20.46 215.6 20.71 215.5 20.64 215.32 20.18 214.61 18.78 214.05 17.47 211.58 16.43 211.47 16.43 211.16 15.74 211.02 15.33 209.84 16.34 209.68 16.5 209.1 16.9 209.2 17.22 209.27 18.36 208.76 18.31 208.56 Z"
          data-name="Contra Costa"
          data-stusps="CA"
          id="6013"
        />
        <path
          className="white"
          d="M 249.65 318.16 253.72 318.59 253.88 317.02 252.42 316.87 252.59 315.24 253.36 315.31 260.8 316.05 267.37 316.68 266.6 324.88 265.78 329.73 265.62 331.37 256.03 330.44 248.36 329.66 248.7 326.27 248.87 324.72 248.04 324.64 248.48 320.96 248.56 320.24 248.65 319.71 248.71 319.2 248.84 318.07 249.65 318.16 Z"
          data-name="Torrance"
          data-stusps="NM"
          id="35057"
        />
        <path
          className="white"
          d="M 238.79 276.23 247.01 277.22 247.1 277.38 253.06 278.04 255.07 278.25 260.16 278.79 260.46 280.9 259.97 284.14 260.11 288.94 259.58 290.93 258.32 291.35 257.96 291.86 260.9 293.44 262.5 296.08 265.47 298.04 264.82 298.72 262.54 298.39 262.6 297.95 257.17 297.4 257.29 298.76 254.36 298.45 254.39 297.77 254.48 297.11 244.69 296.07 245.17 291.97 233.88 290.56 235.34 279.55 235.72 279.02 238.1 277.99 238.13 277.01 238.79 276.23 Z"
          data-name="Rio Arriba"
          data-stusps="NM"
          id="35039"
        />
        <path
          className="white"
          d="M 50.22 35.26 59.43 38.85 56.72 46.47 52.01 44.66 51.32 46.39 50.8 46.53 50.26 46.14 49.06 46.61 48.67 46.34 48.31 45.53 48.22 45.19 46.62 45.09 47.25 44.06 48.55 41.02 49.38 38.41 50.81 38.85 51.55 38.36 51.18 37.34 49.99 36.43 50.22 35.26 Z"
          data-name="Pacific"
          data-stusps="WA"
          id="53049"
        />
        <path
          className="white"
          d="M 337.05 80.4 348.44 81.2 353.31 81.53 353.12 84.79 352.01 84.73 351.59 91.23 350.62 91.17 350.42 94.37 347.65 94.19 347.61 92.44 346.92 91.71 344.05 91.91 342.96 91.33 342.84 89.88 342 87.76 342.94 87.05 342.27 86.18 339.51 86.61 338.68 86.37 337.27 87.05 334.55 85.39 332.41 85.18 331.72 84.19 332.01 81.23 331.11 80.79 330.41 81.55 330.55 79.86 337.05 80.4 Z"
          data-name="McLean"
          data-stusps="ND"
          id="38055"
        />
        <path
          className="white"
          d="M 147.46 147.9 148.1 145.2 149.18 145.4 149.75 146.64 148.9 148.27 149.9 148.73 150.13 150.59 152.79 151.51 154.67 152.92 157.57 154.38 158.89 155.95 160.22 155.58 160.84 155.76 159.86 155.78 159.42 157.6 156.4 156.92 154.67 164.91 154.67 164.9 150.22 163.9 146.01 162.83 144.05 162.4 147.46 147.9 Z"
          data-name="Twin Falls"
          data-stusps="ID"
          id="16083"
        />
        <path
          className="white"
          d="M 597.75 255.14 597.77 254.89 600.08 253.25 600.16 254.32 601.38 255.09 603.97 254.8 604.57 255.54 605.17 256.81 604.62 257.55 602.66 257.14 602.98 257.68 600.89 259.86 601.14 260.85 599.02 259.19 597.48 258.82 597.27 258.5 597.11 258.37 597.83 256.88 597.75 255.14 Z"
          data-name="Morgan"
          data-stusps="KY"
          id="21175"
        />
        <path
          className="white"
          d="M 741.05 124.03 740.79 123.05 741.11 122.79 742.32 122.03 743.64 123.52 744.21 123.16 745.2 122.54 746.02 122.03 746.95 123.76 748.57 122.96 748.75 123.3 750.64 123.55 751.22 124.65 750.29 125.28 750.65 126 751.24 127.17 752.31 127.37 752.34 127.64 753.6 127.77 754.27 128.05 754.14 128.09 754.13 128.1 753.83 129 753.02 129.23 752.53 129.36 750.34 129.96 749.03 130.32 747.49 130.73 747.12 130.83 746.66 130.95 745.35 131.3 744.92 131.41 743.85 130.15 742.75 127.81 741.76 127.59 741.05 124.03 Z"
          data-name="Hillsborough"
          data-stusps="NH"
          id="33011"
        />
        <path
          className="white"
          d="M 436.06 415.82 438.54 415.71 438.8 414.72 440.41 414.36 441.4 414.86 442.81 417.32 445.63 418.22 445.94 418.75 445.79 420.19 445.47 420.58 444.56 421.51 445.2 422.27 445.66 422.97 446.08 423.59 445.71 423.81 444.06 423.78 442.51 424.01 440.8 424.69 437.67 426.12 437.53 420.03 436.15 420.01 436.06 415.82 Z"
          data-name="Jefferson"
          data-stusps="TX"
          id="48245"
        />
        <path
          className="white"
          d="M 103.02 57.6 106.42 58.3 108.27 57.24 108.72 58.38 108.98 59.82 110.14 62.07 108.76 66.72 111.18 69.11 111.74 70.37 111.53 72.59 110.78 72.93 109.57 73.4 108.58 73.62 106.92 72.96 105.42 72.86 104.48 72.74 103.72 72.64 102.74 71.94 102.33 71.93 101.05 72.82 99.27 72.44 98.36 72.34 99.6 68.57 103.02 57.6 Z"
          data-name="Benton"
          data-stusps="WA"
          id="53005"
        />
        <path
          className="white"
          d="M 78.12 61.35 87.46 64.59 99.6 68.57 98.36 72.34 97 72.19 96.48 72.29 95.4 72.48 94.4 72.41 93.21 73 92.25 72.78 90.52 72.67 89.42 72.3 89.19 72.22 88.36 70.98 87.79 70.81 87.5 70.91 86.89 71.13 84.44 71.24 83.74 71.59 83.54 71.42 83.19 71.13 81.3 70.67 80.61 71.1 79.74 71.01 79.73 69.66 78.35 68.49 77.16 68.31 76.97 68.14 76.04 67.3 75.31 65.82 76.96 60.94 78.12 61.35 Z"
          data-name="Klickitat"
          data-stusps="WA"
          id="53039"
        />
        <path
          className="white"
          d="M 625.27 321.12 626.69 322.45 628.11 322.86 630.55 324.37 631.45 325.34 631.9 325.49 630.38 328.37 630.18 329.09 629.59 329.33 629.54 328.75 627.11 329.18 626.32 328.53 625.45 329.54 624.89 327.83 625.7 326.89 625.73 324.7 624.06 322.57 625.27 321.12 Z"
          data-name="Greenwood"
          data-stusps="SC"
          id="45047"
        />
        <path
          className="white"
          d="M 270.95 176.4 278.15 177.31 277.76 178.27 277.07 179.58 278.25 180.02 280.36 180.23 281.26 177.65 281.94 177.72 280.66 190.69 280.4 192.29 279.06 204.66 279.05 204.66 266.04 203.18 265.65 203.14 264.18 202.95 265.06 195.48 268.67 195.92 270.14 182.91 270.95 176.4 Z"
          data-name="Albany"
          data-stusps="WY"
          id="56001"
        />
        <path
          className="white"
          d="M 266.04 203.18 279.05 204.66 279.06 204.66 283.81 205.17 282.5 217.37 280.9 217.2 280.75 218.84 279.25 218.7 272.13 217.93 270.14 214.64 270.37 213.66 269.71 213.36 269.01 212.72 269.08 211.76 267.64 207.05 265.97 204.39 266.04 203.18 Z"
          data-name="Larimer"
          data-stusps="CO"
          id="8069"
        />
        <path
          className="white"
          d="M 382.64 256.39 390.78 256.56 390.65 264.74 385.76 264.64 382.49 264.58 382.61 258.03 382.64 256.39 Z"
          data-name="McPherson"
          data-stusps="KS"
          id="20113"
        />
        <path
          className="white"
          d="M 714.38 235.75 714.88 234.77 720.49 232.82 719.61 235.67 719.17 236.64 718.21 236.51 717.61 237.38 717.03 239.2 716.79 240.95 716.68 242.05 716.99 242.96 716.33 244.64 716.52 244.93 715.86 245.42 715.04 245.34 714.88 245.55 714.25 245.3 714.48 244.95 714.2 244.5 714.4 244.17 713.57 243.85 712.57 244.01 711.92 244.32 711.93 244.02 712.27 242.52 712.58 241.1 713.09 240.06 712.83 239.28 713.96 238.52 714.32 237.78 713.26 236.94 714.38 235.75 Z"
          data-name="Accomack"
          data-stusps="VA"
          id="51001"
        />
        <path
          className="white"
          d="M 686.08 269.56 688.11 269.15 688.38 269.1 695.3 267.72 696.96 267.39 697.36 267.31 699.05 267.94 698.28 268.61 697.82 273.14 696.59 274.16 696.84 274.89 696.54 274.92 695.2 274.32 693.87 272.38 692.48 273.08 691.68 272.6 691.84 270.94 690.22 270.02 686.23 270.33 686.08 269.56 Z"
          data-name="Northampton"
          data-stusps="NC"
          id="37131"
        />
        <path
          className="white"
          d="M 507.36 216.01 509.3 215.82 510.54 215.14 511.34 214.37 511.18 212.73 512 212.65 516.92 212.17 517.28 214.81 518.93 214.65 519.27 218.76 519.44 220.95 517.8 221.1 512.84 221.47 509.54 221.74 509.54 221.73 507.9 221.89 507.82 221.05 507.36 216.01 Z"
          data-name="McLean"
          data-stusps="IL"
          id="17113"
        />
        <path
          className="white"
          d="M 617.14 394.74 619.99 394.61 620.08 394.61 624.28 394.4 627.38 394.25 626.86 395.05 628.54 398.02 627.97 399.27 627.19 399.5 626.37 399.63 626.24 399.4 622.63 398.04 621.28 397.94 619.95 399.2 619.03 398.57 617.75 394.79 617.14 394.74 Z"
          data-name="Hamilton"
          data-stusps="FL"
          id="12047"
        />
        <path
          className="white"
          d="M 675.58 315.56 676.87 312.52 678.17 311.48 678.85 311.8 681.72 311.33 685.21 312.36 686.99 312.23 688.12 311.4 689.13 312.13 689.75 311.95 688.77 314.89 686.91 315.44 686.36 316.82 684.81 316.58 684.41 317.04 684.5 318.68 683.34 319.9 683.39 321.16 680.4 319.01 675.58 315.56 675.58 315.56 Z"
          data-name="Columbus"
          data-stusps="NC"
          id="37047"
        />
        <path
          className="white"
          d="M 629.94 378.17 631.09 377.78 631.66 376.49 632.77 375.63 634.04 376.59 634.44 376.56 635.58 376.51 636.17 378.22 637.09 379.75 635.22 380.33 634.11 381.79 632.56 381.55 632.06 381.59 630.79 380.49 629.94 378.17 Z"
          data-name="Pierce"
          data-stusps="GA"
          id="13229"
        />
        <path
          className="white"
          d="M 626.62 379.6 626.39 377.6 626.89 377.54 628.56 377.35 628.9 378.29 629.94 378.17 630.79 380.49 632.06 381.59 632.56 381.55 633.93 382.41 634.14 384.05 635.57 385.3 630.92 385.82 631.35 389.97 635.81 389.63 635.2 393.95 631.87 394.03 631.04 389.53 630.06 389.66 629.81 386.93 628.02 386.08 626.34 383.1 625.68 381.37 626.82 381.29 626.62 379.6 Z"
          data-name="Ware"
          data-stusps="GA"
          id="13299"
        />
        <path
          className="white"
          d="M 57.7 60.84 59.53 61.52 59.87 61.48 59.44 62.33 59.55 62.76 59.67 63.18 60.67 64.27 62.47 65.47 63.04 66.09 63.89 66.13 64.34 66.88 65.22 67.27 65.43 67.23 66.47 67.01 67.58 67.29 69.08 67.13 69.94 66.83 70.37 66.78 69.73 69.34 70.48 70.85 70.04 70.72 61.37 67.64 59.42 67.02 58.68 67.27 58.17 67.08 58.21 66.99 58.73 65.53 57.11 62.44 57.7 60.84 Z"
          data-name="Multnomah"
          data-stusps="OR"
          id="41051"
        />
        <path
          className="white"
          d="M 686.85 296.09 688.7 295.7 691.24 296.13 692.04 295.36 693.17 295.79 693.94 297.92 694.26 298.29 695.27 298.78 695.72 299.35 696.09 303.62 691.37 304.63 689.25 304.86 687.85 304.72 688.11 301.51 686.85 296.09 Z"
          data-name="Duplin"
          data-stusps="NC"
          id="37061"
        />
        <path
          className="white"
          d="M 617.45 413.27 618.24 413.19 618.7 410.13 625.29 409.36 624.96 410.74 625.23 413.95 625.51 413.81 624.99 416.18 623.98 418.63 622.36 419.97 622.29 419.95 622.08 418.93 621.53 418.04 620.82 417.37 619.9 417.38 619.62 416.82 617.96 415.96 617.75 414.59 617.45 413.27 Z"
          data-name="Dixie"
          data-stusps="FL"
          id="12029"
        />
        <path
          className="white"
          d="M 568.67 188.84 573.84 187.99 574.38 187.9 574.86 189.55 575.13 191.48 575.68 191.4 575.75 191.94 575.9 193.03 569.36 193.92 569.09 191.96 568.67 188.84 Z"
          data-name="Williams"
          data-stusps="OH"
          id="39171"
        />
        <path
          className="white"
          d="M 587.55 325.74 588.65 325.63 588.72 326.21 591.18 325.82 591.58 326.04 593.81 325.63 593.9 326.5 594.11 328.35 594.21 329.32 592.77 329.66 591.94 331.73 590.42 331.8 589.54 331.94 588.7 331.93 588.16 332.06 587.81 326.81 587.55 325.74 Z"
          data-name="Cherokee"
          data-stusps="GA"
          id="13057"
        />
        <path
          className="white"
          d="M 552.6 230.07 556.92 229.51 557.53 234.98 555.58 235.26 553.16 235.57 552.6 230.07 Z"
          data-name="Johnson"
          data-stusps="IN"
          id="18081"
        />
        <path
          className="white"
          d="M 573.32 279.38 573.57 277.98 575.61 274.14 577.14 275.56 577.91 275.2 577.99 276.52 579.16 277.33 577.58 278.23 577.45 279.08 576.01 280.34 575.25 281.03 573.36 280.13 573.73 280.68 572.73 279.96 573.32 279.38 Z"
          data-name="Russell"
          data-stusps="KY"
          id="21207"
        />
        <path
          className="white"
          d="M 559.96 270.83 562.3 270.77 565.88 270.73 565.52 273.06 565.93 275.29 565.08 275.62 562.68 276.29 560.38 276.17 560.4 275.25 558.53 273.16 559.9 272.77 560.5 271.83 559.96 270.83 Z"
          data-name="Hart"
          data-stusps="KY"
          id="21099"
        />
        <path
          className="white"
          d="M 638.1 365.6 639.41 366.23 639.41 368.13 641.69 369.94 644.3 370.86 643.4 373.36 641.92 374.29 641.6 374.27 641.17 373.49 638.55 372.24 636.32 370.18 636.11 370.11 638.1 365.6 Z"
          data-name="Long"
          data-stusps="GA"
          id="13183"
        />
        <path
          className="white"
          d="M 507.32 382.55 510.83 382.11 510.99 385.21 513.81 386.86 513.9 388.36 512.81 388.42 510.07 388.57 510.13 389.4 507.95 389.51 507.54 387.04 507.32 382.55 Z"
          data-name="Jefferson Davis"
          data-stusps="MS"
          id="28065"
        />
        <path
          className="white"
          d="M 398 217.49 398.04 217.18 398.11 210.96 398.15 210.96 404.47 211.04 404.46 211.58 404.43 215.94 404.4 220.83 397.97 220.76 398 217.49 Z"
          data-name="Lancaster"
          data-stusps="NE"
          id="31109"
        />
        <path
          className="white"
          d="M 430.87 67.24 431.38 66.97 432.71 67.07 433.1 67.47 433.13 67.98 435.11 68.18 437.16 68.36 438.2 68.37 438.71 69.47 438.61 70.29 440.37 70.44 441.77 70.16 442.94 69.81 442.95 68.94 444.1 68.65 444.38 68.24 446.12 67.88 446.94 68.18 447.61 68.12 447.89 78.63 448.2 81.92 439.42 82.07 439.44 83.05 431.31 83.25 431.29 81.61 431 73.45 430.87 67.24 Z"
          data-name="Koochiching"
          data-stusps="MN"
          id="27071"
        />
        <path
          className="white"
          d="M 588.83 189.82 590.03 190.47 593.87 189.9 595.5 189.64 597.06 189.93 597.3 191.2 597.55 192.56 597.67 193.21 589.43 194.46 588.83 189.82 Z"
          data-name="Sandusky"
          data-stusps="OH"
          id="39143"
        />
        <path
          className="white"
          d="M 666.38 182.72 667.97 180.43 668.35 181.82 669.68 181.46 670.79 182.69 672.57 182.63 674.61 184.59 674.74 184.69 677.03 183.71 679.59 182.02 678.22 184.98 677.26 186.44 673.54 189.26 673.19 189.63 671.07 189.81 669.56 191.16 667.38 190.84 666.9 190.78 666.47 190.8 663.43 191.62 663.1 191.26 664 189.2 664.54 188.98 665.28 186.75 666.59 186.51 666.71 185.59 665.48 183.69 666.38 182.72 Z"
          data-name="Centre"
          data-stusps="PA"
          id="42027"
        />
        <path
          className="white"
          d="M 686.31 178.29 686.99 178.1 688.54 175.39 688.96 174.64 690.34 174.28 690.64 176.18 691.6 177.54 692.26 177.25 693.4 180.75 692.59 182.25 692.62 183.87 691.69 184.61 690.99 183.62 689.73 184.08 689.1 183.08 688.96 181.6 687.76 179.98 687.02 179.96 686.31 178.29 Z"
          data-name="Columbia"
          data-stusps="PA"
          id="42037"
        />
        <path
          className="white"
          d="M 621.66 261.77 622.24 261.39 622.71 260.89 623.4 261.61 625.81 260.91 628.77 261.2 631.28 261.98 630.77 263.74 629.97 265.15 629.19 265.67 628.52 266.3 628.15 266.68 626.38 267.03 625.36 266.47 625.28 266.43 624.72 265.89 623.55 265.86 622.72 265.08 621.99 264.09 621.86 263.52 621.04 262.97 621.66 261.77 Z"
          data-name="McDowell"
          data-stusps="WV"
          id="54047"
        />
        <path
          className="white"
          d="M 197.28 57.04 197.63 59.63 197.06 62.08 197.51 63.47 198.34 64.26 201.48 63.92 202.81 65.16 202.9 66.19 203.97 66.62 204.32 67.41 207.28 67.85 206.03 73.9 206.85 74.24 207.14 75.1 209.04 75.78 208.18 79.81 209.88 80.17 209.8 81.74 211.35 83.41 210.07 82.84 209.44 83.5 208.89 86.67 206.87 86.26 203.75 85.62 202.84 86.45 201.19 86.43 201.4 87.32 199.52 87.61 200.06 84.72 200.5 83.81 200.33 83.19 199.18 82.94 199.35 82.12 197.74 81.77 198.29 79.25 194.94 78.56 196.38 72.1 193.03 71.3 194.35 65.52 193.66 64.83 193.73 63.28 193.99 60.89 195.19 60.58 195.85 57.42 197.28 57.04 Z"
          data-name="Lewis and Clark"
          data-stusps="MT"
          id="30049"
        />
        <path
          className="white"
          d="M 496.73 246.83 503.28 246.41 504.15 246.35 504.29 247.86 504.28 247.86 504.89 248.65 505.1 251.11 505.24 252.75 503.6 252.87 498.71 253.13 496.6 253.23 496.37 252.73 496.11 252.02 496.69 251.1 496.69 251.1 497.37 250.44 497.38 249.62 495.94 248.77 495.59 248.57 494.9 248.45 494.85 246.95 496.73 246.83 Z"
          data-name="Madison"
          data-stusps="IL"
          id="17119"
        />
        <path
          className="white"
          d="M 146.94 70.69 148.56 71.16 150.12 65.43 158.98 67.83 167.62 70.07 167.96 70.53 167.54 71.34 168.08 72.59 169.09 73.5 169.2 74.32 170.08 74.51 170.33 74.74 170.88 75.26 170.7 76.3 171.06 76.5 170.93 76.84 156.8 76.45 156.58 77.1 154.93 78.16 153.87 79.79 153.4 79.7 151.21 78.31 150.5 77 149.32 76.5 149.3 75.86 147.74 75.24 147.24 74.03 146.29 73.29 146.94 70.69 Z"
          data-name="Clearwater"
          data-stusps="ID"
          id="16035"
        />
        <path
          className="white"
          d="M 480.76 203.8 480.77 203.79 489.84 203.39 489.99 206.69 490.07 208.34 485.15 208.54 482.78 208.66 482.77 208.6 482.66 207.89 482.03 206.95 481.4 206.92 480.79 206.04 480.29 205.4 480.76 203.8 Z"
          data-name="Mercer"
          data-stusps="IL"
          id="17131"
        />
        <path
          className="white"
          d="M 132.14 102.6 135.66 103.57 134.79 106.87 135.82 108.11 135.21 110.43 136.61 111.74 138.06 112.12 136.82 114.25 135.83 117.42 134.57 117.08 128.55 115.46 128.58 115.44 128.61 114.94 127.84 114.44 127.96 113.64 126.79 113.29 126.17 112.31 125.41 112.47 124.93 111.75 125.04 111.62 125.47 111.09 125.3 110.4 125.1 109.73 125.67 109.15 125.79 108.13 126.8 107.53 127.3 106.98 128.43 105.38 129.25 104.09 130.05 103.71 131.3 103.44 132.14 102.6 Z"
          data-name="Washington"
          data-stusps="ID"
          id="16087"
        />
        <path
          className="white"
          d="M 646.83 214.68 651.02 213.9 651.6 217.49 652.23 221.03 652.68 223.65 652.72 223.86 649.51 222.96 647.85 224.06 646.72 223.02 646.35 222.99 645.9 220.41 645.67 219.55 646.79 216.58 646.83 214.68 Z"
          data-name="Preston"
          data-stusps="WV"
          id="54077"
        />
        <path
          className="white"
          d="M 507.85 202.45 508.17 206.32 505.38 206.54 505.73 205.68 503.79 205.81 503.67 204.21 505.22 204.11 505.43 202.81 507.85 202.45 Z"
          data-name="Putnam"
          data-stusps="IL"
          id="17155"
        />
        <path
          className="white"
          d="M 508.9 296.1 509.23 296.07 509.38 295.43 508.84 294.68 509.12 293.87 508.79 293.21 510.64 293.07 511.73 292.95 511.62 294.7 510.56 298.04 510 298.51 509.95 298.99 507.83 299.17 506.8 298.49 506.99 298.04 508.15 298.15 508.84 297.36 507.92 296.83 508.05 296.18 508.9 296.1 Z"
          data-name="Lake"
          data-stusps="TN"
          id="47095"
        />
        <path
          className="white"
          d="M 702.35 209.8 703.62 209.93 706.73 209 706.73 209 707.18 210.51 707.46 211.45 705.78 211.55 703.75 212.44 703.53 214.02 702.21 215.67 701.84 217.79 700.89 217.29 701.43 217.37 701.09 215.99 700.78 215.5 700.19 215.11 700.43 213.71 700.66 212.54 701.03 211.88 701.13 211.12 701.7 210.26 702.35 209.8 Z"
          data-name="Kent"
          data-stusps="MD"
          id="24029"
        />
        <path
          className="white"
          d="M 682.47 217.51 684.71 215.45 685.01 215.17 686.21 214.05 686.01 214.38 687.03 215.4 688.07 215.62 689.87 217.06 690.21 217.54 691.25 217.38 691.05 217.7 690.46 219.86 690.24 220.88 689.55 220.43 688.63 221.84 688.63 221.84 688.12 221.36 687.27 221.46 686.5 221.27 686.36 220.49 686.36 220.49 685.34 220.21 685.04 220.19 684.57 220.17 683 220.22 682.61 219.72 681.97 219.55 681.8 218.8 682.22 218.22 682.47 217.52 682.47 217.51 Z"
          data-name="Montgomery"
          data-stusps="MD"
          id="24031"
        />
        <path
          className="white"
          d="M 283.85 405.78 290.06 401.43 303.57 413.86 307.1 417.08 307.43 417.48 306.91 417.64 306.55 418.41 306.1 419.42 304.87 419.08 304.16 419.03 303.5 419.52 302.48 419.54 301.41 419.66 301.07 420.8 300.27 421.79 299.56 422.98 299.01 423.59 298.55 425.03 298.61 425.88 297.77 426.73 297.38 427.93 297.66 428.8 296.83 429.71 295.51 430.19 294.79 431.24 294.09 431.53 293.63 432.61 293.14 433.42 291.48 433.14 290.58 433.26 289.29 432.49 287.68 431.48 286.73 430.39 285.64 429.77 284.55 429.3 283.51 428.85 282.53 427.53 282.45 427.49 282.78 422.96 283.85 405.78 Z"
          data-name="Brewster"
          data-stusps="TX"
          id="48043"
        />
        <path
          className="white"
          d="M 368.42 468.8 373.28 468.95 376.2 469.03 377.41 469.06 377.4 470.02 377.27 478.04 371.63 477.9 369.92 477.85 370.1 472.77 369.28 472.76 368.91 469.37 368.42 468.8 Z"
          data-name="Brooks"
          data-stusps="TX"
          id="48047"
        />
        <path
          className="white"
          d="M 258.51 134.11 271.13 135.9 271.43 135.84 276.78 136.49 276.61 137.29 275.04 150.43 274.17 156.55 273.34 156.46 259.49 154.69 259.23 154.5 260 148.56 260.68 142.19 260.46 141.94 260.76 137.62 259.13 136.04 258.51 134.11 Z"
          data-name="Johnson"
          data-stusps="WY"
          id="56019"
        />
        <path
          className="white"
          d="M 193.88 164.74 194.2 164.52 194.23 161.54 197.72 162.06 198.82 162.99 199.51 162.14 199.18 164.51 200.05 164.77 201.94 164.33 201.35 167.42 200.16 173.97 195.56 173.13 194.19 172.9 193.68 172.8 193.68 172.8 193.75 171.36 192.75 170.69 192.76 168.58 194.31 166.07 193.88 164.74 Z"
          data-name="Bear Lake"
          data-stusps="ID"
          id="16007"
        />
        <path
          className="white"
          d="M 574.88 380.31 575.54 380.24 580.08 379.77 580.9 379.71 581.43 385.46 580.45 386.86 577.49 386.73 576.9 388.16 575.58 388.26 574.88 380.31 Z"
          data-name="Dale"
          data-stusps="AL"
          id="1045"
        />
        <path
          className="white"
          d="M 676.72 492.68 676.75 492.57 676.88 492.18 677.41 491.82 677.97 491.83 678.35 491.45 678.3 491.08 678.62 490.31 680.38 489.25 681.03 489.41 680.91 489.72 679.22 493.29 677.14 496.52 674.74 499.38 669.58 503.03 667.26 504.03 666.38 503.33 668.17 501.93 671.34 500.05 675.14 496.61 676.58 494.72 676.73 493.52 676.72 492.68 Z M 658.97 483.02 668.81 481.86 668.91 482.71 669.78 490.3 670.45 493.84 670.16 493.93 669.52 494.64 667.93 495.13 666.72 495.39 665.49 494.29 664.86 493.14 665.07 491.44 664.93 490.01 663.66 488.27 662.9 486.53 661.88 485.2 660.67 484.76 660.03 483.42 658.97 483.02 Z M 655.09 507.28 655.98 505.55 657.26 504.53 658.72 503.65 658.91 503.25 661.02 501.93 663.56 502.78 664.81 504.21 663.15 505.09 662.14 505.47 661.36 505.19 660.12 505.73 658.82 506.41 657.32 507.24 655.12 507.72 655.09 507.28 Z M 651.59 508.13 652.06 507.36 654.06 507.09 653.36 508.82 651.45 509 651.59 508.13 Z M 648.51 507.83 649.19 506.85 650.25 507.36 650.11 508.47 648.75 508.68 648.51 507.83 Z"
          data-name="Monroe"
          data-stusps="FL"
          fillRule="evenodd"
          id="12087"
        />
        <path
          className="white"
          d="M 627.85 342.79 629.26 342.04 630.65 343.13 634.6 342.27 634.62 342.37 636.04 342.92 636.07 343.03 636.31 343.88 637.98 344.59 638.69 344.76 638.94 344.81 639.96 345.45 636.74 348.5 635.18 347.86 631.7 349.04 630.94 351.15 629.86 351.46 628.14 351.07 628.59 349.04 627.98 346.72 628.49 343.4 627.85 342.79 Z"
          data-name="Burke"
          data-stusps="GA"
          id="13033"
        />
        <path
          className="white"
          d="M 576.03 359.06 576.3 358.89 580.94 358.53 583.46 357.88 583.67 358.26 584.22 359.59 584.51 360.51 584.66 360.97 585.78 361.98 585.9 362.23 585.04 363.03 580.66 363.56 580.82 364.64 579.16 364.82 578.93 363.18 578.11 363.27 574.63 361.72 574.43 359.81 574.68 359.5 576.03 359.06 Z"
          data-name="Lee"
          data-stusps="AL"
          id="1081"
        />
        <path
          className="white"
          d="M 598.98 203.61 599.23 203.43 600.84 203.21 601.38 203.13 602.28 203.03 602.15 203.87 602.79 206.02 603.05 209.93 601.61 210.06 598.93 210.3 598.84 209.21 597.4 209.07 598.14 207.86 597.75 205.13 599.12 204.72 598.98 203.61 Z"
          data-name="Morrow"
          data-stusps="OH"
          id="39117"
        />
        <path
          className="white"
          d="M 8.63 200.59 10.17 200.54 12.06 203.54 14.56 204.84 15.06 206.4 15.28 206.6 15.23 206.61 14.66 208.03 15.15 208.93 14.44 209.33 14.2 210.2 14.61 210.92 14.83 211.84 13.69 212.04 12.89 211.72 12.18 210.56 11.2 209.59 10.75 209.72 10.21 208.67 9.81 207.68 9.15 206.63 7.98 205.95 7.22 206.54 6.72 206.15 8.15 204.29 8.64 203.13 8.51 201.78 8.74 201.1 8.63 200.59 Z"
          data-name="Marin"
          data-stusps="CA"
          id="6041"
        />
        <path
          className="white"
          d="M 186.05 165.77 188.04 166.15 189.15 166.94 190.03 163.98 192.06 164.09 193.88 164.74 194.31 166.07 192.76 168.58 192.75 170.69 193.75 171.36 193.68 172.8 190.26 172.17 185.22 171.23 185.86 167.98 186.64 166.8 186.05 165.77 Z"
          data-name="Franklin"
          data-stusps="ID"
          id="16041"
        />
        <path
          className="white"
          d="M 613.15 269 614.62 267.98 615.98 267.37 616.51 266.69 616.81 266.46 619.39 269.85 619.71 271.14 617.78 272.25 617.2 272.87 616.72 273.23 614.94 272.2 613.47 270.43 613.15 269 Z"
          data-name="Dickenson"
          data-stusps="VA"
          id="51051"
        />
        <path
          className="white"
          d="M 478.16 233.58 484.66 233.26 484.56 231.62 484.96 231.67 489.57 231.45 489.22 232.39 488.64 234.05 489.78 237.41 489.42 238.64 489.44 239.81 484.75 239.99 484.72 239.97 483.2 239.16 482.78 238.31 482.21 237.51 481.51 237.41 481.08 236.57 480.95 236.46 479.53 235.26 479.08 234.9 478.14 234.14 478.16 233.58 Z"
          data-name="Pike"
          data-stusps="IL"
          id="17149"
        />
        <path
          className="white"
          d="M 578.33 341.22 579.09 341.16 582.74 339.59 582.75 337.73 583.82 337.85 584.96 338.09 585.31 342.01 586.84 341.83 586.84 342.86 586.31 343.09 585.12 344.63 583.87 344.98 579.45 345.4 579.18 344.38 578.95 343.51 578.33 341.22 Z"
          data-name="Carroll"
          data-stusps="GA"
          id="13045"
        />
        <path
          className="white"
          d="M 142.06 59.32 144.17 61.82 149 63.08 150.57 63.8 150.12 65.43 148.56 71.16 146.94 70.69 144.95 70.1 143.11 71.37 138.97 70.24 142.06 59.32 Z"
          data-name="Latah"
          data-stusps="ID"
          id="16057"
        />
        <path
          className="white"
          d="M 451.71 383.1 452.02 381.43 453.04 381.44 454.91 381.93 454.9 380.63 456.77 380.59 455.64 377.32 459.59 377.23 460.77 380.99 459.33 384.11 459.26 385.47 459.42 386 460.35 387.01 462 387.47 463.45 388.95 459.86 392.25 459.31 392.26 459.14 392.01 455.2 392.03 455.12 388.78 453.5 388.81 453.41 385.52 451.76 385.55 451.71 383.1 Z"
          data-name="Natchitoches"
          data-stusps="LA"
          id="22069"
        />
        <path
          className="white"
          d="M 320.86 95.41 327.38 95.98 332.32 95.84 332.9 96.43 332.5 101.38 332.36 103.01 321.62 102.11 317.68 101.75 318.31 95.18 320.86 95.41 Z"
          data-name="Stark"
          data-stusps="ND"
          id="38089"
        />
        <path
          className="white"
          d="M 336.61 62.24 336.48 63.87 338.71 64.05 338.31 68.94 348.09 69.68 348.55 71.35 348.1 77.9 348.44 81.2 337.05 80.4 337.31 77.1 336.67 77.05 337.19 70.5 336.55 70.45 336.82 67.18 333.57 66.91 333.84 63.65 334.85 63.73 334.99 62.1 336.61 62.24 Z"
          data-name="Ward"
          data-stusps="ND"
          id="38101"
        />
        <path
          className="white"
          d="M 416.3 70.39 419.54 70.35 421.17 70.34 421.21 73.61 431 73.45 431.29 81.61 431.31 83.25 431.48 90.78 431.49 91.4 428.25 91.48 426.6 91.51 421.71 91.51 421.5 82.88 420.43 81.89 421.03 80.11 416.57 80.12 416.45 79.81 416.43 77.26 416.3 70.39 Z"
          data-name="Beltrami"
          data-stusps="MN"
          id="27007"
        />
        <path
          className="white"
          d="M 446.91 140.25 447.93 139.84 448.62 138.87 448.87 138.36 449.95 137.67 450.98 138.25 451.14 139.08 451.11 140.41 454.11 140.61 454.96 141.41 455.01 143.01 454.2 143.04 454.26 144.67 450.97 145.3 450.99 146.12 447.74 146.22 447.69 144.87 447.69 143.24 447.1 141.63 446.91 140.25 Z"
          data-name="Dakota"
          data-stusps="MN"
          id="27037"
        />
        <path
          className="white"
          d="M 491.71 410.39 492.24 409.92 493.79 409.86 494.81 410.31 497.15 412.91 498.13 412 498.01 413.03 493.59 414.23 492.84 415.13 491.02 414.93 490.8 415.29 490.52 415.31 490.48 414.45 490.72 413.82 490.98 413.44 491.17 412.45 491.67 410.69 491.71 410.39 Z"
          data-name="Ascension"
          data-stusps="LA"
          id="22005"
        />
        <path
          className="white"
          d="M 70.37 66.78 70.72 66.74 71.36 66.32 72.18 66.32 73.09 66.9 74.04 67 75.94 67.21 76.04 67.3 76.97 68.14 75.82 71.48 73.62 76.17 70.79 75.21 71.52 73.04 70.48 70.85 69.73 69.34 70.37 66.78 Z"
          data-name="Hood River"
          data-stusps="OR"
          id="41027"
        />
        <path
          className="white"
          d="M 21.19 233.78 22.19 233.96 22.81 233.76 22.95 233.73 23.09 233.56 23.49 233.38 23.6 233.19 23.83 232.92 24.68 232.82 25.05 233.51 28.18 234.39 27.69 234.97 28.64 237.11 31.56 239.92 35.19 246.14 34.36 249.22 32.76 250.04 31.74 248.91 32.12 250.02 31.77 251.23 31.14 250.91 29.99 248.76 29.23 248.16 27.29 248.68 27.43 247.39 25.71 244.39 25.25 242.99 24.18 242.77 24.66 240.68 24.38 239.81 22.76 238.57 23.23 237.89 21.59 235.08 21.19 233.78 Z"
          data-name="San Benito"
          data-stusps="CA"
          id="6069"
        />
        <path
          className="white"
          d="M 475.73 185.95 478.98 185.79 482.22 185.61 482.5 190.52 482.59 192.16 476.04 192.5 475.73 185.95 Z"
          data-name="Jones"
          data-stusps="IA"
          id="19105"
        />
        <path
          className="white"
          d="M 516.85 366.65 516.93 366.64 523.35 366.23 523.79 372.85 517.26 373.28 516.85 366.65 Z"
          data-name="Newton"
          data-stusps="MS"
          id="28101"
        />
        <path
          className="white"
          d="M 614.83 378.85 617.98 378.56 618.18 379.53 620.24 382.08 620.23 383.83 620.45 384.52 618.38 384.75 618.11 387.12 616.52 387.27 616.69 386.55 615.96 385.97 615.38 383.23 613.55 381.41 614.47 380.33 614.36 379.12 614.83 378.85 Z"
          data-name="Berrien"
          data-stusps="GA"
          id="13019"
        />
        <path
          className="white"
          d="M 494.05 354.85 496.59 354.71 496.53 353.61 498.14 353.52 498.87 355.26 500.09 353.92 500.27 357.02 498.71 357.89 499.86 359.44 498.52 359.53 498.59 361.14 495.32 361.32 495.13 358.06 494.44 358.1 494.79 357.96 494.68 356.1 494.05 354.85 Z"
          data-name="Humphreys"
          data-stusps="MS"
          id="28053"
        />
        <path
          className="white"
          d="M 602.27 316.16 603.29 316.09 604.29 317.5 605.89 317.16 607.24 317.57 607.46 318.13 607.1 318.39 606.09 322.19 604.83 322.2 603.76 323.48 602.79 322.22 603.48 321.4 602.48 319.26 602.93 317.82 601.86 316.63 602.27 316.16 Z"
          data-name="Habersham"
          data-stusps="GA"
          id="13137"
        />
        <path
          className="white"
          d="M 356.61 340.54 356.83 334.7 356.89 334.71 357.66 335.04 358.1 333.9 358.79 334.02 359.93 335.01 360.72 336.18 360.87 336.4 361.15 338.28 362.05 338.4 363.18 338.59 364.06 338.48 364.84 338.58 364.62 345.53 356.44 345.26 356.61 340.54 Z"
          data-name="Wilbarger"
          data-stusps="TX"
          id="48487"
        />
        <path
          className="white"
          d="M 613.93 280.57 615.79 280.3 618.73 279.89 619.51 279.79 620.57 279.64 621 279.58 624.22 279.11 624.34 278.67 625.81 278.48 625.16 278.82 623.71 280.85 620.87 283.34 619.18 283.66 617.19 282.96 614.51 283.8 613.27 283.81 612.88 283.41 614.12 282.01 613.93 280.57 Z"
          data-name="Sullivan"
          data-stusps="TN"
          id="47163"
        />
        <path
          className="white"
          d="M 482.33 341.45 483.54 342.46 486.31 342.26 486.85 342.85 485.82 340.6 486 339.92 486.99 339.22 489.36 339.12 489.69 339.14 489.68 339.27 490.4 339.52 490.83 339.92 490.59 340.78 489.82 340.99 489.25 341.35 488.88 341.8 488.19 341.68 487.58 342.16 488.42 342.45 488.61 343.11 488.09 343.71 488.26 344.7 488.71 345.03 488.73 345.82 487.79 345.62 487.39 345.68 486.91 346.21 488.01 346.78 487.65 347.81 486.45 348.04 487.22 348.76 486.34 349.45 486.09 350.04 485.5 350.6 483.85 350.63 483.83 349.8 482.2 349.87 482.07 345.8 480.39 345.82 480.38 342.18 482.33 341.45 Z"
          data-name="Desha"
          data-stusps="AR"
          id="5041"
        />
        <path
          className="white"
          d="M 185.69 139.44 197.9 141.89 198.7 142.14 200.97 142.58 203.1 142.99 203.32 144.55 205.39 145.77 204.75 149.25 203.9 153.83 203.72 154.82 196.19 153.39 197.16 148.47 193.94 147.84 194.25 146.26 191.22 145.65 191.38 144.83 190.62 144.39 184.91 143.23 185.69 139.44 Z"
          data-name="Bonneville"
          data-stusps="ID"
          id="16019"
        />
        <path
          className="white"
          d="M 529.88 258.76 530.73 258.09 531.8 257.27 532.46 256.01 532.81 255.07 536.48 253.3 536.88 252.54 537 253.8 537.97 255.42 539.31 255.19 539.54 257.73 539.61 258.57 537.44 259.45 534.16 259.69 532.45 259.21 532.41 258.71 529.87 258.89 529.88 258.76 Z"
          data-name="Gibson"
          data-stusps="IN"
          id="18051"
        />
        <path
          className="white"
          d="M 552.54 282.36 553.07 283.31 555.88 283.47 555.85 284.06 555.84 285.96 556.01 286.48 554.54 286.55 553.91 286.88 553.74 286.85 553.04 286.7 550.67 286.99 550.71 285.5 551.88 282.55 552.54 282.36 Z"
          data-name="Simpson"
          data-stusps="KY"
          id="21213"
        />
        <path
          className="white"
          d="M 490.21 100.79 490.83 100.01 492.23 99.4 493.25 99.42 494.17 99.22 495.07 98.97 496.15 98.83 498.45 97.34 499.43 95.9 500.87 95.46 501.75 95.25 502.04 94.75 502.5 99.79 503.38 99.71 503.52 101.32 501.9 101.45 502.3 106.34 502.45 107.98 497.58 108.37 497.32 105.13 492.45 105.52 492.33 103.89 490.72 104.01 490.48 100.77 490.21 100.79 Z"
          data-name="Ontonagon"
          data-stusps="MI"
          id="26131"
        />
        <path
          className="white"
          d="M 641.5 336.61 644.01 333.1 645.49 332.06 646.15 331.74 647.25 332.79 648.06 333.36 650.17 333.14 653.6 335.31 654.34 333.27 655.25 333.27 657.22 335.17 659.95 334.78 659.87 337.6 658.26 338.66 656.24 338.53 655.79 337.54 651.64 341.14 651.53 341.23 650.58 340.18 649.86 339.78 649.83 339.84 649.76 339.72 649.31 339.49 648.9 339.16 644.03 337.22 642.66 336.62 641.5 336.61 Z"
          data-name="Orangeburg"
          data-stusps="SC"
          id="45075"
        />
        <path
          className="white"
          d="M 620.79 329.35 621.66 328.11 624.89 327.83 625.45 329.54 626.32 328.53 627.11 329.18 629.54 328.75 629.59 329.33 627.94 330.02 628.86 331.81 628.03 333.96 629.65 335.48 629.44 336.2 628.98 336.12 628.66 336.06 627.94 335.26 627.6 334.72 627.13 333.95 625.55 332.44 623.74 331.78 622.28 330.63 621.56 330.56 621.44 330.36 620.85 329.43 620.79 329.35 Z"
          data-name="McCormick"
          data-stusps="SC"
          id="45065"
        />
        <path
          className="white"
          d="M 682.82 224.78 683.94 222.47 684.27 221.77 685.04 220.19 685.34 220.21 686.36 220.49 686.36 220.49 686.5 221.27 687.27 221.46 688.12 221.36 688.63 221.84 688.57 221.93 688.02 222.78 687.76 222.78 687.67 222.74 687.76 222.81 687.73 222.99 687.82 223.12 688.07 223.06 688.31 223.12 688.43 223.04 689.13 223.53 688.81 224.35 690.43 224.41 690.56 225.14 690.6 225.31 690.53 225.88 690.14 225.97 690.06 226.07 689.49 226.81 689.68 227.54 688.29 227.83 687.82 227.2 687.18 226.85 686.88 226.74 685.97 226.53 685.62 226.67 685.39 226.19 685.07 226.34 684.93 225.82 684.37 225.32 684.02 225.54 683.64 225.35 683.24 224.82 682.82 224.78 Z M 685.82 223.81 686.09 224.35 686.41 224.26 686.78 224.08 686.68 223.61 685.82 223.81 Z"
          data-name="Fairfax"
          data-stusps="VA"
          fillRule="evenodd"
          id="51059"
        />
        <path
          className="white"
          d="M 613.45 310.26 613.45 310.26 615.16 309.46 615.5 309.49 615.77 310.11 618.48 309.23 618.3 310.54 619.15 310.28 620.45 313.88 616.12 317.28 615.43 318.32 614.93 316.42 614.19 316.21 613.66 312.56 612.91 311.63 613.45 310.26 Z"
          data-name="Pickens"
          data-stusps="SC"
          id="45077"
        />
        <path
          className="white"
          d="M 653.5 275.49 653.5 275.49 655.58 275.14 658.28 274.69 661.37 274.17 662.05 279.74 662.06 279.9 654.29 280.91 653.5 275.49 Z"
          data-name="Rockingham"
          data-stusps="NC"
          id="37157"
        />
        <path
          className="white"
          d="M 652.48 270.75 653 269.96 657.01 269.73 658.04 269.14 658.38 268.53 658.28 274.69 655.58 275.14 653.5 275.49 653.5 275.49 653.1 275.55 651.72 271.17 652.48 270.75 Z M 655.12 272.69 655.68 272.79 655.71 273.01 655.98 273.09 656.02 272.78 656.16 273.01 656.19 272.75 655.89 272.55 655.88 271.93 655.42 271.85 655.19 271.91 654.93 272.48 655.12 272.69 Z"
          data-name="Henry"
          data-stusps="VA"
          fillRule="evenodd"
          id="51089"
        />
        <path
          className="white"
          d="M 214.97 171.35 222.73 172.79 229.06 173.8 233.08 174.44 248.69 176.77 250.31 176.99 249.86 180.26 248.92 188.37 243 187.51 242.3 192.42 241.41 199.91 236.67 199.26 225.27 197.55 222.41 197.1 215.77 196.1 211.69 195.44 211.01 195.33 212.84 184.4 214.97 171.35 Z"
          data-name="Sweetwater"
          data-stusps="WY"
          id="56037"
        />
        <path
          className="white"
          d="M 191.61 183.65 193.96 179.59 193.7 176.37 193.16 175.57 193.94 174.25 193.68 172.8 194.19 172.9 195.56 173.13 200.16 173.97 198.74 181.91 198.69 182.18 197.98 186.03 197.61 188.09 194.59 189.66 194.14 189.55 195 188.33 194.18 187.99 194.71 186.69 193.92 185.36 192.67 185.06 191.94 184.47 191.61 183.65 Z"
          data-name="Rich"
          data-stusps="UT"
          id="49033"
        />
        <path
          className="white"
          d="M 758.66 149.11 759.15 148.21 760.49 148.81 760.87 147.62 761.02 147.75 761.14 147.85 762.11 147.86 762.38 148.97 763.23 150.88 763.02 151.18 762.43 151.94 762.1 151.86 761.64 151.75 761.54 151.73 760.94 151.78 760.76 152.58 760.22 152.76 759.62 152.73 759.25 152.94 759.26 152.48 758.66 149.11 Z"
          data-name="Newport"
          data-stusps="RI"
          id="44005"
        />
        <path
          className="white"
          d="M 224.99 97.31 225.11 96.63 233.28 98.14 233 99.77 233.64 99.89 233.34 101.52 235.8 101.96 235.44 103.53 234.35 103.36 234.06 105.03 233.5 104.92 233.02 106.52 232.47 109.8 230.85 109.51 230.7 110.33 229.08 110.04 228.93 110.85 227.31 110.56 226.72 113.82 224.97 113.5 224.37 116.82 222.2 116.43 222.92 113.13 224.4 104.95 223.46 104.77 224.67 98.23 224.99 97.31 Z"
          data-name="Sweet Grass"
          data-stusps="MT"
          id="30097"
        />
        <path
          className="white"
          d="M 187.13 95.9 189.56 94.99 189.6 93.84 190.96 93.06 191.93 93.28 192.3 91.64 193.55 91.92 195.08 91.4 196.04 91.5 195.65 92.36 196.16 97.33 195.83 98.27 198.42 100.54 194.83 99.9 194.42 99.47 193.44 100.74 191.39 101.47 190.95 98.95 188.19 97.16 187.13 95.9 Z"
          data-name="Silver Bow"
          data-stusps="MT"
          id="30093"
        />
        <path
          className="white"
          d="M 202.08 136.93 204.98 137.3 207.07 136.7 206.81 138.11 206.04 142.26 205.39 145.77 203.32 144.55 203.1 142.99 200.97 142.58 202.08 136.93 Z"
          data-name="Teton"
          data-stusps="ID"
          id="16081"
        />
        <path
          className="white"
          d="M 287.83 399.37 297.9 388.63 299.12 389.11 300.74 390.78 301.74 390.34 303.25 389.75 304.4 391.01 305.64 391.17 307.08 392.56 307.62 394.59 309.11 395.63 310.58 395.82 310.71 396.35 314.06 396.85 315.62 398.09 316.63 402.4 317.21 403.31 317.21 403.31 317.2 403.3 313.49 403.09 313.45 403.07 312.94 403.03 312.93 403.03 312.91 403.03 312.9 403.03 312.9 403.04 311.22 402.93 311.14 404.03 307.82 403.81 307.48 409.72 303.82 409.53 303.57 413.86 290.06 401.43 287.83 399.37 Z"
          data-name="Pecos"
          data-stusps="TX"
          id="48371"
        />
        <path
          className="white"
          d="M 264.92 400.24 282.22 405.67 283.85 405.78 282.78 422.96 282.45 427.49 281.44 427 279.51 426.6 278.23 425.84 276.84 424.76 276.28 423.9 275.57 422.81 274.32 421.9 273.31 421.47 272.06 420.23 270.73 418.76 270.43 416.95 269.66 415.49 268.89 414.17 268.79 412.67 268.53 412 268.85 410.45 268.83 408.47 268.28 407.52 268 406.71 267.08 405.32 266.53 404.9 266.47 403.6 266.26 402.13 265.79 400.77 265.03 400.6 264.92 400.24 Z"
          data-name="Presidio"
          data-stusps="TX"
          id="48377"
        />
        <path
          className="white"
          d="M 585.24 376.22 586.15 376.3 587.99 375.99 588.32 377.82 588.64 377.94 588.56 378.97 590.57 378.74 590.94 380.72 590.77 380.99 587.41 381.61 586.98 381.02 587.09 380.53 586.78 380.06 586.69 379.13 585.46 377.82 585.49 377.1 585.33 376.54 585.24 376.22 Z"
          data-name="Clay"
          data-stusps="GA"
          id="13061"
        />
        <path
          className="white"
          d="M 349.47 415.6 350.57 415.64 350.45 418.74 351.89 418.8 351.72 424.06 344.98 423.9 344.86 419.67 345.36 418.78 346.05 415.32 349.47 415.6 Z"
          data-name="Real"
          data-stusps="TX"
          id="48385"
        />
        <path
          className="white"
          d="M 683.82 241.15 684.56 241.34 687.35 242.89 689.07 244.64 689.81 244.25 690.37 245.24 691.84 245.33 693.78 246.65 693.67 247.35 692.36 248.7 689.86 248.02 689.56 247.8 688.7 246.56 685.82 246.71 684.6 246.94 683.23 246.74 683.48 245.09 683.82 241.15 Z"
          data-name="Hanover"
          data-stusps="VA"
          id="51085"
        />
        <path
          className="white"
          d="M 380.5 451.95 384.63 452.89 385.09 452.24 386.07 452.18 386.97 453.15 388.8 452.81 389.73 453.97 391.76 457.2 390.9 458.67 391.26 458.43 390.87 458.7 389.85 457.7 388.03 458.16 388.41 457.56 385.94 457.91 384.99 457.98 384.21 458.01 383.88 457.36 383.4 457.82 382.79 457.5 382.53 456.84 380.61 456.48 380.77 455.35 380.73 454.55 380.11 454.61 379.38 454.18 379.05 453.1 380.5 451.95 Z"
          data-name="San Patricio"
          data-stusps="TX"
          id="48409"
        />
        <path
          className="white"
          d="M 505.21 370.65 505.04 370.3 505.06 370.28 505.12 370.27 505.12 370.32 505.14 370.33 505.19 370.34 505.22 370.31 505.24 370.27 505.2 370.23 505.18 370.16 505.14 370.12 505.11 370.01 505.12 369.93 505.14 369.92 505.17 369.94 505.29 369.98 505.31 369.98 505.33 369.94 505.33 369.9 505.34 369.89 505.37 369.91 505.43 369.92 505.48 369.9 505.52 369.87 505.57 369.84 505.6 369.79 505.63 369.76 505.62 369.72 505.6 369.71 505.57 369.75 505.55 369.73 505.56 369.69 505.64 369.58 505.67 369.55 505.7 369.5 505.71 369.45 505.73 369.44 505.76 369.44 505.77 369.43 505.79 369.36 505.8 369.33 505.79 369.29 505.79 369.26 505.8 369.26 505.87 369.25 505.89 369.22 505.87 369.19 505.87 369.15 505.88 369.14 505.93 369.15 505.96 369.12 505.96 369.09 505.97 369.08 505.99 369.11 506.01 369.11 506.06 369.09 506.06 369.03 506.07 369 506.13 368.98 506.22 368.96 506.26 369.02 506.29 369.03 506.31 368.99 506.36 368.94 506.41 368.93 506.42 368.93 506.41 368.86 506.44 368.79 506.45 368.73 506.46 368.73 506.5 368.77 506.54 368.76 506.57 368.81 506.58 368.81 506.61 368.76 506.64 368.75 506.72 368.78 506.77 368.84 506.79 368.84 506.8 368.82 506.79 368.78 506.82 368.72 506.87 368.7 506.88 368.67 506.87 368.63 506.88 368.61 506.95 368.59 507.02 368.55 507.05 368.55 507.08 368.52 507.08 368.5 507.08 368.5 507.05 368.51 507.01 368.49 507.02 368.47 507.07 368.41 507.1 368.4 507.16 368.41 507.18 368.4 507.24 368.42 507.27 368.4 507.29 368.36 507.27 368.32 507.31 368.27 507.33 368.24 507.35 368.17 507.35 368.1 507.38 368.08 507.43 368.1 507.48 368.09 507.51 368.1 507.54 368.09 507.55 368.06 507.54 368.02 507.51 367.99 507.5 367.97 507.53 367.93 507.55 367.92 507.63 367.93 507.67 367.91 507.7 367.86 507.71 367.82 507.77 367.85 507.81 367.82 507.78 367.78 507.78 367.76 507.81 367.72 507.81 367.68 507.79 367.65 507.76 367.61 507.76 367.6 507.8 367.57 507.83 367.53 507.85 367.51 507.9 367.42 507.97 367.45 508.05 367.48 508.08 367.49 508.12 367.47 508.14 367.45 508.16 367.41 508.21 367.38 508.21 367.36 508.21 367.32 508.25 367.29 508.26 367.17 508.6 366.82 509.5 366.89 510.61 371.23 510.75 373.69 510.94 376.97 502.93 377.36 502.44 375.48 503.36 374.74 503.52 373.07 503.85 372.85 505.21 370.65 Z"
          data-name="Rankin"
          data-stusps="MS"
          id="28121"
        />
        <path
          className="white"
          d="M 446.64 352.52 450.36 352.55 450.36 353.09 452.22 353.1 451.1 356.62 450.47 356.6 450.44 361.13 449.96 361.13 446.76 361.19 445.44 361.22 444.52 359.74 444.98 358.8 446.49 358.45 446.44 357.78 447.56 355.36 446.92 355.19 447 354.28 446.26 353.23 446.64 352.52 Z"
          data-name="Lafayette"
          data-stusps="AR"
          id="5073"
        />
        <path
          className="white"
          d="M 42.03 133.44 44.79 125.29 45.05 124.66 48.39 114.85 48.85 113.51 51.5 114.23 53.12 111.89 54.32 111.3 54.35 109.57 53.29 107.22 54.06 105.03 56.18 104.53 65.32 107.56 63.5 112.37 59.75 123.83 66.21 125.95 61.79 140.11 59.61 139.43 56.59 138.39 53.93 137.55 53.82 137.51 50.63 136.42 48.24 135.58 44.66 134.35 42.03 133.44 42.03 133.44 Z"
          data-name="Klamath"
          data-stusps="OR"
          id="41035"
        />
        <path
          className="white"
          d="M 465.47 212.7 472.04 212.39 472.11 214.03 472.32 217.97 472.13 217.79 469.13 218.07 469.08 218.07 465.7 218.32 465.47 212.7 Z"
          data-name="Van Buren"
          data-stusps="IA"
          id="19177"
        />
        <path
          className="white"
          d="M 698.38 290.97 699.74 289.92 700.56 290.25 701.24 288.85 705.28 290.38 706.44 291.09 705.38 293.26 706.24 293.8 706.42 295.7 709.4 296.52 710.36 295.7 711.46 296.36 711.08 297.8 708.18 298.85 707.19 299.75 705.23 300.09 704.68 299.81 703.79 295.28 702.52 295.28 697.49 293.32 697.79 291.27 698.38 290.97 Z"
          data-name="Craven"
          data-stusps="NC"
          id="37049"
        />
        <path
          className="white"
          d="M 563.67 374.73 564.37 374.68 564.21 373.05 565.85 372.88 566.02 374.51 567.8 374.33 567.97 377.66 568.79 377.57 569.03 379.98 568.58 380.91 569.12 380.84 569.29 382.34 568.48 382.56 568.64 384.25 567.28 384.08 567.1 382.71 565.32 384.33 565.17 382.91 563.57 383.08 563.36 380.63 564.18 380.55 563.67 374.73 Z"
          data-name="Crenshaw"
          data-stusps="AL"
          id="1041"
        />
        <path
          className="white"
          d="M 591.54 310.12 591.55 309.72 592.37 308.81 593.14 309.26 594.37 308.99 595.33 308.02 596.44 309.3 598.48 308.32 600.49 308.22 600.71 308.4 600.16 310.04 598.38 310.6 596.39 313.72 594.46 313.94 591.47 314.29 591.54 310.12 Z"
          data-name="Cherokee"
          data-stusps="NC"
          id="37039"
        />
        <path
          className="white"
          d="M 609.59 377.69 609.54 377.15 611.95 376.92 612 377.37 613.33 377.54 614.83 378.85 614.36 379.12 614.47 380.33 613.55 381.41 613.18 381.91 612.33 381.99 610.02 382.19 609.84 380.23 609.51 379.28 609.74 379.16 609.59 377.69 Z"
          data-name="Tift"
          data-stusps="GA"
          id="13277"
        />
        <path
          className="white"
          d="M 568.48 276.4 570.57 275.05 570.94 274.55 571.43 273.46 573.18 272.78 573.51 272.01 575.26 272.83 575.61 274.14 573.57 277.98 573.32 279.38 569.97 279.5 570.03 279.13 569.05 278.28 568.48 276.4 Z"
          data-name="Adair"
          data-stusps="KY"
          id="21001"
        />
        <path
          className="white"
          d="M 457.32 409.62 458.38 409.31 463.09 409.21 463.09 408.26 465.43 408.2 465.4 408.33 466.04 409.45 465.48 410.33 466.23 413.91 465.72 415.61 465.53 416 463.92 416.69 463.59 416.66 459.69 416.78 459.67 415.96 461.45 415.9 461.32 414.53 459.64 414.56 459.03 412.64 458.97 410.41 457.33 410.01 457.32 409.62 Z"
          data-name="Jefferson Davis"
          data-stusps="LA"
          id="22053"
        />
        <path
          className="white"
          d="M 164.24 27.92 170.94 29.76 174.53 30.75 180.42 32.26 180.81 32.91 180.23 33.44 180.1 35.33 179.44 35.8 180.65 37.26 179.34 38.26 179.87 38.91 176.79 38.12 176.38 39.7 176.86 39.83 175.21 46.31 173.07 45.76 172.18 49.67 170.38 49.2 169.51 50.87 168.2 51.17 167.71 50.5 165.21 50.02 164.95 49.28 165.4 48.26 165.02 47.7 164.81 45.41 164.4 44.43 164.84 43.97 164.24 42.7 163.34 43.24 161.44 43.5 161.01 44.08 160.21 42.52 160.68 40.78 161.56 37.59 161.67 37.2 164.24 27.92 Z"
          data-name="Lincoln"
          data-stusps="MT"
          id="30053"
        />
        <path
          className="white"
          d="M 260.16 278.79 260.3 278.81 264.51 279.24 264.54 279.25 267.3 279.53 269.03 279.71 271.57 279.97 272.03 280.02 272.19 281.55 271.62 282.79 271.37 285.12 270.14 284.98 269.17 285.72 269.38 286.57 268.82 288.13 269.6 289.35 268.94 290.09 269.31 290.96 268.83 293.64 267.74 294.01 267.38 295.97 265.47 298.04 262.5 296.08 260.9 293.44 257.96 291.86 258.32 291.35 259.58 290.93 260.11 288.94 259.97 284.14 260.46 280.9 260.16 278.79 Z"
          data-name="Taos"
          data-stusps="NM"
          id="35055"
        />
        <path
          className="white"
          d="M 751.69 158.92 752.92 158.23 753.27 158.92 751.68 159.72 751.69 158.92 Z M 735.03 177.06 734.75 175.97 734.24 174.81 734.11 174.5 733.19 172.41 732.39 171.48 732.45 170.99 733.21 171.02 733.73 170.47 734.74 170.71 736.23 170.77 736.34 170.78 737.37 170.01 737.29 169.49 737.7 169.05 738.74 168.91 741.32 168.17 743.44 167.34 745.09 166.47 746.01 165.27 746.62 164.22 747.3 163.58 747.64 162.83 748.45 162.28 749.7 161.14 749.89 161.4 749.22 162.98 749.04 163.91 750.13 164.15 750.85 163.69 751.03 162.37 751.71 162.45 751.8 163.4 752.61 163.85 753.66 162.51 754.18 162.16 755.14 162.09 754.34 163.64 752.3 165.2 749.71 167.09 748.51 168.18 743.86 171.57 741.73 173.2 740.62 174.19 738.87 175.35 738.05 175.89 736.69 176.46 735.99 176.45 735.03 177.06 Z"
          data-name="Suffolk"
          data-stusps="NY"
          fillRule="evenodd"
          id="36103"
        />
        <path
          className="white"
          d="M 617.3 224.99 617.49 224.11 619.21 224.09 618.83 222.14 620.64 221.81 622.33 221.6 622.14 220.42 623.42 221.07 625.04 220.72 628.74 220.76 628.84 221.4 628.37 222.03 627.87 223.13 627.79 223.3 627 223.79 626.21 224.71 624.9 225.78 624.56 225.78 624.21 225.78 623.8 225.02 623.12 224.85 622.54 225.64 621.84 226.57 621.92 227.62 621.21 227.75 620.27 227.93 619.95 229.03 619.83 229.21 619.65 228.11 618.22 228.28 617.57 227.5 617.3 224.99 Z"
          data-name="Washington"
          data-stusps="OH"
          id="39167"
        />
        <path
          className="white"
          d="M 305.81 113.55 310.85 114.06 313.81 114.35 316.65 114.62 319.57 114.89 320.27 114.95 318.84 128.68 304.47 127.31 304.7 125 304.98 122.09 305.11 120.83 305.47 117.22 305.68 115.07 305.71 114.74 305.81 113.55 Z"
          data-name="Harding"
          data-stusps="SD"
          id="46063"
        />
        <path
          className="white"
          d="M 31.05 186.48 35.06 187.68 35.21 187.93 34.57 192.03 33.74 195.34 34.53 194.46 36.58 194.57 36.18 195.92 35.36 195.67 34.04 199.26 32.92 198.88 32.27 198.7 31.26 198.24 31.15 195.95 29.93 195.05 29.9 194.04 30.91 192.87 29.97 190.98 29.76 188.67 31.05 186.48 Z"
          data-name="Sutter"
          data-stusps="CA"
          id="6101"
        />
        <path
          className="white"
          d="M 638.46 362.88 643.8 360.45 644.64 363.03 644.9 363.12 646.84 365.11 649.63 367.11 649.11 367.95 649.74 369.86 647.92 369.32 646.21 368.37 645.03 366.03 643.86 365.61 641.96 365.92 641.69 365.24 640.05 363.92 639.63 363.95 638.98 363.75 638.46 362.88 Z"
          data-name="Bryan"
          data-stusps="GA"
          id="13029"
        />
        <path
          className="white"
          d="M 551.87 200.86 552.2 200.76 551.57 195.89 557.31 195.2 557.51 196.81 557.65 197.87 557.9 200.06 557.42 200.12 557.74 202.59 556.16 202.83 554.03 203.09 552.08 202.52 551.87 200.86 Z"
          data-name="Kosciusko"
          data-stusps="IN"
          id="18085"
        />
        <path
          className="white"
          d="M 553.97 246.47 556.63 245.82 559.37 246.02 559.73 246.41 560.1 249.4 560.46 249.35 560.69 249.6 560.26 250.75 559.19 250.9 558.69 251.21 558.81 252.53 558.24 252.6 554.94 252.86 554.15 252.94 553.63 247.95 553.52 247.1 553.97 246.47 Z"
          data-name="Washington"
          data-stusps="IN"
          id="18175"
        />
        <path
          className="white"
          d="M 470.82 399.09 471.99 399.1 471.47 395.94 471.37 392.38 473.11 392.61 473.72 392.04 474.69 391.87 474.99 392.18 475.34 394.05 476.32 392.71 477.83 393.19 480.42 394.57 479.78 395.6 479.77 397.29 479.36 397.79 478.5 398.63 478.42 401.02 474.97 401.12 471.99 401.24 471.59 401.25 470.82 399.09 Z"
          data-name="Avoyelles"
          data-stusps="LA"
          id="22009"
        />
        <path
          className="white"
          d="M 180.93 78.71 182.98 79.24 183.23 78.16 185.78 78.19 186.03 77.11 188.43 77.08 190.33 79.85 191.41 79.66 189.47 88.44 189.29 89.25 186.06 88.54 185.39 91.88 183.97 92.08 181.82 93.14 180.22 92.28 180.01 90.84 178.5 90.45 179.49 89.2 179.04 87.12 180.22 86.22 179.83 85.82 180.2 84.49 179.68 82.76 179.65 81.42 180.82 80.11 180.93 78.71 Z"
          data-name="Granite"
          data-stusps="MT"
          id="30039"
        />
        <path
          className="white"
          d="M 47.99 78.43 48.26 77.92 49.54 78.62 49.66 79.74 50.56 79.34 53.37 78.81 54.46 79.6 55.49 79.67 56.1 80.34 59.78 82.09 60.08 83.21 61.48 83.12 62.64 84.35 65.73 85.46 65.24 87.16 63.87 88.84 63.29 90.7 62.63 92.71 63.02 93.42 55.89 91.08 54.88 91.48 52.36 90.37 51.68 89.31 50.28 88.32 48.87 87.89 48.17 88.23 47.75 89.31 44.25 88.07 44.62 86.44 44.07 85.21 45.67 82.08 45.39 80.98 47.12 79.93 48.53 80.1 47.99 78.43 Z"
          data-name="Linn"
          data-stusps="OR"
          id="41043"
        />
        <path
          className="white"
          d="M 688.51 233.4 688.87 233.69 690.35 233.12 691.36 232.78 692.01 232.49 692.54 232.99 692.57 233.52 693.1 233.87 692.46 234.37 692.6 236.3 692.5 236.73 691.83 236.7 690.17 236.11 689.75 235.24 688.3 235.55 687.9 233.87 688.51 233.4 Z"
          data-name="King George"
          data-stusps="VA"
          id="51099"
        />
        <path
          className="white"
          d="M 719.48 117.62 721.51 116.76 720.96 115.48 723.47 114.56 723.88 115.3 724.54 114.67 725.42 113.84 725.63 114.07 726.17 114.13 726.22 113.91 726.84 114.03 727.07 114.38 726.89 115.61 727.13 115.65 727.05 116.17 728.86 116.29 728.61 118.35 729.02 120.44 729.73 120.45 729.74 122.42 728.47 122.69 728.67 124.18 727.25 124.79 727.01 124.57 723.28 125.45 723.05 124.52 722.28 121.25 721.32 120.52 720.62 119.88 720 121.23 719.43 120.77 719.26 119.61 719.32 118.76 719.48 117.62 Z"
          data-name="Rutland"
          data-stusps="VT"
          id="50021"
        />
        <path
          className="white"
          d="M 175.06 96.66 176.51 95.04 176.91 95.74 179.05 94.4 181.42 94.21 181.83 93.17 182.88 96.93 186 95.17 187.13 95.9 188.19 97.16 190.95 98.95 191.39 101.47 190.76 104.11 191.42 105.09 193.05 105.39 193.31 107.27 192.28 112.17 193.92 112.52 193.57 114.17 195.47 114.57 195.12 117.89 196.47 118.18 196.31 118.98 200.1 119.8 199.83 121.16 204.12 122.27 203.9 122.54 202.87 124.22 202.18 124.62 201.46 124.44 200.3 124.15 198.73 124.78 198.08 123.63 195.79 123.68 194.53 123.6 193.29 123.06 192.52 122.41 191.39 122.95 190.69 124.39 189.66 123.55 187.98 122.98 186.6 122.45 186.22 122.44 184.74 123.24 184.68 123.92 184.61 123.94 183.77 124.25 182.98 123.37 182.46 122.17 182.65 121.3 182.16 120.03 182.53 119.09 182.16 117.45 181.98 116.31 180.68 114.88 179.85 115.17 178.99 114.27 178.42 113.99 178.01 112.56 178.53 111.83 178.9 110.86 178.94 109.84 178.33 108.9 177.6 108.18 177.05 105.96 176.31 104 176.61 102.89 176.38 101.99 176.66 101.01 176.28 100.09 176.57 98.6 175.94 98.03 175.54 97.53 175.06 96.66 Z"
          data-name="Beaverhead"
          data-stusps="MT"
          id="30001"
        />
        <path
          className="white"
          d="M 68.81 57.87 71.09 51.73 71.14 51.74 72.72 52.29 73.79 52.65 80.35 54.94 80.35 54.95 78.12 61.35 76.96 60.94 75.31 65.82 76.04 67.3 75.94 67.21 74.04 67 73.09 66.9 72.18 66.32 71.36 66.32 70.72 66.74 70.37 66.78 69.94 66.83 69.08 67.13 67.58 67.29 66.47 67.01 65.43 67.23 68.81 57.87 Z"
          data-name="Skamania"
          data-stusps="WA"
          id="53059"
        />
        <path
          className="white"
          d="M 450.99 146.12 450.97 145.3 454.26 144.67 454.2 143.04 455.01 143.01 454.96 141.41 455.45 141.87 456.56 143.26 457.5 143.89 459.53 144.17 460.04 144.13 460.65 144.48 460.69 144.5 461.05 145.47 461.69 146.03 459.2 146.12 459.26 147.75 457.64 147.81 457.77 151.07 456.04 151.13 451.15 151.28 450.99 146.12 Z"
          data-name="Goodhue"
          data-stusps="MN"
          id="27049"
        />
        <path
          className="white"
          d="M 63.02 93.42 62.63 92.71 63.29 90.7 73.15 94.06 71.66 98.81 73.19 99.39 72.14 102.64 75.35 103.75 74.84 105.37 79.85 106.95 79.35 108.58 80.97 109.1 80.47 110.72 85.38 112.26 84.89 113.9 78.69 111.96 78.35 111.76 65.32 107.56 56.18 104.53 56.77 104.49 56.7 103.74 57.67 101.94 58.09 100.12 59.06 99.36 59.87 99.59 60.38 98.64 62.44 96.48 63.06 94.25 63.02 93.42 Z"
          data-name="Deschutes"
          data-stusps="OR"
          id="41017"
        />
        <path
          className="white"
          d="M 460.78 259.27 462.7 259.26 464.06 259.26 464.04 260.84 467.21 260.82 467.22 261.64 467.53 264.09 467.58 266.81 464.3 266.84 462.67 266.88 461.83 266.08 461.25 264.14 459.87 263.23 459.88 260.85 460.71 260.83 460.78 259.27 Z"
          data-name="Miller"
          data-stusps="MO"
          id="29131"
        />
        <path
          className="white"
          d="M 84.89 113.9 85.38 112.26 87.01 112.77 88.55 107.88 90.15 108.37 101.55 111.76 102.03 110.12 105.1 111.18 109.97 112.59 108.46 117.62 104.12 133.78 100.79 145.82 101.02 146.06 99.59 151.14 95.3 149.99 91.42 148.95 88.25 148.03 85.33 147.2 83.7 146.71 83.2 146.56 87.3 132.31 79.26 129.96 80.41 126.8 81.9 121.87 82.39 122.02 84.89 113.9 Z"
          data-name="Harney"
          data-stusps="OR"
          id="41025"
        />
        <path
          className="white"
          d="M 479.55 262.65 479.82 262.74 483.58 262.55 483.96 271.26 483.27 271.28 483.21 272.1 480.86 272.17 480.81 270.53 477.53 270.65 477.28 264.15 477.13 263.84 477.07 262.74 479.55 262.65 Z"
          data-name="Crawford"
          data-stusps="MO"
          id="29055"
        />
        <path
          className="white"
          d="M 536.76 339.9 540.1 339.73 541.72 339.59 541.79 340.41 543.43 340.36 543.75 343.66 545.4 343.58 545.54 345.21 542.25 345.33 541.83 347.04 539.08 347.19 537.42 347.33 536.76 339.9 Z"
          data-name="Fayette"
          data-stusps="AL"
          id="1057"
        />
        <path
          className="white"
          d="M 61.63 226.79 56.34 229.83 56 231.08 54.81 231.45 54.58 232.28 52.89 231.84 47.24 235.12 45.73 233.09 44.49 225.09 44.49 225.08 44.69 224.11 45.9 224.82 45.62 223.52 49.23 223.35 50.21 222.65 52.45 224.73 53.92 225.18 56.32 224.89 56.87 224.1 58.84 223.46 59.52 224.64 60.3 224.62 61.63 226.79 Z"
          data-name="Mariposa"
          data-stusps="CA"
          id="6043"
        />
        <path
          className="white"
          d="M 361.87 361.9 364.16 361.97 370.1 362.18 369.98 366.32 369.87 370.41 361.61 370.19 361.73 366.58 361.87 361.9 Z"
          data-name="Stephens"
          data-stusps="TX"
          id="48429"
        />
        <path
          className="white"
          d="M 627.95 200.95 629.61 200.71 630.8 200.78 631.66 201.84 632.16 203.18 632.01 204.21 631.98 204.41 632.61 205.88 632.24 206.97 631.88 208.28 631.71 208.89 630.79 209.09 629.09 209.3 628.48 204.29 627.37 204.45 627.48 203.59 627.25 201.91 628.08 201.79 627.95 200.95 Z"
          data-name="Jefferson"
          data-stusps="OH"
          id="39081"
        />
        <path
          className="white"
          d="M 720.39 150.32 721.38 147.11 720.44 143.49 726.22 140.97 726.24 144.17 726.26 149.56 726.68 150.1 726.55 151.67 723.82 151.86 720.37 151.31 720.39 150.32 Z"
          data-name="Columbia"
          data-stusps="NY"
          id="36021"
        />
        <path
          className="white"
          d="M 497.7 344.48 501.92 344.29 501.92 345.11 500.22 345.48 500.2 346.49 501.1 345.69 502.73 345.9 502.91 346.73 503.56 350.8 502.44 351.65 502.53 353.22 500.18 352.56 500.87 353.19 500.09 353.92 498.87 355.26 498.14 353.52 497.7 344.48 Z"
          data-name="Leflore"
          data-stusps="MS"
          id="28083"
        />
        <path
          className="white"
          d="M 503.13 390.51 503.39 390.5 505.57 390.38 506.69 390.6 506.98 393.6 508.54 394.32 508.88 395.4 510.25 395.32 510.33 396.69 509.33 396.75 503.47 397.08 503.13 390.51 Z"
          data-name="Walthall"
          data-stusps="MS"
          id="28147"
        />
        <path
          className="white"
          d="M 592.17 244.3 591.69 237.03 592.59 236.93 595.82 235.79 596.87 235.7 597.61 236.3 598.66 243.49 598.77 243.87 598.48 244.18 597.91 243.81 596.99 243.19 596.02 243.17 594.56 242.74 593.24 243.36 593.09 244.07 593.04 244.11 592.59 244.39 592.17 244.3 Z"
          data-name="Adams"
          data-stusps="OH"
          id="39001"
        />
        <path
          className="white"
          d="M 720.19 209.84 719.88 209.26 720.31 206.85 723.54 206.77 725.15 206.15 724.69 206.85 724 208.2 723.78 208.9 723.43 210.2 723.63 210.49 722.92 212.26 722.66 213.07 722.03 214.14 721.06 214.61 720.53 214.64 720.4 213.31 720.77 211.49 720.78 210.36 720.35 209.84 720.19 209.84 Z"
          data-name="Cape May"
          data-stusps="NJ"
          id="34009"
        />
        <path
          className="white"
          d="M 243.36 89.63 248.23 90.48 258.62 92.01 258.84 93.51 258.02 94.98 258.46 96.98 258.16 98.87 256.26 98.57 255.01 99.5 254.57 100.83 250.78 100.23 249.6 100.58 249.29 102.51 244.4 101.73 244.85 99.01 244.05 97.19 244.34 95.57 244.16 93.12 243.08 92.92 243.36 89.63 Z"
          data-name="Musselshell"
          data-stusps="MT"
          id="30065"
        />
        <path
          className="white"
          d="M 599.45 336.36 600.48 335.16 601.23 334.25 602.01 333.31 602.69 333.9 604.46 333.47 606.45 334.86 606.89 334.87 606.62 335.32 604.63 339.38 604.42 339.02 602.74 338.27 600.6 337.03 599.45 336.36 Z"
          data-name="Walton"
          data-stusps="GA"
          id="13297"
        />
        <path
          className="white"
          d="M 625.14 285.34 625.32 284.88 625.69 286.24 627.02 286.92 627.46 287.96 628.74 288.62 627.93 290.78 626.4 290.27 625.84 291.12 625.38 292.13 624.49 291.66 623.32 288.67 623.34 288.67 624.08 288.2 624.84 286.09 625.14 285.34 Z"
          data-name="Avery"
          data-stusps="NC"
          id="37011"
        />
        <path
          className="white"
          d="M 174.36 77.25 174.62 77.21 180.93 78.71 180.82 80.11 179.65 81.42 179.68 82.76 180.2 84.49 179.83 85.82 180.22 86.22 179.04 87.12 179.49 89.2 178.5 90.45 180.01 90.84 180.22 92.28 181.82 93.14 181.83 93.17 181.42 94.21 179.05 94.4 176.91 95.74 176.51 95.04 175.06 96.66 174.83 96.25 174.23 96.19 174.06 96.99 172.94 97.71 171.32 98.49 170.42 98.43 169.81 99.41 168.69 98.9 167.75 97.67 167.17 97.22 167.06 96.68 166.97 96.23 167.2 95.42 167.75 95.19 167.93 94.18 167.43 92.91 168.28 92.01 169.6 91.94 170.18 91.55 169.98 90.92 170.35 90.02 169.97 89.39 169.65 88.49 170.21 87.3 169.55 86.58 169.82 85.81 170.75 85.91 170.98 84.71 171.26 84.05 171.55 83.39 172.02 81.99 172.62 81.65 172.78 79.97 173.49 79.95 174.07 78.71 174.52 77.45 174.36 77.25 Z"
          data-name="Ravalli"
          data-stusps="MT"
          id="30081"
        />
        <path
          className="white"
          d="M 370.1 362.18 372.44 362.28 372.48 361.24 378.33 361.46 377.98 369.78 377.94 370.67 371.48 370.49 369.87 370.41 369.98 366.32 370.1 362.18 Z"
          data-name="Palo Pinto"
          data-stusps="TX"
          id="48363"
        />
        <path
          className="white"
          d="M 495.08 382.71 495.34 381.6 495.13 377.77 502.93 377.36 505.17 382.36 504.95 382.85 503.81 383.37 503.02 383.61 500.89 384.32 500.32 384.07 495.14 384.35 495.08 382.71 Z"
          data-name="Copiah"
          data-stusps="MS"
          id="28029"
        />
        <path
          className="white"
          d="M 226.94 87.48 231.01 87.41 232.73 88.87 233.69 89.03 238.28 89.86 237.43 93.63 236.55 98.71 233.28 98.14 225.11 96.63 226.94 87.48 Z"
          data-name="Wheatland"
          data-stusps="MT"
          id="30107"
        />
        <path
          className="white"
          d="M 591.91 265.33 592.87 262.85 594.24 261.7 594.45 261.67 595.94 262.42 597.43 262.77 596.91 265.38 595.98 264.85 594.48 265.93 592.28 265.76 591.91 265.33 Z"
          data-name="Lee"
          data-stusps="KY"
          id="21129"
        />
        <path
          className="white"
          d="M 594.1 209.35 597.4 209.07 598.84 209.21 598.93 210.3 601.61 210.06 601.74 211.44 602 214.31 598.95 214.59 598.45 214.63 596.05 214.85 595.74 212.95 594.64 213.11 594.1 209.35 Z"
          data-name="Delaware"
          data-stusps="OH"
          id="39041"
        />
        <path
          className="white"
          d="M 644.03 337.22 648.9 339.16 649.31 339.49 649.76 339.72 649.83 339.84 649.86 339.78 650.58 340.18 651.53 341.23 650.11 342.44 650.28 343.65 649.51 342.97 647.39 344.75 647.05 344.37 645.37 343.25 644.7 342.53 644.03 337.22 Z"
          data-name="Bamberg"
          data-stusps="SC"
          id="45009"
        />
        <path
          className="white"
          d="M 337.2 360.83 339.36 360.94 345.29 361.25 344.92 369.45 336.75 369.05 337.2 360.83 Z"
          data-name="Fisher"
          data-stusps="TX"
          id="48151"
        />
        <path
          className="white"
          d="M 436.43 386.96 441.38 387.5 443.1 388.44 443.16 390.37 442.2 391.44 442.36 396.6 442.27 396.93 440.91 397.28 439.45 395.92 437.7 394.98 437.74 394.87 437.49 394.68 437.59 392.39 438.04 389.32 437.86 388.14 436.43 386.96 Z"
          data-name="San Augustine"
          data-stusps="TX"
          id="48405"
        />
        <path
          className="white"
          d="M 681.97 170.66 690.6 169.62 690.62 170.22 690.44 172.93 690.34 174.28 688.96 174.64 688.54 175.39 686.35 175.33 683.68 173.93 681.97 170.66 Z"
          data-name="Sullivan"
          data-stusps="PA"
          id="42113"
        />
        <path
          className="white"
          d="M 452.79 122.42 452.98 122.27 453.59 121.25 453.78 120.39 454.25 119.46 455.07 118.66 456.04 118.21 456.48 117.74 457.44 117.65 457.72 117.09 458.45 116.73 458.99 116.78 459.13 116.09 459.69 115.65 459.63 114.09 462.81 113.94 463.18 117.19 463.52 123.64 461.89 123.72 461.82 122.11 456.9 122.27 456.96 123.89 452.24 124.04 452.42 122.7 452.79 122.42 Z"
          data-name="Burnett"
          data-stusps="WI"
          id="55013"
        />
        <path
          className="white"
          d="M 481.34 122.68 480.95 116.23 485.85 115.9 489.23 115.65 489.36 117.24 489.82 123.66 490.07 126.91 481.65 127.56 481.34 122.68 Z"
          data-name="Price"
          data-stusps="WI"
          id="55099"
        />
        <path
          className="white"
          d="M 477.54 332.8 477.96 332.79 479.25 332.77 479.2 331.12 482.57 331.06 483.91 331.04 485.81 333.04 487.76 335.09 487.58 338.72 486.99 339.22 486 339.92 485.82 340.6 486.85 342.85 486.31 342.26 483.54 342.46 482.33 341.45 482.06 341.16 481.91 340.17 481.76 339.17 480.78 339.06 480.37 337.55 477.63 337.47 477.61 336.08 477.54 332.8 Z"
          data-name="Arkansas"
          data-stusps="AR"
          id="5001"
        />
        <path
          className="white"
          d="M 671.12 209.93 671.46 209.86 675.95 208.95 680.33 208.05 680.33 208.05 679.25 210.26 678.99 215.29 678.87 216.31 678.24 216.37 677.73 215.85 677.63 214.91 676.48 213.69 676.2 213.25 675.91 212.82 675.58 211.67 674.1 211.58 672.94 211.94 672.56 211.64 671.56 210.85 669.52 211.51 668.34 212.29 668.06 212.4 668.1 211.13 667.56 210.65 667.56 210.65 671.12 209.93 Z"
          data-name="Washington"
          data-stusps="MD"
          id="24043"
        />
        <path
          className="white"
          d="M 677.08 143.32 676.98 142.23 675.56 137.46 676 137.05 676.47 135.73 676.63 135.56 677.55 138.65 679.39 138.73 680.22 142.95 681.51 145.81 682.79 145.43 684.29 146.63 685.09 149.38 682.43 150.11 679.51 150.71 678.18 149.09 677 144.41 677.08 143.32 Z"
          data-name="Cayuga"
          data-stusps="NY"
          id="36011"
        />
        <path
          className="white"
          d="M 409.31 195.66 415.68 195.72 417.3 195.71 417.3 200.61 418.15 200.6 418.16 202.41 411.16 202.4 411 201.71 409.94 202 409.78 201.38 409.41 200.4 409.51 199.37 409.56 199.22 409.85 198.36 410.18 197.03 409.57 196.14 409.31 195.66 Z"
          data-name="Harrison"
          data-stusps="IA"
          id="19085"
        />
        <path
          className="white"
          d="M 523.02 246.59 522.63 241.7 527.79 241.21 528.63 241.12 529.23 247.21 524.64 247.65 523.11 247.69 523.02 246.59 Z"
          data-name="Jasper"
          data-stusps="IL"
          id="17079"
        />
        <path
          className="white"
          d="M 572.06 147.62 571.62 144.4 573.26 144.17 573.5 145.78 575.45 145.54 575.37 145.85 575.43 148.07 575.3 148.89 575.99 149.99 577.24 149.78 578.56 150.56 579.06 150.9 579.15 151.57 579.41 153.2 577.78 153.44 577.67 152.63 576.31 152.82 574.46 153.06 574.36 152.24 572.74 152.45 572.06 147.62 Z"
          data-name="Bay"
          data-stusps="MI"
          id="26017"
        />
        <path
          className="white"
          d="M 343.39 59.14 347.98 59.47 356.56 60.03 359.63 60.21 359.33 65.47 359.79 65.5 359.61 68.76 357.97 68.68 356.35 68.58 356.45 66.94 348.32 66.41 348.21 68.05 343.32 67.69 343 64.38 343.39 59.14 Z"
          data-name="Bottineau"
          data-stusps="ND"
          id="38009"
        />
        <path
          className="white"
          d="M 509.21 179.95 511.49 179.79 512.45 179.71 513.02 186.1 509.74 186.39 509.21 179.95 Z"
          data-name="Boone"
          data-stusps="IL"
          id="17007"
        />
        <path
          className="white"
          d="M 308.54 87.56 313.37 88.08 312.71 94.64 313.44 94.71 312.79 101.28 310.32 101.03 310.15 102.71 306.98 102.38 307.18 100.49 307.32 99.13 307.75 95 308.14 91.37 308.54 87.56 Z"
          data-name="Golden Valley"
          data-stusps="ND"
          id="38033"
        />
        <path
          className="white"
          d="M 469.3 138.11 479.03 137.54 479.32 142.44 477.69 142.53 476.06 142.62 471.18 142.9 469.55 142.98 469.47 141.34 469.3 138.11 Z"
          data-name="Eau Claire"
          data-stusps="WI"
          id="55035"
        />
        <path
          className="white"
          d="M 561.98 209.58 563.62 209.37 563 204.43 566.74 203.96 567.63 210.53 565.73 210.78 563.01 211.11 562.2 211.21 561.98 209.58 Z"
          data-name="Wells"
          data-stusps="IN"
          id="18179"
        />
        <path
          className="white"
          d="M 410.49 238.81 414.07 238.81 414.07 237.18 417.33 237.18 417.26 241.56 416.98 241.83 416.99 245.37 410.48 245.36 410.49 238.81 Z"
          data-name="Jackson"
          data-stusps="KS"
          id="20085"
        />
        <path
          className="white"
          d="M 116.2 155.52 121.7 156.98 125.83 158.02 132.34 159.64 135.77 160.46 140.16 161.53 144.05 162.4 146.01 162.83 150.22 163.9 154.67 164.9 154.67 164.91 158.04 165.66 157.07 170.19 155.99 175.13 154.81 180.48 153.95 184.4 153.95 184.4 152.82 189.56 151.86 193.91 151.45 195.75 150.32 201.06 147.34 200.43 132.66 197.08 124.39 195.06 121.97 194.5 122.14 183.76 123.66 177.46 117.53 175.94 111.34 174.39 116.2 155.52 Z"
          data-name="Elko"
          data-stusps="NV"
          id="32007"
        />
        <path
          className="white"
          d="M 481.87 104.77 482.41 104.67 483.34 105.13 483.58 105.03 484.02 105.61 484.72 105.19 485.36 105.8 486.3 106.09 487.15 107.53 487.75 109.06 490.29 109.57 490.74 115.54 489.23 115.65 485.85 115.9 485.61 112.65 484.01 112.77 483.9 111.15 482.25 111.25 481.87 104.77 Z"
          data-name="Iron"
          data-stusps="WI"
          id="55051"
        />
        <path
          className="white"
          d="M 486.41 404.28 486.75 404.35 486.95 404.43 486.71 405.47 487.88 406.53 487.33 407.11 488.49 406.74 488.7 407.06 488.75 408.05 488.73 408.62 488.13 409.98 489.73 410.44 486.98 410.57 486.73 410.11 486.08 409.45 485.33 408.69 484.02 407.4 485.16 407.09 486.76 404.42 486.41 404.28 Z"
          data-name="West Baton Rouge"
          data-stusps="LA"
          id="22121"
        />
        <path
          className="white"
          d="M 482.27 353.15 482.28 350.92 482.2 349.87 483.83 349.8 483.85 350.63 485.5 350.6 486.09 350.04 485.96 350.35 485.96 350.35 486.41 351.02 486.71 351.58 487.12 352.22 487.68 352.84 487.27 353.68 487.59 354.96 488.22 355.06 488.53 355.81 488.33 356.8 488.05 357.73 487.28 357.7 486.87 358.41 487.86 359.19 487.28 360.03 487.18 360.17 485.63 360.23 482.91 360.32 482.53 360.34 482.27 353.15 Z"
          data-name="Chicot"
          data-stusps="AR"
          id="5017"
        />
        <path
          className="white"
          d="M 643.64 178.09 651.51 176.56 652.17 180.08 650.63 180.07 650.6 182.28 650.49 182.59 649.02 182.76 648.67 180.89 645.92 181.33 646.1 182.27 645 182.48 644.8 181.47 644.22 181.09 643.64 178.09 Z"
          data-name="Forest"
          data-stusps="PA"
          id="42053"
        />
        <path
          className="white"
          d="M 745.35 131.3 746.66 130.95 747.12 130.83 747.49 130.73 749.03 130.32 750.34 129.96 752.53 129.36 753.02 129.23 753.83 129 754.13 128.1 754.14 128.09 754.77 129.28 754.59 129.59 756 129.99 756.21 130.31 756.23 129.95 757.4 129.81 757.62 129.64 758.1 129.98 758.17 130.27 757.85 130.3 758.48 132.13 759.76 132.8 759.79 132.87 758.64 134.01 758.95 134.19 758.83 134.43 758.24 134.51 757.56 134.8 757.88 135.32 757.68 136.36 756.9 135.82 756.31 135.85 755.59 136.37 756.31 137.5 755.9 137.63 756.03 137.89 755.92 138.11 756 138.3 755.85 138.35 755.87 138.48 756.01 138.57 755.79 138.74 755.49 138.91 755.32 139.23 754.38 139.97 753.84 139.42 753.15 139.82 752.27 138.5 752.75 138.22 753.14 138.09 753.37 138.07 753.27 136.74 752.39 137.08 752 137.52 751.22 136.94 751.24 135.97 751.79 135.51 751.41 134.34 751.57 133.35 751.32 132.95 750.13 133.12 750.07 133.72 749.44 133.78 749.17 132.19 747.44 132.05 746.35 132.59 745.35 131.3 Z"
          data-name="Middlesex"
          data-stusps="MA"
          id="25017"
        />
        <path
          className="white"
          d="M 726.08 111.44 726.43 111.79 726.53 112.08 727.47 112.07 729.53 112.24 731.27 112.43 735.02 112.64 734.95 112.93 734.32 113.93 734.34 116.22 734.3 116.28 733.85 117.06 734.28 118.59 734.43 119.86 734.43 119.87 734.57 121.17 734.8 121.62 734.96 121.92 735.01 123.07 735.02 123.7 731.61 124.91 729.58 124.82 729.34 124.01 728.67 124.18 728.47 122.69 729.74 122.42 729.73 120.45 729.02 120.44 728.61 118.35 728.86 116.29 727.05 116.17 727.13 115.65 726.89 115.61 727.07 114.38 726.84 114.03 726.22 113.91 726.17 114.13 725.63 114.07 725.42 113.84 724.54 114.67 723.95 113.68 725.25 112.9 725.63 113.63 726.08 111.44 Z"
          data-name="Windsor"
          data-stusps="VT"
          id="50027"
        />
        <path
          className="white"
          d="M 671.12 209.93 672.12 207.67 672.63 204.14 673.21 202.81 674.35 199.11 674.75 198.5 675.1 197.91 676.34 198.86 676.29 199.46 678.09 202.04 679.53 203.24 679.4 203.83 680.48 208.02 680.33 208.05 680.33 208.05 675.95 208.95 671.46 209.86 671.12 209.93 Z"
          data-name="Franklin"
          data-stusps="PA"
          id="42055"
        />
        <path
          className="white"
          d="M 694.81 237.51 695.52 236.43 697.7 238.39 699.8 238.64 701.12 239.06 702.23 240.66 701.38 240.87 700.06 242.33 697.84 240.47 695.58 239.11 694.81 237.51 Z"
          data-name="Richmond"
          data-stusps="VA"
          id="51159"
        />
        <path
          className="white"
          d="M 409.26 425.53 410.31 425.51 410.18 423.17 411.19 423.16 413.56 422.04 414.78 422.83 415.81 423.49 415.83 423.51 416.4 423.86 416.9 424.19 417.73 424.65 419.78 425.73 420.14 425.93 419.83 427.24 419.52 428.57 418.09 428.59 417.61 430.43 416.85 431.31 414.76 430.73 413.21 431.89 411.58 430.56 411.14 429.1 409.73 427.94 409.98 426.27 409.26 425.53 Z"
          data-name="Fort Bend"
          data-stusps="TX"
          id="48157"
        />
        <path
          className="white"
          d="M 766.05 95.08 767.39 94.95 767.5 94.88 766.73 93 766.6 91.96 768.11 91.83 768.27 91.47 768.13 90.11 769.16 89.98 769.06 90.39 769.87 91.94 771.27 91.82 773.03 94.5 772.19 95.62 772.41 97 772.16 96.82 771.98 97.58 771.85 97.9 771.43 99.56 770.74 99.72 770.5 100.17 769.65 100.87 769.08 101.23 767.82 99.61 767.68 97.3 767.01 97.38 766.02 97.46 766.05 95.08 Z"
          data-name="Lincoln"
          data-stusps="ME"
          id="23015"
        />
        <path
          className="white"
          d="M 634.56 414.81 637.8 414.45 638.14 415.6 640.49 414.94 640.42 414.38 641.21 413.7 643.85 413 645.04 413.51 645.89 415.65 647.01 416.41 647.77 417.24 648.04 419.29 648.23 423.29 646.51 423.49 643.29 423.89 637.31 424.59 636.61 424.13 634.66 423.22 633.38 423.42 633.02 420.2 635.21 419.92 634.85 417.16 634.56 414.81 Z"
          data-name="Marion"
          data-stusps="FL"
          id="12083"
        />
        <path
          className="white"
          d="M 307.56 180.2 316.9 180.95 317.21 181.16 316.8 187.51 317.29 189.21 307.96 188.46 307.43 188.4 307.57 186.77 306.97 186.71 307.56 180.2 Z"
          data-name="Box Butte"
          data-stusps="NE"
          id="31013"
        />
        <path
          className="white"
          d="M 494.81 374.47 495.07 372.16 496.15 371.59 497.34 369.03 497.84 369.09 498.92 367.7 499.01 369.31 502.29 369.15 502.37 370.79 504.29 370.7 505.21 370.65 503.85 372.85 503.52 373.07 503.36 374.74 502.44 375.48 502.93 377.36 495.13 377.77 494.81 374.47 Z"
          data-name="Hinds"
          data-stusps="MS"
          id="28049"
        />
        <path
          className="white"
          d="M 504.96 268.98 505.26 268.34 506.14 265.9 512.35 265.56 512.75 265.54 512.87 267.19 513.18 272.11 508.71 272.43 508.08 273.04 508.12 272.84 507.87 272.01 507.55 270.69 506.48 270.25 505.29 269.65 504.96 268.98 Z"
          data-name="Jackson"
          data-stusps="IL"
          id="17077"
        />
        <path
          className="white"
          d="M 596.56 339.38 597.71 339.85 598.86 337.07 599.45 336.36 600.6 337.03 600.55 338.81 599.62 340.77 599.03 341.4 598.92 341.12 598.12 340.85 597.69 340.87 596.56 339.38 Z"
          data-name="Rockdale"
          data-stusps="GA"
          id="13247"
        />
        <path
          className="white"
          d="M 579.45 345.4 583.87 344.98 585.07 347.69 585.48 348.65 582.86 349.48 582.77 350.09 580.95 350.93 579.45 345.4 Z"
          data-name="Heard"
          data-stusps="GA"
          id="13149"
        />
        <path
          className="white"
          d="M 425.85 286.88 426.04 286.88 430.29 286.85 431.72 286.83 431.77 291.19 431.8 293.04 426.03 293.05 425.99 287.94 425.46 286.98 425.85 286.88 Z"
          data-name="Ottawa"
          data-stusps="OK"
          id="40115"
        />
        <path
          className="white"
          d="M 104.48 72.74 105.42 72.86 106.92 72.96 108.58 73.62 109.57 73.4 110.78 72.93 110.78 72.93 114.81 74.13 115.73 74.41 118.84 75.35 123.67 76.79 123.92 76.86 123.25 79.16 123.22 79.49 122.98 80.3 122.04 80.02 121.06 82.35 120.39 82.15 119.21 86.22 118.13 85.91 117.9 86.72 114.87 85.79 114.46 87.17 110.86 86.29 110.37 87.94 110.91 88.1 110.58 89.24 112.02 89.67 111.36 91.84 111.28 93.54 102.72 90.97 103.44 89.41 105.93 81.32 104.58 80.9 105.07 79.3 102.64 78.52 104.48 72.74 Z"
          data-name="Umatilla"
          data-stusps="OR"
          id="41059"
        />
        <path
          className="white"
          d="M 593.93 339.64 595.02 339.53 595.74 340.54 595.19 341.39 595.26 343.55 594.33 343.64 594.41 344.38 594.49 345.23 593.96 345.29 593.83 343.18 593.53 342.79 592.76 341.68 592.43 341.66 592.34 340.84 592.27 340.18 592.23 339.81 593.93 339.64 Z"
          data-name="Clayton"
          data-stusps="GA"
          id="13063"
        />
        <path
          className="white"
          d="M 503.63 112.79 505.3 113.6 506.23 113.41 506.99 113.59 507.59 119.05 510.88 118.76 511.45 125.24 508.14 125.51 504.85 125.8 504.75 124.18 503.12 124.33 502.42 116.24 502.28 114.61 503.78 114.48 503.63 112.79 Z"
          data-name="Forest"
          data-stusps="WI"
          id="55041"
        />
        <path
          className="white"
          d="M 649.95 258.94 651.14 256.36 650.03 254.55 651.4 253.25 652.58 251.11 654.85 251.45 655.05 253.39 658.27 255.34 657.2 257.15 656.61 257.15 656.48 257.13 656.02 256.67 655.57 256.92 655.23 257.51 654.28 258.46 653.94 258.62 654.35 259 654.55 258.94 654.51 259.55 653.75 260.49 653.42 260.18 652.09 259.74 650.17 259.18 649.95 258.94 Z"
          data-name="Botetourt"
          data-stusps="VA"
          id="51023"
        />
        <path
          className="white"
          d="M 507.21 147.08 508.83 146.93 509.19 146.9 512.09 146.63 513.72 146.48 514.24 152.23 514.33 153.07 507.78 153.61 507.63 151.95 507.21 147.08 Z"
          data-name="Winnebago"
          data-stusps="WI"
          id="55139"
        />
        <path
          className="white"
          d="M 532.35 343.54 532.56 337.6 536.02 337.45 536.61 337.97 536.76 339.9 537.42 347.33 532.23 347.54 532.32 344.41 532.35 343.54 Z"
          data-name="Lamar"
          data-stusps="AL"
          id="1075"
        />
        <path
          className="white"
          d="M 605.31 402.94 605 399.89 605.47 399.09 606.42 398.06 605.63 395.28 608.7 395.13 609.97 395.07 612.15 394.96 612.42 396.27 610.39 397.91 610.8 399.27 609.53 400.61 609.45 401.92 608.9 402.56 608 403.19 607.05 406.28 606.89 406.16 605.86 406.17 605.65 406.24 605.31 402.94 Z"
          data-name="Jefferson"
          data-stusps="FL"
          id="12065"
        />
        <path
          className="white"
          d="M 173.99 162.5 178.83 163.47 179.17 161.83 181.34 162.27 181.67 160.63 182.76 160.85 184.28 162.1 183.38 164.48 185.39 164.35 186.05 165.77 186.64 166.8 185.86 167.98 185.22 171.23 185.22 171.23 184.52 171.07 183.05 170.73 177.66 169.67 172.7 168.7 173.99 162.5 Z"
          data-name="Oneida"
          data-stusps="ID"
          id="16071"
        />
        <path
          className="white"
          d="M 498.01 413.03 498.13 412 498.79 412.21 499.42 412.42 500.46 410.84 503.14 410.3 505.8 411.38 505.92 412.22 504.88 412.53 504.25 412.79 503.17 413.09 500.97 415.43 499.83 415.76 499.98 416.67 500.09 418.23 498.45 418.11 498.01 418.24 497.36 415.51 498.01 413.03 Z"
          data-name="St. John the Baptist"
          data-stusps="LA"
          id="22095"
        />
        <path
          className="white"
          d="M 542.7 100.39 543.32 105.27 544.01 110.85 543.45 111.45 541.27 110.85 538.63 111.62 537.94 113.76 536.91 115.28 536.67 115.5 535.95 112.81 535.37 107.9 533.73 108.08 533.35 104.8 536.61 104.44 536.21 101.18 542.7 100.39 Z"
          data-name="Schoolcraft"
          data-stusps="MI"
          id="26153"
        />
        <path
          className="white"
          d="M 391.73 204.29 392.87 204.23 393.35 204.54 394.41 204.7 398.28 203.26 398.28 203.32 398.15 210.96 398.11 210.96 391.62 210.84 391.73 204.29 Z"
          data-name="Butler"
          data-stusps="NE"
          id="31023"
        />
        <path
          className="white"
          d="M 434.27 131.31 436.48 130.17 437.04 128.65 440.75 130.89 443.5 130.77 444.09 131.78 442.3 132.81 442.58 133.18 442.58 133.34 442.5 133.42 442.46 133.48 442.28 133.58 442.21 133.56 442.09 133.63 440.99 134.97 440.96 136.92 437.7 136.97 434.45 137.03 434.34 132.15 434.27 131.31 Z"
          data-name="Wright"
          data-stusps="MN"
          id="27171"
        />
        <path
          className="white"
          d="M 668.27 318.11 669.15 316.85 670.7 316.35 673.46 316.77 674.83 316.58 674.91 316.92 673.89 318.69 673.57 320.63 672.78 321.25 672.39 322.54 672.89 322.94 674.02 324.18 674.13 325.27 675.59 327.17 674.73 327.51 673.34 326.09 673.16 325.74 669.5 322.54 669.2 320.57 668.04 319.07 668.27 318.11 Z"
          data-name="Marion"
          data-stusps="SC"
          id="45067"
        />
        <path
          className="white"
          d="M 559.09 289.23 560.09 289.95 563 290 563.07 290.39 561.59 291.49 560.85 292.7 559.7 291.92 558.9 292.82 558.52 291.95 558.54 289.94 559.09 289.23 Z"
          data-name="Trousdale"
          data-stusps="TN"
          id="47169"
        />
        <path
          className="white"
          d="M 674.06 268.81 675.75 264.7 676.99 265.25 683.27 265.51 683.83 270 682.51 270.26 679.59 270.84 677.54 271.24 676.74 271.4 673.3 272.02 673.3 270.07 674.01 268.96 675.83 269.89 674.06 268.81 Z"
          data-name="Mecklenburg"
          data-stusps="VA"
          id="51117"
        />
        <path
          className="white"
          d="M 710.58 258.73 711.07 258.87 710.93 257.91 710.97 256.89 712.42 256.97 713.02 256.47 713.76 256.42 714.8 258.62 715.85 260.55 716.58 261.61 717.28 263.06 714.82 263.59 713.35 263.91 712.89 261.71 713.61 261.02 711.21 260 710.7 259.09 710.58 258.73 Z"
          data-name="Virginia Beach"
          data-stusps="VA"
          id="51810"
        />
        <path
          className="white"
          d="M 534.6 357.53 534.9 356.73 537.71 355.75 539.67 354.17 539.69 354.49 539.85 355.29 539.95 356.73 541.82 356.78 541.67 357.88 540.57 358.95 540.22 360.05 540.55 360.6 539.71 361.57 540.71 361.68 540.8 363.92 542.08 364.65 541.29 364.86 540.97 365.97 540.75 365.61 540.31 365.88 539.51 364.8 540.41 364.49 538.97 364.09 537.03 364.97 535.45 360.55 534.13 358.91 534.63 358.74 534.6 357.53 Z"
          data-name="Greene"
          data-stusps="AL"
          id="1063"
        />
        <path
          className="white"
          d="M 459.42 186.69 462.69 186.54 463.04 194.7 456.47 194.96 456.21 188.44 456.15 186.81 459.42 186.69 Z"
          data-name="Tama"
          data-stusps="IA"
          id="19171"
        />
        <path
          className="white"
          d="M 553.27 318.2 558.17 317.76 560.48 317.54 560.59 317.52 561.53 318.45 560.47 318.56 560.5 324.35 561.06 324.92 561.16 326.56 559.76 327.32 558.01 327.04 557.67 326.26 557.16 325.63 556.17 326.34 555.43 325.69 553.93 326.51 553.27 318.2 Z"
          data-name="Madison"
          data-stusps="AL"
          id="1089"
        />
        <path
          className="white"
          d="M 539.26 220.41 544.98 219.84 545.05 220.51 545.56 225.32 545.67 226.41 541.11 226.84 539.92 226.94 539.77 225.33 539.26 220.41 Z"
          data-name="Montgomery"
          data-stusps="IN"
          id="18107"
        />
        <path
          className="white"
          d="M 583.15 210.14 583.14 209.14 584.77 208.85 584.78 208.98 590.03 208.78 590.31 214.02 586.87 213.91 583.51 214.11 583.57 213.34 583.15 210.14 Z"
          data-name="Logan"
          data-stusps="OH"
          id="39091"
        />
        <path
          className="white"
          d="M 463.08 243.82 464.77 243.8 467.85 243.81 467.89 247.1 467.28 250.86 467.72 251.81 466.6 253.73 466.59 255.07 464.55 254.46 463.96 253.37 464.11 252.05 462.31 249.99 461.41 249.11 461.29 248.59 463.08 243.82 Z"
          data-name="Boone"
          data-stusps="MO"
          id="29019"
        />
        <path
          className="white"
          d="M 498.92 367.7 499.64 367.65 500.27 367.08 501.58 365.94 502.92 365.76 505.13 364.33 506.3 361.55 508.29 361.33 510.04 361.24 510.3 365.95 509.69 366.51 509.5 366.89 508.6 366.82 508.26 367.17 508.25 367.29 508.21 367.32 508.21 367.36 508.21 367.38 508.16 367.41 508.14 367.45 508.12 367.47 508.08 367.49 508.05 367.48 507.97 367.45 507.9 367.42 507.85 367.51 507.83 367.53 507.8 367.57 507.76 367.6 507.76 367.61 507.79 367.65 507.81 367.68 507.81 367.72 507.78 367.76 507.78 367.78 507.81 367.82 507.77 367.85 507.71 367.82 507.7 367.86 507.67 367.91 507.63 367.93 507.55 367.92 507.53 367.93 507.5 367.97 507.51 367.99 507.54 368.02 507.55 368.06 507.54 368.09 507.51 368.1 507.48 368.09 507.43 368.1 507.38 368.08 507.35 368.1 507.35 368.17 507.33 368.24 507.31 368.27 507.27 368.32 507.29 368.36 507.27 368.4 507.24 368.42 507.18 368.4 507.16 368.41 507.1 368.4 507.07 368.41 507.02 368.47 507.01 368.49 507.05 368.51 507.08 368.5 507.08 368.5 507.08 368.52 507.05 368.55 507.02 368.55 506.95 368.59 506.88 368.61 506.87 368.63 506.88 368.67 506.87 368.7 506.82 368.72 506.79 368.78 506.8 368.82 506.79 368.84 506.77 368.84 506.72 368.78 506.64 368.75 506.61 368.76 506.58 368.81 506.57 368.81 506.54 368.76 506.5 368.77 506.46 368.73 506.45 368.73 506.44 368.79 506.41 368.86 506.42 368.93 506.41 368.93 506.36 368.94 506.31 368.99 506.29 369.03 506.26 369.02 506.22 368.96 506.13 368.98 506.07 369 506.06 369.03 506.06 369.09 506.01 369.11 505.99 369.11 505.97 369.08 505.96 369.09 505.96 369.12 505.93 369.15 505.88 369.14 505.87 369.15 505.87 369.19 505.89 369.22 505.87 369.25 505.8 369.26 505.79 369.26 505.79 369.29 505.8 369.33 505.79 369.36 505.77 369.43 505.76 369.44 505.73 369.44 505.71 369.45 505.7 369.5 505.67 369.55 505.64 369.58 505.56 369.69 505.55 369.73 505.57 369.75 505.6 369.71 505.62 369.72 505.63 369.76 505.6 369.79 505.57 369.84 505.52 369.87 505.48 369.9 505.43 369.92 505.37 369.91 505.34 369.89 505.33 369.9 505.33 369.94 505.31 369.98 505.29 369.98 505.17 369.94 505.14 369.92 505.12 369.93 505.11 370.01 505.14 370.12 505.18 370.16 505.2 370.23 505.24 370.27 505.22 370.31 505.19 370.34 505.14 370.33 505.12 370.32 505.12 370.27 505.06 370.28 505.04 370.3 505.21 370.65 504.29 370.7 502.37 370.79 502.29 369.15 499.01 369.31 498.92 367.7 Z"
          data-name="Madison"
          data-stusps="MS"
          id="28089"
        />
        <path
          className="white"
          d="M 615.5 309.49 615.74 309.51 616.57 308.52 618.2 307.88 618.87 307.61 620.01 307.04 620.64 306.47 621.55 306.42 622.46 306.36 623.69 306.22 624.43 312.73 625.53 313.62 625.87 313.79 624.99 317.7 625.11 318.72 624.02 319.85 622.18 318.7 621.14 316.72 621 314.58 620.45 313.88 619.15 310.28 618.3 310.54 618.48 309.23 615.77 310.11 615.5 309.49 Z"
          data-name="Greenville"
          data-stusps="SC"
          id="45045"
        />
        <path
          className="white"
          d="M 622.46 302.54 624.12 302.03 627.36 304.46 627.54 305.8 626.44 305.91 626.31 305.93 623.69 306.22 622.46 306.36 621.55 306.42 621.34 305.56 622.46 302.54 Z"
          data-name="Polk"
          data-stusps="NC"
          id="37149"
        />
        <path
          className="white"
          d="M 44.66 188.79 45.23 188.49 48.94 188.8 50.85 187.83 51.99 188.26 52.6 190.01 60 192.16 59.28 194.6 58.81 194.47 54.59 193.26 51.15 192.28 48.43 192.05 45.09 193.51 41.8 195.95 40.94 195.02 38.81 194.45 40.38 189.98 43.04 188.54 44.66 188.79 Z"
          data-name="Nevada"
          data-stusps="CA"
          id="6057"
        />
        <path
          className="white"
          d="M 583.25 260.6 583.99 260.54 584.61 259.57 585.52 258.97 585.79 259.73 588.55 259.82 588.04 260.57 588.77 260.78 588.86 263.32 588.35 263.88 589.08 265.24 587.88 265.56 587.55 266.27 586.54 266.54 585.28 266.24 583.38 263.44 582.08 262.22 582.96 261.47 582.63 260.56 583.25 260.6 Z"
          data-name="Madison"
          data-stusps="KY"
          id="21151"
        />
        <path
          className="white"
          d="M 307.68 169.54 308.08 169.58 314.63 170.17 317.51 170.41 317.43 174.47 316.9 180.95 307.56 180.2 307.06 180.15 307.65 173.63 307.68 169.54 Z"
          data-name="Dawes"
          data-stusps="NE"
          id="31045"
        />
        <path
          className="white"
          d="M 646.3 273.45 647.25 272.59 647.75 270.8 649.27 269.78 651.94 269.92 652.48 270.75 651.72 271.17 653.1 275.55 649.4 276.14 647.29 276.37 647.16 276.38 644.51 276.67 644.36 274.86 645.57 274.83 646.3 273.45 Z"
          data-name="Patrick"
          data-stusps="VA"
          id="51141"
        />
        <path
          className="white"
          d="M 335.21 188.87 343.32 189.45 342.99 195.98 342.53 195.96 335.06 195.44 334.79 195.42 335.21 188.87 Z"
          data-name="Hooker"
          data-stusps="NE"
          id="31091"
        />
        <path
          className="white"
          d="M 515.16 194.12 517.93 193.84 518.34 193.79 519.93 193.62 519.94 193.61 520 194.15 520.22 196.07 520.38 197.44 520.51 198.52 515.66 199.05 515.29 195.78 515.16 194.12 Z"
          data-name="Kendall"
          data-stusps="IL"
          id="17093"
        />
        <path
          className="white"
          d="M 658.38 268.53 658.47 264.88 660.33 265.26 660.73 264.22 661.99 262.4 663.94 262.41 664.5 263.55 666.04 263.16 665.88 273.36 663.97 273.71 664.47 272.91 663.42 272.5 662.79 271.9 662.57 272.79 661.3 272.67 661.08 273 662.12 273.33 662.03 274.05 661.41 274.16 661.37 274.17 658.28 274.69 658.38 268.53 Z"
          data-name="Pittsylvania"
          data-stusps="VA"
          id="51143"
        />
        <path
          className="white"
          d="M 457.7 269.42 461.2 269.37 462.32 271.06 464.36 269.88 464.4 272.61 466.9 273.74 466.93 274.57 466.98 277.04 460.47 277.11 457.98 277.15 457.94 272.7 457.7 269.42 Z"
          data-name="Laclede"
          data-stusps="MO"
          id="29105"
        />
        <path
          className="white"
          d="M 443.34 231.08 449.11 230.78 449.21 235.73 450.63 235.7 450.75 237.2 450.51 237.35 443.55 237.61 443.46 234.36 443.34 231.08 Z"
          data-name="Livingston"
          data-stusps="MO"
          id="29117"
        />
        <path
          className="white"
          d="M 431.77 291.19 440.06 291.41 440.03 296.08 435.72 296.14 431.84 296.19 431.81 294.07 431.8 293.04 431.77 291.19 Z"
          data-name="McDonald"
          data-stusps="MO"
          id="29119"
        />
        <path
          className="white"
          d="M 456.5 229.25 463.75 228.99 463.82 230.56 464.64 230.54 464.73 237.06 464.71 237.06 459.02 237.18 459.01 235.53 456.56 235.58 456.5 229.25 Z"
          data-name="Macon"
          data-stusps="MO"
          id="29121"
        />
        <path
          className="white"
          d="M 311.13 63.1 325.59 64.56 325.44 66.19 325.14 69.45 325.86 69.52 325.43 74.19 321.96 73.44 320.75 73.54 320.34 74.64 319.49 75.22 317.72 75.12 316.95 75.6 315.79 74.58 316.31 74 315.78 73.06 313.88 73.64 314.24 74.21 313.28 74.23 312.95 75.43 312.29 74.97 311.38 75.99 309.89 75.07 309.89 75.07 310.36 70.47 310.65 67.69 310.85 65.72 311.13 63.1 Z"
          data-name="Williams"
          data-stusps="ND"
          id="38105"
        />
        <path
          className="white"
          d="M 585.42 302.44 585.97 302.39 586.27 302.63 586.92 302.66 589.21 306.71 589.49 307.98 588.13 309 585.51 309.63 585 310.2 585.07 309.96 584.32 309.84 584.61 309.4 582.35 308.42 582.98 306.47 585.42 302.44 Z"
          data-name="McMinn"
          data-stusps="TN"
          id="47107"
        />
        <path
          className="white"
          d="M 703.92 192.39 705.15 188.75 705.41 187.94 706.2 188.32 708.69 189.45 711.93 190.92 714.29 191.97 713.35 194.05 712.83 193.83 711.47 193.57 711.05 194.45 712.09 195.04 712.1 195.04 712.1 195.05 712.08 195.07 712.07 195.09 712.04 195.12 711.55 195.61 711.23 195.95 710.52 195.26 709.82 194.77 709.59 194.57 706.82 193.57 705.35 192.14 703.92 192.39 Z"
          data-name="Montgomery"
          data-stusps="PA"
          id="42091"
        />
        <path
          className="white"
          d="M 350.93 104.25 358.45 104.7 360.59 104.83 360.23 111.39 360.73 111.42 360.39 117.83 360.38 117.83 356.82 117.63 354.96 117.51 352.27 117.35 352.11 117.34 352.11 117.34 350.91 114.85 350.8 113.46 351.84 111.55 352.06 109.43 351.63 108.19 352.19 105.21 350.93 104.25 Z"
          data-name="Emmons"
          data-stusps="ND"
          id="38029"
        />
        <path
          className="white"
          d="M 684.92 178.28 685.77 178.44 686.31 178.29 687.02 179.96 687.76 179.98 688.96 181.6 689.1 183.08 688.77 183.15 688.45 182.12 686.82 181.9 685.01 182.69 685.24 179.8 684.92 178.28 Z"
          data-name="Montour"
          data-stusps="PA"
          id="42093"
        />
        <path
          className="white"
          d="M 476.06 142.62 477.69 142.53 479.32 142.44 479.41 144.06 481.05 143.96 481.14 145.6 484.41 145.4 487.68 145.14 487.86 148.12 487.95 148.44 488.07 150.19 486.39 150.19 484.8 150.31 480.06 150.65 479.11 151.24 479.23 152.34 477.02 152.47 476.8 152.32 476.43 149.18 476.06 142.62 Z"
          data-name="Jackson"
          data-stusps="WI"
          id="55053"
        />
        <path
          className="white"
          d="M 488.07 150.19 488.28 153.46 488.28 153.46 488.61 158.15 480.46 158.78 480.04 152.28 479.23 152.34 479.11 151.24 480.06 150.65 484.8 150.31 486.39 150.19 488.07 150.19 Z"
          data-name="Monroe"
          data-stusps="WI"
          id="55081"
        />
        <path
          className="white"
          d="M 508.14 125.51 511.45 125.24 513.07 125.14 513.33 128.39 514.97 128.3 515.08 129.92 516.02 129.87 516.15 131.5 518.56 131.84 521.04 132.17 520.38 132.4 520.03 133 520.19 133.94 520.01 134.26 519.41 135.06 519.03 136.28 518.54 137.01 518.43 137.83 515.45 138.21 515.14 138.11 514.76 134.86 511.53 135.11 511.16 130.2 509.06 130.38 508.4 128.78 508.14 125.51 Z"
          data-name="Oconto"
          data-stusps="WI"
          id="55083"
        />
        <path
          className="white"
          d="M 105.69 9.52 107.32 10.1 111.46 11.53 116.01 13.11 122.63 15.31 126.6 16.6 130.2 17.76 128.14 24.18 127.74 24.05 126.72 27.24 127.04 27.34 123.97 36.95 123.86 37.02 122.61 36.95 122.26 36.81 122.26 36.43 122.99 35.5 122.48 34.84 122.36 32.89 121.25 32.35 119.67 32.74 119.24 32.33 118.28 33.37 117.29 32.49 116.2 32.42 114.14 33.03 113.82 32.27 114.38 31.57 113.26 30.6 111.42 31.11 111.18 32.87 108.78 31.95 108.44 29.81 107.66 29.25 106.31 27.18 106.76 26.46 105.68 24.66 105.46 23.73 104.59 23.25 105.14 22.57 104.27 21.51 104.92 20.28 105.13 18.93 104.48 18.82 104.93 18.06 104.03 16.72 104.68 16.29 106.29 15.45 105.72 13.97 106.22 12.53 105.69 9.52 Z"
          data-name="Okanogan"
          data-stusps="WA"
          id="53047"
        />
        <path
          className="white"
          d="M 134.57 117.08 135.83 117.42 136.82 114.25 138.06 112.12 139.55 111.18 140.24 111.6 139.46 114.89 138.64 114.68 137.79 117.92 136.99 117.72 135.19 124.14 132.05 123.33 129.33 122.62 130.2 119.35 132.1 119.86 133.06 118.4 134.14 118.7 134.57 117.08 Z"
          data-name="Gem"
          data-stusps="ID"
          id="16045"
        />
        <path
          className="white"
          d="M 562.58 244.55 563.38 244.42 564.59 243.04 564.51 242.49 565.88 242.32 569.44 241.89 569.94 245.96 569.34 245.55 568.75 245.26 567.92 245.48 567.8 245.51 566.92 245.57 566.26 246.08 566.52 247.08 566.69 248.22 566.79 248.44 565.78 248.17 564.7 248.3 564.53 246.94 562.75 246.03 562.58 244.55 Z"
          data-name="Jefferson"
          data-stusps="IN"
          id="18077"
        />
        <path
          className="white"
          d="M 740.58 146.58 742.16 146.15 743.29 145.84 744.97 145.38 745.86 145.14 746.34 145.01 746.77 146.31 746.03 146.52 745.11 146.82 745.78 149.14 746.53 148.93 747.1 150.43 745.87 151.3 746.14 151.51 745.18 153.24 745.46 153.67 744.77 154.48 744.33 154.32 744.19 153.79 742.79 151.84 741.7 149.8 741.36 149.71 741 148.27 741.28 148.15 740.58 146.58 Z"
          data-name="Tolland"
          data-stusps="CT"
          id="9013"
        />
        <path
          className="white"
          d="M 615.94 360.54 618.95 365.47 620.55 364.34 620.75 364.63 620 365.58 619.85 365.25 616.05 370.57 614.46 369.14 614.2 367.35 613.46 366.93 613.87 366.5 614.04 365.46 612.94 363.79 613.46 362.4 615.32 360.05 615.94 360.54 Z"
          data-name="Dodge"
          data-stusps="GA"
          id="13091"
        />
        <path
          className="white"
          d="M 594.4 281.41 595.37 279.41 598.53 276.19 598.12 275.78 599.38 275.95 599.78 276.72 600.01 279.8 600.78 280.99 599.78 281.12 598.53 281.9 597.68 282.65 597.49 283.02 594.38 283.34 593.83 283.39 593.3 282.35 594.4 281.41 Z"
          data-name="Bell"
          data-stusps="KY"
          id="21013"
        />
        <path
          className="white"
          d="M 707.83 185.55 708.71 184.43 709.58 183.68 709.67 183.99 709.8 184.42 710.49 184.12 711.46 184.44 712.01 185.64 712.01 186.17 712.4 186.86 712.92 186.98 713.73 186.86 714.27 187.58 714.61 187.84 715.09 188.21 715.94 188.77 716.59 189.33 717.71 189.91 717.95 190.13 718.48 190.62 718.46 190.64 717.9 191.26 717.11 191.56 716.75 192.49 715.82 193 715.33 193.56 715.13 192.18 714.29 191.97 711.93 190.92 708.69 189.45 706.2 188.32 706.96 186.74 707.83 185.55 Z"
          data-name="Bucks"
          data-stusps="PA"
          id="42017"
        />
        <path
          className="white"
          d="M 115.97 326.32 116.69 325.32 118.07 324.37 118.19 323.31 118.45 322.27 118.89 321.73 119.12 321.26 119.13 320.45 119.13 319.11 119.49 318.46 119.58 317.76 119.26 317.14 119.77 316.67 120.83 315.81 121.25 315.26 121.47 314.59 121.55 314.33 121.97 314.04 122.97 313.77 123.97 313.32 125.04 313.12 126.05 312.26 126.74 312 126.86 311.17 128.45 312.32 133.14 313.56 133.79 314.28 135.07 314.13 136.39 312.85 139.02 313.6 139.69 313.21 138.62 319.27 137.14 327.53 136.52 331.13 126.54 329.37 126.84 327.71 121.86 326.8 120.34 335.11 116.31 334.47 115.43 334.08 114.55 334.02 113.89 333.76 113.56 332.37 114.18 331.41 114.46 330.06 114.61 329.59 113.94 328.82 114.31 328.19 114.51 327.17 114.33 326.58 115.2 326.48 115.84 326.51 115.97 326.32 Z"
          data-name="La Paz"
          data-stusps="AZ"
          id="4012"
        />
        <path
          className="white"
          d="M 283.81 205.17 285.06 205.3 290.17 205.75 296.49 206.38 303.31 207 303.32 207 302.4 215.97 294.29 215.21 293.94 218.48 293.32 225.04 288.41 224.58 281.59 223.9 281.59 223.9 281.59 223.9 281.62 223.62 281.68 223.07 280.27 223.76 280.27 223.42 280.5 221.16 280.75 218.84 280.9 217.2 282.5 217.37 283.81 205.17 Z"
          data-name="Weld"
          data-stusps="CO"
          id="8123"
        />
        <path
          className="white"
          d="M 668.81 481.86 668.42 478.53 671.76 478.15 671.81 478.57 677.92 477.83 678.44 477.51 679.97 477.28 681.55 477.08 681.64 478.18 681.79 478.97 681.8 479 682 480.03 681.89 481.13 681.58 483.06 681.15 482.73 680.14 481.93 679.67 483.43 679.16 484.36 679.11 485.81 679.09 485.94 678.88 487.27 679.51 488.66 680.76 487.89 681.55 485.87 681.93 487.16 681.03 489.41 680.38 489.25 678.62 490.31 678.3 491.08 678.35 491.45 677.97 491.83 677.41 491.82 676.88 492.18 676.75 492.57 676.72 492.68 675.89 492.65 674.04 493.2 673.08 494.02 672.44 494.19 671.23 493.58 670.45 493.84 669.78 490.3 668.91 482.71 668.81 481.86 Z"
          data-name="Miami-Dade"
          data-stusps="FL"
          id="12086"
        />
        <path
          className="white"
          d="M 36.56 258.5 43.52 254.7 44.64 250.49 47.82 251.31 49.27 251.35 51.07 250.38 51.76 250.59 51.32 252.24 52.15 252.47 51.5 255 50.65 254.76 49.46 258.94 48.14 263.94 37.85 261.27 37.54 261.19 37.17 258.69 36.56 258.5 Z"
          data-name="Kings"
          data-stusps="CA"
          id="6031"
        />
        <path
          className="white"
          d="M 4.22 163 11.26 165.39 11.1 165.87 20.04 168.82 20.14 169.73 19.37 170.08 18.87 172.23 18.97 174.14 18.28 176.63 17.89 177.58 15.18 177.23 14.41 179 14.53 182.66 12.91 183.45 12.46 185.94 12.28 186.47 13.17 187.26 13.14 189.29 14.73 190.86 10.87 189.57 9.78 190.13 6.11 189.61 3.46 188.95 3.19 188.21 2.48 187.01 2.35 186.35 1.85 185.33 1.78 184.42 2.83 183.36 3.03 181.22 2.81 179.69 2.82 178.05 3 176.21 3.71 174.63 5.11 172.84 5.32 171.45 5.57 170.21 5.28 169.28 5.66 167.1 5.04 166.23 4.73 164.86 4.22 163 Z"
          data-name="Mendocino"
          data-stusps="CA"
          id="6045"
        />
        <path
          className="white"
          d="M 138.5 84.01 139.24 83.84 139.52 82.46 140.52 81.64 141.39 81.19 142.64 82.18 143.65 79.77 145.13 78.76 148 80.47 149.02 79.55 150.64 79.77 149.52 78.01 149.32 76.5 150.5 77 151.21 78.31 153.4 79.7 153.87 79.79 154.93 78.16 156.58 77.1 156.8 76.45 170.93 76.84 171.06 76.5 171.59 76.79 172.82 76.99 174.1 76.92 174.36 77.25 174.52 77.45 174.07 78.71 173.49 79.95 172.78 79.97 172.62 81.65 172.02 81.99 171.55 83.39 171.26 84.05 170.98 84.71 170.75 85.91 169.82 85.81 169.55 86.58 170.21 87.3 169.65 88.49 169.97 89.39 170.35 90.02 169.98 90.92 170.18 91.55 169.6 91.94 168.28 92.01 167.43 92.91 167.93 94.18 167.75 95.19 167.2 95.42 166.97 96.23 167.06 96.68 164.7 98.37 163.15 97.26 162.83 98.61 164.69 101.85 163.05 103.41 146.05 99.18 146.16 98.72 144.45 99.61 143.94 99.36 143.39 100.23 141.62 99.34 141.55 96.54 136.95 95.28 137.4 94.49 139.19 92.4 140.94 90.38 141.7 89.6 141.19 88.15 141.35 87.13 140.83 86.1 139.9 85.78 139.2 84.7 138.6 84.25 138.5 84.01 Z"
          data-name="Idaho"
          data-stusps="ID"
          id="16049"
        />
        <path
          className="white"
          d="M 33.89 148.05 48.94 152.89 50.58 153.4 49.11 158.72 46.28 167.41 45.8 167.23 43.82 166.64 40.33 165.76 39.33 165.25 37.2 165.19 36.27 164.66 31.57 164.32 28.55 162.99 26.35 163.52 25.29 162.4 23.27 162.07 22.34 162.65 21.54 162.21 20.07 162.32 20.31 161.44 21.87 160.15 23.42 160.09 24.63 159.23 27.17 158.72 27.15 156.18 28.86 154.98 29.25 154.01 30.65 152.92 30.92 151.79 32.42 151.09 33.08 149.76 33.94 149.87 34.49 148.77 33.89 148.05 Z"
          data-name="Shasta"
          data-stusps="CA"
          id="6089"
        />
        <path
          className="white"
          d="M 293.2 115.18 293.76 115.24 294.52 108.68 295.22 108.76 300.04 109.31 299.87 110.84 301.51 111.02 301.34 112.6 304.69 112.99 304.52 114.62 305.71 114.74 305.68 115.07 305.47 117.22 305.11 120.83 304.98 122.09 304.7 125 304.47 127.31 304.3 128.96 304.07 131.33 303.82 131.33 290.93 129.88 290.76 129.86 291.52 123.26 292.19 123.34 293.2 115.18 Z"
          data-name="Carter"
          data-stusps="MT"
          id="30011"
        />
        <path
          className="white"
          d="M 258.98 97.33 266.29 98.4 266.33 100.08 267.95 100.31 267.98 102.03 267.52 105.25 268.42 105.33 267.71 110.33 266.23 110.12 266.35 109.31 264.72 109.08 264.84 108.26 261.58 107.79 261.82 106.17 260.69 106 261.66 103.56 260.24 100.02 258.98 97.33 Z"
          data-name="Treasure"
          data-stusps="MT"
          id="30103"
        />
        <path
          className="white"
          d="M 350.37 245.45 358.3 245.8 358.5 245.81 358.06 253.99 349.89 253.61 350.37 245.45 Z"
          data-name="Trego"
          data-stusps="KS"
          id="20195"
        />
        <path
          className="white"
          d="M 478.38 96.74 478.84 96.48 479.96 96.06 481.14 96.31 481.37 96.67 481.87 97.69 481.74 98.18 481.44 98.59 480.32 98.83 479.71 97.94 479.26 97.42 478.52 97.14 478.38 96.74 Z M 476.99 105.06 477.34 105.12 478.2 104.44 478.63 104.25 479.12 103.82 479.29 102.94 480.31 103.76 481.65 104.81 481.87 104.77 482.25 111.25 483.9 111.15 484.01 112.77 485.61 112.65 485.85 115.9 480.95 116.23 477.7 116.44 477.5 113.19 476.99 105.06 Z"
          data-name="Ashland"
          data-stusps="WI"
          fillRule="evenodd"
          id="55003"
        />
        <path
          className="white"
          d="M 488.62 416.08 490.52 415.31 490.8 415.29 491.02 414.93 492.84 415.13 493.2 416.79 493.76 416.75 494.25 418.11 494.28 418.63 493.67 419.54 492.8 421.18 492.42 421.76 491.25 423.47 490.86 423.17 490.9 422.12 490.95 420.21 489.44 419.42 488.16 417.12 488.62 416.08 Z"
          data-name="Assumption"
          data-stusps="LA"
          id="22007"
        />
        <path
          className="white"
          d="M 701.13 174.68 701.66 173.3 702.16 173.01 704.22 172.37 707.43 171.32 707.53 173.33 710.14 173.83 709.96 174.51 709.57 175.19 709.37 175.52 708.66 176.47 708.87 176.71 707.03 179.16 704.53 180.79 703.61 179.75 702.47 178.56 703.43 177.61 700.61 175.59 701.13 174.68 Z"
          data-name="Monroe"
          data-stusps="PA"
          id="42089"
        />
        <path
          className="white"
          d="M 446.1 309.65 448.81 309.69 448.81 310.23 454.25 310.2 454.26 312.66 453.44 312.65 453.47 315.1 452.36 315.1 452.38 317.78 450.55 317.84 450.25 315.93 446.05 317.03 446.1 309.65 Z"
          data-name="Johnson"
          data-stusps="AR"
          id="5071"
        />
        <path
          className="white"
          d="M 622.25 180.29 621.83 177.76 623.19 177.14 624.46 176.12 627.37 174.66 628.18 174.13 628.62 176.54 629.24 179.92 629.83 183.12 622.97 184.31 622.25 180.29 Z"
          data-name="Ashtabula"
          data-stusps="OH"
          id="39007"
        />
        <path
          className="white"
          d="M 690.43 224.41 690.41 224.29 691.1 223.22 691.92 221.96 690.24 220.88 690.46 219.86 691.05 217.7 691.25 217.38 692.08 217.75 692.35 218.37 693.05 218.68 693.68 218.76 695.41 220.93 695.18 222.78 695.82 223.98 695.74 224.74 696.86 227.97 695.79 227.74 695.45 226.67 693.56 226.25 691.39 226.84 690.99 227.64 690.06 226.07 690.14 225.97 690.53 225.88 690.6 225.31 690.56 225.14 690.43 224.41 Z"
          data-name="Prince George's"
          data-stusps="MD"
          id="24033"
        />
        <path
          className="white"
          d="M 714.31 194.9 715.02 195.22 715.08 195.37 715.16 195.4 715.15 195.53 715.18 195.59 715.36 195.66 715.51 195.66 715.8 195.61 715.69 195.8 715.72 195.85 716.69 196.45 717.55 198.14 718.77 197.9 720.26 198.71 719.58 199.98 718.76 201.52 717.37 200.05 714.9 199.02 713.58 197.05 713.69 196.97 713.55 196.49 713.42 196.02 713.45 195.93 713.57 195.61 714.31 194.9 Z"
          data-name="Camden"
          data-stusps="NJ"
          id="34007"
        />
        <path
          className="white"
          d="M 664.26 424.54 665.89 426.53 667.16 427.92 668.5 430.43 667.56 431.49 667.42 432.95 667.66 434.45 668.1 435.94 669.13 438.32 671.29 441.69 670.34 442.56 664.23 443.33 663.07 433.3 662.57 430.75 660.33 428.5 660.71 428.45 660.22 425.08 664.26 424.54 Z"
          data-name="Brevard"
          data-stusps="FL"
          id="12009"
        />
        <path
          className="white"
          d="M 781.31 66.19 782.72 65.33 778.69 58.95 780.31 57.48 781.61 57.01 781.61 57.03 782.81 56.54 783.61 57.27 784.25 57.23 785.7 57.23 786.67 56.65 787.32 57.1 787.9 58.37 787.16 58.76 787.39 59.64 788.7 60.8 788.78 62.34 788.75 63.03 789.3 63.4 790.75 64.7 791.62 64.98 792.02 64.37 792.06 63.41 793.08 63.43 793.71 63.37 794.72 64.07 795.32 64.77 795.71 65.45 797.01 66.87 797.93 67.29 798.2 68.35 799 68.72 798.34 70.03 797.91 70.76 797.59 71.65 797.2 72.74 796.52 73.54 796 74.55 794.82 74.45 794.57 75.02 793.93 75.31 793.66 76.36 793.59 77.37 794.07 77.89 793.38 79.17 792.24 78.37 791.72 77.74 791.17 78.45 790.06 79.02 789.68 79.8 789.76 80.73 789.34 81.43 788.73 81.29 788.66 81.4 788.29 81.19 786.42 78.37 782.83 72.27 784.34 71.35 781.31 66.19 Z"
          data-name="Washington"
          data-stusps="ME"
          id="23029"
        />
        <path
          className="white"
          d="M 53.93 209.68 54.97 206 56.97 205.06 58.78 203.63 58.71 202.32 62.27 207.79 62.3 207.83 61.22 209.78 61.73 212.42 59.47 214.97 58.94 213 55.93 213.4 54.31 211.36 53.6 210.88 53.93 209.68 Z"
          data-name="Alpine"
          data-stusps="CA"
          id="6003"
        />
        <path
          className="white"
          d="M 583.62 215.81 583.51 214.11 586.87 213.91 590.31 214.02 591.14 213.97 591.31 216.14 591.4 218.07 583.79 218.54 583.62 215.81 Z"
          data-name="Champaign"
          data-stusps="OH"
          id="39021"
        />
        <path
          className="white"
          d="M 450.06 336.34 451.15 336.34 451.98 337.43 454.45 337.42 457.01 338.12 457 339.65 459.38 339.57 459.36 342.81 458.3 343.01 459.4 344.32 459.45 346.05 459.06 345.85 457.31 346.87 456.16 346.76 453.72 345.85 451.87 343.49 450.85 341.39 450.38 338.87 449.75 338.72 450.06 336.34 Z"
          data-name="Clark"
          data-stusps="AR"
          id="5019"
        />
        <path
          className="white"
          d="M 675.1 197.91 676.56 195.44 680.97 190.86 684.14 189.25 683.77 190.53 684.8 192.26 684.2 194.43 685.89 194.81 685.11 195.34 681.87 196.51 678.87 197.79 679.51 196.49 676.29 199.46 676.34 198.86 675.1 197.91 Z"
          data-name="Perry"
          data-stusps="PA"
          id="42099"
        />
        <path
          className="white"
          d="M 369.78 87.3 379.52 87.69 379.36 92.59 369.56 92.19 369.78 87.3 Z"
          data-name="Foster"
          data-stusps="ND"
          id="38031"
        />
        <path
          className="white"
          d="M 489.92 294.32 490.2 294.3 493.07 294.15 494.31 294.08 498.46 293.89 499.48 293.84 499.7 294.5 499.91 295.33 500.93 295.81 501 296.36 501.06 297.37 500.32 298.12 499.76 299.12 499.27 299.44 497.26 299.52 497.22 298.42 489.8 298.68 490.65 298.39 490.54 295.9 489.92 294.32 Z"
          data-name="Clay"
          data-stusps="AR"
          id="5021"
        />
        <path
          className="white"
          d="M 385.6 184.62 390.45 184.7 392.09 184.73 392.06 186.36 391.96 191.26 385.44 191.14 385.6 184.62 Z"
          data-name="Pierce"
          data-stusps="NE"
          id="31139"
        />
        <path
          className="white"
          d="M 385.35 197.67 391.85 197.78 393.47 197.81 393.35 204.54 392.87 204.23 391.73 204.29 389.54 204.89 388.46 205.41 388.48 204.25 386.99 204.22 387.04 201.75 385.26 201.72 385.35 197.67 Z"
          data-name="Platte"
          data-stusps="NE"
          id="31141"
        />
        <path
          className="white"
          d="M 464.71 237.06 464.73 237.06 466.37 237.02 466.35 235.92 471.26 235.79 473.17 235.72 473.27 236.82 473.4 241.7 471.12 241.82 464.77 241.9 464.71 237.06 Z"
          data-name="Monroe"
          data-stusps="MO"
          id="29137"
        />
        <path
          className="white"
          d="M 439.97 113.17 444.73 112.97 444.77 114.71 444.86 117.95 443.74 117.98 443.93 122.62 444.07 125.91 440.79 125.99 440.6 121.06 439.91 118.05 439.83 114.8 439.79 113.34 439.97 113.17 Z"
          data-name="Mille Lacs"
          data-stusps="MN"
          id="27095"
        />
        <path
          className="white"
          d="M 449.7 114.47 449.52 109.57 459.42 109.21 459.55 112.46 459.63 114.09 459.69 115.65 459.13 116.09 458.99 116.78 458.45 116.73 457.72 117.09 457.44 117.65 456.48 117.74 456.04 118.21 455.07 118.66 454.25 119.46 453.78 120.39 453.59 121.25 452.98 122.27 452.79 122.42 448.83 122.53 448.65 117.83 449.8 117.79 449.7 114.47 Z"
          data-name="Pine"
          data-stusps="MN"
          id="27115"
        />
        <path
          className="white"
          d="M 647.39 344.75 649.51 342.97 650.28 343.65 650.11 342.44 651.53 341.23 651.64 341.14 652.99 341.41 654.65 342.92 656.08 342.64 658.42 342.79 658.19 344.31 658.78 346.34 658.27 348.72 659.55 350.22 659 350.87 659.03 351.06 659.07 351.15 659.13 351.21 659.1 351.24 659.22 351.23 659.28 351.19 659.39 351.08 659.55 350.92 659.59 350.9 659.66 350.92 659.68 350.98 659.6 351.13 659.56 351.25 659.55 351.32 659.57 351.48 659.61 351.58 659.71 351.71 659.7 351.82 659.6 351.82 659.53 351.87 659.48 351.95 659.35 352.06 659.32 352.1 659.31 352.19 659.33 352.31 659.39 352.38 659.55 352.47 659.53 352.53 659.62 352.73 659.84 353.69 659.68 353.73 658.77 353.4 658.73 353.52 657.19 352.26 655.31 351.63 654.97 350.53 652.38 350.27 650.85 348.01 649.27 346.92 647.39 344.75 Z"
          data-name="Colleton"
          data-stusps="SC"
          id="45029"
        />
        <path
          className="white"
          d="M 447.61 68.12 449.27 67.98 450.05 68.63 452.17 69.6 453.33 69.48 453.4 70.13 453.11 70.92 454.15 71.37 454.9 71.19 455.66 71.8 455.54 72.98 456.26 74.01 456.92 75.39 457.58 74.98 457.79 74.27 457.75 73.4 458.14 72.8 459.39 72.59 460.73 72.6 461.46 73.28 461.77 74.64 462.87 74.78 464.11 75.31 464.87 87.76 465.39 99.03 465.24 99.21 463.99 100.07 462.67 101.22 462.07 101.81 462.76 103.61 462.3 103.55 461.64 103.14 461.08 103.22 460.6 103.92 460.34 104.51 459.22 104.59 459.01 102.7 449.2 103.05 449.09 98.17 448.67 91.15 448.56 85.14 448.2 81.92 447.89 78.63 447.61 68.12 Z"
          data-name="St. Louis"
          data-stusps="MN"
          id="27137"
        />
        <path
          className="white"
          d="M 95.95 88.9 96.33 89.03 102.72 90.97 111.28 93.54 112.19 94.49 113.3 94.24 114.71 95.31 114.43 97.12 113.52 96.9 113.04 99.04 111.74 98.8 109.67 98.97 109.65 99.79 111.27 100.65 111.88 102 109.76 104.15 107.49 107.5 111.07 108.52 110.88 109.35 109.97 112.59 105.1 111.18 102.03 110.12 101.55 111.76 90.15 108.37 92.18 101.85 95.22 92.2 95.95 88.9 Z"
          data-name="Grant"
          data-stusps="OR"
          id="41023"
        />
        <path
          className="white"
          d="M 441.11 143.25 443.09 141.94 443.37 140.64 443.57 140.29 444.35 140.07 446.54 140.37 446.91 140.25 447.1 141.63 447.69 143.24 447.69 144.87 446.67 144.9 444.43 144.98 439.25 145.12 439.34 144.28 441.11 143.25 Z"
          data-name="Scott"
          data-stusps="MN"
          id="27139"
        />
        <path
          className="white"
          d="M 572.47 244.49 573.29 244.02 574.82 243.6 575.47 243.6 575.47 242.37 575.51 242.2 575.8 242.16 577.75 243.49 576 243.94 576.02 244.79 575.68 245.18 573.96 246.15 573.51 245.87 572.47 244.49 Z"
          data-name="Gallatin"
          data-stusps="KY"
          id="21077"
        />
        <path
          className="white"
          d="M 689.68 227.54 689.49 226.81 690.06 226.07 690.99 227.64 691.39 226.84 693.56 226.25 695.45 226.67 695.79 227.74 696.86 227.97 697.03 228.66 695.57 228.71 694.53 231.37 695.73 233.72 695.13 233.64 694.09 233.02 693.15 232.51 692.46 231.18 692.14 230.77 691.34 231.36 690.68 231.77 689.49 232.62 688.55 231.72 688.34 229.74 689.02 228.36 689.78 227.93 689.68 227.54 Z"
          data-name="Charles"
          data-stusps="MD"
          id="24017"
        />
        <path
          className="white"
          d="M 358.9 222.92 365.38 223.19 365.14 229.73 360.48 229.55 358.7 229.48 358.65 229.48 358.9 222.92 Z"
          data-name="Harlan"
          data-stusps="NE"
          id="31083"
        />
        <path
          className="white"
          d="M 124.39 195.06 132.66 197.08 147.34 200.43 150.32 201.06 150.24 201.42 149.46 205.04 149.01 207.16 148.02 211.92 147.85 212.73 145.87 222.08 145.39 224.48 144.58 228.29 130.44 225.3 119.07 213.11 120.86 207.46 122.34 205.25 122.65 202.61 123.76 200.4 123.89 197.15 124.39 195.06 Z"
          data-name="White Pine"
          data-stusps="NV"
          id="32033"
        />
        <path
          className="white"
          d="M 723.44 165.8 726.22 164.64 729.46 163.28 729.73 164.65 731.12 165.95 728.57 168.61 728.19 169.01 729.59 170.31 729.66 170.57 729.78 170.92 729.78 170.92 729.43 171.94 728.72 172.68 728.75 173.31 729.13 173.31 729.05 173.42 727.87 173.36 727.38 173.08 726.34 173.18 726.37 172.51 726.33 171.6 726.3 171.44 725.72 168.91 723.98 167.15 723.44 165.8 Z"
          data-name="Westchester"
          data-stusps="NY"
          id="36119"
        />
        <path
          className="white"
          d="M 696.33 126.74 693.18 117.91 694.83 118.39 697.56 117.27 701.54 127.95 701.01 131.04 703.41 131.49 704.19 133.53 703.84 135.96 703.94 136.15 704.25 136.4 704.81 139.63 703.03 139.38 703.01 140.86 699.91 139.99 698.64 141.36 698.51 140.92 697.58 137.7 698.79 133.88 698.77 133.88 698.75 133.88 698.74 133.88 698.73 133.87 698.72 133.85 698.72 133.84 698.72 133.82 698.72 133.81 698.73 133.8 698.75 133.79 698.76 133.78 698.76 133.77 698.75 133.76 698.74 133.76 698.73 133.75 698.71 133.75 698.7 133.75 698.69 133.76 698.68 133.77 698.66 133.79 698.65 133.8 698.63 133.83 698.61 133.84 698.61 133.84 698.6 133.85 698.59 133.86 698.58 133.87 698.56 133.88 698.54 133.88 698.52 133.89 698.51 133.89 698.48 133.9 698.45 133.9 698.43 133.9 698.34 133.88 698.32 133.87 698.3 133.86 698.27 133.85 698.25 133.84 698.23 133.84 698.22 133.84 698.19 133.84 698.17 133.83 698.15 133.83 698.14 133.82 698.12 133.82 698.12 133.82 698.1 133.82 698.08 133.83 698.07 133.83 698.05 133.82 698.04 133.82 698.02 133.82 698 133.81 697.99 133.81 697.98 133.81 697.98 133.8 697.98 133.78 697.96 133.74 697.95 133.72 697.95 133.71 697.94 133.71 697.92 133.71 697.92 133.71 697.91 133.7 697.9 133.71 697.89 133.71 697.83 133.71 697.79 133.72 697.77 133.72 697.75 133.71 697.75 133.7 697.74 133.7 697.74 133.7 697.72 133.68 697.69 133.67 697.67 133.66 697.66 133.64 697.65 133.62 697.64 133.62 697.63 133.62 697.62 133.63 697.62 133.63 697.63 133.66 697.63 133.68 697.62 133.68 697.6 133.69 697.59 133.71 697.59 133.72 697.59 133.73 697.59 133.74 697.6 133.75 697.61 133.76 697.61 133.78 697.61 133.78 697.61 133.79 697.6 133.8 697.59 133.8 697.57 133.8 697.56 133.79 697.56 133.78 697.55 133.74 697.55 133.74 697.55 133.71 697.52 133.68 697.51 133.66 697.5 133.63 697.5 133.6 697.49 133.59 697.48 133.59 697.47 133.59 697.47 133.61 697.47 133.62 697.47 133.63 697.45 133.65 697.44 133.66 697.44 133.66 697.4 133.67 697.37 133.64 698.19 131.96 696.33 126.74 Z"
          data-name="Herkimer"
          data-stusps="NY"
          id="36043"
        />
        <path
          className="white"
          d="M 332.9 96.43 337.16 96.77 347.81 97.49 348.08 98.98 349.53 102.24 349.37 103.1 350.93 104.25 352.19 105.21 351.63 108.19 349.88 108.79 347.78 108.3 345.79 110.52 345.6 108.87 342.35 108.65 342.69 103.79 337.26 103.38 337.38 101.76 332.5 101.38 332.9 96.43 Z"
          data-name="Morton"
          data-stusps="ND"
          id="38059"
        />
        <path
          className="white"
          d="M 707.5 258.86 708.06 259.03 708.05 259.94 708.68 260.18 709.74 259.74 709.68 259.28 710.58 258.73 710.7 259.09 711.21 260 713.61 261.02 712.89 261.71 713.35 263.91 710.42 264.53 710.42 264.53 707.68 265.1 707.28 261.3 707.15 259.92 707.5 258.86 Z"
          data-name="Chesapeake"
          data-stusps="VA"
          id="51550"
        />
        <path
          className="white"
          d="M 597.57 296.34 599.54 294.19 599.07 293.25 602.39 295.05 604.98 295.23 605.91 296.47 606.27 298.53 606.16 298.78 605.78 299.7 605 299.75 603.97 300.82 603.51 301.04 602.9 301.89 601.51 301.99 600.5 302.09 600.35 302.12 600.06 299.8 599.36 299.48 597.57 296.34 Z"
          data-name="Sevier"
          data-stusps="TN"
          id="47155"
        />
        <path
          className="white"
          d="M 482.93 299.19 485.71 301.07 485.89 301.74 486.14 301.04 489.87 300.88 490.82 300.84 489.79 302.19 489.4 304.33 489.17 305.98 486.72 306.02 484.18 306.05 481.76 306.15 481.58 299.76 482.93 299.19 Z"
          data-name="Lawrence"
          data-stusps="AR"
          id="5075"
        />
        <path
          className="white"
          d="M 697.56 117.27 701.73 115.56 705.04 114.23 706.17 116.96 705.31 118.1 707.57 119.79 708.35 119.19 709.91 119.44 710.04 120.45 707.98 121.33 710.56 127.84 711.44 129.98 710.49 130.89 708.94 130.9 706.14 131.93 703.41 131.49 701.01 131.04 701.54 127.95 697.56 117.27 Z"
          data-name="Hamilton"
          data-stusps="NY"
          id="36041"
        />
        <path
          className="white"
          d="M 424.57 354.55 429.49 354.77 429.55 355 429.45 362.13 427.6 360.45 424.6 361.2 424.57 354.55 Z"
          data-name="Titus"
          data-stusps="TX"
          id="48449"
        />
        <path
          className="white"
          d="M 388.92 286.74 390.09 286.76 393.66 286.81 394.37 286.82 399.64 286.88 399.57 290.95 397.49 291.5 396.84 292.72 394.84 292.73 394.92 294.42 388.81 294.34 388.79 294.34 388.92 286.74 Z"
          data-name="Kay"
          data-stusps="OK"
          id="40071"
        />
        <path
          className="white"
          d="M 710.56 127.84 714.21 126.3 715.49 127.82 715.62 128.83 716.73 129.16 716.88 128.24 718.66 126.93 720.21 131.54 720.02 133.94 719.72 134.2 719.56 134.83 720.27 136.82 720.27 137.07 719.38 136.53 718.46 137.66 716.88 136.63 716.46 135.54 715.82 135.99 713.62 135.41 713.44 134.98 713.42 134.91 711.44 129.98 710.56 127.84 Z"
          data-name="Saratoga"
          data-stusps="NY"
          id="36091"
        />
        <path
          className="white"
          d="M 366.03 190.57 372.48 190.79 372.29 197.33 365.92 197.09 365.78 197.08 366.03 190.57 Z"
          data-name="Garfield"
          data-stusps="NE"
          id="31071"
        />
        <path
          className="white"
          d="M 698.38 152.29 701.22 150.69 705.41 146.52 707.23 145.94 708.98 147.36 711.78 148.03 711.22 151.26 712.58 151.56 711.58 152.28 708.71 155.64 704.38 160.09 703.68 160.01 702.55 159.84 701.85 158.78 700.94 158.09 700.67 158.14 700 157.96 698.9 154.55 698.38 152.29 Z"
          data-name="Delaware"
          data-stusps="NY"
          id="36025"
        />
        <path
          className="white"
          d="M 412.99 357.78 414.17 357.13 415.05 356.17 415.22 356.28 415.95 356.23 417.35 355.15 418.65 355.36 421.69 354.8 421.72 362.57 416.09 362.63 415.91 362.27 412.98 362.27 412.99 357.78 Z"
          data-name="Hopkins"
          data-stusps="TX"
          id="48223"
        />
        <path
          className="white"
          d="M 484.63 417.54 488.16 417.12 489.44 419.42 490.95 420.21 490.9 422.12 488.98 421.22 486.15 420.72 486.32 419.76 484.63 417.54 Z M 479.62 407.55 480.51 407.53 481.54 408.52 481.95 411 482.94 412.24 484.38 412.42 484.65 414.79 486.24 415.55 482.48 416.18 481.47 414.81 480.3 414.58 478.91 416.1 476.73 415.64 477.42 414.08 476.19 413.6 476.76 412.56 475.92 410.11 476.07 409.38 480.95 409.44 479.62 407.55 Z"
          data-name="St. Martin"
          data-stusps="LA"
          fillRule="evenodd"
          id="22099"
        />
        <path
          className="white"
          d="M 406.11 362.22 406.17 355.28 413.04 354.22 412.99 357.78 412.98 362.27 411.67 362.27 411 364.2 411.84 364.94 409.58 364.91 406.1 364.84 406.11 362.22 Z"
          data-name="Hunt"
          data-stusps="TX"
          id="48231"
        />
        <path
          className="white"
          d="M 703.87 96.84 705.95 102.11 706.21 102.01 708.45 107.03 705.45 108.33 707.5 113.2 705.04 114.23 701.73 115.56 701.49 114.19 695.66 99.13 696.1 98.97 698.43 98.39 701.15 97.71 703.87 96.84 Z"
          data-name="Franklin"
          data-stusps="NY"
          id="36033"
        />
        <path
          className="white"
          d="M 704.38 160.09 708.71 155.64 714.01 157.1 712.94 160.01 715.98 161.24 716.64 162.15 715.53 164.2 711.53 165.5 711.91 166.66 711.28 166.75 709.87 166.62 708.37 166.18 707.12 164.91 706.95 164.38 706.73 163.67 706.14 161.6 705.61 160.74 704.87 160.15 704.38 160.09 Z"
          data-name="Sullivan"
          data-stusps="NY"
          id="36105"
        />
        <path
          className="white"
          d="M 671.76 231.35 673.69 232.84 676.2 234.87 676.57 236.62 674.82 238.56 674.49 238.54 674.16 238.03 673.81 237.92 672.9 238.01 671.36 236.55 670.62 234.56 670.57 233.54 671.76 231.35 Z"
          data-name="Madison"
          data-stusps="VA"
          id="51113"
        />
        <path
          className="white"
          d="M 401.56 405.01 403.34 404.11 405.29 400.82 406.86 399.83 407.4 400.33 408.02 402.66 407.69 406.86 408.76 409.77 409.44 410.02 408.34 410.9 408.22 411.89 407.83 410.68 405.87 410.96 406.32 410.27 405.2 409.18 404.92 407.92 402.47 406.29 400.99 406.02 401.56 405.01 Z"
          data-name="Brazos"
          data-stusps="TX"
          id="48041"
        />
        <path
          className="white"
          d="M 401.71 340.97 403.76 340.99 404.49 340.18 410.97 340.21 411.8 340.81 412.1 344.56 414.12 345.54 413.64 345.81 413.26 345.77 412.59 345.7 411.84 345.49 409.83 346.12 408.46 346.3 408.12 346.88 407.24 347.86 406.49 347.45 406.01 348.1 405.13 348.86 404.88 348.46 404.51 347.88 403.99 347.25 402.96 347.37 402.63 346.53 401.86 346.5 401.55 346.28 401.6 345.35 401.53 345.3 401.82 343.78 401.08 342.92 402.28 341.93 401.71 340.97 Z"
          data-name="Bryan"
          data-stusps="OK"
          id="40013"
        />
        <path
          className="white"
          d="M 524.26 112.43 525.9 112.26 525.56 108.99 527.2 108.82 533.73 108.08 535.37 107.9 535.95 112.81 536.67 115.5 535.69 116.42 534.89 118.18 534.8 119.68 533.65 118.51 533.58 116.99 534.25 116.12 532.42 114.84 531.75 116.61 530.2 117.72 528.71 117.01 527.49 118.23 526.65 120.44 525.67 120.52 524.99 114 524.26 112.43 Z"
          data-name="Delta"
          data-stusps="MI"
          id="26041"
        />
        <path
          className="white"
          d="M 737.44 98.95 738.3 98.32 738.62 97.24 739.32 96.34 738.94 95.51 739.33 94.74 738.95 93.87 738.29 93.3 737.24 91.95 737.64 90.62 737.83 89 738.02 88.31 737.14 87.26 737.32 86.44 737.02 85.37 737.45 84.43 737.47 83.15 737.48 82.58 736.8 81.95 737.64 81.05 738.46 80.12 739.18 80.58 740.16 80.82 740.72 80.6 740.88 79.74 741.07 79.19 743.28 84.78 745.17 89.62 746.79 93.98 747.2 95.09 747.89 96.92 748.15 97.64 748.27 97.96 748.13 98.98 745.26 99.76 745.07 103.09 744.32 101.68 743.24 101.07 742.65 100.49 740.83 100.95 740.39 100.06 738.75 100.01 737.44 98.95 Z"
          data-name="Coos"
          data-stusps="NH"
          id="33007"
        />
        <path
          className="white"
          d="M 660.61 167.29 663.07 166.76 665.88 166.17 667.03 165.91 669 165.47 671.04 174.05 671.32 175.25 665.79 176.52 664.91 176.69 662.18 174.47 660.61 167.29 Z"
          data-name="Potter"
          data-stusps="PA"
          id="42105"
        />
        <path
          className="white"
          d="M 409.67 129.11 414.56 129.11 421.07 129.07 421.09 132.34 421.22 133.96 410.72 133.99 409.83 133.53 409.65 132.34 409.67 129.11 Z"
          data-name="Swift"
          data-stusps="MN"
          id="27151"
        />
        <path
          className="white"
          d="M 568.75 352.88 569.27 352.54 574.37 352.03 575.33 351.92 576.03 359.06 574.68 359.5 574.43 359.81 574.63 361.72 573.02 362.16 573.2 363.79 571.78 363.95 571.41 359.01 569.38 359.2 569.17 357.99 568.75 352.88 Z"
          data-name="Tallapoosa"
          data-stusps="AL"
          id="1123"
        />
        <path
          className="white"
          d="M 559.56 149.57 566.12 148.65 567 155.22 563.74 155.66 560.47 156.09 559.56 149.57 Z"
          data-name="Isabella"
          data-stusps="MI"
          id="26073"
        />
        <path
          className="white"
          d="M 348.57 337.63 351.99 340.23 353.85 340.19 355.45 341.06 356.61 340.54 356.44 345.26 356.39 347.14 355.18 345.88 354.46 346.06 350.81 345.02 348.29 344.91 347.47 344.88 347.8 337.49 347.96 337.33 348.57 337.63 Z"
          data-name="Foard"
          data-stusps="TX"
          id="48155"
        />
        <path
          className="white"
          d="M 550.32 127.6 550.08 132.45 547.45 132.78 545.81 132.91 543.92 133.14 543.98 132.31 543.87 130.62 544.94 130.58 545.44 129.33 546.54 129.77 547.43 128.9 547.71 127.47 548.48 126.58 548.93 125.03 549.93 124.15 550.27 124.74 550.13 127.31 550.32 127.6 Z M 542.52 128.27 543.5 125.93 544.25 126 544.79 126.54 544.62 127.64 543.39 129.17 542.39 129.06 542.52 128.27 Z"
          data-name="Leelanau"
          data-stusps="MI"
          fillRule="evenodd"
          id="26089"
        />
        <path
          className="white"
          d="M 757.83 159.32 757.97 157.82 758.63 157.52 759.13 158.62 759.53 159.17 758.48 159.55 757.83 159.32 Z M 753.7 157.38 753.86 156.64 753.48 155.56 754.06 155.3 754.05 155.29 753.17 151.86 757.46 150.46 758.66 149.11 759.26 152.48 759.25 152.94 759.1 153.02 758.98 154.01 758.79 154.82 757.75 155.09 756.83 155.62 755.87 156.4 755.49 156.59 754.73 156.97 753.72 157.59 753.7 157.38 Z"
          data-name="Washington"
          data-stusps="RI"
          fillRule="evenodd"
          id="44009"
        />
        <path
          className="white"
          d="M 431.36 240.75 437.03 240.69 437.09 245.33 435.94 244.79 435.31 245.81 434.86 246.19 434.23 245.63 434.36 245.98 434.33 246.17 434 246.61 433.48 247.02 433.13 246.55 432.98 246.46 432.57 246.5 432.34 246.62 432.19 246.84 431.65 246.99 431.78 245.9 431.56 246.4 431.42 246.39 431.36 240.75 Z"
          data-name="Clay"
          data-stusps="MO"
          id="29047"
        />
        <path
          className="white"
          d="M 318.35 157.49 327 158.18 327.51 157.97 327.19 162.18 327.45 163.84 327.11 168.73 327.29 171.2 327.29 171.2 322.79 170.85 317.51 170.41 314.63 170.17 315.4 161.22 315.61 158.8 317.06 157.62 318.35 157.49 Z"
          data-name="Oglala Lakota"
          data-stusps="SD"
          id="46102"
        />
        <path
          className="white"
          d="M 331.3 133.01 331.93 124.86 338.93 125.37 338.6 126.99 338.14 133.5 337.89 134.33 342.75 134.65 342.44 139.29 341.13 140.24 339.35 140.2 339.04 140.82 338.02 141.08 336.92 142.3 334.47 141.9 333.1 142.88 332.08 142.5 330.54 142.89 331.3 133.01 Z"
          data-name="Ziebach"
          data-stusps="SD"
          id="46137"
        />
        <path
          className="white"
          d="M 424.21 239.38 431.33 239.36 431.36 240.75 431.42 246.39 431.1 246.37 430.27 245.86 429.37 246.14 428.63 245.56 428.52 245.48 428.13 244.81 427.67 244.21 426.91 243.29 427.18 241.99 426.34 241.87 426.05 241.46 425.81 241.11 424.82 240.1 424.21 239.38 Z"
          data-name="Platte"
          data-stusps="MO"
          id="29165"
        />
        <path
          className="white"
          d="M 537.5 303.52 537.55 302.25 540.04 300.39 545.15 300.58 545.22 300.93 545.17 302.64 544.79 305.52 543.58 306.41 541.8 307.39 539.79 306.84 538.76 307.76 537.36 306.84 537.5 303.52 Z"
          data-name="Hickman"
          data-stusps="TN"
          id="47081"
        />
        <path
          className="white"
          d="M 158.04 165.66 161.17 166.45 165.7 167.33 169.19 168.01 172.69 168.7 172.7 168.7 177.66 169.67 183.05 170.73 184.52 171.07 185.89 175.31 185.11 176.82 185.34 180.31 185.9 180.04 186.69 181.52 186.31 182.59 185.3 182.26 184.98 183.53 183.95 183.9 180.97 183.32 176.38 187.51 171.72 188.09 153.95 184.4 153.95 184.4 154.81 180.48 155.99 175.13 157.07 170.19 158.04 165.66 Z"
          data-name="Box Elder"
          data-stusps="UT"
          id="49003"
        />
        <path
          className="white"
          d="M 372.87 425.24 374.74 424.46 376.52 423.65 378.03 422.39 378.96 421.38 380.09 420.44 381.3 422.45 381.6 422.32 381.8 423.08 383.99 424.41 383.45 425.19 380.51 429.47 378.61 429.4 376.02 429.59 375.71 428.16 375.91 427.49 375.22 427.47 374.12 426.01 373.46 426.07 372.87 425.24 Z"
          data-name="Guadalupe"
          data-stusps="TX"
          id="48187"
        />
        <path
          className="white"
          d="M 150.32 201.06 151.45 195.75 151.86 193.91 152.82 189.56 153.95 184.4 171.72 188.09 176.38 187.51 178.59 193.96 179.2 195.3 179 196.77 179.21 197.31 178.75 199.9 178.16 199.94 178.24 202.37 177.81 204.31 178.09 205.43 177.02 208.47 175.45 209.6 174.6 209.17 174.28 210.05 161.09 207.47 149.46 205.04 150.24 201.42 150.32 201.06 Z"
          data-name="Tooele"
          data-stusps="UT"
          id="49045"
        />
        <path
          className="white"
          d="M 413.02 208.91 419.8 208.9 419.81 213.74 413.97 213.76 413.63 213.83 413.36 213.33 413.5 212.43 412.96 211.59 412.98 210.92 412.99 210.35 412.92 209.58 413.02 208.91 Z"
          data-name="Mills"
          data-stusps="IA"
          id="19129"
        />
        <path
          className="white"
          d="M 385.09 452.24 387.89 448.09 391.49 445.04 393.34 445.13 395.54 446.35 395.94 445.95 397.21 447.41 398.03 447.48 397.58 449.49 392.04 450.31 393.69 451.92 391.66 453.49 389.73 453.97 388.8 452.81 386.97 453.15 386.07 452.18 385.09 452.24 Z"
          data-name="Refugio"
          data-stusps="TX"
          id="48391"
        />
        <path
          className="white"
          d="M 47.24 235.12 52.89 231.84 54.58 232.28 54.81 231.45 56 231.08 56.34 229.83 61.63 226.79 62.04 227.69 64.21 228.37 65.01 231.61 59.93 234.58 58.86 235.61 58.41 237.64 57.72 238.24 56.61 238.07 55.78 238.89 55.43 237.98 54.33 238.4 54.13 239.41 53.52 239.1 53.04 239.89 52.73 239.45 52.52 239.5 52.4 239.99 51.9 239.88 51.61 240.06 51.45 240.18 49.17 242.48 47.32 242.12 45.7 242.28 45.28 241.99 42.36 242.3 40.26 241.41 39.35 239.55 39.69 238.65 38.99 235.71 40.27 234.99 44.45 234.76 46.32 235.2 47.24 235.12 Z"
          data-name="Madera"
          data-stusps="CA"
          id="6039"
        />
        <path
          className="white"
          d="M 721.4 174.9 722.67 175.34 723.82 175.84 723.76 176.15 723.74 176.54 723.66 177.33 724.4 177.31 724.55 177.86 724.64 178 724.44 178.61 723.32 178.58 722.07 178.27 721.93 178.44 720.74 178.26 720.7 177.83 720.57 174.89 721.4 174.9 Z"
          data-name="Essex"
          data-stusps="NJ"
          id="34013"
        />
        <path
          className="white"
          d="M 519.94 193.61 521.53 193.44 523.19 193.24 523.28 194.06 523.31 194.35 525 194.69 525.19 196.32 526.56 196.16 526.92 196.7 527.07 197.79 530.77 197.43 531.06 200.67 531.06 200.67 524.17 201.42 524.34 203.05 521.05 203.42 520.51 198.52 520.51 198.52 520.38 197.44 520.22 196.07 520 194.15 519.94 193.61 Z"
          data-name="Will"
          data-stusps="IL"
          id="17197"
        />
        <path
          className="white"
          d="M 357.91 272.05 366.05 272.38 365.89 277.31 365.86 278.93 357.89 278.69 357.71 278.49 357.76 277.06 357.91 272.05 Z"
          data-name="Kiowa"
          data-stusps="KS"
          id="20097"
        />
        <path
          className="white"
          d="M 592.98 256.45 594.4 255.7 595.61 255.85 595.58 254.95 596.74 254.95 597.35 255.52 597.75 255.14 597.83 256.88 597.11 258.37 597.27 258.5 596.53 259.38 595.33 259.46 594.83 259.35 593.04 257.98 592.77 256.67 592.98 256.45 Z"
          data-name="Menifee"
          data-stusps="KY"
          id="21165"
        />
        <path
          className="white"
          d="M 765.37 75.76 766.89 74.87 768.4 73.98 771.5 72.11 770.62 70.7 771.9 69.91 770.03 66.79 769.81 66.41 768.89 64.96 767.59 65.74 766.65 62.93 768.22 61.88 763.47 48.64 764.92 48.11 768.48 47.06 770.83 53.36 771.63 55.14 774.07 61.92 774.42 61.96 776.17 60.64 778.69 58.95 782.72 65.33 781.31 66.19 778.25 67.98 779.52 70.08 777.97 71.01 778.84 72.51 777.3 73.43 778.23 75.03 779.13 76.55 779.52 77.22 778.49 77.83 777.39 78.46 777.24 79.3 776.53 79.18 776.24 80.57 775.12 80.48 774.71 80.24 772.56 81.65 770.48 82.97 769.63 81.47 768.86 81.91 768.22 80.74 768.1 80.35 767.2 78.84 766.26 77.26 765.37 75.76 Z"
          data-name="Penobscot"
          data-stusps="ME"
          id="23019"
        />
        <path
          className="white"
          d="M 78.29 166.3 85.8 168.4 85.24 170.38 90.25 171.76 101.67 174.77 100.81 178.05 105.75 179.36 105 182.32 98.95 191.37 84.95 187.75 74.39 184.85 72.72 184.4 75.89 174.56 78.29 166.3 Z"
          data-name="Pershing"
          data-stusps="NV"
          id="32027"
        />
        <path
          className="white"
          d="M 434.98 158.27 441.49 158.12 443.12 158.08 443.29 164.62 438.88 164.73 435.09 164.79 434.98 158.27 Z"
          data-name="Faribault"
          data-stusps="MN"
          id="27043"
        />
        <path
          className="white"
          d="M 608.56 196.59 610.74 196.28 614.87 195.63 615.45 195.54 615.68 196.94 615.95 198.6 616.42 201.58 609.58 202.68 608.56 196.59 Z"
          data-name="Wayne"
          data-stusps="OH"
          id="39169"
        />
        <path
          className="white"
          d="M 562.43 296.53 564.65 295.71 565.4 296.07 566.2 295.27 566.93 296.37 568.92 297.2 568.72 298.05 569.44 300.34 568.71 300.73 565.82 300.74 565.57 300.89 565.48 300.56 563.35 298.81 562.4 296.83 562.43 296.53 Z"
          data-name="DeKalb"
          data-stusps="TN"
          id="47041"
        />
        <path
          className="white"
          d="M 430.69 348.29 430.96 348.54 432.29 349.16 433.19 349.22 433.89 350.11 434.56 349.8 435.63 350.92 436.12 351.14 436.65 351.3 436.9 351.09 437.44 351.14 438.46 350.89 438.85 351 439.32 350.59 439.96 350.85 441.07 350.93 441.53 351.31 441.58 353.48 441.61 355.45 441.63 356.56 441.41 356.07 438.86 356.13 438.67 357.18 436.34 356.94 435.76 356.42 434.15 356.47 433.3 357.09 432.03 356.75 431.4 355.94 430.53 355.64 430.47 348.63 430.69 348.29 Z"
          data-name="Bowie"
          data-stusps="TX"
          id="48037"
        />
        <path
          className="white"
          d="M 677.95 254.91 678.43 253.32 679.2 252.97 681.03 251.76 682.63 251.89 683.52 252.84 683.39 253.91 685.55 255.39 687.17 255.12 687.2 255.13 686 256.8 685.26 256.95 684.77 256.86 678.27 256.26 677.95 254.91 Z"
          data-name="Amelia"
          data-stusps="VA"
          id="51007"
        />
        <path
          className="white"
          d="M 672.06 228.7 673.23 228.12 673.94 226.24 675.68 227.3 676.53 228.77 677.48 228.86 674.57 232.89 673.69 232.84 671.76 231.35 671.63 229.2 672.06 228.7 Z"
          data-name="Rappahannock"
          data-stusps="VA"
          id="51157"
        />
        <path
          className="white"
          d="M 703.41 131.49 706.14 131.93 708.94 130.9 710.49 130.89 711.44 129.98 713.42 134.91 708 136.33 707.25 136.52 703.94 136.15 703.84 135.96 704.19 133.53 703.41 131.49 Z"
          data-name="Fulton"
          data-stusps="NY"
          id="36035"
        />
        <path
          className="white"
          d="M 402.87 333.65 402.92 330.38 404.56 330.39 404.57 328.75 409.43 328.77 409.43 330.4 409.42 333.67 408.59 333.67 408.59 335.31 404.52 335.29 402.86 335.26 402.87 333.65 Z"
          data-name="Coal"
          data-stusps="OK"
          id="40029"
        />
        <path
          className="white"
          d="M 396.29 339.83 401.16 340.07 401.71 340.97 402.28 341.93 401.08 342.92 401.82 343.78 401.53 345.3 400.52 344.66 400.16 345.41 399.68 346.25 398.68 346.05 398.41 345.54 397.52 345.94 396.81 344.89 396.69 344.06 396.23 344.08 396.24 342.82 395.71 341.73 395.75 339.82 396.29 339.83 Z"
          data-name="Marshall"
          data-stusps="OK"
          id="40095"
        />
        <path
          className="white"
          d="M 414.95 389.91 416.35 389.2 422.42 388.22 424.1 388.39 425.21 389.59 425.19 390.51 426.78 391.33 427.21 391.64 427.51 392.05 419.87 398.25 416.92 400.65 415.9 399.6 416.29 397.86 414.55 397.59 415.12 396.28 415.18 394.27 416.27 393.03 415.4 390.85 414.83 390.77 414.95 389.91 Z"
          data-name="Houston"
          data-stusps="TX"
          id="48225"
        />
        <path
          className="white"
          d="M 396.45 327.05 396.5 324.99 397.19 325.71 398.3 325.38 398.88 326.22 399.61 327.03 399.88 326.01 401.95 325.94 402.69 326.82 403.28 326.06 404.59 325.62 404.57 328.75 404.56 330.39 402.92 330.38 402.87 333.65 398.01 333.6 398.03 331.96 396.39 331.95 396.4 331.13 396.45 327.05 Z"
          data-name="Pontotoc"
          data-stusps="OK"
          id="40123"
        />
        <path
          className="white"
          d="M 670.32 235.68 670.62 234.56 671.36 236.55 672.9 238.01 673.81 237.92 672.94 239.83 668.2 238.91 669.64 237.51 670.32 235.68 Z"
          data-name="Greene"
          data-stusps="VA"
          id="51079"
        />
        <path
          className="white"
          d="M 624.67 214.09 624.09 209.95 624.52 209.83 626.07 209.67 629.09 209.3 630.79 209.09 631.71 208.89 631.68 209.01 631.46 210.43 631.6 211.31 631.77 212.5 631.49 212.95 631.03 213.64 630.96 214.99 624.88 215.67 624.67 214.09 Z"
          data-name="Belmont"
          data-stusps="OH"
          id="39013"
        />
        <path
          className="white"
          d="M 539.08 347.19 541.83 347.04 542.25 345.33 545.54 345.21 546.39 345.43 547.22 345.35 547.34 346.73 548.15 346.69 547.03 347.58 549.55 349.79 549.81 350.05 549.83 350.18 550.1 350.16 550.13 350.43 550.68 350.4 550.71 350.68 551.33 350.63 551.35 350.84 551.55 350.82 551.56 350.89 551.7 350.88 551.74 351.43 549.71 352.55 549.81 353.79 548.5 353.86 548.12 356.29 546.48 356.48 541.82 356.78 539.95 356.73 539.85 355.29 539.69 354.49 539.67 354.17 539.08 347.19 Z"
          data-name="Tuscaloosa"
          data-stusps="AL"
          id="1125"
        />
        <path
          className="white"
          d="M 596.04 304.76 596.12 304.71 601.86 304.48 600.77 307.59 600.49 308.22 598.48 308.32 596.44 309.3 595.33 308.02 595.41 307.94 595.07 306.97 595.48 306.48 595.18 305.83 595.83 304.88 596.04 304.76 Z"
          data-name="Graham"
          data-stusps="NC"
          id="37075"
        />
        <path
          className="white"
          d="M 537.54 376.33 544.05 375.83 544.23 378 545.05 378.86 546.96 378.67 546.91 381.16 546.1 381.24 546.32 383.94 545.5 384.66 546.36 386.18 544.89 386.52 543.11 388.51 543.46 389 542.8 388.64 542.41 390.33 540.67 391.18 540.29 388.88 541.12 388.69 541.36 387.36 540.52 386.47 540.92 385.51 540.61 385.32 540.28 384.9 539.83 384.86 538.81 384.36 538.83 383.91 538.45 383.96 538.1 383.77 537.74 382.58 537.89 382.37 537.7 381.82 536.07 379.76 536.83 377.14 537.54 376.33 Z"
          data-name="Clarke"
          data-stusps="AL"
          id="1025"
        />
        <path
          className="white"
          d="M 546.69 358.9 548.3 358.76 548.37 359.58 553.14 359.08 553.33 361.1 552.22 365.74 547.25 366.27 547.53 369.56 546.71 369.64 545.89 369.71 545.63 366.42 545.36 363.15 546.18 363.08 545.94 359.79 546.69 358.9 Z"
          data-name="Perry"
          data-stusps="AL"
          id="1105"
        />
        <path
          className="white"
          d="M 544.05 375.83 544.75 375.51 544.55 373.12 546.18 372.99 546.11 370.47 546.79 370.44 550.31 372.39 551.83 374.15 556.17 373.79 556.98 373.71 557.1 375.34 556.28 375.42 556.51 377.88 546.96 378.67 545.05 378.86 544.23 378 544.05 375.83 Z"
          data-name="Wilcox"
          data-stusps="AL"
          id="1131"
        />
        <path
          className="white"
          d="M 616.48 253.61 619.35 252.21 620.19 252.07 619.59 252.91 622.64 253.42 623.96 255.67 625.74 255.79 623.52 256.76 624.58 257.66 623.18 258.67 621.21 258.55 620.27 259.42 618.87 258.53 617.99 255.71 616.48 253.61 Z"
          data-name="Logan"
          data-stusps="WV"
          id="54045"
        />
        <path
          className="white"
          d="M 621.42 296.69 621.7 296.75 622.6 295.92 623.29 294.13 625.48 292.63 625.38 292.13 625.84 291.12 626.62 292.49 625.59 294.11 627.64 295.5 628.74 298.14 628.54 298.8 626.65 299.38 623.53 299.79 621.48 298.86 621.42 296.69 Z"
          data-name="McDowell"
          data-stusps="NC"
          id="37111"
        />
        <path
          className="white"
          d="M 679.4 239.85 682.14 235.02 682.23 234.51 683.01 234.01 683.46 234.12 683.82 234.72 685.01 234.96 685.72 235.51 686.35 235.17 687.34 235.74 687.64 235.65 685.99 238.78 684.56 241.34 683.82 241.15 681.18 239.74 679.4 239.85 Z"
          data-name="Spotsylvania"
          data-stusps="VA"
          id="51177"
        />
        <path
          className="white"
          d="M 379.72 94.22 386.19 94.42 389.45 94.51 389.33 99.41 389.65 99.42 389.49 105.97 384.94 105.84 379.69 105.67 379.9 99.13 379.72 94.22 Z"
          data-name="Barnes"
          data-stusps="ND"
          id="38003"
        />
        <path
          className="white"
          d="M 751.18 117.69 751.82 116.05 750.68 112.61 752.44 112.24 752.91 113.06 753.39 111.72 753.7 112.25 753.83 112.95 753.99 113.82 754.09 114.89 755.23 115.59 756.26 116.39 757.4 117.13 757.46 117.88 757.46 117.88 757.72 118.85 757.87 118.92 757.36 119.97 754.63 120.81 754.93 119.55 753.17 118.82 753.07 118.78 751.08 117.93 751.18 117.69 Z"
          data-name="Strafford"
          data-stusps="NH"
          id="33017"
        />
        <path
          className="white"
          d="M 423.55 426.36 424.44 427.46 425.41 427.01 426.02 426.3 426.79 426.37 428.58 427.45 430.5 426.42 430.99 426.91 434.53 425.97 436.54 426.06 437.4 426.25 435.28 427.22 433.74 427.93 432.51 428.64 431.53 429.81 431.68 430.51 430.35 431.5 426.71 433.99 425.26 435.35 426.21 433.02 423.96 429.2 423.28 428.06 423.55 426.36 Z"
          data-name="Galveston"
          data-stusps="TX"
          id="48167"
        />
        <path
          className="white"
          d="M 463.96 321.45 464.47 321.42 464.3 319.24 464.93 318.38 464.93 316.63 468.44 316.6 470.61 316.54 470.7 322.1 470.71 323.12 469.07 323.13 469.09 324.77 466.17 324.79 465.95 326.46 465.31 324.53 464.22 324.46 463.36 323.7 463.96 321.45 Z"
          data-name="Faulkner"
          data-stusps="AR"
          id="5045"
        />
        <path
          className="white"
          d="M 518.67 118 520.46 117.81 520.12 114.51 521.17 114.4 521 112.77 524.26 112.43 524.99 114 525.67 120.52 526.65 120.44 526.28 121.4 525.64 123.25 524.4 125.93 523.44 127.58 523.08 129.45 522.29 129.32 521.58 128.55 520.87 127.74 521.18 126.8 521.63 125.4 521.66 124.41 520.98 124.19 520.45 124.79 519.8 124.88 518.97 124.98 518.98 124.22 519.01 123.24 519.5 122.65 519.43 121.68 519.55 120.71 519.62 120.05 518.91 119.29 519.45 118.84 519.08 118.32 518.67 118 Z"
          data-name="Menominee"
          data-stusps="MI"
          id="26109"
        />
        <path
          className="white"
          d="M 669 165.47 677.46 163.54 678.05 163.41 678.6 163.28 681.08 170.73 680.06 171.86 671.04 174.05 669 165.47 Z"
          data-name="Tioga"
          data-stusps="PA"
          id="42117"
        />
        <path
          className="white"
          d="M 726.65 176.78 727.02 175.77 727.07 175.47 727.99 175.13 728.25 175 728.91 174.67 729.47 175.11 730.32 175.49 730.13 176.12 730.09 176.23 730.17 176.4 730.34 176.96 730.37 177.23 730.48 177.46 730.3 177.73 730.43 178.77 730.08 178.83 729.42 179.3 728.75 178.11 728.34 177.46 728.21 177.22 728.07 177.33 727.32 177.02 727.31 177.01 726.65 176.78 Z"
          data-name="Queens"
          data-stusps="NY"
          id="36081"
        />
        <path
          className="white"
          d="M 689.14 262.39 692.07 259.53 694.88 256.87 695.31 256.52 698.44 257.03 699.04 259.08 692.67 265.05 691.7 264.98 691.64 262.19 690.92 262.69 689.14 262.39 Z"
          data-name="Sussex"
          data-stusps="VA"
          id="51183"
        />
        <path
          className="white"
          d="M 332.97 310.67 341.34 311.09 340.97 319.27 332.53 318.87 332.97 310.67 Z"
          data-name="Gray"
          data-stusps="TX"
          id="48179"
        />
        <path
          className="white"
          d="M 359.84 81.92 363.09 82.09 369.6 82.41 369.45 85.68 369.78 87.3 369.56 92.19 366.82 92.07 359.76 91.71 360.12 85.21 359.84 81.92 Z"
          data-name="Wells"
          data-stusps="ND"
          id="38103"
        />
        <path
          className="white"
          d="M 710 199.75 710.06 199.68 709.88 200.14 710.79 200.68 710.91 201.04 713.76 201.55 716.24 202.92 716.46 205.04 713.69 203.73 712.25 206.13 711.83 207.58 711.4 207.42 710.9 206.8 709.76 206.64 709.71 205.9 709.55 205.19 709.58 204.33 709.04 204.1 708.66 203.51 708.94 203.1 709.14 202.27 709.48 201.61 709.52 200.59 710 199.75 Z"
          data-name="Salem"
          data-stusps="NJ"
          id="34033"
        />
        <path
          className="white"
          d="M 451.14 335.25 458.29 335.22 458.74 333.01 460.63 333.01 462.33 333.53 462.62 334.62 462.62 339.59 459.38 339.57 457 339.65 457.01 338.12 454.45 337.42 451.98 337.43 451.15 336.34 451.14 335.25 Z"
          data-name="Hot Spring"
          data-stusps="AR"
          id="5059"
        />
        <path
          className="white"
          d="M 313.78 218.53 315.43 218.66 324.24 219.28 324.12 220.99 324.1 221.19 323.66 227.48 323.42 230.94 323.12 235.54 312.16 234.85 312.94 226.7 313.45 220.15 313.78 218.53 Z"
          data-name="Yuma"
          data-stusps="CO"
          id="8125"
        />
        <path
          className="white"
          d="M 332.98 310.55 333.42 302.48 333.42 302.44 341.63 302.88 341.73 302.88 341.34 311.09 332.97 310.67 332.98 310.55 Z"
          data-name="Roberts"
          data-stusps="TX"
          id="48393"
        />
        <path
          className="white"
          d="M 403.46 169.51 403.85 169.48 413.03 169.55 413.06 176.09 403.66 176.06 403.65 175.8 404.23 175.11 403.95 174.77 404.34 174.26 404.08 173.6 404.82 173.09 404.91 172.81 405.09 172.22 404.82 171.67 404.6 170.21 403.97 170.2 403.55 169.71 403.46 169.51 Z"
          data-name="Sioux"
          data-stusps="IA"
          id="19167"
        />
        <path
          className="white"
          d="M 351.5 377.97 352.82 378.04 359.77 378.31 359.31 389.77 357.47 390.79 356.09 390.07 354.32 390.42 352.91 389.1 352.52 389.55 351.04 387.44 351.5 377.97 Z"
          data-name="Coleman"
          data-stusps="TX"
          id="48083"
        />
        <path
          className="white"
          d="M 441.74 195.38 443.39 195.34 448.3 195.21 448.43 200.13 448.77 201.87 448.78 202.19 448.56 202.37 447.57 201.91 442.25 201.97 441.87 200.31 441.74 195.38 Z"
          data-name="Polk"
          data-stusps="IA"
          id="19153"
        />
        <path
          className="white"
          d="M 589.66 196.11 589.43 194.46 597.67 193.21 597.8 193.93 598.56 198.06 598.19 198.17 594.53 198.72 590.14 199.4 589.66 196.11 Z"
          data-name="Seneca"
          data-stusps="OH"
          id="39147"
        />
        <path
          className="white"
          d="M 586.77 385.06 586.76 384.81 586.61 384.04 586.91 382.7 586.75 382.01 586.98 381.02 587.41 381.61 590.77 380.99 591.39 382.16 593.85 381.95 594.21 383.86 594.13 385.27 589.65 385.78 589.92 389.25 588.31 389.35 588.01 388.76 586.7 387.4 586.55 386.03 586.78 385.32 586.77 385.06 Z"
          data-name="Early"
          data-stusps="GA"
          id="13099"
        />
        <path
          className="white"
          d="M 357.13 481.57 359.97 479.66 360.98 477.61 369.92 477.85 371.63 477.9 368.62 484.16 366.83 487.92 366.49 487.74 365.8 488.03 365.05 487.46 363.71 486.28 363.27 485.47 361.85 485.66 360.73 484.95 359.49 484.58 358.64 484.85 358.17 484.28 358.52 483.34 358.3 482.9 357.21 481.94 357.13 481.57 Z"
          data-name="Starr"
          data-stusps="TX"
          id="48427"
        />
        <path
          className="white"
          d="M 317.21 403.31 319.06 404.02 319.11 405.15 317.44 407.69 318.71 408.95 317.02 410.17 316.47 419.73 315.69 419.48 314.62 419.35 313.14 419.02 312.22 419.06 311.36 419.31 310.68 419.17 309.95 418.62 308.9 418.11 307.72 417.4 307.43 417.48 307.1 417.08 303.57 413.86 303.82 409.53 307.48 409.72 307.82 403.81 311.14 404.03 311.22 402.93 312.9 403.04 312.9 403.03 312.91 403.03 312.93 403.03 312.94 403.03 313.45 403.07 313.49 403.09 317.2 403.3 317.21 403.31 317.21 403.31 Z"
          data-name="Terrell"
          data-stusps="TX"
          id="48443"
        />
        <path
          className="white"
          d="M 607.09 322.5 610.5 321.77 611.53 320.48 611.63 320.58 612.45 321.17 611.96 322.76 612 325.49 611.15 326.27 608.89 326.15 608.32 326.91 608.5 326.17 607.47 325.07 607.09 322.5 Z"
          data-name="Franklin"
          data-stusps="GA"
          id="13119"
        />
        <path
          className="white"
          d="M 650.88 473.75 651.38 473.96 652.64 473.81 654.15 473.63 653.9 471.66 655.57 471.44 655.35 469.71 660.35 469.07 661 474.1 667.68 473.2 668.42 478.53 668.81 481.86 658.97 483.02 658.42 482.82 655.8 481.62 655.39 481.99 654.87 482.45 653.83 481.59 653.11 479.87 651.91 477.07 650.92 473.79 650.88 473.75 Z"
          data-name="Collier"
          data-stusps="FL"
          id="12021"
        />
        <path
          className="white"
          d="M 20.85 143.71 22.42 145.45 22.6 146.51 24.03 146.92 25.05 147.96 25.04 148.85 26.69 149.62 27.2 149.06 26.64 147.11 28.49 145.77 29.54 146.18 32.34 145.29 33.76 144.3 34.82 144.99 33.74 147.35 33.89 148.05 34.49 148.77 33.94 149.87 33.08 149.76 32.42 151.09 30.92 151.79 30.65 152.92 29.25 154.01 28.86 154.98 27.15 156.18 27.17 158.72 24.63 159.23 23.42 160.09 21.87 160.15 20.31 161.44 20.07 162.32 21.06 163.61 20.28 165.37 20.04 168.82 11.1 165.87 11.26 165.39 16.04 151.39 16.4 149.6 16.13 147.39 17.18 147.31 18.08 148.37 19.81 146.87 19.38 145.4 20.85 143.71 Z"
          data-name="Trinity"
          data-stusps="CA"
          id="6105"
        />
        <path
          className="white"
          d="M 524.26 271.29 524.82 271.24 527.75 271.01 528.49 271.4 528.51 271.45 529.47 272.2 529.59 272.66 529.68 272.96 528.29 273.47 526.45 273.89 525.37 274.88 525.37 274.88 524.48 274.64 524.26 271.29 Z"
          data-name="Hardin"
          data-stusps="IL"
          id="17069"
        />
        <path
          className="white"
          d="M 566.9 249.62 567.71 249.62 568.73 250.01 568.33 250.68 569.48 252.49 568.97 253.46 566.89 254.17 566.76 254.1 565.04 253.35 564.23 252.69 564.34 251.95 564.77 251.26 566.04 250.78 566.33 250.06 566.9 249.62 566.9 249.62 Z"
          data-name="Oldham"
          data-stusps="KY"
          id="21185"
        />
        <path
          className="white"
          d="M 404.82 199.06 409.19 199.1 409.56 199.22 409.51 199.37 409.41 200.4 409.78 201.38 409.94 202 411 201.71 411.16 202.4 411.31 203.1 412.17 203.36 412.1 204.6 411.85 204.54 406.42 204.52 404.94 202.6 404.82 199.06 Z"
          data-name="Washington"
          data-stusps="NE"
          id="31177"
        />
        <path
          className="white"
          d="M 239.65 315.4 240.11 317.1 244.84 317.64 245.46 317.02 249.52 317.54 249.65 317.74 249.65 318.16 248.84 318.07 248.71 319.2 248.65 319.71 248.56 320.24 248.48 320.96 248.04 324.64 248.87 324.72 248.7 326.27 243.4 323.95 241.71 322.84 236.73 322.3 237.53 315.15 239.65 315.4 Z"
          data-name="Valencia"
          data-stusps="NM"
          id="35061"
        />
        <path
          className="white"
          d="M 631.87 394.03 635.2 393.95 635.12 394.8 635.7 395.62 635.66 396.58 636.29 397.58 636.91 397.61 637.71 397.56 638.42 397.33 638.67 399.13 638.87 400.77 638.97 401.6 637.43 401.79 632.23 402.55 632.17 402.01 631.19 394.05 631.19 394.05 631.87 394.03 Z"
          data-name="Baker"
          data-stusps="FL"
          id="12003"
        />
        <path
          className="white"
          d="M 643.04 436.41 644.69 436.29 644.62 435.6 646.26 435.08 649.67 434.96 649.86 436.53 651.56 436.43 652.38 438.58 653.53 438.44 653.67 439.54 655.52 439.32 655.14 440.78 653.69 440.19 654.47 441.05 656.54 442.35 656.79 443.48 658.48 444.06 659.79 446.04 660.01 447.32 653.42 448.05 652.85 448.11 644.52 449.08 643.94 444.11 643.89 443.74 643.34 439.09 642.5 439.19 642.3 437.52 643.04 436.41 Z"
          data-name="Polk"
          data-stusps="FL"
          id="12105"
        />
        <path
          className="white"
          d="M 383.91 277.73 393.7 277.88 393.66 286.81 390.09 286.76 388.92 286.74 384.31 286.66 383.81 286.65 383.92 279.76 383.89 279.38 383.91 277.73 Z"
          data-name="Sumner"
          data-stusps="KS"
          id="20191"
        />
        <path
          className="white"
          d="M 766.32 83.4 767.08 81.86 768.86 81.91 769.63 81.47 770.48 82.97 772.56 81.65 774.71 80.24 775.12 80.48 775.23 80.79 775.18 81.91 776.13 82.56 776.78 84.64 777.2 89.72 776.73 90.04 776.4 89.82 775.39 89.93 773.87 89.94 771.18 88.59 770.5 90.01 769.63 89.59 769.16 89.98 768.13 90.11 768.16 87.56 768.87 87.46 768.61 85.71 767.89 85.25 767.71 84.02 766.32 83.4 Z"
          data-name="Waldo"
          data-stusps="ME"
          id="23027"
        />
        <path
          className="white"
          d="M 445.79 420.19 446.14 419.77 446.49 418.64 447.56 417.36 448.11 416.78 457.53 416.57 459.69 416.78 463.59 416.66 463.92 416.69 465.9 416.62 466.13 425.05 465 424.77 461.77 423.45 459.89 422.68 458.33 422.24 456.87 421.88 454.92 421.83 453.04 422.02 450.96 422.14 447.64 422.71 446.71 423.12 446.08 423.59 445.66 422.97 445.2 422.27 444.56 421.51 445.47 420.58 445.79 420.19 Z"
          data-name="Cameron"
          data-stusps="LA"
          id="22023"
        />
        <path
          className="white"
          d="M 450.27 401.27 451.51 401.58 452.34 401.13 459.58 401.04 459.71 406.29 457.25 406.35 457.32 409.62 457.33 410.01 453.2 410.11 453.18 408.47 451.53 408.5 451.57 410.14 447.47 410.22 448.04 409.7 447.89 408.27 447.57 407.56 448.28 406.65 448.25 406.04 449.13 404.99 449.3 403.89 450.06 402.67 450.21 401.42 450.27 401.27 Z"
          data-name="Beauregard"
          data-stusps="LA"
          id="22011"
        />
        <path
          className="white"
          d="M 657.08 157.76 660.85 156.95 663.62 156.42 663.8 157.23 665.45 156.93 665.62 158.22 667.03 165.91 665.88 166.17 663.07 166.76 660.61 167.29 659.7 167.48 659.18 167.59 657.08 157.76 Z"
          data-name="Allegany"
          data-stusps="NY"
          id="36003"
        />
        <path
          className="white"
          d="M 672.31 298.99 672.28 298.65 674.69 297.7 676.74 296.42 679.57 296.31 679.66 298.84 679.25 299.52 679.96 301.22 682.81 303.38 682.51 303.63 677.61 304.41 676.49 304.9 675.66 303.71 673.96 303.04 673.97 302.96 672.23 299.96 672.31 298.99 Z"
          data-name="Cumberland"
          data-stusps="NC"
          id="37051"
        />
        <path
          className="white"
          d="M 53.41 47.87 54.36 48.01 54.75 49 54.38 49.87 54.9 50.82 54.99 50.85 52.47 57.67 47.76 56.04 44.63 54.63 45.08 53.66 45.5 52.31 45.44 51.47 46.39 51.17 46.95 50.01 47.28 48.02 46.63 46.57 47.45 46.09 48.15 47.55 49.19 47.68 50.39 47.69 50.72 48.33 51.66 48.11 52.7 48.24 53.41 47.87 Z"
          data-name="Clatsop"
          data-stusps="OR"
          id="41007"
        />
        <path
          className="white"
          d="M 243.02 123.32 244.63 123.57 247.99 124.08 251.34 124.58 252.48 124.75 252.83 125.12 252.94 128.88 253.84 130.31 255.59 130.98 258.51 134.11 259.13 136.04 260.76 137.62 260.46 141.94 255.13 141.17 241.49 139.07 241.21 138.81 241.97 132.36 243.02 125.79 243.02 123.32 Z"
          data-name="Big Horn"
          data-stusps="WY"
          id="56003"
        />
        <path
          className="white"
          d="M 546.96 378.67 556.51 377.88 556.65 379.34 554.37 380.19 553.13 381.73 552.81 384.08 548.97 389.29 546.89 390.07 545.95 389.82 544.28 388.85 543.46 389 543.11 388.51 544.89 386.52 546.36 386.18 545.5 384.66 546.32 383.94 546.1 381.24 546.91 381.16 546.96 378.67 Z"
          data-name="Monroe"
          data-stusps="AL"
          id="1099"
        />
        <path
          className="white"
          d="M 659.01 212.33 660.76 211.99 662 211.75 667.01 210.76 667.56 210.65 668.1 211.13 668.06 212.4 667.35 212.66 666.77 213.93 666.58 214.71 666.47 214.73 664.66 215.01 663.67 214.93 662.86 214.86 662.19 213.93 661.62 213.48 660.76 215.3 659.69 216.97 659.63 217.75 658.35 217.35 657.89 217.45 657.87 217.3 659.01 212.33 Z"
          data-name="Allegany"
          data-stusps="MD"
          id="24001"
        />
        <path
          className="white"
          d="M 531.71 365.64 531.79 363.1 531.9 358.99 531.94 357.81 534.6 357.53 534.63 358.74 534.13 358.91 535.45 360.55 537.03 364.97 538.97 364.09 540.41 364.49 539.51 364.8 540.31 365.88 537.61 367.94 537.45 369.02 539.39 370.14 531.55 370.74 531.71 365.64 Z"
          data-name="Sumter"
          data-stusps="AL"
          id="1119"
        />
        <path
          className="white"
          d="M 481.2 398.08 487.88 397.82 488.65 397.79 488 400.04 487.84 401.1 486.54 403.51 486.75 404.35 486.41 404.28 485.53 402.43 484.41 402.9 482.75 403.07 482.07 402.73 482.93 401.92 483.25 400.34 482.68 399.59 481.62 399.6 482.61 400.86 480.9 400.71 481.12 399.41 481.2 398.08 Z M 479.77 397.29 481.34 397.97 481.2 398.08 480.38 397.76 479.36 397.79 479.77 397.29 Z"
          data-name="West Feliciana"
          data-stusps="LA"
          fillRule="evenodd"
          id="22125"
        />
        <path
          className="white"
          d="M 647.04 255.52 648.31 255.84 650.03 254.55 651.14 256.36 649.95 258.94 647.57 260.69 647.37 260.96 646.34 260.6 644.9 261.86 644.63 261.69 643.96 259.83 644.04 259.87 644.91 259.03 646.3 257.35 646.28 256.4 647.05 255.53 647.04 255.52 Z"
          data-name="Craig"
          data-stusps="VA"
          id="51045"
        />
        <path
          className="white"
          d="M 668.06 212.4 668.34 212.29 669.52 211.51 671.56 210.85 672.56 211.64 671.03 212.48 670.49 216.59 668.47 215.51 666.81 215.04 666.47 214.73 666.58 214.71 666.77 213.93 667.35 212.66 668.06 212.4 Z"
          data-name="Morgan"
          data-stusps="WV"
          id="54065"
        />
        <path
          className="white"
          d="M 667.3 223.87 668.55 224.11 669.19 222.53 670.01 222.37 670.69 224.08 671.13 225.26 670.19 227.82 668.85 229.99 668.22 229.86 667.33 232.66 663.38 230.31 663.84 228.89 664.33 227.57 665.56 226.7 666.26 225.45 667.03 224.78 667.3 223.87 Z"
          data-name="Shenandoah"
          data-stusps="VA"
          id="51171"
        />
        <path
          className="white"
          d="M 473.89 347.56 473.83 345.92 478.72 345.72 480.39 345.82 482.07 345.8 482.2 349.87 482.28 350.92 482.27 353.15 473.88 353.31 473.45 352.29 474.01 350.84 473.89 347.56 Z"
          data-name="Drew"
          data-stusps="AR"
          id="5043"
        />
        <path
          className="white"
          d="M 497.9 332.94 499.42 332.84 499.29 331.25 500.94 331.13 501.23 335.06 502.19 335.69 502.29 337.66 502.38 339.3 497.45 339.57 497.27 336.01 498.07 335.99 497.9 332.94 Z"
          data-name="Quitman"
          data-stusps="MS"
          id="28119"
        />
        <path
          className="white"
          d="M 469.24 223.8 469.08 218.07 469.13 218.07 472.13 217.79 472.32 217.97 472.79 218.41 473.02 218.93 473.78 219.11 473.96 219.84 474.64 220.54 475.31 221.04 475.64 221.6 476.79 221.99 476.12 223.07 475.83 224.08 475.79 224.48 469.26 224.62 469.24 223.8 Z"
          data-name="Clark"
          data-stusps="MO"
          id="29045"
        />
        <path
          className="white"
          d="M 431.14 229.81 436.72 229.81 436.94 229.99 436.99 234.42 437 235.22 431.26 235.29 431.23 233.93 431.14 229.81 Z"
          data-name="DeKalb"
          data-stusps="MO"
          id="29063"
        />
        <path
          className="white"
          d="M 448.83 222.99 456.17 222.71 456.19 223.52 456.37 229.25 449.08 229.55 449 229.23 448.88 225.18 448.83 222.99 Z"
          data-name="Sullivan"
          data-stusps="MO"
          id="29211"
        />
        <path
          className="white"
          d="M 286.4 53.12 287.15 53.22 290.55 53.67 295.73 54.35 296.85 54.48 299.41 54.81 299.45 56.5 298.85 61.38 299.66 61.48 299.46 63.11 289.11 61.8 286.41 61.44 287.07 56.56 285.45 56.34 286.4 53.12 Z"
          data-name="Daniels"
          data-stusps="MT"
          id="30019"
        />
        <path
          className="white"
          d="M 287.25 72.11 289.88 71.17 291.75 71.02 295.56 72.09 295.1 75.81 294.42 77.2 292.79 77 292.18 81.9 290.83 88.36 285.37 87.67 285.16 89.33 283.53 89.12 283.74 87.47 282.12 87.25 281.05 87.11 281.48 83.86 279.86 83.64 280.77 80.43 281.64 74.06 280.41 73.9 280.64 72.23 279.88 72.12 280.38 70.19 282.44 71.16 285.27 71.4 287.25 72.11 Z"
          data-name="McCone"
          data-stusps="MT"
          id="30055"
        />
        <path
          className="white"
          d="M 541.33 273.76 542.62 273.85 544.23 273.04 543.81 274.6 544.74 273.86 546.12 274.75 546.25 275.63 547.61 276.58 547.35 277.89 547.91 278.91 547.23 279.34 546.69 279.3 545.55 279.65 542.62 280.31 542.43 279.72 541.2 278.71 541.16 278.23 540.16 276.11 541.33 273.76 Z"
          data-name="Muhlenberg"
          data-stusps="KY"
          id="21177"
        />
        <path
          className="white"
          d="M 507.83 299.17 509.95 298.99 510 298.51 515.01 298.32 515.11 301.69 514.47 302 514.76 302.21 513.5 304.43 512.55 304.6 511.63 303.52 508.09 304.08 507.84 304.46 507.77 304.15 507.21 303.69 506.45 302.74 507.04 302.33 507.16 301.15 507.7 300.72 508.43 300.07 507.89 299.21 507.83 299.17 Z"
          data-name="Dyer"
          data-stusps="TN"
          id="47045"
        />
        <path
          className="white"
          d="M 667.09 302.44 668.64 299.87 669.9 298.64 672.31 298.99 672.23 299.96 673.97 302.96 673.96 303.04 671.96 305.71 669.49 306.04 669.07 304.05 667.09 302.44 Z"
          data-name="Hoke"
          data-stusps="NC"
          id="37093"
        />
        <path
          className="white"
          d="M 544.23 273.04 543.57 271.79 544.9 270.23 546.11 268.79 547.99 267.79 547.79 266.59 550.69 267.75 550.74 268.56 551.56 269.52 550.5 269.77 551.59 272.73 549.54 274.66 548.65 274.27 547.61 276.58 546.25 275.63 546.12 274.75 544.74 273.86 543.81 274.6 544.23 273.04 Z"
          data-name="Ohio"
          data-stusps="KY"
          id="21183"
        />
        <path
          className="white"
          d="M 461.26 326.42 462.63 326.41 462.63 328.05 464.25 328.05 464.26 329.4 465.96 329.67 465.96 330.52 467.49 330.49 467.48 331.31 469.1 331.28 469.14 332.91 466.69 332.96 466.7 333.78 463.82 333.81 462.62 334.62 462.33 333.53 460.63 333.01 460.35 331.38 459.28 330.58 457.66 330.58 457.75 328.05 456.11 328.1 456.09 326.48 461.26 326.42 Z"
          data-name="Saline"
          data-stusps="AR"
          id="5125"
        />
        <path
          className="white"
          d="M 443.12 158.08 446.4 157.99 451.25 157.83 451.48 164.37 449.02 164.45 445.35 164.56 444.27 164.59 443.29 164.62 443.12 158.08 Z"
          data-name="Freeborn"
          data-stusps="MN"
          id="27047"
        />
        <path
          className="white"
          d="M 610.56 267.76 611.08 267.27 611.97 264.07 611.29 263.45 610.97 260.28 611.7 259.9 614.13 259.81 613.88 259.05 615.17 258.22 615.71 259.29 616.85 259.76 618.28 260.67 619.58 261.45 621.05 261.36 617.99 264.96 616.57 266.61 616.51 266.69 615.98 267.37 614.62 267.98 613.15 269 613.09 269.05 612.99 269.13 611.89 268.29 611.11 268.77 610.26 268.07 610.56 267.76 Z"
          data-name="Pike"
          data-stusps="KY"
          id="21195"
        />
        <path
          className="white"
          d="M 544.95 164.62 549.99 164.02 549.78 162.39 551.4 162.21 551.83 165.48 552.18 167.65 552.31 168.75 552.51 170.4 547.74 170.96 547.6 170.98 546.61 171.11 546.28 168.94 545.89 166.99 545.29 165.25 544.95 164.62 Z"
          data-name="Ottawa"
          data-stusps="MI"
          id="26139"
        />
        <path
          className="white"
          d="M 542.43 279.72 542.62 280.31 545.55 279.65 546.16 287.49 545.34 287.58 542 287.93 542.43 279.72 Z"
          data-name="Todd"
          data-stusps="KY"
          id="21219"
        />
        <path
          className="white"
          d="M 664.19 307.58 665.39 307.18 665.91 305.24 665.47 303.71 667.09 302.44 669.07 304.05 669.49 306.04 669.96 307.22 668.37 310.3 664.46 307.54 664.19 307.58 Z"
          data-name="Scotland"
          data-stusps="NC"
          id="37165"
        />
        <path
          className="white"
          d="M 519.49 188.7 520.73 188.56 524.01 188.15 524.37 189.11 524.42 189.76 524.66 191.83 524.67 191.93 524.72 192.29 524.84 193.26 524.49 193.61 524.48 193.69 524.42 193.76 524.31 193.82 524.16 193.95 523.96 193.96 523.94 193.98 523.62 194.02 523.28 194.06 523.19 193.24 521.53 193.44 519.94 193.61 519.93 193.62 519.78 191.97 519.78 191.97 519.66 190.65 519.64 190.34 519.49 188.7 Z"
          data-name="DuPage"
          data-stusps="IL"
          id="17043"
        />
        <path
          className="white"
          d="M 434.77 373.1 436.46 373.59 437.03 374.34 441.91 373.03 441.92 373.57 441.98 376.71 441.99 377.8 442.05 380.53 442.26 380.76 434.56 380.98 433.14 381.01 433.4 376.73 434.18 375.4 434.77 373.1 Z"
          data-name="Panola"
          data-stusps="TX"
          id="48365"
        />
        <path
          className="white"
          d="M 531.63 272.95 534.34 269.71 537.91 269.23 538.17 270.09 539.84 270.52 538.15 272.23 536.75 272.85 533.63 275.22 533.77 274.67 533 273.95 531.79 274.27 531.63 272.95 Z"
          data-name="Webster"
          data-stusps="KY"
          id="21233"
        />
        <path
          className="white"
          d="M 604.32 228.56 607.7 228.03 607.67 227.53 610.99 227.24 611.68 228.9 611.82 230.6 611.25 230.65 611.53 234.04 609.85 234.15 609.71 232.19 608 232.32 607.95 231.63 604.55 231.61 604.51 231.04 604.32 228.56 Z"
          data-name="Vinton"
          data-stusps="OH"
          id="39163"
        />
        <path
          className="white"
          d="M 433.95 398.13 435.33 398.7 435.63 398.59 435.71 399.1 437.31 398.45 439.18 398.91 439.09 399.76 439.82 400.48 439.59 401.03 440.2 402.99 440.67 403.08 441.09 405.06 441.68 404.99 442.32 405.89 441.63 407.08 442.02 408 434.33 408.09 432.41 399.03 433.95 398.13 Z"
          data-name="Tyler"
          data-stusps="TX"
          id="48457"
        />
        <path
          className="white"
          d="M 616.42 201.58 615.95 198.6 615.68 196.94 618.96 196.54 619.08 194.93 619.59 194.84 621.91 194.45 622.08 194.42 623.47 194.19 623.74 195.82 623.75 195.87 624.3 199.09 622.7 199.34 622.34 200.93 621.24 201.09 619.16 201.14 616.53 202.21 616.42 201.58 Z"
          data-name="Stark"
          data-stusps="OH"
          id="39151"
        />
        <path
          className="white"
          d="M 621.44 330.36 621.56 330.56 622.28 330.63 623.74 331.78 625.55 332.44 627.13 333.95 627.6 334.72 626.11 334.67 624.38 335.86 623.55 336.19 621.28 332.87 621.52 332.09 621 332.28 620.07 330.01 620.23 330.18 621.44 330.36 Z"
          data-name="Lincoln"
          data-stusps="GA"
          id="13181"
        />
        <path
          className="white"
          d="M 594.53 198.72 598.19 198.17 598.56 198.06 600.06 197.85 600.84 203.21 599.23 203.43 598.98 203.61 595.35 204.19 594.53 198.72 Z"
          data-name="Crawford"
          data-stusps="OH"
          id="39033"
        />
        <path
          className="white"
          d="M 633.31 440.2 636.29 439.89 639.91 439.49 642.5 439.19 643.34 439.09 643.89 443.74 643.94 444.11 644.52 449.08 636.07 450.04 636.6 448.83 637.19 448.43 637.86 447.49 637.49 446.72 637.06 446.62 636.77 446.56 635.63 446.19 635.45 446.44 635.18 445.07 633.76 443.88 633.38 440.73 633.31 440.2 Z"
          data-name="Hillsborough"
          data-stusps="FL"
          id="12057"
        />
        <path
          className="white"
          d="M 583.11 197.02 589.66 196.11 590.14 199.4 589.61 199.48 589.03 201.22 589.25 202.86 584.03 203.56 583.77 201.67 583.11 197.02 Z"
          data-name="Hancock"
          data-stusps="OH"
          id="39063"
        />
        <path
          className="white"
          d="M 597.55 192.56 604.65 191.57 604.9 192.94 604.93 193.14 605.39 195.67 603.96 195.9 604.23 197.26 600.06 197.85 598.56 198.06 597.8 193.93 597.67 193.21 597.55 192.56 Z"
          data-name="Huron"
          data-stusps="OH"
          id="39077"
        />
        <path
          className="white"
          d="M 573.72 229.76 573.62 228.9 578.53 228.26 578.47 227.84 580.13 227.65 580.72 228.35 581.03 233.23 576.93 233.37 574.19 233.84 574.01 232.21 573.72 229.76 Z"
          data-name="Butler"
          data-stusps="OH"
          id="39017"
        />
        <path
          className="white"
          d="M 299.73 350.67 307.02 351.15 306.49 359.23 299.06 358.73 299.46 353.84 299.73 350.67 Z"
          data-name="Yoakum"
          data-stusps="TX"
          id="48501"
        />
        <path
          className="white"
          d="M 587.99 375.99 588.78 375.93 588.55 373.14 590.09 372.84 592.02 372.85 592.26 372.67 592.6 372.8 593.51 372.7 593.75 375.51 595.03 377.2 594.95 378.26 594.11 378.04 590.57 378.74 588.56 378.97 588.64 377.94 588.32 377.82 587.99 375.99 Z"
          data-name="Randolph"
          data-stusps="GA"
          id="13243"
        />
        <path
          className="white"
          d="M 179.9 151.48 181.17 150.36 189.66 152.07 189.13 153.37 187.99 154.22 188.16 155.51 187.62 156.73 187.87 158.03 189.83 158.05 190.19 160.09 190.03 163.98 189.15 166.94 188.04 166.15 186.05 165.77 185.39 164.35 183.38 164.48 184.28 162.1 182.76 160.85 183.86 158.27 182.57 156.31 182.99 152.93 182.59 151.84 179.79 152.22 179.9 151.48 Z"
          data-name="Bannock"
          data-stusps="ID"
          id="16005"
        />
        <path
          className="white"
          d="M 609.42 186.63 609.76 186.75 611.38 186.41 611.55 186.37 612.16 186.35 612.59 186.34 613.91 185.11 615.67 182.99 615.88 184.21 617.25 183.98 617.65 186.32 617.74 186.87 617.96 188.15 617.12 188.27 616.16 188.42 615.02 188.59 615.72 189.89 615.36 189.96 614.23 190.15 614.02 190.19 613.74 190.23 611.83 190.58 611.28 190.68 611.06 189.26 609.72 189.46 609.42 186.63 Z"
          data-name="Cuyahoga"
          data-stusps="OH"
          id="39035"
        />
        <path
          className="white"
          d="M 411.16 202.4 418.16 202.41 423 202.4 423.04 208.89 419.8 208.9 413.02 208.91 413.09 208.4 412.34 208.45 412.34 208.32 412.32 207.45 412.62 206.69 412.12 205.87 412.08 204.97 412.1 204.6 412.17 203.36 411.31 203.1 411.16 202.4 Z"
          data-name="Pottawattamie"
          data-stusps="IA"
          id="19155"
        />
        <path
          className="white"
          d="M 617.25 183.98 618.6 183.74 618.39 182.4 621.11 181.92 620.86 180.55 622.25 180.29 622.97 184.31 623.47 187.21 617.96 188.15 617.74 186.87 617.65 186.32 617.25 183.98 Z"
          data-name="Geauga"
          data-stusps="OH"
          id="39055"
        />
        <path
          className="white"
          d="M 562.37 347.76 563.69 345.38 564.46 345.6 565.28 343.15 564.75 341.71 565.55 341.99 567.05 341.93 568.09 343.51 571.25 343.22 571.28 343.77 571.18 344.18 570.51 344.94 569.67 345.02 569.56 346.98 568.75 347.33 568.85 348.99 566.66 349.16 566.8 351.08 565.97 351.14 566.11 352.86 561.09 353.35 560.77 351.93 561.37 350.69 562.87 349.5 563.03 348.39 562.37 347.76 Z"
          data-name="Talladega"
          data-stusps="AL"
          id="1121"
        />
        <path
          className="white"
          d="M 138.62 319.27 147.97 320.89 155.02 324.36 155.99 323.12 157.27 322.09 157.31 321.5 164.1 323.54 167.77 324.12 168.56 324.22 168.23 325.75 169.19 327.77 168.78 328.62 170.06 331.14 170.93 332.34 172.24 331.08 173.43 335.37 164.82 334.06 164.02 339 162.37 338.76 159.42 338.32 159.05 338.24 156.03 337.76 154.46 336.34 154.42 335.44 154.23 336.65 152.5 347.37 151.96 350.74 145.15 349.68 133.68 347.78 134.54 342.77 136.52 331.13 137.14 327.53 138.62 319.27 Z"
          data-name="Maricopa"
          data-stusps="AZ"
          id="4013"
        />
        <path
          className="white"
          d="M 446.27 323.69 446.19 321.53 448.92 321.27 450 319.93 452.73 319.92 452.71 318.05 455.89 320.58 456.11 321.61 456.67 320.78 458.29 320.46 458.59 320.56 456.47 321.77 456.49 322.37 452.5 326.25 452.82 328.16 451.17 328.22 451.18 328.76 446.3 328.83 446.27 323.69 Z"
          data-name="Yell"
          data-stusps="AR"
          id="5149"
        />
        <path
          className="white"
          d="M 660.01 447.32 664.59 446.77 666.2 446.56 666.42 448.17 668.08 447.97 668.95 454.69 669.16 456.3 665.97 459.85 665.61 455.82 664.46 455.25 663.91 455.08 662.5 452.52 661.37 452.27 659.05 449.65 660.14 448.11 660.01 447.32 Z"
          data-name="Okeechobee"
          data-stusps="FL"
          id="12093"
        />
        <path
          className="white"
          d="M 589.22 247.48 590.36 248.02 593.41 246.29 594.54 247.95 596.58 248.62 596.06 250.85 595.34 251.96 594.36 252.65 594.24 252.98 592.76 250.84 590.92 251 590.94 250.21 589.75 249.95 588.61 248.58 589.22 247.48 Z"
          data-name="Fleming"
          data-stusps="KY"
          id="21069"
        />
        <path
          className="white"
          d="M 465.4 408.33 467.66 408.28 471.69 408.16 472.86 409.62 472.89 410.57 473.17 410.56 473.18 410.7 473.47 411.5 471.8 413.21 471.24 414.42 469.04 416.32 467.19 415.28 465.72 415.61 466.23 413.91 465.48 410.33 466.04 409.45 465.4 408.33 Z"
          data-name="Acadia"
          data-stusps="LA"
          id="22001"
        />
        <path
          className="white"
          d="M 488.76 375.06 490.63 374.86 491.26 373.53 491.63 372.41 490.58 372.28 490.85 370.9 489.45 370.7 489.27 369.32 490.05 369.21 489.41 368.18 490.75 368.06 490.9 371.15 492.5 370.49 492.4 368 494.51 368.06 494.59 367.07 495.64 367.57 495.7 368.39 497.34 369.03 496.15 371.59 495.07 372.16 494.81 374.47 491.52 377.38 489.95 376.89 488.76 375.06 Z"
          data-name="Warren"
          data-stusps="MS"
          id="28149"
        />
        <path
          className="white"
          d="M 592.09 366.88 594.25 368.53 595.79 368.37 595.95 370.12 595.92 371.54 595.87 372.47 593.51 372.7 592.6 372.8 592.48 367.77 592.09 366.88 Z"
          data-name="Webster"
          data-stusps="GA"
          id="13307"
        />
        <path
          className="white"
          d="M 74.39 184.85 84.95 187.75 98.95 191.37 99.57 193.83 98.41 196.33 98.3 198.84 97.58 200.22 95.91 200.36 94.69 201.05 94.65 201.88 92.69 202.54 92.53 205.65 90.93 206.6 91.13 207.72 89.7 207.75 76.52 204.29 76.71 203.57 75.83 202.45 75.29 200.86 74.15 199.36 72.77 196.88 73.44 194.4 75.1 190.7 75.45 190.5 73.47 191.64 72.96 191.97 73.08 191.6 73.51 191.12 73.63 188.51 74.39 184.85 Z"
          data-name="Churchill"
          data-stusps="NV"
          id="32001"
        />
        <path
          className="white"
          d="M 404.52 335.29 408.59 335.31 408.59 333.67 409.42 333.67 409.43 330.4 412.68 330.4 412.68 332.03 415.94 332.03 415.94 333.66 414.28 333.66 414.28 340.22 410.97 340.21 404.49 340.18 404.52 335.29 Z"
          data-name="Atoka"
          data-stusps="OK"
          id="40005"
        />
        <path
          className="white"
          d="M 373.06 156.11 379.52 156.28 379.48 157.58 379.56 157.91 379.42 164.53 374.16 164.34 372.94 164.3 373.15 157.74 373.06 156.11 Z"
          data-name="Aurora"
          data-stusps="SD"
          id="46003"
        />
        <path
          className="white"
          d="M 288.59 382.69 293.15 383.02 301.65 383.58 302.16 383.61 301.74 390.34 300.74 390.78 299.12 389.11 297.9 388.63 295.15 388.47 293.92 387.3 292.8 387.52 291.02 386.98 290.19 383.29 288.59 382.69 Z"
          data-name="Ward"
          data-stusps="TX"
          id="48475"
        />
        <path
          className="white"
          d="M 362.71 389.56 366.17 387.28 366.53 385.84 368.01 385.64 370.83 385.28 371.28 386.04 374.26 391.12 374.08 391.4 369.48 394.5 368.47 393.52 369.13 392.71 368.21 392.9 368.07 391.84 367.12 392.22 367.41 391.13 366.97 390.74 364.88 390.95 364.6 390.36 363.62 390.47 362.71 389.56 Z"
          data-name="Mills"
          data-stusps="TX"
          id="48333"
        />
        <path
          className="white"
          d="M 576.18 201.36 577 201.24 576.57 197.95 578.18 197.73 583.11 197.02 583.77 201.67 580.54 202.41 580.65 203.24 577.35 203.72 576.41 203 576.18 201.36 Z"
          data-name="Putnam"
          data-stusps="OH"
          id="39137"
        />
        <path
          className="white"
          d="M 273.23 51.21 280.16 52.24 284.89 52.91 286.4 53.12 285.45 56.34 287.07 56.56 286.41 61.44 289.11 61.8 288.26 68.26 287.25 72.11 285.27 71.4 282.44 71.16 280.38 70.19 279.88 72.12 278.84 71.96 278.52 73.43 277.1 75.03 275.69 75.08 275.31 75.75 273.7 75.46 273.14 76.57 271.61 76.57 268.59 76.16 266.58 75.28 267.21 71.95 268.21 65.43 268.64 65.49 268.9 63.87 270.26 64.08 270.51 62.41 270 62.33 270.24 60.7 270.88 60.15 271.68 60.38 271.68 59.25 272.66 52.8 273.23 51.21 Z"
          data-name="Valley"
          data-stusps="MT"
          id="30105"
        />
        <path
          className="white"
          d="M 695.27 298.78 697.98 298.35 700.34 299.11 701.83 298.48 703.95 300.86 704.69 301.28 705.33 303.5 704.97 303.67 703.49 304.85 702.39 306.09 700.41 307.73 699.7 308.54 698.6 307.97 696.09 303.62 695.72 299.35 695.27 298.78 Z"
          data-name="Onslow"
          data-stusps="NC"
          id="37133"
        />
        <path
          className="white"
          d="M 631.2 217.49 635.81 216.65 637.24 216.4 637.45 216.43 637.89 217.92 637.34 217.97 636.64 219.58 637.01 221.33 636.4 222.23 635.76 221.9 635.25 222.01 633.66 221.69 631.43 219.74 629.99 219.87 630.95 218.63 631.31 217.61 631.2 217.49 Z"
          data-name="Wetzel"
          data-stusps="WV"
          id="54103"
        />
        <path
          className="white"
          d="M 612.15 394.96 613.99 394.87 616.34 394.77 617.14 394.74 617.75 394.79 619.03 398.57 619.95 399.2 619.62 399.43 618.96 401.7 616.98 401.93 615.31 402.11 615.22 401.28 609.45 401.92 609.53 400.61 610.8 399.27 610.39 397.91 612.42 396.27 612.15 394.96 Z"
          data-name="Madison"
          data-stusps="FL"
          id="12079"
        />
        <path
          className="white"
          d="M 431.41 254.22 431.41 254.17 431.39 252.17 438.59 252.32 438.67 257.28 439.49 257.29 439.47 259.19 439.51 259.54 437.36 259.59 435.87 259.15 431.43 259.1 431.43 257.79 431.41 254.22 Z"
          data-name="Cass"
          data-stusps="MO"
          id="29037"
        />
        <path
          className="white"
          d="M 477.86 172.83 479.19 172.65 480.8 171.26 482.08 170.88 484.43 168.97 486.05 168.12 487.65 168.21 488.16 175.5 488.54 181.23 488.39 181.24 485.53 181.4 485.04 180.14 484.59 179.23 483.97 178.91 482.44 178.64 481.82 178.5 481.19 178.35 480.1 177.74 479.3 176.74 478.82 175.09 478.24 174.38 477.92 173.04 477.86 172.83 Z"
          data-name="Grant"
          data-stusps="WI"
          id="55043"
        />
        <path
          className="white"
          d="M 482.14 383.91 484.49 383.79 484.79 384.17 484.78 384.17 484.61 385.84 483.54 386.33 483.66 386.94 484.01 387.7 483.19 387.96 482.77 388.65 482.92 389.76 482.61 390.69 482.59 391.66 483.06 392.52 482.19 393.12 481.26 393.04 480.92 393.68 481.82 394.41 481.81 394.44 481.35 395.49 481.82 396.33 482.4 397.09 481.34 397.97 479.77 397.29 479.78 395.6 480.42 394.57 477.83 393.19 477.36 392.54 477.58 391.15 478.68 390.93 477.38 390.25 477.31 388.93 478.15 389.94 479.26 390.04 479.24 389.37 478.26 389.29 478.53 388.2 477.73 387.09 478.51 385.99 479.15 386.62 479.63 386.06 479.75 384.32 480.7 384.4 481.22 383.76 482.14 383.91 Z"
          data-name="Concordia"
          data-stusps="LA"
          id="22029"
        />
        <path
          className="white"
          d="M 483.1 368.28 483.84 367.73 483.76 366.17 484.59 365.05 484.97 361.56 485.63 360.23 487.18 360.17 487.7 360.59 488.73 361.35 488.79 362.27 487.76 363.06 487.41 363.76 487.51 364.44 488.24 365.09 489.15 365.32 488.52 366.1 488.89 367.68 489.3 368.07 488.09 368.89 482.94 369.11 483.1 368.28 Z"
          data-name="East Carroll"
          data-stusps="LA"
          id="22035"
        />
        <path
          className="white"
          d="M 366.83 487.92 368.62 484.16 371.63 477.9 377.27 478.04 377.22 481.13 377.69 481.22 376.85 484.25 379.24 484.58 379.22 486.18 379.15 490.44 379.13 491.61 378.97 491.61 377.74 491.56 376.61 491.46 376.13 491.87 375.26 491.52 374.27 491.57 373.46 491.55 373.33 491.5 372.59 491.22 371.69 490.51 371.6 490.45 370.29 489.58 369.36 488.79 368.34 488.48 367.12 488.07 366.83 487.92 Z"
          data-name="Hidalgo"
          data-stusps="TX"
          id="48215"
        />
        <path
          className="white"
          d="M 457.39 302.86 458.22 302.85 459.03 302.83 459.07 303.65 465.54 303.58 465.56 305.21 465.64 308.72 462.39 308.79 462.41 310.15 459.68 310.16 457.51 310.18 457.52 305.2 457.51 303.67 457.39 302.86 Z"
          data-name="Searcy"
          data-stusps="AR"
          id="5129"
        />
        <path
          className="white"
          d="M 471.62 171.38 477.54 171.1 477.59 171.88 477.86 172.83 477.92 173.04 478.24 174.38 478.82 175.09 479.3 176.74 480.1 177.74 481.19 178.35 481.82 178.5 481.84 179.03 478.58 179.22 472.01 179.6 471.62 171.38 Z"
          data-name="Clayton"
          data-stusps="IA"
          id="19043"
        />
        <path
          className="white"
          d="M 431.45 260.77 431.43 259.1 431.43 259.1 435.87 259.15 437.36 259.59 439.51 259.54 439.45 263.89 439.83 263.91 439.77 267.24 438.62 266.86 437.11 267.49 431.52 266.93 431.49 263.6 431.45 260.77 Z"
          data-name="Bates"
          data-stusps="MO"
          id="29013"
        />
        <path
          className="white"
          d="M 741.07 79.19 741.64 78.87 741.77 78.15 742.69 78.12 743.39 78.62 744 79.6 744.67 79.48 744.57 78.74 746.86 83.23 746.31 83.51 748.04 86.54 748.77 88.53 750.43 86.67 752.87 89.35 752.45 89.84 756.3 89.41 756.14 90.12 757.12 90.51 757.56 91.29 757.97 96.36 757.41 97.69 756.73 99.85 756.97 100.36 756.27 101.14 755.41 100.87 754.96 99.14 754.16 98.4 752.07 101.03 754.22 102.72 754.23 103.41 753.69 105.08 754.2 105.79 754.06 105.99 752.89 106.28 752 107.1 751.55 107.08 751.24 106.22 749.55 101.52 748.45 98.44 748.27 97.96 748.15 97.64 747.89 96.92 747.2 95.09 746.79 93.98 745.17 89.62 743.28 84.78 741.07 79.19 Z"
          data-name="Oxford"
          data-stusps="ME"
          id="23017"
        />
        <path
          className="white"
          d="M 364.08 453.85 371.88 454.02 373.52 454.05 373.28 468.95 368.42 468.8 368.46 467.34 367.35 467.02 363.85 467.03 364.08 453.85 Z"
          data-name="Duval"
          data-stusps="TX"
          id="48131"
        />
        <path
          className="white"
          d="M 756.97 100.36 758.83 100.7 759.16 99.52 760.73 100.32 762.68 101.07 763.03 100.54 763.36 99.41 764.52 100.28 765.95 99.18 765.88 100.59 766.67 102.66 766.23 102.63 765.5 103.52 765.47 104.23 764.62 104.46 764.5 104.49 764.44 105.11 764.42 105.38 763.42 105.65 763.3 106.31 763.24 107.35 763.63 108.03 763.21 108.54 762.25 109.12 762 109.18 759.43 108.39 759.68 107.57 757.97 106.6 756.51 107.18 756.12 105.71 754.2 105.79 753.69 105.08 754.23 103.41 754.22 102.72 752.07 101.03 754.16 98.4 754.96 99.14 755.41 100.87 756.27 101.14 756.97 100.36 Z"
          data-name="Cumberland"
          data-stusps="ME"
          id="23005"
        />
        <path
          className="white"
          d="M 426.43 146.19 427.11 146.44 427.58 146.96 429.14 148.11 431.5 148.72 433.15 150.48 433.24 153.4 426.59 153.51 423.34 153.55 423.32 152.19 423.21 151.92 423.21 150.29 426.47 150.24 426.43 146.19 Z"
          data-name="Brown"
          data-stusps="MN"
          id="27015"
        />
        <path
          className="white"
          d="M 547.61 276.58 548.65 274.27 549.54 274.66 551.59 272.73 553.53 273.16 553.88 273.91 555.21 276.65 553.7 276.41 551.82 276.77 551.38 280.26 548.7 279.44 547.23 279.34 547.91 278.91 547.35 277.89 547.61 276.58 Z"
          data-name="Butler"
          data-stusps="KY"
          id="21031"
        />
        <path
          className="white"
          d="M 375.53 118.54 376.83 118.6 379.59 118.72 384.1 118.86 384.91 118.89 385.3 118.9 385.11 125.43 384.91 131.96 375.15 131.59 375.08 131.59 375.3 125.6 375.28 125.07 375.53 118.54 Z"
          data-name="Brown"
          data-stusps="SD"
          id="46013"
        />
        <path
          className="white"
          d="M 324.22 334.78 325.67 334.87 332.37 335.23 332.2 338.63 331.92 344.21 323.73 343.84 323.97 339.26 324.22 334.78 Z"
          data-name="Floyd"
          data-stusps="TX"
          id="48153"
        />
        <path
          className="white"
          d="M 776.36 150.68 777.51 150.25 779.11 149.62 779.1 148.12 780.22 148.45 781.14 150.12 780.51 150.87 779.33 151.19 777.65 151.56 776.36 150.68 Z"
          data-name="Nantucket"
          data-stusps="MA"
          id="25019"
        />
        <path
          className="white"
          d="M 511.73 292.95 513.76 292.73 517.51 292.53 519.48 292.39 519.59 292.39 519.88 294.09 517.87 294.25 517.95 297.78 517.96 298.18 515.01 298.32 510 298.51 510.56 298.04 511.62 294.7 511.73 292.95 Z"
          data-name="Obion"
          data-stusps="TN"
          id="47131"
        />
        <path
          className="white"
          d="M 529.49 298.85 531.23 296.17 531.18 295.92 531.08 295.42 530.88 295.13 530.99 294.57 530.91 294.21 531.88 294.12 532.5 294.07 532.67 294.18 533.36 295.81 533.31 296.21 533.95 298.3 532.63 301.52 534.16 302.06 533.73 303.79 533.64 304.28 532.35 303.73 530.43 303.96 529.82 304 529.49 298.85 Z"
          data-name="Benton"
          data-stusps="TN"
          id="47005"
        />
        <path
          className="white"
          d="M 592.05 298.59 592.41 298.73 592.26 297.72 594.27 297.66 594.5 296.79 596.77 297.32 597.57 296.34 599.36 299.48 600.06 299.8 600.35 302.12 598.69 302.43 597.6 303.39 596.65 304.38 596.12 304.71 596.04 304.76 596.28 304.15 595.29 303.08 593.95 303.41 592.15 302.3 592.9 301.51 592.16 300.35 592.05 298.59 Z"
          data-name="Blount"
          data-stusps="TN"
          id="47009"
        />
        <path
          className="white"
          d="M 524.31 292.04 524.38 292.04 524.72 292.01 530.22 291.63 531.34 291.52 531.3 292.58 532.5 294.07 531.88 294.12 530.91 294.21 530.99 294.57 530.88 295.13 531.08 295.42 531.18 295.92 531.23 296.17 529.49 298.85 529.47 298.36 524.6 298.62 524.31 292.04 Z"
          data-name="Henry"
          data-stusps="TN"
          id="47079"
        />
        <path
          className="white"
          d="M 615.43 318.32 616.12 317.28 620.45 313.88 621 314.58 621.14 316.72 622.18 318.7 624.02 319.85 618.07 325.82 617.86 325.28 617.28 324.52 617.17 324.37 616.34 323.29 615.95 322.55 615.27 321.26 614.43 321.17 613.43 321.47 613.59 321.07 615.43 318.32 Z"
          data-name="Anderson"
          data-stusps="SC"
          id="45007"
        />
        <path
          className="white"
          d="M 373.52 454.05 379.38 454.18 380.11 454.61 380.73 454.55 380.77 455.35 378.48 457.38 378.26 462.04 376.31 462.01 376.2 469.03 373.28 468.95 373.52 454.05 Z"
          data-name="Jim Wells"
          data-stusps="TX"
          id="48249"
        />
        <path
          className="white"
          d="M 420.55 230.65 421.01 230.65 422.13 231.7 423.41 232.59 424.3 233.22 425.2 232.54 425.57 232.52 426.17 232.47 426.51 232.92 427.24 233.85 427.25 233.96 427.36 234.85 427.52 235.29 426.96 235.78 425.92 235.8 425.93 236.49 424.97 237.13 424.88 237.87 423.85 237.15 420.59 237.16 420.55 230.65 Z"
          data-name="Doniphan"
          data-stusps="KS"
          id="20043"
        />
        <path
          className="white"
          d="M 592.42 347.27 593.45 347.18 593.96 345.29 594.49 345.23 597.76 345.18 598.6 345.8 598.85 346.01 598.47 347.64 598.52 348.1 596.53 348.12 593.26 348.11 592.59 348.66 592.42 347.97 592.42 347.27 Z"
          data-name="Spalding"
          data-stusps="GA"
          id="13255"
        />
        <path
          className="white"
          d="M 630.76 360.69 634.2 361.01 635.42 364.66 636.97 365.06 639.04 364.83 638.1 365.6 636.11 370.11 636.32 370.18 636.24 370.32 636.11 370.3 634.94 369.63 633.74 368.37 631.87 368.37 631.95 363.48 630.76 360.69 Z"
          data-name="Tattnall"
          data-stusps="GA"
          id="13267"
        />
        <path
          className="white"
          d="M 627.83 360.4 627.83 360.39 628.86 361.44 630.76 360.69 631.95 363.48 631.87 368.37 628.84 368.05 628.41 367.79 627.57 367.84 627.5 361.61 627.83 360.4 Z"
          data-name="Toombs"
          data-stusps="GA"
          id="13279"
        />
        <path
          className="white"
          d="M 386.42 344.82 386.83 343.24 386.48 341.59 395.71 341.73 396.24 342.82 396.23 344.08 396.07 344.09 395.95 344.1 395.38 344.58 395.42 345.18 394.32 345.74 393.95 346.55 393.8 347.27 393.74 348 392.82 348.23 391.96 346.58 392.58 345.88 391.98 344.62 391.35 344.87 390.21 345.51 389.34 346.36 388.23 346.26 388.13 345.37 387.63 344.56 387.6 344.5 386.47 344.86 386.42 344.82 Z"
          data-name="Love"
          data-stusps="OK"
          id="40085"
        />
        <path
          className="white"
          d="M 731.23 138.61 732.68 138.5 733.07 139.55 735.61 139.46 736.29 140.14 738.66 138.96 740.34 138.74 741.25 140.88 741.61 139.95 741.93 139.68 743.24 140.13 743.57 141.26 743.46 141.42 742.55 141.95 742.02 142.34 741.35 143.26 740.4 142.68 738.43 143.57 738.22 143.55 737.87 143.24 738.04 142.58 737.8 142.25 737.75 142.24 737.27 144.48 735.49 143.9 733.81 144.33 733.69 142.46 732.18 143.3 731.8 143.49 731.14 143.04 730.86 142.12 731.67 142.08 731.23 138.61 Z"
          data-name="Hampshire"
          data-stusps="MA"
          id="25015"
        />
        <path
          className="white"
          d="M 758.85 90.26 760.03 89.91 759.97 89.45 759.35 89.22 759.5 88.29 759.4 87.97 760.65 87.83 760.69 87.66 760.72 87.05 762.18 86.62 762.78 87.05 763.26 86.35 764.42 86.29 765.28 86.19 765.16 85.04 764.36 84.52 764.13 84.04 766.17 82.93 766.32 83.4 767.71 84.02 767.89 85.25 768.61 85.71 768.87 87.46 768.16 87.56 768.13 90.11 768.27 91.47 768.11 91.83 766.6 91.96 766.73 93 767.5 94.88 767.39 94.95 766.05 95.08 765.89 94.85 764.56 94.99 764.37 96.32 762.81 96.49 762.47 96.41 762.61 95.39 761.64 95.48 760.83 93.7 760.2 92.99 759.54 92.45 759.89 92.07 758.85 90.26 Z"
          data-name="Kennebec"
          data-stusps="ME"
          id="23011"
        />
        <path
          className="white"
          d="M 452.38 182.06 458.94 181.84 459.28 183.45 459.42 186.69 456.15 186.81 456.21 188.44 452.95 188.57 452.77 183.66 452.38 182.06 Z"
          data-name="Grundy"
          data-stusps="IA"
          id="19075"
        />
        <path
          className="white"
          d="M 750.7 49.52 762.23 45.37 763.47 48.64 768.22 61.88 766.65 62.93 767.59 65.74 768.89 64.96 769.81 66.41 770.03 66.79 771.9 69.91 770.62 70.7 771.5 72.11 768.4 73.98 766.89 74.87 765.37 75.76 763.59 76.8 762.26 78.16 756.71 68.97 757.18 67.02 754.74 65.57 755.06 64.48 755.94 64.78 755.53 62.39 756.35 62.38 755.08 60.32 754.54 60.65 751.75 52.92 750.7 49.52 Z"
          data-name="Piscataquis"
          data-stusps="ME"
          id="23021"
        />
        <path
          className="white"
          d="M 484.73 294.59 486.37 294.51 489.92 294.32 490.54 295.9 490.65 298.39 489.8 298.68 489.87 300.88 486.14 301.04 485.89 301.74 485.71 301.07 482.93 299.19 482.59 297.01 480.48 294.81 480.51 294.81 484.73 294.59 Z"
          data-name="Randolph"
          data-stusps="AR"
          id="5121"
        />
        <path
          className="white"
          d="M 330.67 395.9 335.09 396.02 344.36 396.37 344.07 403.46 330.37 402.96 330.67 395.9 Z"
          data-name="Schleicher"
          data-stusps="TX"
          id="48413"
        />
        <path
          className="white"
          d="M 693.1 233.87 693.22 233.95 693.83 234.43 693.88 234.99 694.72 235.15 695.93 235.56 697.27 235.3 698.27 235.2 699.36 235.12 699.72 235.81 700.86 236.37 701.36 236.86 699.91 237.95 699.8 238.64 697.7 238.39 695.52 236.43 694.81 237.51 693.32 237.54 692.6 236.3 692.46 234.37 693.1 233.87 Z"
          data-name="Westmoreland"
          data-stusps="VA"
          id="51193"
        />
        <path
          className="white"
          d="M 649.53 246.52 649.72 245.55 649.82 244.12 650.63 243.02 651.32 242.23 652.83 242.86 655.86 243.11 657.05 243.24 656.63 244.82 656.15 246.52 654.88 249.27 654.3 249.96 653.31 249.33 651.22 249.55 650.29 248.52 648.5 248.88 648.74 248.53 649.46 246.91 649.53 246.52 Z"
          data-name="Bath"
          data-stusps="VA"
          id="51017"
        />
        <path
          className="white"
          d="M 178.16 369.68 177.72 371.89 177 377.23 166.96 375.85 162.44 373.41 162.7 371.57 166.02 372.04 166.57 368.15 168.3 368.39 178.16 369.68 Z"
          data-name="Santa Cruz"
          data-stusps="AZ"
          id="4023"
        />
        <path
          className="white"
          d="M 105.69 9.52 106.22 12.53 105.72 13.97 106.29 15.45 104.68 16.29 102.76 15.62 102.66 15.92 94.65 13.03 86.71 10.05 83.22 8.75 82.32 8.74 81.79 8.61 81.14 7.97 81.21 6.37 81.56 5.09 81.75 4.14 81.32 3.02 81.4 1.82 82.6 1 88.73 3.32 90.58 4.02 94.75 5.66 99.08 7.18 102.36 8.33 105.69 9.52 Z"
          data-name="Whatcom"
          data-stusps="WA"
          id="53073"
        />
        <path
          className="white"
          d="M 560.26 260.05 560.67 259.74 560.76 258.17 560.76 256.86 560.76 256.69 561.47 255.64 561.73 254.79 562.06 254.85 562.73 254.97 563.67 254.34 564.13 253.38 564.23 252.69 565.04 253.35 566.76 254.1 566.89 254.17 567.88 254.47 567.84 256.69 567.83 257.24 566.41 258.06 563.68 258.3 561.24 259.46 560.5 260.33 560.26 260.05 Z"
          data-name="Jefferson"
          data-stusps="KY"
          id="21111"
        />
        <path
          className="white"
          d="M 480.78 321.26 480.82 320.02 481.85 319.13 481.91 318.22 481.17 317.41 480.96 316 482.16 315.19 482.3 314.62 483.74 314.42 483.84 316.08 487.1 315.99 487.24 319.85 487.33 322.62 485.72 322.67 484.37 322.7 483.52 323.1 483.56 324.46 482.42 324.51 482.37 321.89 480.59 321.83 480.78 321.26 Z"
          data-name="Woodruff"
          data-stusps="AR"
          id="5147"
        />
        <path
          className="white"
          d="M 587.77 154.86 587.91 155.67 589.54 155.39 589.98 157.84 590.91 162.71 589.28 163.06 584.46 163.95 583.39 157.52 583.36 157.34 584.85 157.07 584.57 155.44 587.77 154.86 Z"
          data-name="Lapeer"
          data-stusps="MI"
          id="26087"
        />
        <path
          className="white"
          d="M 413.03 169.55 419.53 169.58 419.57 176.06 413.06 176.09 413.03 169.55 Z"
          data-name="O'Brien"
          data-stusps="IA"
          id="19141"
        />
        <path
          className="white"
          d="M 360.59 104.83 366.62 105.14 371.96 105.4 371.69 111.92 360.73 111.42 360.23 111.39 360.59 104.83 Z"
          data-name="Logan"
          data-stusps="ND"
          id="38047"
        />
        <path
          className="white"
          d="M 440.06 291.41 440.09 287.96 446.9 287.98 446.92 289.9 447.51 289.9 447.49 295.92 445.73 295.96 443.21 296.02 441.81 296.05 440.03 296.08 440.06 291.41 Z"
          data-name="Barry"
          data-stusps="MO"
          id="29009"
        />
        <path
          className="white"
          d="M 566.89 254.17 568.97 253.46 569.48 252.49 573.76 252.41 574.37 252.4 573.88 253.56 573.84 256.35 573.6 257.46 572.88 258.21 571.39 257.67 570.82 257.46 567.84 256.69 567.88 254.47 566.89 254.17 Z"
          data-name="Shelby"
          data-stusps="KY"
          id="21211"
        />
        <path
          className="white"
          d="M 171.3 64.32 174.2 65.33 176.61 67.48 177.4 68.77 178.46 68.69 181.7 69.47 181.89 68.66 183.32 69 183.71 67.37 183.17 66.86 183.63 64.92 182.99 63.1 183.7 62.52 183.81 60.88 183.58 60.8 187.56 61.75 189.68 62.25 187.84 70.11 189.92 70.58 188.43 77.08 186.03 77.11 185.78 78.19 183.23 78.16 182.98 79.24 180.93 78.71 174.62 77.21 174.36 77.25 174.1 76.92 172.82 76.99 171.59 76.79 171.06 76.5 170.7 76.3 170.88 75.26 170.33 74.74 172.04 74.86 172.82 70.77 173.55 70.04 174.97 70.11 174.36 69.08 173.3 68.82 173.3 67.71 171.97 66.22 172.18 65.4 171.37 65.2 171.3 64.32 Z"
          data-name="Missoula"
          data-stusps="MT"
          id="30063"
        />
        <path
          className="white"
          d="M 28.51 89.44 31.4 90.53 33.58 89.59 35.25 90.22 36.24 91.07 36.41 92.25 37.49 93.88 39.14 94.5 38.95 95.04 41.81 96.08 40.65 99.34 40.61 100.71 45.64 102.39 44.93 104.4 53.29 107.22 54.35 109.57 54.32 111.3 53.12 111.89 51.5 114.23 48.85 113.51 48.39 114.85 46.76 114.29 45.58 115.08 44.1 114.89 42.2 115.16 39.9 116.53 37.71 115.84 36.75 115.99 34.8 115.23 33.37 115.85 32.95 115.08 30.38 114.78 28.73 113.42 26.86 112.75 27.16 111.92 26.34 111.3 25.88 111.35 27.16 107.41 27.98 107.7 28.57 106.07 29.41 106.3 30.54 103.08 29.72 102.78 30.88 99.71 30.18 99.26 30.78 97.67 29.97 97.38 30.6 95.65 25.94 93.87 26.96 92.22 28.51 89.44 Z"
          data-name="Douglas"
          data-stusps="OR"
          id="41019"
        />
        <path
          className="white"
          d="M 480.51 407.53 482.43 407.47 484.02 407.4 485.33 408.69 486.08 409.45 486.73 410.11 486.98 410.57 489.73 410.44 489.99 410.62 491.71 410.39 491.67 410.69 491.17 412.45 490.98 413.44 490.72 413.82 490.48 414.45 490.52 415.31 488.62 416.08 488.49 415.81 486.24 415.55 484.65 414.79 484.38 412.42 482.94 412.24 481.95 411 481.54 408.52 480.51 407.53 Z"
          data-name="Iberville"
          data-stusps="LA"
          id="22047"
        />
        <path
          className="white"
          d="M 705.58 271.63 705.53 270.6 705.86 270.15 707.42 269.12 707.39 271.35 708.18 273.76 710.94 273.92 711.22 274.78 709.62 276.02 708.17 276.37 706.78 275.61 705.47 273.5 705.58 271.63 Z"
          data-name="Chowan"
          data-stusps="NC"
          id="37041"
        />
        <path
          className="white"
          d="M 14.91 124.22 17.86 125.33 20.38 126.24 22.7 127.07 24.66 127.68 23.38 129.26 22.19 129.14 20.93 129.97 20.78 132.36 19.16 134.31 19.77 135.81 19.8 137.37 18.57 138.63 17.01 138.12 17.56 136.54 13.33 135.03 13.69 133.39 13.75 131.69 13.91 130.03 13.89 129.6 13.41 129.28 13.03 127.94 13.76 127.05 14.63 125.35 14.91 124.22 Z"
          data-name="Del Norte"
          data-stusps="CA"
          id="6015"
        />
        <path
          className="white"
          d="M 594.71 360.31 595.27 360.25 596.08 357.13 596.85 356.53 597.67 356.62 598.31 357.47 599.86 357.39 600.78 359.33 601.83 360.14 601.77 360.3 600.14 360.63 598.99 362.93 598.14 363.57 595.98 362.73 595.84 363.02 594.62 360.85 594.71 360.31 Z"
          data-name="Taylor"
          data-stusps="GA"
          id="13269"
        />
        <path
          className="white"
          d="M 676.63 135.56 677.79 134.27 678.9 133 679.52 132.76 679.55 132.75 680.29 132.84 681.35 132.24 681.59 131.27 681.33 129.85 681.13 129.29 683.63 128.91 683.41 128.19 686.92 127.68 688.19 131.72 687.33 131.67 687.09 134.9 687.92 138.08 687.15 137.85 686.28 137.93 685.04 137.91 682.9 137.06 683.32 138.07 682.38 137.81 679.39 138.73 677.55 138.65 676.63 135.56 Z"
          data-name="Oswego"
          data-stusps="NY"
          id="36075"
        />
        <path
          className="white"
          d="M 723.45 165.72 723.58 164.29 722.87 163.58 723.3 162.47 726.87 160.98 728.13 160.4 728.84 160.19 729.18 161.84 729.42 163.08 729.42 163.09 729.43 163.11 729.46 163.28 726.22 164.64 723.44 165.8 723.45 165.72 Z"
          data-name="Putnam"
          data-stusps="NY"
          id="36079"
        />
        <path
          className="white"
          d="M 457.48 284.92 458.66 284.92 460.75 284.88 467.29 284.79 469.73 284.76 469.82 289.6 469.57 289.69 459.72 289.82 457.54 289.83 457.48 284.92 Z"
          data-name="Douglas"
          data-stusps="MO"
          id="29067"
        />
        <path
          className="white"
          d="M 702.97 254.11 703.81 253.27 703.5 252.82 703.87 252.59 706.32 254.59 706.55 256.04 707.71 257.14 707.56 257.57 706.82 257.51 703.02 254.67 702.97 254.11 Z"
          data-name="Newport News"
          data-stusps="VA"
          id="51700"
        />
        <path
          className="white"
          d="M 708.47 257.5 708.88 256.04 709.18 256.29 709.44 256.5 710.76 256.87 710.97 256.89 710.93 257.91 711.07 258.87 710.58 258.73 709.68 259.28 708.75 258.43 708.72 258.01 708.47 257.5 Z"
          data-name="Norfolk"
          data-stusps="VA"
          id="51710"
        />
        <path
          className="white"
          d="M 287.16 357.75 287.93 357.8 288.54 349.72 289.51 346.5 292.83 346.73 300.03 347.25 299.73 350.67 299.46 353.84 299.06 358.73 298.9 360.79 298.57 365.7 298.48 366.94 298.01 374.03 297.93 375.12 297.82 376.74 293.62 376.46 287.27 376.01 287.99 366.19 286.54 366.08 287.16 357.75 Z"
          data-name="Lea"
          data-stusps="NM"
          id="35025"
        />
        <path
          className="white"
          d="M 180.42 32.26 181.02 32.42 184.73 33.35 187.12 33.98 188.49 34.33 188.89 35.18 188.11 36.42 189.02 38.06 190.62 37.69 191.49 38.65 191.23 39.47 191.71 40.64 190.64 42.47 192.34 43.65 193.08 43.6 193.85 44.56 193.28 46.28 194.68 47.19 194.81 47.94 193.93 48.64 194.27 49.33 195.46 51.08 195.13 52.29 197.66 53.65 198.7 56.94 197.28 57.04 195.85 57.42 195.19 60.58 193.99 60.89 193.73 63.28 191.44 62.75 189.68 62.25 187.56 61.75 188.48 59.57 188.01 59.49 187.87 57.77 188.43 56.22 187.71 54.82 186.63 54.05 186.43 52.56 184.62 52.12 183.87 52.5 184.1 53.75 178.41 52.36 177.79 55.61 176.19 55.22 176.59 53.62 171.75 52.44 172.18 49.67 173.07 45.76 175.21 46.31 176.86 39.83 176.38 39.7 176.79 38.12 179.87 38.91 179.34 38.26 180.65 37.26 179.44 35.8 180.1 35.33 180.23 33.44 180.81 32.91 180.42 32.26 Z"
          data-name="Flathead"
          data-stusps="MT"
          id="30029"
        />
        <path
          className="white"
          d="M 370.79 301.97 377.28 302.14 377.13 310.39 375.51 310.35 375.43 313.6 370.67 313.48 370.55 313.21 370.68 308.58 370.79 301.97 Z"
          data-name="Blaine"
          data-stusps="OK"
          id="40011"
        />
        <path
          className="white"
          d="M 619.18 283.66 620.87 283.34 623.71 280.85 622.95 283.67 625.14 285.34 624.84 286.09 624.08 288.2 623.34 288.67 623.32 288.67 622.62 288.8 622.33 288.23 621.18 287.95 621.06 288.07 619.81 286.36 618.95 286.46 619.25 284.14 619.18 283.66 Z"
          data-name="Carter"
          data-stusps="TN"
          id="47019"
        />
        <path
          className="white"
          d="M 397.58 449.49 396.87 453.44 396.52 454.34 395.94 454.88 393.98 457.15 393.29 458.49 392.45 456.21 391.76 457.2 389.73 453.97 391.66 453.49 393.69 451.92 392.04 450.31 397.58 449.49 Z"
          data-name="Aransas"
          data-stusps="TX"
          id="48007"
        />
        <path
          className="white"
          d="M 761.08 135.32 761.38 134.74 761.91 134.68 762.53 135.15 762.76 135.15 762.67 135.71 763 136.15 763.27 136.32 763.71 135.68 763.62 135.22 764.56 135.71 765.66 136.97 765.78 137.07 766.62 137.74 766.64 137.87 766.75 138.44 766.51 139.35 767 140.13 767.89 140.26 768.18 139.98 768.9 140.44 769.54 141.44 769.58 142.32 769.67 142.38 769.41 142.98 768.6 143.73 768.85 143.96 768.38 145.92 768.29 146.91 767.5 146.63 767.43 146.6 767.12 147.53 766.54 147.44 765.68 145.94 765.07 144.97 764.71 144.92 764.34 144.46 762.93 145.15 762.98 144.71 762.57 144.49 763.2 143.38 762.75 142.59 762.53 142.39 762.43 142.19 761.33 141.39 760.32 139.41 760.55 139.19 761.01 138.72 761.86 137.85 761.96 137.75 762.15 137.57 761.52 135.04 761.08 135.32 Z"
          data-name="Plymouth"
          data-stusps="MA"
          id="25023"
        />
        <path
          className="white"
          d="M 645.44 354.31 649.22 349.78 651.39 352.02 651.8 351.2 652.48 352.11 653.17 354.82 653.01 356.38 651.74 358.21 650.57 358.25 650.58 359.45 653.43 362.26 653.25 363.14 652.26 362.83 651.11 362.15 650.65 362.54 649.35 362.16 649.09 360.96 648.5 360.08 648.37 359.89 648.68 359.1 648.45 358 647.66 357.14 647.24 356.68 647.1 355.66 645.6 354.34 645.44 354.31 Z"
          data-name="Jasper"
          data-stusps="SC"
          id="45053"
        />
        <path
          className="white"
          d="M 658.78 346.34 660.56 346.26 662.55 346.49 662.95 346.48 662.23 345.77 663.58 345.06 663.35 343.94 662.61 343.4 661.95 342.91 662.35 342.63 663.91 342.82 664.66 344.22 665.32 344.46 665.87 344.25 666.64 345.91 666.72 345.9 666.87 345.1 667.79 343.78 668.65 343.2 668.65 342.29 670.17 339.41 672.07 338.63 673.03 337.21 674.75 338.1 676.11 338.21 676.08 338.54 675.84 338.78 675.28 339.26 675.25 340.04 675.06 340.92 674.01 340.92 673.09 341.34 672.36 340.79 671.51 341.49 671.2 342.21 671.93 342.98 671.51 343.61 670.14 344.75 669.78 345.68 668.42 346.66 667.7 347.39 667.58 348.39 666.37 349.45 665.95 350.17 664.73 350.41 663.65 351.05 663.07 351.76 662.2 352.19 662.16 352.23 660.87 353.41 659.84 353.69 659.62 352.73 659.53 352.53 659.55 352.47 659.39 352.38 659.33 352.31 659.31 352.19 659.32 352.1 659.35 352.06 659.48 351.95 659.53 351.87 659.6 351.82 659.7 351.82 659.71 351.71 659.61 351.58 659.57 351.48 659.55 351.32 659.56 351.25 659.6 351.13 659.68 350.98 659.66 350.92 659.59 350.9 659.55 350.92 659.39 351.08 659.28 351.19 659.22 351.23 659.1 351.24 659.13 351.21 659.07 351.15 659.03 351.06 659 350.87 659.55 350.22 658.27 348.72 658.78 346.34 Z"
          data-name="Charleston"
          data-stusps="SC"
          id="45019"
        />
        <path
          className="white"
          d="M 301.14 333.5 301.16 333.31 307.84 333.77 307.23 342.93 300.45 342.48 300.85 337.69 300.89 337.06 301.14 333.5 Z"
          data-name="Bailey"
          data-stusps="TX"
          id="48017"
        />
        <path
          className="white"
          d="M 530.45 304.51 530.43 303.96 532.35 303.73 533.64 304.28 532.81 306.21 532.94 308 534.03 309.82 533.1 311.34 533.67 311.7 534.22 312 533.45 312.3 530.83 312.75 530.07 311.98 529.96 311.69 529.89 310 530.58 308.43 530.45 304.51 Z"
          data-name="Decatur"
          data-stusps="TN"
          id="47039"
        />
        <path
          className="white"
          d="M 381.38 176.93 381.88 176.41 382.1 172.32 382.59 170.82 388.63 170.96 388.53 176.91 387.62 177.04 386.24 176.74 385.46 176.59 385.19 176.81 384.78 177.81 384.14 178.35 382.97 178.42 382.02 177.56 381.44 176.95 381.38 176.93 Z"
          data-name="Bon Homme"
          data-stusps="SD"
          id="46009"
        />
        <path
          className="white"
          d="M 303.82 131.33 304.07 131.33 304.3 128.96 304.47 127.31 318.84 128.68 318.55 131.93 317.74 140.1 309.64 139.36 306.25 139.02 303.03 139.34 303.26 137.08 303.82 131.33 Z"
          data-name="Butte"
          data-stusps="SD"
          id="46019"
        />
        <path
          className="white"
          d="M 395.16 172.69 398.41 172.72 400.04 172.74 399.94 179.93 398.57 179.29 397.75 179.45 397.07 178.84 396.94 178.73 395.47 178.53 395.01 178.16 395.08 177.78 395.16 172.69 Z"
          data-name="Clay"
          data-stusps="SD"
          id="46027"
        />
        <path
          className="white"
          d="M 604.86 287.69 606.13 286.44 607.62 288.23 606.84 289.38 606.49 289.56 606.18 289.71 606.49 290.58 605.41 290.79 605.68 291.5 604.96 290.72 602.58 290.58 601.9 290.28 602.06 289.42 603.72 287.7 604.86 287.69 Z"
          data-name="Hamblen"
          data-stusps="TN"
          id="47063"
        />
        <path
          className="white"
          d="M 654.32 309.01 658.15 308.47 660.5 308.13 661.72 310.15 663.46 311.45 662.89 313.12 662.15 314.03 659.62 314.41 656.17 317.42 656.13 316.89 655.14 314.95 653.55 313 652.02 311.49 650.54 309.53 650.54 309.53 654.32 309.01 Z"
          data-name="Chesterfield"
          data-stusps="SC"
          id="45025"
        />
        <path
          className="white"
          d="M 719.84 272.92 720.87 272.14 720.08 268.81 721.38 270.89 722.69 272.47 724.71 275.17 725.89 276.8 726.42 277.5 727.55 279.89 727.95 283.9 727.9 287.23 726.32 287.68 724.67 288.72 722.39 282.92 720.35 279.99 718.38 280.4 717.77 276.01 717.99 274.35 719.84 272.92 Z"
          data-name="Dare"
          data-stusps="NC"
          id="37055"
        />
        <path
          className="white"
          d="M 720.1 181.25 720.56 180.72 720.69 179.98 720.61 179.74 719.77 179.84 719.95 179.5 720.68 178.52 720.74 178.26 721.93 178.44 722.07 178.27 723.32 178.58 724.44 178.61 724.39 178.77 724.24 179.24 724.1 179.29 723.74 179.66 723.71 179.68 723.88 180.41 722.62 180.75 722.37 180.48 721.59 180.77 720.42 181.21 720.1 181.25 Z"
          data-name="Union"
          data-stusps="NJ"
          id="34039"
        />
        <path
          className="white"
          d="M 353.31 81.53 358.21 81.82 359.84 81.92 360.12 85.21 359.76 91.71 358.74 91.65 351.59 91.23 352.01 84.73 353.12 84.79 353.31 81.53 Z"
          data-name="Sheridan"
          data-stusps="ND"
          id="38083"
        />
        <path
          className="white"
          d="M 712.58 151.56 714.88 152.06 718.24 151.52 718.85 149.73 720.39 150.32 720.37 151.31 720.72 154.57 721.95 157.82 722.51 160.62 721.13 161.18 717.89 160.98 716.64 162.15 715.98 161.24 712.94 160.01 714.01 157.1 708.71 155.64 711.58 152.28 712.58 151.56 Z"
          data-name="Ulster"
          data-stusps="NY"
          id="36111"
        />
        <path
          className="white"
          d="M 454.19 262.64 455.16 263.98 458.24 263.86 458.87 263.87 459.87 263.23 461.25 264.14 461.83 266.08 462.67 266.88 464.3 266.84 464.32 267.65 464.36 269.88 462.32 271.06 461.2 269.37 457.7 269.42 454.47 269.39 454.49 266.39 454.51 264.08 454.19 262.64 Z"
          data-name="Camden"
          data-stusps="MO"
          id="29029"
        />
        <path
          className="white"
          d="M 358.74 91.65 359.76 91.71 366.82 92.07 366.97 98.6 366.62 105.14 360.59 104.83 358.45 104.7 358.88 98.18 358.74 91.65 Z"
          data-name="Kidder"
          data-stusps="ND"
          id="38043"
        />
        <path
          className="white"
          d="M 386.12 86.29 387.41 86.33 392.61 86.46 392.45 92.98 392.71 94.59 389.45 94.51 386.19 94.42 385.91 92.79 386.12 86.29 Z"
          data-name="Steele"
          data-stusps="ND"
          id="38091"
        />
        <path
          className="white"
          d="M 392.61 86.46 399.96 86.58 400.1 87.02 400.44 88.47 400.39 89.84 400.36 90.94 400.54 94.01 400.59 94.75 392.71 94.59 392.45 92.98 392.61 86.46 Z"
          data-name="Traill"
          data-stusps="ND"
          id="38097"
        />
        <path
          className="white"
          d="M 469.72 332.91 472.49 332.87 473.35 332.85 477.54 332.8 477.61 336.08 477.63 337.47 480.37 337.55 480.78 339.06 481.76 339.17 481.91 340.17 481.36 340.61 480.43 339.82 477.67 338.55 477.53 340.64 477.22 340.11 473.96 340.25 473.98 340.8 469.62 340.99 469.83 337.83 469.72 332.91 Z"
          data-name="Jefferson"
          data-stusps="AR"
          id="5069"
        />
        <path
          className="white"
          d="M 398.35 197.89 403.28 197.95 404.84 197.97 404.82 199.06 404.94 202.6 406.42 204.52 404.42 204.5 403.04 203.75 398.28 203.32 398.28 203.26 398.35 197.89 Z"
          data-name="Dodge"
          data-stusps="NE"
          id="31053"
        />
        <path
          className="white"
          d="M 473.98 340.8 473.96 340.25 477.22 340.11 477.53 340.64 477.67 338.55 480.43 339.82 481.36 340.61 481.91 340.17 482.06 341.16 482.33 341.45 480.38 342.18 480.39 345.82 478.72 345.72 473.83 345.92 473.69 342.44 473.98 340.8 Z"
          data-name="Lincoln"
          data-stusps="AR"
          id="5079"
        />
        <path
          className="white"
          d="M 470.02 266.82 471.86 265.98 475.76 265.81 475.7 263.88 477.13 263.84 477.28 264.15 477.53 270.65 473.39 270.8 473.51 274.41 470.21 274.48 470.02 266.82 Z"
          data-name="Phelps"
          data-stusps="MO"
          id="29161"
        />
        <path
          className="white"
          d="M 439.52 322.32 439.53 321.5 441.19 321.52 441.2 320.2 441.2 320.15 442.87 319.83 442.88 318.15 444.53 318.23 444.54 316.14 446.05 317.03 450.25 315.93 450.55 317.84 452.38 317.78 452.71 318.05 452.73 319.92 450 319.93 448.92 321.27 446.19 321.53 446.27 323.69 440.56 323.68 439.52 323.15 439.52 322.32 Z"
          data-name="Logan"
          data-stusps="AR"
          id="5083"
        />
        <path
          className="white"
          d="M 718.76 201.52 719.58 199.98 720.26 198.71 720.48 198.81 721.94 200.36 724.92 201.14 725.75 200.82 726.57 201.8 727.84 201.28 727.84 201.29 727.82 202.03 727.23 203.58 726.75 204.53 725.36 205.82 725.15 206.15 723.54 206.77 720.31 206.85 719.93 204.94 717.61 203.67 718.39 202.21 718.76 201.52 Z"
          data-name="Atlantic"
          data-stusps="NJ"
          id="34001"
        />
        <path
          className="white"
          d="M 654.85 251.45 655.54 249.39 654.88 249.27 656.15 246.52 656.63 244.82 661.7 247.26 662.18 247.62 662.5 248.25 662.26 249.33 661.33 249.3 660.15 252.5 658.92 253.57 659.11 254.41 658.27 255.34 655.05 253.39 654.85 251.45 Z M 657.97 250.43 658.13 250.82 658.55 250.28 658.66 250.27 658.1 250.3 657.97 250.43 Z M 659.34 251.04 659.61 251.31 659.63 251.91 660.16 250.88 660.02 250.58 659.34 251.04 Z"
          data-name="Rockbridge"
          data-stusps="VA"
          fillRule="evenodd"
          id="51163"
        />
        <path
          className="white"
          d="M 46.26 184.13 49.08 182.13 49.85 183.75 51.31 184.86 51.86 184.41 59.32 186.57 61.25 187.1 61.56 186.91 60.53 190.39 60 192.16 52.6 190.01 51.99 188.26 50.85 187.83 48.94 188.8 45.23 188.49 44.66 188.79 44.96 185.87 46.26 184.13 Z"
          data-name="Sierra"
          data-stusps="CA"
          id="6091"
        />
        <path
          className="white"
          d="M 223.02 212.2 236.56 214.19 243.33 215.08 246.29 215.49 252.08 216.2 251.77 218.72 247.73 218.22 247.27 221.52 245.64 221.25 245.42 222.94 238.05 222.01 237.71 224.47 228.74 223.22 228.62 224.04 223.65 223.32 221.42 222.79 222.03 218.75 222.9 212.98 223.02 212.2 Z"
          data-name="Rio Blanco"
          data-stusps="CO"
          id="8103"
        />
        <path
          className="white"
          d="M 320.46 276.57 327.73 277.05 327.31 284.43 322.08 284.14 320.18 284.02 319.97 284.01 320.02 283.22 320.11 281.88 320.3 279.03 320.46 276.57 Z"
          data-name="Morton"
          data-stusps="KS"
          id="20129"
        />
        <path
          className="white"
          d="M 762.81 96.49 764.37 96.32 764.56 94.99 765.89 94.85 766.05 95.08 766.02 97.46 767.01 97.38 767.68 97.3 767.82 99.61 769.08 101.23 768.82 101.39 768.62 102.47 768 103.02 767.81 103.64 767.5 103.67 767.06 102.69 766.67 102.66 765.88 100.59 765.95 99.18 764.52 100.28 763.36 99.41 763.02 99.2 763.21 98.93 762.81 96.49 Z"
          data-name="Sagadahoc"
          data-stusps="ME"
          id="23023"
        />
        <path
          className="white"
          d="M 678.87 216.31 678.99 215.29 679.25 210.26 680.33 208.05 680.48 208.02 683.68 207.34 684.02 207.27 683.11 209.47 684.88 209.95 686.54 211.19 686.22 214.04 686.21 214.05 685.01 215.17 684.71 215.45 682.47 217.51 681.8 217.02 680.86 216.66 680.25 216.33 679.05 216.29 678.87 216.31 Z"
          data-name="Frederick"
          data-stusps="MD"
          id="24021"
        />
        <path
          className="white"
          d="M 483.58 105.03 484.7 104.17 485.84 103.77 488.27 102.77 489.81 101.29 490.21 100.79 490.48 100.77 490.72 104.01 492.33 103.89 492.45 105.52 497.32 105.13 497.58 108.37 502.45 107.98 502.83 112.4 501.45 111.73 494.16 110.33 490.29 109.57 487.75 109.06 487.15 107.53 486.3 106.09 485.36 105.8 484.72 105.19 484.02 105.61 483.58 105.03 Z"
          data-name="Gogebic"
          data-stusps="MI"
          id="26053"
        />
        <path
          className="white"
          d="M 404.46 211.58 406.09 211.61 406.52 211.05 407.94 212.01 410.26 210.68 410.98 210.78 411.36 210.91 412.98 210.92 412.96 211.59 413.5 212.43 413.36 213.33 413.63 213.83 413.75 214.04 413.31 214.81 413.41 215.97 404.43 215.94 404.46 211.58 Z"
          data-name="Cass"
          data-stusps="NE"
          id="31025"
        />
        <path
          className="white"
          d="M 89.7 207.75 91.13 207.72 98.03 208.04 108.82 210.71 119.07 213.11 130.44 225.3 127.88 237.19 114.46 234.25 109.31 257.23 106.55 270 107.12 271.12 106.46 274.14 105.88 273.29 103.42 269.65 99.97 264.55 98.6 262.52 92.41 253.3 90.43 250.36 95.1 230.72 89.42 219.81 84.04 209.43 84.43 207.89 89.7 207.75 Z"
          data-name="Nye"
          data-stusps="NV"
          id="32023"
        />
        <path
          className="white"
          d="M 114.71 95.31 116.71 94.13 118.58 95.67 120.59 94.98 121.11 96.47 123.95 97.26 124.41 95.64 128.37 96.72 134.76 98.54 134.75 98.55 133.75 99.2 133.26 100.12 133.33 101.14 132.62 102.12 132.14 102.6 131.3 103.44 130.05 103.71 129.25 104.09 128.43 105.38 127.3 106.98 126.8 107.53 125.79 108.13 125.67 109.15 125.1 109.73 125.3 110.4 125.47 111.09 125.04 111.62 121.35 110.52 121.81 108.9 120.71 107.43 115.58 106 112.38 108.01 111.07 108.52 107.49 107.5 109.76 104.15 111.88 102 111.27 100.65 109.65 99.79 109.67 98.97 111.74 98.8 113.04 99.04 113.52 96.9 114.43 97.12 114.71 95.31 Z"
          data-name="Baker"
          data-stusps="OR"
          id="41001"
        />
        <path
          className="white"
          d="M 701.82 194.98 703.92 192.39 705.35 192.14 706.82 193.57 709.59 194.57 709.14 195.44 707.01 199.01 707.24 199.75 706.29 200.24 705.63 200.97 705.25 201.75 705.11 202.5 704.9 202.55 699.82 203.73 700.3 203.57 701.28 200.46 700.87 198.89 701.35 197.08 700.93 195.74 701.82 194.98 Z"
          data-name="Chester"
          data-stusps="PA"
          id="42029"
        />
        <path
          className="white"
          d="M 613.4 242.4 613.48 242.12 614.3 242.03 617.07 243.87 617.48 245.74 615.08 247.34 614.65 248.97 614.07 247.29 613.26 247.71 610.5 246.01 611.39 245.64 612.33 245.35 613.15 244.95 613.31 244.02 613.29 242.79 613.4 242.4 Z"
          data-name="Cabell"
          data-stusps="WV"
          id="54011"
        />
        <path
          className="white"
          d="M 714.2 176.47 715.09 176.48 715.96 175.39 715.78 174.99 716.84 172.83 717.17 172.19 717.5 173.15 718.13 172.58 719.54 173.05 720.5 173.01 721.4 174.9 720.57 174.89 720.7 177.83 720.74 178.26 720.68 178.52 719.95 179.5 719.77 179.84 719 180.52 718.9 179.57 718 178.58 716.65 179.39 715.74 179.93 714.22 179.85 713.06 179.23 713.54 178.79 714.2 176.47 Z"
          data-name="Morris"
          data-stusps="NJ"
          id="34027"
        />
        <path
          className="white"
          d="M 511.16 415.21 511.1 416.41 512.05 416.71 512.91 416.97 513.65 417.76 514.56 417.9 515.34 417.53 515.62 415.58 516.88 414.44 517.67 414.02 519.34 413.95 519.95 413.31 521.04 412.43 521.84 412.11 521.89 413.72 521.48 415.07 521.3 416.36 521.27 417.28 520.42 418.72 520.83 419.58 518.72 419.43 518.73 421.1 517.75 421.72 517.19 422.1 516.88 421.82 515.05 421.32 513.45 419.96 510.98 419.38 510.24 418.05 510.02 417.16 508.5 416.67 511.16 415.21 Z"
          data-name="St. Bernard"
          data-stusps="LA"
          id="22087"
        />
        <path
          className="white"
          d="M 369.47 334.94 371.92 334.73 375.18 334.28 376.01 333.21 377.6 333.25 377.63 333.58 377.55 337.32 377.5 340.1 377.01 340.6 376.14 340.34 374.69 339.94 373.99 339.72 373.44 340.25 373.17 341.05 373.03 341.11 372.21 341.42 371.4 340.82 370.66 339.79 370.15 339.64 370.25 336.31 369.44 336.3 369.47 334.94 Z"
          data-name="Cotton"
          data-stusps="OK"
          id="40033"
        />
        <path
          className="white"
          d="M 292.18 252.96 298.69 253.52 300.28 253.77 299.97 257.04 299.93 258.5 299.67 260.23 298.04 260.11 297.95 261.2 294.73 260.93 291.48 260.02 292.18 252.96 Z"
          data-name="Crowley"
          data-stusps="CO"
          id="8025"
        />
        <path
          className="white"
          d="M 310.37 375.91 311.59 375.99 318.55 376.38 318.1 384.56 309.88 384.09 310.37 375.91 Z"
          data-name="Midland"
          data-stusps="TX"
          id="48329"
        />
        <path
          className="white"
          d="M 377.55 337.32 386.53 337.51 386.47 341.15 386.48 341.59 386.83 343.24 386.42 344.82 385.88 344.38 385.7 343.51 384.73 343.06 383.33 344.27 382.63 345.11 381.64 345.66 380.32 345.09 380.31 344.85 380.3 344.23 380.42 342.98 379.51 342.87 378.31 342.73 378.08 341.85 378.09 340.81 377.74 339.86 377.5 340.1 377.55 337.32 Z"
          data-name="Jefferson"
          data-stusps="OK"
          id="40067"
        />
        <path
          className="white"
          d="M 336.75 369.05 344.92 369.45 344.5 377.7 343.17 377.65 336.3 377.3 336.75 369.05 Z"
          data-name="Nolan"
          data-stusps="TX"
          id="48353"
        />
        <path
          className="white"
          d="M 483.28 274.16 485.78 273.73 489.04 273.58 489.21 277.88 489.88 279.78 489.96 281.74 489.36 282.31 489.44 283.96 486.65 284.04 485.81 283.29 485.49 281.92 484.08 281.43 483.53 280.41 483.14 277.42 482.6 277.44 482.53 275.81 480.98 275.83 480.93 274.18 483.28 274.16 Z"
          data-name="Reynolds"
          data-stusps="MO"
          id="29179"
        />
        <path
          className="white"
          d="M 476.26 284.63 476.08 277.61 482.6 277.44 483.14 277.42 483.53 280.41 484.08 281.43 485.49 281.92 485.81 283.29 482.82 283.62 482.92 287.42 476.35 287.63 476.26 284.63 Z"
          data-name="Shannon"
          data-stusps="MO"
          id="29203"
        />
        <path
          className="white"
          d="M 361.1 389.95 361.91 389.42 362.71 389.56 363.62 390.47 364.6 390.36 364.88 390.95 366.97 390.74 367.41 391.13 367.12 392.22 368.07 391.84 368.21 392.9 369.13 392.71 368.47 393.52 369.48 394.5 370.29 395.92 369.99 397.12 371.38 398.31 371.67 400.25 371.23 400.33 362.84 400.12 360.87 400.05 360.79 399.69 361.1 389.95 Z"
          data-name="San Saba"
          data-stusps="TX"
          id="48411"
        />
        <path
          className="white"
          d="M 508.62 417.61 509.41 417.44 510.24 418.05 510.98 419.38 513.45 419.96 515.05 421.32 516.88 421.82 517.19 422.1 517.13 422.14 516.61 421.84 515.55 422.62 516.24 423.84 516.2 424.78 516.88 425.86 517.73 426.35 519.43 426.53 520.55 426.53 521.5 427.45 522.44 427.25 523.59 428.41 523.95 429.52 525.45 429.51 525.7 430.41 524.92 431.89 524.11 432.25 523.62 433.12 523.76 433.83 522.48 433.32 521.77 432.68 520.78 433.64 519.56 435.15 519.43 433.59 520.07 432.52 519.53 431.57 518.81 431.14 517.92 429.94 516.54 429.5 515.84 429.36 515.26 428.66 513.82 428.48 511.89 428.3 511.23 428.56 510.92 428.84 509.54 425.97 509.27 422.82 507.63 419.99 507.69 418.92 508.62 417.61 Z"
          data-name="Plaquemines"
          data-stusps="LA"
          id="22075"
        />
        <path
          className="white"
          d="M 176.19 55.22 177.79 55.61 178.41 52.36 184.1 53.75 183.87 52.5 184.62 52.12 186.43 52.56 186.63 54.05 187.71 54.82 188.43 56.22 187.87 57.77 188.01 59.49 188.48 59.57 187.56 61.75 183.58 60.8 183.81 60.88 183.7 62.52 182.99 63.1 183.63 64.92 183.17 66.86 183.71 67.37 183.32 69 181.89 68.66 181.7 69.47 178.46 68.69 178.46 67.82 179.25 64.58 178.17 64.31 177.5 63.47 178.65 61.63 177.55 61.63 178.86 59.75 175.57 58.79 176.24 56.09 176.19 55.22 Z"
          data-name="Lake"
          data-stusps="MT"
          id="30047"
        />
        <path
          className="white"
          d="M 329.01 360.43 331.15 360.42 331.91 360.55 337.2 360.83 336.75 369.05 328.58 368.61 329.01 360.43 Z"
          data-name="Scurry"
          data-stusps="TX"
          id="48415"
        />
        <path
          className="white"
          d="M 386.29 145.07 391.14 145.19 396.03 145.29 395.91 151.81 392.66 151.77 386.18 151.62 386.12 151.62 386.29 145.07 Z"
          data-name="Kingsbury"
          data-stusps="SD"
          id="46077"
        />
        <path
          className="white"
          d="M 599.06 292.45 598.85 291.62 600.75 290.29 601.9 290.28 602.58 290.58 604.96 290.72 605.68 291.5 605.52 293.16 605.23 293.05 605.18 295.03 604.98 295.23 602.39 295.05 599.07 293.25 598.39 292.29 599.06 292.45 Z"
          data-name="Jefferson"
          data-stusps="TN"
          id="47089"
        />
        <path
          className="white"
          d="M 44.63 54.63 47.76 56.04 52.47 57.67 51.98 58.99 50.37 58.39 50.67 60.04 52.08 61.18 49.17 62.54 48.72 63.61 47.23 67.65 43 66.07 42.03 68.68 42.82 68.98 42.59 69.57 38.82 68.14 38.84 68.1 39.99 66.44 40.53 65.13 41.11 64 41.36 62.66 42.2 61.21 42.41 60.03 43.32 58.78 44.12 57.02 44.45 56.15 44.42 55.11 44.63 54.63 Z"
          data-name="Tillamook"
          data-stusps="OR"
          id="41057"
        />
        <path
          className="white"
          d="M 118.18 49.45 131.09 53.43 129.19 59.87 127.75 62.08 125 62.19 123.08 61.66 110.14 57.64 111.19 54.38 116.1 55.96 118.18 49.45 Z"
          data-name="Adams"
          data-stusps="WA"
          id="53001"
        />
        <path
          className="white"
          d="M 594.61 290.98 595.23 291.39 597.86 290.99 598.5 291.96 599.06 292.45 598.39 292.29 599.07 293.25 599.54 294.19 597.57 296.34 596.77 297.32 594.5 296.79 594.27 297.66 592.26 297.72 592.41 298.73 592.05 298.59 591.8 298.33 590.34 297.04 590.19 296.81 590.1 296.24 591.17 295.1 593.17 294.03 592.55 293.48 594.61 290.98 Z"
          data-name="Knox"
          data-stusps="TN"
          id="47093"
        />
        <path
          className="white"
          d="M 717.31 107.87 721.74 105.94 722.23 107.09 722.8 108.35 723.77 109.89 726.37 109.98 726.08 111.44 725.63 113.63 725.25 112.9 723.95 113.68 724.54 114.67 723.88 115.3 723.47 114.56 720.96 115.48 721.51 116.76 719.48 117.62 719.53 117.25 718.89 116.67 718.73 116.53 718.64 115.37 717.89 114.48 717.6 113.64 717.48 112.94 716.89 112.48 716.86 111.33 716.8 110.27 716.78 109.99 717.05 108.62 717.35 107.98 717.31 107.87 Z"
          data-name="Addison"
          data-stusps="VT"
          id="50001"
        />
        <path
          className="white"
          d="M 510.99 239.26 512.66 239.18 512.22 233.4 515.34 233.17 515.47 234.54 516.8 234.46 516.9 235.55 518 235.46 518.94 236.77 520.6 236.65 520.71 238.01 520.95 241.01 516.06 241.38 512.81 241.64 511.17 241.72 510.99 239.26 Z"
          data-name="Shelby"
          data-stusps="IL"
          id="17173"
        />
        <path
          className="white"
          d="M 465.43 179.95 472.01 179.6 472.47 186.12 469.21 186.23 465.95 186.41 465.82 183.2 465.43 179.95 Z"
          data-name="Buchanan"
          data-stusps="IA"
          id="19019"
        />
        <path
          className="white"
          d="M 601.95 241.43 602.19 241.14 603.17 240.75 603.93 240.39 604.07 240.65 604.3 241.07 604.43 241.82 604.91 243.17 605.58 243.69 605.78 243.84 606.91 243.78 607.75 244.47 607.94 244.59 606.59 246.22 606.08 247.07 606.03 247.45 603.7 247.4 602.31 246.22 600.51 245.73 601.16 244.96 602.14 242.05 601.95 241.43 Z"
          data-name="Greenup"
          data-stusps="KY"
          id="21089"
        />
        <path
          className="white"
          d="M 559.15 286.34 561.04 286.25 562.66 286.18 564.21 286.11 565.51 286.01 565.41 286.24 565.37 288.35 565.33 290.03 564.28 289.97 563 290 560.09 289.95 559.09 289.23 559.21 288.98 559.15 286.34 Z"
          data-name="Macon"
          data-stusps="TN"
          id="47111"
        />
        <path
          className="white"
          d="M 545.15 263.28 545.88 263.04 546.58 262.29 547.47 261.72 547.5 261.7 548.04 262.42 549.02 263.53 550.01 263.88 550.2 263.94 549.86 265.34 550.94 267.83 550.69 267.75 547.79 266.59 547.15 264.7 546.28 264.85 546.11 263.6 545.06 263.83 545.15 263.28 Z"
          data-name="Hancock"
          data-stusps="KY"
          id="21091"
        />
        <path
          className="white"
          d="M 560.92 182.66 567.47 181.81 568.25 187.67 563.02 188.35 562.51 188.41 561.67 188.52 560.92 182.66 Z"
          data-name="Branch"
          data-stusps="MI"
          id="26023"
        />
        <path
          className="white"
          d="M 543.58 306.41 544.79 305.52 545.17 302.64 548.01 303.42 548.52 303.69 549.15 303.56 549.6 303.94 552.05 304.74 551.33 308.25 549.81 310.45 547.15 309.94 545.99 310.48 545.67 310.58 544.62 310.38 544.9 309.2 544.41 308.43 543.5 307.83 543.58 306.41 Z"
          data-name="Maury"
          data-stusps="TN"
          id="47119"
        />
        <path
          className="white"
          d="M 447.47 410.22 451.57 410.14 451.53 408.5 453.18 408.47 453.2 410.11 457.33 410.01 458.97 410.41 459.03 412.64 459.64 414.56 461.32 414.53 461.45 415.9 459.67 415.96 459.69 416.78 457.53 416.57 448.11 416.78 448.15 416.74 448.15 415.64 448.11 414.5 447.94 413.54 447.97 413.19 448.02 412.59 447.14 411.59 447.36 410.33 447.47 410.22 Z"
          data-name="Calcasieu"
          data-stusps="LA"
          id="22019"
        />
        <path
          className="white"
          d="M 610.53 296.43 610.9 295.76 611.36 294.79 611.06 293.83 611.3 293.66 611.77 293.34 612.52 293.69 612.88 293.09 612.9 292.32 613.67 291.72 615.04 290.68 615.45 291.11 615.64 291.3 615.54 292.3 616.41 292.58 617.1 291.94 617.49 293.28 619.06 294.82 618.93 294.93 618.78 294.95 618.68 295.06 618.49 295.05 618.39 295.13 618.23 295.1 618.23 295.25 618.07 295.34 617.88 295.31 617.78 295.36 617.71 295.33 617.49 295.33 613.29 298.16 612.1 298.47 610.8 297.33 610.53 296.43 Z"
          data-name="Madison"
          data-stusps="NC"
          id="37115"
        />
        <path
          className="white"
          d="M 692.58 253.1 693.14 253.37 693.05 253.6 692.14 254.09 691.8 253.26 691.8 253.23 691.98 253.31 692.07 253.3 692.27 253.19 692.38 253.15 692.41 253.21 692.39 253.15 692.49 253.1 692.52 253.04 692.58 253.1 Z"
          data-name="Hopewell"
          data-stusps="VA"
          id="51670"
        />
        <path
          className="white"
          d="M 413.93 416.39 415.76 416.23 417.65 415.23 418.18 414.88 419.01 416 420.1 415.9 420.41 416.34 422.25 417.54 425.43 414.91 426.45 417.94 426.59 418.09 427.03 418.19 427.35 420.19 428.55 421.28 428.47 422.4 426.83 424.92 426.79 426.37 426.02 426.3 425.41 427.01 424.44 427.46 423.55 426.36 422.93 426.41 422.39 425.59 422.22 425.61 421.66 425.57 420.14 425.93 419.78 425.73 417.73 424.65 416.9 424.19 416.4 423.86 415.83 423.51 415.81 423.49 414.78 422.83 413.56 422.04 411.37 415.02 413.25 416.41 413.93 416.39 Z"
          data-name="Harris"
          data-stusps="TX"
          id="48201"
        />
        <path
          className="white"
          d="M 442.95 336.31 450.06 336.34 449.75 338.72 450.38 338.87 450.85 341.39 451.87 343.49 451.16 343.67 450.57 343.53 449.46 343.81 445.97 342.69 444.82 342.68 444.79 339.4 443.16 339.38 442.95 336.31 Z"
          data-name="Pike"
          data-stusps="AR"
          id="5109"
        />
        <path
          className="white"
          d="M 688.12 311.4 689.16 309.92 687.76 309.32 687.62 308.46 689.31 305.14 689.25 304.86 691.37 304.63 696.09 303.62 698.6 307.97 699.7 308.54 698.08 310.37 697.08 311.93 695 310.36 691.93 312.05 690.1 311.59 689.75 311.95 689.13 312.13 688.12 311.4 Z"
          data-name="Pender"
          data-stusps="NC"
          id="37141"
        />
        <path
          className="white"
          d="M 458.87 180.22 465.43 179.95 465.82 183.2 465.95 186.41 462.69 186.54 459.42 186.69 459.28 183.45 458.94 181.84 458.87 180.22 Z"
          data-name="Black Hawk"
          data-stusps="IA"
          id="19013"
        />
        <path
          className="white"
          d="M 640.65 463 642.59 462.81 642.41 461.14 645.79 460.78 647.05 460.58 654.23 459.79 654.23 459.79 654.76 464.83 648.5 465.53 643.81 466.04 642.49 465.82 641.77 464.57 640.65 463 Z"
          data-name="Charlotte"
          data-stusps="FL"
          id="12015"
        />
        <path
          className="white"
          d="M 563.52 359.76 564.11 359.43 564.41 359.68 569.38 359.2 571.41 359.01 571.78 363.95 572.34 364.23 569.72 365.53 569.37 365.83 566.98 365.48 565.76 364.34 563.53 366.29 562.99 360.69 562.92 359.87 563.52 359.76 Z"
          data-name="Elmore"
          data-stusps="AL"
          id="1051"
        />
        <path
          className="white"
          d="M 250.74 372.9 254.72 373.27 264.3 374.16 268.08 374.49 267.57 381.56 266.26 396.71 266.01 399.67 264.92 400.24 264.65 399.39 263.68 399.05 263.14 398.39 262.2 397.58 261.31 396.67 259.77 396.24 258.54 395.45 258.51 394.77 257.16 393.62 256.11 392.63 255.83 391.75 255.16 390.49 253.89 389.66 252.9 388.99 252.62 388.29 251.56 386.55 250.49 385.88 250.32 384.99 249.67 384.49 250.41 383.88 249.88 382.78 250.21 378.99 250.74 372.9 Z"
          data-name="Hudspeth"
          data-stusps="TX"
          id="48229"
        />
        <path
          className="white"
          d="M 583.87 344.98 585.12 344.63 586.31 343.09 588.7 342.83 589.83 342.71 590.14 342.84 590.18 344.6 591.79 346.01 592.42 347.27 592.42 347.97 586.86 348.52 586.77 349.15 586.71 348.53 585.48 348.65 585.07 347.69 583.87 344.98 Z"
          data-name="Coweta"
          data-stusps="GA"
          id="13077"
        />
        <path
          className="white"
          d="M 497.59 198.04 500.85 197.79 507.41 197.29 507.85 202.45 505.43 202.81 505.22 204.11 503.67 204.21 503.79 205.81 501.34 205.99 501.22 204.39 498.12 204.59 497.59 198.04 Z"
          data-name="Bureau"
          data-stusps="IL"
          id="17011"
        />
        <path
          className="white"
          d="M 550.83 189.81 554.65 189.38 554.65 189.38 556.5 189.16 557.1 193.58 557.31 195.2 551.57 195.89 551.48 195.08 550.83 189.81 Z"
          data-name="Elkhart"
          data-stusps="IN"
          id="18039"
        />
        <path
          className="white"
          d="M 709.78 219.24 712.25 218.55 713 217 714.04 216.52 714.28 215.55 715.44 215.57 715.54 215.72 715.63 216.21 717.01 217.27 718.34 218.04 719.05 218.01 719.34 217.66 720.05 219.51 721.04 222.49 721.5 224.09 719.46 224.57 717.12 225.09 715.06 225.54 711.82 226.15 711.37 224.61 711.27 224.27 710.86 222.88 710.86 222.87 709.78 219.24 Z"
          data-name="Sussex"
          data-stusps="DE"
          id="10005"
        />
        <path
          className="white"
          d="M 16.53 195.27 19.21 195.32 20.79 193.74 21.19 192.6 22.64 193.57 22.77 196.54 23.34 197.65 23.48 200.66 22.63 202.17 23.02 204.41 20.77 203.97 20.02 206.94 19.71 207.01 16.79 206.1 17.89 205.63 16.9 198.48 16.24 197.49 15.87 197.12 16.53 195.27 Z"
          data-name="Napa"
          data-stusps="CA"
          id="6055"
        />
        <path
          className="white"
          d="M 269.92 265.43 270.54 263.59 269.91 262.99 269.96 262.69 272.38 262.12 272.78 262.92 274.74 260.84 276.31 262.97 276.79 263.66 282.3 263.83 286.56 265.81 284.88 267.1 283.25 269.45 283.19 270.1 281.54 271.45 280.82 271.57 280.75 272.43 279.88 272.97 276.13 273.2 274.18 274.52 273.59 274.52 273.7 268.33 272.15 267.51 269.16 268.66 268.95 268.26 269.92 265.43 Z"
          data-name="Huerfano"
          data-stusps="CO"
          id="8055"
        />
        <path
          className="white"
          d="M 496.95 214.52 496.63 209.6 501.57 209.27 504.29 209.08 504.01 210.09 502.92 212.56 503.09 213.43 503.17 214.21 502.63 214.65 501.63 217.17 500.23 217.3 498.83 218.15 498.67 216.06 497.02 216.15 496.95 214.52 Z"
          data-name="Peoria"
          data-stusps="IL"
          id="17143"
        />
        <path
          className="white"
          d="M 627.04 407.09 627.61 406.38 627.03 406.05 626.24 399.4 626.37 399.63 627.19 399.5 627.97 399.27 628.54 398.02 626.86 395.05 627.38 394.25 629.13 394.16 631.19 394.05 632.17 402.01 632.23 402.55 630.62 405.54 631.5 406.4 629.91 408.75 629.61 408.75 627.65 407.69 627.54 407.11 627.04 407.09 Z"
          data-name="Columbia"
          data-stusps="FL"
          id="12023"
        />
        <path
          className="white"
          d="M 545.99 310.48 547.15 309.94 549.81 310.45 550.82 312.31 552.11 313.14 552.45 318.25 546.64 318.65 546.55 318.66 546.44 318.67 546.1 313.25 545.83 313.16 545.99 310.48 Z"
          data-name="Giles"
          data-stusps="TN"
          id="47055"
        />
        <path
          className="white"
          d="M 637.76 239.54 639.48 236.93 639.94 235.03 640.93 235.09 642.18 235.71 642.71 235.42 644.69 238.37 644.23 241.12 642.78 242.21 643.05 244.49 641.78 243.9 638.68 242.73 637.42 240.04 637.76 239.54 Z"
          data-name="Webster"
          data-stusps="WV"
          id="54101"
        />
        <path
          className="white"
          d="M 628.6 251.85 628.73 247.7 629.94 245.93 632.51 246.55 634 246.2 635.65 248.11 637.7 250.06 637.2 250.85 638.39 252.28 637.51 252.35 635.59 253.64 633.49 252.88 630.13 253.16 629.08 251.63 628.6 251.85 Z"
          data-name="Fayette"
          data-stusps="WV"
          id="54019"
        />
        <path
          className="white"
          d="M 621.94 240.18 623.1 241.39 624.57 240.03 625.51 241.17 629.69 240.86 628.53 242.12 629.94 245.93 629.94 245.93 628.73 247.7 628.6 251.85 627.74 252.01 627.42 251.69 626.16 249.47 623.93 247.72 621.13 248.37 621.14 246.4 619.58 246.37 619.59 244.95 622.02 243.24 621.25 240.98 621.94 240.18 Z"
          data-name="Kanawha"
          data-stusps="WV"
          id="54039"
        />
        <path
          className="white"
          d="M 510.83 382.11 512.46 381.91 516.48 381.37 516.92 388.18 516.07 388.23 513.9 388.36 513.81 386.86 510.99 385.21 510.83 382.11 Z"
          data-name="Covington"
          data-stusps="MS"
          id="28031"
        />
        <path
          className="white"
          d="M 342.79 215.56 350.71 215.97 354.16 216.15 353.94 221.06 352.31 220.97 352.23 222.61 350.75 222.57 342.7 222.15 342.42 222.14 342.79 215.56 Z"
          data-name="Frontier"
          data-stusps="NE"
          id="31063"
        />
        <path
          className="white"
          d="M 490.75 271 490.47 264.58 490.72 265.86 493.83 265.03 495.28 266.09 493.37 268.14 497.46 271.84 498.8 271.73 498.29 272.32 492.49 272.62 490.81 272.73 490.75 271 Z"
          data-name="St. Francois"
          data-stusps="MO"
          id="29187"
        />
        <path
          className="white"
          d="M 364.84 338.58 365.03 338.6 366.07 339.45 367.09 339.56 368.16 340.06 368.89 340.04 369.56 339.47 370.15 339.64 370.66 339.79 371.4 340.82 372.21 341.42 373.03 341.11 372.91 345.72 364.62 345.53 364.84 338.58 Z"
          data-name="Wichita"
          data-stusps="TX"
          id="48485"
        />
        <path
          className="white"
          d="M 292.74 246.44 297.68 246.92 298.9 233.78 299.01 233.79 307.05 234.49 306.37 242.71 306.11 244.4 305.57 250.92 305.32 252.37 305.19 254.01 300.28 253.77 298.69 253.52 292.18 252.96 292.17 252.96 292.74 246.44 Z"
          data-name="Lincoln"
          data-stusps="CO"
          id="8073"
        />
        <path
          className="white"
          d="M 560.52 109.64 561.99 110.7 563.35 111.05 564.26 111.45 563.89 112.36 562.69 112.47 561.13 111.24 560.16 110.37 560.52 109.64 Z M 543.32 105.27 551.48 104.19 553.1 103.96 553.34 105.6 563.11 104.22 563.35 105.84 564.97 105.61 565.21 107.23 566.89 107.31 565.08 107.8 563.56 108.49 562.07 107.83 561.01 108.55 560.15 108.61 558.94 109.63 559.46 110.67 558.3 110.64 556.48 109.52 555.15 108.26 553.1 107.69 551.56 107.61 550.02 107.5 547.94 107.82 546.77 109.81 546.19 110.33 544.66 110.15 544.01 110.85 543.32 105.27 Z"
          data-name="Mackinac"
          data-stusps="MI"
          fillRule="evenodd"
          id="26097"
        />
        <path
          className="white"
          d="M 274.53 239.71 278.86 240.16 278.43 245.07 277.66 246.31 279.6 246.56 279.29 249.31 274.89 248.91 275.03 247.98 273.68 247.84 274.51 239.71 274.53 239.71 Z"
          data-name="Teller"
          data-stusps="CO"
          id="8119"
        />
        <path
          className="white"
          d="M 160.21 42.52 161.01 44.08 161.44 43.5 163.34 43.24 164.24 42.7 164.84 43.97 164.4 44.43 164.81 45.41 165.02 47.7 165.4 48.26 164.95 49.28 165.21 50.02 167.71 50.5 168.2 51.17 169.51 50.87 170.38 49.2 172.18 49.67 171.75 52.44 176.59 53.62 176.19 55.22 176.24 56.09 175.57 58.79 178.86 59.75 177.55 61.63 178.65 61.63 177.5 63.47 178.17 64.31 179.25 64.58 178.46 67.82 178.46 68.69 177.4 68.77 176.61 67.48 174.2 65.33 171.3 64.32 169.32 62.95 169.56 61.34 166.58 58.91 161.71 57.6 160.92 56.38 161.08 55.55 161.66 54.76 161.29 54.04 161.65 53.3 160.57 51.72 160.71 50.68 160.16 49.97 159.7 48.74 159.19 47.1 159.15 46.87 159.1 46.54 159.74 44.22 160.21 42.52 Z"
          data-name="Sanders"
          data-stusps="MT"
          id="30089"
        />
        <path
          className="white"
          d="M 504.25 412.79 504.06 414.2 504.07 415.75 504.11 416.48 504.85 418.43 505.98 419.03 506.06 419.4 505.2 421.61 503.17 421.65 502.78 420.47 501.17 419.71 500.94 418.9 500.09 418.23 499.98 416.67 499.83 415.76 500.97 415.43 503.17 413.09 504.25 412.79 Z"
          data-name="St. Charles"
          data-stusps="LA"
          id="22089"
        />
        <path
          className="white"
          d="M 451.57 289.85 457.54 289.83 459.72 289.82 459.79 295.6 458.78 295.63 458.55 295.64 454.43 295.76 451.9 295.82 451.56 295.83 451.57 289.85 Z"
          data-name="Taney"
          data-stusps="MO"
          id="29213"
        />
        <path
          className="white"
          d="M 431.27 364.06 432.09 364.04 441.75 363.88 441.78 365.44 441.81 367.4 441.01 366.64 439.7 367.4 438.63 366.37 436.3 367.46 434.45 367.49 431.35 365.67 431.81 364.88 431.27 364.06 Z"
          data-name="Marion"
          data-stusps="TX"
          id="48315"
        />
        <path
          className="white"
          d="M 705.04 114.23 707.5 113.2 705.45 108.33 708.45 107.03 711.62 105.9 713.69 104.4 713.85 103.3 715.36 102.69 716.05 103.29 716.67 104.46 716.62 105.65 716.57 106.19 716.97 107.03 717.31 107.87 717.35 107.98 717.05 108.62 716.78 109.99 716.8 110.27 716.86 111.33 716.89 112.48 717.48 112.94 717.6 113.64 717.89 114.48 718.64 115.37 718.73 116.53 718.89 116.67 718.16 116.97 710.04 120.45 709.91 119.44 708.35 119.19 707.57 119.79 705.31 118.1 706.17 116.96 705.04 114.23 Z"
          data-name="Essex"
          data-stusps="NY"
          id="36031"
        />
        <path
          className="white"
          d="M 443.21 296.02 445.73 295.96 447.49 295.92 449.87 295.87 451.56 295.83 451.9 295.82 451.77 296.12 451.97 302.89 449.25 302.89 448.16 302.9 447.08 301.51 446.46 299.62 444.07 299.61 442.9 298.29 443.21 296.02 Z"
          data-name="Carroll"
          data-stusps="AR"
          id="5015"
        />
        <path
          className="white"
          d="M 377.13 310.39 385.29 310.55 385.21 316.54 385.21 317.09 385.19 317.83 385.19 317.86 383.65 317.65 382.7 317.82 382.26 317.32 380.83 317.58 378.68 316.94 375.45 316.87 375.43 313.6 375.51 310.35 377.13 310.39 Z"
          data-name="Canadian"
          data-stusps="OK"
          id="40017"
        />
        <path
          className="white"
          d="M 333.79 433.61 343.01 433.91 342.67 442.13 342.38 450.57 340.99 450.54 339.86 449.5 339.56 448.53 339.06 447.37 338.83 446.14 338.34 445.18 338.03 444.44 337.93 443.31 337.11 442.51 336.29 441.63 336.23 440.6 335.82 439.71 335.81 438.91 335.15 438.31 334.37 437.01 334.09 436 333.93 434.59 333.79 433.61 Z"
          data-name="Maverick"
          data-stusps="TX"
          id="48323"
        />
        <path
          className="white"
          d="M 502.79 180.36 503.29 180.33 507.78 180.05 508.48 180 509.21 179.95 509.74 186.39 507.62 186.59 506.49 186.69 506.41 185.68 503.29 185.96 503.12 183.99 502.79 180.36 Z"
          data-name="Winnebago"
          data-stusps="IL"
          id="17201"
        />
        <path
          className="white"
          d="M 702.64 220.34 703.91 219.53 703.73 218.33 706.04 218.33 707.26 220.11 705.9 222.18 707.15 222.94 706.36 225.15 703.95 224.33 703.73 223.73 703.37 223.86 702.62 223.19 702.08 223.31 701.52 224.1 701.11 224.05 701.03 223.19 700.18 222.85 700.21 222.22 701.21 221.83 701.54 220.66 702.49 221.24 702.83 220.82 702.64 220.34 Z"
          data-name="Talbot"
          data-stusps="MD"
          id="24041"
        />
        <path
          className="white"
          d="M 523.9 258.92 527.15 258.63 528.98 258.49 529.52 258.37 529.88 258.76 529.87 258.89 529.84 259.51 530.63 260.31 530.2 261.33 529.88 262.2 529.29 262.72 529.62 264 529.36 265.34 529.13 265.84 527.91 265 524.37 265.44 523.9 258.92 Z"
          data-name="White"
          data-stusps="IL"
          id="17193"
        />
        <path
          className="white"
          d="M 757.56 91.29 757.96 90.75 758.85 90.26 759.89 92.07 759.54 92.45 760.2 92.99 760.83 93.7 761.64 95.48 762.61 95.39 762.47 96.41 762.81 96.49 763.21 98.93 763.02 99.2 763.36 99.41 763.03 100.54 762.68 101.07 760.73 100.32 759.16 99.52 758.83 100.7 756.97 100.36 756.73 99.85 757.41 97.69 757.97 96.36 757.56 91.29 Z"
          data-name="Androscoggin"
          data-stusps="ME"
          id="23001"
        />
        <path
          className="white"
          d="M 424.54 274.24 431.55 274.19 431.56 274.56 431.62 279.11 431.63 279.98 431.64 280.46 424.79 280.51 424.58 279.69 424.54 274.24 Z"
          data-name="Crawford"
          data-stusps="KS"
          id="20037"
        />
        <path
          className="white"
          d="M 340.97 319.27 349.27 319.65 349.15 322.52 348.93 327.83 342.49 327.53 340.56 327.44 340.97 319.27 Z"
          data-name="Collingsworth"
          data-stusps="TX"
          id="48087"
        />
        <path
          className="white"
          d="M 344.78 387.15 351.04 387.44 352.52 389.55 352.91 389.1 352.62 396.69 344.36 396.37 344.78 387.15 Z"
          data-name="Concho"
          data-stusps="TX"
          id="48095"
        />
        <path
          className="white"
          d="M 309.03 394.69 317.51 395.29 325.62 395.72 330.67 395.9 330.37 402.96 330.02 410.81 317.02 410.17 318.71 408.95 317.44 407.69 319.11 405.15 319.06 404.02 317.21 403.31 316.63 402.4 315.62 398.09 314.06 396.85 310.71 396.35 310.58 395.82 309.11 395.63 307.62 394.59 309.03 394.69 Z"
          data-name="Crockett"
          data-stusps="TX"
          id="48105"
        />
        <path
          className="white"
          d="M 269.98 364.78 270.13 364.8 270.86 356.46 287.16 357.75 286.54 366.08 287.99 366.19 287.27 376.01 283.14 375.7 282.43 375.65 272.49 374.86 269.22 374.58 269.98 364.78 Z"
          data-name="Eddy"
          data-stusps="NM"
          id="35015"
        />
        <path
          className="white"
          d="M 419.51 164.98 421.88 164.96 425.98 164.92 426.04 169.53 419.53 169.58 419.51 164.98 Z"
          data-name="Dickinson"
          data-stusps="IA"
          id="19059"
        />
        <path
          className="white"
          d="M 527.98 235.37 531.94 234.9 534.23 234.89 534.24 235.03 534.46 237.32 533.79 237.52 533.51 238.07 533.69 239.06 533.73 239.29 534.03 239.95 533.18 240.87 533.22 241.03 532.93 240.79 528.63 241.12 527.79 241.21 527.39 237.36 527.2 235.45 527.98 235.37 Z"
          data-name="Clark"
          data-stusps="IL"
          id="17023"
        />
        <path
          className="white"
          d="M 553.52 304.54 554.5 302.92 554.09 299.59 554.98 297.23 555.43 296.94 559.73 299.17 561.25 299.15 561.5 299.88 560.89 303.95 560.33 304.29 560.44 305.36 558.89 304.9 558.04 305.85 555.74 304.57 554.28 304.93 553.52 304.54 Z"
          data-name="Rutherford"
          data-stusps="TN"
          id="47149"
        />
        <path
          className="white"
          d="M 678.23 278.31 679.42 278.3 679.84 276.83 680.83 276.04 683.57 275.91 684.17 276.53 685.68 276.37 683.2 284.41 682.13 283.06 678 281.36 677.81 280.24 678.23 278.31 Z"
          data-name="Franklin"
          data-stusps="NC"
          id="37069"
        />
        <path
          className="white"
          d="M 562.31 169.13 565.6 168.71 568.84 168.29 569.76 174.82 568.11 175.05 563.19 175.69 562.31 169.13 Z"
          data-name="Eaton"
          data-stusps="MI"
          id="26045"
        />
        <path
          className="white"
          d="M 405.76 258.38 405.8 254.3 411.78 254.32 411.72 255.14 411.7 260.04 411.7 263.31 411.58 263.56 411.57 264.97 405.67 264.92 405.76 258.38 Z"
          data-name="Lyon"
          data-stusps="KS"
          id="20111"
        />
        <path
          className="white"
          d="M 434.83 325.5 438.17 324.8 438.18 323.13 439.52 322.32 439.52 323.15 440.56 323.68 446.27 323.69 446.3 328.83 444.66 329.51 443.83 329.5 442.92 330.39 442.64 330.11 436.91 329.36 434.78 329.35 434.82 326.32 434.83 325.5 Z"
          data-name="Scott"
          data-stusps="AR"
          id="5127"
        />
        <path
          className="white"
          d="M 220.96 225.85 221.42 222.79 223.65 223.32 228.62 224.04 228.74 223.22 237.71 224.47 238.05 222.01 245.42 222.94 245.64 221.25 247.27 221.52 247.73 218.22 251.77 218.72 251.64 220.4 251.41 221.98 250.25 221.83 248.93 232.24 244.29 231.64 234.42 230.32 220.59 228.32 220.96 225.85 Z"
          data-name="Garfield"
          data-stusps="CO"
          id="8045"
        />
        <path
          className="white"
          d="M 601.27 329.61 604 326.06 605.01 326.76 606.28 326.45 607.64 327.49 608.54 328.94 608.23 330.25 608.67 330.38 608.29 330.48 607.28 331.23 606.52 331.43 606.05 332.13 605.49 330.93 602.2 330.67 601.27 329.61 Z"
          data-name="Jackson"
          data-stusps="GA"
          id="13157"
        />
        <path
          className="white"
          d="M 401.44 302.63 401.77 302.56 406.37 302.61 406.36 304.24 410.45 304.26 410.44 305.89 410.44 307.52 410.38 308.35 408.73 308.34 407.95 308.34 407.93 312.43 401.38 312.39 401.44 306.72 401.44 302.73 401.44 302.63 Z"
          data-name="Creek"
          data-stusps="OK"
          id="40037"
        />
        <path
          className="white"
          d="M 460.47 277.11 466.98 277.04 467.29 284.79 460.75 284.88 460.47 277.11 Z"
          data-name="Wright"
          data-stusps="MO"
          id="29229"
        />
        <path
          className="white"
          d="M 664.23 443.33 670.34 442.56 671.29 441.69 672.67 443.86 673.92 446.46 674.26 447.2 668.08 447.97 666.42 448.17 666.2 446.56 664.59 446.77 664.05 443.61 664.23 443.33 Z"
          data-name="Indian River"
          data-stusps="FL"
          id="12061"
        />
        <path
          className="white"
          d="M 535.01 225.8 539.77 225.33 539.92 226.94 541.11 226.84 541.55 231.76 538.84 231.99 536.17 232.23 535.9 231.4 536.13 227.41 535.01 225.8 Z"
          data-name="Parke"
          data-stusps="IN"
          id="18121"
        />
        <path
          className="white"
          d="M 580.9 379.71 580.75 378.06 583.98 377.83 585.33 376.54 585.49 377.1 585.46 377.82 586.69 379.13 586.78 380.06 587.09 380.53 586.98 381.02 586.75 382.01 586.91 382.7 586.61 384.04 586.76 384.81 586.77 385.06 585.31 385.22 581.43 385.46 580.9 379.71 Z"
          data-name="Henry"
          data-stusps="AL"
          id="1067"
        />
        <path
          className="white"
          d="M 746.34 145.01 747.96 144.57 749.42 144.17 750.61 143.85 750.72 144.14 751.94 147.9 752.44 149.43 752.44 149.44 752.92 151.04 751.93 151.25 750.61 151.83 748.99 151.95 747.71 152.02 747.61 152.24 746.14 151.51 745.87 151.3 747.1 150.43 746.53 148.93 745.78 149.14 745.11 146.82 746.03 146.52 746.77 146.31 746.34 145.01 Z"
          data-name="Windham"
          data-stusps="CT"
          id="9015"
        />
        <path
          className="white"
          d="M 238.68 251.29 240.68 251.55 241.56 244.64 242.91 234.3 244.07 233.69 244.55 233.78 244.69 234.91 245.86 236.58 249.03 236.98 249.8 238.54 251.09 239.65 251.78 239.41 252.59 240.1 253.51 238.99 254.34 238.84 255.61 240.09 256.28 240.15 257.39 241.97 259.44 242.2 258.07 243.6 257.68 245.53 257.11 245.98 258.05 247.24 258.2 249.26 259.55 251.52 248.39 250.15 247.74 255.39 239.29 254.33 239.32 252.74 238.68 251.29 Z"
          data-name="Gunnison"
          data-stusps="CO"
          id="8051"
        />
        <path
          className="white"
          d="M 238.85 257.77 239.94 256.07 239.29 254.33 247.74 255.39 247.31 258.99 245.21 259.06 244.82 264.06 244.17 268.8 238.85 268.15 239.37 264.06 240.06 261.42 239.3 260.48 238.85 257.77 Z"
          data-name="Hinsdale"
          data-stusps="CO"
          id="8053"
        />
        <path
          className="white"
          d="M 378.26 462.04 379.94 463.52 388.54 463.6 390.25 463.32 389.66 464.55 389 466.11 388.3 468.15 388.12 468.89 385.4 469.07 380.78 468.68 379.83 469.41 377.4 470.02 377.41 469.06 376.2 469.03 376.31 462.01 378.26 462.04 Z"
          data-name="Kleberg"
          data-stusps="TX"
          id="48273"
        />
        <path
          className="white"
          d="M 458.34 354.21 463.35 354.46 464.82 354.2 467.02 355.96 468.28 355.37 468.15 355.69 470.29 356.16 471.72 357.81 471.67 359.03 472.9 360.66 470.47 360.74 466.07 360.82 462.56 360.89 462.54 360.89 458.64 360.95 458.36 360.96 458.34 354.21 Z"
          data-name="Union"
          data-stusps="AR"
          id="5139"
        />
        <path
          className="white"
          d="M 424.81 249.71 426.75 249.31 426.97 249.52 427.45 248.26 431.36 248.48 431.37 249.65 431.39 252.17 431.41 254.17 431.41 254.22 427.02 254.27 424.85 254.28 424.81 249.71 Z"
          data-name="Johnson"
          data-stusps="KS"
          id="20091"
        />
        <path
          className="white"
          d="M 58.54 47.12 71.09 51.73 68.81 57.87 66.72 59.15 65.38 58.01 62.63 58.28 61.86 57.89 61.44 59.05 60.42 59.1 60.57 58.8 60.53 57.84 60.83 56.93 60.65 55.74 60.5 54.22 59.89 53.55 59.55 52.82 58.46 51.33 57.84 51.01 57.12 51.12 58.54 47.12 Z"
          data-name="Cowlitz"
          data-stusps="WA"
          id="53015"
        />
        <path
          className="white"
          d="M 497.96 303.33 500.79 303.13 502.99 302.98 503.88 302.92 506.45 302.74 507.21 303.69 507.77 304.15 507.84 304.46 507.88 304.64 506.76 305.11 506.68 305.61 506.82 306.32 505.72 306.89 504.74 307.61 503.94 307.52 503.38 308.68 504.31 309.46 504.69 309.9 503.85 310.3 503.71 311.21 503.52 311.57 502.3 311.48 502.23 312.49 502.64 313.21 502.33 314.02 501.93 313.89 501.3 314.18 500.85 313.7 498.59 313.8 498.32 308.89 497.96 303.33 Z"
          data-name="Mississippi"
          data-stusps="AR"
          id="5093"
        />
        <path
          className="white"
          d="M 583.32 399.53 586.79 399.24 586.78 398.41 590.63 398.07 589.84 399.7 590.1 401.26 589.29 403.04 589.5 403.78 588.37 406.04 583.87 406.44 583.32 399.53 Z"
          data-name="Calhoun"
          data-stusps="FL"
          id="12013"
        />
        <path
          className="white"
          d="M 580.69 391.56 580.85 391.55 583.37 391.28 586.42 390.96 588.28 390.78 588.75 390.74 588.74 391.19 589.17 391.91 590.07 392.93 590.17 393.77 590.55 394.92 591.54 395.97 591.63 396.31 590.63 398.07 586.78 398.41 586.79 399.24 583.32 399.53 582.49 399.59 582.14 395.47 581.25 394.72 579.33 394.88 580.23 392.05 580.69 391.56 Z"
          data-name="Jackson"
          data-stusps="FL"
          id="12063"
        />
        <path
          className="white"
          d="M 629.81 440.6 633.31 440.2 633.38 440.73 633.76 443.88 635.18 445.07 635.45 446.44 635.15 446.85 634.61 447.62 634.67 448.52 634.27 449.18 633.54 450.71 633.09 450.99 632.86 449.76 632.62 448.77 631.76 447.7 630.68 446.61 630.6 445.03 630.65 443.45 630.65 443.43 630.09 441.91 629.81 440.6 Z"
          data-name="Pinellas"
          data-stusps="FL"
          id="12103"
        />
        <path
          className="white"
          d="M 54.99 50.85 56.06 51.29 57.12 51.12 57.84 51.01 58.46 51.33 59.55 52.82 59.89 53.55 60.5 54.22 60.65 55.74 60.83 56.93 60.53 57.84 60.57 58.8 60.42 59.1 60.04 59.83 60.14 60.93 59.87 61.48 59.53 61.52 57.7 60.84 56.77 59.28 52.47 57.67 54.99 50.85 Z"
          data-name="Columbia"
          data-stusps="OR"
          id="41009"
        />
        <path
          className="white"
          d="M 647.01 416.41 650.8 414.86 650.95 414.49 651.17 414.44 651.56 417.07 656.01 416.41 655.56 413.66 656.4 413.24 657.64 415.39 659.38 418.26 660.57 419.73 663.05 423.07 664.26 424.54 660.22 425.08 660.71 428.45 660.33 428.5 658.76 426.05 658.49 424.85 656.65 425.67 655.79 424.82 654.2 424.99 653.31 424.23 653.27 422.2 650.53 420.35 649.86 418.91 648.44 418.58 647.77 417.24 647.01 416.41 Z"
          data-name="Volusia"
          data-stusps="FL"
          id="12127"
        />
        <path
          className="white"
          d="M 594.13 385.27 595.83 385.15 596.09 388.5 594.42 388.66 593.04 389 589.92 389.25 589.65 385.78 594.13 385.27 Z"
          data-name="Miller"
          data-stusps="GA"
          id="13201"
        />
        <path
          className="white"
          d="M 608.58 363.99 609.81 361.67 610.22 361.63 612.94 363.79 614.04 365.46 613.87 366.5 613.46 366.93 613.04 366.63 609.06 367.2 608.76 364.22 608.58 363.99 Z"
          data-name="Pulaski"
          data-stusps="GA"
          id="13235"
        />
        <path
          className="white"
          d="M 390.3 302.51 393.55 302.56 393.57 300.92 396.85 300.96 398.46 300.98 398.44 302.62 401.44 302.63 401.44 302.73 401.44 306.72 393.5 306.63 392.54 306.56 390.73 305.3 390.26 305.78 390.3 302.51 Z"
          data-name="Payne"
          data-stusps="OK"
          id="40119"
        />
        <path
          className="white"
          d="M 484.79 384.17 485.77 383.89 485.74 383.84 485.78 383.8 485.98 384.52 486.08 384.47 486.07 384.59 486.15 384.59 486.12 384.72 486.2 384.76 486.24 384.88 486.23 384.96 486.12 385.08 486.16 385.13 486.12 385.24 488.52 386.31 488.67 391.26 486.27 391.09 483.69 391.97 483.43 393.74 481.81 394.44 481.82 394.41 480.92 393.68 481.26 393.04 482.19 393.12 483.06 392.52 482.59 391.66 482.61 390.69 482.92 389.76 482.77 388.65 483.19 387.96 484.01 387.7 483.66 386.94 483.54 386.33 484.61 385.84 484.78 384.17 484.79 384.17 Z"
          data-name="Adams"
          data-stusps="MS"
          id="28001"
        />
        <path
          className="white"
          d="M 489.95 376.89 491.52 377.38 494.81 374.47 495.13 377.77 495.34 381.6 495.08 382.71 493.21 382.81 493.35 382.03 490.56 381.49 486.87 381.5 487.01 381.36 487.84 380.52 487.85 379.52 488.8 379.22 489.36 378.51 489.36 378 490.03 377.02 489.95 376.89 Z"
          data-name="Claiborne"
          data-stusps="MS"
          id="28021"
        />
        <path
          className="white"
          d="M 517.26 373.28 523.79 372.85 524.33 380.32 523.8 380.39 517.84 381.19 517.26 373.28 Z"
          data-name="Jasper"
          data-stusps="MS"
          id="28061"
        />
        <path
          className="white"
          d="M 187.48 199.38 188.17 198.88 189.05 199.24 190.74 197.76 190.89 198.99 193.75 201.07 194.33 200.36 196.42 200.68 197.76 199.26 195.36 213.96 192.59 213.47 192.72 212.66 191.28 210.38 190.68 210.12 191.4 208.07 190.93 206.21 190.51 205.57 188.9 205.29 188.37 203.73 187.29 203.53 186.66 201.94 187.44 201.14 187.48 199.38 Z"
          data-name="Wasatch"
          data-stusps="UT"
          id="49051"
        />
        <path
          className="white"
          d="M 692.36 248.7 693.67 247.35 693.78 246.65 696.17 247.33 697.98 246.71 697.88 247.69 699.23 247.68 700.19 248.48 698.06 249.61 698.09 250.69 697.99 250.19 694.94 250.1 693.51 249.4 692.68 248.73 692.36 248.7 Z"
          data-name="New Kent"
          data-stusps="VA"
          id="51127"
        />
        <path
          className="white"
          d="M 51.75 12.64 65.37 18.35 72.28 21.01 73.67 17.35 74.31 17.6 74.46 16.71 75.58 16.62 76.54 16.8 77.03 17.83 76.38 19.41 76.09 20.21 76.35 21.41 76.58 21.45 76.77 22.38 74.55 23.54 72.99 25.37 70.43 25.81 63.49 23.19 62.87 24.79 56.12 22.13 52.39 20.33 52.45 20.1 52.83 17.14 52.66 15.44 52.33 13.81 51.75 12.64 Z"
          data-name="Jefferson"
          data-stusps="WA"
          id="53031"
        />
        <path
          className="white"
          d="M 70.43 25.81 68.73 26.98 71.71 28.1 70.9 30.26 69.23 32.73 69.2 34.04 67.92 34.33 67.71 33.58 67.55 33.6 67.37 33.86 67.1 33.94 66.61 33.97 66.45 34.08 66.26 34.42 65.96 34.49 65.62 34.38 65.4 34.47 65.27 34.74 64.96 34.74 63.63 34.25 59.99 32.91 61.03 29.58 62.87 24.79 63.49 23.19 70.43 25.81 Z"
          data-name="Mason"
          data-stusps="WA"
          id="53045"
        />
        <path
          className="white"
          d="M 147.36 23.07 149.33 23.67 152.21 24.53 151.37 27.36 150.33 30.88 149.05 35.22 147.37 40.74 146.94 42.22 142.02 40.74 142.49 39.12 141.68 38.88 144.59 29.2 143 28.73 143.48 27.12 144.29 27.36 144.81 25.62 145.61 25.85 146.08 24.25 146.92 24.5 147.36 23.07 Z"
          data-name="Pend Oreille"
          data-stusps="WA"
          id="53051"
        />
        <path
          className="white"
          d="M 81.14 7.97 81.79 8.61 82.32 8.74 83.22 8.75 86.71 10.05 94.65 13.03 102.66 15.92 102.76 15.62 104.68 16.29 104.03 16.72 104.93 18.06 104.48 18.82 103.07 18.05 99.92 18.18 98.56 21.18 99.28 21.88 92.19 19.31 84.5 16.53 81.34 15.35 80.58 12.56 79.57 12.27 79.62 12.21 79.75 10.98 80.6 10.18 81.1 9.15 81.14 7.97 Z"
          data-name="Skagit"
          data-stusps="WA"
          id="53057"
        />
        <path
          className="white"
          d="M 137.99 20.22 140.37 20.95 145.19 22.41 147.36 23.07 146.92 24.5 146.08 24.25 145.61 25.85 144.81 25.62 144.29 27.36 143.48 27.12 143 28.73 144.59 29.2 141.68 38.88 142.49 39.12 142.02 40.74 140.77 40.36 139.4 45.08 137.71 43.33 135.99 43.44 135.36 42.81 132.63 42.95 131.77 39.73 131.34 39.64 129.87 40.19 130.22 38.72 129.9 37.47 131.53 37.73 132.19 37.43 132.4 36.09 133.25 35.83 133.52 34.84 134.44 34.16 134.36 32.93 134.84 30.01 135.82 29.29 137.13 27 137.52 24.6 137.09 23.18 137.33 21.3 137.99 20.22 Z"
          data-name="Stevens"
          data-stusps="WA"
          id="53065"
        />
        <path
          className="white"
          d="M 63.63 34.25 64.96 34.74 65.27 34.74 65.4 34.47 65.62 34.38 65.96 34.49 66.26 34.42 66.45 34.08 66.61 33.97 67.1 33.94 67.37 33.86 67.55 33.6 67.71 33.58 67.92 34.33 69.2 34.04 69.61 35.3 70.17 36.4 69.92 38.33 70.7 40.08 71.35 40.92 71.14 41.63 73.26 43.23 73.32 44.57 74.1 44.9 61.91 40.38 62.11 39.84 62.35 39.21 63.55 36.1 63.63 34.25 Z"
          data-name="Thurston"
          data-stusps="WA"
          id="53067"
        />
        <path
          className="white"
          d="M 197.61 188.09 197.98 186.03 198.69 182.18 198.74 181.91 212.32 184.32 212.84 184.4 211.01 195.33 209.96 195.16 203.99 194.16 196.76 192.87 197.61 188.09 Z"
          data-name="Uinta"
          data-stusps="WY"
          id="56041"
        />
        <path
          className="white"
          d="M 111.18 32.87 111.42 31.11 113.26 30.6 114.38 31.57 113.82 32.27 114.14 33.03 116.2 32.42 117.29 32.49 118.28 33.37 119.24 32.33 119.67 32.74 121.25 32.35 122.36 32.89 122.48 34.84 122.99 35.5 122.26 36.43 120.74 35.96 120.2 36.69 118.95 36.9 118.43 38.51 116.92 39.51 116.04 41.31 114.89 41.23 112.78 42.28 112.25 43.89 107.91 42.55 106.92 43.73 105.57 44.2 104.93 46.04 104.09 45.65 104.08 44.9 104.65 43.51 102.74 41.94 102.46 41.66 102.43 41.49 102.46 41.25 102.43 40.84 102.47 40.59 102.46 40.34 102.57 40.08 105.36 36.66 105.64 35.4 108.57 35.66 111.18 32.87 Z"
          data-name="Douglas"
          data-stusps="WA"
          id="53017"
        />
        <path
          className="white"
          d="M 516.48 381.37 517.84 381.19 523.8 380.39 524.26 387.74 521 387.94 516.92 388.18 516.48 381.37 Z"
          data-name="Jones"
          data-stusps="MS"
          id="28067"
        />
        <path
          className="white"
          d="M 632.02 195.34 637.18 194.33 637.74 196.78 637.95 197.72 638.21 198.85 635.57 201.98 633.29 202.39 632.75 199.34 632.02 195.34 Z"
          data-name="Beaver"
          data-stusps="PA"
          id="42007"
        />
        <path
          className="white"
          d="M 395.14 119.12 397.05 119.15 403.85 119.25 403.73 120.44 403.52 121.48 402.94 122.13 402.38 123.04 401.42 123.61 400.34 124.49 400 125.14 400.09 125.61 400.2 125.76 400.91 126.71 401.41 127.8 401.82 128.58 402.28 129.09 403.04 129.14 403.77 129.56 404.31 129.76 404.82 130.31 404.98 130.68 398.06 130.6 397.85 131.16 394.95 131.1 395.03 126.21 395.14 119.12 Z"
          data-name="Roberts"
          data-stusps="SD"
          id="46109"
        />
        <path
          className="white"
          d="M 595.62 215.6 596.05 214.85 598.45 214.63 598.95 214.59 602 214.31 602.13 215.73 602.25 217.16 602.23 217.86 601.81 217.89 602.21 219.4 602.26 220.1 602.03 220.68 595.88 221.23 595.07 216.82 595.68 216.4 595.62 215.6 Z"
          data-name="Franklin"
          data-stusps="OH"
          id="39049"
        />
        <path
          className="white"
          d="M 244.64 372.33 247.48 372.59 250.74 372.9 250.21 378.99 249.88 382.78 250.41 383.88 249.67 384.49 249.54 384.39 248.33 384.16 246.89 382.92 246 381.75 245.38 380.76 245.12 379.63 244.45 378.3 244.21 377.82 243.52 376.96 242.73 376.74 242.43 376.94 241.79 376.2 241 375.53 240.23 374.36 240.51 373.58 240.51 372.49 240.75 371.95 244.64 372.33 Z"
          data-name="El Paso"
          data-stusps="TX"
          id="48141"
        />
        <path
          className="white"
          d="M 364.8 423.25 365.26 422.71 367.34 422.2 367.45 422.29 369.02 422.04 370.76 422.57 370.74 422.85 372.24 422.61 371.8 423.94 372.58 424.98 372.87 425.24 372.87 425.24 373.46 426.07 374.12 426.01 375.22 427.47 375.91 427.49 375.71 428.16 371.09 434.2 370.53 433.97 364.61 431.49 364.8 423.25 Z"
          data-name="Bexar"
          data-stusps="TX"
          id="48029"
        />
        <path
          className="white"
          d="M 149.46 205.04 161.09 207.47 174.28 210.05 174.6 209.17 175.45 209.6 177.02 208.47 178.44 211.05 177.52 213.06 178.12 213.27 180.54 211.42 182.13 210.83 182.93 212.45 182.33 213.38 184.15 213.67 184.88 214.36 184.74 215.19 182.64 215.71 181.9 220.14 181.26 220.87 181.14 221.51 178.57 221.07 176.96 222.08 174.48 221.33 174.93 217.03 172.84 216.64 171.26 216.37 157.15 213.6 151.45 212.43 151.06 212.53 148.02 211.92 149.01 207.16 149.46 205.04 Z"
          data-name="Juab"
          data-stusps="UT"
          id="49023"
        />
        <path
          className="white"
          d="M 435.89 202.26 440.75 202.17 442.25 201.97 442.42 208.53 440.87 208.67 439.23 208.7 436.01 208.76 435.89 202.26 Z"
          data-name="Madison"
          data-stusps="IA"
          id="19121"
        />
        <path
          className="white"
          d="M 473.47 411.5 474.31 410.89 474.93 409.91 475.92 410.11 476.76 412.56 476.19 413.6 477.42 414.08 476.73 415.64 476.53 416.32 474.85 415.68 474.45 414.67 471.24 414.42 471.8 413.21 473.47 411.5 Z"
          data-name="Lafayette"
          data-stusps="LA"
          id="22055"
        />
        <path
          className="white"
          d="M 633.14 278.11 635.85 277.78 637.61 277.6 640.08 277.31 640.08 277.31 639.3 279.53 639.55 280.49 638.73 281.18 637.48 280.07 636.47 280.38 635.27 281.84 635.36 281.47 633.14 278.11 Z"
          data-name="Alleghany"
          data-stusps="NC"
          id="37005"
        />
        <path
          className="white"
          d="M 226.08 358.83 231.02 359.38 229.39 374.91 227.36 374.7 214.66 373.28 214.6 372.56 214.69 371.74 215.17 367.66 215.94 359.36 220.84 359.92 221.03 358.28 226.08 358.83 Z"
          data-name="Luna"
          data-stusps="NM"
          id="35029"
        />
        <path
          className="white"
          d="M 612.1 298.47 613.29 298.16 617.49 295.33 617.71 295.33 617.78 295.36 617.88 295.31 618.07 295.34 618.23 295.25 618.23 295.1 618.39 295.13 618.49 295.05 618.68 295.06 618.78 294.95 618.93 294.93 619.06 294.82 619.77 294.66 620.38 295.96 621.22 296.31 621.42 296.69 621.48 298.86 623.53 299.79 622.56 300.09 622.19 301.14 621.07 300.67 618.7 302.06 618.2 302.68 615.91 302.17 614.89 303.01 613.95 302.23 614.1 300.17 612.84 299.6 612.1 298.47 Z"
          data-name="Buncombe"
          data-stusps="NC"
          id="37021"
        />
        <path
          className="white"
          d="M 32.02 81.96 34.08 82.7 34.39 82.7 36.62 83.52 39.02 84.55 44.62 86.44 44.25 88.07 47.75 89.31 48.17 88.23 48.87 87.89 50.28 88.32 51.68 89.31 52.36 90.37 54.88 91.48 55.89 91.08 63.02 93.42 63.06 94.25 62.44 96.48 60.38 98.64 59.87 99.59 59.06 99.36 58.09 100.12 57.67 101.94 56.7 103.74 56.77 104.49 56.18 104.53 54.06 105.03 53.29 107.22 44.93 104.4 45.64 102.39 40.61 100.71 40.65 99.34 41.81 96.08 38.95 95.04 39.14 94.5 37.49 93.88 36.41 92.25 36.24 91.07 35.25 90.22 33.58 89.59 31.4 90.53 28.51 89.44 28.97 88.61 30.71 85.13 31.77 82.74 32.02 81.96 Z"
          data-name="Lane"
          data-stusps="OR"
          id="41039"
        />
        <path
          className="white"
          d="M 587.24 323.17 589.58 322.63 590.12 322.57 590.63 322.78 591.67 322.68 592.04 322.36 592.65 324.11 593.63 324 593.81 325.63 591.58 326.04 591.18 325.82 588.72 326.21 588.65 325.63 587.55 325.74 587.6 324.91 587.24 323.17 Z"
          data-name="Pickens"
          data-stusps="GA"
          id="13227"
        />
        <path
          className="white"
          d="M 419.87 398.25 427.51 392.05 429.1 394.88 429.4 396.54 427.87 398.51 423.68 402.61 422.83 401.07 421.62 401.96 420.5 402 419.88 400.51 419.87 398.25 Z"
          data-name="Trinity"
          data-stusps="TX"
          id="48455"
        />
        <path
          className="white"
          d="M 366.6 246.11 374.6 246.37 374.68 246.72 374.54 251.29 374.42 254.55 366.38 254.3 366.24 254.29 366.6 246.11 Z"
          data-name="Russell"
          data-stusps="KS"
          id="20167"
        />
        <path
          className="white"
          d="M 486.72 306.02 489.17 305.98 489.4 304.33 496.5 304.01 496.75 303.41 497.96 303.33 498.32 308.89 486.82 309.34 486.72 306.02 Z"
          data-name="Craighead"
          data-stusps="AR"
          id="5031"
        />
        <path
          className="white"
          d="M 535.95 278.84 538.44 279.45 541.16 278.23 541.2 278.71 542.43 279.72 542 287.93 541.82 287.94 537.38 288.4 536.58 288.49 536.56 282.25 535.39 281.67 535.7 281.28 535.95 278.84 Z"
          data-name="Christian"
          data-stusps="KY"
          id="21047"
        />
        <path
          className="white"
          d="M 377.4 470.02 379.83 469.41 380.78 468.68 385.4 469.07 388.12 468.89 387.91 469.7 387.53 472.96 387.69 476.23 388.39 479.68 388.96 481.59 379.29 481.5 377.69 481.22 377.22 481.13 377.27 478.04 377.4 470.02 Z"
          data-name="Kenedy"
          data-stusps="TX"
          id="48261"
        />
        <path
          className="white"
          d="M 282.12 87.25 283.74 87.47 283.53 89.12 285.16 89.33 285.37 87.67 290.83 88.36 291.87 88.49 291.4 92.32 293.05 92.52 292.91 93.61 294.55 93.8 294.96 94.95 300.42 95.59 300.31 96.13 300.01 98.88 298.32 99.24 298.22 100.06 296.6 99.87 296.5 100.69 294.87 100.49 294.81 101.04 291.51 100.63 291.58 100.09 288.86 99.74 288.38 99.13 288.51 98.04 287.42 97.91 287.08 96.21 287.29 94.57 284.6 93.68 281.33 93.27 282.12 87.25 Z"
          data-name="Prairie"
          data-stusps="MT"
          id="30079"
        />
        <path
          className="white"
          d="M 637.76 316.22 646.39 315.49 646.22 316.61 646.61 317.12 648.56 318.39 647.99 320.57 643.89 322.25 642.53 322.33 642.7 323.19 640.34 322.28 639.86 321.81 637.96 317.69 637.8 317.03 637.76 316.22 Z"
          data-name="Fairfield"
          data-stusps="SC"
          id="45039"
        />
        <path
          className="white"
          d="M 241.49 139.07 255.13 141.17 260.46 141.94 260.68 142.19 260 148.56 259.23 154.5 253.43 153.67 252.6 153.55 252.99 150.83 251.34 150.6 251.58 148.96 248.3 148.47 248.54 146.87 245.57 146.42 245.51 145.85 243.82 145.62 243.98 144.56 242.35 144.31 242.64 142.65 241.8 142.52 242.04 140.87 241.22 140.74 241.49 139.07 Z"
          data-name="Washakie"
          data-stusps="WY"
          id="56043"
        />
        <path
          className="white"
          d="M 348.21 68.05 348.32 66.41 356.45 66.94 356.35 68.58 357.97 68.68 357.78 71.94 357.9 78.52 358.21 81.82 353.31 81.53 348.44 81.2 348.1 77.9 348.55 71.35 348.09 69.68 348.21 68.05 Z"
          data-name="McHenry"
          data-stusps="ND"
          id="38049"
        />
        <path
          className="white"
          d="M 176.96 222.08 178.57 221.07 181.14 221.51 181.26 220.87 181.9 220.14 182.64 215.71 184.74 215.19 184.88 214.36 184.15 213.67 189.9 214.7 189.54 216.75 188.74 221.22 187.82 221.93 186.55 229.3 178.39 227.84 176.06 227.17 176.96 222.08 Z"
          data-name="Sanpete"
          data-stusps="UT"
          id="49039"
        />
        <path
          className="white"
          d="M 166.04 242.89 166.56 242.94 173.92 244.35 175.55 244.53 178.66 245.1 192.81 247.47 204.15 249.27 202.81 249.88 201.47 251.81 200.6 251.55 199.44 252.51 199.09 253.5 196.21 253.29 195.56 255.14 194.45 256.42 194.06 257.4 193.1 257.48 191.55 259.11 182.45 257.63 173.5 256.18 165.4 254.6 160.85 253.75 161.68 248.78 163.34 249.1 163.5 247.45 165.3 247.78 166.04 242.89 Z"
          data-name="Garfield"
          data-stusps="UT"
          id="49017"
        />
        <path
          className="white"
          d="M 645.64 306.72 646.75 307.82 646.84 309.98 650.54 309.53 652.02 311.49 653.55 313 651.48 314.38 652 315.39 648.73 316.36 648.51 315.23 646.61 317.12 646.22 316.61 646.39 315.49 645.84 313.86 646.22 312.56 645.71 310.85 645.27 310.28 645.68 309.69 645.35 307.74 644.4 305.47 644.46 305.53 645.64 306.72 Z"
          data-name="Lancaster"
          data-stusps="SC"
          id="45057"
        />
        <path
          className="white"
          d="M 614.83 254.45 616.48 253.61 617.99 255.71 618.87 258.53 620.27 259.42 621.21 258.55 623.18 258.67 623.38 259.2 622.71 260.89 622.24 261.39 621.66 261.77 621.05 261.36 619.58 261.45 618.28 260.67 616.85 259.76 615.71 259.29 615.17 258.22 615.02 257.92 614.28 257.27 613.74 256.56 613.6 256.19 614.83 254.45 Z"
          data-name="Mingo"
          data-stusps="WV"
          id="54059"
        />
        <path
          className="white"
          d="M 242.51 101.41 244.4 101.73 249.29 102.51 249.6 100.58 250.78 100.23 254.57 100.83 255.01 99.5 256.26 98.57 258.16 98.87 258.46 96.98 258.98 97.33 260.24 100.02 261.66 103.56 260.69 106 258.56 105.67 258.4 106.76 256.77 106.51 256.69 107.06 255.52 107.43 253.27 107.63 252.93 109.81 251.87 114.73 250.24 114.48 250.15 115.02 248.53 114.77 248.44 115.31 244.1 114.55 243.57 113.34 242.31 112.57 242.84 110.98 241.95 111.37 241.36 109.89 242.26 104.71 242.51 101.41 Z"
          data-name="Yellowstone"
          data-stusps="MT"
          id="30111"
        />
        <path
          className="white"
          d="M 484.75 239.99 489.44 239.81 489.98 243.48 489.7 244.56 489.89 245.01 491.07 247.94 492.04 247.68 492.3 247.81 492.05 247.82 491.63 248.81 490.86 249.6 490.27 249.56 489.32 248.76 489.24 248.49 488.97 247.58 488.35 246.3 488.78 245.4 488.33 244.48 488.03 243.11 487.9 242.52 486.2 241.03 484.75 239.99 Z"
          data-name="Calhoun"
          data-stusps="IL"
          id="17013"
        />
        <path
          className="white"
          d="M 287.48 326.74 290.75 327.01 290.28 332.68 294.65 333.01 301.14 333.5 300.89 337.06 300.85 337.69 300.45 342.48 300.03 347.25 300.03 347.25 292.83 346.73 292.96 345.1 289.68 344.87 289.94 341.8 287.97 341.65 288.36 336.71 286.73 336.57 287.48 326.74 Z"
          data-name="Roosevelt"
          data-stusps="NM"
          id="35041"
        />
        <path
          className="white"
          d="M 404.41 448.21 405.35 443.47 405.34 442.86 405.6 437.48 411.27 434.05 412.77 432.5 413.23 434.79 414.48 435.56 414.49 437.34 415.97 437.44 417.82 439.99 418.82 440.08 417.48 440.86 415.91 441.78 413.79 443.08 410.68 444.51 407.47 446.11 405.24 447.58 404.41 448.21 Z"
          data-name="Matagorda"
          data-stusps="TX"
          id="48321"
        />
        <path
          className="white"
          d="M 661 201.73 660.95 200.99 661.23 200.04 664.04 201.1 664.01 199.97 666.35 200.67 666.59 199.53 667.18 200.85 668.88 201.67 668.14 203.37 668.62 203.82 667.81 208.57 667.01 210.76 662 211.75 660.76 211.99 661.13 209.95 660.18 205.55 661 201.73 Z"
          data-name="Bedford"
          data-stusps="PA"
          id="42009"
        />
        <path
          className="white"
          d="M 194.27 49.33 203.9 51.56 204.62 48.31 209.46 49.5 211.71 50.76 211.54 51.59 213.96 52.13 213.79 52.94 215.41 53.29 214.89 55.72 218.1 56.39 217.76 58.02 217.2 60.73 209.97 59.26 210.2 58.17 209.4 57.99 209.58 57.18 207.95 56.82 208.13 56 197.66 53.65 195.13 52.29 195.46 51.08 194.27 49.33 Z"
          data-name="Pondera"
          data-stusps="MT"
          id="30073"
        />
        <path
          className="white"
          d="M 510.3 365.95 510.37 367.02 516.85 366.65 517.26 373.28 511.2 373.63 510.75 373.69 510.61 371.23 509.5 366.89 509.69 366.51 510.3 365.95 Z"
          data-name="Scott"
          data-stusps="MS"
          id="28123"
        />
        <path
          className="white"
          d="M 579.16 364.82 580.82 364.64 580.66 363.56 585.04 363.03 585.9 362.23 585.93 362.29 586.5 363.46 586.47 364.68 586.47 364.98 586.12 365.52 587.02 366.01 588.13 366.71 587.74 367.37 587.6 367.61 586.58 368.36 585.7 369.39 585.98 370.29 585.96 370.77 583.81 371 582.48 369.49 580.03 369.75 579.75 369.78 579.49 368.13 579.16 364.82 Z"
          data-name="Russell"
          data-stusps="AL"
          id="1113"
        />
        <path
          className="white"
          d="M 599.06 352.75 600.16 352.64 599.78 347.5 602.96 347.24 603.32 347.52 603.52 348.42 605.18 350.13 605.59 351.61 605.22 351.69 603.34 353.56 602.93 353.92 601.88 354.03 601.4 354.08 599.22 354.32 599.06 352.75 Z"
          data-name="Monroe"
          data-stusps="GA"
          id="13207"
        />
        <path
          className="white"
          d="M 584.33 172.52 585.97 172.21 587.59 171.91 589.15 171.62 589.87 171.48 590.82 171.32 593.78 170.79 593.78 170.79 593.32 172.76 592.98 172.97 592.48 173.27 591.09 174.3 591.08 174.38 590.99 175.45 590.9 176.55 591.15 178.17 590.52 178.96 590.44 179.34 589.03 178.46 585.47 179.07 585.19 177.4 584.92 175.75 584.63 174.13 584.33 172.52 Z"
          data-name="Wayne"
          data-stusps="MI"
          id="26163"
        />
        <path
          className="white"
          d="M 488.65 397.79 490.53 397.71 494.31 397.53 493.76 398.64 494.09 399.63 493.9 399.93 494.2 400.4 494.18 402.81 487.61 403.36 486.95 404.43 486.75 404.35 486.54 403.51 487.84 401.1 488 400.04 488.65 397.79 Z"
          data-name="East Feliciana"
          data-stusps="LA"
          id="22037"
        />
        <path
          className="white"
          d="M 378.39 223.62 384.84 223.78 384.89 223.78 384.73 230.31 383.14 230.28 381.06 230.22 378.2 230.15 378.39 223.62 Z"
          data-name="Nuckolls"
          data-stusps="NE"
          id="31129"
        />
        <path
          className="white"
          d="M 718.91 186.09 719.21 185.12 720.32 183.71 720.67 183.28 719.37 182.03 720.1 181.25 720.42 181.21 721.59 180.77 722.37 180.48 722.62 180.75 723.88 180.41 723.85 181.11 723.45 181.48 723.5 182.33 723.66 183.05 724.28 183.22 724.13 183.36 723.69 184.89 723.3 185.57 722.65 187.04 721.45 187.87 719.11 187.02 718.91 186.09 Z"
          data-name="Middlesex"
          data-stusps="NJ"
          id="34023"
        />
        <path
          className="white"
          d="M 668.37 310.3 669.96 307.22 669.49 306.04 671.96 305.71 673.96 303.04 675.66 303.71 676.49 304.9 678.49 307.42 678.17 311.48 676.87 312.52 675.58 315.56 675.58 315.55 670.26 311.64 668.58 310.45 668.37 310.3 Z"
          data-name="Robeson"
          data-stusps="NC"
          id="37155"
        />
        <path
          className="white"
          d="M 623.47 194.19 624.68 193.98 624.42 192.59 624.19 191.23 631.08 190.02 631.1 190.18 631.57 192.77 631.83 194.3 631.86 194.42 627.53 195.17 626.38 194.81 626.47 195.36 623.74 195.82 623.47 194.19 Z"
          data-name="Mahoning"
          data-stusps="OH"
          id="39099"
        />
        <path
          className="white"
          d="M 610.31 311.73 610.31 311.73 611.8 311.03 613.45 310.26 612.91 311.63 613.66 312.56 614.19 316.21 614.93 316.42 615.43 318.32 613.59 321.07 613.43 321.47 613.37 321.49 612.49 321.2 612.45 321.17 611.63 320.58 611.53 320.48 610.59 319.62 609.5 319.34 608.53 318.79 607.49 318.21 607.46 318.13 607.24 317.57 607.15 317.36 607.6 316.71 607.47 316.15 607.99 315.44 608.42 314.8 609.15 314.11 609.99 313.23 610.17 312.62 610.31 311.73 Z"
          data-name="Oconee"
          data-stusps="SC"
          id="45073"
        />
        <path
          className="white"
          d="M 444.42 396.12 449.16 395.71 449.41 395.57 450.19 395.51 450.47 395.49 450.41 396.55 450.58 398 450.47 398.81 450.31 399.59 450.64 400.38 450.27 401.27 450.21 401.42 450.06 402.67 449.3 403.89 449.13 404.99 448.25 406.04 448.28 406.65 447.57 407.56 447.89 408.27 448.04 409.7 447.47 410.22 447.36 410.33 447.14 411.59 448.02 412.59 447.97 413.19 444.87 413.27 445.22 400.06 444.42 396.12 Z"
          data-name="Newton"
          data-stusps="TX"
          id="48351"
        />
        <path
          className="white"
          d="M 601.77 360.3 601.83 360.14 605.27 356.63 606.32 356.53 606.34 359.79 604.48 361.02 601.65 360.61 601.77 360.3 Z"
          data-name="Peach"
          data-stusps="GA"
          id="13225"
        />
        <path
          className="white"
          d="M 593.85 381.95 595.85 381.64 596.89 381.24 597.21 381.55 600.75 381.19 601.89 380.99 601.09 382.69 598.92 383.88 598.1 386 597.08 386.7 596.65 388.45 596.09 388.5 595.83 385.15 594.13 385.27 594.21 383.86 593.85 381.95 Z"
          data-name="Baker"
          data-stusps="GA"
          id="13007"
        />
        <path
          className="white"
          d="M 521.64 137.97 521.78 137.7 521.91 137.5 526.77 137.03 526.5 137.9 525.98 138.81 525.53 141.24 525.19 143.8 522.18 144.1 521.64 137.97 Z"
          data-name="Kewaunee"
          data-stusps="WI"
          id="55061"
        />
        <path
          className="white"
          d="M 557.1 193.58 563.6 192.73 564.24 197.66 562.6 197.86 559.34 198.22 557.65 197.87 557.51 196.81 557.31 195.2 557.1 193.58 Z"
          data-name="Noble"
          data-stusps="IN"
          id="18113"
        />
        <path
          className="white"
          d="M 244.1 114.55 248.44 115.31 248.53 114.77 250.15 115.02 250.24 114.48 251.87 114.73 252.93 109.81 253.27 107.63 255.52 107.43 256.69 107.06 256.77 106.51 258.4 106.76 258.56 105.67 260.69 106 261.82 106.17 261.58 107.79 264.84 108.26 264.72 109.08 266.35 109.31 266.23 110.12 267.71 110.33 267.61 111.05 268.43 111.17 267.84 111.92 267.57 113.87 269.99 114.35 268.61 120.35 268.17 123.6 274.66 124.47 274.84 124.74 274.41 127.99 266.09 126.83 259.94 125.86 252.48 124.75 251.34 124.58 247.99 124.08 247.87 123.92 248.67 122.39 250.63 120.27 242.64 119.06 243.04 116.6 243.52 115.05 244.1 114.55 Z"
          data-name="Big Horn"
          data-stusps="MT"
          id="30003"
        />
        <path
          className="white"
          d="M 630.55 324.37 631.07 322.42 632.67 320.95 633.21 319.61 633.68 319.11 634.4 317.44 636.24 318.89 637.96 317.69 639.86 321.81 640.34 322.28 640.11 323.12 638.74 324.63 639.58 325.64 638.34 325.72 637.87 325.84 636.75 325.5 633.95 324.2 631.94 324.64 631.9 325.49 631.45 325.34 630.55 324.37 Z"
          data-name="Newberry"
          data-stusps="SC"
          id="45071"
        />
        <path
          className="white"
          d="M 128.97 65.68 130.77 64.8 132.49 65.75 134.35 65.73 134.94 67.62 136.23 69.39 136.12 71.03 135.84 71.98 133.23 71.81 131.84 76.68 131.05 76.46 130.39 78.78 128.79 78.3 130.5 71.92 129.68 71.7 129.6 68.97 127.98 68.51 128.97 65.68 Z"
          data-name="Garfield"
          data-stusps="WA"
          id="53023"
        />
        <path
          className="white"
          d="M 600.78 280.99 601.16 280.94 601.87 280.45 604.05 279.39 605.53 278.88 605.72 277.84 606.17 276.73 607.14 276.66 608.83 275.76 608.96 275.45 609.65 276.31 610.92 277.05 610.31 278.41 608.57 279.76 608.22 281.36 603.76 281.9 600.78 282.27 597.68 282.65 598.53 281.9 599.78 281.12 600.78 280.99 Z"
          data-name="Lee"
          data-stusps="VA"
          id="51105"
        />
        <path
          className="white"
          d="M 197.66 53.65 208.13 56 207.95 56.82 209.58 57.18 209.4 57.99 210.2 58.17 209.97 59.26 217.2 60.73 216.08 66.14 212.83 65.47 212.49 67.09 209.24 66.4 208.75 68.47 207.28 67.85 204.32 67.41 203.97 66.62 202.9 66.19 202.81 65.16 201.48 63.92 198.34 64.26 197.51 63.47 197.06 62.08 197.63 59.63 197.28 57.04 198.7 56.94 197.66 53.65 Z"
          data-name="Teton"
          data-stusps="MT"
          id="30099"
        />
        <path
          className="white"
          d="M 629.61 408.75 629.91 408.75 631.5 406.4 631.8 406.28 633.37 406.52 635.97 407.75 638.3 407.61 639.86 409.69 639.97 409.97 640.42 414.38 640.49 414.94 638.14 415.6 637.8 414.45 634.56 414.81 632.07 415.2 631.93 414.11 630.23 413.78 629.61 408.75 Z"
          data-name="Alachua"
          data-stusps="FL"
          id="12001"
        />
        <path
          className="white"
          d="M 562.46 284.41 565.33 281.95 565.82 281.8 567.75 281.76 568.03 282 569.41 283.51 570.11 283.39 569.8 284.24 570.87 285.51 570.09 285.65 566.38 285.95 565.51 286.01 564.21 286.11 562.66 286.18 562.99 285.72 562.46 284.41 Z"
          data-name="Monroe"
          data-stusps="KY"
          id="21171"
        />
        <path
          className="white"
          d="M 488.43 428.57 488.93 428.31 489.26 427.48 488.5 427.01 488.22 425.31 489.69 423.85 491.25 423.47 492.42 421.76 494.49 421.64 495.59 420.48 497.36 422.48 497.71 422.84 498.84 423.66 502.93 427.86 502.62 430.25 502.78 433.65 502.24 433.72 501.48 433.7 498.78 433.84 497.21 434.24 496.15 434.25 495.22 434.03 495.02 433.12 493.92 432.08 492.95 431.99 491.39 431.71 490.32 431.18 488.31 430.71 487.35 429.78 488.28 429.17 488.44 428.57 488.43 428.57 Z"
          data-name="Terrebonne"
          data-stusps="LA"
          id="22109"
        />
        <path
          className="white"
          d="M 566.12 148.65 569.38 148.23 572.06 147.62 572.74 152.45 572.94 154.08 570.25 154.77 567 155.22 566.12 148.65 Z"
          data-name="Midland"
          data-stusps="MI"
          id="26111"
        />
        <path
          className="white"
          d="M 543.92 133.14 545.81 132.91 547.45 132.78 548.02 137.69 542.38 138.28 542.49 137.34 541.86 135.87 541.82 134.9 542.93 134.21 543.86 133.85 543.92 133.14 Z"
          data-name="Benzie"
          data-stusps="MI"
          id="26019"
        />
        <path
          className="white"
          d="M 465.72 415.61 467.19 415.28 469.04 416.32 471.24 414.42 474.45 414.67 474.85 415.68 476.53 416.32 476.15 417.58 476.59 420.45 476.45 423.97 475.54 424.97 475.18 424.83 473.64 424.96 472.13 425.8 470.96 425.98 469.54 425.72 468.48 425.5 466.93 425.24 466.13 425.05 465.9 416.62 463.92 416.69 465.53 416 465.72 415.61 Z"
          data-name="Vermilion"
          data-stusps="LA"
          id="22113"
        />
        <path
          className="white"
          d="M 258.16 212.77 258.58 214.08 260.42 213.69 260.94 214.99 262.25 214.94 263.96 215.79 267.11 215.21 267.91 215.78 268.8 214.92 269.16 213.48 269.71 213.36 270.37 213.66 270.14 214.64 272.13 217.93 271.87 222.13 270.89 223.82 271.12 224.07 270.68 224.8 270.74 225.56 269.97 226.37 267.76 226.28 267.01 228.05 265.7 228.14 264.93 225.77 262.73 223.44 260.11 222.94 257.33 222.6 257.35 221.13 258.21 214.75 257.92 214.63 258.16 212.77 Z"
          data-name="Grand"
          data-stusps="CO"
          id="8049"
        />
        <path
          className="white"
          d="M 385.11 112.38 394.57 112.6 394.84 112.79 394.74 117.96 395.14 119.12 391.02 119.05 387.94 118.98 385.3 118.9 384.91 118.89 385.11 112.38 Z"
          data-name="Sargent"
          data-stusps="ND"
          id="38081"
        />
        <path
          className="white"
          d="M 601.89 380.99 602.25 380.9 604.21 380.66 604.4 382.73 604.8 386.93 604.65 387.15 604.87 387.61 603.02 387.79 598.79 388.22 596.65 388.45 597.08 386.7 598.1 386 598.92 383.88 601.09 382.69 601.89 380.99 Z"
          data-name="Mitchell"
          data-stusps="GA"
          id="13205"
        />
        <path
          className="white"
          d="M 359.63 60.21 362.96 60.4 367.75 60.64 367.5 65.91 367.91 65.93 367.75 69.19 359.61 68.76 359.79 65.5 359.33 65.47 359.63 60.21 Z"
          data-name="Rolette"
          data-stusps="ND"
          id="38079"
        />
        <path
          className="white"
          d="M 718.16 116.97 718.89 116.67 719.53 117.25 719.48 117.62 719.32 118.76 719.26 119.61 719.43 120.77 720 121.23 720.62 119.88 721.32 120.52 722.28 121.25 723.05 124.52 723.28 125.45 724.57 130.74 724.6 130.85 725.01 132.49 722.76 132.82 720.02 133.94 720.21 131.54 718.66 126.93 717.08 123.49 717.12 122.06 718.19 119.93 718.16 116.97 Z"
          data-name="Washington"
          data-stusps="NY"
          id="36115"
        />
        <path
          className="white"
          d="M 377.69 481.22 379.29 481.5 388.96 481.59 389.51 483.41 389.94 485.14 387.25 485.12 386.21 486.71 385.2 486.93 379.22 486.18 379.24 484.58 376.85 484.25 377.69 481.22 Z"
          data-name="Willacy"
          data-stusps="TX"
          id="48489"
        />
        <path
          className="white"
          d="M 322.59 243.82 330.91 244.34 330.32 252.49 329.1 252.42 322.05 252 322.49 245.44 322.59 243.82 Z"
          data-name="Wallace"
          data-stusps="KS"
          id="20199"
        />
        <path
          className="white"
          d="M 580.9 284.66 585.15 284.28 588.79 283.92 589.08 285 588.89 285.45 587.93 285.61 587.73 286.46 588.44 289.84 587.95 291.21 587.57 292.06 587.02 292.34 584.84 291.33 582.59 288.9 583.17 288.36 581.78 286.05 580.79 284.67 580.79 284.67 580.9 284.66 Z"
          data-name="Scott"
          data-stusps="TN"
          id="47151"
        />
        <path
          className="white"
          d="M 432.83 213.65 439.33 213.58 439.44 219.63 438.36 219.68 436.34 219.73 435.22 219.76 432.92 219.81 432.83 213.65 Z"
          data-name="Ringgold"
          data-stusps="IA"
          id="19159"
        />
        <path
          className="white"
          d="M 406.34 61.71 411.66 61.73 419.5 61.74 419.76 61.73 420.01 63.51 420.82 63.93 422.6 63.18 422.66 67.08 419.52 67.1 419.54 70.35 416.3 70.39 406.5 70.27 406.31 67.02 406.34 61.71 Z"
          data-name="Roseau"
          data-stusps="MN"
          id="27135"
        />
        <path
          className="white"
          d="M 251.41 221.98 256.88 222.64 257.31 222.72 257.33 222.6 260.11 222.94 260.47 225.99 263.21 228.82 261.74 231.9 262.21 233.59 261.02 234.02 258.96 233.54 257.75 233.39 248.93 232.24 250.25 221.83 251.41 221.98 Z"
          data-name="Eagle"
          data-stusps="CO"
          id="8037"
        />
        <path
          className="white"
          d="M 302.98 308.7 316.47 309.53 316.46 309.68 315.86 317.87 302.36 316.95 302.98 308.7 Z"
          data-name="Oldham"
          data-stusps="TX"
          id="48359"
        />
        <path
          className="white"
          d="M 573.2 305.28 575.33 302.12 575.41 301.26 580.41 300.65 580.61 300.75 578.07 304.67 577.64 306.25 577.94 306.85 577.65 307.13 577.37 306.96 576.69 308.96 573.67 306.66 573.07 305.79 573.2 305.28 Z"
          data-name="Bledsoe"
          data-stusps="TN"
          id="47007"
        />
        <path
          className="white"
          d="M 538.57 213.88 543.22 213.42 544.31 213.31 544.57 215.75 544.98 219.84 539.26 220.41 538.98 217.56 538.76 215.51 538.57 213.88 Z"
          data-name="Tippecanoe"
          data-stusps="IN"
          id="18157"
        />
        <path
          className="white"
          d="M 579.8 255.87 579.99 255.52 582.91 253.74 583.67 254.21 583.47 255.52 584.96 256.18 585.13 257.07 584.42 259.47 584.61 259.57 583.99 260.54 583.25 260.6 582.37 258.92 580.93 258.39 580.56 258.26 579.53 258.06 579.8 255.87 Z"
          data-name="Fayette"
          data-stusps="KY"
          id="21067"
        />
        <path
          className="white"
          d="M 254.88 75.51 258.06 75.75 259.71 76.6 259.61 78.83 259.46 79.75 258.62 80.53 258.25 82.47 258.19 86.8 258.61 87.36 257.53 89.53 258.06 90.1 258.41 90.45 258.62 92.01 248.23 90.48 248.77 88.88 249.61 83.99 247.97 83.71 248.74 80.53 250.37 80.8 250.49 80.12 254.03 80.54 254.88 75.51 Z"
          data-name="Petroleum"
          data-stusps="MT"
          id="30069"
        />
        <path
          className="white"
          d="M 777.2 89.72 776.78 84.64 776.13 82.56 775.18 81.91 775.23 80.79 775.12 80.48 776.24 80.57 776.53 79.18 777.24 79.3 777.39 78.46 778.49 77.83 779.52 77.22 779.13 76.55 778.23 75.03 777.3 73.43 778.84 72.51 777.97 71.01 779.52 70.08 778.25 67.98 781.31 66.19 784.34 71.35 782.83 72.27 786.42 78.37 788.29 81.19 788.66 81.4 788.33 81.95 787.84 82.07 787.77 83.35 786.81 82.99 786.36 82.68 785.6 83.24 786.12 84.01 786.02 84.5 785.79 85.43 786.81 85.93 784.97 86.41 785.12 87.15 785.51 88.91 784 89.27 783.24 89.89 782.92 90.22 782.43 89.55 780.2 90.66 778.12 89.42 777.2 89.72 Z"
          data-name="Hancock"
          data-stusps="ME"
          id="23009"
        />
        <path
          className="white"
          d="M 407.89 122.57 414.4 122.58 414.56 129.11 409.67 129.11 408.02 129.09 407.88 125.84 407.89 122.57 Z"
          data-name="Stevens"
          data-stusps="MN"
          id="27149"
        />
        <path
          className="white"
          d="M 353.11 175.72 354.24 176.65 360.21 178.23 360.15 183.8 359.88 190.34 359.53 190.33 352.81 190.01 352.93 183.47 353.26 176.95 353.11 175.72 Z"
          data-name="Brown"
          data-stusps="NE"
          id="31017"
        />
        <path
          className="white"
          d="M 386.53 337.51 386.6 333.43 389.86 333.48 389.83 335.93 394.7 336 394.84 336.82 396.33 336.83 396.29 339.83 395.75 339.82 395.71 341.73 386.48 341.59 386.47 341.15 386.53 337.51 Z"
          data-name="Carter"
          data-stusps="OK"
          id="40019"
        />
        <path
          className="white"
          d="M 640.34 322.28 642.7 323.19 642.53 322.33 643.89 322.25 647.99 320.57 647.55 322.32 650.63 323.81 651.79 323.28 651.52 323.61 652.21 324.45 652.23 328.01 652.62 328.69 652.92 328.84 652.94 329.75 652.75 330.06 650.09 330.11 647.84 329.42 646.15 328.39 645.19 326.25 643.61 325.11 641.38 324.88 640.11 323.12 640.34 322.28 Z"
          data-name="Richland"
          data-stusps="SC"
          id="45079"
        />
        <path
          className="white"
          d="M 361.19 468.55 363.82 468.64 363.85 467.03 367.35 467.02 368.46 467.34 368.42 468.8 368.91 469.37 369.28 472.76 370.1 472.77 369.92 477.85 360.98 477.61 361.19 468.55 Z"
          data-name="Jim Hogg"
          data-stusps="TX"
          id="48247"
        />
        <path
          className="white"
          d="M 639.28 275.31 639.44 275.15 639.47 274.82 639.64 274.95 639.83 274.74 640.05 274.78 639.93 275.13 639.62 275.67 639.65 276.07 639.43 276.18 639.52 275.81 639.11 275.78 639.04 275.51 639.08 275.25 639.28 275.31 Z"
          data-name="Galax"
          data-stusps="VA"
          id="51640"
        />
        <path
          className="white"
          d="M 186.55 229.3 187.82 221.93 188.74 221.22 189.54 216.75 190.46 219.02 190.92 218.75 191.3 220.61 191.18 221.64 206.65 224.19 206.69 225.22 205.29 227.71 205.48 228.66 204.71 229.29 204.54 230.29 203.39 232.11 204.13 233.13 204.97 233.12 205.38 234.03 204.51 233.33 203.32 233.12 203.29 234.19 202.67 234.42 203.61 237.58 203.12 237.89 203.52 239.42 204.02 239.57 203.49 240.82 204.27 242.03 203.72 242.47 185.1 239.41 184.75 239.15 186.55 229.3 Z"
          data-name="Emery"
          data-stusps="UT"
          id="49015"
        />
        <path
          className="white"
          d="M 618.06 234.93 619.06 234.46 619.72 233.68 619.28 232.6 618.94 231.81 619.73 231.3 620.22 231.6 622.44 232.37 623.23 232.65 623.93 234.23 623.62 234.59 624.02 238.96 624.57 240.03 623.1 241.39 621.94 240.18 621.15 239.36 620.65 239.33 620.22 238.39 618.04 235.97 618.06 234.93 Z"
          data-name="Jackson"
          data-stusps="WV"
          id="54035"
        />
        <path
          className="white"
          d="M 531.13 122.4 532.37 121.71 532.84 122.36 532.15 123.58 531.85 124.71 530.98 123.73 531.13 122.4 Z M 526.77 137.03 521.91 137.5 522.12 137.17 522.05 136.58 522.9 135.09 523.67 134.01 524.33 133.83 524.52 133.58 525.4 133.18 526.02 132.2 526.62 130.63 527.44 129.26 527.62 127.61 528.45 127.41 529.08 126.64 529.16 125.74 529.76 124.99 530.29 124.81 530.82 124.91 530.94 126.1 530.16 126.96 530.24 127.93 530.13 129 529.25 130.37 528.73 131.65 528.61 132.84 527.79 133.93 527.33 135.15 526.77 137.03 Z"
          data-name="Door"
          data-stusps="WI"
          fillRule="evenodd"
          id="55029"
        />
        <path
          className="white"
          d="M 467.22 261.64 472.14 261.41 475.38 261.36 475.48 263.68 475.7 263.88 475.76 265.81 471.86 265.98 470.02 266.82 467.58 266.81 467.53 264.09 467.22 261.64 Z"
          data-name="Maries"
          data-stusps="MO"
          id="29125"
        />
        <path
          className="white"
          d="M 680.68 223.34 682.42 224.09 682.63 224.84 682.82 224.78 683.24 224.82 683.64 225.35 684.02 225.54 684.37 225.32 684.93 225.82 685.07 226.34 685.39 226.19 685.62 226.67 685.97 226.53 686.88 226.74 687.18 226.85 687.82 227.2 688.29 227.83 687.95 227.9 687.52 229.44 687.51 229.71 687.5 230.63 684.54 229.47 684.03 230.28 682.09 227.92 680.96 226.53 680.19 225.49 680.68 223.34 Z M 684.26 225.96 684.61 226.34 684.85 225.89 684.47 225.96 683.98 225.7 683.97 225.85 683.51 227.2 684.25 226.85 684.26 225.96 Z"
          data-name="Prince William"
          data-stusps="VA"
          fillRule="evenodd"
          id="51153"
        />
        <path
          className="white"
          d="M 616.26 274.82 617.82 274.03 617.2 272.87 617.78 272.25 619.71 271.14 621.27 270.81 621.64 269.34 623.19 268.67 623.42 269.21 625.53 271.87 624.76 272.56 623.29 274.03 621.3 274.51 621.07 275.64 617.85 277.82 617.29 276.54 616.26 274.82 Z"
          data-name="Russell"
          data-stusps="VA"
          id="51167"
        />
        <path
          className="white"
          d="M 691.69 184.61 692.62 183.87 692.59 182.25 693.4 180.75 696.19 181.04 696.57 180.73 698.61 182.18 700.82 183.27 700.22 183.97 699.15 184.83 697.86 185.88 697.8 187.2 695.75 188.46 692.04 190.09 690.41 189.29 687.58 187.89 687.69 187.74 689.36 186.47 691.69 184.61 Z"
          data-name="Schuylkill"
          data-stusps="PA"
          id="42107"
        />
        <path
          className="white"
          d="M 735.02 123.7 735.01 123.07 734.96 121.92 734.8 121.62 734.57 121.17 734.43 119.87 734.43 119.86 734.28 118.59 733.85 117.06 734.3 116.28 738.05 116.73 740.18 116.08 739.66 118.12 739.06 118.22 739.23 120.6 741.11 122.79 740.79 123.05 741.05 124.03 739.1 124.55 739.12 123.52 736.43 125.34 735.59 125.52 735.19 125.11 735.02 124.06 735.02 123.7 Z"
          data-name="Sullivan"
          data-stusps="NH"
          id="33019"
        />
        <path
          className="white"
          d="M 385.3 118.9 387.94 118.98 391.02 119.05 395.14 119.12 395.03 126.21 393.21 126.17 393.11 125.62 385.11 125.43 385.3 118.9 Z"
          data-name="Marshall"
          data-stusps="SD"
          id="46091"
        />
        <path
          className="white"
          d="M 519.14 261.75 518.98 259.28 523.9 258.92 524.37 265.44 524.37 265.45 519.42 265.86 519.14 261.75 Z"
          data-name="Hamilton"
          data-stusps="IL"
          id="17065"
        />
        <path
          className="white"
          d="M 607.94 244.59 608.7 245.07 609.22 246.06 609.3 246.84 609.37 247.52 609.84 248.01 609.88 249.3 609.86 249.46 609.35 249.04 606.73 249.85 606.74 247.56 606.03 247.45 606.08 247.07 606.59 246.22 607.94 244.59 Z"
          data-name="Boyd"
          data-stusps="KY"
          id="21019"
        />
        <path
          className="white"
          d="M 606.49 289.56 606.84 289.38 607.62 288.23 609.61 286.18 612.99 284.26 614.05 283.95 614.52 289.13 615.46 289.97 615.45 291.11 615.04 290.68 613.67 291.72 612.9 292.32 612.88 293.09 612.52 293.69 611.77 293.34 611.3 293.66 607.61 290.56 606.46 290.02 606.49 289.56 Z"
          data-name="Greene"
          data-stusps="TN"
          id="47059"
        />
        <path
          className="white"
          d="M 533.31 296.21 535.61 295.99 538.93 296.61 539.25 296.95 539.73 299.97 540.04 300.39 537.55 302.25 537.5 303.52 535.47 304.35 533.73 303.79 534.16 302.06 532.63 301.52 533.95 298.3 533.31 296.21 Z"
          data-name="Humphreys"
          data-stusps="TN"
          id="47085"
        />
        <path
          className="white"
          d="M 529.52 258.37 530.06 257.73 529.53 256.14 529.92 254.52 529.55 252.49 530.18 252.43 534.08 252.15 533.94 252.65 534.09 253.19 533.26 253.87 532.93 254.74 532.81 255.07 532.46 256.01 531.8 257.27 530.73 258.09 529.88 258.76 529.52 258.37 Z"
          data-name="Wabash"
          data-stusps="IL"
          id="17185"
        />
        <path
          className="white"
          d="M 340.54 335.59 342.09 335.67 348.63 335.99 348.57 337.63 347.96 337.33 347.8 337.49 347.47 344.88 340.11 344.57 340.54 335.59 Z"
          data-name="Cottle"
          data-stusps="TX"
          id="48101"
        />
        <path
          className="white"
          d="M 679.57 296.31 679.92 295.25 680.56 294.75 681.46 295.63 682.75 295.56 684.27 294.64 685.43 295.64 686.63 295.79 686.85 296.09 688.11 301.51 687.85 304.72 689.25 304.86 689.31 305.14 687.62 308.46 685.23 306 684.82 305.28 684.81 305.12 682.81 303.38 679.96 301.22 679.25 299.52 679.66 298.84 679.57 296.31 Z"
          data-name="Sampson"
          data-stusps="NC"
          id="37163"
        />
        <path
          className="white"
          d="M 537.91 269.23 538.21 268.87 539.14 268.43 543.36 270.09 544.9 270.23 543.57 271.79 544.23 273.04 542.62 273.85 541.33 273.76 540.83 273.68 539.84 270.52 538.17 270.09 537.91 269.23 Z"
          data-name="McLean"
          data-stusps="KY"
          id="21149"
        />
        <path
          className="white"
          d="M 703.95 224.33 706.36 225.15 707.15 222.94 708.6 222.02 710.86 222.87 710.86 222.88 711.27 224.27 709.79 226.2 709.75 228.81 709.01 230.04 709.3 230.99 708.98 231.01 707.54 231.22 707.93 232.47 708.51 233.65 708.79 234.48 708.1 234.44 707.24 233.87 707.06 232.56 706.19 231.97 704.65 230.85 703.97 230.61 703.93 229.88 703.3 229.2 702.09 227.7 702.76 226.56 702.46 226.08 702.45 225.28 703.15 225.04 703.58 225.01 704.15 224.89 703.95 224.33 Z"
          data-name="Dorchester"
          data-stusps="MD"
          id="24019"
        />
        <path
          className="white"
          d="M 651.79 323.28 651.72 323.11 652.36 323.19 653.74 321.64 653.88 322.71 656.5 322.93 658.23 324.32 659.11 325.02 661.67 322.75 663.35 323.37 663.55 323.62 662.39 324.61 659.21 327.2 658.27 328.19 655.48 329.75 654.4 331.74 652.67 330.3 652.75 330.06 652.94 329.75 652.92 328.84 652.62 328.69 652.23 328.01 652.21 324.45 651.52 323.61 651.79 323.28 Z"
          data-name="Sumter"
          data-stusps="SC"
          id="45085"
        />
        <path
          className="white"
          d="M 281.29 93.54 281.33 93.27 284.6 93.68 287.29 94.57 287.08 96.21 287.42 97.91 288.51 98.04 288.38 99.13 288.86 99.74 291.58 100.09 291.51 100.63 294.81 101.04 294.87 100.49 296.5 100.69 296.6 99.87 298.22 100.06 297.95 102.51 295.7 102.25 295.22 108.76 294.52 108.68 293.76 115.24 293.2 115.18 277.31 113.19 278.18 106.65 278.67 106.72 279.51 100.22 279.96 100.28 281.29 93.54 Z"
          data-name="Custer"
          data-stusps="MT"
          id="30017"
        />
        <path
          className="white"
          d="M 739.95 132.69 741.06 132.41 742.18 132.12 742.36 132.07 742.78 131.96 744.92 131.41 745.35 131.3 746.35 132.59 747.44 132.05 749.17 132.19 749.44 133.78 750.07 133.72 750.13 133.12 751.32 132.95 751.57 133.35 751.41 134.34 751.79 135.51 751.24 135.97 751.22 136.94 752 137.52 752.39 137.08 753.27 136.74 753.37 138.07 753.14 138.09 752.75 138.22 752.27 138.5 753.15 139.82 753.84 139.42 754.38 139.97 754.52 140.45 754.39 141.07 754.63 141.79 754.91 142.71 754.06 143 753.62 143.15 753.4 143.23 750.72 144.14 750.61 143.85 749.42 144.17 747.96 144.57 746.34 145.01 745.86 145.14 745.22 142.92 745.04 142.68 744.28 143.05 743.2 142.75 743.46 141.42 743.57 141.26 743.24 140.13 741.93 139.68 741.61 139.95 741.3 138.91 741.64 136.46 741.08 135.93 741.31 134.46 739.95 132.69 Z"
          data-name="Worcester"
          data-stusps="MA"
          id="25027"
        />
        <path
          className="white"
          d="M 487.65 168.21 488.73 167.98 489.28 168 489.99 168.12 490.94 168.68 492.83 168.92 493.57 167.93 495.78 167.56 496.25 174.11 496.3 174.93 488.16 175.5 487.65 168.21 Z"
          data-name="Iowa"
          data-stusps="WI"
          id="55049"
        />
        <path
          className="white"
          d="M 298.29 187.59 307.43 188.4 307.96 188.46 307.54 193.33 307.36 194.15 297.74 193.29 298.08 189.77 298.29 187.59 Z"
          data-name="Scotts Bluff"
          data-stusps="NE"
          id="31157"
        />
        <path
          className="white"
          d="M 384.94 105.84 389.49 105.97 394.69 106.09 394.57 112.6 385.11 112.38 384.75 112.37 384.94 105.84 Z"
          data-name="Ransom"
          data-stusps="ND"
          id="38073"
        />
        <path
          className="white"
          d="M 24.66 127.68 25.87 128.05 27.08 128.53 28.76 128.99 29.98 129.32 31.36 129.93 34.82 131.09 39.06 132.43 42.03 133.44 42.03 133.44 44.66 134.35 48.24 135.58 50.63 136.42 53.82 137.51 53.4 138.36 52.47 141.67 48.94 152.89 33.89 148.05 33.74 147.35 34.82 144.99 33.76 144.3 32.34 145.29 29.54 146.18 28.49 145.77 26.64 147.11 27.2 149.06 26.69 149.62 25.04 148.85 25.05 147.96 24.03 146.92 22.6 146.51 22.42 145.45 20.85 143.71 21.01 139.59 18.57 138.63 19.8 137.37 19.77 135.81 19.16 134.31 20.78 132.36 20.93 129.97 22.19 129.14 23.38 129.26 24.66 127.68 Z"
          data-name="Siskiyou"
          data-stusps="CA"
          id="6093"
        />
        <path
          className="white"
          d="M 595.33 259.46 596.53 259.38 597.27 258.5 597.48 258.82 599.02 259.19 601.14 260.85 601.46 261.63 598.86 261.58 597.88 263.07 597.43 262.77 595.94 262.42 594.45 261.67 595.33 259.46 Z"
          data-name="Wolfe"
          data-stusps="KY"
          id="21237"
        />
        <path
          className="white"
          d="M 534.65 319.52 536.7 319.36 540.22 319.11 540.51 319.09 546.44 318.67 546.55 318.66 546.64 318.65 546.88 322.1 545.96 322.98 546.26 323.24 545.69 323.44 544.9 322.64 543.62 322.68 542.05 322.2 537.82 324.45 535.95 323.23 535.01 321.82 533.06 321.79 532.14 321.29 531.33 319.97 531.27 319.74 534.41 319.54 534.65 319.52 Z"
          data-name="Lauderdale"
          data-stusps="AL"
          id="1077"
        />
        <path
          className="white"
          d="M 492.38 225.9 494.48 225.17 494.54 224.64 495.64 223.6 496.63 220.9 498.18 219.65 501.16 219.45 501.34 221.64 502.95 221.51 503.23 225.22 502.66 224.64 501.1 225.28 497.9 225.21 497.58 225.86 494.77 227.08 493.46 227.13 492.38 225.9 Z"
          data-name="Mason"
          data-stusps="IL"
          id="17125"
        />
        <path
          className="white"
          d="M 665.45 147.59 666.81 147.3 666.38 145.59 667.95 145.23 669.67 144.84 670.07 144.64 671.33 144.9 673.67 144.34 674.09 147.26 674.66 149.05 669.93 150.19 669.71 150.81 669.63 152.36 669.98 153.84 668.73 154.11 668.24 154.21 667.9 152.45 666.34 152.77 665.78 151.09 665.45 147.59 Z"
          data-name="Ontario"
          data-stusps="NY"
          id="36069"
        />
        <path
          className="white"
          d="M 478.58 179.22 481.84 179.03 481.82 178.5 482.44 178.64 483.97 178.91 484.59 179.23 485.04 180.14 485.53 181.4 485.52 182.09 486.33 182.5 486.69 182.64 487.4 183.27 487.88 183.64 485.37 183.79 485.46 185.43 482.22 185.61 478.98 185.79 478.58 179.22 Z"
          data-name="Dubuque"
          data-stusps="IA"
          id="19061"
        />
        <path
          className="white"
          d="M 366.11 270.65 374.16 270.92 374.26 271.19 374.22 272.64 374.09 277.55 365.89 277.31 366.05 272.38 366.11 270.65 Z"
          data-name="Pratt"
          data-stusps="KS"
          id="20151"
        />
        <path
          className="white"
          d="M 529.21 284.74 531.48 283.74 533.29 282.65 533.59 282.8 535.39 281.67 536.56 282.25 536.58 288.49 534.17 288.76 534.18 288.18 531.7 288.14 530.81 288.19 530.62 287.66 530.09 286.94 529.71 285.83 529.21 284.74 Z"
          data-name="Trigg"
          data-stusps="KY"
          id="21221"
        />
        <path
          className="white"
          d="M 364.1 378.46 370.15 375.18 373.58 381.27 374.49 380.75 374.82 380.59 375.47 381.75 376.27 383.19 371.28 386.04 370.83 385.28 368.01 385.64 364.1 378.46 Z"
          data-name="Comanche"
          data-stusps="TX"
          id="48093"
        />
        <path
          className="white"
          d="M 99.28 21.88 98.56 21.18 99.92 18.18 103.07 18.05 104.48 18.82 105.13 18.93 104.92 20.28 104.27 21.51 105.14 22.57 104.59 23.25 105.46 23.73 105.68 24.66 106.76 26.46 106.31 27.18 107.66 29.25 108.44 29.81 108.78 31.95 111.18 32.87 108.57 35.66 105.64 35.4 105.36 36.66 102.57 40.08 102.46 40.34 102.47 40.59 102.43 40.84 102.46 41.25 102.43 41.49 102.46 41.66 102.74 41.94 104.65 43.51 104.08 44.9 100.34 43.68 99.02 41.72 97.39 40.98 96.15 38.91 94.74 38.29 94.32 36.29 93.55 35.35 93.36 34.33 93.83 32.66 94.71 32.38 94.47 30.92 95.38 30.27 94.48 28.45 95.89 26.91 95.74 25.96 97.67 25.91 99.58 24.75 99.28 21.88 Z"
          data-name="Chelan"
          data-stusps="WA"
          id="53007"
        />
        <path
          className="white"
          d="M 560.65 309.51 560.93 308.72 560.44 305.36 560.33 304.29 560.89 303.95 562.81 304.84 564.39 304.43 565.12 306 566.31 306.82 566.7 309.52 566.19 311.3 564.34 310.45 562.28 310.3 560.74 311 560.36 310.01 560.65 309.51 Z"
          data-name="Coffee"
          data-stusps="TN"
          id="47031"
        />
        <path
          className="white"
          d="M 573.89 325.09 574.15 326 574.83 328.42 575.13 329.49 575.97 332.47 576.19 333.29 576.77 335.45 575.26 335.75 574.75 336.09 574.53 335.82 571.41 335.91 570.24 333.42 569.54 333.39 569.34 331.71 569.25 330.87 570.31 330.49 572.35 327.68 573.21 325.57 573.89 325.09 Z"
          data-name="Cherokee"
          data-stusps="AL"
          id="1019"
        />
        <path
          className="white"
          d="M 67.41 306.07 68.86 307.91 68.81 307.95 70.4 311.5 72.13 312.91 71.17 313.85 70.04 314.97 69.92 315.53 69.79 316.22 68.6 316.27 68.03 317.5 67.46 316.29 66.42 315.66 66.34 315.18 66.26 315.07 65.22 313.54 64.89 313.03 63.63 312.1 62.65 310.9 61.56 309.12 61.2 308.76 61.74 308.02 62.39 307.4 62.55 306.99 63.13 306.72 64.12 306.2 64.47 305.41 65.23 305.55 67.41 306.07 Z"
          data-name="Orange"
          data-stusps="CA"
          id="6059"
        />
        <path
          className="white"
          d="M 607.05 406.28 608 403.19 608.9 402.56 609.45 401.92 615.22 401.28 615.31 402.11 616.98 401.93 617.71 408.99 618.14 410.2 618.7 410.13 618.24 413.19 617.45 413.27 617.43 413.19 616.24 412.78 615.29 412.41 614.41 411.28 613.57 410.04 612.55 408.96 610.63 408.05 608.15 407.13 607.05 406.28 Z"
          data-name="Taylor"
          data-stusps="FL"
          id="12123"
        />
        <path
          className="white"
          d="M 570.4 241.12 570.57 234.24 574.19 233.84 574.35 235.31 574.63 237.6 574.1 238.19 573.62 238.74 573.96 239.1 572.27 239.97 570.95 241.3 570.4 241.12 Z"
          data-name="Dearborn"
          data-stusps="IN"
          id="18029"
        />
        <path
          className="white"
          d="M 632.21 284.76 633.78 283.64 634.17 281.82 635.27 281.84 636.47 280.38 637.48 280.07 638.73 281.18 639.55 280.49 641.29 281.68 641.49 283.4 641.9 286.84 640.44 287.01 639.66 287.39 636.11 288.32 635.2 289.02 633.93 287.87 631.52 287.24 632.66 285.46 632.21 284.76 Z"
          data-name="Wilkes"
          data-stusps="NC"
          id="37193"
        />
        <path
          className="white"
          d="M 465.21 174.97 465.07 171.68 471.62 171.38 472.01 179.6 465.43 179.95 465.21 174.97 Z"
          data-name="Fayette"
          data-stusps="IA"
          id="19065"
        />
        <path
          className="white"
          d="M 668.95 454.69 675.66 453.85 675.53 452.75 677.01 452.57 678.01 454.26 678.4 455.34 678.87 456.04 679.7 457.91 678.72 458.31 671.21 459.23 665.97 459.85 669.16 456.3 668.95 454.69 Z"
          data-name="Martin"
          data-stusps="FL"
          id="12085"
        />
        <path
          className="white"
          d="M 50.58 153.4 62.46 157.06 69.63 159.2 67.87 165.22 67.09 167.97 64.9 175.56 63.81 179.25 62.87 182.47 61.56 186.91 61.25 187.1 59.32 186.57 60.17 185.62 61.15 182.32 60.21 180.53 60.49 179.11 58.73 178 57.55 176.38 57.01 174.73 55.29 173.01 53.71 172.36 50.61 173.99 49.04 172.18 50.15 168.58 46.28 167.41 49.11 158.72 50.58 153.4 Z"
          data-name="Lassen"
          data-stusps="CA"
          id="6035"
        />
        <path
          className="white"
          d="M 362.76 330.38 364.34 330.43 364.31 331.25 367.03 331.33 366.98 332.96 369.53 333.03 369.47 334.94 369.44 336.3 370.25 336.31 370.15 339.64 369.56 339.47 368.89 340.04 368.16 340.06 367.09 339.56 366.07 339.45 365.03 338.6 364.84 338.58 364.06 338.48 363.18 338.59 362.05 338.4 361.15 338.28 360.87 336.4 360.72 336.18 360.53 334.27 361.79 331.29 362.76 330.38 Z"
          data-name="Tillman"
          data-stusps="OK"
          id="40141"
        />
        <path
          className="white"
          d="M 247.74 255.39 248.39 250.15 259.55 251.52 262.07 251.79 262.65 251.2 263.09 251.47 263.21 251.92 265.89 255.23 267.44 257.66 268.45 261.18 269.96 262.69 269.91 262.99 270.54 263.59 269.92 265.43 261.23 264.56 253.03 263.65 253.21 262.01 251.61 261.81 251.7 261.09 249.51 259.96 249.13 259.11 247.31 258.99 247.74 255.39 Z"
          data-name="Saguache"
          data-stusps="CO"
          id="8109"
        />
        <path
          className="white"
          d="M 385.21 317.09 389.01 317.15 390.64 317.17 393.33 317.22 393.22 325.63 390.27 325.01 389.99 322.8 389.19 321.64 387.15 320.18 386.93 318.78 385.19 317.83 385.21 317.09 Z"
          data-name="Cleveland"
          data-stusps="OK"
          id="40027"
        />
        <path
          className="white"
          d="M 52.39 20.33 56.12 22.13 62.87 24.79 61.03 29.58 59.99 32.91 63.63 34.25 63.55 36.1 62.35 39.21 62.11 39.84 59.69 38.92 59.43 38.85 50.22 35.26 50.28 34.93 50.5 32.99 50.12 32.4 50.76 31.19 51.7 28.08 51.73 27.75 52.05 25.46 51.51 23.78 52.39 20.33 Z"
          data-name="Grays Harbor"
          data-stusps="WA"
          id="53027"
        />
        <path
          className="white"
          d="M 723.38 90.87 723.67 90.81 726.12 90.11 730.43 88.75 731.87 88.28 732.07 88.21 732.42 90.29 732.36 92.65 732.94 92.84 732.39 94.46 730.72 93.93 729.93 98.42 728.2 98.1 726.46 97.61 726.83 95.68 724.34 95.25 724.65 94.07 723.38 90.87 Z"
          data-name="Orleans"
          data-stusps="VT"
          id="50019"
        />
        <path
          className="white"
          d="M 83.7 146.71 85.33 147.2 88.25 148.03 91.42 148.95 95.3 149.99 99.59 151.14 99.59 151.14 104.15 152.36 107.67 153.3 110.77 154.11 113.67 154.85 116.08 155.49 116.2 155.52 111.34 174.39 109.63 181.14 106.34 180.32 105 182.32 105.75 179.36 100.81 178.05 101.67 174.77 90.25 171.76 85.24 170.38 85.8 168.4 78.29 166.3 78.07 165.96 79.83 161.13 80.54 157.65 83.7 146.71 Z"
          data-name="Humboldt"
          data-stusps="NV"
          id="32013"
        />
        <path
          className="white"
          d="M 566.4 293.22 569.83 293.14 570.62 291.55 571.91 292.67 575.37 293.89 576.68 293.89 576.99 293.97 576.27 294.8 574.84 294.93 574.82 297.25 574.02 296.34 570.88 295.72 568.92 297.2 566.93 296.37 566.2 295.27 566.02 293.86 566.4 293.22 Z"
          data-name="Putnam"
          data-stusps="TN"
          id="47141"
        />
        <path
          className="white"
          d="M 495.16 331.19 497.9 332.94 498.07 335.99 497.27 336.01 497.45 339.57 497.54 341.21 494.31 341.34 494.15 338.87 489.7 339.07 489.77 338.53 490.44 338.27 490.6 337.82 490.38 337.08 491.22 336.82 491.6 335.98 492.53 335.75 492.29 334.76 492.83 334.33 493.93 334.81 494.18 333.89 495.17 333.25 495 332.43 495.16 331.19 Z"
          data-name="Coahoma"
          data-stusps="MS"
          id="28027"
        />
        <path
          className="white"
          d="M 413.75 297.73 413.75 294.87 413.79 294.47 419.51 294.46 421.07 294.45 421.08 296.09 419.45 296.1 419.42 304.25 417.42 304.26 416.7 302.62 415.06 302.63 414.52 302.62 413.71 302.62 413.71 301.29 413.76 301 413.75 299.09 414.02 297.87 413.75 297.73 Z"
          data-name="Rogers"
          data-stusps="OK"
          id="40131"
        />
        <path
          className="white"
          d="M 757.68 136.36 757.88 135.32 757.56 134.8 758.24 134.51 758.83 134.43 758.95 134.19 758.64 134.01 759.79 132.87 760.28 134.05 760.27 134.08 760.24 134.32 760.16 134.8 760.28 134.94 759.64 135.29 759.64 135.86 759.14 136.24 758.85 137.14 758.46 136.68 757.73 136.39 757.68 136.36 Z"
          data-name="Suffolk"
          data-stusps="MA"
          id="25025"
        />
        <path
          className="white"
          d="M 400.59 417.21 405.95 416.26 408.11 417.07 408.34 416.76 409.34 417.98 408.72 418.66 408.74 421.13 409.91 421.76 410.18 423.17 410.31 425.51 409.26 425.53 408.87 425.12 407.84 424.93 406.47 424.27 405.11 421.25 403.97 421.33 401.98 419.78 401.43 418.76 400.59 417.21 Z"
          data-name="Austin"
          data-stusps="TX"
          id="48015"
        />
        <path
          className="white"
          d="M 424.76 260.82 431.45 260.77 431.49 263.6 431.52 266.93 431.52 267.36 424.64 267.43 424.76 260.82 Z"
          data-name="Linn"
          data-stusps="KS"
          id="20107"
        />
        <path
          className="white"
          d="M 452 169.74 458.46 169.51 458.68 175.25 452.18 175.47 452 169.74 Z"
          data-name="Floyd"
          data-stusps="IA"
          id="19067"
        />
        <path
          className="white"
          d="M 605.08 273.99 606.05 273.54 605.72 271.53 606.42 270.06 606.8 270.45 608.96 268.3 610.26 268.07 611.11 268.77 611.89 268.29 612.99 269.13 610.78 271.07 610.99 272.07 610.65 272.77 609.71 273.23 608.98 273.97 607.81 273.33 604.72 274.89 605.08 273.99 Z"
          data-name="Letcher"
          data-stusps="KY"
          id="21133"
        />
        <path
          className="white"
          d="M 176.38 187.51 180.97 183.32 183.95 183.9 184.98 183.53 185.3 182.26 186.31 182.59 187.87 184.01 189.42 183.13 191.61 183.65 191.94 184.47 192.67 185.06 191.12 187.39 189.74 186.91 188.38 187.77 186.78 186.77 185.63 187.13 185.69 188.09 181.03 186.93 177.01 187.43 176.38 187.51 Z"
          data-name="Weber"
          data-stusps="UT"
          id="49057"
        />
        <path
          className="white"
          d="M 665.97 459.85 671.21 459.23 678.72 458.31 679.7 457.91 680.6 459.96 680.89 460.98 681.01 461.42 681.06 461.61 681.23 463.45 681.31 464.04 681.39 464.66 681.44 465.5 681.39 466.67 681.39 468.28 681.4 470.33 680.97 470.25 679.76 470.4 679.17 470.48 678.35 470.31 677.54 470.55 667.48 471.78 665.97 459.85 Z"
          data-name="Palm Beach"
          data-stusps="FL"
          id="12099"
        />
        <path
          className="white"
          d="M 573.27 225.9 572.86 222.32 577.59 221.69 578.47 227.84 578.53 228.26 573.62 228.9 573.27 225.9 573.27 225.9 Z"
          data-name="Preble"
          data-stusps="OH"
          id="39135"
        />
        <path
          className="white"
          d="M 422.46 219.79 424.37 219.8 426.57 219.82 427.93 219.83 430.62 219.83 430.65 221.69 430.99 221.85 431.15 223.29 431.11 228.18 424.81 228.18 424.48 226 422.81 225.73 422.82 221.65 422.46 219.79 Z"
          data-name="Nodaway"
          data-stusps="MO"
          id="29147"
        />
        <path
          className="white"
          d="M 584.02 222.15 585.69 222.05 587.41 222.7 590.12 222.8 590.18 223.87 590.36 227.04 585.84 227.29 583.82 227.39 583.48 222.45 584.02 222.15 Z"
          data-name="Greene"
          data-stusps="OH"
          id="39057"
        />
        <path
          className="white"
          d="M 400.06 442.15 403.61 442.33 404.09 441.83 404.01 442.88 405.34 442.86 405.35 443.47 404.41 448.21 404.21 448.36 403.34 449.55 400.19 451.31 398.73 452.39 397.52 453.39 396.52 454.34 396.87 453.44 397.58 449.49 398.03 447.48 397.21 447.41 395.94 445.95 395.3 444.46 396.58 443.56 400.06 442.15 Z"
          data-name="Calhoun"
          data-stusps="TX"
          id="48057"
        />
        <path
          className="white"
          d="M 43.82 166.64 45.8 167.23 46.28 167.41 50.15 168.58 49.04 172.18 50.61 173.99 53.71 172.36 55.29 173.01 57.01 174.73 57.55 176.38 58.73 178 60.49 179.11 60.21 180.53 61.15 182.32 60.17 185.62 59.32 186.57 51.86 184.41 51.31 184.86 49.85 183.75 49.08 182.13 46.26 184.13 45.03 184.64 44.33 183.79 43.8 181.6 42.32 179.07 41.6 177.3 42.42 175.15 43.61 174.06 42.97 172.49 44.32 171.65 45.27 169.92 43.65 168.57 43.82 166.64 Z"
          data-name="Plumas"
          data-stusps="CA"
          id="6063"
        />
        <path
          className="white"
          d="M 352.71 468.46 354.25 467.43 354.85 468.31 361.19 468.55 360.98 477.61 359.97 479.66 357.13 481.57 356.77 479.93 356.66 478.65 356.13 477.44 355.72 476.4 354.72 475.69 354.21 474.75 353.79 473.74 352.82 472.89 352.94 471.38 353.17 470.4 352.95 469.19 352.71 468.46 Z"
          data-name="Zapata"
          data-stusps="TX"
          id="48505"
        />
        <path
          className="white"
          d="M 617.99 330.53 618.82 330.17 620.07 330.01 621 332.28 621.52 332.09 621.28 332.87 623.55 336.19 623.06 335.86 620.93 337.12 620.47 337.35 618.23 336.56 617.26 337.36 615.89 335.37 615.17 334.55 616.61 331.66 617.99 330.53 Z"
          data-name="Wilkes"
          data-stusps="GA"
          id="13317"
        />
        <path
          className="white"
          d="M 690.3 205.88 691.34 205.64 693.48 205.17 693.77 206.27 694.77 208.4 696.68 209.28 697.27 209.52 697.62 210.2 699.08 212.09 698.96 212.86 698.7 213.4 698.1 213.87 697.77 214.46 697.21 214.58 696.7 214.72 696.64 214.84 696.18 214.56 695.85 213.07 695.53 211.65 694.12 211.97 693.14 212.18 692.9 212.42 692.94 212.58 693.26 214.03 693.7 214.16 694.11 214.28 694.37 214.36 693.73 215.19 693.39 215.04 692.09 214.52 691.9 213.61 690.44 213.21 690.54 213.05 689.99 211.51 689.84 211.21 690.23 206.79 690.3 205.88 Z"
          data-name="Baltimore"
          data-stusps="MD"
          id="24005"
        />
        <path
          className="white"
          d="M 431.52 267.36 431.52 266.93 437.11 267.49 438.62 266.86 439.77 267.24 439.71 269.78 439.68 274.69 431.56 274.56 431.55 274.19 431.55 274.02 431.53 268.29 431.52 267.36 Z"
          data-name="Vernon"
          data-stusps="MO"
          id="29217"
        />
        <path
          className="white"
          d="M 721.45 187.87 722.65 187.04 723.3 185.57 723.69 184.89 724.13 183.36 724.28 183.22 724.58 183.3 725.26 182.98 725.99 182.87 726.98 183.12 727.14 182.02 727.42 181.84 728.06 183.05 728.44 184.17 728.63 185.51 728.65 186.77 728.69 188.66 728.72 189.06 727.5 188.68 727 189.56 725.13 188.69 722.97 189.12 721.29 191.42 720.5 190.43 719.9 189.69 720.78 188.78 721.45 187.87 Z"
          data-name="Monmouth"
          data-stusps="NJ"
          id="34025"
        />
        <path
          className="white"
          d="M 695.66 99.13 701.49 114.19 701.73 115.56 697.56 117.27 694.83 118.39 693.18 117.91 688.82 116.61 682.32 114.53 682.61 114.11 682.73 113.1 683.07 112.12 685.05 108.76 686.49 106.43 687.45 105.17 688.23 103.94 689.52 102.74 690.39 101.91 691.07 101.16 691.13 100.76 692.23 100.34 693.05 99.49 694.37 99.62 694.61 99.53 695.66 99.13 Z"
          data-name="St. Lawrence"
          data-stusps="NY"
          id="36089"
        />
        <path
          className="white"
          d="M 504.01 210.09 508.45 209.64 510.06 209.54 511.71 209.38 512 212.65 511.18 212.73 511.34 214.37 510.54 215.14 509.3 215.82 507.36 216.01 506.51 215.67 506.28 213.18 503.09 213.43 502.92 212.56 504.01 210.09 Z"
          data-name="Woodford"
          data-stusps="IL"
          id="17203"
        />
        <path
          className="white"
          d="M 570.43 202.13 576.18 201.36 576.41 203 577.35 203.72 576.65 204.64 576.98 207.1 576.13 207.21 576.02 206.4 571.07 207.04 571.07 207.04 570.6 203.38 570.43 202.13 Z"
          data-name="Van Wert"
          data-stusps="OH"
          id="39161"
        />
        <path
          className="white"
          d="M 639.04 364.83 639.63 363.95 640.05 363.92 641.69 365.24 641.96 365.92 643.86 365.61 645.03 366.03 646.21 368.37 647.92 369.32 649.74 369.86 650.06 369.86 650.02 370.08 650.32 371.52 649.85 372.89 649.86 373.2 648.86 371.58 647.28 371.24 645.35 371.83 644.3 370.86 641.69 369.94 639.41 368.13 639.41 366.23 638.1 365.6 639.04 364.83 Z"
          data-name="Liberty"
          data-stusps="GA"
          id="13179"
        />
        <path
          className="white"
          d="M 576.13 207.21 576.98 207.1 579.47 206.75 581.23 207.33 584.49 206.86 584.77 208.85 583.14 209.14 583.15 210.14 578.32 210.83 578.58 212.74 577.26 213.39 576.93 213.25 576.72 211.6 576.43 209.41 576.13 207.21 Z"
          data-name="Auglaize"
          data-stusps="OH"
          id="39011"
        />
        <path
          className="white"
          d="M 340.99 450.54 342.38 450.57 354.34 450.83 354.34 450.96 354.33 454.1 364.08 453.85 363.85 467.03 363.82 468.64 361.19 468.55 354.85 468.31 354.25 467.43 352.71 468.46 352.67 468.34 352.27 467.83 351.58 467.6 352.35 465.63 352.24 464.89 352.23 463.97 351.71 463.99 351.73 462.46 351.3 461.81 350.18 461.4 348.85 460.97 347.99 459.78 347.29 459.3 346.59 458.58 346.07 457.71 345.66 456.74 345.46 455.93 345.25 454.99 344.39 454.53 343.71 452.96 342.97 451.96 341.36 450.88 340.99 450.54 Z"
          data-name="Webb"
          data-stusps="TX"
          id="48479"
        />
        <path
          className="white"
          d="M 584.51 360.51 587.12 360.25 587.2 360.24 587.25 360.7 590.66 360.33 591.13 360.66 590.79 361.56 589.8 363.54 586.47 364.68 586.5 363.46 585.93 362.29 585.9 362.23 585.78 361.98 584.66 360.97 584.51 360.51 Z"
          data-name="Muscogee"
          data-stusps="GA"
          id="13215"
        />
        <path
          className="white"
          d="M 615.25 336.22 615.89 335.37 617.26 337.36 618.23 336.56 620.47 337.35 619.56 339.2 618.52 339.12 617.84 340.25 618.12 340.66 616.02 340.85 615.51 340.5 615.23 338.4 616.03 336.74 615.25 336.22 Z"
          data-name="Taliaferro"
          data-stusps="GA"
          id="13265"
        />
        <path
          className="white"
          d="M 396.48 379.15 404.69 374.44 407.64 376.74 408.45 376.65 409.1 379.21 409.9 380.38 402.82 384.41 399.26 384.03 396.48 379.15 Z"
          data-name="Navarro"
          data-stusps="TX"
          id="48349"
        />
        <path
          className="white"
          d="M 421.08 296.09 425.96 296.06 425.93 302.59 424.3 302.6 424.32 304.23 422.95 304.24 419.42 304.25 419.45 296.1 421.08 296.09 Z"
          data-name="Mayes"
          data-stusps="OK"
          id="40097"
        />
        <path
          className="white"
          d="M 562.25 337.34 562.73 336.46 564.15 336.23 565.2 337.83 566.52 338.79 566.99 340.24 565.55 341.99 564.75 341.71 565.28 343.15 564.46 345.6 563.69 345.38 562.37 347.76 562.19 345.66 560.55 345.81 560.48 344.99 559.92 345.04 559.14 340.95 558.59 340.99 558.53 340.3 561.17 339.42 562 338.48 562.25 337.34 Z"
          data-name="St. Clair"
          data-stusps="AL"
          id="1115"
        />
        <path
          className="white"
          d="M 638.13 260.95 640.15 255.04 640.09 254.59 643.44 254.96 644.17 254.2 645.85 254.51 645.82 254.56 647.04 255.52 647.05 255.53 646.28 256.4 646.3 257.35 644.91 259.03 644.04 259.87 643.96 259.83 642.68 259.16 641.06 260.6 639.6 261.65 638.44 260.83 638.13 260.95 Z"
          data-name="Monroe"
          data-stusps="WV"
          id="54063"
        />
        <path
          className="white"
          d="M 546.48 356.48 548.12 356.29 548.5 353.86 549.81 353.79 549.71 352.55 551.74 351.43 552.36 351.38 552.51 352.9 553.51 354.09 554.99 354.89 555.41 358.9 553.14 359.08 548.37 359.58 548.3 358.76 546.69 358.9 546.48 356.48 Z"
          data-name="Bibb"
          data-stusps="AL"
          id="1007"
        />
        <path
          className="white"
          d="M 746.84 50.9 750.7 49.52 751.75 52.92 754.54 60.65 755.08 60.32 756.35 62.38 755.53 62.39 755.94 64.78 755.06 64.48 754.74 65.57 757.18 67.02 756.71 68.97 762.26 78.16 763.59 76.8 765.37 75.76 766.26 77.26 767.2 78.84 768.1 80.35 768.22 80.74 768.86 81.91 767.08 81.86 766.32 83.4 766.17 82.93 764.13 84.04 764.36 84.52 765.16 85.04 765.28 86.19 764.42 86.29 763.26 86.35 762.78 87.05 762.18 86.62 760.72 87.05 759.88 85.87 759.42 86.1 757.74 82.78 756.54 83.47 756 82.71 756.18 81.58 754.38 78.42 752.72 79.37 752.19 78.44 750.86 79.29 747.22 72.86 745.79 70.11 745.79 70.11 746.95 68.97 747.58 68.11 746.83 67.3 746.94 66.8 747.52 65.66 748.21 64.65 748.02 63.84 747.66 63.34 747.05 63.57 746.94 62.84 746.62 62.53 746.5 61.69 746.76 60.77 746.84 59.88 745.9 59.31 745.97 58.02 746.02 57.21 746.27 56.8 746.04 56.23 746.44 55.47 746.84 54.85 747.17 54.19 747.39 53.72 746.84 50.9 Z"
          data-name="Somerset"
          data-stusps="ME"
          id="23025"
        />
        <path
          className="white"
          d="M 514.82 284.37 515.2 284.89 519.14 283.88 519.19 284.01 519.43 287.28 515.59 287.56 515 287.14 514.23 287.4 514.23 287.35 514.28 286.25 514.63 285.38 514.82 284.37 Z"
          data-name="Carlisle"
          data-stusps="KY"
          id="21039"
        />
        <path
          className="white"
          d="M 665.45 156.93 665.22 155.72 666.05 155.54 665.88 154.68 668.24 154.21 668.73 154.11 669.98 153.84 673.07 153.13 673.99 154.76 675 158.72 676.86 158.17 678.05 163.41 677.46 163.54 669 165.47 667.03 165.91 665.62 158.22 665.45 156.93 Z"
          data-name="Steuben"
          data-stusps="NY"
          id="36101"
        />
        <path
          className="white"
          d="M 137.79 117.92 139.14 118.34 139.7 116.71 147.56 118.73 149.28 118.67 150.27 117.2 151.09 117.53 152.45 118.72 152.17 120.51 153.89 121.87 153.19 123.62 153.41 125.85 152.33 125.75 151.59 124.73 151.46 122.57 150.84 122.26 151.16 122.93 149.32 125.13 146.08 125.35 145.12 126.95 144.53 126.69 143.76 127.89 142.48 128.83 140.99 128.99 139.69 129.61 138.33 129.26 138.12 129.14 135.38 124.46 135.19 124.14 136.99 117.72 137.79 117.92 Z"
          data-name="Boise"
          data-stusps="ID"
          id="16015"
        />
        <path
          className="white"
          d="M 495.32 361.32 498.59 361.14 498.52 359.53 499.86 359.44 500.13 359.2 506.3 361.55 505.13 364.33 502.92 365.76 501.58 365.94 500.27 367.08 499.64 367.65 498.92 367.7 497.84 369.09 497.34 369.03 495.7 368.39 495.64 367.57 494.59 367.07 495.03 366.72 494.5 366.26 495.37 366.05 494.13 365.02 494.81 363.36 493.76 363.03 495.32 361.32 Z"
          data-name="Yazoo"
          data-stusps="MS"
          id="28163"
        />
        <path
          className="white"
          d="M 464.11 75.31 464.32 75.4 465.15 75.38 465.52 76.87 467.2 76.98 467.47 78 468.43 77.7 470.05 77.55 471.12 77.21 472.24 76.08 473.7 75.07 473.73 75.05 474.24 80.72 474.7 88.66 473.22 90.33 471.86 92.33 470.37 94.15 469.52 95.11 468.07 96.12 467.23 97.36 466.08 98.24 465.39 99.03 464.87 87.76 464.11 75.31 Z"
          data-name="Lake"
          data-stusps="MN"
          id="27075"
        />
        <path
          className="white"
          d="M 434.62 344.12 435.7 344.02 437.37 346.13 439.28 346.91 441.5 346.99 442.79 347.55 442.82 347.55 442.63 347.77 442.68 348.96 444.93 350.16 444.76 350.29 444.36 350.15 444.09 350.53 443.82 350.73 443.77 350.5 443.52 350.57 443.74 350.81 443.6 350.93 443.36 350.72 443.1 351.25 442.87 351.26 442.84 350.98 442.49 350.98 442.63 351.25 442.44 351.61 441.53 351.31 441.07 350.93 439.96 350.85 439.32 350.59 438.85 351 438.46 350.89 437.44 351.14 436.9 351.09 436.65 351.3 436.12 351.14 435.63 350.92 434.56 349.8 434.59 346.97 434.62 344.12 Z"
          data-name="Little River"
          data-stusps="AR"
          id="5081"
        />
        <path
          className="white"
          d="M 426.18 182.57 432.72 182.51 432.75 184.11 433.38 184.1 433.46 189.06 430.24 189.1 427.03 189.14 427 184.18 426.19 184.19 426.18 182.57 Z"
          data-name="Calhoun"
          data-stusps="IA"
          id="19025"
        />
        <path
          className="white"
          d="M 563.02 188.35 568.25 187.67 568.52 187.64 568.67 188.84 569.09 191.96 563.6 192.73 563.02 188.35 Z"
          data-name="Steuben"
          data-stusps="IN"
          id="18151"
        />
        <path
          className="white"
          d="M 576.54 375.16 577.46 372.84 579.98 372.26 580.03 369.75 582.48 369.49 583.81 371 585.96 370.77 585.89 372.12 585.87 372.59 585.27 374.06 584.92 375.13 585.24 376.22 585.33 376.54 583.98 377.83 580.75 378.06 580.9 379.71 580.08 379.77 575.54 380.24 575.73 380.1 576.59 377.2 576.54 375.16 Z"
          data-name="Barbour"
          data-stusps="AL"
          id="1005"
        />
        <path
          className="white"
          d="M 571.17 161.11 577.2 160.17 578.24 166.77 574.98 167.31 572.14 167.72 571.19 161.3 571.17 161.11 Z"
          data-name="Shiawassee"
          data-stusps="MI"
          id="26155"
        />
        <path
          className="white"
          d="M 20.07 162.32 21.54 162.21 22.34 162.65 23.27 162.07 25.29 162.4 26.35 163.52 28.55 162.99 31.57 164.32 36.27 164.66 37.2 165.19 39.33 165.25 40.33 165.76 43.82 166.64 43.65 168.57 45.27 169.92 44.32 171.65 42.97 172.49 40.49 172.79 38.92 174.76 38.09 174.47 36.02 175.91 32.49 174.81 31.95 176.44 18.87 172.23 19.37 170.08 20.14 169.73 20.04 168.82 20.28 165.37 21.06 163.61 20.07 162.32 Z"
          data-name="Tehama"
          data-stusps="CA"
          id="6103"
        />
        <path
          className="white"
          d="M 407.57 230.65 407.57 230.65 408.79 230.66 410.67 230.66 410.87 230.66 414.08 230.66 414.07 237.18 414.07 238.81 410.49 238.81 407.54 238.8 407.56 232.27 407.57 230.65 Z"
          data-name="Nemaha"
          data-stusps="KS"
          id="20131"
        />
        <path
          className="white"
          d="M 486.87 381.5 490.56 381.49 493.35 382.03 493.21 382.81 495.08 382.71 495.14 384.35 495.21 385.99 488.52 386.31 486.12 385.24 486.16 385.13 486.12 385.08 486.23 384.96 486.24 384.88 486.2 384.76 486.12 384.72 486.15 384.59 486.07 384.59 486.08 384.47 485.98 384.52 485.78 383.8 485.74 383.84 485.07 382.9 485.26 382.08 486.16 382.21 486.87 381.5 Z"
          data-name="Jefferson"
          data-stusps="MS"
          id="28063"
        />
        <path
          className="white"
          d="M 521.09 205.07 521.21 204.78 521.05 203.42 524.34 203.05 524.17 201.42 531.06 200.67 531.3 203.15 531.56 205.8 531.59 206.07 522.99 207.1 521.35 207.31 521.09 205.07 Z"
          data-name="Kankakee"
          data-stusps="IL"
          id="17091"
        />
        <path
          className="white"
          d="M 512.11 277.19 515.18 277.08 515.23 277.75 516.96 277.45 517.07 278.89 517.01 278.87 516.99 278.87 515.98 279.01 515.17 279.74 514.62 280.68 513.67 282.01 513.69 282.04 512.21 281.51 512.11 277.19 Z"
          data-name="Pulaski"
          data-stusps="IL"
          id="17153"
        />
        <path
          className="white"
          d="M 431.3 142.01 431.33 143.65 434.59 143.58 434.57 141.94 437.83 141.88 439.46 141.85 439.48 142.67 441.1 142.63 441.11 143.25 439.34 144.28 439.25 145.12 439.59 145.57 439.03 146.75 429.69 146.94 429.54 142.05 431.3 142.01 Z"
          data-name="Sibley"
          data-stusps="MN"
          id="27143"
        />
        <path
          className="white"
          d="M 605.39 195.67 607.75 195.34 607.94 196.69 608.56 196.59 609.58 202.68 608.22 202.91 608.53 204.78 606.89 205.29 606.62 203.72 606.35 202.06 604.9 200.42 604.23 197.26 603.96 195.9 605.39 195.67 Z"
          data-name="Ashland"
          data-stusps="OH"
          id="39005"
        />
        <path
          className="white"
          d="M 654.94 285.6 654.59 283.02 654.29 280.91 662.06 279.9 663.04 286.4 660.37 286.72 655.17 287.32 654.94 285.6 Z"
          data-name="Guilford"
          data-stusps="NC"
          id="37081"
        />
        <path
          className="white"
          d="M 635.57 201.98 638.21 198.85 637.95 197.72 639.1 197.5 643.16 196.81 644.51 196.58 643.67 198.45 643.9 199.05 644.9 199.33 645.21 201.21 644.5 201.99 644.39 205.06 643.6 205.97 642.29 205.89 642.79 205.05 638.64 204.25 635.57 201.98 Z"
          data-name="Allegheny"
          data-stusps="PA"
          id="42003"
        />
        <path
          className="white"
          d="M 464.64 230.54 466.23 230.44 469.48 230.4 471.11 230.35 471.26 235.79 466.35 235.92 466.37 237.02 464.73 237.06 464.64 230.54 Z"
          data-name="Shelby"
          data-stusps="MO"
          id="29205"
        />
        <path
          className="white"
          d="M 303.14 306.5 303.59 300.57 316.99 301.5 316.47 309.53 302.98 308.7 303.14 306.5 Z"
          data-name="Hartley"
          data-stusps="TX"
          id="48205"
        />
        <path
          className="white"
          d="M 683.52 252.84 684.19 252.55 685.99 249.47 686.93 249.45 686.99 249.85 689.99 250.97 690.12 251.46 692.5 252.35 692.83 251.69 692.75 252.92 692.59 252.98 692.58 253.1 692.52 253.04 692.49 253.1 692.39 253.15 692.41 253.21 692.38 253.15 692.27 253.19 692.07 253.3 691.98 253.31 691.8 253.23 691.8 253.26 691.56 253.44 691.56 254.02 691.38 254.48 691.43 254.68 691.35 254.82 691.07 254.93 691.05 254.91 691.36 254.74 691.31 254.26 691.51 253.93 691.36 253.64 691.26 253.93 690.48 254.25 690.8 254.49 690.88 255.03 690.45 255.31 689.34 255.65 687.2 255.13 687.17 255.12 685.55 255.39 683.39 253.91 683.52 252.84 Z"
          data-name="Chesterfield"
          data-stusps="VA"
          id="51041"
        />
        <path
          className="white"
          d="M 628.41 367.79 628.84 368.05 631.87 368.37 633.74 368.37 634.94 369.63 634.43 369.69 633.7 370.83 634.44 376.56 634.04 376.59 632.77 375.63 627.98 372.78 627.56 372.81 627.02 372.39 627.28 370.39 628.72 370.22 628.41 367.79 Z"
          data-name="Appling"
          data-stusps="GA"
          id="13001"
        />
        <path
          className="white"
          d="M 242.91 234.3 241.56 244.64 228.58 242.91 229 239.88 232.73 238.86 233.58 237.62 235.35 236.46 237.31 236.2 238.58 237.07 240.7 235.46 242.91 234.3 Z"
          data-name="Delta"
          data-stusps="CO"
          id="8029"
        />
        <path
          className="white"
          d="M 434.92 317 434.91 316.9 435.27 315.85 437.1 317.75 437.87 317.54 438 317.58 439.56 316.91 439.38 315.76 440.42 315.83 440.4 316.44 440.39 318.8 440.66 320.42 441.2 320.15 441.2 320.2 441.19 321.52 439.53 321.5 439.52 322.32 438.18 323.13 438.17 324.8 434.83 325.5 434.87 323.09 434.93 319.09 434.96 317.33 434.92 317 Z"
          data-name="Sebastian"
          data-stusps="AR"
          id="5131"
        />
        <path
          className="white"
          d="M 647.16 276.38 647.29 276.37 649.4 276.14 653.1 275.55 653.5 275.49 654.29 280.91 647.88 281.89 647.16 276.38 Z"
          data-name="Stokes"
          data-stusps="NC"
          id="37169"
        />
        <path
          className="white"
          d="M 711.84 274.78 714.39 273.7 714.79 273.38 716.25 272.65 716.73 272.23 716.78 272.42 718.58 272.05 719.25 272.79 719.84 272.92 717.99 274.35 717.77 276.01 718.38 280.4 716.42 280.14 715.76 282.36 714.61 282.47 714.53 280.77 712.38 281.08 712.03 279.39 712.54 277.79 711.92 276.86 711.84 274.78 Z"
          data-name="Tyrrell"
          data-stusps="NC"
          id="37177"
        />
        <path
          className="white"
          d="M 670.69 224.08 672.87 223.45 672.98 223.06 674.46 223.09 675.37 223.7 674.85 225.53 673.94 226.24 673.23 228.12 672.06 228.7 671.89 228.32 670.19 227.82 671.13 225.26 670.69 224.08 Z"
          data-name="Warren"
          data-stusps="VA"
          id="51187"
        />
        <path
          className="white"
          d="M 440.6 121.06 440.79 125.99 435.64 126.12 434.9 125 435.15 123.87 433.95 122.09 432.86 121.24 440.6 121.06 Z"
          data-name="Benton"
          data-stusps="MN"
          id="27009"
        />
        <path
          className="white"
          d="M 502.04 94.75 502.14 94.58 502.49 93.44 503.38 92.59 504.74 91.26 506.15 90.42 506.99 89.51 509.72 89.25 509.89 90.87 511.14 90.75 510.75 91.93 509.57 93.16 509.12 94.64 508.54 95.88 507.1 96.09 507.26 97.71 505.62 97.86 506.35 105.97 502.3 106.34 501.9 101.45 503.52 101.32 503.38 99.71 502.5 99.79 502.04 94.75 Z"
          data-name="Houghton"
          data-stusps="MI"
          id="26061"
        />
        <path
          className="white"
          d="M 635.65 248.11 638.27 248.15 641.78 243.9 643.05 244.49 643.37 246.6 645.06 247.63 646.52 247.58 649.53 246.52 649.46 246.91 648.74 248.53 648.5 248.88 647.56 250.26 646.75 251.61 646.6 252.49 646.21 253.78 645.85 254.51 644.17 254.2 643.44 254.96 640.09 254.59 639.92 254.01 637.51 252.35 638.39 252.28 637.2 250.85 637.7 250.06 635.65 248.11 Z"
          data-name="Greenbrier"
          data-stusps="WV"
          id="54025"
        />
        <path
          className="white"
          d="M 233.28 98.14 236.55 98.71 237.43 93.63 238.28 89.86 238.29 89.86 238.3 89.78 238.32 89.67 238.32 89.66 238.33 89.59 238.35 89.47 238.36 89.45 238.47 88.78 243.36 89.63 243.08 92.92 244.16 93.12 244.34 95.57 244.05 97.19 244.85 99.01 244.4 101.73 242.51 101.41 236.09 100.32 235.8 101.96 233.34 101.52 233.64 99.89 233 99.77 233.28 98.14 Z"
          data-name="Golden Valley"
          data-stusps="MT"
          id="30037"
        />
        <path
          className="white"
          d="M 549.35 331.68 549.33 331.41 557.6 330.84 559.23 330.73 559.69 331.51 558.67 331.74 558.11 333.35 557.96 333.45 557.79 333.98 557.56 334.26 557.62 334.37 556.23 335 556.4 335.61 554.88 337.78 552.9 338.77 552.37 339.78 550.3 339.36 549.21 337.5 549.82 337.46 549.35 331.68 Z"
          data-name="Cullman"
          data-stusps="AL"
          id="1043"
        />
        <path
          className="white"
          d="M 343.01 433.91 354.51 434.2 354.33 442.65 342.67 442.13 343.01 433.91 Z"
          data-name="Zavala"
          data-stusps="TX"
          id="48507"
        />
        <path
          className="white"
          d="M 638.42 397.33 638.58 397.27 638.48 396.65 638.6 395.78 638.57 394.17 638.44 392.82 637.76 391.87 637.8 391.16 637.81 390.03 638.34 389.28 639.09 388.39 639.72 388.42 639.78 388.43 640.4 388.89 641.39 388.82 642.17 389.03 642.74 389.42 643.8 389.38 644.42 389.59 645.63 389.71 646.16 389.49 646.5 389.45 647.57 389.57 647.88 389.75 647.86 391.63 648.2 393.1 648.33 393.4 647.02 392.46 646.41 393.31 645.23 392.88 645.22 392.27 643.35 392.78 643.03 393.61 641.8 394.99 638.84 398.91 638.67 399.13 638.42 397.33 Z"
          data-name="Nassau"
          data-stusps="FL"
          id="12089"
        />
        <path
          className="white"
          d="M 666.71 317.06 668.58 310.45 670.26 311.64 675.58 315.55 675.36 315.67 674.83 316.58 673.46 316.77 670.7 316.35 669.15 316.85 668.27 318.11 667.24 317.12 666.71 317.06 Z"
          data-name="Dillon"
          data-stusps="SC"
          id="45033"
        />
        <path
          className="white"
          d="M 38.99 235.71 39.69 238.65 39.35 239.55 40.26 241.41 42.36 242.3 45.28 241.99 45.7 242.28 47.32 242.12 49.17 242.48 51.45 240.18 51.61 240.06 51.9 239.88 52.4 239.99 52.52 239.5 52.73 239.45 53.04 239.89 53.52 239.1 54.13 239.41 54.33 238.4 55.43 237.98 55.78 238.89 56.61 238.07 57.72 238.24 58.41 237.64 58.86 235.61 59.93 234.58 65.01 231.61 66.44 232.7 67.08 234.39 68.17 234.93 67.4 237.17 68.4 237.73 68.44 241.53 69.37 241.84 71.37 243.94 71.72 247.52 71.02 248.43 71.04 250.25 61.45 247.9 61 249.51 59.4 249.09 58.07 248.73 56.08 248.17 55.64 249.84 53.15 249.16 51.59 250.11 51.07 250.38 49.27 251.35 47.82 251.31 44.64 250.49 43.52 254.7 36.56 258.5 35.04 256.82 32.26 252.57 33.23 251.49 32.76 250.04 34.36 249.22 35.19 246.14 31.56 239.92 36.75 236.98 37.75 237.26 38.99 235.71 Z"
          data-name="Fresno"
          data-stusps="CA"
          id="6019"
        />
        <path
          className="white"
          d="M 410.72 133.99 421.22 133.96 421.23 138.86 418.1 138.89 418.11 141.49 417.9 140.79 414.71 138.05 413.81 137.8 413.54 137.1 410.72 133.99 Z"
          data-name="Chippewa"
          data-stusps="MN"
          id="27023"
        />
        <path
          className="white"
          d="M 642.57 224.78 644.65 224.3 646.35 222.99 646.72 223.02 647.85 224.06 647.77 226.02 648.02 226.27 647.46 229.15 644.76 230.14 645.14 228.82 643.82 228.54 642.11 227.38 641.95 226.28 642.57 224.78 Z"
          data-name="Barbour"
          data-stusps="WV"
          id="54001"
        />
        <path
          className="white"
          d="M 666.28 279.12 667.88 278.87 671.02 278.36 671.25 284.92 671.28 285.68 670.27 285.91 667.63 286.06 667.23 285.49 666.28 279.12 Z"
          data-name="Orange"
          data-stusps="NC"
          id="37135"
        />
        <path
          className="white"
          d="M 644.76 230.14 647.46 229.15 648.02 226.27 648.87 227.65 653.17 228.08 655.43 227.86 655.57 227.98 655.33 228.74 653.29 229.68 653.82 231.76 652.5 234.27 650.78 234.28 650.01 233.25 649.37 237.05 647.21 239.22 645.86 239.17 644.23 241.12 644.69 238.37 642.71 235.42 643.19 234.38 644.82 234.05 644.76 230.14 Z"
          data-name="Randolph"
          data-stusps="WV"
          id="54083"
        />
        <path
          className="white"
          d="M 619.83 229.21 619.95 229.03 620.27 227.93 621.21 227.75 621.92 227.62 621.84 226.57 622.54 225.64 623.12 224.85 623.8 225.02 624.21 225.78 624.56 225.78 624.74 226.3 626.73 226.99 626.44 227.06 626.12 228.69 624.41 229.93 622.44 232.37 620.22 231.6 619.73 231.3 619.83 231.23 619.47 229.85 619.45 229.78 619.83 229.21 Z"
          data-name="Wood"
          data-stusps="WV"
          id="54107"
        />
        <path
          className="white"
          d="M 349.67 411.54 357.03 411.85 356.95 414.71 363.16 414.81 363.02 421.5 358.84 419.25 351.89 418.8 350.45 418.74 350.57 415.64 349.47 415.6 349.67 411.54 Z"
          data-name="Kerr"
          data-stusps="TX"
          id="48265"
        />
        <path
          className="white"
          d="M 276.97 256.53 278.58 256.68 279.06 251.77 292.17 252.96 292.18 252.96 291.48 260.02 290.75 267.75 286.56 265.81 282.3 263.83 276.79 263.66 276.31 262.97 276.97 256.53 Z"
          data-name="Pueblo"
          data-stusps="CO"
          id="8101"
        />
        <path
          className="white"
          d="M 600.49 308.22 600.77 307.59 603.58 306.85 604.49 306.25 605.92 305.95 607.14 307.77 607.93 307.47 608.13 309 609.58 310.34 610.31 311.73 610.31 311.73 606.99 312.25 604.51 312.66 601.36 309.8 600.16 310.04 600.71 308.4 600.49 308.22 Z"
          data-name="Macon"
          data-stusps="NC"
          id="37113"
        />
        <path
          className="white"
          d="M 74.46 16.71 74.31 17.6 73.67 17.35 72.28 21.01 65.37 18.35 51.75 12.64 51.65 12.45 51.65 10.8 52.13 9.18 52.48 8.26 52.46 7.09 53.35 6.03 54.19 4.73 54.17 2.8 55.09 3.08 56.12 4.29 57.63 6.38 59.08 7.39 60.56 9.01 60.89 9.98 62.87 11.13 64.75 11.83 65.44 12.1 66.85 12.9 68 13.92 69.5 14.73 70.46 15 72.03 14.39 72.61 15.78 73.17 16.63 73.94 16.75 74.46 16.71 Z"
          data-name="Clallam"
          data-stusps="WA"
          id="53009"
        />
        <path
          className="white"
          d="M 507.76 321.63 509 321.55 512.23 321.36 513.5 321.27 513.68 324.08 514.51 324.02 514.85 328.93 515.67 328.88 515.77 330.52 514.49 330.03 512.96 330.26 512.11 329.65 509.13 329.83 508.97 327.37 508.14 327.42 508.02 325.79 507.76 321.63 Z"
          data-name="Marshall"
          data-stusps="MS"
          id="28093"
        />
        <path
          className="white"
          d="M 96.48 72.29 97 72.19 98.36 72.34 99.27 72.44 101.05 72.82 102.33 71.93 102.74 71.94 103.72 72.64 104.48 72.74 102.64 78.52 105.07 79.3 104.58 80.9 105.93 81.32 103.44 89.41 102.72 90.97 96.33 89.03 95.95 88.9 94.37 88.41 94.81 87.05 95.29 86.92 95.82 85.28 94.17 84.77 94.71 83.13 93.08 82.6 96.48 72.29 Z"
          data-name="Morrow"
          data-stusps="OR"
          id="41049"
        />
        <path
          className="white"
          d="M 494.97 329.18 495.32 328.57 495.35 327.84 495.91 326.63 496.38 326.15 496.49 325.28 497.35 325.22 497.45 325.22 498.78 324.46 498.81 324.44 500.51 324.58 500.69 327.13 500.23 327.57 500.17 329 500.89 330.32 500.94 331.13 499.29 331.25 499.42 332.84 497.9 332.94 495.16 331.19 495.16 331.18 495.43 330.36 494.79 329.49 494.97 329.18 Z"
          data-name="Tunica"
          data-stusps="MS"
          id="28143"
        />
        <path
          className="white"
          d="M 348.29 344.91 350.81 345.02 354.46 346.06 355.18 345.88 356.39 347.14 356.2 353.42 348.04 353.14 348.29 344.91 Z"
          data-name="Knox"
          data-stusps="TX"
          id="48275"
        />
        <path
          className="white"
          d="M 548.86 292.21 550.26 292.7 551.23 291.55 553.27 294.22 553.97 294.34 554.74 296.36 555.43 296.94 554.98 297.23 554.09 299.59 551.34 298.54 549.2 298.44 547.62 299.79 547.31 298.75 547.5 298.81 548.3 294.46 549 292.51 548.86 292.21 Z"
          data-name="Davidson"
          data-stusps="TN"
          id="47037"
        />
        <path
          className="white"
          d="M 579.12 260.82 579.53 258.06 580.56 258.26 580.93 258.39 582.37 258.92 583.25 260.6 582.63 260.56 582.96 261.47 582.08 262.22 581.5 263.08 580.03 261.7 580.09 262.19 579.12 261.71 579.45 260.99 579.12 260.82 Z"
          data-name="Jessamine"
          data-stusps="KY"
          id="21113"
        />
        <path
          className="white"
          d="M 593.51 372.7 595.87 372.47 595.92 371.54 597.48 372.95 597.82 373.14 599.18 373.86 598.82 374.6 598.98 377.82 596.51 378.09 596.08 378.14 594.95 378.26 595.03 377.2 593.75 375.51 593.51 372.7 Z"
          data-name="Terrell"
          data-stusps="GA"
          id="13273"
        />
        <path
          className="white"
          d="M 579.81 307.58 580.42 306.41 581.35 306.76 582.04 305.65 581.71 304.67 582.93 304.49 582.87 302.18 583.74 301.78 583.59 300.59 585.3 301.25 585.42 302.44 582.98 306.47 582.35 308.42 582.04 308.39 581.15 309.75 579.66 308.17 579.81 307.58 Z"
          data-name="Meigs"
          data-stusps="TN"
          id="47121"
        />
        <path
          className="white"
          d="M 508.72 314.37 509.23 313.99 511.13 313.71 512.66 313.67 513.08 313.63 515.6 313.52 515.89 321.1 513.5 321.27 512.23 321.36 509 321.55 508.72 314.37 Z"
          data-name="Fayette"
          data-stusps="TN"
          id="47047"
        />
        <path
          className="white"
          d="M 509.21 230.61 510.32 230.76 510.57 233.51 512.22 233.4 512.66 239.18 510.99 239.26 505.28 239.67 505.01 236.37 504.87 234.73 504.84 234.19 505.66 234.13 505.59 233.32 506.38 233.27 506.28 232.07 508.02 231.42 508.77 230.41 509.21 230.61 Z"
          data-name="Christian"
          data-stusps="IL"
          id="17021"
        />
        <path
          className="white"
          d="M 541.59 245.06 542.52 245 544.44 244.78 544.33 246.44 544.89 252.3 544.57 252.62 542.68 252.34 542.12 251.96 540.12 252.01 539.32 249.31 539.82 248.28 539.64 246.89 540.08 247.03 541.59 245.06 Z"
          data-name="Daviess"
          data-stusps="IN"
          id="18027"
        />
        <path
          className="white"
          d="M 480.79 215.74 480.8 215.25 481.09 214.21 481.03 213.44 481.67 212.51 482.46 211.64 482.89 210.83 482.92 209.6 482.78 208.66 485.15 208.54 485.55 216.67 483.91 216.7 479.89 216.94 480.78 216.24 480.79 215.74 Z"
          data-name="Henderson"
          data-stusps="IL"
          id="17071"
        />
        <path
          className="white"
          d="M 51.47 72.21 52.7 71.77 52.82 69.62 54.21 68.78 55.6 69.81 57.06 70.34 55.55 72.55 56.17 74.24 57.35 75.49 57.59 77.31 59.04 78.9 67.9 81.98 67.29 82.94 66.21 83.18 66.77 84.18 65.73 85.46 62.64 84.35 61.48 83.12 60.08 83.21 59.78 82.09 56.1 80.34 55.49 79.67 54.46 79.6 53.37 78.81 50.56 79.34 49.66 79.74 49.54 78.62 48.26 77.92 49.37 76.95 48.5 75.72 49.94 74.69 50.89 74.76 51.47 72.21 Z"
          data-name="Marion"
          data-stusps="OR"
          id="41047"
        />
        <path
          className="white"
          d="M 376.22 409.72 376.27 408.6 377.52 406.04 379.03 405.99 380.44 407.55 380.56 408.55 381.14 409.31 381.94 409.75 384.84 408.47 388.49 410.06 387.98 411.02 386.46 413.91 386.46 413.92 383.84 416.57 382.86 417.39 381.69 416.39 381.19 415.96 380.47 415.34 375.42 411.02 376.22 409.72 Z"
          data-name="Travis"
          data-stusps="TX"
          id="48453"
        />
        <path
          className="white"
          d="M 509.06 228.67 510.13 228.58 509.93 226.12 515.69 225.55 516.08 230.49 515.18 231.54 515.34 233.17 512.22 233.4 510.57 233.51 510.32 230.76 509.21 230.61 509.06 228.67 Z"
          data-name="Macon"
          data-stusps="IL"
          id="17115"
        />
        <path
          className="white"
          d="M 35.21 187.93 38.67 188.07 40.24 186.77 41.22 185.1 43.55 185.66 45.03 184.64 46.26 184.13 44.96 185.87 44.66 188.79 43.04 188.54 40.38 189.98 38.81 194.45 38.07 194.08 37.52 194.12 36.58 194.57 34.53 194.46 33.74 195.34 34.57 192.03 35.21 187.93 Z"
          data-name="Yuba"
          data-stusps="CA"
          id="6115"
        />
        <path
          className="white"
          d="M 256.5 201.94 264.18 202.95 265.65 203.14 266.04 203.18 265.97 204.39 267.64 207.05 269.08 211.76 269.01 212.72 269.71 213.36 269.16 213.48 268.8 214.92 267.91 215.78 267.11 215.21 263.96 215.79 262.25 214.94 260.94 214.99 260.42 213.69 258.58 214.08 258.16 212.77 258.26 211.83 257.79 209.45 259.19 206.32 259.07 205.17 258.64 204.37 257.91 204.61 256.84 203.3 256.43 203.38 256.5 201.94 Z"
          data-name="Jackson"
          data-stusps="CO"
          id="8057"
        />
        <path
          className="white"
          d="M 510.93 173.24 512.02 173.15 514.19 172.96 517.44 172.69 517.84 177.03 518.05 179.19 515.24 179.45 512.45 179.71 512.45 179.71 511.49 179.79 510.95 173.41 510.93 173.24 Z"
          data-name="Walworth"
          data-stusps="WI"
          id="55127"
        />
        <path
          className="white"
          d="M 650.1 264.76 650.67 263.92 652.58 264.05 654.03 262.08 656.1 262.42 656.96 263.05 658.47 264.88 658.38 268.53 658.04 269.14 657.01 269.73 653 269.96 652.48 270.75 651.94 269.92 649.27 269.78 650.51 267.77 650.1 264.76 Z"
          data-name="Franklin"
          data-stusps="VA"
          id="51067"
        />
        <path
          className="white"
          d="M 67.18 215.29 70.93 216.24 72.68 209.59 73.2 207.95 71.53 207.5 72 205.75 74 203.73 74.38 203.71 76.52 204.29 89.7 207.75 84.43 207.89 84.04 209.43 89.42 219.81 76.7 228.35 75.55 228.01 74.71 226.72 69.54 218.86 67.18 215.29 Z"
          data-name="Mineral"
          data-stusps="NV"
          id="32021"
        />
        <path
          className="white"
          d="M 632.23 402.55 637.43 401.79 637.43 402.43 635.76 404.21 635.15 405.66 633.37 406.52 631.8 406.28 631.5 406.4 630.62 405.54 632.23 402.55 Z"
          data-name="Union"
          data-stusps="FL"
          id="12125"
        />
        <path
          className="white"
          d="M 548.53 190.07 547.91 184.21 554.35 183.5 555 188.58 554.65 189.38 554.65 189.38 550.83 189.81 548.53 190.07 548.53 190.07 Z"
          data-name="Cass"
          data-stusps="MI"
          id="26027"
        />
        <path
          className="white"
          d="M 426.91 102.89 428.56 102.87 428.25 91.48 431.49 91.4 431.48 90.78 432.62 91.3 435.56 90.07 436.45 91.35 436.28 92.03 437.98 93.4 438.27 93 439.74 93.22 439.33 94.59 439.78 94.98 439.86 98.38 439.96 102.65 432.64 102.77 432.86 106.04 432.85 112.68 431.73 111.67 430.33 112.25 428.77 111.41 427.94 111.37 427.75 111.05 427.12 110.58 426.91 102.89 Z"
          data-name="Cass"
          data-stusps="MN"
          id="27021"
        />
        <path
          className="white"
          d="M 258.06 90.1 263.55 90.78 273.27 92.46 281.29 93.54 279.96 100.28 279.51 100.22 278.67 106.72 278.18 106.65 277.31 113.19 276.75 113.12 275.66 121.32 275.08 121.24 274.66 124.47 268.17 123.6 268.61 120.35 269.99 114.35 267.57 113.87 267.84 111.92 268.43 111.17 267.61 111.05 267.71 110.33 268.42 105.33 267.52 105.25 267.98 102.03 267.95 100.31 266.33 100.08 266.29 98.4 258.98 97.33 258.46 96.98 258.02 94.98 258.84 93.51 258.62 92.01 258.41 90.45 258.06 90.1 Z"
          data-name="Rosebud"
          data-stusps="MT"
          id="30087"
        />
        <path
          className="white"
          d="M 519.88 159.2 523.29 158.86 523.35 159.81 522.83 161.22 522.37 163.41 522.48 165.5 522.48 165.59 522.09 165.63 521.62 165.67 520.19 165.81 519.89 162.52 520.2 162.48 519.88 159.2 Z"
          data-name="Ozaukee"
          data-stusps="WI"
          id="55089"
        />
        <path
          className="white"
          d="M 218.1 56.39 219.77 56.73 222.85 42.22 226.12 42.89 229.33 43.53 228.92 45.08 226.27 58.05 225.37 57.87 225.05 59.48 217.76 58.02 218.1 56.39 Z"
          data-name="Liberty"
          data-stusps="MT"
          id="30051"
        />
        <path
          className="white"
          d="M 700.88 165.14 698.91 158.46 699 158.44 700.67 158.14 700.94 158.09 701.85 158.78 702.55 159.84 703.68 160.01 704.38 160.09 704.87 160.15 705.61 160.74 706.14 161.6 706.73 163.67 706.95 164.38 704.93 169.53 703.74 169.91 704.47 170.46 704.22 172.37 702.16 173.01 702.97 172.3 700.88 165.14 Z"
          data-name="Wayne"
          data-stusps="PA"
          id="42127"
        />
        <path
          className="white"
          d="M 524.86 342.82 524.53 337.88 524.61 337.59 527.26 337.41 532.58 337.07 532.56 337.6 532.35 343.54 531.15 343.62 529.97 345.07 528.31 345.62 528.31 345.62 528.31 345.62 528.31 345.61 528.3 345.59 528.3 345.57 528.3 345.56 528.3 345.54 528.3 345.52 528.3 345.5 528.3 345.49 528.3 345.48 528.3 345.45 528.31 345.43 528.31 345.41 528.32 345.41 528.33 345.4 528.35 345.4 528.36 345.4 528.37 345.39 528.39 345.37 528.41 345.35 528.42 345.34 528.45 345.32 528.46 345.32 528.47 345.32 528.47 345.32 528.48 345.31 528.47 345.29 528.47 345.27 528.46 345.26 528.46 345.26 528.46 345.25 528.46 345.23 528.47 345.21 528.47 345.19 528.47 345.17 528.47 345.17 528.48 345.16 528.48 345.16 528.49 345.15 528.49 345.14 528.49 345.14 528.49 345.14 528.5 345.14 528.5 345.14 528.5 345.14 528.51 345.14 528.51 345.13 528.52 345.13 528.53 345.13 528.54 345.14 528.54 345.14 528.55 345.14 528.55 345.15 528.56 345.15 528.57 345.16 528.57 345.16 528.57 345.17 528.58 345.17 528.58 345.18 528.59 345.19 528.59 345.19 528.6 345.2 528.6 345.2 528.6 345.2 528.61 345.2 528.61 345.2 528.62 345.2 528.62 345.19 528.63 345.19 528.63 345.18 528.63 345.17 528.64 345.17 528.64 345.16 528.46 345.05 525.03 345.29 524.86 342.82 Z"
          data-name="Monroe"
          data-stusps="MS"
          id="28095"
        />
        <path
          className="white"
          d="M 460.65 144.48 463.09 144.36 462.97 141.65 469.47 141.34 469.55 142.98 464.56 143.34 463.89 146.87 463.53 146.71 461.87 146.19 461.69 146.03 461.05 145.47 460.69 144.5 460.65 144.48 Z"
          data-name="Pepin"
          data-stusps="WI"
          id="55091"
        />
        <path
          className="white"
          d="M 697.03 228.66 698.32 229.87 700.13 230.51 701.12 231.63 701.86 231.18 701.85 231.35 702.34 231.54 702.31 232.67 703.15 233.71 703.81 234.36 703.82 235.14 704.21 236.3 703.28 235.65 702.24 235.08 701.49 235.31 700.45 234.8 699.45 233.8 698.12 233.69 697.12 233.88 696.07 233.77 695.73 233.72 694.53 231.37 695.57 228.71 697.03 228.66 Z"
          data-name="St. Mary's"
          data-stusps="MD"
          id="24037"
        />
        <path
          className="white"
          d="M 136.12 71.03 136.17 71.83 138.4 72.41 138.33 72.71 137.69 73.67 138.27 74.85 138.44 75.9 138.17 76.9 138.53 77.58 138.23 78.07 137.33 78.98 137.72 79.57 137.72 80.89 132.02 79.27 130.39 78.78 131.05 76.46 131.84 76.68 133.23 71.81 135.84 71.98 136.12 71.03 Z"
          data-name="Asotin"
          data-stusps="WA"
          id="53003"
        />
        <path
          className="white"
          d="M 146.94 42.22 147.37 40.74 149.05 35.22 150.33 30.88 151.37 27.36 154.41 28.22 152.56 34.67 161.67 37.2 161.56 37.59 160.68 40.78 160.21 42.52 159.74 44.22 159.1 46.54 159.15 46.87 158.38 45.68 156.49 44.64 155.68 45.25 155.03 47.62 152.83 47.01 153.36 45.13 151.67 44.94 146.58 43.48 146.94 42.22 Z"
          data-name="Bonner"
          data-stusps="ID"
          id="16017"
        />
        <path
          className="white"
          d="M 645.64 306.72 646.61 305.95 649.56 302.09 650.33 302.42 652.7 302.43 653.85 301.65 654.32 309.01 650.54 309.53 650.54 309.53 646.84 309.98 646.75 307.82 645.64 306.72 Z"
          data-name="Union"
          data-stusps="NC"
          id="37179"
        />
        <path
          className="white"
          d="M 592.15 302.3 593.95 303.41 595.29 303.08 596.28 304.15 596.04 304.76 595.83 304.88 595.18 305.83 595.48 306.48 595.07 306.97 595.41 307.94 595.33 308.02 594.37 308.99 593.14 309.26 592.37 308.81 591.55 309.72 591.54 310.12 590.9 309.94 590.39 309.72 588.13 309 589.49 307.98 589.21 306.71 586.92 302.66 587.16 301.84 590.47 301.66 592.15 302.3 Z"
          data-name="Monroe"
          data-stusps="TN"
          id="47123"
        />
        <path
          className="white"
          d="M 548.02 137.69 554.53 136.88 555.36 143.4 552.25 143.8 548.79 144.25 548.02 137.69 Z"
          data-name="Wexford"
          data-stusps="MI"
          id="26165"
        />
        <path
          className="white"
          d="M 378.33 361.46 380.45 361.54 384.27 361.7 386.41 361.78 386.18 370 385.12 369.98 377.98 369.78 378.33 361.46 Z"
          data-name="Parker"
          data-stusps="TX"
          id="48367"
        />
        <path
          className="white"
          d="M 387.25 377.18 387.41 376.98 393.49 375.53 395.76 379.56 396.48 379.15 399.26 384.03 395.83 385.99 394.18 383.08 390.31 385.24 389.54 384.42 390.26 383.41 388.66 382.87 387.78 381.68 388.73 380.96 387.05 380.09 387.25 377.18 Z"
          data-name="Hill"
          data-stusps="TX"
          id="48217"
        />
        <path
          className="white"
          d="M 676.2 213.25 676.48 213.69 677.63 214.91 677.73 215.85 678.24 216.37 677.74 218.29 677.52 219.53 677.38 220.28 677.38 220.28 673.86 218.39 673.85 218.39 673.85 218.39 673.77 218.14 674.3 217.21 674.43 216.25 674.91 215.88 675.88 214.39 676.2 213.25 Z"
          data-name="Jefferson"
          data-stusps="WV"
          id="54037"
        />
        <path
          className="white"
          d="M 484.63 417.54 486.32 419.76 486.15 420.72 488.98 421.22 490.9 422.12 490.86 423.17 491.25 423.47 489.69 423.85 488.22 425.31 488.5 427.01 489.26 427.48 488.93 428.31 488.43 428.57 487.29 428.04 486.78 427.52 487.03 427.06 486.23 426.1 485.15 426.65 484.73 426.12 483.96 425.54 483.83 424.9 483.74 424.37 482.76 423.72 482.04 423.75 482.32 422.45 481.58 421.61 480.43 421.58 479.29 422.08 478.57 422.52 478.43 423.19 477.24 423.14 480.79 419.75 482.15 417.84 484.63 417.54 Z"
          data-name="St. Mary"
          data-stusps="LA"
          id="22101"
        />
        <path
          className="white"
          d="M 590.06 258.13 592.4 258.42 593.04 257.98 594.83 259.35 595.33 259.46 594.45 261.67 594.24 261.7 593.31 261.05 591.38 261.25 590.25 259.7 589.75 259.96 589.3 259.41 590.06 258.13 Z"
          data-name="Powell"
          data-stusps="KY"
          id="21197"
        />
        <path
          className="white"
          d="M 401.09 106.18 407.62 106.21 407.6 112.76 407.77 116.02 407.75 117.65 403.74 117.62 403.99 116.46 403.48 113.9 403.43 112.03 402.83 111.29 402.04 109.84 401.61 107.38 401.09 106.18 Z"
          data-name="Wilkin"
          data-stusps="MN"
          id="27167"
        />
        <path
          className="white"
          d="M 516.99 278.87 519.14 283.88 515.2 284.89 514.82 284.37 514.86 284.12 514.32 283.7 514.33 283.02 513.69 282.04 513.67 282.01 514.62 280.68 515.17 279.74 515.98 279.01 516.99 278.87 Z"
          data-name="Ballard"
          data-stusps="KY"
          id="21007"
        />
        <path
          className="white"
          d="M 631.9 325.49 631.94 324.64 633.95 324.2 636.75 325.5 637.87 325.84 638.34 325.72 637.36 329.43 637.31 329.72 636.21 331.09 633.14 330.51 631.94 328.58 630.18 329.09 630.38 328.37 631.9 325.49 Z"
          data-name="Saluda"
          data-stusps="SC"
          id="45081"
        />
        <path
          className="white"
          d="M 710.14 231.34 711.46 229.73 712.99 229.11 713.82 229.33 715.26 230.99 715.72 232.67 714.11 233.99 714.88 234.77 714.38 235.75 713.5 235.54 712.57 235.72 711.65 237.01 711.17 237.15 710.83 236.07 711.18 234.71 711.07 234.31 710.82 233.55 709.62 233.36 709.28 232.18 710.39 231.66 710.14 231.34 Z M 708.4 235.6 708.94 235.25 709.48 235.77 709.7 237.05 708.7 236.96 708.4 235.6 Z"
          data-name="Somerset"
          data-stusps="MD"
          fillRule="evenodd"
          id="24039"
        />
        <path
          className="white"
          d="M 400.04 172.74 404.91 172.81 404.82 173.09 404.08 173.6 404.34 174.26 403.95 174.77 404.23 175.11 403.65 175.8 403.66 176.06 403.7 176.63 403.13 177.58 402.52 178.48 402.47 179.49 402.92 180.2 403.81 181.08 404.45 182.59 404.49 182.69 404.26 183.41 404.48 183.56 404.92 183.92 404.14 184.06 403.81 183.54 402.61 183.61 402.39 183.21 401.97 182.47 401.27 181.76 401.45 180.72 400.33 180.64 400.01 179.97 399.94 179.93 400.04 172.74 Z"
          data-name="Union"
          data-stusps="SD"
          id="46127"
        />
        <path
          className="white"
          d="M 491.08 286.2 496 285.92 497.42 285.93 498.41 288.69 499.46 290.06 499.41 291.3 498.57 293.02 498.46 293.89 494.31 294.08 493.07 294.15 492.09 290.79 491.97 288.33 491.44 288.35 491.39 287 491.08 286.2 Z"
          data-name="Butler"
          data-stusps="MO"
          id="29023"
        />
        <path
          className="white"
          d="M 277.31 113.19 293.2 115.18 292.19 123.34 291.52 123.26 290.76 129.86 290.25 129.8 279.97 128.57 277.61 128.32 274.42 127.99 274.41 127.99 274.84 124.74 274.66 124.47 275.08 121.24 275.66 121.32 276.75 113.12 277.31 113.19 Z"
          data-name="Powder River"
          data-stusps="MT"
          id="30075"
        />
        <path
          className="white"
          d="M 638.67 399.13 638.84 398.91 641.8 394.99 643.03 393.61 643.35 392.78 645.22 392.27 645.23 392.88 646.41 393.31 647.02 392.46 648.33 393.4 648.4 393.58 648.69 393.82 649.28 396.49 649.86 398.1 648.83 398.25 649.24 401.03 645.12 401.26 644.97 399.94 644.44 399.99 638.87 400.77 638.67 399.13 Z"
          data-name="Duval"
          data-stusps="FL"
          id="12031"
        />
        <path
          className="white"
          d="M 550.2 263.94 550.69 264.12 550.82 263.09 552.17 263.02 551.81 261.82 551.73 260.49 552.22 260.34 556.2 263.1 557.72 264.43 556.26 268.49 554.3 269.2 552.67 268.29 551.56 269.52 550.74 268.56 550.69 267.75 550.94 267.83 549.86 265.34 550.2 263.94 Z"
          data-name="Breckinridge"
          data-stusps="KY"
          id="21027"
        />
        <path
          className="white"
          d="M 553.54 176.9 556.62 176.51 560.03 176.12 560.92 182.66 554.35 183.5 553.54 176.9 Z"
          data-name="Kalamazoo"
          data-stusps="MI"
          id="26077"
        />
        <path
          className="white"
          d="M 604.15 188.89 605.26 188.65 606.37 187.68 607.86 186.95 608.89 186.45 609.29 186.58 609.42 186.63 609.72 189.46 611.06 189.26 611.28 190.68 609.94 190.91 610.15 192.32 608.75 192.55 608.91 193.74 607.55 193.95 607.75 195.34 605.39 195.67 604.93 193.14 604.9 192.94 604.65 191.57 604.41 190.27 604.4 190.21 604.15 188.89 Z"
          data-name="Lorain"
          data-stusps="OH"
          id="39093"
        />
        <path
          className="white"
          d="M 341.34 311.09 349.61 311.46 349.46 315.15 349.27 319.65 340.97 319.27 341.34 311.09 Z"
          data-name="Wheeler"
          data-stusps="TX"
          id="48483"
        />
        <path
          className="white"
          d="M 418.31 251.86 418.3 248.36 419.48 248.15 421.45 248.8 422.88 248.57 422.91 250.06 424.81 249.71 424.85 254.28 418.32 254.32 418.31 251.86 Z"
          data-name="Douglas"
          data-stusps="KS"
          id="20045"
        />
        <path
          className="white"
          d="M 439.77 267.24 439.83 263.91 447.13 263.99 447.62 263.86 448.02 264.01 447.98 266.37 447.93 269.37 447.09 269.36 447.06 270.99 446.24 270.99 443.51 270.95 443.53 269.86 439.71 269.78 439.77 267.24 Z"
          data-name="St. Clair"
          data-stusps="MO"
          id="29185"
        />
        <path
          className="white"
          d="M 546.41 177.76 553.54 176.9 554.35 183.5 547.91 184.21 547.53 180.98 545.54 181.21 545.66 180.99 546.36 178.24 546.41 177.76 Z"
          data-name="Van Buren"
          data-stusps="MI"
          id="26159"
        />
        <path
          className="white"
          d="M 571.97 392.44 574.27 392.24 576.6 391.99 579.37 391.7 580.69 391.56 580.23 392.05 579.33 394.88 579.17 396.54 577.26 396.67 576.3 395.92 575.79 395.96 575.56 397.64 572.41 397.9 571.97 392.44 Z"
          data-name="Holmes"
          data-stusps="FL"
          id="12059"
        />
        <path
          className="white"
          d="M 332.6 115.99 332.63 115.99 335.3 116.2 338.41 116.44 340.93 116.61 344.31 116.84 348.83 117.14 352.11 117.34 352.11 117.34 352.27 117.35 353.66 118.83 354.5 122.26 353.17 122.93 352.8 123.95 351.99 125 353.84 126.3 338.93 125.37 331.93 124.86 332.6 115.99 Z"
          data-name="Corson"
          data-stusps="SD"
          id="46031"
        />
        <path
          className="white"
          d="M 482.92 287.42 482.82 283.62 485.81 283.29 486.65 284.04 489.44 283.96 490.19 283.93 491.08 286.2 491.39 287 491.44 288.35 484.59 288.47 482.94 288.51 482.92 287.42 Z"
          data-name="Carter"
          data-stusps="MO"
          id="29035"
        />
        <path
          className="white"
          d="M 374.57 438.62 377.84 435.99 382.3 432.4 384.16 434.53 381.79 436.42 384.71 440.09 381.3 442.76 379.06 441.75 377.56 442.28 376.06 440.44 374.57 438.62 Z"
          data-name="Karnes"
          data-stusps="TX"
          id="48255"
        />
        <path
          className="white"
          d="M 379.56 157.91 384.42 158.05 384.29 164.65 382.24 164.61 379.42 164.53 379.56 157.91 Z"
          data-name="Davison"
          data-stusps="SD"
          id="46035"
        />
        <path
          className="white"
          d="M 214.19 273 220.63 273.89 224.28 274.38 230.01 275.12 237.87 276.12 238.79 276.23 238.13 277.01 238.1 277.99 235.72 279.02 235.34 279.55 233.88 290.56 233.33 294.7 211.55 291.82 211.86 289.66 213.86 275.35 214.19 273 Z"
          data-name="San Juan"
          data-stusps="NM"
          id="35045"
        />
        <path
          className="white"
          d="M 298.48 366.94 312.08 367.79 311.59 375.99 310.37 375.91 302.18 375.42 301.45 375.35 297.93 375.12 298.01 374.03 298.48 366.94 Z"
          data-name="Andrews"
          data-stusps="TX"
          id="48003"
        />
        <path
          className="white"
          d="M 631.08 190.02 630.74 188.15 630.4 186.25 629.86 183.32 635.47 182.46 637.22 181.95 638.34 187.94 637.48 189.79 637.29 190.1 636.44 189.42 634.82 189.44 631.1 190.18 631.08 190.02 Z"
          data-name="Mercer"
          data-stusps="PA"
          id="42085"
        />
        <path
          className="white"
          d="M 428.63 245.56 429.37 246.14 430.27 245.86 431.1 246.37 431.42 246.39 431.56 246.4 431.35 247.18 431.36 248.48 427.45 248.26 426.97 249.52 427.05 245.55 428.63 245.56 Z"
          data-name="Wyandotte"
          data-stusps="KS"
          id="20209"
        />
        <path
          className="white"
          d="M 38.82 68.14 42.59 69.57 40.46 75.26 40.61 75.7 41.96 76.2 40.04 81.6 38.4 80.99 37.96 82.38 36.29 82.72 36.62 83.52 34.39 82.7 34.08 82.7 32.02 81.96 32.08 81.76 33.4 79.5 34.01 77.91 35.18 75.55 35.7 74.24 36.23 72.42 36.64 71.78 37.97 69.84 38.82 68.14 Z"
          data-name="Lincoln"
          data-stusps="OR"
          id="41041"
        />
        <path
          className="white"
          d="M 593.71 146.92 586.78 148.31 582.05 149.19 581.29 147.81 581.51 146.85 581.89 145.03 582.14 144.33 583.78 143.72 583.96 143.01 585.62 142.38 586.75 141.76 586.96 141.16 588.18 140.5 590.16 141.08 591.52 142.3 592.91 144.33 593.48 146 593.71 146.92 Z"
          data-name="Huron"
          data-stusps="MI"
          id="26063"
        />
        <path
          className="white"
          d="M 575.12 300.76 575.43 300.63 575.28 298.46 574.82 297.25 574.84 294.93 576.27 294.8 576.99 293.97 578.01 293.25 579.9 293.31 581.61 294.37 583.11 296.02 583.91 297.58 583.27 298.61 582.54 299.33 582.24 299.4 580.61 300.75 580.41 300.65 575.41 301.26 575.12 300.76 Z"
          data-name="Cumberland"
          data-stusps="TN"
          id="47035"
        />
        <path
          className="white"
          d="M 679.35 248.95 680.83 249.31 681.53 247.84 683.42 249.15 685.99 249.47 684.19 252.55 683.52 252.84 682.63 251.89 681.03 251.76 679.2 252.97 679.16 249.34 679.35 248.95 Z"
          data-name="Powhatan"
          data-stusps="VA"
          id="51145"
        />
        <path
          className="white"
          d="M 553.81 131.25 553.78 130.52 560.18 129.52 561.02 136.04 554.53 136.88 553.81 131.25 Z"
          data-name="Kalkaska"
          data-stusps="MI"
          id="26079"
        />
        <path
          className="white"
          d="M 546.64 318.65 552.45 318.25 553.27 318.2 553.27 318.2 553.93 326.51 553.16 326.47 548.8 324.4 546.84 323.1 546.26 323.24 545.96 322.98 546.88 322.1 546.64 318.65 Z"
          data-name="Limestone"
          data-stusps="AL"
          id="1083"
        />
        <path
          className="white"
          d="M 648.92 410.41 652.23 409.93 654.01 408.83 655.08 410.93 656.4 413.24 655.56 413.66 656.01 416.41 651.56 417.07 651.17 414.44 650.95 414.49 650.24 414.61 649.26 412.73 648.92 410.41 Z"
          data-name="Flagler"
          data-stusps="FL"
          id="12035"
        />
        <path
          className="white"
          d="M 18.28 176.63 20.49 177.33 19.23 181.08 18.54 180.87 19.07 181.35 18.25 182.27 19.2 184.11 21.83 186.31 20.89 188.55 21.85 189.54 21.57 190.66 22.37 191.72 21.42 191.4 21.03 191.72 21.19 192.6 20.79 193.74 19.21 195.32 16.53 195.27 15.29 191.64 14.73 190.86 13.14 189.29 13.17 187.26 12.28 186.47 12.46 185.94 12.91 183.45 14.53 182.66 14.41 179 15.18 177.23 17.89 177.58 18.28 176.63 Z"
          data-name="Lake"
          data-stusps="CA"
          id="6033"
        />
        <path
          className="white"
          d="M 70.43 25.81 72.99 25.37 74.55 23.54 76.77 22.38 76.58 21.45 76.81 21.49 77.52 21.21 78.27 21.94 78.46 24.15 78.01 25.04 76.32 29.35 74.21 31.5 70.9 30.26 71.71 28.1 68.73 26.98 70.43 25.81 Z"
          data-name="Kitsap"
          data-stusps="WA"
          id="53035"
        />
        <path
          className="white"
          d="M 587.02 292.34 587.57 292.06 587.95 291.21 590.04 291.71 590.1 290.41 592.54 290.39 592.95 288.97 593.45 289.51 593.58 289.84 594.61 290.98 592.55 293.48 593.17 294.03 591.17 295.1 590.1 296.24 590.19 296.81 589.26 295.36 588.8 294.32 586.94 292.77 587.02 292.34 Z"
          data-name="Anderson"
          data-stusps="TN"
          id="47001"
        />
        <path
          className="white"
          d="M 510.75 373.69 511.2 373.63 517.26 373.28 517.84 381.19 516.48 381.37 512.46 381.91 512.03 376.91 510.94 376.97 510.75 373.69 Z"
          data-name="Smith"
          data-stusps="MS"
          id="28129"
        />
        <path
          className="white"
          d="M 454.38 138.66 462.81 138.39 462.97 141.65 463.09 144.36 460.65 144.48 460.04 144.13 459.53 144.17 457.5 143.89 456.56 143.26 455.45 141.87 454.96 141.41 454.11 140.61 453.93 140.44 454.36 138.81 454.38 138.67 454.38 138.66 Z"
          data-name="Pierce"
          data-stusps="WI"
          id="55093"
        />
        <path
          className="white"
          d="M 573.36 323.24 573.95 322.31 573.9 321.75 574.4 320.55 574.26 319.19 574.43 318.34 575.3 316.18 576.64 316.01 576.83 315.99 577.1 318.45 578.08 318.35 578.24 319.84 579.14 319.89 578.87 320.82 580.7 320.63 580.91 322.47 580.69 323.16 580.09 323.22 576.16 323.75 573.55 323.89 573.36 323.24 Z"
          data-name="Walker"
          data-stusps="GA"
          id="13295"
        />
        <path
          className="white"
          d="M 618.96 401.7 619.62 399.43 619.95 399.2 621.28 397.94 622.63 398.04 626.24 399.4 627.03 406.05 627.61 406.38 627.04 407.09 626.05 407.61 625.83 408.1 624.22 406.24 620.71 404.4 619.63 404.45 618.96 401.7 Z"
          data-name="Suwannee"
          data-stusps="FL"
          id="12121"
        />
        <path
          className="white"
          d="M 500.45 191.84 503.36 191.56 503.49 191.92 510.12 191.29 510.56 196.23 507.33 196.48 507.41 197.29 500.85 197.79 500.45 191.84 Z"
          data-name="Lee"
          data-stusps="IL"
          id="17103"
        />
        <path
          className="white"
          d="M 504.25 412.79 504.88 412.53 505.92 412.22 506.72 412.64 506.63 416.2 506.41 416.74 506.56 417.39 507.74 416.72 508.62 417.61 507.69 418.92 507.63 419.99 509.27 422.82 509.54 425.97 510.92 428.84 510.07 429.62 508.46 431.02 507.96 431.41 509.33 428.82 508.79 428.21 508.85 426.39 506.89 425.58 506.01 424 506.55 423.51 506.4 421.83 505.2 421.61 506.06 419.4 505.98 419.03 504.85 418.43 504.11 416.48 504.07 415.75 504.06 414.2 504.25 412.79 Z"
          data-name="Jefferson"
          data-stusps="LA"
          id="22051"
        />
        <path
          className="white"
          d="M 582.59 288.9 584.84 291.33 587.02 292.34 586.94 292.77 588.8 294.32 587.34 295.7 584.99 296.59 583.91 297.58 583.11 296.02 581.61 294.37 579.9 293.31 580.11 290.82 581.27 290.46 582.59 288.9 Z"
          data-name="Morgan"
          data-stusps="TN"
          id="47129"
        />
        <path
          className="white"
          d="M 199.71 270.9 207.37 272.02 214.19 273 213.86 275.35 211.86 289.66 211.55 291.82 211.23 294.14 210.54 299.16 209.89 303.89 209.41 307.45 208.87 311.53 208.87 311.53 207.9 318.73 207.76 319.8 206.14 332.05 205.89 333.9 201.12 333.25 200.76 333.96 198.82 334.62 198.47 335.32 193.15 337.89 191.97 336.07 192.52 332.09 193.03 332.16 193.96 325.57 195.06 319.01 195.02 317.33 195.49 315.71 196.05 312.4 197.96 299.24 198.61 296.54 195.93 296.15 199.71 270.9 Z"
          data-name="Apache"
          data-stusps="AZ"
          id="4001"
        />
        <path
          className="white"
          d="M 430.62 219.83 432.02 219.83 432.92 219.81 435.22 219.76 436.34 219.73 436.39 221.64 436.66 223.25 431.15 223.29 430.99 221.85 430.65 221.69 430.62 219.83 Z"
          data-name="Worth"
          data-stusps="MO"
          id="29227"
        />
        <path
          className="white"
          d="M 553.74 286.85 553.91 286.88 554.54 286.55 556.01 286.48 559.15 286.34 559.21 288.98 559.09 289.23 558.54 289.94 558.52 291.95 558.35 292.61 555.98 292.42 555.02 293.61 554.47 292.89 553.97 294.34 553.27 294.22 551.23 291.55 552.17 291.43 553.74 286.85 Z"
          data-name="Sumner"
          data-stusps="TN"
          id="47165"
        />
        <path
          className="white"
          d="M 700.89 217.29 701.84 217.79 702.21 215.67 703.53 214.02 703.75 212.44 705.78 211.55 707.46 211.45 708.04 213.38 706.91 214.33 705.91 217.2 706.04 218.33 703.73 218.33 703.91 219.53 702.64 220.34 702.36 219.67 702.23 218.99 701.53 219.14 700.61 219.69 700.58 220.71 700 221.03 699.84 219.3 700.14 217.9 700.3 217.2 700.89 217.29 Z"
          data-name="Queen Anne's"
          data-stusps="MD"
          id="24035"
        />
        <path
          className="white"
          d="M 708.87 176.71 708.66 176.47 709.37 175.52 709.57 175.19 709.96 174.51 710.14 173.83 710.21 173.55 710.58 173.77 713.79 176.16 714.2 176.47 713.54 178.79 713.06 179.23 712.29 180.96 712.1 181.13 710.12 183.16 709.67 183.99 709.58 183.68 709.42 183.14 709.04 181.67 709.03 180.7 709.86 179.98 709.9 179.95 709.88 178.79 710.07 178.01 709.42 177.35 708.87 176.71 Z"
          data-name="Warren"
          data-stusps="NJ"
          id="34041"
        />
        <path
          className="white"
          d="M 552.11 313.14 553.39 313.23 555.49 311.63 555.47 310.91 556.63 311 556.68 311.81 558.9 313.05 559.54 315.12 560.24 314.98 560.48 317.54 558.17 317.76 553.27 318.2 553.27 318.2 552.45 318.25 552.11 313.14 Z"
          data-name="Lincoln"
          data-stusps="TN"
          id="47103"
        />
        <path
          className="white"
          d="M 518.25 248.57 518.14 246.91 523.02 246.59 523.11 247.69 524.64 247.65 524.83 249.84 524.48 251.85 525.09 252.31 520.2 252.56 518.53 252.71 518.25 248.57 Z"
          data-name="Clay"
          data-stusps="IL"
          id="17025"
        />
        <path
          className="white"
          d="M 598.42 287.47 598.6 287.68 600.46 287.03 602.54 285.62 603.86 285.92 604.21 285.75 604.12 286.07 604.86 287.69 603.72 287.7 602.06 289.42 601.9 290.28 600.75 290.29 598.85 291.62 599.06 292.45 598.5 291.96 597.86 290.99 598.11 290.78 598.42 287.47 Z"
          data-name="Grainger"
          data-stusps="TN"
          id="47057"
        />
        <path
          className="white"
          d="M 448.83 122.53 452.79 122.42 452.42 122.7 452.24 124.04 452.23 124.14 452.37 125.36 453.42 125.52 454.02 125.6 454.42 126.18 455 127.17 455.56 127.79 455.43 128.58 454.94 129.72 454.32 130.51 450.72 130.62 450.65 128.47 450.51 125.74 448.93 125.77 448.83 122.53 Z"
          data-name="Chisago"
          data-stusps="MN"
          id="27025"
        />
        <path
          className="white"
          d="M 652.53 207.36 653.88 205.73 655.09 202.08 656.95 201.72 657.32 201.83 657.72 202.36 661 201.73 660.18 205.55 661.13 209.95 660.76 211.99 659.01 212.33 657.3 212.66 652.24 213.66 651.94 213.45 652.55 212.43 651.4 211.23 652.53 207.36 Z"
          data-name="Somerset"
          data-stusps="PA"
          id="42111"
        />
        <path
          className="white"
          d="M 439.96 102.65 439.86 98.38 449.09 98.17 449.2 103.05 449.22 104.72 449.3 106.3 449.4 106.57 449.52 109.57 449.7 114.47 446.71 114.54 444.77 114.71 444.73 112.97 439.97 113.17 439.78 113.02 440.04 106.65 439.96 102.65 Z"
          data-name="Aitkin"
          data-stusps="MN"
          id="27001"
        />
        <path
          className="white"
          d="M 671.02 278.36 673.31 278.02 673.74 280.85 674.66 281.01 675.67 281.99 675.07 283.86 674.32 283.97 674.15 285.1 672.97 285.29 671.28 285.68 671.25 284.92 671.02 278.36 Z"
          data-name="Durham"
          data-stusps="NC"
          id="37063"
        />
        <path
          className="white"
          d="M 503.81 402.48 508.09 403.15 510.82 402.94 510.92 403.4 511.5 405.11 512.86 406.43 513.09 406.86 513.48 407.6 514.31 409.54 514.84 411.23 516.24 411.84 514.96 412.62 514.62 412.44 513.62 412.08 511.8 412.46 510.04 411.84 507.84 412.77 506.72 412.64 505.92 412.22 505.8 411.38 504.33 409.06 504.19 406.39 504.07 403.74 503.81 402.48 Z"
          data-name="St. Tammany"
          data-stusps="LA"
          id="22103"
        />
        <path
          className="white"
          d="M 515.01 298.32 517.96 298.18 517.95 297.78 519.54 299.27 522.25 300.49 522.41 305.61 519.19 305.72 516.14 304.71 515.6 302.75 514.76 302.21 514.47 302 515.11 301.69 515.01 298.32 Z"
          data-name="Gibson"
          data-stusps="TN"
          id="47053"
        />
        <path
          className="white"
          d="M 494.25 418.11 495.99 417.72 498.01 418.24 498.45 418.11 500.09 418.23 500.94 418.9 501.17 419.71 502.78 420.47 503.17 421.65 505.2 421.61 506.4 421.83 506.55 423.51 506.01 424 506.89 425.58 508.85 426.39 508.79 428.21 509.33 428.82 507.96 431.41 507.43 431.81 505.83 433 504.01 433.49 502.78 433.65 502.62 430.25 502.93 427.86 498.84 423.66 497.71 422.84 497.36 422.48 495.59 420.48 494.49 421.64 492.42 421.76 492.8 421.18 493.67 419.54 494.28 418.63 494.25 418.11 Z"
          data-name="Lafourche"
          data-stusps="LA"
          id="22057"
        />
        <path
          className="white"
          d="M 390.78 256.56 397.28 256.66 397.27 258.29 398.89 258.31 398.59 261.56 398.49 266.49 393.86 266.4 393.89 264.77 390.65 264.74 390.78 256.56 Z"
          data-name="Marion"
          data-stusps="KS"
          id="20115"
        />
        <path
          className="white"
          d="M 55.76 68.65 56.09 68.6 56.24 68.22 57.49 68.97 58.17 67.08 58.68 67.27 59.42 67.02 61.37 67.64 70.04 70.72 70.48 70.85 71.52 73.04 70.79 75.21 70.93 75.44 69.77 76.68 70.37 78.32 70.06 78.95 67.79 79.29 67.9 81.98 59.04 78.9 57.59 77.31 57.35 75.49 56.17 74.24 55.55 72.55 57.06 70.34 55.6 69.81 55.76 68.65 Z"
          data-name="Clackamas"
          data-stusps="OR"
          id="41005"
        />
        <path
          className="white"
          d="M 577.59 221.69 578.45 221.55 582.33 220.98 582.43 221.68 583.98 221.59 584.02 222.15 583.48 222.45 583.82 227.39 581.28 227.5 580.13 227.65 578.47 227.84 577.59 221.69 Z"
          data-name="Montgomery"
          data-stusps="OH"
          id="39113"
        />
        <path
          className="white"
          d="M 166.99 234.74 168.38 232.87 170.4 233.35 171.94 232.63 172.33 230.02 173.99 228.48 175.01 228.66 176.06 227.17 178.39 227.84 186.55 229.3 184.75 239.15 178.11 237.99 177.87 238.1 172.72 236.98 166.72 235.91 166.99 234.74 Z"
          data-name="Sevier"
          data-stusps="UT"
          id="49041"
        />
        <path
          className="white"
          d="M 705.23 300.09 707.19 299.75 708.18 298.85 711.08 297.8 711.46 296.36 710.36 295.7 715.91 290.22 719.95 290.91 721.03 291.95 719.37 293.76 718.18 295.65 717.17 296.91 716.23 298.45 715.49 299.99 714.62 302.66 714.19 301.96 713 301.32 711.2 301.19 708.42 302.01 705.33 303.5 704.69 301.28 703.95 300.86 703.98 300.65 705.23 300.09 Z"
          data-name="Carteret"
          data-stusps="NC"
          id="37031"
        />
        <path
          className="white"
          d="M 335.06 195.44 342.53 195.96 342.99 195.98 344.83 196.1 344.44 202.59 336.57 202.1 334.63 201.96 335.06 195.44 Z"
          data-name="McPherson"
          data-stusps="NE"
          id="31117"
        />
        <path
          className="white"
          d="M 447.64 258.14 450.9 258.17 450.9 257.62 454.2 257.63 454.19 262.64 454.51 264.08 454.49 266.39 447.98 266.37 448.02 264.01 447.62 263.86 447.64 258.14 Z"
          data-name="Benton"
          data-stusps="MO"
          id="29015"
        />
        <path
          className="white"
          d="M 414.46 308.37 416.23 308.36 417.16 310.07 420.66 308.98 422.1 309.15 424.22 309.14 424.24 312.4 424.18 314.52 424.9 315.72 425.45 315.77 423.62 318.57 422.55 319.47 420.95 318.9 420.92 314.06 415.28 314.07 415.27 310.81 414.46 310.81 414.46 308.37 Z"
          data-name="Muskogee"
          data-stusps="OK"
          id="40101"
        />
        <path
          className="white"
          d="M 426.92 373.62 433.19 373.66 433.38 373.11 433.76 372.86 434.77 373.1 434.18 375.4 433.4 376.73 433.14 381.01 434.56 380.98 434.58 381.93 435.53 383.4 427.77 383.46 427.01 383.45 426.96 377.98 426.92 373.62 Z"
          data-name="Rusk"
          data-stusps="TX"
          id="48401"
        />
        <path
          className="white"
          d="M 317.96 326.21 323.69 326.56 326.13 326.7 325.67 334.87 324.22 334.78 317.47 334.38 317.96 326.21 Z"
          data-name="Swisher"
          data-stusps="TX"
          id="48437"
        />
        <path
          className="white"
          d="M 144.17 230.27 148.63 231.15 160.13 233.45 166.99 234.74 166.72 235.91 168.82 239.77 168.13 241.76 166.56 242.94 166.04 242.89 151.19 240.04 142.53 238.31 142.92 236.39 143.51 233.46 144.17 230.27 144.17 230.27 Z"
          data-name="Beaver"
          data-stusps="UT"
          id="49001"
        />
        <path
          className="white"
          d="M 659.27 230.1 660.16 227.71 659.13 225.73 660.03 221.65 665.71 222.89 666.58 222.46 667.52 223.12 667.3 223.87 667.03 224.78 666.26 225.45 665.56 226.7 664.33 227.57 663.84 228.89 663.38 230.31 661.18 229.22 660.97 230.07 660.6 230.87 659.27 230.1 Z"
          data-name="Hardy"
          data-stusps="WV"
          id="54031"
        />
        <path
          className="white"
          d="M 290.25 129.8 290.76 129.86 290.93 129.88 303.82 131.33 303.26 137.08 303.03 139.34 302.43 145.36 302.29 146.67 297.97 146.2 288.44 145.27 289.67 133.8 290.25 129.8 Z"
          data-name="Crook"
          data-stusps="WY"
          id="56011"
        />
        <path
          className="white"
          d="M 291.04 175.32 291.64 175.4 299.41 176.13 299.2 178.23 298.75 182.92 298.32 187.31 298.29 187.59 298.08 189.77 297.74 193.29 297.59 194.88 297.51 195.8 289.03 194.95 289.2 193.29 291.04 175.32 Z"
          data-name="Goshen"
          data-stusps="WY"
          id="56015"
        />
        <path
          className="white"
          d="M 463.04 194.7 469.59 194.43 469.93 201.01 468.28 201.09 463.32 201.33 463.04 194.7 Z"
          data-name="Iowa"
          data-stusps="IA"
          id="19095"
        />
        <path
          className="white"
          d="M 533.51 227.26 533.28 224.85 533.06 222.28 533.68 222.61 534.89 222.5 534.7 225.67 535.01 225.8 536.13 227.41 535.9 231.4 536.17 232.23 533.99 232.44 533.89 231.36 533.51 227.26 Z"
          data-name="Vermillion"
          data-stusps="IN"
          id="18165"
        />
        <path
          className="white"
          d="M 603.02 387.79 604.87 387.61 604.93 388.28 609.31 387.88 609.97 395.07 608.7 395.13 605.63 395.28 604.37 395.34 604.02 390.85 603.18 389.63 603.02 387.79 Z"
          data-name="Thomas"
          data-stusps="GA"
          id="13275"
        />
        <path
          className="white"
          d="M 713.12 167.76 717.03 168.96 718.54 169.46 717.17 172.19 716.84 172.83 715.78 174.99 715.96 175.39 715.09 176.48 714.2 176.47 713.79 176.16 710.58 173.77 710.21 173.55 710.24 173.46 711.09 172.34 711.29 170.84 711.7 169.36 712.27 168.32 713.12 167.76 Z"
          data-name="Sussex"
          data-stusps="NJ"
          id="34037"
        />
        <path
          className="white"
          d="M 441.53 351.31 442.44 351.61 442.63 351.25 442.49 350.98 442.84 350.98 442.87 351.26 443.1 351.25 443.36 350.72 443.6 350.93 443.74 350.81 443.52 350.57 443.77 350.5 443.82 350.73 444.09 350.53 444.36 350.15 444.76 350.29 444.93 350.16 445.81 352.22 446.64 352.52 446.26 353.23 447 354.28 446.92 355.19 447.56 355.36 446.44 357.78 446.49 358.45 444.98 358.8 444.52 359.74 445.44 361.22 445.32 361.22 441.71 361.29 441.67 358.64 441.63 356.56 441.61 355.45 441.58 353.48 441.53 351.31 Z"
          data-name="Miller"
          data-stusps="AR"
          id="5091"
        />
        <path
          className="white"
          d="M 431.36 248.48 431.35 247.18 431.56 246.4 431.78 245.9 431.65 246.99 432.19 246.84 432.34 246.62 432.57 246.5 432.98 246.46 433.13 246.55 433.48 247.02 434 246.61 434.33 246.17 434.36 245.98 434.23 245.63 434.86 246.19 435.31 245.81 435.94 244.79 437.09 245.33 437.66 245.19 438.69 246.49 438.66 248.91 438.63 250.74 438.59 252.32 431.39 252.17 431.37 249.65 431.36 248.48 Z"
          data-name="Jackson"
          data-stusps="MO"
          id="29095"
        />
        <path
          className="white"
          d="M 438.69 246.49 439.86 246.26 440.48 245.29 440.38 246.29 442.52 245.06 443.72 245.2 445.28 244.39 447.6 244.79 447.78 243.49 447.67 250.06 447.67 250.33 442.72 250.27 438.63 250.74 438.66 248.91 438.69 246.49 Z"
          data-name="Lafayette"
          data-stusps="MO"
          id="29107"
        />
        <path
          className="white"
          d="M 369.48 394.5 374.08 391.4 374.26 391.12 375.74 390.27 379.99 397.74 379.9 398.39 371.38 398.31 369.99 397.12 370.29 395.92 369.48 394.5 Z"
          data-name="Lampasas"
          data-stusps="TX"
          id="48281"
        />
        <path
          className="white"
          d="M 636.64 263.52 637.55 263.27 638.73 262.52 637.86 261.71 638.02 260.99 638.12 260.95 638.13 260.95 638.44 260.83 639.6 261.65 641.06 260.6 642.68 259.16 643.96 259.83 644.63 261.69 644.9 261.86 643.97 262.81 642.46 263.66 639.72 265.38 639.01 266.11 636.21 264.08 636.64 263.52 Z"
          data-name="Giles"
          data-stusps="VA"
          id="51071"
        />
        <path
          className="white"
          d="M 641.49 283.4 645.16 281.84 646.33 281.67 647.93 282.27 648.31 282.66 648.45 284.16 647.52 284.91 647.86 286.07 644.81 286.47 641.9 286.84 641.49 283.4 Z"
          data-name="Yadkin"
          data-stusps="NC"
          id="37197"
        />
        <path
          className="white"
          d="M 39.04 201.22 41.05 198.99 41.69 197.78 41.74 197.79 43.45 197.33 44.61 197.88 45.57 197.17 46.6 197.26 47.78 198.97 48.79 199.89 50.45 199.3 51.33 198.26 55.08 199.28 55.87 198.76 57.98 199.35 57.63 200.65 58.71 202.32 58.78 203.63 56.97 205.06 54.97 206 54.62 205.77 53.61 206.95 52.47 206.81 50.71 207.96 47.37 207.79 45.57 207.45 43.11 205.51 39.6 205.61 39.41 201.2 39.04 201.22 Z"
          data-name="El Dorado"
          data-stusps="CA"
          id="6017"
        />
        <path
          className="white"
          d="M 599.78 276.72 601.02 276.66 601.08 276.06 603.08 274.87 604.12 273.73 605.08 273.99 604.72 274.89 607.81 273.33 608.98 273.97 609.18 274.96 608.96 275.45 608.83 275.76 607.14 276.66 606.17 276.73 605.72 277.84 605.53 278.88 604.05 279.39 601.87 280.45 601.16 280.94 600.78 280.99 600.01 279.8 599.78 276.72 Z"
          data-name="Harlan"
          data-stusps="KY"
          id="21095"
        />
        <path
          className="white"
          d="M 507.84 304.46 508.09 304.08 511.63 303.52 512.55 304.6 512.63 304.95 512.43 305.8 511.72 305.75 510.48 310.4 508.54 309.17 505.92 309.66 504.28 311.59 503.71 311.21 503.85 310.3 504.69 309.9 504.31 309.46 503.38 308.68 503.94 307.52 504.74 307.61 505.72 306.89 506.82 306.32 506.68 305.61 506.76 305.11 507.88 304.64 507.84 304.46 Z"
          data-name="Lauderdale"
          data-stusps="TN"
          id="47097"
        />
        <path
          className="white"
          d="M 254.39 297.77 254.36 298.45 254.13 300.17 255.28 300.51 253.93 301.74 251.47 300.25 252.06 297.64 254.39 297.77 Z"
          data-name="Los Alamos"
          data-stusps="NM"
          id="35028"
        />
        <path
          className="white"
          d="M 571.21 306.14 572.69 305.72 573.2 305.28 573.07 305.79 573.67 306.66 576.69 308.96 576.45 309.66 574.62 313.14 574.22 311.73 571.62 310.17 572.57 308.41 570.45 306.25 571.21 306.14 Z"
          data-name="Sequatchie"
          data-stusps="TN"
          id="47153"
        />
        <path
          className="white"
          d="M 690.45 255.31 690.88 255.03 690.89 255.01 690.92 255 690.92 255 690.97 255 690.98 254.98 691 254.97 691.02 254.95 691.04 254.94 691.05 254.91 691.07 254.93 691.35 254.82 691.43 254.68 692.33 255.44 691.38 256.16 691.03 256.34 690.45 255.31 Z"
          data-name="Petersburg"
          data-stusps="VA"
          id="51730"
        />
        <path
          className="white"
          d="M 189.68 62.25 191.44 62.75 193.73 63.28 193.66 64.83 194.35 65.52 193.03 71.3 196.38 72.1 194.94 78.56 198.29 79.25 197.74 81.77 199.35 82.12 199.18 82.94 200.33 83.19 200.5 83.81 200.06 84.72 199.52 87.61 197.37 88.85 195.69 89.06 195.68 89.83 189.47 88.44 191.41 79.66 190.33 79.85 188.43 77.08 189.92 70.58 187.84 70.11 189.68 62.25 Z"
          data-name="Powell"
          data-stusps="MT"
          id="30077"
        />
        <path
          className="white"
          d="M 303.03 139.34 306.25 139.02 309.64 139.36 308.93 145.88 310.57 146.03 310.38 148.2 302.22 147.41 302.29 146.67 302.43 145.36 303.03 139.34 Z"
          data-name="Lawrence"
          data-stusps="SD"
          id="46081"
        />
        <path
          className="white"
          d="M 273.59 274.52 274.18 274.52 276.13 273.2 279.88 272.97 280.75 272.43 280.82 271.57 281.54 271.45 283.19 270.1 283.25 269.45 284.88 267.1 286.56 265.81 290.75 267.75 290.64 269.46 300.42 270.3 305.33 270.69 304.24 282.77 294.48 282.02 290.33 281.71 285.34 281.32 279.4 280.77 273.54 280.17 273.02 280.12 273.59 274.52 Z"
          data-name="Las Animas"
          data-stusps="CO"
          id="8071"
        />
        <path
          className="white"
          d="M 472.91 360.66 475.97 360.56 482.07 360.35 482.53 360.34 482.91 360.32 482.91 360.79 480.97 363.23 479.98 366.8 478.4 368.9 477.4 368.71 476.88 369.72 475.72 370 475.18 368.49 475.64 367.08 474.59 366.18 473.16 366.01 473.31 364.66 472.67 361.48 472.91 360.66 Z"
          data-name="Morehouse"
          data-stusps="LA"
          id="22067"
        />
        <path
          className="white"
          d="M 465.43 408.2 466.15 406.78 465.73 400.54 467.17 400.5 467.6 399.43 469.15 398.46 470.82 399.09 471.59 401.25 471.99 401.24 472.69 402.73 472.75 404.49 472.18 406.49 471.37 407.07 468.8 407.15 467.66 408.28 465.4 408.33 465.43 408.2 Z"
          data-name="Evangeline"
          data-stusps="LA"
          id="22039"
        />
        <path
          className="white"
          d="M 677.26 186.44 678.22 184.98 679.59 182.02 679.49 181.55 681.78 180.66 681.78 179.46 682.73 179.43 683.69 181.04 683.87 182.99 685.2 183.98 683.15 184.32 677.53 187.16 677.26 186.44 Z"
          data-name="Union"
          data-stusps="PA"
          id="42119"
        />
        <path
          className="white"
          d="M 104.93 46.04 105.57 44.2 106.92 43.73 107.91 42.55 112.25 43.89 112.78 42.28 114.89 41.23 116.04 41.31 116.92 39.51 118.43 38.51 118.95 36.9 120.2 36.69 120.74 35.96 122.26 36.43 122.26 36.81 118.18 49.45 116.1 55.96 111.19 54.38 110.14 57.64 109.8 58.74 108.72 58.38 108.27 57.24 106.42 58.3 103.02 57.6 102.7 57.29 102.41 55.16 103.37 54.21 103.76 51.35 103.57 48.62 104.42 47.81 104.93 46.04 Z"
          data-name="Grant"
          data-stusps="WA"
          id="53025"
        />
        <path
          className="white"
          d="M 686.23 270.33 690.22 270.02 691.84 270.94 691.68 272.6 692.48 273.08 693.87 272.38 695.2 274.32 696.54 274.92 696.84 274.89 698.02 275.9 696.65 276.84 696.48 277.02 695.73 278.33 693.84 278.08 693.26 277.02 690.62 276.4 690.34 276.84 687.75 277.14 685.68 276.37 686.49 272.68 686.23 270.33 Z"
          data-name="Halifax"
          data-stusps="NC"
          id="37083"
        />
        <path
          className="white"
          d="M 68.17 234.93 82.51 238.49 84.31 241.19 89.49 248.95 90.43 250.36 92.41 253.3 98.6 262.52 99.97 264.55 103.42 269.65 105.88 273.29 106.46 274.14 108.92 277.73 107.48 277.75 99.06 275.95 83.9 272.52 77.93 271.09 73.4 270.01 72.05 269.88 72.43 268.47 72.84 268.47 73.02 266.16 72.67 265.57 72.46 260.04 73.19 258.86 71.83 256.73 71.87 254.95 71.24 254.08 71.67 253.4 70.7 251.25 71.04 250.25 71.02 248.43 71.72 247.52 71.37 243.94 69.37 241.84 68.44 241.53 68.4 237.73 67.4 237.17 68.17 234.93 Z"
          data-name="Inyo"
          data-stusps="CA"
          id="6027"
        />
        <path
          className="white"
          d="M 682.81 303.38 684.81 305.12 684.82 305.28 685.23 306 687.62 308.46 687.76 309.32 689.16 309.92 688.12 311.4 686.99 312.23 685.21 312.36 681.72 311.33 678.85 311.8 678.17 311.48 678.49 307.42 676.49 304.9 677.61 304.41 682.51 303.63 682.81 303.38 Z"
          data-name="Bladen"
          data-stusps="NC"
          id="37017"
        />
        <path
          className="white"
          d="M 599.22 354.32 601.4 354.08 601.88 354.03 602.93 353.92 604.5 356.01 606.32 356.52 606.32 356.53 605.27 356.63 601.83 360.14 600.78 359.33 599.86 357.39 598.31 357.47 599.32 355.23 599.22 354.32 Z"
          data-name="Crawford"
          data-stusps="GA"
          id="13079"
        />
        <path
          className="white"
          d="M 123.22 79.49 126.17 80.33 125.69 81.96 125.16 81.81 124.72 83.38 125.12 84.97 124.57 86.88 124.61 89.91 125.53 90.73 125.96 92.27 125.67 93.36 126.02 94.33 128.81 95.11 128.37 96.72 124.41 95.64 123.95 97.26 121.11 96.47 120.59 94.98 118.58 95.67 116.71 94.13 114.71 95.31 113.3 94.24 112.19 94.49 111.28 93.54 111.36 91.84 112.02 89.67 110.58 89.24 110.91 88.1 110.37 87.94 110.86 86.29 114.46 87.17 114.87 85.79 117.9 86.72 118.13 85.91 119.21 86.22 120.39 82.15 121.06 82.35 122.04 80.02 122.98 80.3 123.22 79.49 Z"
          data-name="Union"
          data-stusps="OR"
          id="41061"
        />
        <path
          className="white"
          d="M 588.37 406.04 589.5 403.78 589.29 403.04 590.1 401.26 589.84 399.7 590.63 398.07 591.43 398.01 591.58 399.38 593.25 399.48 593.38 400.6 595.72 401.73 594.7 402.88 594.79 403.5 595.82 406.68 597.31 408.42 598.11 408.69 590.48 409.38 590.26 410.21 588.72 409.37 587.93 408.14 588.37 406.04 Z"
          data-name="Liberty"
          data-stusps="FL"
          id="12077"
        />
        <path
          className="white"
          d="M 706.95 164.38 707.12 164.91 708.37 166.18 709.87 166.62 711.28 166.75 711.91 166.66 712.22 166.62 713.12 167.76 712.27 168.32 711.7 169.36 711.29 170.84 711.09 172.34 710.24 173.46 710.21 173.55 710.14 173.83 707.53 173.33 707.43 171.32 704.22 172.37 704.47 170.46 703.74 169.91 704.93 169.53 706.95 164.38 Z"
          data-name="Pike"
          data-stusps="PA"
          id="42103"
        />
        <path
          className="white"
          d="M 399.63 188.12 400.81 188.13 400.97 187.87 405.8 187.94 406.19 187.86 406.42 188.16 406.41 189.03 406.39 189.1 406.24 190 407.34 191.01 407.27 192.25 406.76 192.85 403.32 192.81 403.33 191.42 399.58 191.38 399.63 188.12 Z"
          data-name="Thurston"
          data-stusps="NE"
          id="31173"
        />
        <path
          className="white"
          d="M 342.51 153.47 342.74 153.49 342.95 150.23 352.14 150.77 351.82 156.81 352.05 159.27 348.72 158.1 346.65 159.14 345.92 158.76 345.87 158.22 345.26 158.07 344.12 156.66 342.32 156.36 342.51 153.47 Z"
          data-name="Jones"
          data-stusps="SD"
          id="46075"
        />
        <path
          className="white"
          d="M 256.03 330.44 265.62 331.37 265.78 329.73 272.36 330.34 271.9 335.21 270.77 348.2 270.73 349.95 270.13 353.07 263.6 352.61 263.89 349.34 257.42 348.75 257.56 347.13 247.77 346.17 247.36 346.1 247.51 344.44 247.85 341.03 252.89 341.74 253.23 338.43 255.24 338.63 256.03 330.44 Z"
          data-name="Lincoln"
          data-stusps="NM"
          id="35027"
        />
        <path
          className="white"
          d="M 502.95 221.51 507.82 221.05 507.9 221.89 509.54 221.73 509.54 221.74 509.93 226.12 510.13 228.58 509.06 228.67 506.35 228.85 505.13 227.83 503.77 227.94 503.6 225.76 503.23 225.22 502.95 221.51 Z"
          data-name="Logan"
          data-stusps="IL"
          id="17107"
        />
        <path
          className="white"
          d="M 565.51 286.01 566.38 285.95 570.09 285.65 570.87 285.51 572.99 285.12 573.07 285.1 573.28 285.08 573.54 286.07 573.35 286.89 570.96 287.78 570.41 289.65 569.05 288.49 567 287.75 565.37 288.35 565.41 286.24 565.51 286.01 Z"
          data-name="Clay"
          data-stusps="TN"
          id="47027"
        />
        <path
          className="white"
          d="M 404.45 182.59 413.05 182.63 414.7 182.62 414.7 184.24 415.7 184.24 415.69 189.18 406.39 189.1 406.41 189.03 406.42 188.16 406.19 187.86 405.42 186.8 405.38 185.42 405.81 184.47 404.92 183.92 404.48 183.56 404.26 183.41 404.49 182.69 404.45 182.59 Z"
          data-name="Woodbury"
          data-stusps="IA"
          id="19193"
        />
        <path
          className="white"
          d="M 441.98 376.71 443.43 376.69 446.35 373.83 447.93 374.33 448.78 375.81 450.05 376.61 450.03 378.32 451.65 380.4 453.04 381.44 452.02 381.43 451.71 383.1 444.72 383.26 444.2 382.35 443.1 381.75 442.26 380.76 442.05 380.53 441.99 377.8 441.98 376.71 Z"
          data-name="De Soto"
          data-stusps="LA"
          id="22031"
        />
        <path
          className="white"
          d="M 417.3 195.71 423.82 195.67 423.86 200.57 424.59 200.57 424.61 202.39 423 202.4 418.16 202.41 418.15 200.6 417.3 200.61 417.3 195.71 Z"
          data-name="Shelby"
          data-stusps="IA"
          id="19165"
        />
        <path
          className="white"
          d="M 708.74 281.67 712.38 281.08 714.53 280.77 714.61 282.47 715.76 282.36 716.42 280.14 718.38 280.4 720.35 279.99 722.39 282.92 724.67 288.72 724.55 288.79 722.37 290.52 721.03 291.95 719.95 290.91 715.91 290.22 713.03 288.17 711.91 288.01 710.06 285.08 711.46 284.83 711.97 283.97 709.84 283.13 708.74 281.67 Z"
          data-name="Hyde"
          data-stusps="NC"
          id="37095"
        />
        <path
          className="white"
          d="M 17.78 220.59 18.04 220.95 20.04 221.76 21.27 221.49 27.12 223.26 27.52 225.46 26.21 227.14 26.34 229.82 28.37 229.83 28.95 231.01 27.83 233.84 28.18 234.39 25.05 233.51 24.68 232.82 23.83 232.92 23.6 233.19 23.49 233.38 23.09 233.56 22.95 233.73 22.81 233.76 22.19 233.96 20.27 231.51 19.63 229.67 19.22 228.97 17.26 227.4 15.59 223.94 15.17 223.13 15.85 220.98 16.7 220.67 17.78 220.59 Z"
          data-name="Santa Clara"
          data-stusps="CA"
          id="6085"
        />
        <path
          className="white"
          d="M 565.33 290.03 565.37 288.35 567 287.75 569.05 288.49 570.41 289.65 570.44 290.18 570.62 291.55 569.83 293.14 566.4 293.22 565.64 292.97 565.33 290.03 Z"
          data-name="Jackson"
          data-stusps="TN"
          id="47087"
        />
        <path
          className="white"
          d="M 693.48 205.17 695.68 204.67 698.3 204.08 698.39 204.06 698.39 204.06 698.85 204.65 701.09 206.5 702.18 207.72 702.42 208.49 702.08 208.58 701.03 209.76 700.11 211.01 699.27 212.23 698.96 212.86 699.08 212.09 697.62 210.2 697.27 209.52 696.68 209.28 694.77 208.4 693.77 206.27 693.48 205.17 Z"
          data-name="Harford"
          data-stusps="MD"
          id="24025"
        />
        <path
          className="white"
          d="M 330.53 142.91 330.54 142.89 332.08 142.5 333.1 142.88 334.47 141.9 336.92 142.3 338.02 141.08 339.04 140.82 339.35 140.2 341.13 140.24 342.44 139.29 342.13 140.35 341.7 146.86 341.33 150.13 342.95 150.23 342.74 153.49 342.51 153.47 329.72 152.59 330.53 142.91 Z"
          data-name="Haakon"
          data-stusps="SD"
          id="46055"
        />
        <path
          className="white"
          d="M 673.85 218.39 673.86 218.39 677.38 220.28 677.07 221.35 675.86 222.92 675.37 223.7 674.46 223.09 672.98 223.06 673.37 221.81 673.85 218.39 Z"
          data-name="Clarke"
          data-stusps="VA"
          id="51043"
        />
        <path
          className="white"
          d="M 108.72 58.38 109.8 58.74 110.14 57.64 123.08 61.66 125 62.19 124.47 62.13 124.09 64.97 123.95 64.83 120.85 63.82 118.47 64.99 117.72 66.6 115.96 67.18 115.34 68.24 113.87 68.72 111.56 68.74 111.18 69.11 108.76 66.72 110.14 62.07 108.98 59.82 108.72 58.38 Z"
          data-name="Franklin"
          data-stusps="WA"
          id="53021"
        />
        <path
          className="white"
          d="M 560.24 314.98 560.24 313 561.01 311.16 560.74 311 562.28 310.3 564.34 310.45 566.19 311.3 566.95 312.48 567.12 312.7 567.54 316.92 560.59 317.52 560.48 317.54 560.24 314.98 Z"
          data-name="Franklin"
          data-stusps="TN"
          id="47051"
        />
        <path
          className="white"
          d="M 279.48 231.93 281.58 232.15 285.13 232.5 284.29 240.7 278.86 240.16 274.53 239.71 276.42 237.43 277.39 234.74 279.09 232.29 279.41 231.98 279.48 231.93 Z"
          data-name="Douglas"
          data-stusps="CO"
          id="8035"
        />
        <path
          className="white"
          d="M 336.57 202.1 344.44 202.59 350.97 202.95 350.84 209.19 351.03 209.47 350.71 215.97 342.79 215.56 336.07 215.2 336.39 209.45 336.15 208.62 336.57 202.1 Z"
          data-name="Lincoln"
          data-stusps="NE"
          id="31111"
        />
        <path
          className="white"
          d="M 85.48 84.06 94.81 87.05 94.37 88.41 95.95 88.9 95.22 92.2 92.18 101.85 88.9 100.84 89.38 99.29 87.75 98.78 88.03 97.85 83.12 96.35 83.88 93.95 85.02 89.56 85.63 89.2 84.78 88.02 85.48 84.06 Z"
          data-name="Wheeler"
          data-stusps="OR"
          id="41069"
        />
        <path
          className="white"
          d="M 509.06 130.38 511.16 130.2 511.53 135.11 508.23 135.39 508.1 133.76 504.82 134.05 504.68 132.43 504.53 130.76 509.06 130.38 Z"
          data-name="Menominee"
          data-stusps="WI"
          id="55078"
        />
        <path
          className="white"
          d="M 631.28 261.98 631.6 262.12 631.23 261.31 632.36 260.14 632.52 258.85 634.05 258.36 637.95 260.71 638.12 260.95 638.02 260.99 637.86 261.71 638.73 262.52 637.55 263.27 636.64 263.52 636.41 263.58 634.71 264.26 633.14 265.36 630.77 263.74 631.28 261.98 Z"
          data-name="Mercer"
          data-stusps="WV"
          id="54055"
        />
        <path
          className="white"
          d="M 358.7 229.48 360.48 229.55 365.14 229.73 366.49 229.78 366.76 229.79 366.47 237.93 358.69 237.64 358.31 237.63 358.7 229.48 Z"
          data-name="Phillips"
          data-stusps="KS"
          id="20147"
        />
        <path
          className="white"
          d="M 529.78 247.17 531.57 247.03 535.26 246.63 535.51 247.1 535.96 248.36 535.41 249.93 534.38 250.75 534.2 251.73 534.08 252.15 530.18 252.43 529.78 247.17 Z"
          data-name="Lawrence"
          data-stusps="IL"
          id="17101"
        />
        <path
          className="white"
          d="M 424.81 228.18 431.11 228.18 431.14 229.81 431.23 233.93 427.25 233.96 427.24 233.85 426.51 232.92 426.17 232.47 425.57 232.52 425.29 229.74 424.57 229.31 424.81 228.18 Z"
          data-name="Andrew"
          data-stusps="MO"
          id="29003"
        />
        <path
          className="white"
          d="M 143.84 290.17 146.22 291.02 146.57 291.64 148.93 293.75 149.17 294.58 152.41 296.09 153.06 296.07 155.19 297.92 156.82 297.75 156.46 299.84 158.12 300.15 157.57 303.48 162.69 304.28 166.31 304.78 165.74 308.15 169.29 308.74 168.24 315.01 167.73 315.93 166.33 316.37 165.85 317.85 164.68 320.51 168.5 321.3 168.48 322.82 167.77 324.12 164.1 323.54 157.31 321.5 157.27 322.09 155.99 323.12 155.02 324.36 147.97 320.89 138.62 319.27 139.69 313.21 140.5 308.57 143.77 290.55 143.84 290.17 Z"
          data-name="Yavapai"
          data-stusps="AZ"
          id="4025"
        />
        <path
          className="white"
          d="M 602.21 366.96 604.08 364.44 604.83 364.38 606.92 364.15 607.46 364.1 608.58 363.99 608.76 364.22 609.06 367.2 609.24 368.91 603.57 369.5 602.15 367.32 602.21 366.96 Z"
          data-name="Dooly"
          data-stusps="GA"
          id="13093"
        />
        <path
          className="white"
          d="M 391.5 217.38 398 217.49 397.97 220.76 397.92 223.65 397.88 224.02 391.38 223.91 391.5 217.38 Z"
          data-name="Saline"
          data-stusps="NE"
          id="31151"
        />
        <path
          className="white"
          d="M 685.82 246.71 688.7 246.56 689.56 247.8 689.86 248.02 692.36 248.7 692.68 248.73 693.51 249.4 693.23 251.64 692.83 251.69 692.5 252.35 690.12 251.46 689.99 250.97 690.18 249.2 689.15 248.15 689.15 248.15 689.05 248.12 688.99 248.12 688.98 248.1 688.87 248.15 688.9 248.23 688.73 248.28 688.72 248.23 688.68 248.25 688.65 248.26 688.56 248.27 688.54 248.27 688.56 248.29 688.55 248.39 688.55 248.43 688.57 248.49 688.58 248.49 688.6 248.51 688.67 248.58 688.67 248.61 688.7 248.64 688.57 248.77 688.42 248.67 688.37 248.63 688.3 248.78 688.07 248.69 688.06 248.71 688.03 248.71 688.03 248.72 687.91 248.65 687.76 248.57 687.74 248.56 686.93 249.45 685.99 249.47 686.53 249.1 685.84 248.46 685.82 246.71 Z"
          data-name="Henrico"
          data-stusps="VA"
          id="51087"
        />
        <path
          className="white"
          d="M 546.71 369.64 547.53 369.56 547.25 366.27 552.22 365.74 553.33 361.1 553.43 362.35 555.03 362.2 555.41 364.58 557.18 368.15 556.5 369.46 557.44 370.33 555.87 370.46 556.17 373.79 551.83 374.15 550.31 372.39 546.79 370.44 546.71 369.64 Z"
          data-name="Dallas"
          data-stusps="AL"
          id="1047"
        />
        <path
          className="white"
          d="M 454.42 361.04 455.07 361.03 458.36 360.96 458.64 360.95 462.54 360.89 462.63 364.57 462.67 365.67 461.04 365.72 460.29 369.01 455.57 369.14 455.62 368.22 454.57 366.7 454.42 361.04 Z"
          data-name="Claiborne"
          data-stusps="LA"
          id="22027"
        />
        <path
          className="white"
          d="M 606.05 332.13 606.52 331.43 607.28 331.23 608.29 330.48 608.67 330.38 609.78 330.86 610.37 330.96 610.16 331.9 610.87 332.72 610.45 333.85 608.08 332.79 606.59 332.73 606.05 332.13 Z"
          data-name="Clarke"
          data-stusps="GA"
          id="13059"
        />
        <path
          className="white"
          d="M 424.19 361.6 424.6 361.2 427.6 360.45 429.45 362.13 430.26 363.19 431.04 363.58 424.21 363.68 424.23 361.79 424.19 361.6 Z"
          data-name="Camp"
          data-stusps="TX"
          id="48063"
        />
        <path
          className="white"
          d="M 706.44 291.09 707.37 291.65 710.63 290.62 710.8 288.07 711.91 288.01 713.03 288.17 715.91 290.22 710.36 295.7 709.4 296.52 706.42 295.7 706.24 293.8 705.38 293.26 706.44 291.09 Z"
          data-name="Pamlico"
          data-stusps="NC"
          id="37137"
        />
        <path
          className="white"
          d="M 545.95 389.82 546.89 390.07 548.97 389.29 559.71 388.41 559.66 389.54 560.85 389.63 561.14 393.08 561.35 393.31 559.77 393.42 559.02 393.48 557.46 393.6 553.65 393.88 553.63 393.88 551.22 394.08 549.38 394.22 547.86 394.35 546.57 394.45 546.3 394.42 545.95 389.82 Z"
          data-name="Escambia"
          data-stusps="AL"
          id="1053"
        />
        <path
          className="white"
          d="M 461.69 146.03 461.87 146.19 463.53 146.71 463.89 146.87 465.56 147.59 466.24 148.38 466.63 150 467.18 150.61 464.15 150.84 464.22 152.46 460.98 152.58 460.91 150.96 457.77 151.07 457.64 147.81 459.26 147.75 459.2 146.12 461.69 146.03 Z"
          data-name="Wabasha"
          data-stusps="MN"
          id="27157"
        />
        <path
          className="white"
          d="M 645.18 290.26 645.4 290.02 649.36 291.73 649.97 291.96 651.35 291.85 651.48 292.54 653.72 294.16 654.36 295.57 652.63 295.87 645.76 296.91 645.51 295.9 644.74 293.84 645.18 290.26 Z"
          data-name="Rowan"
          data-stusps="NC"
          id="37159"
        />
        <path
          className="white"
          d="M 442.25 201.97 447.57 201.91 448.56 202.37 448.78 202.19 448.97 208.39 445.71 208.46 442.42 208.53 442.25 201.97 Z"
          data-name="Warren"
          data-stusps="IA"
          id="19181"
        />
        <path
          className="white"
          d="M 497.54 341.21 497.45 339.57 502.38 339.3 502.29 337.66 505.05 337.52 505.47 337.4 505.59 337.84 505.84 342.4 505.92 343.79 502.64 344.25 502.73 345.9 501.1 345.69 500.2 346.49 500.22 345.48 501.92 345.11 501.92 344.29 497.7 344.48 497.54 341.21 Z"
          data-name="Tallahatchie"
          data-stusps="MS"
          id="28135"
        />
        <path
          className="white"
          d="M 381.3 442.76 384.71 440.09 387.34 438.03 389.16 439.2 390.86 439.41 391.56 440.87 391.14 443.97 391.49 445.04 387.89 448.09 385 446.89 384.9 445.7 382.62 445.15 381.3 442.76 Z"
          data-name="Goliad"
          data-stusps="TX"
          id="48175"
        />
        <path
          className="white"
          d="M 60.42 59.1 61.44 59.05 61.86 57.89 62.63 58.28 65.38 58.01 66.72 59.15 68.81 57.87 65.43 67.23 65.22 67.27 64.34 66.88 63.89 66.13 63.04 66.09 62.47 65.47 60.67 64.27 59.67 63.18 59.55 62.76 59.44 62.33 59.87 61.48 60.14 60.93 60.04 59.83 60.42 59.1 Z"
          data-name="Clark"
          data-stusps="WA"
          id="53011"
        />
        <path
          className="white"
          d="M 327.27 80.03 328.21 80.94 330.41 81.55 331.11 80.79 332.01 81.23 331.72 84.19 332.41 85.18 332.02 89.81 332.8 89.87 332.32 95.84 327.38 95.98 320.86 95.41 321.47 88.88 320.62 88.8 321.22 82.31 327.01 82.84 327.27 80.03 Z"
          data-name="Dunn"
          data-stusps="ND"
          id="38025"
        />
        <path
          className="white"
          d="M 650.6 169.37 655.12 168.43 659.18 167.59 659.7 167.48 660.61 167.29 662.18 174.47 659.23 175.09 659.17 175.41 658.16 175.04 651.51 176.56 650.82 172.63 651.25 172.34 650.6 169.37 Z"
          data-name="McKean"
          data-stusps="PA"
          id="42083"
        />
        <path
          className="white"
          d="M 709.59 194.57 709.82 194.77 710.52 195.26 711.23 195.95 712.02 196.55 711.89 197.8 712.69 197.81 712.57 197.95 711.57 198.44 710.87 198.66 710.06 199.68 710 199.75 708.91 199.46 707.56 199.58 707.44 199.65 707.26 199.74 707.24 199.75 707.01 199.01 709.14 195.44 709.59 194.57 Z"
          data-name="Delaware"
          data-stusps="PA"
          id="42045"
        />
        <path
          className="white"
          d="M 503.02 383.61 503.81 383.37 504.95 382.85 507.32 382.55 507.54 387.04 507.95 389.51 506.63 389.5 506.69 390.6 505.57 390.38 503.39 390.5 503.02 383.61 Z"
          data-name="Lawrence"
          data-stusps="MS"
          id="28077"
        />
        <path
          className="white"
          d="M 449.74 188.68 452.95 188.57 456.21 188.44 456.47 194.96 449.93 195.17 449.74 188.68 Z"
          data-name="Marshall"
          data-stusps="IA"
          id="19127"
        />
        <path
          className="white"
          d="M 502.05 397.15 502.07 397.15 503.47 397.08 509.33 396.75 510.33 396.69 512.07 396.59 512.07 396.59 511.81 398.29 511.23 400.06 510.6 401.85 510.82 402.94 508.09 403.15 503.81 402.48 502.65 399.18 502.15 398.93 502.05 397.15 Z"
          data-name="Washington"
          data-stusps="LA"
          id="22117"
        />
        <path
          className="white"
          d="M 613.27 283.81 614.51 283.8 617.19 282.96 619.18 283.66 619.25 284.14 618.95 286.46 617.96 288.33 616.36 288.83 615.46 289.97 614.52 289.13 614.05 283.95 612.99 284.26 613.27 283.81 Z"
          data-name="Washington"
          data-stusps="TN"
          id="47179"
        />
        <path
          className="white"
          d="M 552.95 259.44 553.57 258.67 554 258.42 554.5 258.14 555.23 258.99 556.46 260.32 558.13 260.39 559.14 261.02 559.63 260.57 560.18 262.71 559.83 263.84 557.72 264.43 556.2 263.1 552.22 260.34 552.46 260.27 552.94 259.45 552.95 259.44 Z"
          data-name="Meade"
          data-stusps="KY"
          id="21163"
        />
        <path
          className="white"
          d="M 717.17 172.19 718.54 169.46 719.62 169.81 720.74 170.12 720.74 170.12 721.11 170.22 720.91 171.73 720.81 172.62 722.46 173.02 722.94 173.11 723.29 173.91 723.96 175.01 723.82 175.84 722.67 175.34 721.4 174.9 720.5 173.01 719.54 173.05 718.13 172.58 717.5 173.15 717.17 172.19 Z"
          data-name="Passaic"
          data-stusps="NJ"
          id="34031"
        />
        <path
          className="white"
          d="M 48.72 63.61 53.04 65.21 54.19 66.23 54.61 67.62 55.76 68.65 55.6 69.81 54.21 68.78 52.82 69.62 52.7 71.77 51.47 72.21 42.82 68.98 42.03 68.68 43 66.07 47.23 67.65 48.72 63.61 Z"
          data-name="Yamhill"
          data-stusps="OR"
          id="41071"
        />
        <path
          className="white"
          d="M 676.29 199.46 679.51 196.49 678.87 197.79 681.87 196.51 685.11 195.34 685.89 194.81 685.92 195.58 687.13 196.56 686.5 196.73 686.71 197.85 685 198.58 683.74 200.4 683.29 201.14 680.18 202.66 679.4 203.83 679.53 203.24 678.09 202.04 676.29 199.46 Z"
          data-name="Cumberland"
          data-stusps="PA"
          id="42041"
        />
        <path
          className="white"
          d="M 502.61 272.85 506.47 272.52 508.03 273.25 507.91 273.81 508.6 274.96 509.36 276.02 509.39 276.98 508.72 277.44 508.43 277.64 508.15 278.47 508.69 278.83 506.66 279.49 504.61 281.64 503.09 281.73 502.61 272.85 Z"
          data-name="Cape Girardeau"
          data-stusps="MO"
          id="29031"
        />
        <path
          className="white"
          d="M 732.18 143.3 733.69 142.46 733.81 144.33 735.49 143.9 737.27 144.48 737.75 142.24 737.8 142.25 738.04 142.58 737.87 143.24 738.22 143.55 738.43 143.57 740.4 142.68 741.35 143.26 742.02 142.34 742.55 141.95 743.46 141.42 743.2 142.75 744.28 143.05 745.04 142.68 745.22 142.92 745.86 145.14 744.97 145.38 743.29 145.84 742.16 146.15 740.58 146.58 740.31 146.65 739.21 147.04 737.38 147.45 737.12 148.21 737.02 148.25 736.54 148.47 735.81 147.89 733.66 148.46 733.53 148.49 732.89 148.65 732.08 146.77 732.18 143.3 Z"
          data-name="Hampden"
          data-stusps="MA"
          id="25013"
        />
        <path
          className="white"
          d="M 191.39 101.47 193.44 100.74 194.42 99.47 194.83 99.9 198.42 100.54 200.19 98.91 202.29 99.25 203.66 100.66 203.62 100.88 204.17 100.99 204.11 101.25 204.66 101.37 204.55 101.91 205.36 102.08 206.6 104.3 209.03 104.79 207.97 110.26 205.4 121.43 205.3 121.34 204.46 121.85 204.12 122.27 199.83 121.16 200.1 119.8 196.31 118.98 196.47 118.18 195.12 117.89 195.47 114.57 193.57 114.17 193.92 112.52 192.28 112.17 193.31 107.27 193.05 105.39 191.42 105.09 190.76 104.11 191.39 101.47 Z"
          data-name="Madison"
          data-stusps="MT"
          id="30057"
        />
        <path
          className="white"
          d="M 73.15 94.06 74.75 94.59 75.28 92.97 77.45 93.68 77.97 92.07 83.88 93.95 83.12 96.35 88.03 97.85 87.75 98.78 89.38 99.29 88.9 100.84 92.18 101.85 90.15 108.37 88.55 107.88 87.01 112.77 85.38 112.26 80.47 110.72 80.97 109.1 79.35 108.58 79.85 106.95 74.84 105.37 75.35 103.75 72.14 102.64 73.19 99.39 71.66 98.81 73.15 94.06 Z"
          data-name="Crook"
          data-stusps="OR"
          id="41013"
        />
        <path
          className="white"
          d="M 125 62.19 127.75 62.08 129.19 59.87 131.09 53.43 132.82 53.95 142.76 56.86 142.21 58.8 142.06 59.32 138.97 70.24 138.6 71.54 138.4 72.41 136.17 71.83 136.12 71.03 136.23 69.39 134.94 67.62 134.35 65.73 132.49 65.75 130.77 64.8 128.97 65.68 128.4 66.18 124.55 65.79 124.09 64.97 124.47 62.13 125 62.19 Z"
          data-name="Whitman"
          data-stusps="WA"
          id="53075"
        />
        <path
          className="white"
          d="M 579.12 261.71 580.09 262.19 580.03 261.7 581.5 263.08 582.08 262.22 583.38 263.44 585.28 266.24 585.04 267.54 583.92 267.42 580.61 265.46 580.41 265.01 580.46 264.69 578.93 263.69 579.73 263.32 579.12 261.71 Z"
          data-name="Garrard"
          data-stusps="KY"
          id="21079"
        />
        <path
          className="white"
          d="M 729.58 124.82 731.61 124.91 735.02 123.7 735.02 124.06 735.19 125.11 735.21 125.26 735.81 126.45 735.67 127.36 735.95 127.76 736.13 128.04 735.68 128.92 735.2 129.32 735.53 130.39 735.36 131.09 735.44 131.24 735.93 132.18 737.03 132.75 737.49 133.32 736.67 133.52 732.56 134.55 731.79 134.75 730.91 134.98 730.87 134.99 729.94 131.42 728.77 131.68 728.75 131.69 727.9 128.13 729.69 127.69 729.15 124.81 729.58 124.82 Z"
          data-name="Windham"
          data-stusps="VT"
          id="50025"
        />
        <path
          className="white"
          d="M 756.73 142.8 757.1 142.59 757.87 141.84 759.28 140.45 759.64 140.1 760.32 139.41 761.33 141.39 762.43 142.19 762.53 142.39 762.75 142.59 763.2 143.38 762.57 144.49 762.98 144.71 762.93 145.15 764.34 144.46 764.71 144.92 765.07 144.97 765.68 145.94 766.54 147.44 767.12 147.53 766.97 147.96 766.51 148.02 766.45 148.05 765.77 148.45 765.76 148.46 765.52 149.3 765.13 150.04 764.63 150.36 764.43 150.48 763.66 150.51 763.23 150.88 762.38 148.97 762.11 147.86 761.14 147.85 761.02 147.75 760.87 147.62 759.76 146.67 758.83 146.44 758.63 146.4 758.2 145.51 757.85 144.35 757.25 144.53 756.92 143.42 756.73 142.8 Z"
          data-name="Bristol"
          data-stusps="MA"
          id="25005"
        />
        <path
          className="white"
          d="M 327.29 171.2 339.07 172.04 342.21 172.25 353.26 172.87 353.11 175.72 353.26 176.95 352.93 183.47 352.81 190.01 351.41 189.93 343.32 189.45 335.21 188.87 327.1 188.23 327.13 181.68 327.21 175.23 327.29 171.2 327.29 171.2 Z"
          data-name="Cherry"
          data-stusps="NE"
          id="31031"
        />
        <path
          className="white"
          d="M 666.59 199.53 667.71 195.67 666.45 194.43 666.66 193.21 665.64 192.31 666.9 190.78 667.38 190.84 669.56 191.16 671.07 189.81 673.19 189.63 673.32 190.65 671.6 193.52 672.16 194.38 671.16 196.59 672.12 197.05 673.58 196.48 674.75 198.5 674.35 199.11 673.21 202.81 672.16 202.2 668.88 201.67 667.18 200.85 666.59 199.53 Z"
          data-name="Huntingdon"
          data-stusps="PA"
          id="42061"
        />
        <path
          className="white"
          d="M 13.33 135.03 17.56 136.54 17.01 138.12 18.57 138.63 21.01 139.59 20.85 143.71 19.38 145.4 19.81 146.87 18.08 148.37 17.18 147.31 16.13 147.39 16.4 149.6 16.04 151.39 11.26 165.39 4.22 163 4.14 162.72 3.71 162.4 3.82 161.22 3.3 160.24 2.69 159.72 2.02 158.34 1.18 156.77 1 156.35 1.62 155.06 1.73 154.17 1.51 152.75 2.29 151.59 4.57 149.09 7.6 146.24 9.42 143.78 9.71 142.62 9.55 141.74 9.76 140.71 10.7 139.96 11.79 138.26 13.23 135.53 13.33 135.03 Z"
          data-name="Humboldt"
          data-stusps="CA"
          id="6023"
        />
        <path
          className="white"
          d="M 384.89 223.78 391.38 223.91 391.26 230.45 390.59 230.43 385.37 230.33 384.73 230.31 384.89 223.78 Z"
          data-name="Thayer"
          data-stusps="NE"
          id="31169"
        />
        <path
          className="white"
          d="M 472.01 179.6 478.58 179.22 478.98 185.79 475.73 185.95 472.47 186.12 472.01 179.6 Z"
          data-name="Delaware"
          data-stusps="IA"
          id="19055"
        />
        <path
          className="white"
          d="M 580.95 350.93 582.77 350.09 582.86 349.48 585.48 348.65 586.71 348.53 586.77 349.15 587.41 355.16 587.1 355.27 582.25 355.74 581.05 351.33 580.95 350.93 Z"
          data-name="Troup"
          data-stusps="GA"
          id="13285"
        />
        <path
          className="white"
          d="M 577.67 216.35 580.75 215.88 583.62 215.81 583.79 218.54 583.98 221.59 582.43 221.68 582.33 220.98 578.45 221.55 577.67 216.35 Z"
          data-name="Miami"
          data-stusps="OH"
          id="39109"
        />
        <path
          className="white"
          d="M 358.69 237.64 366.47 237.93 366.79 237.95 366.45 246.1 358.5 245.81 358.3 245.8 358.69 237.64 Z"
          data-name="Rooks"
          data-stusps="KS"
          id="20163"
        />
        <path
          className="white"
          d="M 244.77 46.44 247.71 46.98 250.78 47.55 256.42 48.52 260.2 49.15 259.65 50.71 259.12 53.92 258.38 53.8 257.5 57 257.05 59.73 256.33 59.11 255.32 63.35 254.56 67.9 252.42 67.26 251.97 68.55 248.67 67.94 248.03 71.46 247.15 70 245.13 70.06 243.38 69.52 241.23 70.55 239.86 69.94 241.26 62.54 241.58 59.53 241.99 59.6 242.8 56.69 243.21 56.75 243.46 55.39 243.09 54.5 244.27 48.03 244.77 46.44 Z"
          data-name="Blaine"
          data-stusps="MT"
          id="30005"
        />
        <path
          className="white"
          d="M 468.76 131.51 470.4 131.45 470.32 129.84 478.49 129.38 478.81 134.28 478.92 135.9 479.03 137.54 469.3 138.11 469.12 134.85 468.83 133.15 468.76 131.51 Z"
          data-name="Chippewa"
          data-stusps="WI"
          id="55017"
        />
        <path
          className="white"
          d="M 494.18 402.81 494.2 400.4 493.9 399.93 494.09 399.63 493.76 398.64 494.31 397.53 495.4 397.48 498.5 397.33 498.65 400.62 498.81 403.9 493.23 404.16 494.17 403.17 494.18 402.81 Z"
          data-name="St. Helena"
          data-stusps="LA"
          id="22091"
        />
        <path
          className="white"
          d="M 649.95 258.94 650.17 259.18 652.09 259.74 653.42 260.18 653.75 260.49 653.72 261.32 654.03 262.08 652.58 264.05 650.67 263.92 650.1 264.76 649.38 265.06 648.82 262.82 647.37 260.96 647.57 260.69 649.95 258.94 Z M 651.09 261.86 652.56 262.58 653.34 260.91 651.75 260.33 651.11 260.97 649.69 261.63 650.35 261.93 651.09 261.86 Z"
          data-name="Roanoke"
          data-stusps="VA"
          fillRule="evenodd"
          id="51161"
        />
        <path
          className="white"
          d="M 176.97 147.74 175.99 152.4 178.64 152.95 179.9 151.48 179.79 152.22 182.59 151.84 182.99 152.93 182.57 156.31 183.86 158.27 182.76 160.85 181.67 160.63 181.34 162.27 179.17 161.83 178.83 163.47 173.99 162.5 174.97 157.59 172.58 157.06 171.87 156.2 172.88 155.43 173.22 153.79 172.41 153.62 173.72 147.05 176.97 147.74 Z"
          data-name="Power"
          data-stusps="ID"
          id="16077"
        />
        <path
          className="white"
          d="M 397.08 238.7 399.29 238.73 402.58 238.76 400.73 240.71 400.42 241.79 401.69 243.88 402.97 245.4 404.25 246.26 405.31 246.16 405.27 248.59 403.66 248.57 398.54 247.69 398.59 245.24 396.96 245.2 397.08 238.7 Z"
          data-name="Riley"
          data-stusps="KS"
          id="20161"
        />
        <path
          className="white"
          d="M 624.02 319.85 625.11 318.72 624.99 317.7 625.87 313.79 628.4 315.81 630.83 317.05 630.97 316.75 633.8 317.06 634.4 317.44 633.68 319.11 633.21 319.61 632.67 320.95 631.07 322.42 630.55 324.37 628.11 322.86 626.69 322.45 625.27 321.12 624.1 320.16 624.02 319.85 Z"
          data-name="Laurens"
          data-stusps="SC"
          id="45059"
        />
        <path
          className="white"
          d="M 238.85 268.15 244.17 268.8 244.1 269.38 250.41 269.9 250.9 269.97 250.51 273.27 251.66 274.04 251.67 275.09 253.06 278.04 247.1 277.38 247.01 277.22 238.79 276.23 237.87 276.12 238.85 268.15 Z"
          data-name="Archuleta"
          data-stusps="CO"
          id="8007"
        />
        <path
          className="white"
          d="M 233.88 290.56 245.17 291.97 244.69 296.07 254.48 297.11 254.39 297.77 252.06 297.64 251.47 300.25 253.93 301.74 253.32 307.63 252.97 311.49 252.94 311.92 247.46 311.29 246.97 311.21 245.44 311.07 244.91 311.01 238.19 310.22 237.74 308.52 236.65 308.39 238.2 295.32 233.33 294.7 233.88 290.56 Z"
          data-name="Sandoval"
          data-stusps="NM"
          id="35043"
        />
        <path
          className="white"
          d="M 452.56 372.49 454.72 372.44 454.7 371.61 456.13 371.55 455.57 369.14 460.29 369.01 460.39 371.47 462.02 371.43 462.19 375.5 461.57 377.18 459.59 377.23 455.64 377.32 455.18 375.69 451.75 375.78 452.1 373.27 451.76 372.74 452.56 372.49 Z"
          data-name="Bienville"
          data-stusps="LA"
          id="22013"
        />
        <path
          className="white"
          d="M 159.15 46.87 159.19 47.1 159.7 48.74 160.16 49.97 160.71 50.68 160.57 51.72 161.65 53.3 161.29 54.04 161.66 54.76 161.08 55.55 160.92 56.38 161.71 57.6 160.85 57.87 160.43 58.54 161.85 59.93 162.18 61.08 162.81 61.82 163.98 62.52 164.5 62.84 164.72 63.82 165.02 64.59 165.65 65.63 166.19 67.15 166.64 68.05 166.9 69.12 167.62 70.07 158.98 67.83 150.12 65.43 150.57 63.8 152.58 56.49 155.03 47.62 155.68 45.25 156.49 44.64 158.38 45.68 159.15 46.87 Z"
          data-name="Shoshone"
          data-stusps="ID"
          id="16079"
        />
        <path
          className="white"
          d="M 677.21 291.36 678.06 290.22 680.3 287.12 683.2 284.41 683.79 285.61 684.5 285.89 685.04 286.13 686.15 288.14 686.99 288.28 686.18 291.73 686.44 293 684.27 294.64 682.75 295.56 681.46 295.63 680.56 294.75 680.63 294.37 678.04 291.67 677.21 291.36 Z"
          data-name="Johnston"
          data-stusps="NC"
          id="37101"
        />
        <path
          className="white"
          d="M 338.93 125.37 353.84 126.3 354.64 128.06 354.1 129.73 354.68 130.61 353.66 133.33 354.19 134.86 352.7 134.66 352.39 137.06 352.15 138.07 350.58 139.43 349.53 139.31 348.68 138.24 348.07 139.19 345.51 138.79 343.94 139.82 342.44 139.29 342.75 134.65 337.89 134.33 338.14 133.5 338.6 126.99 338.93 125.37 Z"
          data-name="Dewey"
          data-stusps="SD"
          id="46041"
        />
        <path
          className="white"
          d="M 210.75 117.61 210.75 117.6 214.21 118.23 215.23 118.63 220.33 119.44 224.73 120.15 227.35 120.62 230.33 121.15 236.61 122.15 237.14 122.36 243.02 123.32 243.02 125.79 241.97 132.36 241.21 138.81 241.49 139.07 241.22 140.74 237.95 140.22 237.69 141.89 236.01 141.62 235.79 143.24 233.34 142.85 233.07 144.48 230.07 144.07 228.68 141.58 227.42 140.77 225.94 141.26 225.37 142.66 223.54 143.17 222.87 142.73 223.43 141.65 223.11 140.1 221.3 139.95 220.64 138.7 221.05 136.36 220.16 136.2 220.49 134.96 220.26 133.12 219.76 132.88 219.49 131.41 218.76 130.16 219.32 128.63 219.18 128 218.22 127.12 214.3 126.41 214.59 124.84 209.4 123.86 209.61 122.75 210.1 120.09 210.75 117.61 Z"
          data-name="Park"
          data-stusps="WY"
          id="56029"
        />
        <path
          className="white"
          d="M 52.47 57.67 56.77 59.28 57.7 60.84 57.11 62.44 58.73 65.53 58.21 66.99 58.17 67.08 57.49 68.97 56.24 68.22 56.09 68.6 55.76 68.65 54.61 67.62 54.19 66.23 53.04 65.21 48.72 63.61 49.17 62.54 52.08 61.18 50.67 60.04 50.37 58.39 51.98 58.99 52.47 57.67 Z"
          data-name="Washington"
          data-stusps="OR"
          id="41067"
        />
        <path
          className="white"
          d="M 473.73 75.05 475.26 74.07 476.04 73.9 476.62 75.1 477.04 76.12 477.98 76.55 479.68 75.94 480.9 76.17 482.84 76.07 485.1 75.75 486.48 76.11 487.28 77.32 488.65 77.79 490.1 77.04 491.68 77.14 493.39 76.94 492.62 77.75 491.33 78.31 490.4 79 489.74 79.56 488.14 80.24 487.54 80.88 486.33 81.34 484.91 82.07 483.23 82.65 482.01 83.09 480.59 83.79 479.24 84.76 478.16 85.44 476.56 86.81 474.7 88.66 474.24 80.72 473.73 75.05 Z"
          data-name="Cook"
          data-stusps="MN"
          id="27031"
        />
        <path
          className="white"
          d="M 192.31 132.36 193.95 132.7 194.29 131.07 195.92 131.39 196.84 130.73 197.4 128.32 198.22 128.48 198.53 126.89 200.88 127.37 201.46 124.44 202.18 124.62 202.87 124.22 203.9 122.54 204.12 122.27 204.46 121.85 205.3 121.34 205.4 121.43 206.01 122.07 206.54 123.27 206.98 124.23 207.11 125.18 207.74 126.08 207.87 126.93 208.79 127.48 208.44 129.34 207.52 134.23 207.07 136.7 204.98 137.3 202.08 136.93 200.71 136.54 199.76 137.25 196.02 136.22 194.24 135.3 194.4 134.48 191.97 133.98 192.31 132.36 Z"
          data-name="Fremont"
          data-stusps="ID"
          id="16043"
        />
        <path
          className="white"
          d="M 230.07 144.07 233.07 144.48 233.34 142.85 235.79 143.24 236.01 141.62 237.69 141.89 237.95 140.22 241.22 140.74 242.04 140.87 241.8 142.52 242.64 142.65 242.35 144.31 243.98 144.56 243.82 145.62 245.51 145.85 245.57 146.42 248.54 146.87 248.3 148.47 251.58 148.96 251.34 150.6 252.99 150.83 252.6 153.55 252.52 154.1 244.84 153 242.32 152.83 240.73 152.31 240.82 151.77 239.19 151.51 239.27 150.96 237.64 150.71 237.78 149.9 236.14 149.64 236.23 149.08 234.64 148.56 231.4 148.03 231.64 146.53 230.07 144.07 Z"
          data-name="Hot Springs"
          data-stusps="WY"
          id="56017"
        />
        <path
          className="white"
          d="M 260.2 49.15 266.76 50.21 270.01 50.73 270.96 50.86 273.23 51.21 272.66 52.8 271.68 59.25 271.68 60.38 270.88 60.15 270.24 60.7 270 62.33 270.51 62.41 270.26 64.08 268.9 63.87 268.64 65.49 268.21 65.43 267.21 71.95 266.58 75.28 266.07 76.47 263.97 75.73 262.85 75.9 261.76 77.29 260.35 77.73 259.61 78.83 259.71 76.6 258.06 75.75 254.88 75.51 254.54 75.77 252.29 74.37 249.26 73.39 248.03 71.46 248.67 67.94 251.97 68.55 252.42 67.26 254.56 67.9 255.32 63.35 256.33 59.11 257.05 59.73 257.5 57 258.38 53.8 259.12 53.92 259.65 50.71 260.2 49.15 Z"
          data-name="Phillips"
          data-stusps="MT"
          id="30071"
        />
        <path
          className="white"
          d="M 632.09 435.33 639.44 434.47 639.35 433.64 642.69 433.25 643.04 436.41 642.3 437.52 642.5 439.19 639.91 439.49 636.29 439.89 633.31 440.2 629.81 440.6 629.8 440.56 631.26 439.06 631.64 437.46 632.01 435.59 632.09 435.33 Z"
          data-name="Pasco"
          data-stusps="FL"
          id="12101"
        />
        <path
          className="white"
          d="M 614.02 190.19 614.23 190.15 615.36 189.96 615.72 189.89 615.02 188.59 616.16 188.42 617.12 188.27 617.96 188.15 618.18 189.5 618.63 192.15 618.74 192.82 618.97 194.23 619.08 194.93 618.96 196.54 615.68 196.94 615.45 195.54 614.87 195.63 614.43 192.85 614.02 190.19 Z"
          data-name="Summit"
          data-stusps="OH"
          id="39153"
        />
        <path
          className="white"
          d="M 604.15 226.65 604.05 225.01 605.65 224.59 605.56 223.74 607.35 223.58 607.26 222.46 608.97 222.33 609.06 223.44 610.8 223.29 610.86 223.83 612.4 223.7 612.54 225.42 610.87 225.55 610.99 227.24 607.67 227.53 607.7 228.03 604.32 228.56 604.15 226.65 Z"
          data-name="Hocking"
          data-stusps="OH"
          id="39073"
        />
        <path
          className="white"
          d="M 636.74 348.5 639.96 345.45 640.71 345.91 640.94 347.26 641.63 348.05 642.5 349.22 642.85 350.85 642.87 350.95 643.4 352.53 643.47 353.45 643.66 353.55 641.6 355.46 641.35 355.99 638.93 355.22 636.43 353.5 636.23 353.6 635.73 353.2 636.74 348.5 Z"
          data-name="Screven"
          data-stusps="GA"
          id="13251"
        />
        <path
          className="white"
          d="M 413.06 176.09 419.57 176.06 419.6 182.6 414.7 182.62 413.05 182.63 413.06 176.09 Z"
          data-name="Cherokee"
          data-stusps="IA"
          id="19035"
        />
        <path
          className="white"
          d="M 586.47 364.68 589.8 363.54 590.79 361.56 591.67 361.16 591.43 361.95 591.93 366.9 589.68 367.17 589.14 367.23 587.74 367.37 588.13 366.71 587.02 366.01 586.12 365.52 586.47 364.98 586.47 364.68 Z"
          data-name="Chattahoochee"
          data-stusps="GA"
          id="13053"
        />
        <path
          className="white"
          d="M 402.39 183.21 402.61 183.61 403.81 183.54 404.14 184.06 404.92 183.92 405.81 184.47 405.38 185.42 405.42 186.8 406.19 187.86 405.8 187.94 400.97 187.87 400.97 187.83 401.08 183.25 402.39 183.21 Z"
          data-name="Dakota"
          data-stusps="NE"
          id="31043"
        />
        <path
          className="white"
          d="M 534.77 201.81 535.53 201.29 536.69 200.34 539.13 201.35 539.64 200.97 539.76 202.19 540.26 207.07 539.45 207.16 539.61 208.55 537.99 208.72 538.2 210.62 535.78 210.86 534.77 201.81 Z"
          data-name="Jasper"
          data-stusps="IN"
          id="18073"
        />
        <path
          className="white"
          d="M 622.19 301.14 622.56 300.09 623.53 299.79 626.65 299.38 628.54 298.8 628.74 298.14 629.73 297.25 630.77 297.74 631.22 301.98 630.69 305.49 629.03 305.66 627.54 305.8 627.36 304.46 624.12 302.03 622.46 302.54 622.03 301.64 622.19 301.14 Z"
          data-name="Rutherford"
          data-stusps="NC"
          id="37161"
        />
        <path
          className="white"
          d="M 247.31 258.99 249.13 259.11 249.51 259.96 251.7 261.09 251.61 261.81 250.97 265 250.41 269.9 244.1 269.38 244.17 268.8 244.82 264.06 245.21 259.06 247.31 258.99 Z"
          data-name="Mineral"
          data-stusps="CO"
          id="8079"
        />
        <path
          className="white"
          d="M 434.73 333.5 434.76 331.11 434.78 329.35 436.91 329.36 442.64 330.11 442.92 330.39 442.95 336.31 437.98 336.29 438.2 339.35 434.67 339.45 434.7 336.27 434.73 333.5 Z"
          data-name="Polk"
          data-stusps="AR"
          id="5113"
        />
        <path
          className="white"
          d="M 380.51 429.47 383.45 425.19 383.99 424.41 384.56 424.78 389.18 421.96 392.2 424.63 392.01 424.92 390.99 425.8 390.36 429.47 388.78 430.75 384.16 434.53 382.3 432.4 380.2 429.91 380.51 429.47 Z"
          data-name="Gonzales"
          data-stusps="TX"
          id="48177"
        />
        <path
          className="white"
          d="M 649.97 188.09 649.92 187.54 649.02 182.76 650.49 182.59 650.6 182.28 652.22 181.25 656.02 182.72 656.61 183.8 655.8 183.94 655.53 185.38 656.38 189.65 650.49 190.71 650.1 188.41 649.97 188.09 Z"
          data-name="Jefferson"
          data-stusps="PA"
          id="42065"
        />
        <path
          className="white"
          d="M 530.77 197.43 530.67 196.31 530.35 192.96 531.17 193.55 531.91 193.19 532.73 194.22 534.22 194.24 534.75 194.03 535.53 201.29 534.77 201.81 533.19 203.03 531.3 203.15 531.06 200.67 531.06 200.67 530.77 197.43 Z"
          data-name="Lake"
          data-stusps="IN"
          id="18089"
        />
        <path
          className="white"
          d="M 480.26 245.12 481.36 245.07 481.31 243.42 488.03 243.11 488.33 244.48 488.78 245.4 488.35 246.3 488.97 247.58 489.24 248.49 488.6 249.13 484.95 249.93 482.7 250.02 482.66 248.9 481.5 248.96 481.46 247.83 480.34 247.88 480.26 245.12 Z"
          data-name="Lincoln"
          data-stusps="MO"
          id="29113"
        />
        <path
          className="white"
          d="M 117.53 175.94 123.66 177.46 122.14 183.76 121.97 194.5 124.39 195.06 123.89 197.15 123.76 200.4 122.65 202.61 122.34 205.25 120.86 207.46 119.07 213.11 108.82 210.71 109.91 206.69 113.01 193.45 114.24 188.78 117.13 176.93 117.36 176.61 117.53 175.94 Z"
          data-name="Eureka"
          data-stusps="NV"
          id="32011"
        />
        <path
          className="white"
          d="M 621.24 201.09 622.34 200.93 622.7 199.34 624.3 199.09 626.74 198.69 627 200.26 627.95 200.95 628.08 201.79 627.25 201.91 627.48 203.59 627.37 204.45 623.45 204.95 623.09 205.03 622.62 205.09 622.5 204.27 622.27 202.6 621.45 202.7 621.24 201.09 Z"
          data-name="Carroll"
          data-stusps="OH"
          id="39019"
        />
        <path
          className="white"
          d="M 413.21 431.89 414.76 430.73 416.85 431.31 417.61 430.43 418.09 428.59 419.52 428.57 419.83 427.24 420.14 425.93 421.66 425.57 422.22 425.61 422.39 425.59 422.93 426.41 423.55 426.36 423.28 428.06 423.96 429.2 426.21 433.02 425.26 435.35 425.1 435.51 424.01 436.34 422.28 438.02 420.88 439.29 419.93 439.43 418.82 440.08 417.82 439.99 415.97 437.44 414.49 437.34 414.48 435.56 413.23 434.79 412.77 432.5 413.21 431.89 Z"
          data-name="Brazoria"
          data-stusps="TX"
          id="48039"
        />
        <path
          className="white"
          d="M 684.14 189.25 684.67 189.62 687.58 187.89 690.41 189.29 688.7 191.28 691.5 196.17 689.77 197.36 689.57 198.12 688.89 197.17 688.09 196.86 687.73 196.9 687.43 196.58 687.13 196.56 685.92 195.58 685.89 194.81 684.2 194.43 684.8 192.26 683.77 190.53 684.14 189.25 Z"
          data-name="Dauphin"
          data-stusps="PA"
          id="42043"
        />
        <path
          className="white"
          d="M 576.29 173.88 578.89 173.52 582.77 172.83 584.33 172.52 584.63 174.13 584.92 175.75 585.19 177.4 585.47 179.07 582.19 179.6 577.2 180.51 576.29 173.88 Z"
          data-name="Washtenaw"
          data-stusps="MI"
          id="26161"
        />
        <path
          className="white"
          d="M 595.5 189.64 598.58 188.76 599.09 188.35 599.14 188.42 600.33 189.47 601.63 189.99 602.67 189.92 603.95 188.94 604.15 188.89 604.4 190.21 604.41 190.27 604.65 191.57 597.55 192.56 597.3 191.2 597.06 189.93 595.5 189.64 Z"
          data-name="Erie"
          data-stusps="OH"
          id="39043"
        />
        <path
          className="white"
          d="M 204.49 344.66 212.51 345.68 213.97 346 221.12 346.85 223.38 347.12 223.44 349.68 222.97 350.88 224.08 351.96 223.98 353.84 224.64 355.37 224.08 358.15 226.08 358.83 221.03 358.28 220.84 359.92 215.94 359.36 215.17 367.66 214.69 371.74 209.72 371.16 210 367.05 211.01 358.78 209.24 358.57 209.45 356.92 206.14 356.51 206.53 353.22 203.45 352.82 204.49 344.66 Z"
          data-name="Grant"
          data-stusps="NM"
          id="35017"
        />
        <path
          className="white"
          d="M 677.53 187.16 683.15 184.32 685.2 183.98 685.24 184.04 685.17 184.68 684.88 185.25 684.8 185.52 685.03 187.5 684.23 189.03 681.56 188.57 678.99 189.09 678.01 189.15 677.53 187.16 Z"
          data-name="Snyder"
          data-stusps="PA"
          id="42109"
        />
        <path
          className="white"
          d="M 740.18 116.08 740.5 115.04 740.75 114.48 741.7 115.29 742.82 114.56 745.29 116.43 745.9 115.89 747.21 116.33 749.27 117.02 751.18 117.69 751.08 117.93 751.02 118.45 750.96 119.13 750.78 120.35 750.6 121.65 750.31 123 750.64 123.55 748.75 123.3 748.57 122.96 746.95 123.76 746.02 122.03 745.2 122.54 744.21 123.16 743.64 123.52 742.32 122.03 741.11 122.79 739.23 120.6 739.06 118.22 739.66 118.12 740.18 116.08 Z"
          data-name="Merrimack"
          data-stusps="NH"
          id="33013"
        />
        <path
          className="white"
          d="M 40.81 297.63 40.27 298.67 39.2 298.38 37.4 298.18 36.33 298.46 35.15 298.1 33.98 297.45 34.13 296.6 33.67 295.77 34.68 295.76 36.47 296.65 39.27 297.26 40.81 297.63 Z M 26.48 293.58 28.41 294.47 29.98 295.5 31.33 295.61 32.21 296.93 32.18 297.78 30.82 298.01 29.57 298.08 28.8 297.23 28.6 296.58 26.12 295.23 24.86 294.16 26.48 293.58 Z M 26.5 275.05 29.04 275.34 29.97 275.72 31.68 277.84 31.67 275.76 34.11 275.9 34.66 275.12 36.22 274.72 37.55 276.23 38.38 276.4 40.85 278.8 42 279.1 43.81 281.11 44.83 281.29 45.29 281.4 43.68 287.96 43.22 289.83 42.87 290.97 42.24 291.33 41.38 290.78 40.22 289.97 39.07 289.94 38.62 290.09 37.49 289.39 36.69 289.19 36.05 289.17 34.66 288.09 33.48 287.44 32.09 286.84 29.62 286.26 26.99 286.07 26.42 284.36 25.9 283.81 25.47 283.41 24.79 283.29 24.56 282.67 25.82 280.71 25.81 279.91 25.67 279.72 26.54 277.47 25.81 276.33 26.5 275.05 Z"
          data-name="Santa Barbara"
          data-stusps="CA"
          fillRule="evenodd"
          id="6083"
        />
        <path
          className="white"
          d="M 176.97 147.74 177.67 144.47 178.5 144.64 179.29 141.58 180.94 141.93 181.29 140.3 182.91 140.56 183.26 139 184.06 139.1 185.69 139.44 184.91 143.23 190.62 144.39 191.38 144.83 191.22 145.65 194.25 146.26 193.94 147.84 197.16 148.47 196.19 153.39 189.66 152.07 181.17 150.36 179.9 151.48 178.64 152.95 175.99 152.4 176.97 147.74 Z"
          data-name="Bingham"
          data-stusps="ID"
          id="16011"
        />
        <path
          className="white"
          d="M 419.76 61.73 421.82 61.71 421.79 58.22 421.77 55.88 421.76 54.47 422.93 55.05 423.78 54.74 424.23 54.74 425.14 55.4 425.91 55.62 426.17 57.62 426.48 59.29 426.78 59.76 427.2 61.63 427.67 63.8 427.65 64.63 427.56 65.58 428.51 66.54 429.89 67.22 430.67 67.34 430.87 67.24 431 73.45 421.21 73.61 421.17 70.34 419.54 70.35 419.52 67.1 422.66 67.08 422.6 63.18 420.82 63.93 420.01 63.51 419.76 61.73 Z"
          data-name="Lake of the Woods"
          data-stusps="MN"
          id="27077"
        />
        <path
          className="white"
          d="M 396.92 77.12 405.02 77.21 405 80.07 405.22 81.17 405.21 83.35 406.85 83.36 406.85 85 413.37 85.01 413.37 83.37 414.99 83.36 414.98 81.72 416.59 81.75 416.65 86.64 416.97 86.64 416.97 89.9 410.43 89.92 400.39 89.84 400.44 88.47 400.1 87.02 399.96 86.58 399.54 85.21 398.7 83.33 398.21 81.65 397.84 79.9 397.4 78.67 396.9 77.21 396.92 77.12 Z"
          data-name="Polk"
          data-stusps="MN"
          id="27119"
        />
        <path
          className="white"
          d="M 469.6 376.97 469.52 374.5 472.81 374.74 473.94 374.35 474.6 374.34 474.88 376.4 476.26 376.63 476.72 377.74 475.7 378.24 476.46 380 476.27 380.84 474.64 380.9 469.73 381.06 469.6 376.97 Z"
          data-name="Caldwell"
          data-stusps="LA"
          id="22021"
        />
        <path
          className="white"
          d="M 481.55 381.47 482.54 380.55 482.25 380.01 482.77 377.49 482.62 375.41 485.37 375.31 488.32 374.31 488.76 375.06 489.95 376.89 490.03 377.02 489.36 378 489.36 378.51 488.8 379.22 487.85 379.52 487.84 380.52 487.01 381.36 486.87 381.5 486.16 382.21 485.26 382.08 485.07 382.9 485.74 383.84 485.77 383.89 484.79 384.17 484.49 383.79 482.14 383.91 481.58 383.11 481.55 381.47 Z"
          data-name="Tensas"
          data-stusps="LA"
          id="22107"
        />
        <path
          className="white"
          d="M 406.37 302.61 406.82 302.62 410.88 302.65 410.89 297.73 413.75 297.73 414.02 297.87 413.75 299.09 413.76 301 413.71 301.29 413.71 302.62 414.52 302.62 414.53 307.52 413.65 308.37 410.38 308.35 410.44 307.52 410.44 305.89 410.45 304.26 406.36 304.24 406.37 302.61 Z"
          data-name="Tulsa"
          data-stusps="OK"
          id="40143"
        />
        <path
          className="white"
          d="M 677.48 228.86 677.85 228.76 678.77 230.79 679.93 231.64 681.54 233.62 683.05 233.36 683.46 234.12 683.01 234.01 682.23 234.51 681.1 234.1 681.03 234.68 679.07 234.74 677.38 236.45 676.57 236.62 676.2 234.87 673.69 232.84 674.57 232.89 677.48 228.86 Z"
          data-name="Culpeper"
          data-stusps="VA"
          id="51047"
        />
        <path
          className="white"
          d="M 662.26 249.33 662.74 249.02 663.86 249.52 664.13 250.61 665.44 250.85 667.26 253.42 667.74 253.43 666.66 254.39 665.83 255.99 665.28 256.94 664.99 256.82 664.45 256.85 663.23 255.75 660.69 255.19 658.92 253.57 660.15 252.5 661.33 249.3 662.26 249.33 Z"
          data-name="Amherst"
          data-stusps="VA"
          id="51009"
        />
        <path
          className="white"
          d="M 389.06 410.38 391.98 409.39 395.11 407.55 395.83 407.9 396.5 409.61 398.64 412.03 400.31 412.48 398.78 413.51 397.79 415.01 396.95 415.83 394.12 417.37 394.03 417.02 393.13 413.11 391.89 412.14 391.24 411.62 390.39 411.14 389.06 410.38 Z"
          data-name="Lee"
          data-stusps="TX"
          id="48287"
        />
        <path
          className="white"
          d="M 397.36 397.31 401.14 395.17 405.63 392.65 405.43 394.61 406.41 397.88 406.55 397.9 406.83 398.2 406.86 399.83 405.29 400.82 403.34 404.11 401.56 405.01 400.68 404.35 400.84 403.85 400.37 402.71 398.53 400.66 398.37 398.49 397.36 397.31 Z"
          data-name="Robertson"
          data-stusps="TX"
          id="48395"
        />
        <path
          className="white"
          d="M 420.9 323.3 427.39 323.26 427.42 325.44 426.33 325.45 426.35 327.08 425.39 327.08 425.42 330.35 418.37 330.39 418.46 323.86 420.9 323.3 Z"
          data-name="Latimer"
          data-stusps="OK"
          id="40077"
        />
        <path
          className="white"
          d="M 366.09 177.1 369.95 175.52 371.15 176.52 374.39 177.32 375.38 177.91 379.23 178.37 379.05 184.19 379.12 184.46 378.92 190.99 372.48 190.79 366.03 190.57 365.86 190.56 366.23 177.52 366.09 177.1 Z"
          data-name="Holt"
          data-stusps="NE"
          id="31089"
        />
        <path
          className="white"
          d="M 280.4 192.29 289.2 193.29 289.03 194.95 297.51 195.8 297.2 199.02 297.2 199.02 297 201.18 296.69 204.25 296.49 206.38 290.17 205.75 285.06 205.3 283.81 205.17 279.06 204.66 280.4 192.29 Z"
          data-name="Laramie"
          data-stusps="WY"
          id="56021"
        />
        <path
          className="white"
          d="M 677.54 271.24 679.59 270.84 681.14 275.19 680.83 276.04 679.84 276.83 679.42 278.3 678.23 278.31 677.02 273.04 677.02 271.87 677.54 271.24 Z"
          data-name="Vance"
          data-stusps="NC"
          id="37181"
        />
        <path
          className="white"
          d="M 318.55 376.38 319.84 376.44 326.73 376.81 326.27 385 318.1 384.56 318.55 376.38 Z"
          data-name="Glasscock"
          data-stusps="TX"
          id="48173"
        />
        <path
          className="white"
          d="M 161.71 57.6 166.58 58.91 169.56 61.34 169.32 62.95 171.3 64.32 171.37 65.2 172.18 65.4 171.97 66.22 173.3 67.71 173.3 68.82 174.36 69.08 174.97 70.11 173.55 70.04 172.82 70.77 172.04 74.86 170.33 74.74 170.08 74.51 169.2 74.32 169.09 73.5 168.08 72.59 167.54 71.34 167.96 70.53 167.62 70.07 166.9 69.12 166.64 68.05 166.19 67.15 165.65 65.63 165.02 64.59 164.72 63.82 164.5 62.84 163.98 62.52 162.81 61.82 162.18 61.08 161.85 59.93 160.43 58.54 160.85 57.87 161.71 57.6 Z"
          data-name="Mineral"
          data-stusps="MT"
          id="30061"
        />
        <path
          className="white"
          d="M 714.88 93.35 715.17 93.25 716.78 92.74 718.27 92.31 722.99 90.94 723.38 90.87 724.65 94.07 724.34 95.25 723.77 95.02 722.89 95.24 722.21 95.42 721.99 97.8 721.11 97.64 720.56 99.39 718.94 99.51 715.99 98.92 715.38 98.27 715.46 95.3 714.83 95.09 714.58 94.71 714.88 93.35 Z"
          data-name="Franklin"
          data-stusps="VT"
          id="50011"
        />
        <path
          className="white"
          d="M 484.59 288.47 491.44 288.35 491.97 288.33 492.09 290.79 493.07 294.15 490.2 294.3 489.92 294.32 486.37 294.51 484.73 294.59 484.59 288.47 Z"
          data-name="Ripley"
          data-stusps="MO"
          id="29181"
        />
        <path
          className="white"
          d="M 567.8 374.33 570.95 374.02 570.78 372.45 571.57 372.17 572.44 372.37 572.73 373.86 574.25 373.72 574.39 375.36 576.54 375.16 576.59 377.2 575.73 380.1 575.54 380.24 574.88 380.31 569.12 380.84 568.58 380.91 569.03 379.98 568.79 377.57 567.97 377.66 567.8 374.33 Z"
          data-name="Pike"
          data-stusps="AL"
          id="1109"
        />
        <path
          className="white"
          d="M 768.29 146.91 768.38 145.92 768.85 143.96 768.6 143.73 769.41 142.98 769.67 142.38 770.49 142.9 771.36 143.06 773.13 142.85 773.94 142.9 774.61 142.24 775.84 141.51 777.05 140.53 777.21 140.04 776.91 139.22 775.83 138.89 775.43 137.9 774.84 136.56 773.81 136.59 773.29 136.89 772.26 136.32 772.93 135.71 773.08 135.61 773.57 135.28 775.01 135.41 776.18 136.39 776.71 137.33 776.91 137.7 778.17 139.71 778.99 141.9 779.38 143.21 779.33 144.72 778.72 145.07 778.25 143.64 778 142.64 777.36 142.99 775.98 143.73 774.6 144.84 773.79 144.84 772.81 145.65 772.27 146.12 772.03 146.89 770.9 147.46 769.73 148.43 769.56 148.61 769.07 148.47 768.57 148.29 768.87 147.87 768.65 147.03 768.29 146.91 Z"
          data-name="Barnstable"
          data-stusps="MA"
          id="25001"
        />
        <path
          className="white"
          d="M 474.64 380.9 476.27 380.84 476.46 380 477.87 381.42 479.09 381.58 480.33 379.88 481.15 379.85 481.55 381.47 481.58 383.11 482.14 383.91 481.22 383.76 480.7 384.4 479.75 384.32 479.63 386.06 479.15 386.62 478.51 385.99 477.73 387.09 478.53 388.2 478.26 389.29 479.24 389.37 479.26 390.04 478.15 389.94 477.31 388.93 477.38 390.25 478.68 390.93 477.58 391.15 477.36 392.54 477.83 393.19 476.32 392.71 475.34 394.05 474.99 392.18 474.64 380.9 Z"
          data-name="Catahoula"
          data-stusps="LA"
          id="22025"
        />
        <path
          className="white"
          d="M 371.09 434.2 375.71 428.16 376.02 429.59 378.61 429.4 380.51 429.47 380.2 429.91 382.3 432.4 377.84 435.99 374.57 438.62 371.09 434.2 Z"
          data-name="Wilson"
          data-stusps="TX"
          id="48493"
        />
        <path
          className="white"
          d="M 160.85 253.75 165.4 254.6 173.5 256.18 182.45 257.63 191.55 259.11 190.98 260.25 189.78 260.54 190.42 261.07 189.6 262.59 188.91 262.91 187.59 262.2 187.94 263.21 187.35 263.36 186.61 265.39 185.56 266.22 183.98 266.45 182.16 266.09 180.86 267.45 180.64 266.78 179.8 267.46 178.28 267.41 163.92 264.93 161.17 264.44 161.07 264.43 156.74 263.64 155.68 263.45 157.41 253.97 157.56 253.15 160.85 253.75 Z"
          data-name="Kane"
          data-stusps="UT"
          id="49025"
        />
        <path
          className="white"
          d="M 308.68 86.31 309.1 82.44 309.52 78.69 309.84 75.53 309.89 75.07 311.38 75.99 312.29 74.97 312.95 75.43 313.28 74.23 314.24 74.21 313.88 73.64 315.78 73.06 316.31 74 315.79 74.58 316.95 75.6 317.72 75.12 319.49 75.22 320.34 74.64 320.75 73.54 321.96 73.44 325.43 74.19 327.42 75.26 328.69 76.88 327.37 78.47 327.27 80.03 327.01 82.84 321.22 82.31 320.62 88.8 313.37 88.08 308.54 87.56 308.54 87.53 308.68 86.31 Z"
          data-name="McKenzie"
          data-stusps="ND"
          id="38053"
        />
        <path
          className="white"
          d="M 627.99 282.5 629.43 283.06 630.76 284.36 632.21 284.76 632.66 285.46 631.52 287.24 629.51 287.44 627.46 287.96 627.02 286.92 625.69 286.24 625.32 284.88 625.44 284.58 626.46 283.55 627.46 283.52 628.43 283.43 627.99 282.5 Z"
          data-name="Watauga"
          data-stusps="NC"
          id="37189"
        />
        <path
          className="white"
          d="M 147.24 74.03 147.74 75.24 149.3 75.86 149.32 76.5 149.52 78.01 150.64 79.77 149.02 79.55 148 80.47 145.13 78.76 143.65 79.77 142.64 82.18 141.39 81.19 140.52 81.64 142.06 75.45 146.61 76.34 147.24 74.03 Z"
          data-name="Lewis"
          data-stusps="ID"
          id="16061"
        />
        <path
          className="white"
          d="M 468.7 102.34 469.22 102.31 470.47 101.64 471.12 101.44 471.68 100.87 472.42 100.64 472.97 100.04 473.56 100.42 474.01 99.92 474.56 99.71 475.21 99.22 475.82 98.76 475.7 97.7 476.51 97.28 477.48 97.96 478.1 98.37 478.94 99.15 478.34 100.53 477.61 101.66 477.38 102.16 477.79 102.9 477.03 103.72 476.86 104.51 476.59 104.99 476.99 105.06 477.5 113.19 469.32 113.61 468.71 102.52 468.7 102.34 Z"
          data-name="Bayfield"
          data-stusps="WI"
          id="55007"
        />
        <path
          className="white"
          d="M 716.64 162.15 717.89 160.98 721.13 161.18 722.51 160.62 722.52 163.32 722.87 163.58 723.58 164.29 723.45 165.72 720.74 170.12 719.62 169.81 718.54 169.46 717.03 168.96 713.12 167.76 712.22 166.62 711.91 166.66 711.53 165.5 715.53 164.2 716.64 162.15 Z"
          data-name="Orange"
          data-stusps="NY"
          id="36071"
        />
        <path
          className="white"
          d="M 548.15 346.69 548.05 346.38 549.36 345.77 549.37 344.68 551.21 343.71 551.82 341.18 552.59 340.58 553.64 339.96 555.61 339.83 557.51 340.95 558.59 340.99 559.14 340.95 559.92 345.04 559.96 345.45 557.57 346.76 555.33 349.51 554.5 349.56 553.11 351.14 552.36 351.38 551.74 351.43 551.7 350.88 551.56 350.89 551.55 350.82 551.35 350.84 551.33 350.63 550.71 350.68 550.68 350.4 550.13 350.43 550.1 350.16 549.83 350.18 549.81 350.05 549.55 349.79 547.03 347.58 548.15 346.69 Z"
          data-name="Jefferson"
          data-stusps="AL"
          id="1073"
        />
        <path
          className="white"
          d="M 29.99 206.82 31.34 206.24 32.21 204.22 31.59 203.36 31.76 203.17 32.22 203.16 32.17 202.97 32.49 202.84 32.56 202.73 32.53 202.31 32.86 201.99 32.87 201.69 32.65 201.54 32.35 201.6 32.25 201.45 31.53 199.51 32.27 198.7 32.92 198.88 34.04 199.26 35.54 199.85 36.6 200.27 39.04 201.22 39.41 201.2 39.6 205.61 38.45 209.58 35.17 209.78 34.32 209.42 32.44 209.33 31.85 208.58 31.51 208.38 28.94 211.06 27.53 210.66 26.17 211.64 25.18 211.45 24.51 210.32 24.56 210.24 24.86 210.21 25.03 210.48 25.48 210.72 26.43 210.46 26.89 210.63 27.72 209.33 28.98 208.96 29.99 206.82 Z"
          data-name="Sacramento"
          data-stusps="CA"
          id="6067"
        />
        <path
          className="white"
          d="M 16.79 206.1 19.71 207.01 20.02 206.94 20.77 203.97 23.02 204.41 22.63 202.17 23.48 200.66 24.71 201.55 26.04 201.03 29.54 202.05 28.48 206.35 29.99 206.82 28.98 208.96 27.72 209.33 26.89 210.63 26.43 210.46 25.48 210.72 25.03 210.48 24.86 210.21 24.56 210.24 24.51 210.32 24.17 210.57 21.63 209.57 20.87 209.59 20.06 209.69 18.31 208.56 18.08 207.55 16.92 206.39 16.85 206.4 16.79 206.1 Z"
          data-name="Solano"
          data-stusps="CA"
          id="6095"
        />
        <path
          className="white"
          d="M 707.56 257.57 707.71 257.14 708.47 257.5 708.72 258.01 708.75 258.43 709.68 259.28 709.74 259.74 708.68 260.18 708.05 259.94 708.06 259.03 707.5 258.86 707.56 257.57 Z"
          data-name="Portsmouth"
          data-stusps="VA"
          id="51740"
        />
        <path
          className="white"
          d="M 300.28 253.77 305.19 254.01 305.32 252.37 321.95 253.55 321.66 257.88 321.52 260.06 311.19 259.35 301.44 258.62 299.93 258.5 299.97 257.04 300.28 253.77 Z"
          data-name="Kiowa"
          data-stusps="CO"
          id="8061"
        />
        <path
          className="white"
          d="M 431.35 365.67 434.45 367.49 436.3 367.46 438.63 366.37 439.7 367.4 441.01 366.64 441.81 367.4 441.85 369.81 441.91 373.03 437.03 374.34 436.46 373.59 434.77 373.1 433.76 372.86 433.38 373.11 431.42 372.63 431.38 368.31 431.35 365.67 Z"
          data-name="Harrison"
          data-stusps="TX"
          id="48203"
        />
        <path
          className="white"
          d="M 645.12 401.26 649.24 401.03 648.83 398.25 649.86 398.1 652.11 404.35 652.49 404.92 652.78 406.06 652.96 406.76 654.01 408.83 652.23 409.93 648.92 410.41 648.66 408.53 648.56 407.81 647.44 406.39 646.83 404.23 645.19 402.99 645.12 401.26 Z"
          data-name="St. Johns"
          data-stusps="FL"
          id="12109"
        />
        <path
          className="white"
          d="M 605.58 243.69 606.57 243.07 605.99 241.56 606.84 241.49 607.3 240.06 607.21 238.13 608.32 238.05 608.4 239.3 609.88 239.21 610.3 240.89 612.06 240.74 612.21 242.47 613.4 242.4 613.29 242.79 613.31 244.02 613.15 244.95 612.33 245.35 611.39 245.64 610.5 246.01 609.76 246.32 609.22 246.06 608.7 245.07 607.94 244.59 607.75 244.47 606.91 243.78 605.78 243.84 605.58 243.69 Z"
          data-name="Lawrence"
          data-stusps="OH"
          id="39087"
        />
        <path
          className="white"
          d="M 289.07 296.33 290.33 281.71 294.48 282.02 304.24 282.77 305.51 282.86 305.38 284.56 305.04 288.96 304.95 290.33 304.8 292.25 304.2 292.2 303.59 300.57 303.14 306.5 298.03 306.11 298.41 301.24 298.69 299.61 292.13 299.09 292.27 297.44 289 297.15 289.07 296.33 Z"
          data-name="Union"
          data-stusps="NM"
          id="35059"
        />
        <path
          className="white"
          d="M 684.27 294.64 686.44 293 686.18 291.73 686.99 288.28 687.21 288.03 689.96 287.71 690.76 287.57 691.27 290.65 691.79 291.65 691.65 291.9 692.04 295.36 691.24 296.13 688.7 295.7 686.85 296.09 686.63 295.79 685.43 295.64 684.27 294.64 Z"
          data-name="Wayne"
          data-stusps="NC"
          id="37191"
        />
        <path
          className="white"
          d="M 378.9 194.26 385.38 194.4 385.35 197.67 385.26 201.72 382.27 201.94 381.44 202.48 378.73 202.41 378.86 197.92 378.8 197.52 378.9 194.26 Z"
          data-name="Boone"
          data-stusps="NE"
          id="31011"
        />
        <path
          className="white"
          d="M 630.77 297.74 632.76 297.87 633.2 297.69 633.57 297.76 634.88 300.24 636.66 301.7 637.41 302.94 637.58 304.82 636.96 304.87 634.98 305.06 630.69 305.49 631.22 301.98 630.77 297.74 Z"
          data-name="Cleveland"
          data-stusps="NC"
          id="37045"
        />
        <path
          className="white"
          d="M 617.85 277.82 621.07 275.64 621.3 274.51 623.29 274.03 624.76 272.56 627.25 274.89 628.78 277.42 629.11 277.53 628.56 278.12 625.81 278.48 624.34 278.67 624.22 279.11 621 279.58 621.51 278.82 621.51 278.5 620.99 277.98 621.36 278.68 620.39 279.04 619.51 279.79 618.73 279.89 618.46 279.46 617.85 277.82 Z"
          data-name="Washington"
          data-stusps="VA"
          id="51191"
        />
        <path
          className="white"
          d="M 527.64 227.86 532.31 227.4 533.17 227.56 533.51 227.26 533.89 231.36 533.99 232.44 534.23 234.89 531.94 234.9 527.98 235.37 527.55 231.54 527.34 229.54 527.64 227.86 Z"
          data-name="Edgar"
          data-stusps="IL"
          id="17045"
        />
        <path
          className="white"
          d="M 475.79 224.48 475.83 224.08 476.12 223.07 476.79 221.99 477.44 221.57 477.28 220.58 477.4 219.47 477 219.04 477.24 218.12 477.71 217.52 479 216.98 479.87 216.96 479.89 216.94 483.91 216.7 484.2 223.36 484.27 225.08 475.7 225.39 475.79 224.48 Z"
          data-name="Hancock"
          data-stusps="IL"
          id="17067"
        />
        <path
          className="white"
          d="M 586.72 242.46 586.73 242.46 587.77 242.02 588.54 242.16 588.92 242.25 588.06 245.69 586.66 245.59 585.64 246.76 584.84 246.85 584.93 246.32 585.02 246.08 584.02 241.7 584.27 242.12 585.46 242.28 586.72 242.46 Z"
          data-name="Bracken"
          data-stusps="KY"
          id="21023"
        />
        <path
          className="white"
          d="M 92.55 321.9 102.49 323.86 112.72 325.78 115.97 326.32 115.84 326.51 115.2 326.48 114.33 326.58 114.51 327.17 114.31 328.19 113.94 328.82 114.61 329.59 114.46 330.06 114.18 331.41 113.56 332.37 113.89 333.76 114.55 334.02 115.43 334.08 116.31 334.47 116.41 334.52 116.71 335.59 116.62 336.53 116.76 336.98 116.47 338.05 115.23 339.07 114.48 339.62 113.7 339.6 112.86 339.59 112.27 339.33 111.97 339.73 107.34 339.24 99.69 338.44 90.08 337.43 89.09 337.33 89.49 335.35 91.25 328.65 92.55 321.9 Z"
          data-name="Imperial"
          data-stusps="CA"
          id="6025"
        />
        <path
          className="white"
          d="M 458.26 164.11 459.68 164.05 463.38 163.89 464.73 163.83 464.96 169.23 458.46 169.51 458.26 164.11 Z"
          data-name="Howard"
          data-stusps="IA"
          id="19089"
        />
        <path
          className="white"
          d="M 498.49 390.76 503.13 390.51 503.47 397.08 502.07 397.15 502.05 397.15 498.81 397.32 498.49 390.76 Z"
          data-name="Pike"
          data-stusps="MS"
          id="28113"
        />
        <path
          className="white"
          d="M 483.21 272.1 483.27 271.28 483.96 271.26 490.75 271 490.81 272.73 492.49 272.62 492.35 273.48 492.61 278.75 492.65 279.6 489.88 279.78 489.21 277.88 489.04 273.58 485.78 273.73 483.28 274.16 483.21 272.1 Z"
          data-name="Iron"
          data-stusps="MO"
          id="29093"
        />
        <path
          className="white"
          d="M 675.83 260.99 678.31 260.05 678.79 259.63 681.58 261.24 682.74 260.79 683.27 265.51 676.99 265.25 675.75 264.7 675.83 260.99 Z"
          data-name="Lunenburg"
          data-stusps="VA"
          id="51111"
        />
        <path
          className="white"
          d="M 667.52 223.12 668.65 221.52 668.32 221.02 668.48 219.99 668.38 219.25 669 217.62 668.83 216.56 668.47 215.51 670.49 216.59 671.2 216.97 673.85 218.39 673.85 218.39 673.37 221.81 672.98 223.06 672.87 223.45 670.69 224.08 670.01 222.37 669.19 222.53 668.55 224.11 667.3 223.87 667.52 223.12 Z M 671.8 219.98 671.88 220.84 672.15 221.36 672.64 220.22 672.22 219.93 671.8 219.98 Z"
          data-name="Frederick"
          data-stusps="VA"
          fillRule="evenodd"
          id="51069"
        />
        <path
          className="white"
          d="M 660.6 230.87 660.97 230.07 661.18 229.22 663.38 230.31 667.33 232.66 666.94 234.59 670.32 235.68 669.64 237.51 668.2 238.91 668.38 239.21 667.17 240.5 664.75 239.06 664.38 239.13 659.06 236.68 659.29 235.69 659.71 234.07 660.43 232.9 660.4 232.31 660.6 230.87 Z M 663.86 236.6 664.11 237 664.05 237.5 665.24 236.67 664.33 235.49 663.86 236.6 Z"
          data-name="Rockingham"
          data-stusps="VA"
          fillRule="evenodd"
          id="51165"
        />
        <path
          className="white"
          d="M 471.72 357.81 472.01 356.67 474.15 355.1 473.88 353.31 482.27 353.15 482.53 360.34 482.07 360.35 475.97 360.56 472.91 360.66 472.9 360.66 471.67 359.03 471.72 357.81 Z"
          data-name="Ashley"
          data-stusps="AR"
          id="5003"
        />
        <path
          className="white"
          d="M 442.89 219.49 445.42 219.39 446 219.38 448.61 219.29 448.66 221.32 448.83 222.99 448.88 225.18 443.19 225.37 443.07 221.46 442.89 219.49 Z"
          data-name="Mercer"
          data-stusps="MO"
          id="29129"
        />
        <path
          className="white"
          d="M 643.98 265.57 643.97 265.6 644.02 265.51 644.01 265.29 644.22 265.26 644.29 265.48 643.98 265.87 644.05 265.99 643.65 265.93 643.68 266.27 643.35 266.53 643.16 266.32 643.02 266.02 643.02 265.9 643.04 265.84 643.3 265.56 643.58 265.38 643.65 265.37 643.98 265.57 Z"
          data-name="Radford"
          data-stusps="VA"
          id="51750"
        />
        <path
          className="white"
          d="M 299.41 54.81 301.66 55.08 305.75 55.55 311.87 56.23 311.55 59.09 311.13 63.1 310.85 65.72 310.65 67.69 303.39 66.88 303.58 65.25 301.95 65.05 302.15 63.43 299.46 63.11 299.66 61.48 298.85 61.38 299.45 56.5 299.41 54.81 Z"
          data-name="Sheridan"
          data-stusps="MT"
          id="30091"
        />
        <path
          className="white"
          d="M 636.4 222.23 637.01 221.33 640.22 221.43 641.61 222.01 641.99 224.33 642.57 224.78 641.95 226.28 642.11 227.38 641.06 227.74 637.44 227.52 636.5 227.3 637.4 226.59 635.99 224.98 636.81 223.5 636.4 222.23 Z"
          data-name="Harrison"
          data-stusps="WV"
          id="54033"
        />
        <path
          className="white"
          d="M 569.36 193.92 575.9 193.03 577.51 192.81 578.18 197.73 576.57 197.95 576.46 197.14 574.82 197.35 574.7 196.52 569.79 197.18 569.74 196.83 569.4 194.25 569.36 193.92 Z"
          data-name="Defiance"
          data-stusps="OH"
          id="39039"
        />
        <path
          className="white"
          d="M 519.42 348.44 519.39 347.9 520.48 347.82 524.38 347.5 525.94 347.4 526.02 348.5 526.34 352.62 524.07 352.79 521.65 352.95 519.72 353.08 519.52 350.08 519.42 348.45 519.42 348.44 Z"
          data-name="Oktibbeha"
          data-stusps="MS"
          id="28105"
        />
        <path
          className="white"
          d="M 473.22 154.31 474.59 154.23 474.6 152.79 476.8 152.32 477.02 152.47 479.23 152.34 480.04 152.28 480.46 158.78 475.75 159.04 475.87 158.14 475.2 156.79 475.15 156.68 474.18 155.52 473.22 154.31 Z"
          data-name="La Crosse"
          data-stusps="WI"
          id="55063"
        />
        <path
          className="white"
          d="M 469.55 142.98 471.18 142.9 471.52 149.46 470.47 150.92 471.61 152.29 471.34 153.66 471.14 153.62 470.1 152.97 469.07 151.81 467.71 151.21 467.18 150.61 466.63 150 466.24 148.38 465.56 147.59 463.89 146.87 464.56 143.34 469.55 142.98 Z"
          data-name="Buffalo"
          data-stusps="WI"
          id="55011"
        />
        <path
          className="white"
          d="M 729.46 163.28 729.43 163.11 729.42 163.09 729.42 163.08 729.18 161.84 728.84 160.19 728.39 158 728.29 157.51 728.45 157.48 730.28 160.53 730.93 159.87 732.26 160.44 732.54 160.78 733.97 160.95 734.47 161.4 735.1 161.71 735.74 162.26 736.59 162.66 736.44 163.19 736.56 163.61 736.44 165.16 736.83 165.38 736.78 165.6 736.5 165.82 735.86 165.86 735.41 165.89 734.76 166.89 734.66 166.94 734.28 167.1 733.83 167.3 733.26 167.58 733.61 167.85 733.28 168.5 732.84 168.84 732.16 168.94 731.52 169.37 730.99 169.96 730.51 170.1 729.78 170.92 729.78 170.92 729.66 170.57 729.59 170.31 728.19 169.01 728.57 168.61 731.12 165.95 729.73 164.65 729.46 163.28 Z"
          data-name="Fairfield"
          data-stusps="CT"
          id="9001"
        />
        <path
          className="white"
          d="M 256.06 239 261.74 239.7 262.66 242.02 263.89 242.1 265.25 243.6 265.39 244.86 264.22 246.89 265.38 248.76 264.73 250.53 263.09 251.47 262.65 251.2 262.07 251.79 259.55 251.52 258.2 249.26 258.05 247.24 257.11 245.98 257.68 245.53 258.07 243.6 259.44 242.2 257.39 241.97 256.28 240.15 255.61 240.09 256.06 239 Z"
          data-name="Chaffee"
          data-stusps="CO"
          id="8015"
        />
        <path
          className="white"
          d="M 571.63 368.12 571.96 368.08 571.91 367.51 572.72 368.83 579.49 368.13 579.75 369.78 580.03 369.75 579.98 372.26 577.46 372.84 576.54 375.16 574.39 375.36 574.25 373.72 572.73 373.86 572.44 372.37 571.57 372.17 570.78 372.45 570.61 370.74 570.4 368.69 570.56 368.26 571.63 368.12 Z"
          data-name="Bullock"
          data-stusps="AL"
          id="1011"
        />
        <path
          className="white"
          d="M 394.95 131.1 397.85 131.16 398.06 130.6 404.98 130.68 405.14 131.04 405.14 131.77 405.12 137.24 399.44 137.19 399.46 133.94 394.91 133.84 394.95 131.1 Z"
          data-name="Grant"
          data-stusps="SD"
          id="46051"
        />
        <path
          className="white"
          d="M 597.81 268.56 599.18 267.52 600.3 268.15 602.55 265.83 604.01 266.37 604.41 269.56 605.3 269.28 606.42 270.06 605.72 271.53 606.05 273.54 605.08 273.99 604.12 273.73 604.14 272.17 603.43 270.88 601.45 270.16 600.1 268.52 598.66 270.34 598.31 269.95 597.87 269.45 597.81 268.56 Z"
          data-name="Perry"
          data-stusps="KY"
          id="21193"
        />
        <path
          className="white"
          d="M 679.4 203.83 680.18 202.66 683.29 201.14 683.74 200.4 685.7 201.08 686.79 202.41 687.28 203.85 686.72 204.48 687.2 206.58 684.02 207.27 683.68 207.34 680.48 208.02 679.4 203.83 Z"
          data-name="Adams"
          data-stusps="PA"
          id="42001"
        />
        <path
          className="white"
          d="M 605.68 291.5 605.41 290.79 606.49 290.58 606.18 289.71 606.49 289.56 606.46 290.02 607.61 290.56 611.3 293.66 611.06 293.83 611.36 294.79 610.9 295.76 610.53 296.43 610.38 296.69 609.29 296.74 608.57 297.06 607.61 297.43 607.13 298.22 606.28 298.51 606.27 298.53 605.91 296.47 604.98 295.23 605.18 295.03 605.23 293.05 605.52 293.16 605.68 291.5 Z"
          data-name="Cocke"
          data-stusps="TN"
          id="47029"
        />
        <path
          className="white"
          d="M 351.89 418.8 358.84 419.25 363.02 421.5 365.26 422.71 364.8 423.25 362.76 425.6 362.03 425.78 361.86 424.43 354.85 424.15 351.72 424.06 351.89 418.8 Z"
          data-name="Bandera"
          data-stusps="TX"
          id="48019"
        />
        <path
          className="white"
          d="M 142.53 238.31 151.19 240.04 166.04 242.89 165.3 247.78 163.5 247.45 163.34 249.1 161.68 248.78 160.85 253.75 157.56 253.15 157.41 253.97 155.36 253.59 155.27 254.07 152.02 253.3 152.19 252.42 148.86 251.77 149.18 250.08 147.42 250.01 140.4 248.62 140.95 245.94 141.5 243.38 142.53 238.31 142.53 238.31 Z"
          data-name="Iron"
          data-stusps="UT"
          id="49021"
        />
        <path
          className="white"
          d="M 655.17 287.32 660.37 286.72 663.04 286.4 663.21 287.48 664.07 293.74 660.78 294.36 656.16 295.24 655.17 287.32 Z"
          data-name="Randolph"
          data-stusps="NC"
          id="37151"
        />
        <path
          className="white"
          d="M 533.63 275.22 536.75 272.85 538.15 272.23 539.84 270.52 540.83 273.68 541.33 273.76 540.16 276.11 541.16 278.23 538.44 279.45 535.95 278.84 533.93 277.27 533.11 275.81 533.63 275.22 Z"
          data-name="Hopkins"
          data-stusps="KY"
          id="21107"
        />
        <path
          className="white"
          d="M 28.94 211.06 31.51 208.38 31.85 208.58 32.44 209.33 34.32 209.42 35.17 209.78 38.45 209.58 38.51 211.15 38.6 213.85 38.73 214.28 36.94 220.79 35.93 220.04 34.09 219.89 31.66 220.81 27.12 223.27 26.17 221.72 27.3 217.89 27.71 216.48 28.24 215.96 28.94 211.06 Z"
          data-name="San Joaquin"
          data-stusps="CA"
          id="6077"
        />
        <path
          className="white"
          d="M 588.06 245.69 588.92 242.25 589.73 242.45 590.08 243.08 590.88 243.37 591.14 244.05 592.17 244.3 592.59 244.39 593.04 244.11 593.44 244.64 593.41 246.29 590.36 248.02 589.22 247.48 588.38 245.77 588.06 245.69 Z"
          data-name="Mason"
          data-stusps="KY"
          id="21161"
        />
        <path
          className="white"
          d="M 235.8 101.96 236.09 100.32 242.51 101.41 242.26 104.71 241.36 109.89 241.95 111.37 240.26 110.98 238.89 111.4 238.13 111.18 237.91 112.39 237.08 112.25 236.89 113.35 234.71 112.98 232.31 113.97 230.86 115.4 230.72 116.21 229.67 116.03 229.36 117.79 227.89 117.54 227.72 117.41 224.37 116.82 224.97 113.5 226.72 113.82 227.31 110.56 228.93 110.85 229.08 110.04 230.7 110.33 230.85 109.51 232.47 109.8 233.02 106.52 233.5 104.92 234.06 105.03 234.35 103.36 235.44 103.53 235.8 101.96 Z"
          data-name="Stillwater"
          data-stusps="MT"
          id="30095"
        />
        <path
          className="white"
          d="M 220.59 228.32 234.42 230.32 244.29 231.64 243.66 232.55 244.55 233.78 244.07 233.69 242.91 234.3 240.7 235.46 238.58 237.07 237.31 236.2 235.35 236.46 233.58 237.62 232.73 238.86 229 239.88 228.58 242.91 228.14 246.08 218.05 244.65 219.91 232.86 220.59 228.32 Z"
          data-name="Mesa"
          data-stusps="CO"
          id="8077"
        />
        <path
          className="white"
          d="M 192.67 185.06 193.92 185.36 194.71 186.69 194.18 187.99 195 188.33 194.14 189.55 192.64 189.55 192.3 190.32 190.4 190.44 188.94 191.54 189.77 192.46 190.09 194.38 189.15 195.63 187.57 195.07 187.42 194.05 186.39 193.64 185.63 191.63 185.95 191 185.54 190.32 185.69 188.09 185.63 187.13 186.78 186.77 188.38 187.77 189.74 186.91 191.12 187.39 192.67 185.06 Z"
          data-name="Morgan"
          data-stusps="UT"
          id="49029"
        />
        <path
          className="white"
          d="M 300.42 95.59 302.98 95.05 304.62 92.61 304.78 90 303.8 86.59 307.48 87 308.68 86.31 308.54 87.53 308.54 87.56 308.14 91.37 307.75 95 307.32 99.13 307.18 100.49 303.17 100.06 302.45 99.16 300.01 98.88 300.31 96.13 300.42 95.59 Z"
          data-name="Wibaux"
          data-stusps="MT"
          id="30109"
        />
        <path
          className="white"
          d="M 638.87 400.77 644.44 399.99 644.97 399.94 645.12 401.26 645.19 402.99 646.83 404.23 647.44 406.39 643.61 406.94 642.11 407.96 641.72 408.9 639.96 409.67 639.95 409.12 638.97 401.6 638.87 400.77 Z"
          data-name="Clay"
          data-stusps="FL"
          id="12019"
        />
        <path
          className="white"
          d="M 565.2 142.18 568.45 141.72 571.17 141.31 571.62 144.4 572.06 147.62 569.38 148.23 566.12 148.65 565.2 142.18 Z"
          data-name="Gladwin"
          data-stusps="MI"
          id="26051"
        />
        <path
          className="white"
          d="M 612.97 219.47 618.53 218.89 619.38 218.79 619.6 220.45 620.44 220.35 620.64 221.81 618.83 222.14 619.21 224.09 617.49 224.11 617.3 224.99 614.19 225.29 614.04 223.56 613.87 220.23 613.04 220.3 612.97 219.47 Z"
          data-name="Morgan"
          data-stusps="OH"
          id="39115"
        />
        <path
          className="white"
          d="M 586.75 248.43 588.37 248.94 588.61 248.58 589.75 249.95 590.94 250.21 590.92 251 589.25 253.23 589.34 252.89 587.34 252.2 585.6 250.26 586.75 248.43 Z"
          data-name="Nicholas"
          data-stusps="KY"
          id="21181"
        />
        <path
          className="white"
          d="M 74.21 31.5 76.32 29.35 78.01 25.04 79.39 25.55 80.09 25.82 80.43 25.95 94.47 30.92 94.71 32.38 93.83 32.66 93.36 34.33 92.58 34.2 88.51 36.22 87.38 37.28 87.41 38.65 88.45 39.18 87.78 40.12 88.14 41.83 86.7 42.6 86.7 42.6 84.35 41.12 83.95 40.26 81.99 39.15 79.98 39.15 78.37 37.39 78.17 36.01 77.09 35.62 75.8 35.15 75.76 35.13 75.65 34.69 74.99 33.25 73.98 33.17 73.75 32.72 74.21 31.5 Z"
          data-name="King"
          data-stusps="WA"
          id="53033"
        />
        <path
          className="white"
          d="M 644.9 363.12 647.7 359.99 648.5 360.08 649.09 360.96 649.35 362.16 650.65 362.54 651.11 362.15 652.26 362.83 653.25 363.14 653.97 363.24 653.98 363.93 653.08 364.92 652.67 365.58 651.87 366.78 651.39 367.7 650.87 368.77 650.1 369.62 650.06 369.86 649.74 369.86 649.11 367.95 649.63 367.11 646.84 365.11 644.9 363.12 Z"
          data-name="Chatham"
          data-stusps="GA"
          id="13051"
        />
        <path
          className="white"
          d="M 217.76 58.02 225.05 59.48 225.37 57.87 226.27 58.05 227.9 58.37 228.22 56.74 237.95 58.62 237.65 60.25 239.14 60.47 238.84 62.13 241.26 62.54 239.86 69.94 237.9 69.78 237.41 70.2 236 69.76 235.23 72.96 232.73 73.65 230.87 74.55 230.19 74.39 224.78 73.36 224.88 72.82 223.24 72.48 223.54 71 222.32 70.77 220.24 68.93 221.55 67.24 216.08 66.14 217.2 60.73 217.76 58.02 Z"
          data-name="Chouteau"
          data-stusps="MT"
          id="30015"
        />
        <path
          className="white"
          d="M 572.99 127.72 580.63 126.51 581.18 128.35 581.66 129.6 581.39 131.2 581.64 133.02 573.99 134.24 572.99 127.72 Z"
          data-name="Alcona"
          data-stusps="MI"
          id="26001"
        />
        <path
          className="white"
          d="M 385.29 310.55 393.44 310.71 393.37 315.59 393.33 317.22 390.64 317.17 389.01 317.15 385.21 317.09 385.21 316.54 385.29 310.55 Z"
          data-name="Oklahoma"
          data-stusps="OK"
          id="40109"
        />
        <path
          className="white"
          d="M 697.23 166.02 700.88 165.14 702.97 172.3 702.16 173.01 701.66 173.3 701.13 174.68 700.32 174.36 699.06 171.62 696.59 170.47 697.12 168.77 696.59 168.53 697.23 166.02 Z"
          data-name="Lackawanna"
          data-stusps="PA"
          id="42069"
        />
        <path
          className="white"
          d="M 615.67 182.99 615.94 182.66 616.84 181.39 618.11 180.14 619.47 179.39 621.16 178.07 621.83 177.76 622.25 180.29 620.86 180.55 621.11 181.92 618.39 182.4 618.6 183.74 617.25 183.98 615.88 184.21 615.67 182.99 Z"
          data-name="Lake"
          data-stusps="OH"
          id="39085"
        />
        <path
          className="white"
          d="M 431.26 235.29 437 235.22 437.04 239.33 437.03 240.69 431.36 240.75 431.33 239.36 431.26 235.29 Z"
          data-name="Clinton"
          data-stusps="MO"
          id="29049"
        />
        <path
          className="white"
          d="M 515.6 313.52 515.58 312.85 517.17 312.77 520.83 312.58 521.71 314.38 521.99 315.9 522.26 320.65 521.69 320.69 518.69 320.9 518.54 320.91 515.89 321.1 515.6 313.52 Z"
          data-name="Hardeman"
          data-stusps="TN"
          id="47069"
        />
        <path
          className="white"
          d="M 565.48 326.84 566.13 326.67 569.45 323.62 572.15 318.86 572.69 320.9 573.36 323.24 573.55 323.89 573.89 325.09 573.21 325.57 572.35 327.68 570.31 330.49 569.25 330.87 569.34 331.71 565.23 332.1 564.66 328.3 565.48 326.84 Z"
          data-name="DeKalb"
          data-stusps="AL"
          id="1049"
        />
        <path
          className="white"
          d="M 59.47 214.97 61.73 212.42 61.22 209.78 62.3 207.83 65.19 212.25 65.77 213.14 67.18 215.29 69.54 218.86 74.71 226.72 75.55 228.01 80.29 235.16 82.51 238.49 68.17 234.93 67.08 234.39 66.44 232.7 65.01 231.61 64.21 228.37 62.04 227.69 63.39 226.72 63.82 225.17 62.5 223.57 62.95 222.11 62.63 220.82 61 219.45 59.53 218.46 58.9 217.44 59.52 216.87 59.07 215.69 59.47 214.97 Z"
          data-name="Mono"
          data-stusps="CA"
          id="6051"
        />
        <path
          className="white"
          d="M 491.99 194.67 492.82 194.06 492.77 193.45 492.95 192.7 492.99 191.83 493.41 191.82 499.62 191.36 500.45 191.84 500.85 197.79 497.59 198.04 493.04 198.33 493.31 197.2 492.3 196.67 491.99 194.67 Z"
          data-name="Whiteside"
          data-stusps="IL"
          id="17195"
        />
        <path
          className="white"
          d="M 134.76 98.54 135.32 97.96 136.81 95.53 136.95 95.28 141.55 96.54 141.62 99.34 143.39 100.23 143.91 101.25 141.49 104.61 140.9 106.12 141.23 107.79 140.3 109.92 140.24 111.6 139.55 111.18 138.06 112.12 136.61 111.74 135.21 110.43 135.82 108.11 134.79 106.87 135.66 103.57 132.14 102.6 132.62 102.12 133.33 101.14 133.26 100.12 133.75 99.2 134.75 98.55 134.76 98.54 Z"
          data-name="Adams"
          data-stusps="ID"
          id="16003"
        />
        <path
          className="white"
          d="M 587.42 277.32 587.96 276.74 589.17 277.23 590.51 276.75 591.15 278.63 592.52 279.47 593.07 280.81 594.4 281.41 593.3 282.35 593.83 283.39 592.96 283.46 592.95 283.46 589.31 283.86 587.89 282.42 586.85 279.98 587.37 279.48 587.42 277.32 Z"
          data-name="Whitley"
          data-stusps="KY"
          id="21235"
        />
        <path
          className="white"
          d="M 555.58 120.49 557.06 122.03 557.5 121.6 560.59 121.21 560.79 122.86 561.01 124.49 559.38 124.68 554.51 125.32 554.3 123.67 552.24 123.91 552.16 122.71 553.07 121.72 554.26 120.72 555.58 120.49 Z M 546.67 114.54 547.31 114.33 548.77 112.48 550.95 112.43 550.86 113.37 549.54 116.84 548.91 117.38 548.07 117.22 546.83 115.26 546.67 114.54 Z"
          data-name="Charlevoix"
          data-stusps="MI"
          fillRule="evenodd"
          id="26029"
        />
        <path
          className="white"
          d="M 211.5 39.75 212.11 39.88 215.67 40.68 220.01 41.63 222.85 42.22 219.77 56.73 218.1 56.39 214.89 55.72 215.41 53.29 213.79 52.94 213.96 52.13 211.54 51.59 211.71 50.76 209.46 49.5 211.5 39.75 Z"
          data-name="Toole"
          data-stusps="MT"
          id="30101"
        />
        <path
          className="white"
          d="M 711.83 207.58 712.25 206.13 713.69 203.73 716.46 205.04 716.24 202.92 717.61 203.67 719.93 204.94 720.31 206.85 719.88 209.26 720.19 209.84 718.9 209.86 718.05 209.58 717.44 209.81 716.9 210.52 716.27 209.86 715.41 209.26 714.84 208.93 714.21 208.95 713.41 208.34 712.92 208.15 712.13 207.7 711.83 207.58 Z"
          data-name="Cumberland"
          data-stusps="NJ"
          id="34011"
        />
        <path
          className="white"
          d="M 651.8 351.2 652.38 350.27 654.97 350.53 655.31 351.63 657.19 352.26 658.73 353.52 658.71 353.61 658.7 353.64 658.56 354.1 659.14 355 659.61 355.61 659.41 356.58 658.16 357.53 657.28 357.92 656.45 357.7 655.22 357.21 654.48 357.96 655.19 358.38 656.26 359.17 655.57 360.37 654.23 361.54 653.51 361.84 653.43 362.26 650.58 359.45 650.57 358.25 651.74 358.21 653.01 356.38 653.17 354.82 652.48 352.11 651.8 351.2 Z"
          data-name="Beaufort"
          data-stusps="SC"
          id="45013"
        />
        <path
          className="white"
          d="M 574.19 233.84 574.19 233.84 576.93 233.37 581.03 233.23 582.37 233.13 582.46 233.45 581.68 234.46 582.24 235.1 582.11 235.34 582.16 238.28 582.06 238.16 580.92 237.95 580.36 237.3 580.11 236.75 579.85 236.64 579.58 236.77 579.43 237.06 579.35 237.08 579.24 237.1 578.6 237.23 577.82 237.82 577.6 237.75 576.74 237.48 576.12 236.9 575.55 236.69 574.63 237.6 574.35 235.31 574.19 233.84 Z"
          data-name="Hamilton"
          data-stusps="OH"
          id="39061"
        />
        <path
          className="white"
          d="M 353.52 159.41 355.07 160.02 356.56 159.74 356.9 160.08 358.85 160.14 360.13 159.8 361.39 158.81 361.82 159.28 361.61 163.83 362.83 163.89 362.42 173.3 358.06 173.1 353.26 172.87 353.18 170.41 353.43 165.49 353.29 163.83 353.52 159.41 Z"
          data-name="Tripp"
          data-stusps="SD"
          id="46123"
        />
        <path
          className="white"
          d="M 482.74 371.61 482.52 369.79 482.94 369.11 488.09 368.89 489.3 368.07 489.4 368.16 489.41 368.18 490.05 369.21 489.27 369.32 489.45 370.7 490.85 370.9 490.58 372.28 491.63 372.41 491.26 373.53 490.63 374.86 488.76 375.06 488.32 374.31 485.37 375.31 482.62 375.41 481.57 374.58 482.87 373.28 482.74 371.61 Z"
          data-name="Madison"
          data-stusps="LA"
          id="22065"
        />
        <path
          className="white"
          d="M 279.86 227.69 283.68 227.95 284.74 226.2 286.06 226.13 286.64 226.33 286.2 227.74 284.14 227.52 284.44 228.58 282.2 228.9 282.02 229.71 281.85 229.66 281.9 229.84 281.9 229.81 281.91 229.81 281.91 229.8 281.91 229.79 282.59 230.52 281.56 231.04 281.35 230.47 281.01 230.44 280.77 230.13 280.18 229.86 280.15 230.2 279.89 230.25 279.81 230.79 279.52 230.89 279.44 231.01 278.88 230.88 279.35 230.92 279.86 227.69 Z"
          data-name="Denver"
          data-stusps="CO"
          id="8031"
        />
        <path
          className="white"
          d="M 272.13 217.93 279.25 218.7 280.75 218.84 280.5 221.16 280.27 223.42 280.27 223.76 279.9 224.67 279.37 224.49 278.46 225.21 275.95 224.95 275.1 224.87 275.14 224.46 271.12 224.07 270.89 223.82 271.87 222.13 272.13 217.93 Z"
          data-name="Boulder"
          data-stusps="CO"
          id="8013"
        />
        <path
          className="white"
          d="M 270.74 225.56 273.35 227.63 274.76 228.01 274.38 231.39 271.64 231.06 268.88 230.81 268.11 230.73 268.98 229.98 267.01 228.05 267.76 226.28 269.97 226.37 270.74 225.56 Z"
          data-name="Clear Creek"
          data-stusps="CO"
          id="8019"
        />
        <path
          className="white"
          d="M 291.48 260.02 294.73 260.93 297.95 261.2 298.04 260.11 299.67 260.23 299.93 258.5 301.44 258.62 300.42 270.3 290.64 269.46 290.75 267.75 291.48 260.02 Z"
          data-name="Otero"
          data-stusps="CO"
          id="8089"
        />
        <path
          className="white"
          d="M 17.78 104.86 20.84 105.98 21.23 106.57 21.73 108.53 20.71 110.52 20.59 112.03 22.61 112.37 24.2 111.05 25.88 111.35 26.34 111.3 27.16 111.92 24.54 114.2 22.82 116.38 21.15 115.87 19.94 117.75 21.84 119.2 22.42 121.83 20.8 123.43 20.99 124.51 20.38 126.24 17.86 125.33 14.91 124.22 14.4 123.03 13.94 122.39 13.84 121.03 14.06 120.02 14.06 119.03 13.84 118.45 14.24 117.38 14.34 116.47 14.82 114.76 16.01 113.06 16.38 111.97 16.63 110.77 16.24 110.24 16.37 109.99 15.82 108.83 15.98 106.62 17.74 104.91 17.78 104.86 Z"
          data-name="Curry"
          data-stusps="OR"
          id="41015"
        />
        <path
          className="white"
          d="M 476.7 164.76 477.07 164.67 484.11 164.25 484.43 168.97 482.08 170.88 480.8 171.26 479.19 172.65 477.86 172.83 477.59 171.88 477.54 171.1 477.48 170.07 478 169.3 478.6 168.37 478.97 167.74 478.23 166.66 477.55 166.3 476.79 165.61 476.87 165.06 476.7 164.76 Z"
          data-name="Crawford"
          data-stusps="WI"
          id="55023"
        />
        <path
          className="white"
          d="M 603.48 312.83 604.51 312.66 606.99 312.25 610.31 311.73 610.17 312.62 609.99 313.23 609.15 314.11 608.42 314.8 607.99 315.44 607.47 316.15 607.6 316.71 607.15 317.36 607.24 317.57 605.89 317.16 604.29 317.5 603.29 316.09 602.27 316.16 602.07 315.12 603.48 312.83 Z"
          data-name="Rabun"
          data-stusps="GA"
          id="13241"
        />
        <path
          className="white"
          d="M 431.84 296.19 435.72 296.14 440.03 296.08 441.81 296.05 443.21 296.02 442.9 298.29 444.07 299.61 443.25 299.61 442.99 300.97 441.7 301.57 436.22 301.47 436.2 302.83 435.38 303.65 432.94 303.63 432.76 302.51 432.37 299.93 431.84 296.19 Z"
          data-name="Benton"
          data-stusps="AR"
          id="5007"
        />
        <path
          className="white"
          d="M 440.42 315.83 441.17 313.4 440.35 313.38 440.36 311.76 441.73 311.76 442.82 309.89 442.96 309.61 446.1 309.65 446.05 317.03 444.54 316.14 444.53 318.23 442.88 318.15 442.87 319.83 441.2 320.15 440.66 320.42 440.39 318.8 440.4 316.44 440.42 315.83 Z"
          data-name="Franklin"
          data-stusps="AR"
          id="5047"
        />
        <path
          className="white"
          d="M 621.46 383.68 626.34 383.1 628.02 386.08 629.81 386.93 630.06 389.66 631.04 389.53 631.87 394.03 631.19 394.05 631.19 394.05 629.13 394.16 628.94 392.17 625.82 391.84 624.28 390.06 622.16 389.64 621.46 383.68 Z"
          data-name="Clinch"
          data-stusps="GA"
          id="13065"
        />
        <path
          className="white"
          d="M 596.91 265.38 597.43 262.77 597.88 263.07 598.86 261.58 601.46 261.63 603.33 262.58 603.94 262.01 605.23 262.77 606.4 264.15 604.24 264.07 604.01 266.37 602.55 265.83 600.3 268.15 599.18 267.52 597.81 268.56 597.81 266.96 596.91 265.38 Z"
          data-name="Breathitt"
          data-stusps="KY"
          id="21025"
        />
        <path
          className="white"
          d="M 562.27 367.64 562.76 366.44 563.53 366.29 565.76 364.34 566.98 365.48 569.37 365.83 569.72 365.53 570.37 367.07 571.63 368.12 570.56 368.26 570.4 368.69 570.61 370.74 570.78 372.45 570.95 374.02 567.8 374.33 566.02 374.51 565.85 372.88 564.21 373.05 563.91 370.07 563.84 369.4 563.61 369.25 563.17 369.1 563 368.91 562.65 368.99 562.56 368.75 562.65 367.85 562.27 367.64 Z"
          data-name="Montgomery"
          data-stusps="AL"
          id="1101"
        />
        <path
          className="white"
          d="M 594.46 313.94 596.39 313.72 597.46 313.59 597.47 313.59 597.94 314.69 599.64 314.92 600.34 316.97 599.67 317.32 599.32 318.45 597.98 318.26 596.69 320.3 594.78 320.41 595.45 317.4 595.03 315.81 593.78 314.71 594.46 313.94 Z"
          data-name="Union"
          data-stusps="GA"
          id="13291"
        />
        <path
          className="white"
          d="M 488.72 159.85 495.9 159.34 496.73 160.59 498.56 160.71 498.79 164.04 497.77 164.49 497.27 165.81 497.17 166.59 495.78 167.56 493.57 167.93 492.83 168.92 490.94 168.68 490.69 164.63 490.47 161.35 488.84 161.48 488.72 159.85 Z"
          data-name="Sauk"
          data-stusps="WI"
          id="55111"
        />
        <path
          className="white"
          d="M 637.76 166.62 639.44 165.22 641.55 163.12 642.34 161.88 643.55 160.76 644.67 159.86 645.36 159.35 645.38 159.26 645.77 159.16 646.54 159.63 648.6 169.78 642.82 170.94 640.88 171.32 638.76 171.72 638.27 169.23 637.76 166.62 Z"
          data-name="Chautauqua"
          data-stusps="NY"
          id="36013"
        />
        <path
          className="white"
          d="M 294.42 77.2 295.1 75.81 295.56 72.09 295.85 71.43 295.86 71.83 298.13 72.4 299.56 70.97 300.35 71.67 302.09 72.17 303.86 71.93 307.42 74.14 308.77 73.83 309.21 74.92 309.89 75.07 309.89 75.07 309.84 75.53 309.52 78.69 309.1 82.44 308.68 86.31 307.48 87 303.8 86.59 302.62 86.45 302.99 83.17 301.96 83.06 302.15 81.43 297.27 80.86 297.47 79.23 294.21 78.83 294.42 77.2 Z"
          data-name="Richland"
          data-stusps="MT"
          id="30083"
        />
        <path
          className="white"
          d="M 518.71 255.18 518.53 252.71 520.2 252.56 525.09 252.31 526.65 252.21 526.71 252.75 527.15 258.63 523.9 258.92 518.98 259.28 518.71 255.18 Z"
          data-name="Wayne"
          data-stusps="IL"
          id="17191"
        />
        <path
          className="white"
          d="M 582.25 355.74 587.1 355.27 587.41 355.16 589.18 355.04 590.04 355.42 590.55 357.54 590.46 358.4 590.66 360.33 587.25 360.7 587.2 360.24 587.12 360.25 584.51 360.51 584.22 359.59 583.67 358.26 583.46 357.88 582.73 356.52 582.29 355.91 582.25 355.74 Z"
          data-name="Harris"
          data-stusps="GA"
          id="13145"
        />
        <path
          className="white"
          d="M 585.96 370.77 585.98 370.29 585.7 369.39 586.58 368.36 587.6 367.61 587.74 367.37 589.14 367.23 589.68 367.17 591.93 366.9 592.09 366.88 592.48 367.77 592.6 372.8 592.26 372.67 592.02 372.85 590.09 372.84 588.55 373.14 587.42 372.76 586.27 372.39 585.89 372.12 585.96 370.77 Z"
          data-name="Stewart"
          data-stusps="GA"
          id="13259"
        />
        <path
          className="white"
          d="M 605.95 260.11 608.67 258.96 610.44 259.4 611.47 259.75 611.7 259.9 610.97 260.28 611.29 263.45 611.97 264.07 611.08 267.27 610.56 267.76 609.4 265.23 608.33 265.59 608.25 264.59 606.79 264.41 607.36 263.4 605.95 260.11 Z"
          data-name="Floyd"
          data-stusps="KY"
          id="21071"
        />
        <path
          className="white"
          d="M 372.08 443.63 376.06 440.44 377.56 442.28 376.16 442.76 380.65 451.83 380.5 451.95 379.05 453.1 379.38 454.18 373.52 454.05 371.88 454.02 372.08 443.63 Z"
          data-name="Live Oak"
          data-stusps="TX"
          id="48297"
        />
        <path
          className="white"
          d="M 629.69 240.86 630.51 239.98 631.07 239 631.66 237.81 633.74 239.49 634.4 240.48 635.44 240.86 634.24 242.3 629.94 245.93 628.53 242.12 629.69 240.86 Z"
          data-name="Clay"
          data-stusps="WV"
          id="54015"
        />
        <path
          className="white"
          d="M 622.36 419.97 623.98 418.63 624.99 416.18 625.51 413.81 626.87 413.79 628.25 413.62 628.58 414.02 630.23 413.78 631.93 414.11 632.07 415.2 634.56 414.81 634.85 417.16 635.21 419.92 633.02 420.2 633.38 423.42 632.17 424.25 630.47 424.02 629.8 424.67 629.73 424.57 629.62 423.67 628.46 422.94 628.84 422.6 628.27 421.82 626.58 421.81 625.41 421.76 625.19 422.8 624.56 422.76 623.99 421.56 623.96 420.58 623.37 420.24 622.36 419.97 Z"
          data-name="Levy"
          data-stusps="FL"
          id="12075"
        />
        <path
          className="white"
          d="M 609.24 368.91 609.06 367.2 613.04 366.63 613.46 366.93 614.2 367.35 614.46 369.14 616.05 370.57 616.1 370.86 616.62 371.5 616.41 371.5 611.73 372.09 610.72 372.09 609.58 372.2 609.24 368.91 Z"
          data-name="Wilcox"
          data-stusps="GA"
          id="13315"
        />
        <path
          className="white"
          d="M 73.08 289.65 73.64 289.79 76.95 275.57 77.68 273.39 77.26 272.7 77.93 271.09 83.9 272.52 99.06 275.95 107.48 277.75 108.92 277.73 108.92 277.74 111.94 282.19 113.2 284.03 115 286.66 116.46 288.79 119.48 293.2 121.64 296.36 121.48 297.49 121.14 298.81 121.84 300.09 122.86 302.08 123.14 302.8 123.41 305.03 123.87 306.39 123.62 307.65 124.31 307.79 125.26 308.93 126.51 310.27 126.87 311.11 126.86 311.17 126.74 312 126.05 312.26 125.04 313.12 123.97 313.32 122.97 313.77 121.97 314.04 121.55 314.33 121.47 314.59 107.37 311.88 107.2 312.72 91.5 309.56 81.45 307.39 81.34 307.95 78.54 307.36 78.26 307.32 76.65 306.67 74.32 306.13 74.32 305.84 71.33 305.48 70.09 307.09 69.37 306.95 68.86 307.91 67.41 306.07 67.23 305.44 67.98 304.72 68.36 304.79 69.15 303.77 69.32 303.49 69.61 303.02 70.07 302.2 71.09 299.97 71.42 297.86 73.08 289.65 Z"
          data-name="San Bernardino"
          data-stusps="CA"
          id="6071"
        />
        <path
          className="white"
          d="M 610.2 212.26 617.05 211.45 617.55 215.64 618.09 215.57 618.32 217.24 618.53 218.89 612.97 219.47 612.89 218.61 611.46 218.75 611.31 217.06 610.26 217.15 610.67 216.37 610.52 215.03 610.2 212.26 Z"
          data-name="Muskingum"
          data-stusps="OH"
          id="39119"
        />
        <path
          className="white"
          d="M 434.67 339.45 438.2 339.35 440.6 339.42 440.55 341.46 441.17 343.59 440.99 344.28 441.34 345.12 442.68 346.71 442.79 347.55 441.5 346.99 439.28 346.91 437.37 346.13 435.7 344.02 434.62 344.12 434.64 342.64 434.67 339.45 Z"
          data-name="Sevier"
          data-stusps="AR"
          id="5133"
        />
        <path
          className="white"
          d="M 388.49 410.06 389.06 410.38 390.39 411.14 391.24 411.62 391.89 412.14 393.13 413.11 394.03 417.02 391.22 419.88 389.21 421.92 383.84 416.57 386.46 413.92 386.46 413.91 387.98 411.02 388.49 410.06 Z"
          data-name="Bastrop"
          data-stusps="TX"
          id="48021"
        />
        <path
          className="white"
          d="M 435.64 126.12 440.79 125.99 444.07 125.91 444.15 128.62 444.22 131.79 444.09 131.78 443.5 130.77 440.75 130.89 437.04 128.65 435.76 127.35 435.64 126.12 Z"
          data-name="Sherburne"
          data-stusps="MN"
          id="27141"
        />
        <path
          className="white"
          d="M 688.82 116.61 693.18 117.91 696.33 126.74 691.49 131.9 688.19 131.72 686.92 127.68 686.27 125.84 685.38 126 685.09 124.24 686.22 124.05 687.89 121.78 688.72 121.63 689 119.45 688.01 119.14 688.82 116.61 Z"
          data-name="Lewis"
          data-stusps="NY"
          id="36049"
        />
        <path
          className="white"
          d="M 691.38 256.16 692.33 255.44 691.43 254.68 691.38 254.48 691.56 254.02 691.56 253.44 691.8 253.26 692.14 254.09 693.05 253.6 693.14 253.37 692.58 253.1 692.59 252.98 692.75 252.92 695.04 252.8 696.01 253.26 697 252.44 697.56 253.36 697.02 253.78 695.31 256.52 694.88 256.87 692.07 259.53 691.96 258.71 691.38 256.16 Z"
          data-name="Prince George"
          data-stusps="VA"
          id="51149"
        />
        <path
          className="white"
          d="M 682.32 114.53 688.82 116.61 688.01 119.14 689 119.45 688.72 121.63 687.89 121.78 686.22 124.05 685.09 124.24 685.38 126 686.27 125.84 686.92 127.68 683.41 128.19 683.63 128.91 681.13 129.29 680.63 127.95 680.17 127.06 679.01 126.29 678.06 126.21 676.92 126.29 677.13 125.38 678.71 124.06 678.08 123.17 677.13 123.27 677.13 122.46 676.88 121.96 676.93 121.3 677.07 120.63 677.54 119.74 678.57 119.27 679.02 118.66 678.86 117.88 679.65 117.31 680.72 116.08 681.4 115.88 682.32 114.53 Z"
          data-name="Jefferson"
          data-stusps="NY"
          id="36045"
        />
        <path
          className="white"
          d="M 379.15 286.55 380.15 286.57 383.81 286.65 384.31 286.66 388.92 286.74 388.79 294.34 379.09 294.14 379.02 293.8 379.15 286.55 Z"
          data-name="Grant"
          data-stusps="OK"
          id="40053"
        />
        <path
          className="white"
          d="M 552.37 339.78 552.9 338.77 554.88 337.78 556.4 335.61 556.23 335 557.62 334.37 557.56 334.26 557.79 333.98 557.96 333.45 558.11 333.35 558.67 331.74 559.69 331.51 560.48 332.47 562.32 334.31 561.97 335.46 561.55 337.41 562.25 337.34 562 338.48 561.17 339.42 558.53 340.3 558.59 340.99 557.51 340.95 555.61 339.83 553.64 339.96 552.59 340.58 552.37 339.78 Z"
          data-name="Blount"
          data-stusps="AL"
          id="1009"
        />
        <path
          className="white"
          d="M 162.79 151.48 165.11 152 165.47 150.4 166.16 150.55 167.6 143.96 171.74 144.87 170.32 151.47 169.5 151.29 168.77 154.67 167.54 154.65 165.7 156.63 165 156.82 163.9 155.85 161.83 155.8 162.79 151.48 Z"
          data-name="Minidoka"
          data-stusps="ID"
          id="16067"
        />
        <path
          className="white"
          d="M 505.83 260.94 512.44 260.6 512.53 262.25 512.83 262.23 513.09 263.44 512.35 265.56 506.14 265.9 505.83 260.94 Z"
          data-name="Perry"
          data-stusps="IL"
          id="17145"
        />
        <path
          className="white"
          d="M 448.77 201.87 455.22 201.66 455.47 208.17 452.21 208.28 448.97 208.39 448.78 202.19 448.77 201.87 Z"
          data-name="Marion"
          data-stusps="IA"
          id="19125"
        />
        <path
          className="white"
          d="M 402.58 238.76 407.54 238.8 410.49 238.81 410.48 245.36 410.47 246.72 410.42 247.05 409.78 245.79 407.59 245.43 406.15 246.43 405.31 246.16 404.25 246.26 402.97 245.4 401.69 243.88 400.42 241.79 400.73 240.71 402.58 238.76 Z"
          data-name="Pottawatomie"
          data-stusps="KS"
          id="20149"
        />
        <path
          className="white"
          d="M 488.51 254.1 489.32 253.24 491.31 253.04 491.93 251.78 492.06 251.54 492.6 250.32 493.46 250.37 494.3 249.02 496.2 250.22 497.37 250.44 496.69 251.1 495.5 252.19 494.65 254.49 494.75 254.88 495.66 255.72 495.59 255.96 495.47 256.39 495.27 257.49 494.57 258.5 493.48 256.41 491.9 256.5 489.74 257.04 489.5 257.68 488.63 257.34 488.51 254.1 Z"
          data-name="St. Louis"
          data-stusps="MO"
          id="29189"
        />
        <path
          className="white"
          d="M 437 235.22 436.99 234.42 443.46 234.36 443.55 237.61 443.57 239.24 437.04 239.33 437 235.22 Z"
          data-name="Caldwell"
          data-stusps="MO"
          id="29025"
        />
        <path
          className="white"
          d="M 744.34 110.02 745.97 110.86 747.67 111.69 747.68 111.7 749.98 112.59 750.68 112.61 751.82 116.05 751.18 117.69 749.27 117.02 747.21 116.33 745.9 115.89 745.29 116.43 742.82 114.56 743.53 113.15 743.19 111.95 744.06 111.53 744.84 111.16 744.34 110.02 Z"
          data-name="Belknap"
          data-stusps="NH"
          id="33001"
        />
        <path
          className="white"
          d="M 400.2 125.76 407.88 125.84 408.02 129.09 409.67 129.11 409.65 132.34 409.83 133.53 407.08 132.11 405.14 131.77 405.14 131.04 404.98 130.68 404.82 130.31 404.31 129.76 403.77 129.56 403.04 129.14 402.28 129.09 401.82 128.58 401.41 127.8 400.91 126.71 400.2 125.76 Z"
          data-name="Big Stone"
          data-stusps="MN"
          id="27011"
        />
        <path
          className="white"
          d="M 643.6 205.97 644.39 205.06 644.5 201.99 645.21 201.21 644.9 199.33 643.9 199.05 643.67 198.45 644.51 196.58 644.51 196.58 644.83 196.32 647.88 198.77 648.5 198.55 648.62 199.43 649.88 199.78 653.18 199.97 654.13 200.63 655.16 199.42 655.87 199.76 655.87 199.77 655.66 200.58 655.09 202.08 653.88 205.73 652.53 207.36 651.84 207.45 650.44 206.41 649.73 205.87 648.04 207.4 645.66 206.94 643.76 207.32 643.27 206.88 643.6 205.97 Z"
          data-name="Westmoreland"
          data-stusps="PA"
          id="42129"
        />
        <path
          className="white"
          d="M 384.87 133.59 391.35 133.78 391.25 140.3 391.14 145.19 386.29 145.07 386.29 143.44 384.66 143.39 384.87 133.59 Z"
          data-name="Clark"
          data-stusps="SD"
          id="46025"
        />
        <path
          className="white"
          d="M 367.45 422.29 371.32 418.78 373.26 416.94 376.09 419.34 377.55 420.58 377.79 421.46 378.03 422.39 376.52 423.65 374.74 424.46 372.87 425.24 372.87 425.24 372.58 424.98 371.8 423.94 372.24 422.61 370.74 422.85 370.76 422.57 369.02 422.04 367.45 422.29 Z"
          data-name="Comal"
          data-stusps="TX"
          id="48091"
        />
        <path
          className="white"
          d="M 723.17 102.32 723.75 102.33 725.49 102.72 725.8 100.97 727.51 101.59 727.55 101.21 727.84 99.81 729.6 100.15 731.13 100.47 731.2 100.52 731.29 100.69 730.99 102.24 730.6 103.21 730.43 105.2 729.66 105.09 729.85 106.91 727.74 106.91 727.57 108.44 727.27 110.06 726.37 109.98 723.77 109.89 722.8 108.35 722.86 107.08 722.92 105.93 722.76 105.93 722.89 104.13 723.4 104.14 722.97 103.36 723.17 102.32 Z"
          data-name="Washington"
          data-stusps="VT"
          id="50023"
        />
        <path
          className="white"
          d="M 728.2 98.1 729.93 98.42 730.72 93.93 732.39 94.46 732.94 92.84 734.61 93.41 734.04 95.01 735.16 95.4 734.64 96.86 735.64 97.61 734.93 98.96 736.76 100.31 736.31 100.66 735.37 100.95 734.68 101.43 734.28 102.22 734.43 103.1 734.69 104.29 734.94 104.73 733.12 104.62 731.41 105.33 730.43 105.2 730.6 103.21 730.99 102.24 731.29 100.69 731.2 100.52 731.13 100.47 729.6 100.15 727.84 99.81 728.2 98.1 Z"
          data-name="Caledonia"
          data-stusps="VT"
          id="50005"
        />
        <path
          className="white"
          d="M 751.55 107.08 752 107.1 752.89 106.28 754.06 105.99 754.2 105.79 756.12 105.71 756.51 107.18 757.97 106.6 759.68 107.57 759.43 108.39 762 109.18 761.69 109.26 761.62 110.16 762.59 110.44 762.09 111.55 762.04 112.03 761.97 112.66 761.42 113.28 761.28 113.31 760.68 113.44 760.52 113.7 760.32 114.01 760.21 115.13 760.58 115.88 760.63 115.99 760.71 117.18 760.52 117.84 760.27 119.13 759.85 119.6 759 119.46 757.87 118.92 757.72 118.85 757.46 117.88 757.46 117.88 757.4 117.13 756.26 116.39 755.23 115.59 754.09 114.89 753.99 113.82 753.83 112.95 753.7 112.25 753.39 111.72 753.09 111.19 752.78 110.38 752.18 108.78 751.55 107.08 Z"
          data-name="York"
          data-stusps="ME"
          id="23031"
        />
        <path
          className="white"
          d="M 754.14 128.09 754.27 128.05 755.15 127.76 754.78 126.77 754.82 126.7 754.99 126.4 755.14 126.15 755.62 126.07 756.38 125.95 756.45 125.42 756.52 124.82 757.36 124.35 757.76 123.9 758.76 123.88 759.41 123.63 760.11 125.28 760.63 125.98 761 126.47 761.83 127.06 762.55 126.98 762.89 126.31 763.55 126.34 763.93 127.11 763.4 128.37 762.82 128.66 761.44 129.42 760.89 129.83 761 130.04 761.42 130.9 760.84 131.5 760.78 131.94 760.75 132.18 760.72 132.42 760.14 132.65 759.97 132.71 759.76 132.8 758.48 132.13 757.85 130.3 758.17 130.27 758.1 129.98 757.62 129.64 757.4 129.81 756.23 129.95 756.21 130.31 756 129.99 754.59 129.59 754.77 129.28 754.14 128.09 Z"
          data-name="Essex"
          data-stusps="MA"
          id="25009"
        />
        <path
          className="white"
          d="M 646.15 328.39 647.84 329.42 650.09 330.11 652.75 330.06 652.67 330.3 654.4 331.74 654.35 332.03 655.25 333.27 654.34 333.27 653.6 335.31 650.17 333.14 648.06 333.36 647.25 332.79 646.15 331.74 647.88 330.52 646.4 330.27 645.79 331.02 646.15 328.39 Z"
          data-name="Calhoun"
          data-stusps="SC"
          id="45017"
        />
        <path
          className="white"
          d="M 539.25 296.95 539.79 295.56 539.81 293.93 543.05 294.07 543.29 293.87 545.35 294 544.83 295.12 545.61 296.41 545.33 298.85 545.33 300.25 545.15 300.58 540.04 300.39 539.73 299.97 539.25 296.95 Z"
          data-name="Dickson"
          data-stusps="TN"
          id="47043"
        />
        <path
          className="white"
          d="M 301.68 152.81 320.28 154.47 320.08 155.54 318.35 157.49 317.06 157.62 315.61 158.8 315.4 161.22 302.62 160 300.99 159.86 301.03 159.38 301.13 158.35 301.68 152.81 Z"
          data-name="Custer"
          data-stusps="SD"
          id="46033"
        />
        <path
          className="white"
          d="M 384.42 158.05 386 158.11 389.3 158.2 389.18 164.75 384.29 164.65 384.42 158.05 Z"
          data-name="Hanson"
          data-stusps="SD"
          id="46061"
        />
        <path
          className="white"
          d="M 656.17 317.42 659.62 314.41 662.15 314.03 662.89 313.12 664.15 313.26 664.43 314.72 666.3 316.99 665.27 317.31 660.46 322.19 658.83 320.98 659.45 320.2 657.92 317.14 657.01 318.1 656.18 317.46 656.17 317.42 Z"
          data-name="Darlington"
          data-stusps="SC"
          id="45031"
        />
        <path
          className="white"
          d="M 673.34 326.09 674.73 327.51 675.59 327.17 676.56 327.82 677.43 329.46 679.12 329.18 678.71 330.02 677.98 331.12 677.42 332.77 677.23 334.3 677.22 336.05 677.44 336.62 676.91 337.71 676.08 338.54 676.11 338.21 674.75 338.1 673.03 337.21 672.77 336.82 669.07 336.06 668.97 335.46 670.7 332.05 672.1 330.34 672.16 328.06 673.34 326.09 Z"
          data-name="Georgetown"
          data-stusps="SC"
          id="45043"
        />
        <path
          className="white"
          d="M 297.2 199.02 306.75 199.86 306.21 206.38 306.04 207.23 303.32 207 303.31 207 296.49 206.38 296.69 204.25 297 201.18 297.2 199.02 Z"
          data-name="Kimball"
          data-stusps="NE"
          id="31105"
        />
        <path
          className="white"
          d="M 418.09 267.45 424.64 267.43 424.65 271.51 424.53 273.15 418.02 273.18 418.1 271.54 418.09 267.45 Z"
          data-name="Allen"
          data-stusps="KS"
          id="20001"
        />
        <path
          className="white"
          d="M 397.7 354.22 404.77 354.41 404.76 355.48 406.17 355.28 406.11 362.22 403.43 362.19 402.64 362.18 401.11 362.14 398.11 362.07 397.47 362.05 397.52 360.19 397.62 356.89 397.7 354.22 Z"
          data-name="Collin"
          data-stusps="TX"
          id="48085"
        />
        <path
          className="white"
          d="M 387.63 344.56 388.13 345.37 388.23 346.26 389.34 346.36 390.21 345.51 391.35 344.87 391.98 344.62 392.58 345.88 391.96 346.58 392.82 348.23 393.74 348 393.8 347.27 393.95 346.55 394.32 345.74 395.42 345.18 395.38 344.58 395.95 344.1 396.07 344.09 395.98 354 389.08 353.65 388.71 353.59 387.44 353.56 387.63 344.56 Z"
          data-name="Cooke"
          data-stusps="TX"
          id="48097"
        />
        <path
          className="white"
          d="M 470.61 316.54 474.6 316.46 474.58 315 475.39 314.6 475.37 313.13 476.11 313.1 478.62 313.06 478.65 314.72 482.3 314.62 482.16 315.19 480.96 316 481.17 317.41 481.91 318.22 481.85 319.13 480.82 320.02 480.78 321.26 478.94 321.3 478.62 322.64 477.16 321.91 475.62 322.58 474.08 322.7 472.34 321.85 470.7 322.1 470.61 316.54 Z"
          data-name="White"
          data-stusps="AR"
          id="5145"
        />
        <path
          className="white"
          d="M 687.13 196.56 687.43 196.58 687.73 196.9 688.09 196.86 688.89 197.17 689.57 198.12 690.65 199.01 690.96 199.04 692.58 198.81 692.98 199.39 693.92 200.58 698.3 204.08 695.68 204.67 693.48 205.17 691.34 205.64 690.3 205.88 687.32 206.55 687.2 206.58 686.72 204.48 687.28 203.85 686.79 202.41 685.7 201.08 683.74 200.4 685 198.58 686.71 197.85 686.5 196.73 687.13 196.56 Z"
          data-name="York"
          data-stusps="PA"
          id="42133"
        />
        <path
          className="white"
          d="M 655.12 272.69 654.93 272.48 655.19 271.91 655.42 271.85 655.88 271.93 655.89 272.55 656.19 272.75 656.16 273.01 656.02 272.78 655.98 273.09 655.71 273.01 655.68 272.79 655.12 272.69 Z"
          data-name="Martinsville"
          data-stusps="VA"
          id="51690"
        />
        <path
          className="white"
          d="M 733.53 148.49 733.66 148.46 735.81 147.89 736.54 148.47 737.02 148.25 737.12 148.21 737.38 147.45 739.21 147.04 740.31 146.65 740.58 146.58 741.28 148.15 741 148.27 741.36 149.71 741.7 149.8 742.79 151.84 744.19 153.79 744.33 154.32 743.63 154.9 742.74 153.87 742.21 154.11 739.89 155.08 740 155.52 739.6 156.15 738.48 157.17 736.97 157.34 736.61 155.66 736.01 155.93 735.4 154.61 735.39 154.58 734.69 153.07 735.6 152.64 735.6 150.3 735.59 149.25 733.62 149.94 733.53 148.49 Z"
          data-name="Hartford"
          data-stusps="CT"
          id="9003"
        />
        <path
          className="white"
          d="M 590.12 222.8 590.99 222.76 591.4 218.07 591.31 216.14 595.62 215.6 595.68 216.4 595.07 216.82 595.88 221.23 596.07 223.46 590.18 223.87 590.12 222.8 Z"
          data-name="Madison"
          data-stusps="OH"
          id="39097"
        />
        <path
          className="white"
          d="M 728.29 157.51 727.66 154.5 726.74 150.17 730.37 149.26 731.84 148.9 732.89 148.65 733.53 148.49 733.62 149.94 735.59 149.25 735.6 150.3 735.6 152.64 734.69 153.07 735.39 154.58 735.4 154.61 736.01 155.93 735.12 156.84 735.21 157.19 734.14 158.11 734.21 158.96 733.56 159.27 732.86 159.4 731.93 159.82 732.26 160.44 730.93 159.87 730.28 160.53 728.45 157.48 728.29 157.51 Z"
          data-name="Litchfield"
          data-stusps="CT"
          id="9005"
        />
        <path
          className="white"
          d="M 12.72 214.23 14.42 214.74 14.36 214.74 14.19 217.1 15.76 218.3 16.61 219.68 17.3 219.54 17.4 219.87 17.78 220.59 16.7 220.67 15.85 220.98 15.17 223.13 15.59 223.94 15.18 225.3 12.48 225.08 12.37 226.76 11.99 226.43 11.83 225.79 11.26 224.71 11.29 223.43 11.87 222.22 12.07 221.81 12.17 221.05 12 219.72 12.11 219.22 11.56 218.4 11.38 217.74 11.68 216.68 12.22 216.09 12.66 214.66 12.72 214.23 Z"
          data-name="San Mateo"
          data-stusps="CA"
          id="6081"
        />
        <path
          className="white"
          d="M 551.51 219.12 557 218.45 557.58 223.63 556.52 224.06 552.13 224.56 551.59 219.78 551.51 219.12 Z"
          data-name="Hamilton"
          data-stusps="IN"
          id="18057"
        />
        <path
          className="white"
          d="M 187.57 195.07 189.15 195.63 190.09 194.38 189.77 192.46 188.94 191.54 190.4 190.44 192.3 190.32 192.64 189.55 194.14 189.55 194.59 189.66 197.61 188.09 196.76 192.87 203.99 194.16 209.96 195.16 211.01 195.33 211.69 195.44 211.12 198.9 209.15 198.63 207 197.84 205.62 198.5 202.91 198.6 202.02 198.23 201.49 198.7 200.16 198.33 199.01 198.85 198.07 198.36 197.76 199.26 196.42 200.68 194.33 200.36 193.75 201.07 190.89 198.99 190.74 197.76 189.05 199.24 188.17 198.88 187.64 197.67 187.77 196.79 187.37 195.53 187.57 195.07 Z"
          data-name="Summit"
          data-stusps="UT"
          id="49043"
        />
        <path
          className="white"
          d="M 459.42 109.21 459.36 107.74 459.22 104.59 460.34 104.51 460.6 103.92 461.08 103.22 461.64 103.14 462.3 103.55 462.76 103.61 463.47 104.02 464.44 103.83 465.3 103.79 467.51 102.83 468.41 102.36 468.7 102.34 468.71 102.52 469.32 113.61 462.81 113.94 459.63 114.09 459.55 112.46 459.42 109.21 Z"
          data-name="Douglas"
          data-stusps="WI"
          id="55031"
        />
        <path
          className="white"
          d="M 366.09 267.37 367.71 267.42 367.88 262.53 374.28 262.73 374.38 263.15 374.34 264.39 374.16 270.92 366.11 270.65 365.98 270.37 366.09 267.37 Z"
          data-name="Stafford"
          data-stusps="KS"
          id="20185"
        />
        <path
          className="white"
          d="M 260.11 222.94 262.73 223.44 264.93 225.77 265.7 228.14 267.01 228.05 268.98 229.98 268.11 230.73 268.23 231.25 265.84 232.89 264.87 234.23 263.25 233.71 262.21 233.59 261.74 231.9 263.21 228.82 260.47 225.99 260.11 222.94 Z"
          data-name="Summit"
          data-stusps="CO"
          id="8117"
        />
        <path
          className="white"
          d="M 367.59 72.46 371.26 72.63 371.09 76.68 372.68 77.64 372.61 79.25 373.51 78.7 373.58 79.89 376 78.67 376.61 80.15 376.03 80.71 377.61 79.85 378.15 81.45 379.41 81.52 379.36 82.81 379.09 82.78 369.6 82.41 363.09 82.09 363.26 78.82 363.16 72.23 367.59 72.46 Z"
          data-name="Benson"
          data-stusps="ND"
          id="38005"
        />
        <path
          className="white"
          d="M 19.79 256.24 29.14 258.89 37.54 261.19 37.85 261.27 36.97 264.63 38.66 265.08 38.21 266.77 40.5 269.16 41.03 269.3 40.58 270.99 41.7 271.28 41.27 272.96 43.52 273.56 43.08 275.24 44.9 275.6 44.32 277.34 45.68 277.91 44.83 281.29 43.81 281.11 42 279.1 40.85 278.8 38.38 276.4 37.55 276.23 36.22 274.72 34.66 275.12 34.11 275.9 31.67 275.76 31.68 277.84 29.97 275.72 29.04 275.34 26.5 275.05 27.06 274 27.35 273.14 27.49 272.24 27.02 271.51 26.52 270.9 25.77 271.02 24.56 269.79 24 268.74 24.51 267.92 25.13 266.71 25.14 265.27 24.14 264.52 23.43 264.18 22.26 261.56 21.77 260.1 20.28 259.04 19.86 257.96 19.96 256.53 19.79 256.24 Z"
          data-name="San Luis Obispo"
          data-stusps="CA"
          id="6079"
        />
        <path
          className="white"
          d="M 331.55 352.4 339.76 352.78 339.36 360.94 337.2 360.83 331.91 360.55 331.15 360.42 331.55 352.4 Z"
          data-name="Kent"
          data-stusps="TX"
          id="48263"
        />
        <path
          className="white"
          d="M 776.73 90.04 777.2 89.72 778.12 89.42 780.2 90.66 782.43 89.55 782.92 90.22 782.34 90.81 782.3 92.12 781.81 92.43 781.15 91.14 779.79 92.01 778.73 93.07 777.96 92.25 777.21 91.4 777.64 90.63 776.73 90.04 Z M 778.98 95.93 779.52 95.33 780.23 96.24 780 97.29 779.03 96.97 778.98 95.93 Z M 769.16 89.98 769.63 89.59 770.5 90.01 771.18 88.59 773.87 89.94 775.39 89.93 775.11 89.96 775.33 91.19 775.32 92.07 776.24 92.82 776.01 93.73 776.56 94.24 776.32 95.01 775.57 95.22 774.98 95.41 774.83 96.63 774.44 96.82 774.19 97.73 773.78 98.35 772.93 97.36 772.41 97 772.19 95.62 773.03 94.5 771.27 91.82 769.87 91.94 769.06 90.39 769.16 89.98 Z"
          data-name="Knox"
          data-stusps="ME"
          fillRule="evenodd"
          id="23013"
        />
        <path
          className="white"
          d="M 621.06 288.07 621.18 287.95 622.33 288.23 622.62 288.8 623.32 288.67 624.49 291.66 625.38 292.13 625.48 292.63 623.29 294.13 621.78 290.64 620.94 290.95 619.23 289.67 618.26 290.03 618.35 289.81 619.22 289.08 619.93 288.62 620.43 288.66 621.06 288.07 Z"
          data-name="Mitchell"
          data-stusps="NC"
          id="37121"
        />
        <path
          className="white"
          d="M 510.88 118.76 515.71 118.47 515.61 117.12 515.73 117.16 516.4 116.85 516.83 117.4 518 117.46 518.67 118 519.08 118.32 519.45 118.84 518.91 119.29 519.62 120.05 519.55 120.71 519.43 121.68 519.5 122.65 519.01 123.24 518.98 124.22 518.97 124.98 519.8 124.88 520.45 124.79 520.98 124.19 521.66 124.41 521.63 125.4 521.18 126.8 520.87 127.74 521.58 128.55 522.29 129.32 523.08 129.45 522.71 130.44 522.78 131.73 521.9 131.86 521.04 132.17 518.56 131.84 516.15 131.5 516.02 129.87 515.08 129.92 514.97 128.3 513.33 128.39 513.07 125.14 511.45 125.24 510.88 118.76 Z"
          data-name="Marinette"
          data-stusps="WI"
          id="55075"
        />
        <path
          className="white"
          d="M 643.29 423.89 646.51 423.49 648.23 423.29 648.04 419.29 647.77 417.24 648.44 418.58 649.86 418.91 650.53 420.35 653.27 422.2 653.31 424.23 652.58 425.5 652.73 426.11 648.84 426.59 648.68 426.98 649.22 431.17 649.67 434.96 646.26 435.08 644.62 435.6 644.21 431.66 643.29 423.89 Z"
          data-name="Lake"
          data-stusps="FL"
          id="12069"
        />
        <path
          className="white"
          d="M 684.23 189.03 685.03 187.5 684.8 185.52 684.88 185.25 685.17 184.68 685.24 184.04 685.2 183.98 683.87 182.99 683.69 181.04 682.73 179.43 682.83 179.05 684.92 178.28 685.24 179.8 685.01 182.69 686.82 181.9 688.45 182.12 688.77 183.15 689.1 183.08 689.73 184.08 690.99 183.62 691.69 184.61 689.36 186.47 687.69 187.74 687.58 187.89 684.67 189.62 684.14 189.25 684.23 189.03 Z"
          data-name="Northumberland"
          data-stusps="PA"
          id="42097"
        />
        <path
          className="white"
          d="M 215.52 263.83 217.82 261.33 227.82 262.69 232.05 263.12 231.14 263.94 230.56 266.53 229.37 267.71 227.92 268.04 227.42 269.27 226.19 270.33 225.99 271.79 224.28 274.38 220.63 273.89 214.19 273 215.52 263.83 Z"
          data-name="Montezuma"
          data-stusps="CO"
          id="8083"
        />
        <path
          className="white"
          d="M 209.4 123.86 214.59 124.84 214.3 126.41 218.22 127.12 219.18 128 219.32 128.63 218.76 130.16 219.49 131.41 219.76 132.88 220.26 133.12 220.49 134.96 220.16 136.2 221.05 136.36 220.64 138.7 218.87 148.91 218.51 150.53 214.57 149.83 214.29 151.46 211.07 150.88 210.87 151.94 207.64 151.35 207.91 149.87 204.75 149.25 205.39 145.77 206.04 142.26 206.81 138.11 207.07 136.7 207.52 134.23 208.44 129.34 208.79 127.48 209.25 124.64 209.4 123.86 Z"
          data-name="Teton"
          data-stusps="WY"
          id="56039"
        />
        <path
          className="white"
          d="M 152.21 24.53 155.57 25.49 159.73 26.67 164.24 27.92 161.67 37.2 152.56 34.67 154.41 28.22 151.37 27.36 152.21 24.53 Z"
          data-name="Boundary"
          data-stusps="ID"
          id="16021"
        />
        <path
          className="white"
          d="M 59.28 194.6 60 192.16 60.53 190.39 61.56 186.91 62.87 182.47 63.81 179.25 64.9 175.56 67.09 167.97 67.87 165.22 69.63 159.2 72.09 150.99 73.52 146.15 74.2 143.89 78.06 145.01 83.2 146.56 83.7 146.71 80.54 157.65 79.83 161.13 78.07 165.96 78.29 166.3 75.89 174.56 72.72 184.4 74.39 184.85 73.63 188.51 73.51 191.12 73.08 191.6 72.08 191.33 71.55 191.77 67.45 191.83 65.98 192.49 64.94 192.02 64.48 195.76 63.25 197.07 62.2 197.5 61.04 197.48 60.3 197.99 58.49 197.48 59.14 195.08 59.28 194.6 Z"
          data-name="Washoe"
          data-stusps="NV"
          id="32031"
        />
        <path
          className="white"
          d="M 547.61 236.05 547.9 236.15 551.27 235.81 552.01 241.27 552.77 241.18 552.9 242.27 547.54 242.79 547.2 239.53 546.83 236.34 547.61 236.05 Z"
          data-name="Monroe"
          data-stusps="IN"
          id="18105"
        />
        <path
          className="white"
          d="M 407.62 106.21 409.03 106.22 409.01 104.59 420.98 104.6 422.07 104.56 422.19 106.21 422.23 111.11 422.37 112.73 422.4 116.03 414.25 116.06 407.77 116.02 407.6 112.76 407.62 106.21 Z"
          data-name="Otter Tail"
          data-stusps="MN"
          id="27111"
        />
        <path
          className="white"
          d="M 325.57 57.63 326.67 57.73 334.49 58.44 336.91 58.64 336.61 62.24 334.99 62.1 334.85 63.73 333.84 63.65 333.57 66.91 325.44 66.19 325.59 64.56 325.74 62.93 325.07 62.87 325.57 57.63 Z"
          data-name="Burke"
          data-stusps="ND"
          id="38013"
        />
        <path
          className="white"
          d="M 497.42 285.93 498.43 284.52 498.94 283.58 499.51 283.56 501.25 283.47 501.69 281.8 503.09 281.73 504.61 281.64 504.34 282.39 506.06 285.39 506.05 286.57 506.19 290.94 502.28 291.15 499.41 291.3 499.46 290.06 498.41 288.69 497.42 285.93 Z"
          data-name="Stoddard"
          data-stusps="MO"
          id="29207"
        />
        <path
          className="white"
          d="M 464.36 269.88 464.32 267.65 464.3 266.84 467.58 266.81 470.02 266.82 470.21 274.48 467.91 274.52 466.93 274.57 466.9 273.74 464.4 272.61 464.36 269.88 Z"
          data-name="Pulaski"
          data-stusps="MO"
          id="29169"
        />
        <path
          className="white"
          d="M 557.72 264.43 559.83 263.84 560.18 262.71 559.63 260.57 559.92 260.3 560.26 260.05 560.5 260.33 561.85 261.2 562.23 262.42 563.87 263.53 563.95 264.1 564.89 264.93 564.22 266.48 562.35 268.79 562.3 270.77 559.96 270.83 558.73 268.73 556.26 268.49 557.72 264.43 Z"
          data-name="Hardin"
          data-stusps="KY"
          id="21093"
        />
        <path
          className="white"
          d="M 403.32 192.81 406.76 192.85 407.27 192.25 407.96 192.72 409.23 193.62 408.86 194.83 409.31 195.66 409.57 196.14 410.18 197.03 409.85 198.36 409.56 199.22 409.19 199.1 404.82 199.06 404.84 197.97 403.28 197.95 403.32 192.81 Z"
          data-name="Burt"
          data-stusps="NE"
          id="31021"
        />
        <path
          className="white"
          d="M 316.03 334.29 317.47 334.38 324.22 334.78 323.97 339.26 323.73 343.84 315.54 343.47 316.03 334.29 Z"
          data-name="Hale"
          data-stusps="TX"
          id="48189"
        />
        <path
          className="white"
          d="M 65.32 107.56 78.35 111.76 78.69 111.96 84.89 113.9 82.39 122.02 81.9 121.87 80.41 126.8 79.26 129.96 87.3 132.31 83.2 146.56 78.06 145.01 74.2 143.89 71.64 143.12 67.13 141.76 64.44 140.93 61.79 140.11 66.21 125.95 59.75 123.83 63.5 112.37 65.32 107.56 Z"
          data-name="Lake"
          data-stusps="OR"
          id="41037"
        />
        <path
          className="white"
          d="M 178.28 267.41 179.8 267.46 180.64 266.78 180.86 267.45 182.16 266.09 183.98 266.45 185.56 266.22 186.61 265.39 187.35 263.36 187.94 263.21 187.59 262.2 188.91 262.91 189.6 262.59 190.42 261.07 189.78 260.54 190.98 260.25 191.55 259.11 193.1 257.48 194.06 257.4 194.45 256.42 195.56 255.14 196.21 253.29 199.09 253.5 199.44 252.51 200.6 251.55 201.47 251.81 202.81 249.88 204.15 249.27 204.87 248.64 204.48 246.76 203.48 245.05 203.3 243.32 203.72 242.47 218.05 244.65 217.43 248.88 217.39 251.01 217.36 251.23 216.61 256.36 215.52 263.83 214.19 273 207.37 272.02 199.71 270.9 192.58 269.8 188.34 269.02 183.54 268.26 180.32 267.77 178.39 267.43 178.28 267.41 Z"
          data-name="San Juan"
          data-stusps="UT"
          id="49037"
        />
        <path
          className="white"
          d="M 268.08 374.49 269.22 374.58 272.49 374.86 282.43 375.65 279.9 392.39 266.01 399.67 266.26 396.71 267.57 381.56 268.08 374.49 Z"
          data-name="Culberson"
          data-stusps="TX"
          id="48109"
        />
        <path
          className="white"
          d="M 430.24 189.1 433.46 189.06 436.71 188.98 436.84 195.49 435.22 195.53 430.33 195.61 430.24 189.1 Z"
          data-name="Greene"
          data-stusps="IA"
          id="19073"
        />
        <path
          className="white"
          d="M 411.57 267.42 418.09 267.45 418.1 271.54 418.02 273.18 411.53 273.16 411.57 267.42 Z"
          data-name="Woodson"
          data-stusps="KS"
          id="20207"
        />
        <path
          className="white"
          d="M 342.67 442.13 354.33 442.65 354.55 442.65 354.34 450.83 342.38 450.57 342.67 442.13 Z"
          data-name="Dimmit"
          data-stusps="TX"
          id="48127"
        />
        <path
          className="white"
          d="M 400.69 96.39 408.79 96.45 409.04 99.71 409.01 104.59 409.03 106.22 407.62 106.21 401.09 106.18 401.04 106.06 401.03 106.04 401.09 104.99 401.09 103.4 401.44 100.87 400.56 99.03 400.77 97.69 400.69 96.39 Z"
          data-name="Clay"
          data-stusps="MN"
          id="27027"
        />
        <path
          className="white"
          d="M 545.77 144.56 548.79 144.25 552.25 143.8 553.11 150.36 546.64 151.15 546.22 147.89 545.77 144.56 Z"
          data-name="Lake"
          data-stusps="MI"
          id="26085"
        />
        <path
          className="white"
          d="M 178.59 193.96 182.77 191.78 183.46 191.91 183.28 193.83 186.39 193.64 187.42 194.05 187.57 195.07 187.37 195.53 187.77 196.79 187.64 197.67 188.17 198.88 187.48 199.38 187.26 199.58 182.44 200.88 181.31 201.42 178.75 199.9 179.21 197.31 179 196.77 179.2 195.3 178.59 193.96 Z"
          data-name="Salt Lake"
          data-stusps="UT"
          id="49035"
        />
        <path
          className="white"
          d="M 210.87 151.94 211.07 150.88 214.29 151.46 214.57 149.83 218.51 150.53 218.87 148.91 222.93 149.64 222.62 151.47 223.44 151.6 223.15 153.5 223.41 155.44 224.4 157.22 224.28 158.57 224.97 158.73 226.19 160.31 226.99 161.89 229.25 164.69 229.09 165.5 229.94 165.65 229.57 170.6 229.06 173.8 222.73 172.79 214.97 171.35 208.17 170.04 208.72 166.82 208.06 166.71 208.94 161.78 208.48 161.7 208.71 160.4 209.21 160.49 210.37 153.97 210.87 151.94 Z"
          data-name="Sublette"
          data-stusps="WY"
          id="56035"
        />
        <path
          className="white"
          d="M 490.07 126.91 489.82 123.66 497.94 123.04 498.12 124.69 498.63 131.23 490.41 131.83 490.07 126.91 Z"
          data-name="Lincoln"
          data-stusps="WI"
          id="55069"
        />
        <path
          className="white"
          d="M 306.75 199.86 306.95 199.06 317.3 199.91 317.62 200.76 317.35 204.01 317.1 207.27 316.88 208.12 316.42 208.08 310.4 207.6 306.04 207.23 306.21 206.38 306.75 199.86 Z"
          data-name="Cheyenne"
          data-stusps="NE"
          id="31033"
        />
        <path
          className="white"
          d="M 159.71 110.31 159.33 111.42 160.09 113.15 161.05 113.54 161.94 115.46 163.65 115.16 165.14 113.57 164.85 112.91 167.91 110.87 168.13 111.73 167.53 113.45 169.2 113.6 169.61 115.73 171.67 119.34 175.59 121.64 176.4 121.18 177.32 124.06 177.25 125.73 175.96 125.44 175.24 128.71 174.68 128.58 173.96 132.08 174.91 133.81 174.28 133.27 173.53 134.07 168.72 135.9 167.99 136.76 167.92 136.14 166.18 133.61 165.7 132.22 164.99 132.82 162.6 130.36 162.62 129.26 161.65 129.29 159.74 128.35 158.76 129.21 157.51 127.26 155.71 126.83 156 125.61 155.2 125.42 153.62 126.12 153.41 125.85 153.19 123.62 153.89 121.87 152.17 120.51 152.45 118.72 151.09 117.53 152.37 116.17 152.56 114.3 152.06 112.98 152.53 112.48 154.21 112.17 154.8 110.7 155.78 110.18 157.39 111.49 159.71 110.31 Z"
          data-name="Custer"
          data-stusps="ID"
          id="16037"
        />
        <path
          className="white"
          d="M 414.7 182.62 419.6 182.6 419.62 184.23 420.53 184.22 420.54 189.17 415.69 189.18 415.7 184.24 414.7 184.24 414.7 182.62 Z"
          data-name="Ida"
          data-stusps="IA"
          id="19093"
        />
        <path
          className="white"
          d="M 244.29 231.64 248.93 232.24 257.75 233.39 258.96 233.54 257.71 234.6 257.32 237.07 256.53 237.19 256.06 239 255.61 240.09 254.34 238.84 253.51 238.99 252.59 240.1 251.78 239.41 251.09 239.65 249.8 238.54 249.03 236.98 245.86 236.58 244.69 234.91 244.55 233.78 243.66 232.55 244.29 231.64 Z"
          data-name="Pitkin"
          data-stusps="CO"
          id="8097"
        />
        <path
          className="white"
          d="M 311.19 259.35 321.52 260.06 321.51 260.17 321.33 262.98 320.9 270.01 320.88 270.29 320.78 271.78 310.23 271.06 310.59 267.68 311.19 259.35 Z"
          data-name="Prowers"
          data-stusps="CO"
          id="8099"
        />
        <path
          className="white"
          d="M 399.64 286.88 403.02 286.92 403.4 286.92 407.65 286.93 410.91 286.94 410.89 297.73 410.88 302.65 406.82 302.62 407 301.43 405.94 301.41 404.32 300.29 403.96 299.41 403.08 300.04 402.2 299.71 403.04 298.56 402.17 298.61 401.27 297.64 400.06 297.31 400.21 296.66 399.51 295.06 398.48 295.5 397.65 296.76 396.66 297.04 395.62 296.06 397.48 294.81 397.11 294.36 394.92 294.42 394.84 292.73 396.84 292.72 397.49 291.5 399.57 290.95 399.64 286.88 Z"
          data-name="Osage"
          data-stusps="OK"
          id="40113"
        />
        <path
          className="white"
          d="M 557.67 326.26 558.01 327.04 559.76 327.32 561.16 326.56 561.06 324.92 561.06 324.92 561.19 324.9 561.23 324.9 563.3 324.71 563.84 324.66 564.79 326.22 565.03 327.07 565.48 326.84 564.66 328.3 565.23 332.1 565.21 332.38 563.71 332.78 562.32 334.31 560.48 332.47 559.69 331.51 559.23 330.73 557.6 330.84 557.49 329.59 557.64 326.37 557.67 326.26 Z"
          data-name="Marshall"
          data-stusps="AL"
          id="1095"
        />
        <path
          className="white"
          d="M 631.88 208.28 632.24 206.97 632.61 205.88 631.98 204.41 632.01 204.21 632.76 203.99 633.55 203.85 633.75 204.94 634.36 208.38 632.19 208.38 631.88 208.28 Z"
          data-name="Brooke"
          data-stusps="WV"
          id="54009"
        />
        <path
          className="white"
          d="M 630.96 214.99 631.03 213.64 631.49 212.95 631.77 212.5 631.6 211.31 634.83 211.08 635.01 212.1 635.81 216.65 631.2 217.49 630.56 216.74 631.09 215.91 630.95 215.04 630.96 214.99 Z"
          data-name="Marshall"
          data-stusps="WV"
          id="54051"
        />
        <path
          className="white"
          d="M 510.3 365.95 510.04 361.24 509.98 360.4 516.5 359.97 516.93 366.64 516.85 366.65 510.37 367.02 510.3 365.95 Z"
          data-name="Leake"
          data-stusps="MS"
          id="28079"
        />
        <path
          className="white"
          d="M 298.22 100.06 298.32 99.24 300.01 98.88 302.45 99.16 303.17 100.06 307.18 100.49 306.98 102.38 306.92 102.96 306.55 106.44 306.47 107.27 305.81 113.55 305.71 114.74 304.52 114.62 304.69 112.99 301.34 112.6 301.51 111.02 299.87 110.84 300.04 109.31 295.22 108.76 295.7 102.25 297.95 102.51 298.22 100.06 Z"
          data-name="Fallon"
          data-stusps="MT"
          id="30025"
        />
        <path
          className="white"
          d="M 700.19 248.48 700.79 249.06 701.81 249.86 700.44 250.66 701.05 251.49 700.98 252.15 702.24 252.34 701.94 252.1 703.25 252.39 703.5 252.82 703.81 253.27 702.97 254.11 702.48 253.21 701.07 254.05 700.36 253.46 699.02 253.56 698.59 250.83 698.09 250.69 698.06 249.61 700.19 248.48 Z"
          data-name="James City"
          data-stusps="VA"
          id="51095"
        />
        <path
          className="white"
          d="M 458.55 295.64 458.78 295.63 459.79 295.6 462.94 295.49 463.47 295.47 463.48 297.57 462.56 298.19 463.41 299.89 464.48 299.97 464.41 301.05 465.47 301.71 465.54 303.58 459.07 303.65 459.03 302.83 458.22 302.85 458.09 295.79 458.55 295.64 Z"
          data-name="Marion"
          data-stusps="AR"
          id="5089"
        />
        <path
          className="white"
          d="M 404.43 215.94 413.41 215.97 413.41 215.99 412.64 216.86 413.25 217.87 414.16 218.42 414.64 219.35 414.4 219.7 414.52 220.81 415.13 220.78 415.16 220.85 410.08 220.86 404.4 220.83 404.43 215.94 Z"
          data-name="Otoe"
          data-stusps="NE"
          id="31131"
        />
        <path
          className="white"
          d="M 750.72 144.14 753.4 143.23 753.62 143.15 754.06 143 754.91 142.71 755.47 142.52 756.54 142.16 756.73 142.8 756.92 143.42 757.25 144.53 757.85 144.35 758.2 145.51 758.63 146.4 758.83 146.44 758.39 147.44 758.09 147.12 757.72 146.97 757.12 147.89 752.44 149.43 751.94 147.9 750.72 144.14 Z"
          data-name="Providence"
          data-stusps="RI"
          id="44007"
        />
        <path
          className="white"
          d="M 710.04 120.45 718.16 116.97 718.19 119.93 717.12 122.06 717.08 123.49 718.66 126.93 716.88 128.24 716.73 129.16 715.62 128.83 715.49 127.82 714.21 126.3 710.56 127.84 707.98 121.33 710.04 120.45 Z"
          data-name="Warren"
          data-stusps="NY"
          id="36113"
        />
        <path
          className="white"
          d="M 528.63 241.12 532.93 240.79 533.22 241.03 533.51 242.07 534.36 242.83 534.36 243.89 535.14 244.38 535.28 245.58 535.27 245.62 535.04 246.21 535.26 246.63 531.57 247.03 529.78 247.17 529.23 247.21 528.63 241.12 Z"
          data-name="Crawford"
          data-stusps="IL"
          id="17033"
        />
        <path
          className="white"
          d="M 387.41 76.51 396.97 76.74 396.92 77.12 396.9 77.21 397.4 78.67 397.84 79.9 398.21 81.65 398.7 83.33 399.54 85.21 399.96 86.58 392.61 86.46 387.41 86.33 387.59 79.78 387.41 76.51 Z"
          data-name="Grand Forks"
          data-stusps="ND"
          id="38035"
        />
        <path
          className="white"
          d="M 629.8 424.67 630.47 424.02 632.17 424.25 633.38 423.42 634.66 423.22 636.61 424.13 637.31 424.59 640.07 427.5 638.77 430.06 636.18 430.39 636.1 429.85 631.91 430.34 631.91 430.31 631.12 429.91 630.94 428.4 630.55 427.49 631.12 426.36 630.43 425.51 629.8 424.67 Z"
          data-name="Citrus"
          data-stusps="FL"
          id="12017"
        />
        <path
          className="white"
          d="M 566.22 392.93 566.61 392.9 569.49 392.65 571.97 392.44 572.41 397.9 575.56 397.64 574.52 399.01 575.67 401.68 573.67 403.78 573.81 406.06 573.75 406.03 572.22 405.54 569.98 404.97 567.07 404.57 566.22 392.93 Z"
          data-name="Walton"
          data-stusps="FL"
          id="12131"
        />
        <path
          className="white"
          d="M 566.07 215.71 572.03 214.91 572.45 218.73 572.67 220.66 567.01 221.36 566.81 221.18 566.66 220.02 566.07 215.71 Z"
          data-name="Randolph"
          data-stusps="IN"
          id="18135"
        />
        <path
          className="white"
          d="M 541.59 158.27 547.4 157.69 547.79 160.96 551.21 160.56 551.4 162.21 549.78 162.39 549.99 164.02 544.95 164.62 544.2 163.25 542.63 160.7 541.87 159.01 541.59 158.27 Z"
          data-name="Muskegon"
          data-stusps="MI"
          id="26121"
        />
        <path
          className="white"
          d="M 566.05 225.62 567.22 225.46 567.9 226.77 570.09 226.52 570.5 230.07 566.69 230.54 566.05 225.62 Z"
          data-name="Fayette"
          data-stusps="IN"
          id="18041"
        />
        <path
          className="white"
          d="M 366.06 164.03 366.06 164.03 372.94 164.3 374.16 164.34 374.06 166.77 382.15 170.27 382.59 170.82 382.1 172.32 381.88 176.41 381.38 176.93 380.29 176.53 379.64 176.25 379.25 176.02 378.19 175.39 377.53 175.16 376.94 174.5 376.69 173.84 376.35 173.06 374.1 172.29 373 170.94 371.7 170.6 371.37 168.99 370.22 168.72 369.06 167.51 367.99 165.48 365.87 164.62 366.06 164.03 Z"
          data-name="Charles Mix"
          data-stusps="SD"
          id="46023"
        />
        <path
          className="white"
          d="M 413.05 165.01 413.41 165.01 418.16 164.99 418.6 164.99 419.51 164.98 419.53 169.58 413.03 169.55 413.05 165.01 Z"
          data-name="Osceola"
          data-stusps="IA"
          id="19143"
        />
        <path
          className="white"
          d="M 691.5 196.17 695 194.21 697 192.54 698.03 193.06 701.82 194.98 700.93 195.74 701.35 197.08 700.87 198.89 701.28 200.46 700.3 203.57 699.82 203.73 698.39 204.06 698.39 204.06 698.3 204.08 693.92 200.58 692.98 199.39 692.58 198.81 690.96 199.04 690.65 199.01 689.57 198.12 689.77 197.36 691.5 196.17 Z"
          data-name="Lancaster"
          data-stusps="PA"
          id="42071"
        />
        <path
          className="white"
          d="M 489.84 203.39 489.71 200.95 491.05 199.79 492.94 199.18 493.04 198.33 497.59 198.04 498.12 204.59 498 204.97 498.08 206.2 496.42 206.31 489.99 206.69 489.84 203.39 Z"
          data-name="Henry"
          data-stusps="IL"
          id="17073"
        />
        <path
          className="white"
          d="M 38.51 211.15 40.03 211.67 41.61 210.88 44.62 210.54 45.14 209.67 48.48 208.89 49.82 209.44 51.89 209.29 53.93 209.68 53.6 210.88 54.31 211.36 51.65 211.84 45.94 216.72 45.38 217.53 44.18 217.66 44.28 218.43 41.52 220.16 38.73 214.28 38.6 213.85 38.51 211.15 Z"
          data-name="Calaveras"
          data-stusps="CA"
          id="6009"
        />
        <path
          className="white"
          d="M 692.08 217.75 692.25 217.58 692.25 217.43 692.4 217.3 692.63 217.25 692.76 217.09 692.77 216.76 692.93 216.34 693.15 216 693.49 215.86 693.58 215.63 693.56 215.47 693.73 215.19 694.37 214.36 695.49 214.95 696.18 214.56 696.64 214.84 696.41 215.32 698.04 215.87 698.35 216.8 698.54 217.55 699.06 218.04 698.36 218.76 698.14 219.33 698.52 219.56 698.38 220.26 698.33 220.36 698.16 220.76 697.91 221.48 698.36 221.63 698.03 222.73 697.68 223.41 698.29 223.92 698.33 224.14 696.98 224.27 696.38 223.44 695.82 223.98 695.18 222.78 695.41 220.93 693.68 218.76 693.05 218.68 692.35 218.37 692.08 217.75 Z"
          data-name="Anne Arundel"
          data-stusps="MD"
          id="24003"
        />
        <path
          className="white"
          d="M 595.02 339.53 595.25 339.51 595.63 339.78 596.56 339.38 597.69 340.87 598.12 340.85 598.92 341.12 599.03 341.4 598.9 341.62 600.68 342.05 601.12 342.72 600.63 344.1 599.46 344.88 599.24 345.51 598.6 345.8 597.76 345.18 594.49 345.23 594.41 344.38 594.33 343.64 595.26 343.55 595.19 341.39 595.74 340.54 595.02 339.53 Z"
          data-name="Henry"
          data-stusps="GA"
          id="13151"
        />
        <path
          className="white"
          d="M 511.14 90.75 509.89 90.87 509.72 89.25 506.99 89.51 507.13 89.36 508.04 87.8 509.65 86.68 510.46 86.1 512.11 85.55 514.08 85.17 515.72 85.1 517.29 85.27 518.49 85.74 518.39 86.43 515.89 86.62 514.09 86.85 514.17 87.87 513.29 88.52 512.35 89.46 511.2 90.56 511.14 90.75 Z M 496.94 78.65 497.43 78.1 499.36 76.84 500.29 76.25 500.86 75.91 501.8 75.4 502.83 74.46 503.96 73.48 504.97 72.88 506.44 72.06 506.49 72.88 505.06 74.25 504.81 75.43 503.13 76.45 501.49 77.17 501.02 78.43 499.26 79.44 497.88 80.16 497.28 79.72 496.56 79.29 496.94 78.65 Z"
          data-name="Keweenaw"
          data-stusps="MI"
          fillRule="evenodd"
          id="26083"
        />
        <path
          className="white"
          d="M 282.43 375.65 283.14 375.7 284.47 378.26 285.4 377.99 285.75 380.25 288.42 381.67 288.59 382.69 290.19 383.29 291.02 386.98 292.8 387.52 293.92 387.3 295.15 388.47 297.9 388.63 287.83 399.37 279.9 392.39 282.43 375.65 Z"
          data-name="Reeves"
          data-stusps="TX"
          id="48389"
        />
        <path
          className="white"
          d="M 528.27 312.92 528.24 312.2 529.79 312.13 530.07 311.98 530.83 312.75 533.45 312.3 534.26 314.07 534.65 319.52 534.41 319.54 531.27 319.74 531.33 319.97 530.43 320.04 528.8 320.16 528.54 320.18 528.19 314.38 528.27 312.92 Z"
          data-name="Hardin"
          data-stusps="TN"
          id="47071"
        />
        <path
          className="white"
          d="M 393.47 197.81 396.74 197.86 398.35 197.89 398.28 203.26 394.41 204.7 393.35 204.54 393.47 197.81 Z"
          data-name="Colfax"
          data-stusps="NE"
          id="31037"
        />
        <path
          className="white"
          d="M 674.83 316.58 675.36 315.67 675.58 315.55 675.58 315.56 675.58 315.56 680.4 319.01 683.39 321.16 684.05 321.62 685.45 322.65 683.47 323.65 682.03 324.85 680.8 326.3 679.82 327.75 679.12 329.18 677.43 329.46 676.56 327.82 675.59 327.17 674.13 325.27 674.02 324.18 672.89 322.94 672.39 322.54 672.78 321.25 673.57 320.63 673.89 318.69 674.91 316.92 674.83 316.58 Z"
          data-name="Horry"
          data-stusps="SC"
          id="45051"
        />
        <path
          className="white"
          d="M 530.81 288.19 531.7 288.14 534.18 288.18 534.17 288.76 536.58 288.49 537.38 288.4 538.56 293.42 536.68 293.57 535.13 294.45 532.67 294.18 532.5 294.07 531.3 292.58 531.34 291.52 531.38 291.51 531.56 290.52 531.1 289.07 530.81 288.19 Z"
          data-name="Stewart"
          data-stusps="TN"
          id="47161"
        />
        <path
          className="white"
          d="M 454.47 269.39 457.7 269.42 457.94 272.7 457.98 277.15 454.72 277.18 454.73 278.54 453.09 278.55 453.07 272.68 452.81 271.32 452.83 269.41 454.47 269.39 Z"
          data-name="Dallas"
          data-stusps="MO"
          id="29059"
        />
        <path
          className="white"
          d="M 637.29 190.1 637.48 189.79 638.34 187.94 639.97 187.62 642.68 187.1 642.78 187.15 644.51 196.58 644.51 196.58 643.16 196.81 639.1 197.5 637.95 197.72 637.74 196.78 637.18 194.33 636.56 191.6 637.29 190.1 Z"
          data-name="Butler"
          data-stusps="PA"
          id="42019"
        />
        <path
          className="white"
          d="M 632.2 236.75 636.3 232.67 637.21 232.29 637.69 233.09 639.39 233.3 639.94 235.03 639.48 236.93 637.76 239.54 635.66 239.29 634.4 240.48 633.74 239.49 631.66 237.81 632.2 236.75 Z"
          data-name="Braxton"
          data-stusps="WV"
          id="54007"
        />
        <path
          className="white"
          d="M 560.31 383.38 563.57 383.08 565.17 382.91 565.32 384.33 567.1 382.71 567.28 384.08 568.64 384.25 568.66 384.82 569.07 388.93 569.41 392.29 569.49 392.65 566.61 392.9 566.22 392.93 563.38 393.16 561.35 393.31 561.14 393.08 560.85 389.63 560.57 386.75 561.14 385.61 560.31 383.38 Z"
          data-name="Covington"
          data-stusps="AL"
          id="1039"
        />
        <path
          className="white"
          d="M 188.34 269.02 192.58 269.8 199.71 270.9 195.93 296.15 198.61 296.54 197.96 299.24 196.05 312.4 195.49 315.71 195.02 317.33 195.06 319.01 193.96 325.57 193.03 332.16 192.52 332.09 191.97 336.07 191.8 335.9 190.26 335.65 191.39 327.63 179.54 325.92 180.29 320.92 182.5 306.31 188.34 269.02 Z"
          data-name="Navajo"
          data-stusps="AZ"
          id="4017"
        />
        <path
          className="white"
          d="M 36.58 194.57 37.52 194.12 38.07 194.08 38.81 194.45 40.94 195.02 41.8 195.95 45.09 193.51 48.43 192.05 51.15 192.28 54.59 193.26 58.81 194.47 59.28 194.6 59.14 195.08 58.49 197.48 58.21 198.49 57.98 199.35 55.87 198.76 55.08 199.28 51.33 198.26 50.45 199.3 48.79 199.89 47.78 198.97 46.6 197.26 45.57 197.17 44.61 197.88 43.45 197.33 41.74 197.79 41.69 197.78 41.05 198.99 39.04 201.22 36.6 200.27 35.54 199.85 34.04 199.26 35.36 195.67 36.18 195.92 36.58 194.57 Z"
          data-name="Placer"
          data-stusps="CA"
          id="6061"
        />
        <path
          className="white"
          d="M 624.38 335.86 626.11 334.67 627.6 334.72 627.94 335.26 628.66 336.06 628.98 336.12 629.44 336.2 629.58 336.23 630.94 337.02 627.36 341.02 627.2 341.19 624.44 337.78 624.38 335.86 Z"
          data-name="Columbia"
          data-stusps="GA"
          id="13073"
        />
        <path
          className="white"
          d="M 485.53 181.4 488.39 181.24 488.54 181.23 491.36 181.04 495.49 180.79 495.49 180.79 495.99 186.59 490.47 187.02 490.14 186.86 489.22 186.24 488.75 185.54 488.89 184.74 488.44 184.07 487.88 183.64 487.4 183.27 486.69 182.64 486.33 182.5 485.52 182.09 485.53 181.4 Z"
          data-name="Jo Daviess"
          data-stusps="IL"
          id="17085"
        />
        <path
          className="white"
          d="M 486.09 350.04 486.34 349.45 487.22 348.76 486.45 348.04 487.65 347.81 488.01 346.78 486.91 346.21 487.39 345.68 487.79 345.62 488.73 345.82 488.71 345.03 488.26 344.7 488.09 343.71 488.61 343.11 488.42 342.45 487.58 342.16 488.19 341.68 488.88 341.8 489.25 341.35 489.82 340.99 490.59 340.78 490.83 339.92 490.4 339.52 489.68 339.27 489.69 339.14 489.7 339.07 494.15 338.87 494.31 341.34 494.64 348.31 492.99 348.39 493.07 350.02 485.96 350.35 485.96 350.35 486.09 350.04 Z"
          data-name="Bolivar"
          data-stusps="MS"
          id="28011"
        />
        <path
          className="white"
          d="M 496.93 264 499.37 262.94 499.26 261.3 501.29 261.21 504.2 261.05 505.83 260.94 506.14 265.9 505.26 268.34 504.96 268.98 504.8 268.65 503.48 267.97 502.39 267.12 501.36 267.81 501.2 267.64 500.54 266.95 500.77 266.04 499.97 266.02 498.84 265.24 498.13 264.62 496.93 264 Z"
          data-name="Randolph"
          data-stusps="IL"
          id="17157"
        />
        <path
          className="white"
          d="M 315.86 317.87 324.26 318.39 323.69 326.56 317.96 326.21 315.32 326.06 315.86 317.87 Z"
          data-name="Randall"
          data-stusps="TX"
          id="48381"
        />
        <path
          className="white"
          d="M 217.36 251.23 233.39 253.47 234.41 254.3 234.17 256.27 235.52 256.89 236.17 258.56 234.34 260.79 234.02 260.77 232.3 258.99 228.92 259.23 228.4 257.74 219.93 256.84 216.61 256.36 217.36 251.23 Z"
          data-name="San Miguel"
          data-stusps="CO"
          id="8113"
        />
        <path
          className="white"
          d="M 735.19 125.11 735.59 125.52 736.43 125.34 739.12 123.52 739.1 124.55 741.05 124.03 741.76 127.59 742.75 127.81 743.85 130.15 744.92 131.41 742.78 131.96 742.36 132.07 742.18 132.12 741.06 132.41 739.95 132.69 738.14 133.15 737.59 133.29 737.49 133.32 737.03 132.75 735.93 132.18 735.44 131.24 735.36 131.09 735.53 130.39 735.2 129.32 735.68 128.92 736.13 128.04 735.95 127.76 735.67 127.36 735.81 126.45 735.21 125.26 735.19 125.11 Z"
          data-name="Cheshire"
          data-stusps="NH"
          id="33005"
        />
        <path
          className="white"
          d="M 332.37 335.23 333.86 335.29 340.54 335.59 340.11 344.57 331.92 344.21 332.2 338.63 332.37 335.23 Z"
          data-name="Motley"
          data-stusps="TX"
          id="48345"
        />
        <path
          className="white"
          d="M 206.87 86.26 208.89 86.67 209.44 83.5 210.07 82.84 211.35 83.41 211.82 83.9 212 85.94 213.02 86.26 212.5 87.87 213.46 88.99 213.37 90.14 214.95 90.43 215.7 91.29 214.31 93.54 214.9 94.09 214.86 95.21 211.13 94.57 210.85 95.79 209.65 96.73 209.46 97.97 206.93 99.21 205.7 100.39 206.52 96.34 204.9 96 206.87 86.26 Z"
          data-name="Broadwater"
          data-stusps="MT"
          id="30007"
        />
        <path
          className="white"
          d="M 349.82 306.55 351 305.99 351.62 304.62 352.83 304.44 352.88 306.12 354.13 307.13 355.61 307.52 356.56 307.1 357.6 305.03 359.37 304.45 359.31 308.22 359.12 313.1 359.29 313.91 356.04 313.79 355.98 315.43 349.46 315.15 349.61 311.46 349.82 306.55 Z"
          data-name="Roger Mills"
          data-stusps="OK"
          id="40129"
        />
        <path
          className="white"
          d="M 123.92 76.86 127.3 77.85 128.79 78.3 130.39 78.78 132.02 79.27 137.72 80.89 137.91 81.68 138 82.74 138.5 84.01 138.6 84.25 139.2 84.7 139.9 85.78 140.83 86.1 141.35 87.13 141.19 88.15 141.7 89.6 140.94 90.38 139.19 92.4 137.4 94.49 136.95 95.28 136.81 95.53 135.32 97.96 134.76 98.54 128.37 96.72 128.81 95.11 126.02 94.33 125.67 93.36 125.96 92.27 125.53 90.73 124.61 89.91 124.57 86.88 125.12 84.97 124.72 83.38 125.16 81.81 125.69 81.96 126.17 80.33 123.22 79.49 123.25 79.16 123.92 76.86 Z"
          data-name="Wallowa"
          data-stusps="OR"
          id="41063"
        />
        <path
          className="white"
          d="M 621.91 346.28 623.25 346.23 623.03 345.27 625.21 342.99 625.88 342.19 626.37 342.12 626.7 342.15 627.85 342.79 628.49 343.4 627.98 346.72 628.59 349.04 628.14 351.07 626.56 351.75 626.44 352.71 626.04 352.64 624.9 351.75 624.83 349.92 623.95 348.08 623.16 347.93 621.91 346.28 Z"
          data-name="Jefferson"
          data-stusps="GA"
          id="13163"
        />
        <path
          className="white"
          d="M 475.62 322.58 477.16 321.91 478.62 322.64 478.94 321.3 480.78 321.26 480.59 321.83 482.37 321.89 482.42 324.51 482.53 329.14 481.41 329.16 481.44 330.26 482.57 331.06 479.2 331.12 479.25 332.77 477.96 332.79 478.61 331.44 478.47 330.1 477.47 329.24 477.38 324.59 475.68 324.63 475.62 322.58 Z"
          data-name="Prairie"
          data-stusps="AR"
          id="5117"
        />
        <path
          className="white"
          d="M 592.96 283.46 593.83 283.39 594.38 283.34 597.49 283.02 597.68 282.65 600.78 282.27 602.06 283.34 602.69 284.71 602.54 285.62 600.46 287.03 598.6 287.68 598.42 287.47 597.42 287.58 596.1 286.01 594.61 286.5 594.33 286.39 593.91 285.56 593.63 285.06 593.07 284 592.96 283.46 Z"
          data-name="Claiborne"
          data-stusps="TN"
          id="47025"
        />
      </g>
    </svg>
  );
};

export default Counties;
